var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/observable-UMO3vUa_.mjs
function observable(subscribe) {
  const self = {
    subscribe(observer) {
      let teardownRef = null;
      let isDone = false;
      let unsubscribed = false;
      let teardownImmediately = false;
      function unsubscribe() {
        if (teardownRef === null) {
          teardownImmediately = true;
          return;
        }
        if (unsubscribed) return;
        unsubscribed = true;
        if (typeof teardownRef === "function") teardownRef();
        else if (teardownRef) teardownRef.unsubscribe();
      }
      __name(unsubscribe, "unsubscribe");
      teardownRef = subscribe({
        next(value) {
          var _observer$next;
          if (isDone) return;
          (_observer$next = observer.next) === null || _observer$next === void 0 || _observer$next.call(observer, value);
        },
        error(err) {
          var _observer$error;
          if (isDone) return;
          isDone = true;
          (_observer$error = observer.error) === null || _observer$error === void 0 || _observer$error.call(observer, err);
          unsubscribe();
        },
        complete() {
          var _observer$complete;
          if (isDone) return;
          isDone = true;
          (_observer$complete = observer.complete) === null || _observer$complete === void 0 || _observer$complete.call(observer);
          unsubscribe();
        }
      });
      if (teardownImmediately) unsubscribe();
      return { unsubscribe };
    },
    pipe(...operations) {
      return operations.reduce(pipeReducer, self);
    }
  };
  return self;
}
function pipeReducer(prev, fn) {
  return fn(prev);
}
function observableToPromise(observable$1) {
  const ac = new AbortController();
  const promise = new Promise((resolve2, reject) => {
    let isDone = false;
    function onDone() {
      if (isDone) return;
      isDone = true;
      obs$.unsubscribe();
    }
    __name(onDone, "onDone");
    ac.signal.addEventListener("abort", () => {
      reject(ac.signal.reason);
    });
    const obs$ = observable$1.subscribe({
      next(data) {
        isDone = true;
        resolve2(data);
        onDone();
      },
      error(data) {
        reject(data);
      },
      complete() {
        ac.abort();
        onDone();
      }
    });
  });
  return promise;
}
var init_observable_UMO3vUa = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/observable-UMO3vUa_.mjs"() {
    "use strict";
    __name(observable, "observable");
    __name(pipeReducer, "pipeReducer");
    __name(observableToPromise, "observableToPromise");
  }
});

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/observable-CUiPknO-.mjs
function share(_opts) {
  return (source) => {
    let refCount = 0;
    let subscription = null;
    const observers = [];
    function startIfNeeded() {
      if (subscription) return;
      subscription = source.subscribe({
        next(value) {
          for (const observer of observers) {
            var _observer$next;
            (_observer$next = observer.next) === null || _observer$next === void 0 || _observer$next.call(observer, value);
          }
        },
        error(error) {
          for (const observer of observers) {
            var _observer$error;
            (_observer$error = observer.error) === null || _observer$error === void 0 || _observer$error.call(observer, error);
          }
        },
        complete() {
          for (const observer of observers) {
            var _observer$complete;
            (_observer$complete = observer.complete) === null || _observer$complete === void 0 || _observer$complete.call(observer);
          }
        }
      });
    }
    __name(startIfNeeded, "startIfNeeded");
    function resetIfNeeded() {
      if (refCount === 0 && subscription) {
        const _sub = subscription;
        subscription = null;
        _sub.unsubscribe();
      }
    }
    __name(resetIfNeeded, "resetIfNeeded");
    return observable((subscriber) => {
      refCount++;
      observers.push(subscriber);
      startIfNeeded();
      return { unsubscribe() {
        refCount--;
        resetIfNeeded();
        const index = observers.findIndex((v) => v === subscriber);
        if (index > -1) observers.splice(index, 1);
      } };
    });
  };
}
function behaviorSubject(initialValue) {
  let value = initialValue;
  const observerList = [];
  const addObserver = /* @__PURE__ */ __name((observer) => {
    if (value !== void 0) observer.next(value);
    observerList.push(observer);
  }, "addObserver");
  const removeObserver = /* @__PURE__ */ __name((observer) => {
    observerList.splice(observerList.indexOf(observer), 1);
  }, "removeObserver");
  const obs = observable((observer) => {
    addObserver(observer);
    return () => {
      removeObserver(observer);
    };
  });
  obs.next = (nextValue) => {
    if (value === nextValue) return;
    value = nextValue;
    for (const observer of observerList) observer.next(nextValue);
  };
  obs.get = () => value;
  return obs;
}
var distinctUnsetMarker;
var init_observable_CUiPknO = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/observable-CUiPknO-.mjs"() {
    "use strict";
    init_observable_UMO3vUa();
    __name(share, "share");
    distinctUnsetMarker = Symbol();
    __name(behaviorSubject, "behaviorSubject");
  }
});

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/observable/index.mjs
var init_observable = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/observable/index.mjs"() {
    "use strict";
    init_observable_UMO3vUa();
    init_observable_CUiPknO();
  }
});

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/codes-DagpWZLc.mjs
function isObject(value) {
  return !!value && !Array.isArray(value) && typeof value === "object";
}
function emptyObject() {
  return /* @__PURE__ */ Object.create(null);
}
function sleep(ms = 0) {
  return new Promise((res) => setTimeout(res, ms));
}
var run, TRPC_ERROR_CODES_BY_KEY, retryableRpcCodes;
var init_codes_DagpWZLc = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/codes-DagpWZLc.mjs"() {
    "use strict";
    __name(isObject, "isObject");
    __name(emptyObject, "emptyObject");
    run = /* @__PURE__ */ __name((fn) => fn(), "run");
    __name(sleep, "sleep");
    TRPC_ERROR_CODES_BY_KEY = {
      PARSE_ERROR: -32700,
      BAD_REQUEST: -32600,
      INTERNAL_SERVER_ERROR: -32603,
      NOT_IMPLEMENTED: -32603,
      BAD_GATEWAY: -32603,
      SERVICE_UNAVAILABLE: -32603,
      GATEWAY_TIMEOUT: -32603,
      UNAUTHORIZED: -32001,
      PAYMENT_REQUIRED: -32002,
      FORBIDDEN: -32003,
      NOT_FOUND: -32004,
      METHOD_NOT_SUPPORTED: -32005,
      TIMEOUT: -32008,
      CONFLICT: -32009,
      PRECONDITION_FAILED: -32012,
      PAYLOAD_TOO_LARGE: -32013,
      UNSUPPORTED_MEDIA_TYPE: -32015,
      UNPROCESSABLE_CONTENT: -32022,
      PRECONDITION_REQUIRED: -32028,
      TOO_MANY_REQUESTS: -32029,
      CLIENT_CLOSED_REQUEST: -32099
    };
    retryableRpcCodes = [
      TRPC_ERROR_CODES_BY_KEY.BAD_GATEWAY,
      TRPC_ERROR_CODES_BY_KEY.SERVICE_UNAVAILABLE,
      TRPC_ERROR_CODES_BY_KEY.GATEWAY_TIMEOUT,
      TRPC_ERROR_CODES_BY_KEY.INTERNAL_SERVER_ERROR
    ];
  }
});

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/getErrorShape-vC8mUXJD.mjs
function createInnerProxy(callback, path, memo) {
  var _memo$cacheKey;
  const cacheKey = path.join(".");
  (_memo$cacheKey = memo[cacheKey]) !== null && _memo$cacheKey !== void 0 || (memo[cacheKey] = new Proxy(noop, {
    get(_obj, key) {
      if (typeof key !== "string" || key === "then") return void 0;
      return createInnerProxy(callback, [...path, key], memo);
    },
    apply(_1, _2, args) {
      const lastOfPath = path[path.length - 1];
      let opts = {
        args,
        path
      };
      if (lastOfPath === "call") opts = {
        args: args.length >= 2 ? [args[1]] : [],
        path: path.slice(0, -1)
      };
      else if (lastOfPath === "apply") opts = {
        args: args.length >= 2 ? args[1] : [],
        path: path.slice(0, -1)
      };
      freezeIfAvailable(opts.args);
      freezeIfAvailable(opts.path);
      return callback(opts);
    }
  }));
  return memo[cacheKey];
}
var __create, __defProp2, __getOwnPropDesc, __getOwnPropNames2, __getProtoOf, __hasOwnProp, __commonJS, __copyProps, __toESM, noop, freezeIfAvailable, createRecursiveProxy, createFlatProxy, require_typeof, require_toPrimitive, require_toPropertyKey, require_defineProperty, require_objectSpread2, import_objectSpread2;
var init_getErrorShape_vC8mUXJD = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/getErrorShape-vC8mUXJD.mjs"() {
    "use strict";
    init_codes_DagpWZLc();
    __create = Object.create;
    __defProp2 = Object.defineProperty;
    __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    __getOwnPropNames2 = Object.getOwnPropertyNames;
    __getProtoOf = Object.getPrototypeOf;
    __hasOwnProp = Object.prototype.hasOwnProperty;
    __commonJS = /* @__PURE__ */ __name((cb, mod) => function() {
      return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    }, "__commonJS");
    __copyProps = /* @__PURE__ */ __name((to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames2(from), i = 0, n = keys.length, key; i < n; i++) {
        key = keys[i];
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp2(to, key, {
          get: ((k) => from[k]).bind(null, key),
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
      return to;
    }, "__copyProps");
    __toESM = /* @__PURE__ */ __name((mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", {
      value: mod,
      enumerable: true
    }) : target, mod)), "__toESM");
    noop = /* @__PURE__ */ __name(() => {
    }, "noop");
    freezeIfAvailable = /* @__PURE__ */ __name((obj) => {
      if (Object.freeze) Object.freeze(obj);
    }, "freezeIfAvailable");
    __name(createInnerProxy, "createInnerProxy");
    createRecursiveProxy = /* @__PURE__ */ __name((callback) => createInnerProxy(callback, [], emptyObject()), "createRecursiveProxy");
    createFlatProxy = /* @__PURE__ */ __name((callback) => {
      return new Proxy(noop, { get(_obj, name) {
        if (name === "then") return void 0;
        return callback(name);
      } });
    }, "createFlatProxy");
    require_typeof = __commonJS({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js"(exports, module) {
      function _typeof$2(o) {
        "@babel/helpers - typeof";
        return module.exports = _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
          return typeof o$1;
        } : function(o$1) {
          return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof$2(o);
      }
      __name(_typeof$2, "_typeof$2");
      module.exports = _typeof$2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_toPrimitive = __commonJS({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js"(exports, module) {
      var _typeof$1 = require_typeof()["default"];
      function toPrimitive$1(t, r) {
        if ("object" != _typeof$1(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != _typeof$1(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      __name(toPrimitive$1, "toPrimitive$1");
      module.exports = toPrimitive$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_toPropertyKey = __commonJS({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js"(exports, module) {
      var _typeof = require_typeof()["default"];
      var toPrimitive = require_toPrimitive();
      function toPropertyKey$1(t) {
        var i = toPrimitive(t, "string");
        return "symbol" == _typeof(i) ? i : i + "";
      }
      __name(toPropertyKey$1, "toPropertyKey$1");
      module.exports = toPropertyKey$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_defineProperty = __commonJS({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js"(exports, module) {
      var toPropertyKey = require_toPropertyKey();
      function _defineProperty(e, r, t) {
        return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
          value: t,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e[r] = t, e;
      }
      __name(_defineProperty, "_defineProperty");
      module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_objectSpread2 = __commonJS({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js"(exports, module) {
      var defineProperty = require_defineProperty();
      function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
          })), t.push.apply(t, o);
        }
        return t;
      }
      __name(ownKeys, "ownKeys");
      function _objectSpread2(e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = null != arguments[r] ? arguments[r] : {};
          r % 2 ? ownKeys(Object(t), true).forEach(function(r$1) {
            defineProperty(e, r$1, t[r$1]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
          });
        }
        return e;
      }
      __name(_objectSpread2, "_objectSpread2");
      module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    import_objectSpread2 = __toESM(require_objectSpread2(), 1);
  }
});

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/tracked-Bjtgv3wJ.mjs
function transformResultInner(response, transformer) {
  if ("error" in response) {
    const error = transformer.deserialize(response.error);
    return {
      ok: false,
      error: (0, import_objectSpread2$1.default)((0, import_objectSpread2$1.default)({}, response), {}, { error })
    };
  }
  const result = (0, import_objectSpread2$1.default)((0, import_objectSpread2$1.default)({}, response.result), (!response.result.type || response.result.type === "data") && {
    type: "data",
    data: transformer.deserialize(response.result.data)
  });
  return {
    ok: true,
    result
  };
}
function transformResult(response, transformer) {
  let result;
  try {
    result = transformResultInner(response, transformer);
  } catch (_unused) {
    throw new TransformResultError();
  }
  if (!result.ok && (!isObject(result.error.error) || typeof result.error.error["code"] !== "number")) throw new TransformResultError();
  if (result.ok && !isObject(result.result)) throw new TransformResultError();
  return result;
}
var import_defineProperty, import_objectSpread2$1, _a, TransformResultError, import_objectSpread22, trackedSymbol;
var init_tracked_Bjtgv3wJ = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/tracked-Bjtgv3wJ.mjs"() {
    "use strict";
    init_getErrorShape_vC8mUXJD();
    init_codes_DagpWZLc();
    import_defineProperty = __toESM(require_defineProperty(), 1);
    import_objectSpread2$1 = __toESM(require_objectSpread2(), 1);
    __name(transformResultInner, "transformResultInner");
    TransformResultError = (_a = class extends Error {
      constructor() {
        super("Unable to transform response from server");
      }
    }, __name(_a, "TransformResultError"), _a);
    __name(transformResult, "transformResult");
    import_objectSpread22 = __toESM(require_objectSpread2(), 1);
    trackedSymbol = Symbol();
  }
});

// ../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/unstable-core-do-not-import.mjs
var init_unstable_core_do_not_import = __esm({
  "../../node_modules/.pnpm/@trpc+server@11.11.0_typescript@5.9.3/node_modules/@trpc/server/dist/unstable-core-do-not-import.mjs"() {
    "use strict";
    init_getErrorShape_vC8mUXJD();
    init_codes_DagpWZLc();
    init_tracked_Bjtgv3wJ();
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/bufferToBase64URLString.js
function bufferToBase64URLString(buffer) {
  const bytes = new Uint8Array(buffer);
  let str = "";
  for (const charCode of bytes) {
    str += String.fromCharCode(charCode);
  }
  const base64String = btoa(str);
  return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
var init_bufferToBase64URLString = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/bufferToBase64URLString.js"() {
    "use strict";
    __name(bufferToBase64URLString, "bufferToBase64URLString");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/base64URLStringToBuffer.js
function base64URLStringToBuffer(base64URLString) {
  const base64 = base64URLString.replace(/-/g, "+").replace(/_/g, "/");
  const padLength = (4 - base64.length % 4) % 4;
  const padded = base64.padEnd(base64.length + padLength, "=");
  const binary = atob(padded);
  const buffer = new ArrayBuffer(binary.length);
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return buffer;
}
var init_base64URLStringToBuffer = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/base64URLStringToBuffer.js"() {
    "use strict";
    __name(base64URLStringToBuffer, "base64URLStringToBuffer");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/browserSupportsWebAuthn.js
function browserSupportsWebAuthn() {
  return _browserSupportsWebAuthnInternals.stubThis(globalThis?.PublicKeyCredential !== void 0 && typeof globalThis.PublicKeyCredential === "function");
}
var _browserSupportsWebAuthnInternals;
var init_browserSupportsWebAuthn = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/browserSupportsWebAuthn.js"() {
    "use strict";
    __name(browserSupportsWebAuthn, "browserSupportsWebAuthn");
    _browserSupportsWebAuthnInternals = {
      stubThis: /* @__PURE__ */ __name((value) => value, "stubThis")
    };
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/toPublicKeyCredentialDescriptor.js
function toPublicKeyCredentialDescriptor(descriptor) {
  const { id } = descriptor;
  return {
    ...descriptor,
    id: base64URLStringToBuffer(id),
    transports: descriptor.transports,
    type: descriptor.type
  };
}
var init_toPublicKeyCredentialDescriptor = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/toPublicKeyCredentialDescriptor.js"() {
    "use strict";
    init_base64URLStringToBuffer();
    __name(toPublicKeyCredentialDescriptor, "toPublicKeyCredentialDescriptor");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/isValidDomain.js
function isValidDomain(hostname) {
  return (
    // Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === "localhost" || // Support punycode (ACE) or ascii labels and domains
    /^((xn--[a-z0-9-]+|[a-z0-9]+(-[a-z0-9]+)*)\.)+([a-z]{2,}|xn--[a-z0-9-]+)$/i.test(hostname)
  );
}
var init_isValidDomain = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/isValidDomain.js"() {
    "use strict";
    __name(isValidDomain, "isValidDomain");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/webAuthnError.js
var _WebAuthnError, WebAuthnError;
var init_webAuthnError = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/webAuthnError.js"() {
    "use strict";
    _WebAuthnError = class _WebAuthnError extends Error {
      constructor({ message, code, cause, name }) {
        super(message, {
          cause
        });
        Object.defineProperty(this, "code", {
          enumerable: true,
          configurable: true,
          writable: true,
          value: void 0
        });
        this.name = name ?? cause.name;
        this.code = code;
      }
    };
    __name(_WebAuthnError, "WebAuthnError");
    WebAuthnError = _WebAuthnError;
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/identifyRegistrationError.js
function identifyRegistrationError({ error, options }) {
  const { publicKey } = options;
  if (!publicKey) {
    throw Error("options was missing required publicKey property");
  }
  if (error.name === "AbortError") {
    if (options.signal instanceof AbortSignal) {
      return new WebAuthnError({
        message: "Registration ceremony was sent an abort signal",
        code: "ERROR_CEREMONY_ABORTED",
        cause: error
      });
    }
  } else if (error.name === "ConstraintError") {
    if (publicKey.authenticatorSelection?.requireResidentKey === true) {
      return new WebAuthnError({
        message: "Discoverable credentials were required but no available authenticator supported it",
        code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
        cause: error
      });
    } else if (
      // @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
      options.mediation === "conditional" && publicKey.authenticatorSelection?.userVerification === "required"
    ) {
      return new WebAuthnError({
        message: "User verification was required during automatic registration but it could not be performed",
        code: "ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE",
        cause: error
      });
    } else if (publicKey.authenticatorSelection?.userVerification === "required") {
      return new WebAuthnError({
        message: "User verification was required but no available authenticator supported it",
        code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
        cause: error
      });
    }
  } else if (error.name === "InvalidStateError") {
    return new WebAuthnError({
      message: "The authenticator was previously registered",
      code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
      cause: error
    });
  } else if (error.name === "NotAllowedError") {
    return new WebAuthnError({
      message: error.message,
      code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
      cause: error
    });
  } else if (error.name === "NotSupportedError") {
    const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param) => param.type === "public-key");
    if (validPubKeyCredParams.length === 0) {
      return new WebAuthnError({
        message: 'No entry in pubKeyCredParams was of type "public-key"',
        code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
        cause: error
      });
    }
    return new WebAuthnError({
      message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
      code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
      cause: error
    });
  } else if (error.name === "SecurityError") {
    const effectiveDomain = globalThis.location.hostname;
    if (!isValidDomain(effectiveDomain)) {
      return new WebAuthnError({
        message: `${globalThis.location.hostname} is an invalid domain`,
        code: "ERROR_INVALID_DOMAIN",
        cause: error
      });
    } else if (publicKey.rp.id !== effectiveDomain) {
      return new WebAuthnError({
        message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
        code: "ERROR_INVALID_RP_ID",
        cause: error
      });
    }
  } else if (error.name === "TypeError") {
    if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) {
      return new WebAuthnError({
        message: "User ID was not between 1 and 64 characters",
        code: "ERROR_INVALID_USER_ID_LENGTH",
        cause: error
      });
    }
  } else if (error.name === "UnknownError") {
    return new WebAuthnError({
      message: "The authenticator was unable to process the specified options, or could not create a new credential",
      code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
      cause: error
    });
  }
  return error;
}
var init_identifyRegistrationError = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/identifyRegistrationError.js"() {
    "use strict";
    init_isValidDomain();
    init_webAuthnError();
    __name(identifyRegistrationError, "identifyRegistrationError");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/webAuthnAbortService.js
var _a2, BaseWebAuthnAbortService, WebAuthnAbortService;
var init_webAuthnAbortService = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/webAuthnAbortService.js"() {
    "use strict";
    BaseWebAuthnAbortService = (_a2 = class {
      constructor() {
        Object.defineProperty(this, "controller", {
          enumerable: true,
          configurable: true,
          writable: true,
          value: void 0
        });
      }
      createNewAbortSignal() {
        if (this.controller) {
          const abortError = new Error("Cancelling existing WebAuthn API call for new one");
          abortError.name = "AbortError";
          this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
      }
      cancelCeremony() {
        if (this.controller) {
          const abortError = new Error("Manually cancelling existing WebAuthn API call");
          abortError.name = "AbortError";
          this.controller.abort(abortError);
          this.controller = void 0;
        }
      }
    }, __name(_a2, "BaseWebAuthnAbortService"), _a2);
    WebAuthnAbortService = new BaseWebAuthnAbortService();
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/toAuthenticatorAttachment.js
function toAuthenticatorAttachment(attachment) {
  if (!attachment) {
    return;
  }
  if (attachments.indexOf(attachment) < 0) {
    return;
  }
  return attachment;
}
var attachments;
var init_toAuthenticatorAttachment = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/toAuthenticatorAttachment.js"() {
    "use strict";
    attachments = [
      "cross-platform",
      "platform"
    ];
    __name(toAuthenticatorAttachment, "toAuthenticatorAttachment");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/methods/startRegistration.js
async function startRegistration(options) {
  if (!options.optionsJSON && options.challenge) {
    console.warn("startRegistration() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.");
    options = {
      optionsJSON: options
    };
  }
  const { optionsJSON, useAutoRegister = false } = options;
  if (!browserSupportsWebAuthn()) {
    throw new Error("WebAuthn is not supported in this browser");
  }
  const publicKey = {
    ...optionsJSON,
    challenge: base64URLStringToBuffer(optionsJSON.challenge),
    user: {
      ...optionsJSON.user,
      id: base64URLStringToBuffer(optionsJSON.user.id)
    },
    excludeCredentials: optionsJSON.excludeCredentials?.map(toPublicKeyCredentialDescriptor)
  };
  const createOptions = {};
  if (useAutoRegister) {
    createOptions.mediation = "conditional";
  }
  createOptions.publicKey = publicKey;
  createOptions.signal = WebAuthnAbortService.createNewAbortSignal();
  let credential;
  try {
    credential = await navigator.credentials.create(
      // TODO: Newer versions of Deno require this casting, revisit once we're using Deno 2.6+
      createOptions
    );
  } catch (err) {
    throw identifyRegistrationError({
      error: err,
      options: createOptions
    });
  }
  if (!credential) {
    throw new Error("Registration was not completed");
  }
  const { id, rawId, response, type } = credential;
  let transports = void 0;
  if (typeof response.getTransports === "function") {
    transports = response.getTransports();
  }
  let responsePublicKeyAlgorithm = void 0;
  if (typeof response.getPublicKeyAlgorithm === "function") {
    try {
      responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
    } catch (error) {
      warnOnBrokenImplementation("getPublicKeyAlgorithm()", error);
    }
  }
  let responsePublicKey = void 0;
  if (typeof response.getPublicKey === "function") {
    try {
      const _publicKey = response.getPublicKey();
      if (_publicKey !== null) {
        responsePublicKey = bufferToBase64URLString(_publicKey);
      }
    } catch (error) {
      warnOnBrokenImplementation("getPublicKey()", error);
    }
  }
  let responseAuthenticatorData;
  if (typeof response.getAuthenticatorData === "function") {
    try {
      responseAuthenticatorData = bufferToBase64URLString(response.getAuthenticatorData());
    } catch (error) {
      warnOnBrokenImplementation("getAuthenticatorData()", error);
    }
  }
  return {
    id,
    rawId: bufferToBase64URLString(rawId),
    response: {
      attestationObject: bufferToBase64URLString(response.attestationObject),
      clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
      transports,
      publicKeyAlgorithm: responsePublicKeyAlgorithm,
      publicKey: responsePublicKey,
      authenticatorData: responseAuthenticatorData
    },
    type,
    clientExtensionResults: credential.getClientExtensionResults(),
    authenticatorAttachment: toAuthenticatorAttachment(credential.authenticatorAttachment)
  };
}
function warnOnBrokenImplementation(methodName, cause) {
  console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${methodName}. You should report this error to them.
`, cause);
}
var init_startRegistration = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/methods/startRegistration.js"() {
    "use strict";
    init_bufferToBase64URLString();
    init_base64URLStringToBuffer();
    init_browserSupportsWebAuthn();
    init_toPublicKeyCredentialDescriptor();
    init_identifyRegistrationError();
    init_webAuthnAbortService();
    init_toAuthenticatorAttachment();
    __name(startRegistration, "startRegistration");
    __name(warnOnBrokenImplementation, "warnOnBrokenImplementation");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/browserSupportsWebAuthnAutofill.js
function browserSupportsWebAuthnAutofill() {
  if (!browserSupportsWebAuthn()) {
    return _browserSupportsWebAuthnAutofillInternals.stubThis(new Promise((resolve2) => resolve2(false)));
  }
  const globalPublicKeyCredential = globalThis.PublicKeyCredential;
  if (globalPublicKeyCredential?.isConditionalMediationAvailable === void 0) {
    return _browserSupportsWebAuthnAutofillInternals.stubThis(new Promise((resolve2) => resolve2(false)));
  }
  return _browserSupportsWebAuthnAutofillInternals.stubThis(globalPublicKeyCredential.isConditionalMediationAvailable());
}
var _browserSupportsWebAuthnAutofillInternals;
var init_browserSupportsWebAuthnAutofill = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/browserSupportsWebAuthnAutofill.js"() {
    "use strict";
    init_browserSupportsWebAuthn();
    __name(browserSupportsWebAuthnAutofill, "browserSupportsWebAuthnAutofill");
    _browserSupportsWebAuthnAutofillInternals = {
      stubThis: /* @__PURE__ */ __name((value) => value, "stubThis")
    };
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/identifyAuthenticationError.js
function identifyAuthenticationError({ error, options }) {
  const { publicKey } = options;
  if (!publicKey) {
    throw Error("options was missing required publicKey property");
  }
  if (error.name === "AbortError") {
    if (options.signal instanceof AbortSignal) {
      return new WebAuthnError({
        message: "Authentication ceremony was sent an abort signal",
        code: "ERROR_CEREMONY_ABORTED",
        cause: error
      });
    }
  } else if (error.name === "NotAllowedError") {
    return new WebAuthnError({
      message: error.message,
      code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
      cause: error
    });
  } else if (error.name === "SecurityError") {
    const effectiveDomain = globalThis.location.hostname;
    if (!isValidDomain(effectiveDomain)) {
      return new WebAuthnError({
        message: `${globalThis.location.hostname} is an invalid domain`,
        code: "ERROR_INVALID_DOMAIN",
        cause: error
      });
    } else if (publicKey.rpId !== effectiveDomain) {
      return new WebAuthnError({
        message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
        code: "ERROR_INVALID_RP_ID",
        cause: error
      });
    }
  } else if (error.name === "UnknownError") {
    return new WebAuthnError({
      message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
      code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
      cause: error
    });
  }
  return error;
}
var init_identifyAuthenticationError = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/identifyAuthenticationError.js"() {
    "use strict";
    init_isValidDomain();
    init_webAuthnError();
    __name(identifyAuthenticationError, "identifyAuthenticationError");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/methods/startAuthentication.js
async function startAuthentication(options) {
  if (!options.optionsJSON && options.challenge) {
    console.warn("startAuthentication() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.");
    options = {
      optionsJSON: options
    };
  }
  const { optionsJSON, useBrowserAutofill = false, verifyBrowserAutofillInput = true } = options;
  if (!browserSupportsWebAuthn()) {
    throw new Error("WebAuthn is not supported in this browser");
  }
  let allowCredentials;
  if (optionsJSON.allowCredentials?.length !== 0) {
    allowCredentials = optionsJSON.allowCredentials?.map(toPublicKeyCredentialDescriptor);
  }
  const publicKey = {
    ...optionsJSON,
    challenge: base64URLStringToBuffer(optionsJSON.challenge),
    allowCredentials
  };
  const getOptions = {};
  if (useBrowserAutofill) {
    if (!await browserSupportsWebAuthnAutofill()) {
      throw Error("Browser does not support WebAuthn autofill");
    }
    const eligibleInputs = document.querySelectorAll("input[autocomplete$='webauthn']");
    if (eligibleInputs.length < 1 && verifyBrowserAutofillInput) {
      throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
    }
    getOptions.mediation = "conditional";
    publicKey.allowCredentials = [];
  }
  getOptions.publicKey = publicKey;
  getOptions.signal = WebAuthnAbortService.createNewAbortSignal();
  let credential;
  try {
    credential = await navigator.credentials.get(
      // TODO: Newer versions of Deno require this casting, revisit once we're using Deno 2.6+
      getOptions
    );
  } catch (err) {
    throw identifyAuthenticationError({
      error: err,
      options: getOptions
    });
  }
  if (!credential) {
    throw new Error("Authentication was not completed");
  }
  const { id, rawId, response, type } = credential;
  let userHandle = void 0;
  if (response.userHandle) {
    userHandle = bufferToBase64URLString(response.userHandle);
  }
  return {
    id,
    rawId: bufferToBase64URLString(rawId),
    response: {
      authenticatorData: bufferToBase64URLString(response.authenticatorData),
      clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
      signature: bufferToBase64URLString(response.signature),
      userHandle
    },
    type,
    clientExtensionResults: credential.getClientExtensionResults(),
    authenticatorAttachment: toAuthenticatorAttachment(credential.authenticatorAttachment)
  };
}
var init_startAuthentication = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/methods/startAuthentication.js"() {
    "use strict";
    init_bufferToBase64URLString();
    init_base64URLStringToBuffer();
    init_browserSupportsWebAuthn();
    init_browserSupportsWebAuthnAutofill();
    init_toPublicKeyCredentialDescriptor();
    init_identifyAuthenticationError();
    init_webAuthnAbortService();
    init_toAuthenticatorAttachment();
    __name(startAuthentication, "startAuthentication");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/identifySignalError.js
var init_identifySignalError = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/identifySignalError.js"() {
    "use strict";
    init_isValidDomain();
    init_webAuthnError();
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/methods/sendSignal.js
var init_sendSignal = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/methods/sendSignal.js"() {
    "use strict";
    init_identifySignalError();
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/getBrowserCapabilities.js
var init_getBrowserCapabilities = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/getBrowserCapabilities.js"() {
    "use strict";
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/browserSupportsPasskeys.js
var init_browserSupportsPasskeys = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/browserSupportsPasskeys.js"() {
    "use strict";
    init_browserSupportsWebAuthn();
    init_getBrowserCapabilities();
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/platformAuthenticatorIsAvailable.js
function platformAuthenticatorIsAvailable() {
  if (!browserSupportsWebAuthn()) {
    return new Promise((resolve2) => resolve2(false));
  }
  return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
}
var init_platformAuthenticatorIsAvailable = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/helpers/platformAuthenticatorIsAvailable.js"() {
    "use strict";
    init_browserSupportsWebAuthn();
    __name(platformAuthenticatorIsAvailable, "platformAuthenticatorIsAvailable");
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/types/index.js
var init_types = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/types/index.js"() {
    "use strict";
  }
});

// ../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/index.js
var init_esm = __esm({
  "../../node_modules/.pnpm/@simplewebauthn+browser@14.0.0/node_modules/@simplewebauthn/browser/esm/index.js"() {
    "use strict";
    init_startRegistration();
    init_startAuthentication();
    init_sendSignal();
    init_browserSupportsWebAuthn();
    init_browserSupportsPasskeys();
    init_platformAuthenticatorIsAvailable();
    init_browserSupportsWebAuthnAutofill();
    init_base64URLStringToBuffer();
    init_bufferToBase64URLString();
    init_getBrowserCapabilities();
    init_webAuthnAbortService();
    init_webAuthnError();
    init_types();
  }
});

// ../sdk/dist/index.mjs
var dist_exports = {};
__export(dist_exports, {
  ATTACHMENT_CACHE_MAX_FILE: () => ATTACHMENT_CACHE_MAX_FILE,
  ATTACHMENT_CACHE_MAX_TOTAL: () => ATTACHMENT_CACHE_MAX_TOTAL,
  AccountService: () => AccountService,
  AiService: () => AiService,
  AllowanceService: () => AllowanceService,
  AppOnboardingService: () => AppOnboardingService,
  ApprovalFlowService: () => ApprovalFlowService,
  AttendanceCorrectionService: () => AttendanceCorrectionService,
  AttendanceRateService: () => AttendanceRateService,
  AttendanceService: () => AttendanceService,
  AuthService: () => AuthService,
  AuthenticationError: () => AuthenticationError,
  AuthorizationError: () => AuthorizationError,
  ChatDeviceLinkService: () => ChatDeviceLinkService,
  ChatKeyManager: () => ChatKeyManager,
  ChatKeyService: () => ChatKeyService,
  ChatRecoveryService: () => ChatRecoveryService,
  ConversationKeyManager: () => ConversationKeyManager,
  ConversationKeyService: () => ConversationKeyService,
  ConversationService: () => ConversationService,
  CookieStorageAdapter: () => CookieStorageAdapter,
  DeductionImportService: () => DeductionImportService,
  DeductionService: () => DeductionService,
  DeviceCredentialService: () => DeviceCredentialService,
  DocumentService: () => DocumentService,
  ENCRYPTED_PUSH_KIND: () => ENCRYPTED_PUSH_KIND,
  ESignService: () => ESignService,
  EducationSubsidyService: () => EducationSubsidyService,
  EmployeeCertificationService: () => EmployeeCertificationService,
  EmployeeService: () => EmployeeService,
  FixedIncentiveService: () => FixedIncentiveService,
  GeneralAffairsService: () => GeneralAffairsService,
  HerebyClient: () => HerebyClient,
  HerebySDKError: () => HerebySDKError,
  IMPERSONATION_ENDED_NOTICE: () => IMPERSONATION_ENDED_NOTICE,
  IMPERSONATION_EXPIRED_NOTICE: () => IMPERSONATION_EXPIRED_NOTICE,
  ImpersonationService: () => ImpersonationService,
  IndexedDbChatKeyStore: () => IndexedDbChatKeyStore,
  IndexedDbDeviceKeyStore: () => IndexedDbDeviceKeyStore,
  InviteService: () => InviteService,
  JobDutyService: () => JobDutyService,
  LeaveImportService: () => LeaveImportService,
  LeaveRequestService: () => LeaveRequestService,
  LocalStorageAdapter: () => LocalStorageAdapter,
  MESSAGE_CACHE_PER_ROOM: () => MESSAGE_CACHE_PER_ROOM,
  MemoryChatKeyStore: () => MemoryChatKeyStore,
  MemoryDeviceKeyStore: () => MemoryDeviceKeyStore,
  MemoryStorageAdapter: () => MemoryStorageAdapter,
  MessageService: () => MessageService,
  NetworkError: () => NetworkError,
  NotFoundError: () => NotFoundError,
  NotificationService: () => NotificationService,
  NurseSchedulerService: () => NurseSchedulerService,
  OffsiteWorkService: () => OffsiteWorkService,
  OrganizationHolidayService: () => OrganizationHolidayService,
  OrganizationService: () => OrganizationService,
  OvertimeService: () => OvertimeService,
  PUSH_BODY_MAX: () => PUSH_BODY_MAX,
  PayrollService: () => PayrollService,
  PeerKeyDirectory: () => PeerKeyDirectory,
  ResignationService: () => ResignationService,
  RoleService: () => RoleService,
  SalaryGradeService: () => SalaryGradeService,
  SecretBytesProvider: () => SecretBytesProvider,
  SecurityService: () => SecurityService,
  SessionStorageAdapter: () => SessionStorageAdapter,
  ShiftGroupService: () => ShiftGroupService,
  ShiftService: () => ShiftService,
  SignupService: () => SignupService,
  TeamDriveService: () => TeamDriveService,
  TeamManagerService: () => TeamManagerService,
  TeamService: () => TeamService,
  TimeoutError: () => TimeoutError,
  ValidationError: () => ValidationError,
  WS_KEEPALIVE: () => WS_KEEPALIVE,
  WS_REOPENED_EVENT: () => WS_REOPENED_EVENT,
  WS_RETRY_MAX_MS: () => WS_RETRY_MAX_MS,
  WebWrapKeyProvider: () => WebWrapKeyProvider,
  WorkPatternService: () => WorkPatternService,
  YearEndSettlementService: () => YearEndSettlementService,
  calculateAgeFromRRN: () => calculateAgeFromRRN,
  clearImpersonationReturn: () => clearImpersonationReturn,
  collectEnvContext: () => collectEnvContext,
  createAlpinePlugin: () => createAlpinePlugin,
  createDefaultChatKeyStore: () => createDefaultChatKeyStore,
  createDefaultDeviceKeyStore: () => createDefaultDeviceKeyStore,
  createHerebyClient: () => createHerebyClient,
  csCollector: () => csCollector,
  decryptIncomingMessage: () => decryptIncomingMessage,
  decryptPushBody: () => decryptPushBody,
  default: () => src_default,
  encryptOutgoingMessage: () => encryptOutgoingMessage,
  fetchAllPages: () => fetchAllPages,
  forgetDeviceKey: () => forgetDeviceKey,
  formatKRW: () => formatKRW,
  formatKoreanPhone: () => formatKoreanPhone,
  fromBase64Url: () => fromBase64Url,
  generateDeviceKey: () => generateDeviceKey,
  getActiveDeviceKey: () => getActiveDeviceKey,
  getDevicePushToken: () => getDevicePushToken,
  getDeviceSecretProvider: () => getDeviceSecretProvider,
  handleSDKError: () => handleSDKError,
  installCsReportHooks: () => installCsReportHooks,
  installImeEnterGuard: () => installImeEnterGuard,
  installImpersonationHistoryGuard: () => installImpersonationHistoryGuard,
  isEncryptedMessage: () => isEncryptedMessage,
  isEncryptedPushData: () => isEncryptedPushData,
  isIndexedDbAvailable: () => isIndexedDbAvailable,
  isKoreanHoliday: () => isKoreanHoliday,
  isPasskeyAvailable: () => isPasskeyAvailable,
  isValidBusinessNumber: () => isValidBusinessNumber,
  isValidDateRange: () => isValidDateRange,
  isValidEmail: () => isValidEmail,
  isValidKoreanPhone: () => isValidKoreanPhone,
  isValidKoreanRRN: () => isValidKoreanRRN,
  loginWithDeviceKey: () => loginWithDeviceKey,
  loginWithPasskey: () => loginWithPasskey,
  navigateAfterImpersonationExit: () => navigateAfterImpersonationExit,
  newMessageId: () => newMessageId,
  parseTRPCError: () => parseTRPCError,
  plainAccountBundle: () => plainAccountBundle,
  pollAsyncOperation: () => pollAsyncOperation,
  readImpersonationReturn: () => readImpersonationReturn,
  recoverFromImpersonationExpiry: () => recoverFromImpersonationExpiry,
  registerDeviceKey: () => registerDeviceKey,
  registerPasskey: () => registerPasskey,
  restoreImpersonationReturn: () => restoreImpersonationReturn,
  restoredPageHasStaleSession: () => restoredPageHasStaleSession,
  saveImpersonationReturn: () => saveImpersonationReturn,
  sendTextToConversation: () => sendTextToConversation,
  setDevicePushToken: () => setDevicePushToken,
  setDeviceSecretProvider: () => setDeviceSecretProvider,
  setEpochKeySink: () => setEpochKeySink,
  signChallenge: () => signChallenge,
  signMembershipChange: () => signMembershipChange,
  takeImpersonationNotice: () => takeImpersonationNotice,
  toBase64Url: () => toBase64Url,
  validatePasswordStrength: () => validatePasswordStrength,
  wsRetryDelayMs: () => wsRetryDelayMs
});
import { resolveTerminology } from "@hereby/core/constants";
import { formatDate, formatDateCustom, formatDateISO, formatDateTime, formatDateTimeLong, formatTime, todayLocal } from "@hereby/core/date";
import { createI18n, getLocaleBundle } from "@hereby/core/locales";
import { redactText, redactValue } from "@hereby/core/redact";
import { deviceLinkCode, exportAccountPrivateBundle, exportPublicKeySpki, fingerprintPublicKey, generateAccountKeyPair, generateDeviceLinkKeyPair, importAccountPrivateBundle, openDeviceLinkPayload, sealDeviceLinkPayload } from "@hereby/core/chat-crypto";
import { buildEpochAttestationBytes, buildMembershipAttestationBytes, generateRoomKey, importRoomKey, openEpochEnvelope, roomKeyCommitment, sealEpochEnvelope, signBytes, verifyBytes } from "@hereby/core/chat-crypto";
import { buildMembershipAttestationBytes as buildMembershipAttestationBytes2, signBytes as signBytes2 } from "@hereby/core/chat-crypto";
import { buildMessageAad, decryptMessage, encryptMessage, generateMessageKey, importRecoveryPublicKey, sealRecoveryEnvelope, unwrapMessageKey, wrapMessageKey } from "@hereby/core/chat-crypto";
import { buildMessageAad as buildMessageAad2, decryptMessage as decryptMessage2, importRoomKey as importRoomKey2, unwrapMessageKey as unwrapMessageKey2 } from "@hereby/core/chat-crypto";
function installImeEnterGuard() {
  if (installed || typeof document === "undefined") {
    return;
  }
  installed = true;
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") {
      return;
    }
    const composing = event.isComposing || event.keyCode === 229;
    if (!composing) {
      return;
    }
    const target = event.target;
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
      event.stopImmediatePropagation();
    }
  }, true);
}
function toBase64Url(bytes) {
  const u8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let bin = "";
  for (const b of u8) {
    bin += String.fromCharCode(b);
  }
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64Url(text) {
  const pad3 = text.length % 4 === 0 ? "" : "=".repeat(4 - text.length % 4);
  const bin = atob(text.replace(/-/g, "+").replace(/_/g, "/") + pad3);
  const out = new Uint8Array(new ArrayBuffer(bin.length));
  for (let i = 0; i < bin.length; i++) {
    out[i] = bin.charCodeAt(i);
  }
  return out;
}
function memoizeKey(load) {
  let pending = null;
  return () => {
    if (!pending) {
      pending = load().catch((e) => {
        pending = null;
        throw e;
      });
    }
    return pending;
  };
}
async function generateDeviceKey(provider) {
  const pair = await subtle().generateKey({
    name: "ECDSA",
    namedCurve: "P-256"
  }, true, [
    "sign",
    "verify"
  ]);
  const spki = await subtle().exportKey("spki", pair.publicKey);
  const pkcs8 = await subtle().exportKey("pkcs8", pair.privateKey);
  const wrap = await provider.getWrappingKey();
  const iv = crypto.getRandomValues(new Uint8Array(new ArrayBuffer(12)));
  const ct = await subtle().encrypt({
    name: "AES-GCM",
    iv
  }, wrap, pkcs8);
  return {
    publicKey: toBase64Url(spki),
    wrappedPrivateKey: {
      iv: toBase64Url(iv),
      ct: toBase64Url(ct)
    }
  };
}
async function signChallenge(provider, wrapped, challenge) {
  const wrap = await provider.getWrappingKey();
  const pkcs8 = await subtle().decrypt({
    name: "AES-GCM",
    iv: fromBase64Url(wrapped.iv)
  }, wrap, fromBase64Url(wrapped.ct));
  const key = await subtle().importKey("pkcs8", pkcs8, {
    name: "ECDSA",
    namedCurve: "P-256"
  }, false, [
    "sign"
  ]);
  const sig = await subtle().sign({
    name: "ECDSA",
    hash: "SHA-256"
  }, key, fromBase64Url(challenge));
  return toBase64Url(sig);
}
function request(req) {
  return new Promise((resolve2, reject) => {
    req.onsuccess = () => resolve2(req.result);
    req.onerror = () => reject(req.error ?? new Error("IndexedDB \uC694\uCCAD\uC774 \uC2E4\uD328\uD588\uC5B4\uC694."));
  });
}
function createDefaultDeviceKeyStore() {
  return typeof indexedDB !== "undefined" ? new IndexedDbDeviceKeyStore() : new MemoryDeviceKeyStore();
}
function setDeviceSecretProvider(provider) {
  current = provider;
}
function getDeviceSecretProvider() {
  return current;
}
async function candidateKeys(provider) {
  const multi = provider;
  if (typeof multi.getWrappingKeys === "function") {
    const keys = await multi.getWrappingKeys();
    if (keys.length === 0) {
      throw new Error("\uBCF4\uD638 \uD0A4\uB97C \uC77D\uC744 \uC218 \uC5C6\uC5B4\uC694.");
    }
    return keys;
  }
  return [
    await provider.getWrappingKey()
  ];
}
async function decryptWithAny(provider, iv, ct) {
  let lastError = null;
  for (const key of await candidateKeys(provider)) {
    try {
      return await crypto.subtle.decrypt({
        name: "AES-GCM",
        iv
      }, key, ct);
    } catch (e) {
      lastError = e;
    }
  }
  throw lastError ?? new Error("\uBCF4\uD638 \uD0A4\uB85C \uD480 \uC218 \uC5C6\uC5B4\uC694.");
}
function isWrapped(value) {
  return !!value && typeof value === "object" && value.v === 1 && typeof value.iv === "string" && typeof value.ct === "string";
}
async function wrapBytes(provider, bytes) {
  const key = await provider.getWrappingKey();
  const iv = crypto.getRandomValues(new Uint8Array(new ArrayBuffer(12)));
  const copy2 = new Uint8Array(new ArrayBuffer(bytes.length));
  copy2.set(bytes);
  const ct = await crypto.subtle.encrypt({
    name: "AES-GCM",
    iv
  }, key, copy2);
  return {
    v: 1,
    iv: toBase64Url(iv),
    ct: toBase64Url(ct)
  };
}
async function unwrapBytes(provider, enc) {
  const plain = await decryptWithAny(provider, fromBase64Url(enc.iv), fromBase64Url(enc.ct));
  return new Uint8Array(plain);
}
async function wrapBinary(provider, bytes) {
  const key = await provider.getWrappingKey();
  const iv = crypto.getRandomValues(new Uint8Array(new ArrayBuffer(12)));
  const copy2 = new Uint8Array(new ArrayBuffer(bytes.length));
  copy2.set(bytes);
  const ct = new Uint8Array(await crypto.subtle.encrypt({
    name: "AES-GCM",
    iv
  }, key, copy2));
  return {
    iv,
    ct
  };
}
async function unwrapBinary(provider, enc) {
  const iv = new Uint8Array(new ArrayBuffer(enc.iv.length));
  iv.set(enc.iv);
  const ct = new Uint8Array(new ArrayBuffer(enc.ct.length));
  ct.set(enc.ct);
  return new Uint8Array(await decryptWithAny(provider, iv, ct));
}
async function wrapJson(provider, value) {
  return wrapBytes(provider, new TextEncoder().encode(JSON.stringify(value)));
}
async function unwrapJson(provider, enc) {
  return JSON.parse(new TextDecoder().decode(await unwrapBytes(provider, enc)));
}
function setEpochKeySink(sink) {
  epochKeySink = sink;
}
function mirrorEpochKey(conversationId, epoch, key) {
  epochKeySink?.put(conversationId, epoch, key).catch(() => void 0);
}
function mirrorClear() {
  epochKeySink?.clear().catch(() => void 0);
}
function matchesIndex(e, params) {
  if (params.fromSenderId && e.senderId !== params.fromSenderId) {
    return false;
  }
  if (params.conversationId && e.conversationId !== params.conversationId) {
    return false;
  }
  const k = params.keyword.trim().toLowerCase();
  return k.length === 0 || e.text.toLowerCase().includes(k);
}
function parseEpochKeyId(id, key) {
  const at = id.lastIndexOf(":");
  return {
    conversationId: id.slice(0, at),
    epoch: Number(id.slice(at + 1)),
    key
  };
}
function request2(req) {
  return new Promise((resolve2, reject) => {
    req.onsuccess = () => resolve2(req.result);
    req.onerror = () => reject(req.error ?? new Error("IndexedDB \uC694\uCCAD\uC774 \uC2E4\uD328\uD588\uC5B4\uC694."));
  });
}
function isIndexedDbAvailable() {
  return typeof indexedDB !== "undefined";
}
function createDefaultChatKeyStore() {
  return isIndexedDbAvailable() ? new IndexedDbChatKeyStore({
    wrap: getDeviceSecretProvider() ?? void 0
  }) : new MemoryChatKeyStore();
}
function isAbortError2(error) {
  if (!error || typeof error !== "object") {
    return false;
  }
  const e = error;
  if (e.name === "AbortError") {
    return true;
  }
  const msg = (e.message || "").toLowerCase();
  if (msg.includes("aborted") || msg.includes("cancelled") || msg.includes("canceled") || // Chrome/Safari/Firefox가 네비게이션 중 끊긴 fetch에 내는 문구들
  msg.includes("failed to fetch") || msg.includes("network error") || msg.includes("load failed")) {
    return true;
  }
  return e.cause ? isAbortError2(e.cause) : false;
}
function isDefinitiveAuthFailure(error) {
  if (isAbortError2(error)) {
    return false;
  }
  if (!error || typeof error !== "object") {
    return false;
  }
  const data = error.data;
  if (!data) {
    return false;
  }
  return data.code === "UNAUTHORIZED" || data.httpStatus === 401;
}
function installUnloadGuard() {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") {
    return;
  }
  const mark = /* @__PURE__ */ __name2(() => {
    unloading = true;
  }, "mark");
  window.addEventListener("pagehide", mark);
  window.addEventListener("beforeunload", mark);
  window.addEventListener("pageshow", () => {
    unloading = false;
  });
}
function isUnloading() {
  return unloading;
}
function isTopLevelFrame() {
  if (typeof window === "undefined") {
    return true;
  }
  try {
    return window.top === window.self;
  } catch {
    return false;
  }
}
function createChain(opts) {
  return observable((observer) => {
    function execute(index = 0, op = opts.op) {
      const next = opts.links[index];
      if (!next) throw new Error("No more links to execute - did you forget to add an ending link?");
      const subscription = next({
        op,
        next(nextOp) {
          const nextObserver = execute(index + 1, nextOp);
          return nextObserver;
        }
      });
      return subscription;
    }
    __name(execute, "execute");
    __name2(execute, "execute");
    const obs$ = execute();
    return obs$.subscribe(observer);
  });
}
function asArray(value) {
  return Array.isArray(value) ? value : [value];
}
function splitLink(opts) {
  return (runtime) => {
    const yes = asArray(opts.true).map((link) => link(runtime));
    const no = asArray(opts.false).map((link) => link(runtime));
    return (props) => {
      return observable((observer) => {
        const links = opts.condition(props.op) ? yes : no;
        return createChain({
          op: props.op,
          links
        }).subscribe(observer);
      });
    };
  };
}
function isTRPCClientError(cause) {
  return cause instanceof TRPCClientError;
}
function isTRPCErrorResponse(obj) {
  return isObject(obj) && isObject(obj["error"]) && typeof obj["error"]["code"] === "number" && typeof obj["error"]["message"] === "string";
}
function getMessageFromUnknownError(err, fallback) {
  if (typeof err === "string") return err;
  if (isObject(err) && typeof err["message"] === "string") return err["message"];
  return fallback;
}
function getTransformer(transformer) {
  const _transformer = transformer;
  if (!_transformer) return {
    input: {
      serialize: /* @__PURE__ */ __name2((data) => data, "serialize"),
      deserialize: /* @__PURE__ */ __name2((data) => data, "deserialize")
    },
    output: {
      serialize: /* @__PURE__ */ __name2((data) => data, "serialize"),
      deserialize: /* @__PURE__ */ __name2((data) => data, "deserialize")
    }
  };
  if ("input" in _transformer) return _transformer;
  return {
    input: _transformer,
    output: _transformer
  };
}
function getFetch(customFetchImpl) {
  if (customFetchImpl) return customFetchImpl;
  if (typeof window !== "undefined" && isFunction2(window.fetch)) return window.fetch;
  if (typeof globalThis !== "undefined" && isFunction2(globalThis.fetch)) return globalThis.fetch;
  throw new Error("No fetch implementation found");
}
function resolveHTTPLinkOptions(opts) {
  return {
    url: opts.url.toString(),
    fetch: opts.fetch,
    transformer: getTransformer(opts.transformer),
    methodOverride: opts.methodOverride
  };
}
function arrayToDict(array) {
  const dict = {};
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    dict[index] = element;
  }
  return dict;
}
function getInput(opts) {
  return "input" in opts ? opts.transformer.input.serialize(opts.input) : arrayToDict(opts.inputs.map((_input) => opts.transformer.input.serialize(_input)));
}
async function fetchHTTPResponse(opts) {
  var _opts$methodOverride;
  throwIfAborted(opts.signal);
  const url = opts.getUrl(opts);
  const body = opts.getBody(opts);
  const method = (_opts$methodOverride = opts.methodOverride) !== null && _opts$methodOverride !== void 0 ? _opts$methodOverride : METHOD[opts.type];
  const resolvedHeaders = await (async () => {
    const heads = await opts.headers();
    if (Symbol.iterator in heads) return Object.fromEntries(heads);
    return heads;
  })();
  const headers = (0, import_objectSpread222.default)((0, import_objectSpread222.default)((0, import_objectSpread222.default)({}, opts.contentTypeHeader && method !== "GET" ? { "content-type": opts.contentTypeHeader } : {}), opts.trpcAcceptHeader ? { "trpc-accept": opts.trpcAcceptHeader } : void 0), resolvedHeaders);
  return getFetch(opts.fetch)(url, {
    method,
    signal: opts.signal,
    body,
    headers
  });
}
async function httpRequest(opts) {
  const meta = {};
  const res = await fetchHTTPResponse(opts);
  meta.response = res;
  const json = await res.json();
  meta.responseJSON = json;
  return {
    json,
    meta
  };
}
function dataLoader(batchLoader) {
  let pendingItems = null;
  let dispatchTimer = null;
  const destroyTimerAndPendingItems = /* @__PURE__ */ __name2(() => {
    clearTimeout(dispatchTimer);
    dispatchTimer = null;
    pendingItems = null;
  }, "destroyTimerAndPendingItems");
  function groupItems(items) {
    const groupedItems = [[]];
    let index = 0;
    while (true) {
      const item = items[index];
      if (!item) break;
      const lastGroup = groupedItems[groupedItems.length - 1];
      if (item.aborted) {
        var _item$reject;
        (_item$reject = item.reject) === null || _item$reject === void 0 || _item$reject.call(item, new Error("Aborted"));
        index++;
        continue;
      }
      const isValid = batchLoader.validate(lastGroup.concat(item).map((it) => it.key));
      if (isValid) {
        lastGroup.push(item);
        index++;
        continue;
      }
      if (lastGroup.length === 0) {
        var _item$reject2;
        (_item$reject2 = item.reject) === null || _item$reject2 === void 0 || _item$reject2.call(item, new Error("Input is too big for a single dispatch"));
        index++;
        continue;
      }
      groupedItems.push([]);
    }
    return groupedItems;
  }
  __name(groupItems, "groupItems");
  __name2(groupItems, "groupItems");
  function dispatch() {
    const groupedItems = groupItems(pendingItems);
    destroyTimerAndPendingItems();
    for (const items of groupedItems) {
      if (!items.length) continue;
      const batch = { items };
      for (const item of items) item.batch = batch;
      const promise = batchLoader.fetch(batch.items.map((_item) => _item.key));
      promise.then(async (result) => {
        await Promise.all(result.map(async (valueOrPromise, index) => {
          const item = batch.items[index];
          try {
            var _item$resolve;
            const value = await Promise.resolve(valueOrPromise);
            (_item$resolve = item.resolve) === null || _item$resolve === void 0 || _item$resolve.call(item, value);
          } catch (cause) {
            var _item$reject3;
            (_item$reject3 = item.reject) === null || _item$reject3 === void 0 || _item$reject3.call(item, cause);
          }
          item.batch = null;
          item.reject = null;
          item.resolve = null;
        }));
        for (const item of batch.items) {
          var _item$reject4;
          (_item$reject4 = item.reject) === null || _item$reject4 === void 0 || _item$reject4.call(item, new Error("Missing result"));
          item.batch = null;
        }
      }).catch((cause) => {
        for (const item of batch.items) {
          var _item$reject5;
          (_item$reject5 = item.reject) === null || _item$reject5 === void 0 || _item$reject5.call(item, cause);
          item.batch = null;
        }
      });
    }
  }
  __name(dispatch, "dispatch");
  __name2(dispatch, "dispatch");
  function load(key) {
    var _dispatchTimer;
    const item = {
      aborted: false,
      key,
      batch: null,
      resolve: throwFatalError,
      reject: throwFatalError
    };
    const promise = new Promise((resolve2, reject) => {
      var _pendingItems;
      item.reject = reject;
      item.resolve = resolve2;
      (_pendingItems = pendingItems) !== null && _pendingItems !== void 0 || (pendingItems = []);
      pendingItems.push(item);
    });
    (_dispatchTimer = dispatchTimer) !== null && _dispatchTimer !== void 0 || (dispatchTimer = setTimeout(dispatch));
    return promise;
  }
  __name(load, "load");
  __name2(load, "load");
  return { load };
}
function allAbortSignals(...signals) {
  const ac = new AbortController();
  const count = signals.length;
  let abortedCount = 0;
  const onAbort = /* @__PURE__ */ __name2(() => {
    if (++abortedCount === count) ac.abort();
  }, "onAbort");
  for (const signal of signals) if (signal === null || signal === void 0 ? void 0 : signal.aborted) onAbort();
  else signal === null || signal === void 0 || signal.addEventListener("abort", onAbort, { once: true });
  return ac.signal;
}
function httpBatchLink(opts) {
  var _opts$maxURLLength, _opts$maxItems;
  const resolvedOpts = resolveHTTPLinkOptions(opts);
  const maxURLLength = (_opts$maxURLLength = opts.maxURLLength) !== null && _opts$maxURLLength !== void 0 ? _opts$maxURLLength : Infinity;
  const maxItems = (_opts$maxItems = opts.maxItems) !== null && _opts$maxItems !== void 0 ? _opts$maxItems : Infinity;
  return () => {
    const batchLoader = /* @__PURE__ */ __name2((type) => {
      return {
        validate(batchOps) {
          if (maxURLLength === Infinity && maxItems === Infinity) return true;
          if (batchOps.length > maxItems) return false;
          const path = batchOps.map((op) => op.path).join(",");
          const inputs = batchOps.map((op) => op.input);
          const url = getUrl((0, import_objectSpread24.default)((0, import_objectSpread24.default)({}, resolvedOpts), {}, {
            type,
            path,
            inputs,
            signal: null
          }));
          return url.length <= maxURLLength;
        },
        async fetch(batchOps) {
          const path = batchOps.map((op) => op.path).join(",");
          const inputs = batchOps.map((op) => op.input);
          const signal = allAbortSignals(...batchOps.map((op) => op.signal));
          const res = await jsonHttpRequester((0, import_objectSpread24.default)((0, import_objectSpread24.default)({}, resolvedOpts), {}, {
            path,
            inputs,
            type,
            headers() {
              if (!opts.headers) return {};
              if (typeof opts.headers === "function") return opts.headers({ opList: batchOps });
              return opts.headers;
            },
            signal
          }));
          const resJSON = Array.isArray(res.json) ? res.json : batchOps.map(() => res.json);
          const result = resJSON.map((item) => ({
            meta: res.meta,
            json: item
          }));
          return result;
        }
      };
    }, "batchLoader");
    const query = dataLoader(batchLoader("query"));
    const mutation = dataLoader(batchLoader("mutation"));
    const loaders = {
      query,
      mutation
    };
    return ({ op }) => {
      return observable((observer) => {
        if (op.type === "subscription") throw new Error("Subscriptions are unsupported by `httpLink` - use `httpSubscriptionLink` or `wsLink`");
        const loader = loaders[op.type];
        const promise = loader.load(op);
        let _res = void 0;
        promise.then((res) => {
          _res = res;
          const transformed = transformResult(res.json, resolvedOpts.transformer.output);
          if (!transformed.ok) {
            observer.error(TRPCClientError.from(transformed.error, { meta: res.meta }));
            return;
          }
          observer.next({
            context: res.meta,
            result: transformed.result
          });
          observer.complete();
        }).catch((err) => {
          observer.error(TRPCClientError.from(err, { meta: _res === null || _res === void 0 ? void 0 : _res.meta }));
        });
        return () => {
        };
      });
    };
  };
}
function withResolvers() {
  let resolve2;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve2 = res;
    reject = rej;
  });
  return {
    promise,
    resolve: resolve2,
    reject
  };
}
async function prepareUrl(urlOptions) {
  const url = await resultOf(urlOptions.url);
  if (!urlOptions.connectionParams) return url;
  const prefix = url.includes("?") ? "&" : "?";
  const connectionParams = `${prefix}connectionParams=1`;
  return url + connectionParams;
}
async function buildConnectionMessage(connectionParams, encoder) {
  const message = {
    method: "connectionParams",
    data: await resultOf(connectionParams)
  };
  return encoder.encode(message);
}
function asyncWsOpen(ws) {
  const { promise, resolve: resolve2, reject } = withResolvers();
  ws.addEventListener("open", () => {
    ws.removeEventListener("error", reject);
    resolve2();
  });
  ws.addEventListener("error", reject);
  return promise;
}
function setupPingInterval(ws, { intervalMs, pongTimeoutMs }) {
  let pingTimeout;
  let pongTimeout;
  function start() {
    pingTimeout = setTimeout(() => {
      ws.send("PING");
      pongTimeout = setTimeout(() => {
        ws.close();
      }, pongTimeoutMs);
    }, intervalMs);
  }
  __name(start, "start");
  __name2(start, "start");
  function reset() {
    clearTimeout(pingTimeout);
    start();
  }
  __name(reset, "reset");
  __name2(reset, "reset");
  function pong() {
    clearTimeout(pongTimeout);
    reset();
  }
  __name(pong, "pong");
  __name2(pong, "pong");
  ws.addEventListener("open", start);
  ws.addEventListener("message", ({ data }) => {
    clearTimeout(pingTimeout);
    start();
    if (data === "PONG") pong();
  });
  ws.addEventListener("close", () => {
    clearTimeout(pingTimeout);
    clearTimeout(pongTimeout);
  });
}
function backwardCompatibility(connection) {
  if (connection.isOpen()) return {
    id: connection.id,
    state: "open",
    ws: connection.ws
  };
  if (connection.isClosed()) return {
    id: connection.id,
    state: "closed",
    ws: connection.ws
  };
  if (!connection.ws) return null;
  return {
    id: connection.id,
    state: "connecting",
    ws: connection.ws
  };
}
function createWSClient(opts) {
  return new WsClient(opts);
}
function wsLink(opts) {
  const { client } = opts;
  const transformer = getTransformer(opts.transformer);
  return () => {
    return ({ op }) => {
      return observable((observer) => {
        const connStateSubscription = op.type === "subscription" ? client.connectionState.subscribe({ next(result) {
          observer.next({
            result,
            context: op.context
          });
        } }) : null;
        const requestSubscription = client.request({
          op,
          transformer
        }).subscribe(observer);
        return () => {
          requestSubscription.unsubscribe();
          connStateSubscription === null || connStateSubscription === void 0 || connStateSubscription.unsubscribe();
        };
      });
    };
  };
}
function createTRPCClientProxy(client) {
  const proxy = createRecursiveProxy(({ path, args }) => {
    const pathCopy = [...path];
    const procedureType = clientCallTypeToProcedureType(pathCopy.pop());
    const fullPath = pathCopy.join(".");
    return client[procedureType](fullPath, ...args);
  });
  return createFlatProxy((key) => {
    if (key === untypedClientSymbol) return client;
    return proxy[key];
  });
}
function createTRPCClient(opts) {
  const client = new TRPCUntypedClient(opts);
  const proxy = createTRPCClientProxy(client);
  return proxy;
}
function valuesOfObj(record) {
  if ("values" in Object) {
    return Object.values(record);
  }
  const values = [];
  for (const key in record) {
    if (record.hasOwnProperty(key)) {
      values.push(record[key]);
    }
  }
  return values;
}
function find(record, predicate) {
  const values = valuesOfObj(record);
  if ("find" in values) {
    return values.find(predicate);
  }
  const valuesNotNever = values;
  for (let i = 0; i < valuesNotNever.length; i++) {
    const value = valuesNotNever[i];
    if (predicate(value)) {
      return value;
    }
  }
  return void 0;
}
function forEach(record, run3) {
  Object.entries(record).forEach(([key, value]) => run3(value, key));
}
function includes(arr, value) {
  return arr.indexOf(value) !== -1;
}
function findArr(record, predicate) {
  for (let i = 0; i < record.length; i++) {
    const value = record[i];
    if (predicate(value)) {
      return value;
    }
  }
  return void 0;
}
function simpleTransformation(isApplicable, annotation, transform, untransform) {
  return {
    isApplicable,
    annotation,
    transform,
    untransform
  };
}
function compositeTransformation(isApplicable, annotation, transform, untransform) {
  return {
    isApplicable,
    annotation,
    transform,
    untransform
  };
}
function isInstanceOfRegisteredClass(potentialClass, superJson) {
  if (potentialClass?.constructor) {
    const isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
    return isRegistered;
  }
  return false;
}
function validatePath(path) {
  if (includes(path, "__proto__")) {
    throw new Error("__proto__ is not allowed as a property");
  }
  if (includes(path, "prototype")) {
    throw new Error("prototype is not allowed as a property");
  }
  if (includes(path, "constructor")) {
    throw new Error("constructor is not allowed as a property");
  }
}
function traverse(tree, walker2, version, origin = []) {
  if (!tree) {
    return;
  }
  const legacyPaths = enableLegacyPaths(version);
  if (!isArray(tree)) {
    forEach(tree, (subtree, key) => traverse(subtree, walker2, version, [
      ...origin,
      ...parsePath(key, legacyPaths)
    ]));
    return;
  }
  const [nodeValue, children] = tree;
  if (children) {
    forEach(children, (child, key) => {
      traverse(child, walker2, version, [
        ...origin,
        ...parsePath(key, legacyPaths)
      ]);
    });
  }
  walker2(nodeValue, origin);
}
function applyValueAnnotations(plain, annotations, version, superJson) {
  traverse(annotations, (type, path) => {
    plain = setDeep(plain, path, (v) => untransformValue(v, type, superJson));
  }, version);
  return plain;
}
function applyReferentialEqualityAnnotations(plain, annotations, version) {
  const legacyPaths = enableLegacyPaths(version);
  function apply(identicalPaths, path) {
    const object = getDeep(plain, parsePath(path, legacyPaths));
    identicalPaths.map((path2) => parsePath(path2, legacyPaths)).forEach((identicalObjectPath) => {
      plain = setDeep(plain, identicalObjectPath, () => object);
    });
  }
  __name(apply, "apply");
  __name2(apply, "apply");
  if (isArray(annotations)) {
    const [root, other] = annotations;
    root.forEach((identicalPath) => {
      plain = setDeep(plain, parsePath(identicalPath, legacyPaths), () => plain);
    });
    if (other) {
      forEach(other, apply);
    }
  } else {
    forEach(annotations, apply);
  }
  return plain;
}
function addIdentity(object, path, identities) {
  const existingSet = identities.get(object);
  if (existingSet) {
    existingSet.push(path);
  } else {
    identities.set(object, [
      path
    ]);
  }
}
function generateReferentialEqualityAnnotations(identitites, dedupe) {
  const result = {};
  let rootEqualityPaths = void 0;
  identitites.forEach((paths) => {
    if (paths.length <= 1) {
      return;
    }
    if (!dedupe) {
      paths = paths.map((path) => path.map(String)).sort((a, b) => a.length - b.length);
    }
    const [representativePath, ...identicalPaths] = paths;
    if (representativePath.length === 0) {
      rootEqualityPaths = identicalPaths.map(stringifyPath);
    } else {
      result[stringifyPath(representativePath)] = identicalPaths.map(stringifyPath);
    }
  });
  if (rootEqualityPaths) {
    if (isEmptyObject(result)) {
      return [
        rootEqualityPaths
      ];
    } else {
      return [
        rootEqualityPaths,
        result
      ];
    }
  } else {
    return isEmptyObject(result) ? void 0 : result;
  }
}
function getType2(payload) {
  return Object.prototype.toString.call(payload).slice(8, -1);
}
function isArray2(payload) {
  return getType2(payload) === "Array";
}
function isPlainObject2(payload) {
  if (getType2(payload) !== "Object") return false;
  const prototype = Object.getPrototypeOf(payload);
  return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
  const propType = {}.propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
  if (propType === "enumerable") carry[key] = newVal;
  if (includeNonenumerable && propType === "nonenumerable") {
    Object.defineProperty(carry, key, {
      value: newVal,
      enumerable: false,
      writable: true,
      configurable: true
    });
  }
}
function copy(target, options = {}) {
  if (isArray2(target)) {
    return target.map((item) => copy(item, options));
  }
  if (!isPlainObject2(target)) {
    return target;
  }
  const props = Object.getOwnPropertyNames(target);
  const symbols = Object.getOwnPropertySymbols(target);
  return [
    ...props,
    ...symbols
  ].reduce((carry, key) => {
    if (key === "__proto__") return carry;
    if (isArray2(options.props) && !options.props.includes(key)) {
      return carry;
    }
    const val = target[key];
    const newVal = copy(val, options);
    assignProp(carry, key, newVal, target, options.nonenumerable);
    return carry;
  }, {});
}
function clip(value) {
  return value.length > MAX_STRING ? `${value.slice(0, MAX_STRING)}\u2026` : value;
}
function utf8Bytes(value) {
  return new TextEncoder().encode(value).length;
}
function collectEnvContext() {
  if (typeof window === "undefined") {
    return {};
  }
  const cap = globalThis.Capacitor;
  const nav = navigator;
  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    timezone = void 0;
  }
  const platformRaw = cap?.getPlatform?.();
  return {
    userAgent: nav.userAgent?.slice(0, 512),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    devicePixelRatio: window.devicePixelRatio,
    language: nav.language,
    timezone,
    platform: platformRaw === "ios" || platformRaw === "android" ? platformRaw : "web",
    buildVersion: typeof __HEREBY_BUILD__ !== "undefined" ? __HEREBY_BUILD__ : void 0,
    online: nav.onLine,
    connectionType: nav.connection?.effectiveType,
    embedded: window.self !== window.top,
    parentUrl: window.self !== window.top ? document.referrer?.slice(0, 512) : void 0
  };
}
function installCsReportHooks() {
  if (hooksInstalled || typeof window === "undefined") {
    return;
  }
  hooksInstalled = true;
  window.addEventListener("error", (event) => {
    const err = event.error;
    csCollector.recordError({
      message: event.message || String(err?.message ?? "unknown error"),
      stack: err?.stack
    });
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    csCollector.recordError({
      message: String(reason?.message ?? reason ?? "unhandled rejection"),
      stack: reason?.stack
    });
  });
  let lastRoute = `${window.location.pathname}${window.location.hash}`;
  const onNavigate = /* @__PURE__ */ __name2(() => {
    const next = `${window.location.pathname}${window.location.hash}`;
    if (next !== lastRoute) {
      csCollector.recordNav(lastRoute, next);
      lastRoute = next;
    }
  }, "onNavigate");
  window.addEventListener("hashchange", onNavigate);
  window.addEventListener("popstate", onNavigate);
}
function createConsoleLogger(level, bindings = {}) {
  const threshold = LOG_LEVELS[level] ?? LOG_LEVELS.warn;
  const prefix = bindings.service ? `[${bindings.service}]` : "[sdk]";
  function makeLogFn(methodLevel, consoleFn) {
    return (obj, msg, ...args) => {
      if (methodLevel < threshold) {
        return;
      }
      if (typeof obj === "string") {
        consoleFn(prefix, obj, msg, ...args);
      } else {
        consoleFn(prefix, msg || "", obj, ...args);
      }
    };
  }
  __name(makeLogFn, "makeLogFn");
  __name2(makeLogFn, "makeLogFn");
  return {
    level,
    // biome-ignore lint/suspicious/noConsole: This IS the logger implementation — console is the output target
    trace: makeLogFn(LOG_LEVELS.trace, console.debug),
    // biome-ignore lint/suspicious/noConsole: This IS the logger implementation
    debug: makeLogFn(LOG_LEVELS.debug, console.debug),
    // biome-ignore lint/suspicious/noConsole: This IS the logger implementation
    info: makeLogFn(LOG_LEVELS.info, console.info),
    // biome-ignore lint/suspicious/noConsole: This IS the logger implementation
    warn: makeLogFn(LOG_LEVELS.warn, console.warn),
    // biome-ignore lint/suspicious/noConsole: This IS the logger implementation
    error: makeLogFn(LOG_LEVELS.error, console.error),
    // biome-ignore lint/suspicious/noConsole: This IS the logger implementation
    fatal: makeLogFn(LOG_LEVELS.fatal, console.error),
    child(childBindings) {
      return createConsoleLogger(level, {
        ...bindings,
        ...childBindings
      });
    }
  };
}
function getSubtle() {
  const subtle2 = globalThis.crypto?.subtle;
  if (!subtle2) {
    throw new Error("Web Crypto API (crypto.subtle) is not available. Requires a browser or Node 20+.");
  }
  return subtle2;
}
function pemToDer(pem) {
  const body = pem.replace(/-----BEGIN [^-]+-----/, "").replace(/-----END [^-]+-----/, "").replace(/\s+/g, "");
  const binary = typeof atob === "function" ? atob(body) : Buffer.from(body, "base64").toString("binary");
  const buffer = new ArrayBuffer(binary.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binary.length; i++) {
    view[i] = binary.charCodeAt(i);
  }
  return buffer;
}
function bytesToBase64(bytes) {
  if (typeof btoa === "function") {
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }
  return Buffer.from(bytes).toString("base64");
}
async function importKey(pem) {
  const der = pemToDer(pem);
  return getSubtle().importKey("spki", der, {
    name: "RSA-OAEP",
    hash: "SHA-256"
  }, false, [
    "encrypt"
  ]);
}
async function encryptPassword(plaintext, publicKeyPem) {
  if (!plaintext) {
    return plaintext;
  }
  if (!cachedKey || cachedPem !== publicKeyPem) {
    cachedKey = await importKey(publicKeyPem);
    cachedPem = publicKeyPem;
  }
  const encoded = new TextEncoder().encode(plaintext);
  const data = new ArrayBuffer(encoded.byteLength);
  new Uint8Array(data).set(encoded);
  const ciphertext = await getSubtle().encrypt({
    name: "RSA-OAEP"
  }, cachedKey, data);
  return PREFIX + bytesToBase64(new Uint8Array(ciphertext));
}
function quietForbiddenContext(opts) {
  return opts?.background ? {
    context: {
      quietForbidden: true
    }
  } : void 0;
}
function announceSettingsChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(NOTIFICATION_SETTINGS_CHANGED_EVENT));
  }
}
function storage() {
  try {
    return typeof localStorage !== "undefined" ? localStorage : null;
  } catch {
    return null;
  }
}
function readImpersonationReturn() {
  const raw = storage()?.getItem(IMPERSONATION_RETURN_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!(parsed && typeof parsed.accessToken === "string" && parsed.accessToken)) {
      return null;
    }
    return {
      accessToken: parsed.accessToken,
      refreshToken: typeof parsed.refreshToken === "string" ? parsed.refreshToken : null,
      returnUrl: typeof parsed.returnUrl === "string" ? parsed.returnUrl : "",
      grantId: typeof parsed.grantId === "string" ? parsed.grantId : "",
      expiresAt: typeof parsed.expiresAt === "string" ? parsed.expiresAt : null,
      targetName: typeof parsed.targetName === "string" ? parsed.targetName : "",
      actorName: typeof parsed.actorName === "string" ? parsed.actorName : ""
    };
  } catch {
    return null;
  }
}
function saveImpersonationReturn(value) {
  storage()?.setItem(IMPERSONATION_RETURN_KEY, JSON.stringify(value));
}
function clearImpersonationReturn() {
  storage()?.removeItem(IMPERSONATION_RETURN_KEY);
}
function takeImpersonationNotice() {
  const s = storage();
  const v = s?.getItem(IMPERSONATION_NOTICE_KEY) ?? null;
  if (v) {
    s?.removeItem(IMPERSONATION_NOTICE_KEY);
  }
  return v;
}
function restoreImpersonationReturn(client, notice) {
  const saved = readImpersonationReturn();
  if (!saved) {
    return {
      restored: false,
      returnUrl: ""
    };
  }
  clearImpersonationReturn();
  client.setTokens(saved.accessToken, saved.refreshToken ?? void 0);
  restoredThisPage = true;
  if (notice) {
    storage()?.setItem(IMPERSONATION_NOTICE_KEY, notice);
  }
  return {
    restored: true,
    returnUrl: saved.returnUrl
  };
}
function recoverFromImpersonationExpiry(client) {
  if (restoredThisPage) {
    return true;
  }
  if (!restoreImpersonationReturn(client, IMPERSONATION_EXPIRED_NOTICE).restored) {
    return false;
  }
  if (typeof window !== "undefined") {
    window.location.reload();
  }
  return true;
}
function navigateAfterImpersonationExit(target, loc = window.location) {
  const current2 = new URL(loc.href);
  const next = new URL(target, loc.href);
  const sameDocument = current2.origin === next.origin && current2.pathname === next.pathname && current2.search === next.search;
  if (!sameDocument) {
    loc.href = next.href;
    return "navigate";
  }
  if (loc.hash !== next.hash) {
    loc.hash = next.hash;
  }
  loc.reload();
  return "reload";
}
function restoredPageHasStaleSession(persisted, liveToken, storedToken) {
  return persisted && (liveToken ?? "") !== (storedToken ?? "");
}
function installImpersonationHistoryGuard(client, loc = window.location) {
  if (historyGuardInstalled || typeof window === "undefined") {
    return;
  }
  historyGuardInstalled = true;
  window.addEventListener("pageshow", (event) => {
    const persisted = event.persisted === true;
    const stored = storage()?.getItem("hereby_access_token") ?? null;
    if (stored && restoredPageHasStaleSession(persisted, client.getAccessToken(), stored)) {
      loc.reload();
    }
  });
}
function mutationPathsFromUrl(url) {
  const marker = "/trpc/";
  const at = url.indexOf(marker);
  if (at < 0) {
    return [];
  }
  const raw = url.slice(at + marker.length).split("?")[0] ?? "";
  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
  }
  return decoded.split(",").filter((p) => p.length > 0);
}
async function readBatchOutcomes(response, count) {
  const byStatus = /* @__PURE__ */ __name2(() => Array.from({
    length: count
  }, () => ({
    ok: response.ok
  })), "byStatus");
  let body;
  try {
    body = await response.clone().json();
  } catch {
    return byStatus();
  }
  const items = Array.isArray(body) ? body : [
    body
  ];
  return Array.from({
    length: count
  }, (_, i) => {
    const item = items[i];
    if (item && typeof item === "object" && "error" in item && item.error) {
      const message = item.error.json?.message ?? item.error.message;
      return typeof message === "string" ? {
        ok: false,
        message
      } : {
        ok: false
      };
    }
    return {
      ok: response.ok
    };
  });
}
function extractPermissionCode(message) {
  const m = (message ?? "").match(/\(([^()\s]+:[^()\s]+)\)\s*$/);
  const code = m ? m[1] : "";
  return PERMISSION_CODE_RE.test(code) ? code : "";
}
function shouldSurfaceForbidden(path, quietCounts) {
  if (!path) {
    return true;
  }
  return (quietCounts.get(path) ?? 0) <= 0;
}
function wsRetryDelayMs(attemptIndex) {
  return Math.min(1e3 * 2 ** attemptIndex, WS_RETRY_MAX_MS);
}
function resolveRequestTimeout(path, fallback, overrides) {
  if (!overrides) {
    return fallback;
  }
  const last = path.split("/").pop() ?? "";
  let timeout = fallback;
  for (const procedure of last.split(",")) {
    const value = overrides[decodeURIComponent(procedure)];
    if (typeof value === "number" && value > timeout) {
      timeout = value;
    }
  }
  return timeout;
}
async function isPasskeyAvailable() {
  try {
    return browserSupportsWebAuthn() && await platformAuthenticatorIsAvailable();
  } catch {
    return false;
  }
}
async function registerPasskey(service, deviceName) {
  const { challengeId, options } = await service.passkeyRegisterOptions();
  let response;
  try {
    response = await startRegistration({
      optionsJSON: options
    });
  } catch (e) {
    if (e?.name === "NotAllowedError") {
      return false;
    }
    throw e;
  }
  await service.passkeyRegisterVerify({
    deviceName,
    response: {
      ...response,
      challengeId
    }
  });
  return true;
}
async function loginWithPasskey(service, identifier) {
  const { challengeId, options } = await service.passkeyLoginOptions(identifier ? {
    identifier
  } : void 0);
  let response;
  try {
    response = await startAuthentication({
      optionsJSON: options
    });
  } catch (e) {
    if (e?.name === "NotAllowedError") {
      return null;
    }
    throw e;
  }
  return service.passkeyLoginVerify({
    challengeId,
    response
  });
}
function resolve(deps) {
  const store = deps.store ?? createDefaultDeviceKeyStore();
  return {
    store,
    provider: deps.provider ?? new WebWrapKeyProvider(store)
  };
}
async function getActiveDeviceKey(deps) {
  try {
    return await resolve(deps).store.getActive();
  } catch {
    return null;
  }
}
async function registerDeviceKey(deps, params) {
  const { store, provider } = resolve(deps);
  const existing = await store.getActive();
  if (existing && existing.employeeId === params.employeeId) {
    return existing;
  }
  const generated = await generateDeviceKey(provider);
  const { credentialId } = await deps.service.registerDeviceKey({
    publicKey: generated.publicKey,
    deviceName: params.deviceName,
    platform: params.platform
  });
  const record = {
    credentialId,
    employeeId: params.employeeId,
    organizationId: params.organizationId,
    employeeName: params.employeeName,
    publicKey: generated.publicKey,
    wrappedPrivateKey: generated.wrappedPrivateKey,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
  await store.setActive(record);
  return record;
}
async function loginWithDeviceKey(deps) {
  const { store, provider } = resolve(deps);
  const active = await store.getActive();
  if (!active) {
    return {
      status: "no-key"
    };
  }
  try {
    const { challengeId, challenge } = await deps.service.deviceKeyChallenge({
      credentialId: active.credentialId
    });
    const signature = await signChallenge(provider, active.wrappedPrivateKey, challenge);
    const result = await deps.service.deviceKeyLogin({
      credentialId: active.credentialId,
      challengeId,
      challenge,
      signature
    });
    return {
      status: "ok",
      result
    };
  } catch (e) {
    const code = e?.data?.code;
    if (code === "UNAUTHORIZED") {
      return {
        status: "rejected",
        message: e.message
      };
    }
    throw e;
  }
}
async function forgetDeviceKey(deps) {
  await resolve(deps).store.clearActive();
}
function detectEmbedded() {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    if (new URLSearchParams(window.location.search).get("embedded") === "1") {
      return true;
    }
    return window.parent !== window.self;
  } catch {
    return true;
  }
}
async function withBootRetry(fn, attempts = 3) {
  let lastError;
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (e) {
      lastError = e;
      if (isUnloading() || isAbortError2(e) || isDefinitiveAuthFailure(e)) {
        throw e;
      }
      if (i < attempts - 1) {
        await new Promise((resolve2) => setTimeout(resolve2, 300 * (i + 1)));
      }
    }
  }
  throw lastError;
}
function endSessionOnBootFailure(client, error) {
  if (isUnloading() || isAbortError2(error)) {
    return false;
  }
  if (isDefinitiveAuthFailure(error)) {
    if (isTopLevelFrame()) {
      if (recoverFromImpersonationExpiry(client)) {
        return true;
      }
      client.clearTokens();
    }
    return true;
  }
  return true;
}
function defaultDeviceName(platform) {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  if (platform === "ios") {
    return /iPad/.test(ua) ? "iPad" : "iPhone";
  }
  if (platform === "android") {
    return /Android.*; ([^;)]+)\)/.exec(ua)?.[1]?.replace(/ Build.*/, "") || "Android";
  }
  const browser = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : /Firefox\//.test(ua) ? "Firefox" : "\uBE0C\uB77C\uC6B0\uC800";
  const os = /Macintosh/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "";
  return os ? `${os} ${browser}` : browser;
}
function createAlpinePlugin(config = {}) {
  return /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function herebyPlugin(Alpine) {
    installUnloadGuard();
    installImeEnterGuard();
    installCsReportHooks();
    const client = new HerebyClient({
      ...config,
      onAuthError: /* @__PURE__ */ __name2((error) => {
        if (isUnloading() || !isDefinitiveAuthFailure(error)) {
          return;
        }
        if (isTopLevelFrame() && recoverFromImpersonationExpiry(client)) {
          return;
        }
        const store = Alpine.store("hereby");
        if (store) {
          store.authenticated = false;
          store.currentUser = null;
        }
      }, "onAuthError")
    });
    const rawClient = Alpine.raw ? Alpine.raw(client) : client;
    Object.defineProperty(rawClient, "__v_skip", {
      value: true
    });
    let _loginPassword = "";
    let pendingLogin;
    const reportedSessions = /* @__PURE__ */ new WeakSet();
    const sessionAdopted = /* @__PURE__ */ __name2((kind, result, store) => {
      if (reportedSessions.has(result)) {
        return;
      }
      if (store.requiresPasswordChange) {
        if (kind === "login") {
          pendingLogin = result;
        }
        return;
      }
      reportedSessions.add(result);
      try {
        config.onSessionAdopted?.({
          kind,
          context: [
            store.authenticated,
            store.currentUser?.id,
            store.currentUser?.organizationId,
            store.account?.id
          ]
        });
      } catch {
      }
    }, "sessionAdopted");
    const i18n = createI18n("ko");
    i18n.load(getLocaleBundle("ko"));
    function extractTimezone(user) {
      return user.organizationTimezone || "Asia/Seoul";
    }
    __name(extractTimezone, "extractTimezone");
    __name2(extractTimezone, "extractTimezone");
    function extractLocale(user) {
      return user.organizationLocale || "ko-KR";
    }
    __name(extractLocale, "extractLocale");
    __name2(extractLocale, "extractLocale");
    function adoptLocaleAndTerms(store, user) {
      store.locale = extractLocale(user);
      i18n.reset(store.locale, getLocaleBundle(store.locale));
      store.setTerminology(user.organizationTerminology);
    }
    __name(adoptLocaleAndTerms, "adoptLocaleAndTerms");
    __name2(adoptLocaleAndTerms, "adoptLocaleAndTerms");
    setDeviceSecretProvider(config.deviceLogin?.secretProvider ?? null);
    const deviceLoginDeps = /* @__PURE__ */ __name2(() => ({
      service: client.deviceCredential,
      provider: config.deviceLogin?.secretProvider
    }), "deviceLoginDeps");
    const adoptLoginResult = /* @__PURE__ */ __name2((store, result) => {
      pendingLogin = void 0;
      store.authenticated = true;
      store.currentUser = result.user;
      store.requiresPasswordChange = result.user.requiresPasswordChange === true;
      store.timezone = extractTimezone(result.user);
      adoptLocaleAndTerms(store, result.user);
      store.refreshProfilePictureUrl();
      sessionAdopted("login", result, store);
    }, "adoptLoginResult");
    Alpine.store("hereby", {
      sdk: rawClient,
      brand: config.brand ?? DEFAULT_BRAND,
      brandFamily: config.brandFamily ?? DEFAULT_BRAND_FAMILY,
      csAppId: config.appId ?? "",
      // 수집기 싱글턴을 스토어에 직접 담지 않는다(내부 배열을 Alpine 이 reactive 로
      // 감싸면 push 마다 재렌더). 함수만 노출해 컴포넌트가 필요할 때 읽는다.
      csReport: {
        snapshotLogs: /* @__PURE__ */ __name2(() => csCollector.snapshot(), "snapshotLogs"),
        envContext: /* @__PURE__ */ __name2(() => collectEnvContext(), "envContext"),
        lastError: /* @__PURE__ */ __name2(() => csCollector.peekLastError(), "lastError"),
        noteError: /* @__PURE__ */ __name2((snapshot) => csCollector.setLastError(snapshot), "noteError")
      },
      embedded: config.embedded ?? detectEmbedded(),
      linkedBrandFamily: config.linkedBrandFamily ?? "",
      authenticated: false,
      twoFactor: null,
      captcha: null,
      unusualLogin: false,
      deviceLogin: {
        ready: false,
        hasDeviceKey: false,
        employeeName: "",
        passkeyAvailable: false,
        platform: config.deviceLogin?.platform ?? "web",
        unsupportedReason: null
      },
      requiresPasswordChange: false,
      timezone: "Asia/Seoul",
      locale: "ko-KR",
      terminology: resolveTerminology(void 0, "ko-KR"),
      currentUser: null,
      currentUserProfilePictureUrl: "",
      isLoading: true,
      accountAuthenticated: false,
      account: null,
      workspaces: [],
      async init() {
        try {
          if (!String(config.baseUrl ?? "").trim()) {
            return;
          }
          client.loadTokens();
          this.refreshDeviceLoginState().catch(() => void 0);
          installImpersonationHistoryGuard(client);
          if (client.isAuthenticated()) {
            if (client.getSessionKind() === "account") {
              try {
                const me = await withBootRetry(() => client.account.me());
                this.accountAuthenticated = true;
                this.account = me.account;
                this.workspaces = me.workspaces;
              } catch (e) {
                this.accountAuthenticated = !endSessionOnBootFailure(client, e);
              }
              return;
            }
            this.authenticated = true;
            try {
              const user = await withBootRetry(() => client.auth.getCurrentUser());
              this.currentUser = user;
              this.requiresPasswordChange = user.mustChangePassword === true;
              this.timezone = extractTimezone(user);
              adoptLocaleAndTerms(this, user);
              this.refreshProfilePictureUrl();
            } catch (e) {
              this.authenticated = !endSessionOnBootFailure(client, e);
            }
          }
        } finally {
          this.isLoading = false;
        }
      },
      async login(identifier, password, captchaToken) {
        pendingLogin = void 0;
        const result = await client.auth.login({
          identifier,
          password,
          captchaToken
        });
        if ("captchaRequired" in result) {
          this.captcha = {
            siteKey: result.siteKey,
            kind: "password",
            identifier,
            secret: password
          };
          return "captcha";
        }
        this.captcha = null;
        if ("twoFactorRequired" in result) {
          this.twoFactor = {
            challengeId: result.challengeId,
            password
          };
          return "two_factor";
        }
        this.authenticated = true;
        this.currentUser = result.user;
        this.requiresPasswordChange = result.user.requiresPasswordChange === true;
        this.timezone = extractTimezone(result.user);
        adoptLocaleAndTerms(this, result.user);
        this.refreshProfilePictureUrl();
        this.unusualLogin = result.unusualLogin === true;
        if (this.requiresPasswordChange) {
          _loginPassword = password;
        }
        sessionAdopted("login", result, this);
        return "ok";
      },
      /** 로그인 2단계 — 인증 앱 코드(또는 백업 코드). 맞으면 세션 채택. 틀리면 throw(폼이 메시지를 보인다). */
      async verifyTwoFactor(code) {
        const pending = this.twoFactor;
        if (!pending) {
          throw new Error("\uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.");
        }
        try {
          const result = await client.security.verifyTwoFactor({
            challengeId: pending.challengeId,
            code
          });
          this.twoFactor = null;
          adoptLoginResult(this, result);
          this.unusualLogin = result.unusualLogin === true;
          if (this.requiresPasswordChange && pending.password) {
            _loginPassword = pending.password;
          }
        } catch (e) {
          const msg = e?.message ?? "";
          const at = msg.lastIndexOf("|");
          if (at > 0) {
            this.twoFactor = {
              ...pending,
              challengeId: msg.slice(at + 1)
            };
            throw new Error(msg.slice(0, at));
          }
          this.twoFactor = null;
          throw e;
        }
      },
      cancelTwoFactor() {
        this.twoFactor = null;
      },
      cancelCaptcha() {
        this.captcha = null;
      },
      async loginWithCode(identifier, code, captchaToken) {
        pendingLogin = void 0;
        const result = await client.auth.loginWithCode(identifier, code, void 0, captchaToken);
        if ("captchaRequired" in result) {
          this.captcha = {
            siteKey: result.siteKey,
            kind: "code",
            identifier,
            secret: code
          };
          return "captcha";
        }
        this.captcha = null;
        if ("twoFactorRequired" in result) {
          this.twoFactor = {
            challengeId: result.challengeId
          };
          return "two_factor";
        }
        this.authenticated = true;
        this.currentUser = result.user;
        this.requiresPasswordChange = result.user.requiresPasswordChange === true;
        this.timezone = extractTimezone(result.user);
        adoptLocaleAndTerms(this, result.user);
        this.refreshProfilePictureUrl();
        this.unusualLogin = result.unusualLogin === true;
        sessionAdopted("login", result, this);
        return "ok";
      },
      _adoptOrgSession(result, password) {
        pendingLogin = void 0;
        this.authenticated = true;
        this.accountAuthenticated = false;
        this.currentUser = result.user;
        this.requiresPasswordChange = result.user.requiresPasswordChange === true;
        this.timezone = extractTimezone(result.user);
        adoptLocaleAndTerms(this, result.user);
        this.refreshProfilePictureUrl();
        if (this.requiresPasswordChange && password) {
          _loginPassword = password;
        }
      },
      async accountLogin(identifier, password, captchaToken) {
        pendingLogin = void 0;
        const result = await client.account.login({
          identifier,
          password,
          captchaToken
        });
        if (result.mode === "captcha") {
          this.captcha = {
            siteKey: result.siteKey,
            kind: "account",
            identifier,
            secret: password
          };
          return "captcha";
        }
        this.captcha = null;
        if (result.mode === "workspace") {
          this.unusualLogin = result.unusualLogin === true;
        }
        if (result.mode === "two_factor") {
          this.twoFactor = {
            challengeId: result.challengeId,
            password
          };
          return "two_factor";
        }
        if (result.mode === "workspace") {
          this._adoptOrgSession(result, password);
          sessionAdopted("login", result, this);
          return "workspace";
        }
        this.accountAuthenticated = true;
        this.account = result.account;
        this.workspaces = result.workspaces;
        sessionAdopted("login", result, this);
        return "account";
      },
      async selectWorkspace(organizationId) {
        const result = await client.account.selectWorkspace(organizationId);
        this._adoptOrgSession(result);
        sessionAdopted("workspace_selected", result, this);
      },
      // owner 암묵 grant 입장 — 멤버십 없는 소유 조직 (허브 ownerEntry 항목)
      async enterOwnedWorkspace(organizationId) {
        const result = await client.account.enterOwnedWorkspace(organizationId);
        this._adoptOrgSession(result);
        sessionAdopted("workspace_selected", result, this);
      },
      // OrganizationGrant 입장 — support 대행/impersonation (허브 지원 섹션)
      async enterGrantedWorkspace(grantId) {
        const result = await client.account.enterGrantedWorkspace(grantId);
        this._adoptOrgSession(result);
        sessionAdopted("workspace_selected", result, this);
      },
      async createWorkspace(input) {
        const result = await client.account.createWorkspace(input);
        this._adoptOrgSession(result);
        this.account = null;
        this.workspaces = [];
      },
      async refreshWorkspaces() {
        if (!this.accountAuthenticated) {
          return;
        }
        this.workspaces = await client.account.workspaces();
      },
      async accountLogout() {
        pendingLogin = void 0;
        try {
          await client.account.logout();
        } catch {
        }
        this.accountAuthenticated = false;
        this.account = null;
        this.workspaces = [];
        window.location.reload();
      },
      /* ── 키 로그인(2026-10-13) ── */
      async refreshDeviceLoginState() {
        const platform = config.deviceLogin?.platform ?? "web";
        const support = config.deviceLogin?.supported?.() ?? {
          ok: true
        };
        if (!support.ok) {
          this.deviceLogin = {
            ready: true,
            hasDeviceKey: false,
            employeeName: "",
            passkeyAvailable: false,
            platform,
            unsupportedReason: support.reason
          };
          return;
        }
        const active = await getActiveDeviceKey(deviceLoginDeps());
        const passkeyAvailable = platform === "web" ? await isPasskeyAvailable() : false;
        this.deviceLogin = {
          ready: true,
          hasDeviceKey: !!active,
          employeeName: active?.employeeName ?? "",
          passkeyAvailable,
          platform,
          unsupportedReason: null
        };
      },
      async loginWithDeviceKey() {
        if (!this.deviceLogin.hasDeviceKey) {
          return "no-key";
        }
        const gate = config.deviceLogin?.gate;
        if (gate && !await gate("\uB85C\uADF8\uC778\uD558\uB824\uBA74 \uBCF8\uC778 \uD655\uC778\uC774 \uD544\uC694\uD574\uC694")) {
          return "cancelled";
        }
        const outcome = await loginWithDeviceKey(deviceLoginDeps());
        if (outcome.status === "no-key") {
          await this.refreshDeviceLoginState();
          return "no-key";
        }
        if (outcome.status === "rejected") {
          await forgetDeviceKey(deviceLoginDeps());
          await this.refreshDeviceLoginState();
          return "rejected";
        }
        adoptLoginResult(this, outcome.result);
        return "ok";
      },
      async loginWithPasskey(identifier) {
        const result = await loginWithPasskey(client.deviceCredential, identifier);
        if (!result) {
          return false;
        }
        adoptLoginResult(this, result);
        return true;
      },
      async registerThisDeviceKey() {
        const user = this.currentUser;
        if (!(user?.id && this.authenticated)) {
          return false;
        }
        if (this.deviceLogin.unsupportedReason) {
          throw new Error(this.t(this.deviceLogin.unsupportedReason));
        }
        const platform = config.deviceLogin?.platform ?? "web";
        const name = `${user.lastName || ""}${user.firstName || ""}`.trim() || user.email || "";
        await registerDeviceKey(deviceLoginDeps(), {
          employeeId: user.id,
          organizationId: user.organizationId || "",
          employeeName: name,
          deviceName: config.deviceLogin?.deviceName?.() || defaultDeviceName(platform),
          platform
        });
        await this.refreshDeviceLoginState();
        return true;
      },
      async forgetThisDeviceKey(revoke) {
        const active = await getActiveDeviceKey(deviceLoginDeps());
        if (active && revoke) {
          try {
            await client.deviceCredential.revoke({
              id: active.credentialId
            });
          } catch {
          }
        }
        await forgetDeviceKey(deviceLoginDeps());
        await this.refreshDeviceLoginState();
      },
      async registerThisPasskey(deviceName) {
        return registerPasskey(client.deviceCredential, deviceName);
      },
      async logout() {
        pendingLogin = void 0;
        try {
          await client.auth.logout();
        } catch {
        }
        this.authenticated = false;
        this.requiresPasswordChange = false;
        this.currentUser = null;
        this.currentUserProfilePictureUrl = "";
        this._fileUrlCache.clear();
        _loginPassword = "";
        try {
          const chatStore = createDefaultChatKeyStore();
          await chatStore.clearMessageCache();
          await chatStore.clearAttachmentCache();
        } catch {
        }
        try {
          sessionStorage.setItem(SKIP_DEVICE_LOGIN_AUTO_KEY, "1");
        } catch {
        }
        window.location.reload();
      },
      async changePassword(newPassword, confirmPassword) {
        await client.auth.changePassword(_loginPassword, newPassword, confirmPassword);
        this.requiresPasswordChange = false;
        _loginPassword = "";
        if (pendingLogin) {
          const completed = pendingLogin;
          pendingLogin = void 0;
          sessionAdopted("login", completed, this);
        }
      },
      hasPermission(permission) {
        if (!this.currentUser) {
          return false;
        }
        if (this.currentUser.isSystemAdmin) {
          return true;
        }
        const perms = this.currentUser.permissions;
        if (!Array.isArray(perms)) {
          return false;
        }
        if (perms.includes(permission)) {
          return true;
        }
        const prefix = `${permission}.`;
        return perms.some((p) => p.startsWith(prefix));
      },
      todayLocal() {
        return todayLocal(this.timezone);
      },
      formatDateISO(date) {
        return formatDateISO(date, this.timezone);
      },
      formatDate(date) {
        return formatDate(date, this.locale, this.timezone);
      },
      formatDateTime(date) {
        return formatDateTime(date, this.locale, this.timezone);
      },
      formatDateTimeLong(date) {
        return formatDateTimeLong(date, this.locale, this.timezone);
      },
      formatTime(date) {
        return formatTime(date, this.locale, this.timezone);
      },
      formatDateCustom(date, options) {
        return formatDateCustom(date, this.locale, this.timezone, options);
      },
      t(key, vars) {
        const self = this ?? Alpine.store("hereby");
        return self.terminology ? i18n.t(key, vars) : key;
      },
      term(key) {
        return this.terminology[key] ?? i18n.term(key);
      },
      setTerminology(config2) {
        this.terminology = resolveTerminology(config2, this.locale);
        i18n.setTerms(this.terminology);
      },
      tEnum(enumName, value) {
        return i18n.tEnum(enumName, value);
      },
      tPermission(code) {
        return i18n.tPermission(code);
      },
      setLocale(newLocale) {
        this.locale = newLocale;
        i18n.reset(newLocale, getLocaleBundle(newLocale));
        this.setTerminology(this.terminology);
      },
      // biome-ignore lint/style/useNamingConvention: internal i18n instance
      _i18n: i18n,
      // biome-ignore lint/style/useNamingConvention: internal cache prefixed with _ to indicate private
      _fileUrlCache: /* @__PURE__ */ new Map(),
      async getFileUrl(key) {
        if (!key) {
          return "";
        }
        const cached = this._fileUrlCache.get(key);
        if (cached && cached.expiresAt > Date.now()) {
          return cached.url;
        }
        const { url } = await rawClient.fileStorage.getDownloadUrl(key);
        this._fileUrlCache.set(key, {
          url,
          expiresAt: Date.now() + 50 * 60 * 1e3
        });
        return url;
      },
      async refreshProfilePictureUrl() {
        const key = this.currentUser?.profilePicture || "";
        if (!key) {
          this.currentUserProfilePictureUrl = "";
          return;
        }
        this._fileUrlCache.delete(key);
        try {
          const url = await this.getFileUrl(key);
          this.currentUserProfilePictureUrl = url;
        } catch {
          this.currentUserProfilePictureUrl = "";
        }
      }
    });
  }, "herebyPlugin"), "herebyPlugin");
}
function setDevicePushToken(token) {
  devicePushToken = token && token.length > 0 ? token : null;
}
function getDevicePushToken() {
  return devicePushToken;
}
function plainAccountBundle(bundle) {
  return {
    v: bundle.v,
    ecdhPublicKey: String(bundle.ecdhPublicKey),
    ecdsaPublicKey: String(bundle.ecdsaPublicKey),
    ecdhPrivateKey: String(bundle.ecdhPrivateKey),
    ecdsaPrivateKey: String(bundle.ecdsaPrivateKey)
  };
}
async function signMembershipChange(params) {
  const at = (params.now ?? /* @__PURE__ */ new Date()).toISOString();
  const employeeIds = [
    ...new Set(params.employeeIds)
  ].sort();
  const signature = await signBytes2(params.pair.ecdsa.privateKey, buildMembershipAttestationBytes2({
    organizationId: params.organizationId,
    conversationId: params.conversationId,
    action: params.action,
    employeeIds,
    at
  }));
  return {
    signerKeyVersion: params.keyVersion,
    action: params.action,
    employeeIds,
    at,
    signature
  };
}
function recoveryKey(info) {
  let p = recoveryKeyCache.get(info.publicKey);
  if (!p) {
    p = importRecoveryPublicKey(info.publicKey);
    recoveryKeyCache.set(info.publicKey, p);
  }
  return p;
}
function newMessageId() {
  return globalThis.crypto.randomUUID();
}
async function encryptOutgoingMessage(params) {
  const roomKey = await params.rooms.getRoomKey(params.conversationId, params.keyEpoch);
  if (!roomKey) {
    throw new Error("\uB300\uD654\uBC29 \uD0A4\uAC00 \uC544\uC9C1 \uC5C6\uC5B4\uC694.");
  }
  const messageId = params.messageId ?? newMessageId();
  const messageKey = generateMessageKey();
  const aad = buildMessageAad({
    organizationId: params.organizationId,
    conversationId: params.conversationId,
    senderId: params.senderId,
    messageId,
    keyEpoch: params.keyEpoch
  });
  const [ciphertext, keyWrap, recoveryEnvelope] = await Promise.all([
    encryptMessage(messageKey, params.payload, aad),
    wrapMessageKey(roomKey, messageKey),
    params.recovery ? sealRecoveryEnvelope({
      recoveryPublicKey: await recoveryKey(params.recovery),
      keyId: params.recovery.keyId,
      messageKey,
      binding: {
        organizationId: params.organizationId,
        conversationId: params.conversationId,
        messageId
      }
    }) : Promise.resolve(null)
  ]);
  return {
    id: messageId,
    ciphertext,
    keyEpoch: params.keyEpoch,
    keyWrap,
    recoveryEnvelope,
    encVersion: 1
  };
}
async function decryptIncomingMessage(rooms, organizationId, message) {
  if (message.encVersion !== void 0 && message.encVersion !== null && message.encVersion !== 1) {
    return null;
  }
  const roomKey = await rooms.getRoomKey(message.conversationId, message.keyEpoch);
  if (!roomKey) {
    return null;
  }
  try {
    const messageKey = await unwrapMessageKey(roomKey, message.keyWrap);
    return await decryptMessage(messageKey, message.ciphertext, buildMessageAad({
      organizationId,
      conversationId: message.conversationId,
      senderId: message.senderId,
      messageId: message.id,
      keyEpoch: message.keyEpoch
    }));
  } catch {
    return null;
  }
}
function isEncryptedMessage(m) {
  return Boolean(m.ciphertext && m.keyWrap && typeof m.keyEpoch === "number");
}
function sameKey(a, b) {
  return a.version === b.version && a.ecdhPublicKey === b.ecdhPublicKey && a.ecdsaPublicKey === b.ecdsaPublicKey;
}
function pinTrusted(pin) {
  return {
    version: pin.version,
    ecdhPublicKey: pin.ecdhPublicKey,
    ecdsaPublicKey: pin.ecdsaPublicKey
  };
}
function isEncryptedPushData(data) {
  const d = data;
  return Boolean(d && d.kind === ENCRYPTED_PUSH_KIND && d.organizationId && d.conversationId && d.messageId && d.senderId && d.keyEpoch !== void 0 && d.ciphertext && d.keyWrap);
}
async function decryptPushBody(store, data) {
  if (!isEncryptedPushData(data)) {
    return null;
  }
  try {
    const raw = await store.getEpochKey(data.conversationId, Number(data.keyEpoch));
    if (!raw) {
      return null;
    }
    const roomKey = await importRoomKey2(raw);
    const messageKey = await unwrapMessageKey2(roomKey, data.keyWrap);
    const payload = await decryptMessage2(messageKey, data.ciphertext, buildMessageAad2({
      organizationId: data.organizationId,
      conversationId: data.conversationId,
      senderId: data.senderId,
      messageId: data.messageId,
      keyEpoch: Number(data.keyEpoch)
    }));
    const text = (payload.text ?? "").trim();
    if (text) {
      return text.length > PUSH_BODY_MAX ? `${text.slice(0, PUSH_BODY_MAX)}\u2026` : text;
    }
    const n = payload.attachments?.length ?? 0;
    return n > 0 ? `\uD30C\uC77C ${n}\uAC1C` : null;
  } catch {
    return null;
  }
}
async function sendTextToConversation(params) {
  const { client, conversationId, text } = params;
  if (!params.encryptionEnabled) {
    await client.message.send({
      conversationId,
      content: text
    });
    return "sent";
  }
  const store = params.store ?? createDefaultChatKeyStore();
  const keys = new ChatKeyManager({
    employeeId: params.employeeId,
    organizationId: params.organizationId,
    store,
    chatKey: client.chatKey,
    chatDeviceLink: client.chatDeviceLink
  });
  const state3 = await keys.ensure();
  if (state3 !== "ready") {
    const view = await client.conversationKey.myEnvelopes(conversationId);
    if (view.currentEpoch === null) {
      await client.message.send({
        conversationId,
        content: text
      });
      return "sent";
    }
    return "missing-key";
  }
  const rooms = new ConversationKeyManager({
    employeeId: params.employeeId,
    organizationId: params.organizationId,
    store,
    conversationKey: client.conversationKey,
    directory: new PeerKeyDirectory({
      store,
      chatKey: client.chatKey
    }),
    accountKey: /* @__PURE__ */ __name2(() => {
      const pair = keys.getKeyPair();
      const version = keys.getKeyVersion();
      const ecdhPublicKey = keys.getPublicKeys()?.ecdhPublicKey;
      return pair && version !== null && ecdhPublicKey ? {
        pair,
        version,
        ecdhPublicKey
      } : null;
    }, "accountKey")
  });
  const sync2 = await rooms.sync(conversationId, true);
  if (sync2.currentEpoch === null) {
    await client.message.send({
      conversationId,
      content: text
    });
    return "sent";
  }
  if (!sync2.haveCurrentKey) {
    return "missing-key";
  }
  let recovery = null;
  try {
    recovery = await client.chatKey.recoveryPublicKey() ?? null;
  } catch {
    recovery = null;
  }
  const encrypted = await encryptOutgoingMessage({
    rooms,
    organizationId: params.organizationId,
    conversationId,
    senderId: params.employeeId,
    keyEpoch: sync2.currentEpoch,
    payload: {
      text
    },
    recovery
  });
  await client.message.send({
    conversationId,
    content: "",
    encrypted
  });
  return "sent";
}
function pollAsyncOperation(options) {
  const { statusFn, getStatus, pendingStatuses, interval = 3e3, timeout = 18e4, onProgress, onError } = options;
  let cancelled = false;
  let intervalId = null;
  let timeoutId = null;
  const cleanup = /* @__PURE__ */ __name2(() => {
    if (intervalId != null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    if (timeoutId != null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }, "cleanup");
  const result = new Promise((resolve2) => {
    let lastData = null;
    const poll = /* @__PURE__ */ __name2(async () => {
      if (cancelled) {
        return;
      }
      try {
        const data = await statusFn();
        lastData = data;
        onProgress?.(data);
        const status = getStatus(data);
        if (!pendingStatuses.includes(status)) {
          cleanup();
          resolve2({
            data,
            timedOut: false
          });
        }
      } catch (error) {
        onError?.(error);
      }
    }, "poll");
    timeoutId = setTimeout(() => {
      cleanup();
      cancelled = true;
      if (lastData) {
        resolve2({
          data: lastData,
          timedOut: true
        });
      } else {
        statusFn().then((data) => resolve2({
          data,
          timedOut: true
        })).catch(() => {
          resolve2({
            data: null,
            timedOut: true
          });
        });
      }
    }, timeout);
    intervalId = setInterval(poll, interval);
    poll();
  });
  const cancel = /* @__PURE__ */ __name2(() => {
    cancelled = true;
    cleanup();
  }, "cancel");
  return {
    result,
    cancel
  };
}
function parseTRPCError(error) {
  if (error instanceof TRPCClientError) {
    const { message, data } = error;
    const code = data?.code || "UNKNOWN_ERROR";
    switch (code) {
      case "UNAUTHORIZED":
        return new AuthenticationError(message, data);
      case "FORBIDDEN":
        return new AuthorizationError(message, data);
      case "BAD_REQUEST":
        return new ValidationError(message, data);
      case "NOT_FOUND":
        return new NotFoundError(message, data);
      default:
        return new HerebySDKError(message, code, data?.httpStatus, data);
    }
  }
  if (error instanceof Error) {
    if (error.message.includes("timeout")) {
      return new TimeoutError(error.message);
    }
    if (error.message.includes("network") || error.message.includes("fetch")) {
      return new NetworkError(error.message);
    }
    return new HerebySDKError(error.message, "UNKNOWN_ERROR");
  }
  return new HerebySDKError("An unknown error occurred", "UNKNOWN_ERROR");
}
async function handleSDKError(promise, errorHandler) {
  try {
    return await promise;
  } catch (error) {
    const sdkError = parseTRPCError(error);
    if (errorHandler) {
      errorHandler(sdkError);
    }
    throw sdkError;
  }
}
async function fetchAllPages(fetcher, pageSize = 1e3, maxPages = 100, shouldStop) {
  const out = [];
  for (let page = 1; page <= maxPages; page++) {
    if (shouldStop?.()) {
      break;
    }
    const result = await fetcher(page, pageSize);
    const items = Array.isArray(result) ? result : result?.items ?? [];
    out.push(...items);
    if (items.length < pageSize) {
      break;
    }
  }
  return out;
}
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function isValidKoreanPhone(phone) {
  const cleaned = phone.replace(/\D/g, "");
  const mobileRegex = /^01[0-9]{8,9}$/;
  const landlineRegex = /^0[2-6][0-9]{7,8}$/;
  return mobileRegex.test(cleaned) || landlineRegex.test(cleaned);
}
function isValidKoreanRRN(rrn) {
  const cleaned = rrn.replace(/-/g, "");
  if (!/^\d{13}$/.test(cleaned)) {
    return false;
  }
  const weights = [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    2,
    3,
    4,
    5
  ];
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number.parseInt(cleaned[i], 10) * weights[i];
  }
  const checkDigit = (11 - sum % 11) % 10;
  return checkDigit === Number.parseInt(cleaned[12], 10);
}
function validatePasswordStrength(password) {
  const feedback = [];
  let score2 = 0;
  if (password.length < 8) {
    feedback.push("Password must be at least 8 characters long");
  } else if (password.length >= 12) {
    score2 += 2;
  } else {
    score2 += 1;
  }
  if (/[A-Z]/.test(password)) {
    score2 += 1;
  } else {
    feedback.push("Include at least one uppercase letter");
  }
  if (/[a-z]/.test(password)) {
    score2 += 1;
  } else {
    feedback.push("Include at least one lowercase letter");
  }
  if (/\d/.test(password)) {
    score2 += 1;
  } else {
    feedback.push("Include at least one number");
  }
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    score2 += 1;
  } else {
    feedback.push("Include at least one special character");
  }
  return {
    isValid: feedback.length === 0 && password.length >= 8,
    score: Math.min(score2, 5),
    feedback
  };
}
function isValidBusinessNumber(number) {
  const cleaned = number.replace(/-/g, "");
  if (!/^\d{10}$/.test(cleaned)) {
    return false;
  }
  const weights = [
    1,
    3,
    7,
    1,
    3,
    7,
    1,
    3,
    5
  ];
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number.parseInt(cleaned[i], 10) * weights[i];
  }
  sum += Math.floor(Number.parseInt(cleaned[8], 10) * 5 / 10);
  const checkDigit = (10 - sum % 10) % 10;
  return checkDigit === Number.parseInt(cleaned[9], 10);
}
function formatKoreanPhone(phone) {
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 10) {
    if (cleaned.startsWith("02")) {
      return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    }
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
}
function formatKRW(amount) {
  return new Intl.NumberFormat("ko-KR", {
    style: "currency",
    currency: "KRW"
  }).format(amount);
}
function isValidDateRange(startDate, endDate) {
  return startDate <= endDate;
}
function isKoreanHoliday(date) {
  const _year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const fixedHolidays = [
    "01-01",
    "03-01",
    "05-05",
    "06-06",
    "08-15",
    "10-03",
    "10-09",
    "12-25"
  ];
  const dateStr = `${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
  return fixedHolidays.includes(dateStr);
}
function calculateAgeFromRRN(rrn) {
  const cleaned = rrn.replace(/-/g, "");
  if (cleaned.length !== 13) {
    return null;
  }
  const yearPrefix = Number.parseInt(cleaned[0] + cleaned[1], 10);
  const genderDigit = Number.parseInt(cleaned[6], 10);
  let fullYear;
  if (genderDigit === 1 || genderDigit === 2) {
    fullYear = 1900 + yearPrefix;
  } else if (genderDigit === 3 || genderDigit === 4) {
    fullYear = 2e3 + yearPrefix;
  } else {
    return null;
  }
  const today = /* @__PURE__ */ new Date();
  const birthDate = new Date(fullYear, Number.parseInt(cleaned[2] + cleaned[3], 10) - 1, Number.parseInt(cleaned[4] + cleaned[5], 10));
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }
  return age;
}
function createHerebyClient(config) {
  return new HerebyClient(config);
}
var __defProp3, __defNormalProp, __name2, __publicField, installed, subtle, _a3, _WebWrapKeyProvider, WebWrapKeyProvider, _a4, _SecretBytesProvider, SecretBytesProvider, DB_NAME, DB_VERSION, STORE_DEVICE_KEY, STORE_WRAP_KEY, ACTIVE, DEFAULT, _a5, _IndexedDbDeviceKeyStore, IndexedDbDeviceKeyStore, _a6, _MemoryDeviceKeyStore, MemoryDeviceKeyStore, current, _a7, _FallbackWrapProvider, FallbackWrapProvider, epochKeySink, MESSAGE_CACHE_PER_ROOM, ATTACHMENT_CACHE_MAX_FILE, ATTACHMENT_CACHE_MAX_TOTAL, _a8, _MemoryChatKeyStore, MemoryChatKeyStore, DB_NAME2, DB_VERSION2, STORE_MESSAGES, INDEX_MESSAGES_ROOM, STORE_ATTACHMENTS, INDEX_ATTACHMENTS_OWNER, STORE_ACCOUNT, STORE_EPOCH, STORE_SEARCH, STORE_PEER, _a9, _IndexedDbChatKeyStore, IndexedDbChatKeyStore, unloading, __create2, __defProp22, __getOwnPropDesc2, __getOwnPropNames3, __getProtoOf2, __hasOwnProp2, __commonJS2, __copyProps2, __toESM2, require_typeof2, require_toPrimitive2, require_toPropertyKey2, require_defineProperty2, require_objectSpread22, import_defineProperty2, import_objectSpread23, _a10, _a11, TRPCClientError, isFunction2, import_objectSpread222, METHOD, getUrl, getBody, jsonHttpRequester, _a22, _a12, AbortError, throwIfAborted, import_objectSpread232, throwFatalError, import_objectSpread24, import_objectSpread25, jsonEncoder, lazyDefaults, keepAliveDefaults, exponentialBackoff, resultOf, import_defineProperty$3, _a32, _a13, TRPCWebSocketClosedError, _a42, _a14, ResettableTimeout, import_defineProperty$2, _a52, _a15, RequestManager, import_defineProperty$1, _a62, _a16, WsConnection, import_defineProperty22, import_objectSpread26, _a72, _a17, WsClient, import_defineProperty3, import_objectSpread2$4, _a82, _a18, TRPCUntypedClient, untypedClientSymbol, clientCallTypeMap, clientCallTypeToProcedureType, import_objectSpread2$3, import_objectSpread2$2, require_asyncIterator, import_asyncIterator, import_objectSpread2$12, require_usingCtx, require_OverloadYield, require_awaitAsyncGenerator, require_wrapAsyncGenerator, import_usingCtx, import_awaitAsyncGenerator, import_wrapAsyncGenerator, import_objectSpread27, _a19, _DoubleIndexedKV, DoubleIndexedKV, _a20, _Registry, Registry, _a21, _ClassRegistry, ClassRegistry, _a23, _CustomTransformerRegistry, CustomTransformerRegistry, getType, isUndefined, isNull, isPlainObject, isEmptyObject, isArray, isString, isNumber, isBoolean, isRegExp, isMap, isSet, isSymbol, isDate, isError, isNaNValue, isPrimitive, isBigint, isInfinite, isTypedArray, isURL, escapeKey, stringifyPath, parsePath, simpleRules, symbolRule, constructorToName, typedArrayRule, classRule, customRule, compositeRules, transformValue, simpleRulesByAnnotation, untransformValue, getNthKey, getDeep, setDeep, enableLegacyPaths, isDeep, walker, _a24, _SuperJSON, SuperJSON, serialize, deserialize, stringify, parse, registerClass, registerCustom, registerSymbol, allowErrorProps, MAX_ENTRIES, MAX_OK_API_ENTRIES, MAX_STRING, MAX_SERIALIZED_BYTES, ERROR_SNAPSHOT_TTL_MS, MAX_STACK_LINES, _a25, _CsReportCollector, CsReportCollector, csCollector, hooksInstalled, LOG_LEVELS, _a92, _a26, SDKLogger, sdkLogger, logger, PREFIX, cachedKey, cachedPem, _a27, _AccountService, AccountService, _a28, _AiService, AiService, _a29, _AllowanceService, AllowanceService, _a30, _AnnualLeavePromotionService, AnnualLeavePromotionService, _a31, _AppOnboardingService, AppOnboardingService, _a33, _ApprovalFlowService, ApprovalFlowService, _a34, _AttendanceCorrectionService, AttendanceCorrectionService, _a35, _AttendanceRateService, AttendanceRateService, _a36, _AttendanceService, AttendanceService, _a37, _AuthService, AuthService, _a38, _CertificationTypeService, CertificationTypeService, _a39, _ChatDeviceLinkService, ChatDeviceLinkService, _a40, _ChatKeyService, ChatKeyService, _a41, _ChatRecoveryService, ChatRecoveryService, _a43, _ConversationKeyService, ConversationKeyService, _a44, _ConversationService, ConversationService, _a45, _DeductionImportService, DeductionImportService, _a46, _DeductionService, DeductionService, _a47, _DeviceCredentialService, DeviceCredentialService, _a48, _DocumentService, DocumentService, _a49, _DocumentTemplateService, DocumentTemplateService, _a50, _EducationSubsidyService, EducationSubsidyService, _a51, _EmployeeCertificationService, EmployeeCertificationService, _a53, _EmployeeService, EmployeeService, _a54, _EntityPickerService, EntityPickerService, _a55, _ESignService, ESignService, _a56, _FixedIncentiveService, FixedIncentiveService, _a57, _GeneralAffairsService, GeneralAffairsService, _a58, _GradePromotionService, GradePromotionService, _a59, _ImpersonationService, ImpersonationService, _a60, _InventoryService, InventoryService, _a61, _InviteService, InviteService, _a63, _ItemCodeService, ItemCodeService, _a64, _JobDutyService, JobDutyService, _a65, _LeaveImportService, LeaveImportService, _a66, _LeaveRequestService, LeaveRequestService, _a67, _ManagementDashboardService, ManagementDashboardService, _a68, _MessageService, MessageService, _a69, _ModuleRegistryService, ModuleRegistryService, NOTIFICATION_SETTINGS_CHANGED_EVENT, _a70, _NotificationService, NotificationService, _a71, _NurseSchedulerService, NurseSchedulerService, _a73, _OffsiteWorkService, OffsiteWorkService, _a74, _OrganizationHolidayService, OrganizationHolidayService, _a75, _OrganizationParameterService, OrganizationParameterService, _a76, _OrganizationService, OrganizationService, _a77, _OvertimeService, OvertimeService, _a78, _PayrollService, PayrollService, _a79, _PermissionRequestService, PermissionRequestService, _a80, _RecurringAllowanceService, RecurringAllowanceService, _a81, _ResignationService, ResignationService, _a83, _RoleService, RoleService, _a84, _SalaryGradeService, SalaryGradeService, _a85, _ScheduledActionService, ScheduledActionService, _a86, _ScreenCaptureService, ScreenCaptureService, _a87, _SearchHistoryService, SearchHistoryService, _a88, _SecomEventService, SecomEventService, _a89, _SecurityService, SecurityService, _a90, _SheetCellService, SheetCellService, _a91, _SheetRowService, SheetRowService, _a93, _SheetTemplateService, SheetTemplateService, _a94, _SheetViewService, SheetViewService, _a95, _ShiftGroupService, ShiftGroupService, _a96, _ShiftService, ShiftService, _a97, _SignupService, SignupService, _a98, _StorageService, StorageService, _a99, _TeamDriveService, TeamDriveService, _a100, _TeamManagerService, TeamManagerService, _a101, _TeamService, TeamService, _a102, _WorkPatternService, WorkPatternService, _a103, _WorkTimeClosingService, WorkTimeClosingService, _a104, _YearEndSettlementService, YearEndSettlementService, defaultConfig, IMPERSONATION_RETURN_KEY, IMPERSONATION_NOTICE_KEY, restoredThisPage, IMPERSONATION_EXPIRED_NOTICE, IMPERSONATION_ENDED_NOTICE, historyGuardInstalled, PERMISSION_CODE_RE, HTTP_BATCH_MAX_ITEMS, HTTP_BATCH_MAX_URL_LENGTH, WS_KEEPALIVE, WS_RETRY_MAX_MS, WS_REOPENED_EVENT, _a105, _HerebyClient, HerebyClient, DEFAULT_BRAND, DEFAULT_BRAND_FAMILY, SKIP_DEVICE_LOGIN_AUTO_KEY, devicePushToken, _a106, _ChatKeyManager, ChatKeyManager, _a107, _ConversationKeyManager, ConversationKeyManager, recoveryKeyCache, _a108, _PeerKeyDirectory, PeerKeyDirectory, ENCRYPTED_PUSH_KIND, PUSH_BODY_MAX, _a109, _HerebySDKError, HerebySDKError, _a110, _AuthenticationError, AuthenticationError, _a111, _AuthorizationError, AuthorizationError, _a112, _ValidationError, ValidationError, _a113, _NotFoundError, NotFoundError, _a114, _NetworkError, NetworkError, _a115, _TimeoutError, TimeoutError, _a116, _LocalStorageAdapter, LocalStorageAdapter, _a117, _SessionStorageAdapter, SessionStorageAdapter, _a118, _MemoryStorageAdapter, MemoryStorageAdapter, _a119, _CookieStorageAdapter, CookieStorageAdapter, src_default;
var init_dist = __esm({
  "../sdk/dist/index.mjs"() {
    "use strict";
    init_observable();
    init_unstable_core_do_not_import();
    init_observable();
    init_unstable_core_do_not_import();
    init_observable();
    init_unstable_core_do_not_import();
    init_observable();
    init_unstable_core_do_not_import();
    init_observable();
    init_esm();
    __defProp3 = Object.defineProperty;
    __defNormalProp = /* @__PURE__ */ __name((obj, key, value) => key in obj ? __defProp3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value, "__defNormalProp");
    __name2 = /* @__PURE__ */ __name((target, value) => __defProp3(target, "name", { value, configurable: true }), "__name");
    __publicField = /* @__PURE__ */ __name((obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value), "__publicField");
    installed = false;
    __name(installImeEnterGuard, "installImeEnterGuard");
    __name2(installImeEnterGuard, "installImeEnterGuard");
    subtle = /* @__PURE__ */ __name2(() => {
      const s = globalThis.crypto?.subtle;
      if (!s) {
        throw new Error("\uC774 \uD658\uACBD\uC740 WebCrypto \uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694.");
      }
      return s;
    }, "subtle");
    __name(toBase64Url, "toBase64Url");
    __name2(toBase64Url, "toBase64Url");
    __name(fromBase64Url, "fromBase64Url");
    __name2(fromBase64Url, "fromBase64Url");
    __name(memoizeKey, "memoizeKey");
    __name2(memoizeKey, "memoizeKey");
    _WebWrapKeyProvider = (_a3 = class {
      constructor(store) {
        __publicField(this, "store");
        __publicField(this, "load");
        this.store = store;
        this.load = memoizeKey(async () => {
          const existing = await this.store.getWrapKey();
          if (existing) {
            return existing;
          }
          const key = await subtle().generateKey({
            name: "AES-GCM",
            length: 256
          }, false, [
            "encrypt",
            "decrypt"
          ]);
          await this.store.setWrapKey(key);
          return key;
        });
      }
      getWrappingKey() {
        return this.load();
      }
    }, __name(_a3, "_WebWrapKeyProvider"), _a3);
    __name2(_WebWrapKeyProvider, "WebWrapKeyProvider");
    WebWrapKeyProvider = _WebWrapKeyProvider;
    _SecretBytesProvider = (_a4 = class {
      constructor(readSecret) {
        __publicField(this, "readSecret");
        __publicField(this, "load");
        this.readSecret = readSecret;
        this.load = memoizeKey(async () => {
          const raw = await this.readSecret();
          if (raw.length !== 32) {
            throw new Error("\uAE30\uAE30 \uBCF4\uD638 \uBE44\uBC00\uC758 \uAE38\uC774\uAC00 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694.");
          }
          const copy2 = new Uint8Array(new ArrayBuffer(32));
          copy2.set(raw);
          return subtle().importKey("raw", copy2, {
            name: "AES-GCM"
          }, false, [
            "encrypt",
            "decrypt"
          ]);
        });
      }
      getWrappingKey() {
        return this.load();
      }
    }, __name(_a4, "_SecretBytesProvider"), _a4);
    __name2(_SecretBytesProvider, "SecretBytesProvider");
    SecretBytesProvider = _SecretBytesProvider;
    __name(generateDeviceKey, "generateDeviceKey");
    __name2(generateDeviceKey, "generateDeviceKey");
    __name(signChallenge, "signChallenge");
    __name2(signChallenge, "signChallenge");
    DB_NAME = "hereby-device";
    DB_VERSION = 1;
    STORE_DEVICE_KEY = "deviceKey";
    STORE_WRAP_KEY = "wrapKey";
    ACTIVE = "active";
    DEFAULT = "default";
    __name(request, "request");
    __name2(request, "request");
    _IndexedDbDeviceKeyStore = (_a5 = class {
      constructor() {
        __publicField(this, "dbPromise", null);
      }
      open() {
        if (!this.dbPromise) {
          this.dbPromise = new Promise((resolve2, reject) => {
            const req = indexedDB.open(DB_NAME, DB_VERSION);
            req.onupgradeneeded = () => {
              const db = req.result;
              if (!db.objectStoreNames.contains(STORE_DEVICE_KEY)) {
                db.createObjectStore(STORE_DEVICE_KEY);
              }
              if (!db.objectStoreNames.contains(STORE_WRAP_KEY)) {
                db.createObjectStore(STORE_WRAP_KEY);
              }
            };
            req.onsuccess = () => {
              const db = req.result;
              db.onversionchange = () => {
                db.close();
                this.dbPromise = null;
              };
              resolve2(db);
            };
            req.onerror = () => {
              this.dbPromise = null;
              reject(req.error ?? new Error("IndexedDB \uB97C \uC5F4 \uC218 \uC5C6\uC5B4\uC694."));
            };
          });
        }
        return this.dbPromise;
      }
      async run(store, mode, fn) {
        const db = await this.open();
        const tx = db.transaction(store, mode);
        const result = await request(fn(tx.objectStore(store)));
        await new Promise((resolve2, reject) => {
          tx.oncomplete = () => resolve2();
          tx.onerror = () => reject(tx.error ?? new Error("IndexedDB \uD2B8\uB79C\uC7AD\uC158\uC774 \uC2E4\uD328\uD588\uC5B4\uC694."));
          tx.onabort = () => reject(tx.error ?? new Error("IndexedDB \uD2B8\uB79C\uC7AD\uC158\uC774 \uC911\uB2E8\uB410\uC5B4\uC694."));
        });
        return result;
      }
      async getActive() {
        const row = await this.run(STORE_DEVICE_KEY, "readonly", (s) => s.get(ACTIVE));
        return row ?? null;
      }
      async setActive(record) {
        await this.run(STORE_DEVICE_KEY, "readwrite", (s) => s.put(record, ACTIVE));
      }
      async clearActive() {
        await this.run(STORE_DEVICE_KEY, "readwrite", (s) => s.delete(ACTIVE));
      }
      async getWrapKey() {
        const row = await this.run(STORE_WRAP_KEY, "readonly", (s) => s.get(DEFAULT));
        return row ?? null;
      }
      async setWrapKey(key) {
        await this.run(STORE_WRAP_KEY, "readwrite", (s) => s.put(key, DEFAULT));
      }
    }, __name(_a5, "_IndexedDbDeviceKeyStore"), _a5);
    __name2(_IndexedDbDeviceKeyStore, "IndexedDbDeviceKeyStore");
    IndexedDbDeviceKeyStore = _IndexedDbDeviceKeyStore;
    _MemoryDeviceKeyStore = (_a6 = class {
      constructor() {
        __publicField(this, "active", null);
        __publicField(this, "wrapKey", null);
      }
      async getActive() {
        return this.active;
      }
      async setActive(record) {
        this.active = record;
      }
      async clearActive() {
        this.active = null;
      }
      async getWrapKey() {
        return this.wrapKey;
      }
      async setWrapKey(key) {
        this.wrapKey = key;
      }
    }, __name(_a6, "_MemoryDeviceKeyStore"), _a6);
    __name2(_MemoryDeviceKeyStore, "MemoryDeviceKeyStore");
    MemoryDeviceKeyStore = _MemoryDeviceKeyStore;
    __name(createDefaultDeviceKeyStore, "createDefaultDeviceKeyStore");
    __name2(createDefaultDeviceKeyStore, "createDefaultDeviceKeyStore");
    current = null;
    __name(setDeviceSecretProvider, "setDeviceSecretProvider");
    __name2(setDeviceSecretProvider, "setDeviceSecretProvider");
    __name(getDeviceSecretProvider, "getDeviceSecretProvider");
    __name2(getDeviceSecretProvider, "getDeviceSecretProvider");
    _FallbackWrapProvider = (_a7 = class {
      constructor(providers) {
        __publicField(this, "providers");
        this.providers = providers;
      }
      async getWrappingKey() {
        let lastError = new Error("\uBCF4\uD638 \uD0A4 \uACF5\uAE09\uC790\uAC00 \uC5C6\uC5B4\uC694.");
        for (const p of this.providers) {
          try {
            return await p.getWrappingKey();
          } catch (e) {
            lastError = e;
          }
        }
        throw lastError;
      }
      /** 풀기용 후보 전부 — 못 읽는 공급자는 건너뛴다 */
      async getWrappingKeys() {
        const keys = [];
        for (const p of this.providers) {
          try {
            keys.push(await p.getWrappingKey());
          } catch {
          }
        }
        return keys;
      }
    }, __name(_a7, "_FallbackWrapProvider"), _a7);
    __name2(_FallbackWrapProvider, "FallbackWrapProvider");
    FallbackWrapProvider = _FallbackWrapProvider;
    __name(candidateKeys, "candidateKeys");
    __name2(candidateKeys, "candidateKeys");
    __name(decryptWithAny, "decryptWithAny");
    __name2(decryptWithAny, "decryptWithAny");
    __name(isWrapped, "isWrapped");
    __name2(isWrapped, "isWrapped");
    __name(wrapBytes, "wrapBytes");
    __name2(wrapBytes, "wrapBytes");
    __name(unwrapBytes, "unwrapBytes");
    __name2(unwrapBytes, "unwrapBytes");
    __name(wrapBinary, "wrapBinary");
    __name2(wrapBinary, "wrapBinary");
    __name(unwrapBinary, "unwrapBinary");
    __name2(unwrapBinary, "unwrapBinary");
    __name(wrapJson, "wrapJson");
    __name2(wrapJson, "wrapJson");
    __name(unwrapJson, "unwrapJson");
    __name2(unwrapJson, "unwrapJson");
    epochKeySink = null;
    __name(setEpochKeySink, "setEpochKeySink");
    __name2(setEpochKeySink, "setEpochKeySink");
    __name(mirrorEpochKey, "mirrorEpochKey");
    __name2(mirrorEpochKey, "mirrorEpochKey");
    __name(mirrorClear, "mirrorClear");
    __name2(mirrorClear, "mirrorClear");
    MESSAGE_CACHE_PER_ROOM = 300;
    ATTACHMENT_CACHE_MAX_FILE = 8 * 1024 * 1024;
    ATTACHMENT_CACHE_MAX_TOTAL = 100 * 1024 * 1024;
    __name(matchesIndex, "matchesIndex");
    __name2(matchesIndex, "matchesIndex");
    _MemoryChatKeyStore = (_a8 = class {
      constructor() {
        __publicField(this, "cache", /* @__PURE__ */ new Map());
        __publicField(this, "attachments", /* @__PURE__ */ new Map());
        __publicField(this, "accounts", /* @__PURE__ */ new Map());
        __publicField(this, "epochKeys", /* @__PURE__ */ new Map());
        __publicField(this, "peers", /* @__PURE__ */ new Map());
        __publicField(this, "search", /* @__PURE__ */ new Map());
      }
      async getCachedMessages(employeeId, conversationId, limit) {
        return [
          ...this.cache.values()
        ].filter((c) => c.employeeId === employeeId && c.conversationId === conversationId).sort((a, b) => b.createdAt.localeCompare(a.createdAt)).slice(0, limit).reverse().map(({ employeeId: _e, ...c }) => structuredClone(c));
      }
      async putCachedMessages(employeeId, items) {
        for (const c of items) {
          this.cache.set(c.id, {
            ...structuredClone(c),
            employeeId
          });
        }
        for (const conversationId of new Set(items.map((i) => i.conversationId))) {
          const rows = [
            ...this.cache.values()
          ].filter((c) => c.employeeId === employeeId && c.conversationId === conversationId).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
          for (const stale of rows.slice(MESSAGE_CACHE_PER_ROOM)) {
            this.cache.delete(stale.id);
          }
        }
      }
      async removeCachedMessages(ids) {
        for (const id of ids) {
          this.cache.delete(id);
        }
      }
      async clearMessageCache() {
        this.cache.clear();
      }
      async getCachedAttachment(employeeId, path) {
        const row = this.attachments.get(path);
        if (!row || row.employeeId !== employeeId) {
          return null;
        }
        row.lastUsedAt = Date.now();
        return {
          path: row.path,
          mode: row.mode,
          data: row.data
        };
      }
      async putCachedAttachment(employeeId, item, opts = {}) {
        if (item.data.byteLength > ATTACHMENT_CACHE_MAX_FILE) {
          return;
        }
        this.attachments.set(item.path, {
          ...item,
          employeeId,
          lastUsedAt: Date.now()
        });
        if (opts.trim !== false) {
          await this.trimAttachmentCache(employeeId);
        }
      }
      async trimAttachmentCache(employeeId) {
        const mine = [
          ...this.attachments.values()
        ].filter((a) => a.employeeId === employeeId).sort((a, b) => a.lastUsedAt - b.lastUsedAt);
        let total = mine.reduce((sum, a) => sum + a.data.byteLength, 0);
        for (const old of mine) {
          if (total <= ATTACHMENT_CACHE_MAX_TOTAL) {
            break;
          }
          this.attachments.delete(old.path);
          total -= old.data.byteLength;
        }
      }
      async clearAttachmentCache() {
        this.attachments.clear();
      }
      async getPeerPin(employeeId) {
        return this.peers.get(employeeId) ?? null;
      }
      async putPeerPin(pin) {
        this.peers.set(pin.employeeId, structuredClone(pin));
      }
      async getAccount(employeeId) {
        return this.accounts.get(employeeId) ?? null;
      }
      async putAccount(record) {
        this.accounts.set(record.employeeId, structuredClone(record));
      }
      async deleteAccount(employeeId) {
        this.accounts.delete(employeeId);
      }
      async getEpochKey(conversationId, epoch) {
        return this.epochKeys.get(`${conversationId}:${epoch}`) ?? null;
      }
      async putEpochKey(conversationId, epoch, key) {
        this.epochKeys.set(`${conversationId}:${epoch}`, key);
        mirrorEpochKey(conversationId, epoch, key);
      }
      async listEpochKeys() {
        return [
          ...this.epochKeys.entries()
        ].map(([k, key]) => parseEpochKeyId(k, key));
      }
      async clearEpochKeys() {
        this.epochKeys.clear();
        mirrorClear();
      }
      async putSearchEntries(entries) {
        for (const e of entries) {
          this.search.set(e.messageId, e);
        }
      }
      async searchIndex(params) {
        return [
          ...this.search.values()
        ].filter((e) => matchesIndex(e, params)).sort((a, b) => b.createdAt.localeCompare(a.createdAt)).slice(0, params.limit);
      }
      async clearSearchIndex() {
        this.search.clear();
      }
    }, __name(_a8, "_MemoryChatKeyStore"), _a8);
    __name2(_MemoryChatKeyStore, "MemoryChatKeyStore");
    MemoryChatKeyStore = _MemoryChatKeyStore;
    __name(parseEpochKeyId, "parseEpochKeyId");
    __name2(parseEpochKeyId, "parseEpochKeyId");
    DB_NAME2 = "hereby-chat";
    DB_VERSION2 = 5;
    STORE_MESSAGES = "messages";
    INDEX_MESSAGES_ROOM = "room";
    STORE_ATTACHMENTS = "attachments";
    INDEX_ATTACHMENTS_OWNER = "owner";
    STORE_ACCOUNT = "account";
    STORE_EPOCH = "epochKey";
    STORE_SEARCH = "search";
    STORE_PEER = "peerKey";
    __name(request2, "request2");
    __name2(request2, "request");
    __name(isIndexedDbAvailable, "isIndexedDbAvailable");
    __name2(isIndexedDbAvailable, "isIndexedDbAvailable");
    _IndexedDbChatKeyStore = (_a9 = class {
      constructor(opts = {}) {
        __publicField(this, "dbPromise", null);
        __publicField(this, "wrap");
        __publicField(this, "legacySearchMigrated", false);
        const web = new WebWrapKeyProvider(createDefaultDeviceKeyStore());
        this.wrap = opts.wrap ? new FallbackWrapProvider([
          opts.wrap,
          web
        ]) : web;
      }
      open() {
        if (!this.dbPromise) {
          this.dbPromise = new Promise((resolve2, reject) => {
            const req = indexedDB.open(DB_NAME2, DB_VERSION2);
            req.onupgradeneeded = () => {
              const db = req.result;
              if (!db.objectStoreNames.contains(STORE_ACCOUNT)) {
                db.createObjectStore(STORE_ACCOUNT, {
                  keyPath: "employeeId"
                });
              }
              if (!db.objectStoreNames.contains(STORE_EPOCH)) {
                db.createObjectStore(STORE_EPOCH);
              }
              if (!db.objectStoreNames.contains(STORE_SEARCH)) {
                db.createObjectStore(STORE_SEARCH, {
                  keyPath: "messageId"
                });
              }
              if (!db.objectStoreNames.contains(STORE_PEER)) {
                db.createObjectStore(STORE_PEER, {
                  keyPath: "employeeId"
                });
              }
              if (!db.objectStoreNames.contains(STORE_MESSAGES)) {
                const messages = db.createObjectStore(STORE_MESSAGES, {
                  keyPath: "id"
                });
                messages.createIndex(INDEX_MESSAGES_ROOM, [
                  "employeeId",
                  "conversationId"
                ], {
                  unique: false
                });
              }
              if (!db.objectStoreNames.contains(STORE_ATTACHMENTS)) {
                const attachments2 = db.createObjectStore(STORE_ATTACHMENTS, {
                  keyPath: "path"
                });
                attachments2.createIndex(INDEX_ATTACHMENTS_OWNER, "employeeId", {
                  unique: false
                });
              }
            };
            req.onsuccess = () => {
              const db = req.result;
              db.onversionchange = () => {
                db.close();
                this.dbPromise = null;
              };
              resolve2(db);
            };
            req.onerror = () => {
              this.dbPromise = null;
              reject(req.error ?? new Error("IndexedDB \uB97C \uC5F4 \uC218 \uC5C6\uC5B4\uC694."));
            };
          });
        }
        return this.dbPromise;
      }
      async run(store, mode, fn) {
        const db = await this.open();
        const tx = db.transaction(store, mode);
        const result = await request2(fn(tx.objectStore(store)));
        await new Promise((resolve2, reject) => {
          tx.oncomplete = () => resolve2();
          tx.onerror = () => reject(tx.error ?? new Error("IndexedDB \uD2B8\uB79C\uC7AD\uC158\uC774 \uC2E4\uD328\uD588\uC5B4\uC694."));
          tx.onabort = () => reject(tx.error ?? new Error("IndexedDB \uD2B8\uB79C\uC7AD\uC158\uC774 \uC911\uB2E8\uB410\uC5B4\uC694."));
        });
        return result;
      }
      async getAccount(employeeId) {
        const row = await this.run(STORE_ACCOUNT, "readonly", (s) => s.get(employeeId));
        if (!row) {
          return null;
        }
        if (row.enc) {
          const bundle = await unwrapJson(this.wrap, row.enc);
          return {
            employeeId: row.employeeId,
            organizationId: row.organizationId,
            version: row.version,
            savedAt: row.savedAt,
            bundle
          };
        }
        if (row.bundle) {
          const record = {
            employeeId: row.employeeId,
            organizationId: row.organizationId,
            version: row.version,
            savedAt: row.savedAt,
            bundle: row.bundle
          };
          this.putAccount(record).catch(() => void 0);
          return record;
        }
        return null;
      }
      async getPeerPin(employeeId) {
        const row = await this.run(STORE_PEER, "readonly", (s) => s.get(employeeId));
        return row ?? null;
      }
      async putPeerPin(pin) {
        await this.run(STORE_PEER, "readwrite", (s) => s.put(pin));
      }
      async putAccount(record) {
        const row = {
          employeeId: record.employeeId,
          organizationId: record.organizationId,
          version: record.version,
          savedAt: record.savedAt,
          enc: await wrapJson(this.wrap, record.bundle)
        };
        await this.run(STORE_ACCOUNT, "readwrite", (s) => s.put(row));
      }
      async deleteAccount(employeeId) {
        await this.run(STORE_ACCOUNT, "readwrite", (s) => s.delete(employeeId));
      }
      /** 세대 키 행 — 감싼 것(enc) 또는 예전 평문 바이트 */
      async decodeEpochRow(conversationId, epoch, value) {
        if (isWrapped(value)) {
          return unwrapBytes(this.wrap, value);
        }
        if (value instanceof Uint8Array || value instanceof ArrayBuffer) {
          const raw = new Uint8Array(value);
          this.putEpochKey(conversationId, epoch, raw).catch(() => void 0);
          return raw;
        }
        return null;
      }
      async getEpochKey(conversationId, epoch) {
        const row = await this.run(STORE_EPOCH, "readonly", (s) => s.get(`${conversationId}:${epoch}`));
        return row ? this.decodeEpochRow(conversationId, epoch, row) : null;
      }
      async putEpochKey(conversationId, epoch, key) {
        const enc = await wrapBytes(this.wrap, key);
        await this.run(STORE_EPOCH, "readwrite", (s) => s.put(enc, `${conversationId}:${epoch}`));
        mirrorEpochKey(conversationId, epoch, key);
      }
      async listEpochKeys() {
        const db = await this.open();
        const tx = db.transaction(STORE_EPOCH, "readonly");
        const store = tx.objectStore(STORE_EPOCH);
        const [ids, values] = await Promise.all([
          request2(store.getAllKeys()),
          request2(store.getAll())
        ]);
        const out = [];
        for (let i = 0; i < ids.length; i++) {
          const parsed = parseEpochKeyId(String(ids[i]), new Uint8Array());
          const key = await this.decodeEpochRow(parsed.conversationId, parsed.epoch, values[i]);
          if (key) {
            out.push({
              conversationId: parsed.conversationId,
              epoch: parsed.epoch,
              key
            });
          }
        }
        return out;
      }
      async clearEpochKeys() {
        await this.run(STORE_EPOCH, "readwrite", (s) => s.clear());
        mirrorClear();
      }
      async putRows(store, rows) {
        if (rows.length === 0) {
          return;
        }
        const db = await this.open();
        const tx = db.transaction(store, "readwrite");
        const os = tx.objectStore(store);
        for (const r of rows) {
          os.put(r);
        }
        await new Promise((resolve2, reject) => {
          tx.oncomplete = () => resolve2();
          tx.onerror = () => reject(tx.error ?? new Error("IndexedDB \uD2B8\uB79C\uC7AD\uC158\uC774 \uC2E4\uD328\uD588\uC5B4\uC694."));
          tx.onabort = () => reject(tx.error ?? new Error("IndexedDB \uD2B8\uB79C\uC7AD\uC158\uC774 \uC911\uB2E8\uB410\uC5B4\uC694."));
        });
      }
      async encodeSearchRow(e) {
        return {
          messageId: e.messageId,
          conversationId: e.conversationId,
          senderId: e.senderId,
          createdAt: e.createdAt,
          type: e.type,
          enc: await wrapJson(this.wrap, {
            senderName: e.senderName,
            text: e.text
          })
        };
      }
      async decodeSearchRow(row) {
        if (row.enc) {
          const { senderName, text } = await unwrapJson(this.wrap, row.enc);
          return {
            messageId: row.messageId,
            conversationId: row.conversationId,
            senderId: row.senderId,
            senderName,
            text,
            createdAt: row.createdAt,
            type: row.type
          };
        }
        if (typeof row.text === "string") {
          return {
            messageId: row.messageId,
            conversationId: row.conversationId,
            senderId: row.senderId,
            senderName: row.senderName ?? "",
            text: row.text,
            createdAt: row.createdAt,
            type: row.type
          };
        }
        return null;
      }
      /** 예전 평문 색인 행을 한 번에 감싸 다시 쓴다 — 저장소 인스턴스당 한 번, 처음 색인을 건드릴 때. */
      async migrateLegacySearchRows(rows) {
        if (this.legacySearchMigrated) {
          return;
        }
        this.legacySearchMigrated = true;
        const legacy = rows.filter((r) => !r.enc && typeof r.text === "string");
        if (legacy.length === 0) {
          return;
        }
        const encoded = [];
        for (const r of legacy) {
          const entry = await this.decodeSearchRow(r);
          if (entry) {
            encoded.push(await this.encodeSearchRow(entry));
          }
        }
        await this.putRows(STORE_SEARCH, encoded).catch(() => void 0);
      }
      async putSearchEntries(entries) {
        if (entries.length === 0) {
          return;
        }
        const rows = [];
        for (const e of entries) {
          rows.push(await this.encodeSearchRow(e));
        }
        await this.putRows(STORE_SEARCH, rows);
      }
      /** 색인 전체를 읽어 푼 뒤 거른다 — 한 사람의 대화량(수만 건)에서는 충분히 빠르고, 전문 검색 색인은 두지 않는다. */
      async searchIndex(params) {
        const all = await this.run(STORE_SEARCH, "readonly", (s) => s.getAll());
        this.migrateLegacySearchRows(all).catch(() => void 0);
        const decoded = [];
        for (const row of all) {
          if (params.conversationId && row.conversationId !== params.conversationId) {
            continue;
          }
          if (params.fromSenderId && row.senderId !== params.fromSenderId) {
            continue;
          }
          const entry = await this.decodeSearchRow(row).catch(() => null);
          if (entry) {
            decoded.push(entry);
          }
        }
        return decoded.filter((e) => matchesIndex(e, params)).sort((a, b) => b.createdAt.localeCompare(a.createdAt)).slice(0, params.limit);
      }
      /* ── 메시지 캐시(2026-10-13) ── */
      async getCachedMessages(employeeId, conversationId, limit) {
        const db = await this.open();
        const tx = db.transaction(STORE_MESSAGES, "readonly");
        const index = tx.objectStore(STORE_MESSAGES).index(INDEX_MESSAGES_ROOM);
        const rows = await request2(index.getAll(IDBKeyRange.only([
          employeeId,
          conversationId
        ])));
        rows.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
        const out = [];
        for (const row of rows.slice(0, limit)) {
          try {
            const payload = await unwrapJson(this.wrap, row.enc);
            out.push({
              id: row.id,
              conversationId: row.conversationId,
              createdAt: row.createdAt,
              payload
            });
          } catch {
          }
        }
        return out.reverse();
      }
      async putCachedMessages(employeeId, items) {
        if (items.length === 0) {
          return;
        }
        const rows = [];
        for (const c of items) {
          rows.push({
            id: c.id,
            employeeId,
            conversationId: c.conversationId,
            createdAt: c.createdAt,
            enc: await wrapJson(this.wrap, c.payload)
          });
        }
        await this.putRows(STORE_MESSAGES, rows);
        const db = await this.open();
        for (const conversationId of new Set(items.map((i) => i.conversationId))) {
          const tx = db.transaction(STORE_MESSAGES, "readwrite");
          const os = tx.objectStore(STORE_MESSAGES);
          const all = await request2(os.index(INDEX_MESSAGES_ROOM).getAll(IDBKeyRange.only([
            employeeId,
            conversationId
          ])));
          all.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
          for (const stale of all.slice(MESSAGE_CACHE_PER_ROOM)) {
            os.delete(stale.id);
          }
          await new Promise((resolve2) => {
            tx.oncomplete = () => resolve2();
            tx.onerror = () => resolve2();
            tx.onabort = () => resolve2();
          });
        }
      }
      async removeCachedMessages(ids) {
        for (const id of ids) {
          await this.run(STORE_MESSAGES, "readwrite", (s) => s.delete(id));
        }
      }
      async clearMessageCache() {
        await this.run(STORE_MESSAGES, "readwrite", (s) => s.clear());
      }
      /* ── 첨부 캐시(2026-10-13) ── */
      async getCachedAttachment(employeeId, path) {
        const row = await this.run(STORE_ATTACHMENTS, "readonly", (s) => s.get(path));
        if (!row || row.employeeId !== employeeId) {
          return null;
        }
        this.run(STORE_ATTACHMENTS, "readwrite", (s) => s.put({
          ...row,
          lastUsedAt: Date.now()
        })).catch(() => void 0);
        if (row.mode === "wrapped") {
          const plain = await unwrapBinary(this.wrap, {
            iv: row.iv,
            ct: row.data
          });
          return {
            path: row.path,
            mode: "wrapped",
            data: plain
          };
        }
        return {
          path: row.path,
          mode: "cipher",
          data: new Uint8Array(row.data)
        };
      }
      async putCachedAttachment(employeeId, item, opts = {}) {
        if (item.data.byteLength > ATTACHMENT_CACHE_MAX_FILE) {
          return;
        }
        const base = {
          path: item.path,
          employeeId,
          size: item.data.byteLength,
          lastUsedAt: Date.now()
        };
        const row = item.mode === "wrapped" ? {
          ...base,
          mode: "wrapped",
          ...await wrapBinary(this.wrap, item.data).then((e) => ({
            iv: e.iv,
            data: e.ct
          }))
        } : {
          ...base,
          mode: "cipher",
          iv: null,
          data: item.data
        };
        await this.run(STORE_ATTACHMENTS, "readwrite", (s) => s.put(row));
        if (opts.trim !== false) {
          await this.trimAttachmentCache(employeeId);
        }
      }
      /** 총량 상한 — 가장 오래 안 쓴 것부터. 전체 행을 읽으므로 묶음 저장 뒤 한 번만 부른다(put 마다 부르면 100MB 를 N 번 읽는다). */
      async trimAttachmentCache(employeeId) {
        const db = await this.open();
        const tx = db.transaction(STORE_ATTACHMENTS, "readwrite");
        const os = tx.objectStore(STORE_ATTACHMENTS);
        const mine = await request2(os.index(INDEX_ATTACHMENTS_OWNER).getAll(IDBKeyRange.only(employeeId)));
        mine.sort((a, b) => a.lastUsedAt - b.lastUsedAt);
        let total = mine.reduce((sum, a) => sum + a.size, 0);
        for (const old of mine) {
          if (total <= ATTACHMENT_CACHE_MAX_TOTAL) {
            break;
          }
          os.delete(old.path);
          total -= old.size;
        }
        await new Promise((resolve2) => {
          tx.oncomplete = () => resolve2();
          tx.onerror = () => resolve2();
          tx.onabort = () => resolve2();
        });
      }
      async clearAttachmentCache() {
        await this.run(STORE_ATTACHMENTS, "readwrite", (s) => s.clear());
      }
      async clearSearchIndex() {
        await this.run(STORE_SEARCH, "readwrite", (s) => s.clear());
      }
    }, __name(_a9, "_IndexedDbChatKeyStore"), _a9);
    __name2(_IndexedDbChatKeyStore, "IndexedDbChatKeyStore");
    IndexedDbChatKeyStore = _IndexedDbChatKeyStore;
    __name(createDefaultChatKeyStore, "createDefaultChatKeyStore");
    __name2(createDefaultChatKeyStore, "createDefaultChatKeyStore");
    __name(isAbortError2, "isAbortError");
    __name2(isAbortError2, "isAbortError");
    __name(isDefinitiveAuthFailure, "isDefinitiveAuthFailure");
    __name2(isDefinitiveAuthFailure, "isDefinitiveAuthFailure");
    unloading = false;
    __name(installUnloadGuard, "installUnloadGuard");
    __name2(installUnloadGuard, "installUnloadGuard");
    __name(isUnloading, "isUnloading");
    __name2(isUnloading, "isUnloading");
    __name(isTopLevelFrame, "isTopLevelFrame");
    __name2(isTopLevelFrame, "isTopLevelFrame");
    __create2 = Object.create;
    __defProp22 = Object.defineProperty;
    __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    __getOwnPropNames3 = Object.getOwnPropertyNames;
    __getProtoOf2 = Object.getPrototypeOf;
    __hasOwnProp2 = Object.prototype.hasOwnProperty;
    __commonJS2 = /* @__PURE__ */ __name2((cb, mod) => function() {
      return mod || (0, cb[__getOwnPropNames3(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    }, "__commonJS");
    __copyProps2 = /* @__PURE__ */ __name2((to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames3(from), i = 0, n = keys.length, key; i < n; i++) {
        key = keys[i];
        if (!__hasOwnProp2.call(to, key) && key !== except) __defProp22(to, key, {
          get: ((k) => from[k]).bind(null, key),
          enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable
        });
      }
      return to;
    }, "__copyProps");
    __toESM2 = /* @__PURE__ */ __name2((mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(isNodeMode || !mod || !mod.__esModule ? __defProp22(target, "default", {
      value: mod,
      enumerable: true
    }) : target, mod)), "__toESM");
    require_typeof2 = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js"(exports, module) {
      function _typeof$2(o) {
        "@babel/helpers - typeof";
        return module.exports = _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
          return typeof o$1;
        } : function(o$1) {
          return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof$2(o);
      }
      __name(_typeof$2, "_typeof$2");
      __name2(_typeof$2, "_typeof$2");
      module.exports = _typeof$2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_toPrimitive2 = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js"(exports, module) {
      var _typeof$1 = require_typeof2()["default"];
      function toPrimitive$1(t, r) {
        if ("object" != _typeof$1(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != _typeof$1(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      __name(toPrimitive$1, "toPrimitive$1");
      __name2(toPrimitive$1, "toPrimitive$1");
      module.exports = toPrimitive$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_toPropertyKey2 = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js"(exports, module) {
      var _typeof = require_typeof2()["default"];
      var toPrimitive = require_toPrimitive2();
      function toPropertyKey$1(t) {
        var i = toPrimitive(t, "string");
        return "symbol" == _typeof(i) ? i : i + "";
      }
      __name(toPropertyKey$1, "toPropertyKey$1");
      __name2(toPropertyKey$1, "toPropertyKey$1");
      module.exports = toPropertyKey$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_defineProperty2 = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js"(exports, module) {
      var toPropertyKey = require_toPropertyKey2();
      function _defineProperty(e, r, t) {
        return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
          value: t,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e[r] = t, e;
      }
      __name(_defineProperty, "_defineProperty");
      __name2(_defineProperty, "_defineProperty");
      module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_objectSpread22 = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js"(exports, module) {
      var defineProperty = require_defineProperty2();
      function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
          })), t.push.apply(t, o);
        }
        return t;
      }
      __name(ownKeys, "ownKeys");
      __name2(ownKeys, "ownKeys");
      function _objectSpread2(e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = null != arguments[r] ? arguments[r] : {};
          r % 2 ? ownKeys(Object(t), true).forEach(function(r$1) {
            defineProperty(e, r$1, t[r$1]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
          });
        }
        return e;
      }
      __name(_objectSpread2, "_objectSpread2");
      __name2(_objectSpread2, "_objectSpread2");
      module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    __name(createChain, "createChain");
    __name2(createChain, "createChain");
    __name(asArray, "asArray");
    __name2(asArray, "asArray");
    __name(splitLink, "splitLink");
    __name2(splitLink, "splitLink");
    import_defineProperty2 = __toESM2(require_defineProperty2(), 1);
    import_objectSpread23 = __toESM2(require_objectSpread22(), 1);
    __name(isTRPCClientError, "isTRPCClientError");
    __name2(isTRPCClientError, "isTRPCClientError");
    __name(isTRPCErrorResponse, "isTRPCErrorResponse");
    __name2(isTRPCErrorResponse, "isTRPCErrorResponse");
    __name(getMessageFromUnknownError, "getMessageFromUnknownError");
    __name2(getMessageFromUnknownError, "getMessageFromUnknownError");
    TRPCClientError = (_a10 = (_a11 = class extends Error {
      constructor(message, opts) {
        var _opts$result, _opts$result2;
        const cause = opts === null || opts === void 0 ? void 0 : opts.cause;
        super(message, { cause });
        (0, import_defineProperty2.default)(this, "cause", void 0);
        (0, import_defineProperty2.default)(this, "shape", void 0);
        (0, import_defineProperty2.default)(this, "data", void 0);
        (0, import_defineProperty2.default)(this, "meta", void 0);
        this.meta = opts === null || opts === void 0 ? void 0 : opts.meta;
        this.cause = cause;
        this.shape = opts === null || opts === void 0 || (_opts$result = opts.result) === null || _opts$result === void 0 ? void 0 : _opts$result.error;
        this.data = opts === null || opts === void 0 || (_opts$result2 = opts.result) === null || _opts$result2 === void 0 ? void 0 : _opts$result2.error.data;
        this.name = "TRPCClientError";
        Object.setPrototypeOf(this, _a10.prototype);
      }
      static from(_cause, opts = {}) {
        const cause = _cause;
        if (isTRPCClientError(cause)) {
          if (opts.meta) cause.meta = (0, import_objectSpread23.default)((0, import_objectSpread23.default)({}, cause.meta), opts.meta);
          return cause;
        }
        if (isTRPCErrorResponse(cause)) return new _a10(cause.error.message, (0, import_objectSpread23.default)((0, import_objectSpread23.default)({}, opts), {}, {
          result: cause,
          cause: opts.cause
        }));
        return new _a10(getMessageFromUnknownError(cause, "Unknown error"), (0, import_objectSpread23.default)((0, import_objectSpread23.default)({}, opts), {}, { cause }));
      }
    }, __name(_a11, "_a"), _a11), __name2(_a10, "TRPCClientError"), _a10);
    __name(getTransformer, "getTransformer");
    __name2(getTransformer, "getTransformer");
    isFunction2 = /* @__PURE__ */ __name2((fn) => typeof fn === "function", "isFunction");
    __name(getFetch, "getFetch");
    __name2(getFetch, "getFetch");
    import_objectSpread222 = __toESM2(require_objectSpread22(), 1);
    __name(resolveHTTPLinkOptions, "resolveHTTPLinkOptions");
    __name2(resolveHTTPLinkOptions, "resolveHTTPLinkOptions");
    __name(arrayToDict, "arrayToDict");
    __name2(arrayToDict, "arrayToDict");
    METHOD = {
      query: "GET",
      mutation: "POST",
      subscription: "PATCH"
    };
    __name(getInput, "getInput");
    __name2(getInput, "getInput");
    getUrl = /* @__PURE__ */ __name2((opts) => {
      const parts = opts.url.split("?");
      const base = parts[0].replace(/\/$/, "");
      let url = base + "/" + opts.path;
      const queryParts = [];
      if (parts[1]) queryParts.push(parts[1]);
      if ("inputs" in opts) queryParts.push("batch=1");
      if (opts.type === "query" || opts.type === "subscription") {
        const input = getInput(opts);
        if (input !== void 0 && opts.methodOverride !== "POST") queryParts.push(`input=${encodeURIComponent(JSON.stringify(input))}`);
      }
      if (queryParts.length) url += "?" + queryParts.join("&");
      return url;
    }, "getUrl");
    getBody = /* @__PURE__ */ __name2((opts) => {
      if (opts.type === "query" && opts.methodOverride !== "POST") return void 0;
      const input = getInput(opts);
      return input !== void 0 ? JSON.stringify(input) : void 0;
    }, "getBody");
    jsonHttpRequester = /* @__PURE__ */ __name2((opts) => {
      return httpRequest((0, import_objectSpread222.default)((0, import_objectSpread222.default)({}, opts), {}, {
        contentTypeHeader: "application/json",
        getUrl,
        getBody
      }));
    }, "jsonHttpRequester");
    AbortError = (_a22 = (_a12 = class extends Error {
      constructor() {
        const name = "AbortError";
        super(name);
        this.name = name;
        this.message = name;
      }
    }, __name(_a12, "_a2"), _a12), __name2(_a22, "AbortError"), _a22);
    throwIfAborted = /* @__PURE__ */ __name2((signal) => {
      var _signal$throwIfAborte;
      if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
      (_signal$throwIfAborte = signal.throwIfAborted) === null || _signal$throwIfAborte === void 0 || _signal$throwIfAborte.call(signal);
      if (typeof DOMException !== "undefined") throw new DOMException("AbortError", "AbortError");
      throw new AbortError();
    }, "throwIfAborted");
    __name(fetchHTTPResponse, "fetchHTTPResponse");
    __name2(fetchHTTPResponse, "fetchHTTPResponse");
    __name(httpRequest, "httpRequest");
    __name2(httpRequest, "httpRequest");
    import_objectSpread232 = __toESM2(require_objectSpread22(), 1);
    throwFatalError = /* @__PURE__ */ __name2(() => {
      throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
    }, "throwFatalError");
    __name(dataLoader, "dataLoader");
    __name2(dataLoader, "dataLoader");
    __name(allAbortSignals, "allAbortSignals");
    __name2(allAbortSignals, "allAbortSignals");
    import_objectSpread24 = __toESM2(require_objectSpread22(), 1);
    __name(httpBatchLink, "httpBatchLink");
    __name2(httpBatchLink, "httpBatchLink");
    import_objectSpread25 = __toESM2(require_objectSpread22(), 1);
    jsonEncoder = {
      encode: /* @__PURE__ */ __name2((data) => JSON.stringify(data), "encode"),
      decode: /* @__PURE__ */ __name2((data) => {
        if (typeof data !== "string") throw new Error("jsonEncoder received binary data. JSON uses text frames. Use a binary encoder for binary data.");
        return JSON.parse(data);
      }, "decode")
    };
    lazyDefaults = {
      enabled: false,
      closeMs: 0
    };
    keepAliveDefaults = {
      enabled: false,
      pongTimeoutMs: 1e3,
      intervalMs: 5e3
    };
    exponentialBackoff = /* @__PURE__ */ __name2((attemptIndex) => {
      return attemptIndex === 0 ? 0 : Math.min(1e3 * 2 ** attemptIndex, 3e4);
    }, "exponentialBackoff");
    resultOf = /* @__PURE__ */ __name2((value, ...args) => {
      return typeof value === "function" ? value(...args) : value;
    }, "resultOf");
    import_defineProperty$3 = __toESM2(require_defineProperty2(), 1);
    TRPCWebSocketClosedError = (_a32 = (_a13 = class extends Error {
      constructor(opts) {
        super(opts.message, { cause: opts.cause });
        this.name = "TRPCWebSocketClosedError";
        Object.setPrototypeOf(this, _a32.prototype);
      }
    }, __name(_a13, "_a3"), _a13), __name2(_a32, "TRPCWebSocketClosedError"), _a32);
    ResettableTimeout = (_a42 = (_a14 = class {
      constructor(onTimeout, timeoutMs) {
        this.onTimeout = onTimeout;
        this.timeoutMs = timeoutMs;
        (0, import_defineProperty$3.default)(this, "timeout", void 0);
      }
      /**
      * Resets the current timeout, restarting it with the same duration.
      * Does nothing if no timeout is active.
      */
      reset() {
        if (!this.timeout) return;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.onTimeout, this.timeoutMs);
      }
      start() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.onTimeout, this.timeoutMs);
      }
      stop() {
        clearTimeout(this.timeout);
        this.timeout = void 0;
      }
    }, __name(_a14, "_a4"), _a14), __name2(_a42, "ResettableTimeout"), _a42);
    __name(withResolvers, "withResolvers");
    __name2(withResolvers, "withResolvers");
    __name(prepareUrl, "prepareUrl");
    __name2(prepareUrl, "prepareUrl");
    __name(buildConnectionMessage, "buildConnectionMessage");
    __name2(buildConnectionMessage, "buildConnectionMessage");
    import_defineProperty$2 = __toESM2(require_defineProperty2(), 1);
    RequestManager = (_a52 = (_a15 = class {
      constructor() {
        (0, import_defineProperty$2.default)(this, "outgoingRequests", new Array());
        (0, import_defineProperty$2.default)(this, "pendingRequests", {});
      }
      /**
      * Registers a new request by adding it to the outgoing queue and setting up
      * callbacks for lifecycle events such as completion or error.
      *
      * @param message - The outgoing message to be sent.
      * @param callbacks - Callback functions to observe the request's state.
      * @returns A cleanup function to manually remove the request.
      */
      register(message, callbacks) {
        const { promise: end, resolve: resolve2 } = withResolvers();
        this.outgoingRequests.push({
          id: String(message.id),
          message,
          end,
          callbacks: {
            next: callbacks.next,
            complete: /* @__PURE__ */ __name2(() => {
              callbacks.complete();
              resolve2();
            }, "complete"),
            error: /* @__PURE__ */ __name2((e) => {
              callbacks.error(e);
              resolve2();
            }, "error")
          }
        });
        return () => {
          this.delete(message.id);
          callbacks.complete();
          resolve2();
        };
      }
      /**
      * Deletes a request from both the outgoing and pending collections, if it exists.
      */
      delete(messageId) {
        if (messageId === null) return;
        this.outgoingRequests = this.outgoingRequests.filter(({ id }) => id !== String(messageId));
        delete this.pendingRequests[String(messageId)];
      }
      /**
      * Moves all outgoing requests to the pending state and clears the outgoing queue.
      *
      * The caller is expected to handle the actual sending of the requests
      * (e.g., sending them over the network) after this method is called.
      *
      * @returns The list of requests that were transitioned to the pending state.
      */
      flush() {
        const requests = this.outgoingRequests;
        this.outgoingRequests = [];
        for (const request3 of requests) this.pendingRequests[request3.id] = request3;
        return requests;
      }
      /**
      * Retrieves all currently pending requests, which are in flight awaiting responses
      * or handling ongoing subscriptions.
      */
      getPendingRequests() {
        return Object.values(this.pendingRequests);
      }
      /**
      * Retrieves a specific pending request by its message ID.
      */
      getPendingRequest(messageId) {
        if (messageId === null) return null;
        return this.pendingRequests[String(messageId)];
      }
      /**
      * Retrieves all outgoing requests, which are waiting to be sent.
      */
      getOutgoingRequests() {
        return this.outgoingRequests;
      }
      /**
      * Retrieves all requests, both outgoing and pending, with their respective states.
      *
      * @returns An array of all requests with their state ("outgoing" or "pending").
      */
      getRequests() {
        return [...this.getOutgoingRequests().map((request3) => ({
          state: "outgoing",
          message: request3.message,
          end: request3.end,
          callbacks: request3.callbacks
        })), ...this.getPendingRequests().map((request3) => ({
          state: "pending",
          message: request3.message,
          end: request3.end,
          callbacks: request3.callbacks
        }))];
      }
      /**
      * Checks if there are any pending requests, including ongoing subscriptions.
      */
      hasPendingRequests() {
        return this.getPendingRequests().length > 0;
      }
      /**
      * Checks if there are any pending subscriptions
      */
      hasPendingSubscriptions() {
        return this.getPendingRequests().some((request3) => request3.message.method === "subscription");
      }
      /**
      * Checks if there are any outgoing requests waiting to be sent.
      */
      hasOutgoingRequests() {
        return this.outgoingRequests.length > 0;
      }
    }, __name(_a15, "_a5"), _a15), __name2(_a52, "RequestManager"), _a52);
    import_defineProperty$1 = __toESM2(require_defineProperty2(), 1);
    __name(asyncWsOpen, "asyncWsOpen");
    __name2(asyncWsOpen, "asyncWsOpen");
    __name(setupPingInterval, "setupPingInterval");
    __name2(setupPingInterval, "setupPingInterval");
    WsConnection = (_a62 = (_a16 = class {
      constructor(opts) {
        var _opts$WebSocketPonyfi;
        (0, import_defineProperty$1.default)(this, "id", ++_a62.connectCount);
        (0, import_defineProperty$1.default)(this, "WebSocketPonyfill", void 0);
        (0, import_defineProperty$1.default)(this, "urlOptions", void 0);
        (0, import_defineProperty$1.default)(this, "keepAliveOpts", void 0);
        (0, import_defineProperty$1.default)(this, "encoder", void 0);
        (0, import_defineProperty$1.default)(this, "wsObservable", behaviorSubject(null));
        (0, import_defineProperty$1.default)(this, "openPromise", null);
        this.WebSocketPonyfill = (_opts$WebSocketPonyfi = opts.WebSocketPonyfill) !== null && _opts$WebSocketPonyfi !== void 0 ? _opts$WebSocketPonyfi : WebSocket;
        if (!this.WebSocketPonyfill) throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
        this.urlOptions = opts.urlOptions;
        this.keepAliveOpts = opts.keepAlive;
        this.encoder = opts.encoder;
      }
      get ws() {
        return this.wsObservable.get();
      }
      set ws(ws) {
        this.wsObservable.next(ws);
      }
      /**
      * Checks if the WebSocket connection is open and ready to communicate.
      */
      isOpen() {
        return !!this.ws && this.ws.readyState === this.WebSocketPonyfill.OPEN && !this.openPromise;
      }
      /**
      * Checks if the WebSocket connection is closed or in the process of closing.
      */
      isClosed() {
        return !!this.ws && (this.ws.readyState === this.WebSocketPonyfill.CLOSING || this.ws.readyState === this.WebSocketPonyfill.CLOSED);
      }
      async open() {
        var _this = this;
        if (_this.openPromise) return _this.openPromise;
        _this.id = ++_a62.connectCount;
        const wsPromise = prepareUrl(_this.urlOptions).then((url) => new _this.WebSocketPonyfill(url));
        _this.openPromise = wsPromise.then(async (ws) => {
          _this.ws = ws;
          ws.binaryType = "arraybuffer";
          ws.addEventListener("message", function({ data }) {
            if (data === "PING") this.send("PONG");
          });
          if (_this.keepAliveOpts.enabled) setupPingInterval(ws, _this.keepAliveOpts);
          ws.addEventListener("close", () => {
            if (_this.ws === ws) _this.ws = null;
          });
          await asyncWsOpen(ws);
          if (_this.urlOptions.connectionParams) ws.send(await buildConnectionMessage(_this.urlOptions.connectionParams, _this.encoder));
        });
        try {
          await _this.openPromise;
        } finally {
          _this.openPromise = null;
        }
      }
      /**
      * Closes the WebSocket connection gracefully.
      * Waits for any ongoing open operation to complete before closing.
      */
      async close() {
        var _this2 = this;
        try {
          await _this2.openPromise;
        } finally {
          var _this$ws;
          (_this$ws = _this2.ws) === null || _this$ws === void 0 || _this$ws.close();
        }
      }
    }, __name(_a16, "_a6"), _a16), __name2(_a62, "WsConnection"), _a62);
    (0, import_defineProperty$1.default)(WsConnection, "connectCount", 0);
    __name(backwardCompatibility, "backwardCompatibility");
    __name2(backwardCompatibility, "backwardCompatibility");
    import_defineProperty22 = __toESM2(require_defineProperty2(), 1);
    import_objectSpread26 = __toESM2(require_objectSpread22(), 1);
    WsClient = (_a72 = (_a17 = class {
      constructor(opts) {
        var _opts$experimental_en, _opts$retryDelayMs;
        (0, import_defineProperty22.default)(this, "connectionState", void 0);
        (0, import_defineProperty22.default)(this, "allowReconnect", false);
        (0, import_defineProperty22.default)(this, "requestManager", new RequestManager());
        (0, import_defineProperty22.default)(this, "activeConnection", void 0);
        (0, import_defineProperty22.default)(this, "reconnectRetryDelay", void 0);
        (0, import_defineProperty22.default)(this, "inactivityTimeout", void 0);
        (0, import_defineProperty22.default)(this, "callbacks", void 0);
        (0, import_defineProperty22.default)(this, "lazyMode", void 0);
        (0, import_defineProperty22.default)(this, "encoder", void 0);
        (0, import_defineProperty22.default)(this, "reconnecting", null);
        this.encoder = (_opts$experimental_en = opts.experimental_encoder) !== null && _opts$experimental_en !== void 0 ? _opts$experimental_en : jsonEncoder;
        this.callbacks = {
          onOpen: opts.onOpen,
          onClose: opts.onClose,
          onError: opts.onError
        };
        const lazyOptions = (0, import_objectSpread26.default)((0, import_objectSpread26.default)({}, lazyDefaults), opts.lazy);
        this.inactivityTimeout = new ResettableTimeout(() => {
          if (this.requestManager.hasOutgoingRequests() || this.requestManager.hasPendingRequests()) {
            this.inactivityTimeout.reset();
            return;
          }
          this.close().catch(() => null);
        }, lazyOptions.closeMs);
        this.activeConnection = new WsConnection({
          WebSocketPonyfill: opts.WebSocket,
          urlOptions: opts,
          keepAlive: (0, import_objectSpread26.default)((0, import_objectSpread26.default)({}, keepAliveDefaults), opts.keepAlive),
          encoder: this.encoder
        });
        this.activeConnection.wsObservable.subscribe({ next: /* @__PURE__ */ __name2((ws) => {
          if (!ws) return;
          this.setupWebSocketListeners(ws);
        }, "next") });
        this.reconnectRetryDelay = (_opts$retryDelayMs = opts.retryDelayMs) !== null && _opts$retryDelayMs !== void 0 ? _opts$retryDelayMs : exponentialBackoff;
        this.lazyMode = lazyOptions.enabled;
        this.connectionState = behaviorSubject({
          type: "state",
          state: lazyOptions.enabled ? "idle" : "connecting",
          error: null
        });
        if (!this.lazyMode) this.open().catch(() => null);
      }
      /**
      * Opens the WebSocket connection. Handles reconnection attempts and updates
      * the connection state accordingly.
      */
      async open() {
        var _this = this;
        _this.allowReconnect = true;
        if (_this.connectionState.get().state === "idle") _this.connectionState.next({
          type: "state",
          state: "connecting",
          error: null
        });
        try {
          await _this.activeConnection.open();
        } catch (error) {
          _this.reconnect(new TRPCWebSocketClosedError({
            message: "Initialization error",
            cause: error
          }));
          return _this.reconnecting;
        }
      }
      /**
      * Closes the WebSocket connection and stops managing requests.
      * Ensures all outgoing and pending requests are properly finalized.
      */
      async close() {
        var _this2 = this;
        _this2.allowReconnect = false;
        _this2.inactivityTimeout.stop();
        const requestsToAwait = [];
        for (const request3 of _this2.requestManager.getRequests()) if (request3.message.method === "subscription") request3.callbacks.complete();
        else if (request3.state === "outgoing") request3.callbacks.error(TRPCClientError.from(new TRPCWebSocketClosedError({ message: "Closed before connection was established" })));
        else requestsToAwait.push(request3.end);
        await Promise.all(requestsToAwait).catch(() => null);
        await _this2.activeConnection.close().catch(() => null);
        _this2.connectionState.next({
          type: "state",
          state: "idle",
          error: null
        });
      }
      /**
      * Method to request the server.
      * Handles data transformation, batching of requests, and subscription lifecycle.
      *
      * @param op - The operation details including id, type, path, input and signal
      * @param transformer - Data transformer for serializing requests and deserializing responses
      * @param lastEventId - Optional ID of the last received event for subscriptions
      *
      * @returns An observable that emits operation results and handles cleanup
      */
      request({ op: { id, type, path, input, signal }, transformer, lastEventId }) {
        return observable((observer) => {
          const abort = this.batchSend({
            id,
            method: type,
            params: {
              input: transformer.input.serialize(input),
              path,
              lastEventId
            }
          }, (0, import_objectSpread26.default)((0, import_objectSpread26.default)({}, observer), {}, { next(event) {
            const transformed = transformResult(event, transformer.output);
            if (!transformed.ok) {
              observer.error(TRPCClientError.from(transformed.error));
              return;
            }
            observer.next({ result: transformed.result });
          } }));
          return () => {
            abort();
            if (type === "subscription" && this.activeConnection.isOpen()) this.send({
              id,
              method: "subscription.stop"
            });
            signal === null || signal === void 0 || signal.removeEventListener("abort", abort);
          };
        });
      }
      get connection() {
        return backwardCompatibility(this.activeConnection);
      }
      reconnect(closedError) {
        var _this3 = this;
        this.connectionState.next({
          type: "state",
          state: "connecting",
          error: TRPCClientError.from(closedError)
        });
        if (this.reconnecting) return;
        const tryReconnect = /* @__PURE__ */ __name2(async (attemptIndex) => {
          try {
            await sleep(_this3.reconnectRetryDelay(attemptIndex));
            if (_this3.allowReconnect) {
              await _this3.activeConnection.close();
              await _this3.activeConnection.open();
              if (_this3.requestManager.hasPendingRequests()) _this3.send(_this3.requestManager.getPendingRequests().map(({ message }) => message));
            }
            _this3.reconnecting = null;
          } catch (_unused) {
            await tryReconnect(attemptIndex + 1);
          }
        }, "tryReconnect");
        this.reconnecting = tryReconnect(0);
      }
      setupWebSocketListeners(ws) {
        var _this4 = this;
        const handleCloseOrError = /* @__PURE__ */ __name2((cause) => {
          const reqs = this.requestManager.getPendingRequests();
          for (const { message, callbacks } of reqs) {
            if (message.method === "subscription") continue;
            callbacks.error(TRPCClientError.from(cause !== null && cause !== void 0 ? cause : new TRPCWebSocketClosedError({
              message: "WebSocket closed",
              cause
            })));
            this.requestManager.delete(message.id);
          }
        }, "handleCloseOrError");
        ws.addEventListener("open", () => {
          run(async () => {
            var _this$callbacks$onOpe, _this$callbacks;
            if (_this4.lazyMode) _this4.inactivityTimeout.start();
            (_this$callbacks$onOpe = (_this$callbacks = _this4.callbacks).onOpen) === null || _this$callbacks$onOpe === void 0 || _this$callbacks$onOpe.call(_this$callbacks);
            _this4.connectionState.next({
              type: "state",
              state: "pending",
              error: null
            });
          }).catch((error) => {
            ws.close(3e3);
            handleCloseOrError(error);
          });
        });
        ws.addEventListener("message", ({ data }) => {
          this.inactivityTimeout.reset();
          if (["PING", "PONG"].includes(data)) return;
          const incomingMessage = this.encoder.decode(data);
          if ("method" in incomingMessage) {
            this.handleIncomingRequest(incomingMessage);
            return;
          }
          this.handleResponseMessage(incomingMessage);
        });
        ws.addEventListener("close", (event) => {
          var _this$callbacks$onClo, _this$callbacks2;
          handleCloseOrError(event);
          (_this$callbacks$onClo = (_this$callbacks2 = this.callbacks).onClose) === null || _this$callbacks$onClo === void 0 || _this$callbacks$onClo.call(_this$callbacks2, event);
          if (!this.lazyMode || this.requestManager.hasPendingSubscriptions()) this.reconnect(new TRPCWebSocketClosedError({
            message: "WebSocket closed",
            cause: event
          }));
        });
        ws.addEventListener("error", (event) => {
          var _this$callbacks$onErr, _this$callbacks3;
          handleCloseOrError(event);
          (_this$callbacks$onErr = (_this$callbacks3 = this.callbacks).onError) === null || _this$callbacks$onErr === void 0 || _this$callbacks$onErr.call(_this$callbacks3, event);
          this.reconnect(new TRPCWebSocketClosedError({
            message: "WebSocket closed",
            cause: event
          }));
        });
      }
      handleResponseMessage(message) {
        const request3 = this.requestManager.getPendingRequest(message.id);
        if (!request3) return;
        request3.callbacks.next(message);
        let completed = true;
        if ("result" in message && request3.message.method === "subscription") {
          if (message.result.type === "data") request3.message.params.lastEventId = message.result.id;
          if (message.result.type !== "stopped") completed = false;
        }
        if (completed) {
          request3.callbacks.complete();
          this.requestManager.delete(message.id);
        }
      }
      handleIncomingRequest(message) {
        if (message.method === "reconnect") this.reconnect(new TRPCWebSocketClosedError({ message: "Server requested reconnect" }));
      }
      /**
      * Sends a message or batch of messages directly to the server.
      */
      send(messageOrMessages) {
        if (!this.activeConnection.isOpen()) throw new Error("Active connection is not open");
        const messages = messageOrMessages instanceof Array ? messageOrMessages : [messageOrMessages];
        this.activeConnection.ws.send(this.encoder.encode(messages.length === 1 ? messages[0] : messages));
      }
      /**
      * Groups requests for batch sending.
      *
      * @returns A function to abort the batched request.
      */
      batchSend(message, callbacks) {
        var _this5 = this;
        this.inactivityTimeout.reset();
        run(async () => {
          if (!_this5.activeConnection.isOpen()) await _this5.open();
          await sleep(0);
          if (!_this5.requestManager.hasOutgoingRequests()) return;
          _this5.send(_this5.requestManager.flush().map(({ message: message$1 }) => message$1));
        }).catch((err) => {
          this.requestManager.delete(message.id);
          callbacks.error(TRPCClientError.from(err));
        });
        return this.requestManager.register(message, callbacks);
      }
    }, __name(_a17, "_a7"), _a17), __name2(_a72, "WsClient"), _a72);
    __name(createWSClient, "createWSClient");
    __name2(createWSClient, "createWSClient");
    __name(wsLink, "wsLink");
    __name2(wsLink, "wsLink");
    import_defineProperty3 = __toESM2(require_defineProperty2(), 1);
    import_objectSpread2$4 = __toESM2(require_objectSpread22(), 1);
    TRPCUntypedClient = (_a82 = (_a18 = class {
      constructor(opts) {
        (0, import_defineProperty3.default)(this, "links", void 0);
        (0, import_defineProperty3.default)(this, "runtime", void 0);
        (0, import_defineProperty3.default)(this, "requestId", void 0);
        this.requestId = 0;
        this.runtime = {};
        this.links = opts.links.map((link) => link(this.runtime));
      }
      $request(opts) {
        var _opts$context;
        const chain$ = createChain({
          links: this.links,
          op: (0, import_objectSpread2$4.default)((0, import_objectSpread2$4.default)({}, opts), {}, {
            context: (_opts$context = opts.context) !== null && _opts$context !== void 0 ? _opts$context : {},
            id: ++this.requestId
          })
        });
        return chain$.pipe(share());
      }
      async requestAsPromise(opts) {
        var _this = this;
        try {
          const req$ = _this.$request(opts);
          const envelope = await observableToPromise(req$);
          const data = envelope.result.data;
          return data;
        } catch (err) {
          throw TRPCClientError.from(err);
        }
      }
      query(path, input, opts) {
        return this.requestAsPromise({
          type: "query",
          path,
          input,
          context: opts === null || opts === void 0 ? void 0 : opts.context,
          signal: opts === null || opts === void 0 ? void 0 : opts.signal
        });
      }
      mutation(path, input, opts) {
        return this.requestAsPromise({
          type: "mutation",
          path,
          input,
          context: opts === null || opts === void 0 ? void 0 : opts.context,
          signal: opts === null || opts === void 0 ? void 0 : opts.signal
        });
      }
      subscription(path, input, opts) {
        const observable$ = this.$request({
          type: "subscription",
          path,
          input,
          context: opts.context,
          signal: opts.signal
        });
        return observable$.subscribe({
          next(envelope) {
            switch (envelope.result.type) {
              case "state": {
                var _opts$onConnectionSta;
                (_opts$onConnectionSta = opts.onConnectionStateChange) === null || _opts$onConnectionSta === void 0 || _opts$onConnectionSta.call(opts, envelope.result);
                break;
              }
              case "started": {
                var _opts$onStarted;
                (_opts$onStarted = opts.onStarted) === null || _opts$onStarted === void 0 || _opts$onStarted.call(opts, { context: envelope.context });
                break;
              }
              case "stopped": {
                var _opts$onStopped;
                (_opts$onStopped = opts.onStopped) === null || _opts$onStopped === void 0 || _opts$onStopped.call(opts);
                break;
              }
              case "data":
              case void 0: {
                var _opts$onData;
                (_opts$onData = opts.onData) === null || _opts$onData === void 0 || _opts$onData.call(opts, envelope.result.data);
                break;
              }
            }
          },
          error(err) {
            var _opts$onError;
            (_opts$onError = opts.onError) === null || _opts$onError === void 0 || _opts$onError.call(opts, err);
          },
          complete() {
            var _opts$onComplete;
            (_opts$onComplete = opts.onComplete) === null || _opts$onComplete === void 0 || _opts$onComplete.call(opts);
          }
        });
      }
    }, __name(_a18, "_a8"), _a18), __name2(_a82, "TRPCUntypedClient"), _a82);
    untypedClientSymbol = Symbol.for("trpc_untypedClient");
    clientCallTypeMap = {
      query: "query",
      mutate: "mutation",
      subscribe: "subscription"
    };
    clientCallTypeToProcedureType = /* @__PURE__ */ __name2((clientCallType) => {
      return clientCallTypeMap[clientCallType];
    }, "clientCallTypeToProcedureType");
    __name(createTRPCClientProxy, "createTRPCClientProxy");
    __name2(createTRPCClientProxy, "createTRPCClientProxy");
    __name(createTRPCClient, "createTRPCClient");
    __name2(createTRPCClient, "createTRPCClient");
    import_objectSpread2$3 = __toESM2(require_objectSpread22(), 1);
    import_objectSpread2$2 = __toESM2(require_objectSpread22(), 1);
    require_asyncIterator = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncIterator.js"(exports, module) {
      function _asyncIterator$1(r) {
        var n, t, o, e = 2;
        for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--; ) {
          if (t && null != (n = r[t])) return n.call(r);
          if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r));
          t = "@@asyncIterator", o = "@@iterator";
        }
        throw new TypeError("Object is not async iterable");
      }
      __name(_asyncIterator$1, "_asyncIterator$1");
      __name2(_asyncIterator$1, "_asyncIterator$1");
      function AsyncFromSyncIterator(r) {
        function AsyncFromSyncIteratorContinuation(r$1) {
          if (Object(r$1) !== r$1) return Promise.reject(new TypeError(r$1 + " is not an object."));
          var n = r$1.done;
          return Promise.resolve(r$1.value).then(function(r$2) {
            return {
              value: r$2,
              done: n
            };
          });
        }
        __name(AsyncFromSyncIteratorContinuation, "AsyncFromSyncIteratorContinuation");
        __name2(AsyncFromSyncIteratorContinuation, "AsyncFromSyncIteratorContinuation");
        return AsyncFromSyncIterator = /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function AsyncFromSyncIterator$1(r$1) {
          this.s = r$1, this.n = r$1.next;
        }, "AsyncFromSyncIterator$1"), "AsyncFromSyncIterator$1"), AsyncFromSyncIterator.prototype = {
          s: null,
          n: null,
          next: /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function next() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
          }, "next"), "next"),
          "return": /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function _return(r$1) {
            var n = this.s["return"];
            return void 0 === n ? Promise.resolve({
              value: r$1,
              done: true
            }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
          }, "_return"), "_return"),
          "throw": /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function _throw(r$1) {
            var n = this.s["return"];
            return void 0 === n ? Promise.reject(r$1) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
          }, "_throw"), "_throw")
        }, new AsyncFromSyncIterator(r);
      }
      __name(AsyncFromSyncIterator, "AsyncFromSyncIterator");
      __name2(AsyncFromSyncIterator, "AsyncFromSyncIterator");
      module.exports = _asyncIterator$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    import_asyncIterator = __toESM2(require_asyncIterator(), 1);
    import_objectSpread2$12 = __toESM2(require_objectSpread22(), 1);
    require_usingCtx = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/usingCtx.js"(exports, module) {
      function _usingCtx() {
        var r = "function" == typeof SuppressedError ? SuppressedError : function(r$1, e$1) {
          var n$1 = Error();
          return n$1.name = "SuppressedError", n$1.error = r$1, n$1.suppressed = e$1, n$1;
        }, e = {}, n = [];
        function using(r$1, e$1) {
          if (null != e$1) {
            if (Object(e$1) !== e$1) throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");
            if (r$1) var o = e$1[Symbol.asyncDispose || Symbol["for"]("Symbol.asyncDispose")];
            if (void 0 === o && (o = e$1[Symbol.dispose || Symbol["for"]("Symbol.dispose")], r$1)) var t = o;
            if ("function" != typeof o) throw new TypeError("Object is not disposable.");
            t && (o = /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function o$1() {
              try {
                t.call(e$1);
              } catch (r$2) {
                return Promise.reject(r$2);
              }
            }, "o$1"), "o$1")), n.push({
              v: e$1,
              d: o,
              a: r$1
            });
          } else r$1 && n.push({
            d: e$1,
            a: r$1
          });
          return e$1;
        }
        __name(using, "using");
        __name2(using, "using");
        return {
          e,
          u: using.bind(null, false),
          a: using.bind(null, true),
          d: /* @__PURE__ */ __name2(/* @__PURE__ */ __name(function d() {
            var o, t = this.e, s = 0;
            function next() {
              for (; o = n.pop(); ) try {
                if (!o.a && 1 === s) return s = 0, n.push(o), Promise.resolve().then(next);
                if (o.d) {
                  var r$1 = o.d.call(o.v);
                  if (o.a) return s |= 2, Promise.resolve(r$1).then(next, err);
                } else s |= 1;
              } catch (r$2) {
                return err(r$2);
              }
              if (1 === s) return t !== e ? Promise.reject(t) : Promise.resolve();
              if (t !== e) throw t;
            }
            __name(next, "next");
            __name2(next, "next");
            function err(n$1) {
              return t = t !== e ? new r(n$1, t) : n$1, next();
            }
            __name(err, "err");
            __name2(err, "err");
            return next();
          }, "d"), "d")
        };
      }
      __name(_usingCtx, "_usingCtx");
      __name2(_usingCtx, "_usingCtx");
      module.exports = _usingCtx, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_OverloadYield = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/OverloadYield.js"(exports, module) {
      function _OverloadYield(e, d) {
        this.v = e, this.k = d;
      }
      __name(_OverloadYield, "_OverloadYield");
      __name2(_OverloadYield, "_OverloadYield");
      module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_awaitAsyncGenerator = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/awaitAsyncGenerator.js"(exports, module) {
      var OverloadYield$1 = require_OverloadYield();
      function _awaitAsyncGenerator$1(e) {
        return new OverloadYield$1(e, 0);
      }
      __name(_awaitAsyncGenerator$1, "_awaitAsyncGenerator$1");
      __name2(_awaitAsyncGenerator$1, "_awaitAsyncGenerator$1");
      module.exports = _awaitAsyncGenerator$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    require_wrapAsyncGenerator = __commonJS2({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/wrapAsyncGenerator.js"(exports, module) {
      var OverloadYield = require_OverloadYield();
      function _wrapAsyncGenerator$1(e) {
        return function() {
          return new AsyncGenerator(e.apply(this, arguments));
        };
      }
      __name(_wrapAsyncGenerator$1, "_wrapAsyncGenerator$1");
      __name2(_wrapAsyncGenerator$1, "_wrapAsyncGenerator$1");
      function AsyncGenerator(e) {
        var r, t;
        function resume(r$1, t$1) {
          try {
            var n = e[r$1](t$1), o = n.value, u = o instanceof OverloadYield;
            Promise.resolve(u ? o.v : o).then(function(t$2) {
              if (u) {
                var i = "return" === r$1 ? "return" : "next";
                if (!o.k || t$2.done) return resume(i, t$2);
                t$2 = e[i](t$2).value;
              }
              settle(n.done ? "return" : "normal", t$2);
            }, function(e$1) {
              resume("throw", e$1);
            });
          } catch (e$1) {
            settle("throw", e$1);
          }
        }
        __name(resume, "resume");
        __name2(resume, "resume");
        function settle(e$1, n) {
          switch (e$1) {
            case "return":
              r.resolve({
                value: n,
                done: true
              });
              break;
            case "throw":
              r.reject(n);
              break;
            default:
              r.resolve({
                value: n,
                done: false
              });
          }
          (r = r.next) ? resume(r.key, r.arg) : t = null;
        }
        __name(settle, "settle");
        __name2(settle, "settle");
        this._invoke = function(e$1, n) {
          return new Promise(function(o, u) {
            var i = {
              key: e$1,
              arg: n,
              resolve: o,
              reject: u,
              next: null
            };
            t ? t = t.next = i : (r = t = i, resume(e$1, n));
          });
        }, "function" != typeof e["return"] && (this["return"] = void 0);
      }
      __name(AsyncGenerator, "AsyncGenerator");
      __name2(AsyncGenerator, "AsyncGenerator");
      AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
        return this;
      }, AsyncGenerator.prototype.next = function(e) {
        return this._invoke("next", e);
      }, AsyncGenerator.prototype["throw"] = function(e) {
        return this._invoke("throw", e);
      }, AsyncGenerator.prototype["return"] = function(e) {
        return this._invoke("return", e);
      };
      module.exports = _wrapAsyncGenerator$1, module.exports.__esModule = true, module.exports["default"] = module.exports;
    } });
    import_usingCtx = __toESM2(require_usingCtx(), 1);
    import_awaitAsyncGenerator = __toESM2(require_awaitAsyncGenerator(), 1);
    import_wrapAsyncGenerator = __toESM2(require_wrapAsyncGenerator(), 1);
    import_objectSpread27 = __toESM2(require_objectSpread22(), 1);
    _DoubleIndexedKV = (_a19 = class {
      constructor() {
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
      }
      set(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
      }
      getByKey(key) {
        return this.keyToValue.get(key);
      }
      getByValue(value) {
        return this.valueToKey.get(value);
      }
      clear() {
        this.keyToValue.clear();
        this.valueToKey.clear();
      }
    }, __name(_a19, "_DoubleIndexedKV"), _a19);
    __name2(_DoubleIndexedKV, "DoubleIndexedKV");
    DoubleIndexedKV = _DoubleIndexedKV;
    _Registry = (_a20 = class {
      constructor(generateIdentifier) {
        this.generateIdentifier = generateIdentifier;
        this.kv = new DoubleIndexedKV();
      }
      register(value, identifier) {
        if (this.kv.getByValue(value)) {
          return;
        }
        if (!identifier) {
          identifier = this.generateIdentifier(value);
        }
        this.kv.set(identifier, value);
      }
      clear() {
        this.kv.clear();
      }
      getIdentifier(value) {
        return this.kv.getByValue(value);
      }
      getValue(identifier) {
        return this.kv.getByKey(identifier);
      }
    }, __name(_a20, "_Registry"), _a20);
    __name2(_Registry, "Registry");
    Registry = _Registry;
    _ClassRegistry = (_a21 = class extends Registry {
      constructor() {
        super((c) => c.name);
        this.classToAllowedProps = /* @__PURE__ */ new Map();
      }
      register(value, options) {
        if (typeof options === "object") {
          if (options.allowProps) {
            this.classToAllowedProps.set(value, options.allowProps);
          }
          super.register(value, options.identifier);
        } else {
          super.register(value, options);
        }
      }
      getAllowedProps(value) {
        return this.classToAllowedProps.get(value);
      }
    }, __name(_a21, "_ClassRegistry"), _a21);
    __name2(_ClassRegistry, "ClassRegistry");
    ClassRegistry = _ClassRegistry;
    __name(valuesOfObj, "valuesOfObj");
    __name2(valuesOfObj, "valuesOfObj");
    __name(find, "find");
    __name2(find, "find");
    __name(forEach, "forEach");
    __name2(forEach, "forEach");
    __name(includes, "includes");
    __name2(includes, "includes");
    __name(findArr, "findArr");
    __name2(findArr, "findArr");
    _CustomTransformerRegistry = (_a23 = class {
      constructor() {
        this.transfomers = {};
      }
      register(transformer) {
        this.transfomers[transformer.name] = transformer;
      }
      findApplicable(v) {
        return find(this.transfomers, (transformer) => transformer.isApplicable(v));
      }
      findByName(name) {
        return this.transfomers[name];
      }
    }, __name(_a23, "_CustomTransformerRegistry"), _a23);
    __name2(_CustomTransformerRegistry, "CustomTransformerRegistry");
    CustomTransformerRegistry = _CustomTransformerRegistry;
    getType = /* @__PURE__ */ __name2((payload) => Object.prototype.toString.call(payload).slice(8, -1), "getType");
    isUndefined = /* @__PURE__ */ __name2((payload) => typeof payload === "undefined", "isUndefined");
    isNull = /* @__PURE__ */ __name2((payload) => payload === null, "isNull");
    isPlainObject = /* @__PURE__ */ __name2((payload) => {
      if (typeof payload !== "object" || payload === null) return false;
      if (payload === Object.prototype) return false;
      if (Object.getPrototypeOf(payload) === null) return true;
      return Object.getPrototypeOf(payload) === Object.prototype;
    }, "isPlainObject");
    isEmptyObject = /* @__PURE__ */ __name2((payload) => isPlainObject(payload) && Object.keys(payload).length === 0, "isEmptyObject");
    isArray = /* @__PURE__ */ __name2((payload) => Array.isArray(payload), "isArray");
    isString = /* @__PURE__ */ __name2((payload) => typeof payload === "string", "isString");
    isNumber = /* @__PURE__ */ __name2((payload) => typeof payload === "number" && !isNaN(payload), "isNumber");
    isBoolean = /* @__PURE__ */ __name2((payload) => typeof payload === "boolean", "isBoolean");
    isRegExp = /* @__PURE__ */ __name2((payload) => payload instanceof RegExp, "isRegExp");
    isMap = /* @__PURE__ */ __name2((payload) => payload instanceof Map, "isMap");
    isSet = /* @__PURE__ */ __name2((payload) => payload instanceof Set, "isSet");
    isSymbol = /* @__PURE__ */ __name2((payload) => getType(payload) === "Symbol", "isSymbol");
    isDate = /* @__PURE__ */ __name2((payload) => payload instanceof Date && !isNaN(payload.valueOf()), "isDate");
    isError = /* @__PURE__ */ __name2((payload) => payload instanceof Error, "isError");
    isNaNValue = /* @__PURE__ */ __name2((payload) => typeof payload === "number" && isNaN(payload), "isNaNValue");
    isPrimitive = /* @__PURE__ */ __name2((payload) => isBoolean(payload) || isNull(payload) || isUndefined(payload) || isNumber(payload) || isString(payload) || isSymbol(payload), "isPrimitive");
    isBigint = /* @__PURE__ */ __name2((payload) => typeof payload === "bigint", "isBigint");
    isInfinite = /* @__PURE__ */ __name2((payload) => payload === Infinity || payload === -Infinity, "isInfinite");
    isTypedArray = /* @__PURE__ */ __name2((payload) => ArrayBuffer.isView(payload) && !(payload instanceof DataView), "isTypedArray");
    isURL = /* @__PURE__ */ __name2((payload) => payload instanceof URL, "isURL");
    escapeKey = /* @__PURE__ */ __name2((key) => key.replace(/\\/g, "\\\\").replace(/\./g, "\\."), "escapeKey");
    stringifyPath = /* @__PURE__ */ __name2((path) => path.map(String).map(escapeKey).join("."), "stringifyPath");
    parsePath = /* @__PURE__ */ __name2((string, legacyPaths) => {
      const result = [];
      let segment = "";
      for (let i = 0; i < string.length; i++) {
        let char = string.charAt(i);
        if (!legacyPaths && char === "\\") {
          const escaped = string.charAt(i + 1);
          if (escaped === "\\") {
            segment += "\\";
            i++;
            continue;
          } else if (escaped !== ".") {
            throw Error("invalid path");
          }
        }
        const isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
          segment += ".";
          i++;
          continue;
        }
        const isEndOfSegment = char === ".";
        if (isEndOfSegment) {
          result.push(segment);
          segment = "";
          continue;
        }
        segment += char;
      }
      const lastSegment = segment;
      result.push(lastSegment);
      return result;
    }, "parsePath");
    __name(simpleTransformation, "simpleTransformation");
    __name2(simpleTransformation, "simpleTransformation");
    simpleRules = [
      simpleTransformation(isUndefined, "undefined", () => null, () => void 0),
      simpleTransformation(isBigint, "bigint", (v) => v.toString(), (v) => {
        if (typeof BigInt !== "undefined") {
          return BigInt(v);
        }
        console.error("Please add a BigInt polyfill.");
        return v;
      }),
      simpleTransformation(isDate, "Date", (v) => v.toISOString(), (v) => new Date(v)),
      simpleTransformation(isError, "Error", (v, superJson) => {
        const baseError = {
          name: v.name,
          message: v.message
        };
        if ("cause" in v) {
          baseError.cause = v.cause;
        }
        superJson.allowedErrorProps.forEach((prop) => {
          baseError[prop] = v[prop];
        });
        return baseError;
      }, (v, superJson) => {
        const e = new Error(v.message, {
          cause: v.cause
        });
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach((prop) => {
          e[prop] = v[prop];
        });
        return e;
      }),
      simpleTransformation(isRegExp, "regexp", (v) => "" + v, (regex) => {
        const body = regex.slice(1, regex.lastIndexOf("/"));
        const flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
      }),
      simpleTransformation(
        isSet,
        "set",
        // (sets only exist in es6+)
        // eslint-disable-next-line es5/no-es6-methods
        (v) => [
          ...v.values()
        ],
        (v) => new Set(v)
      ),
      simpleTransformation(isMap, "map", (v) => [
        ...v.entries()
      ], (v) => new Map(v)),
      simpleTransformation((v) => isNaNValue(v) || isInfinite(v), "number", (v) => {
        if (isNaNValue(v)) {
          return "NaN";
        }
        if (v > 0) {
          return "Infinity";
        } else {
          return "-Infinity";
        }
      }, Number),
      simpleTransformation((v) => v === 0 && 1 / v === -Infinity, "number", () => {
        return "-0";
      }, Number),
      simpleTransformation(isURL, "URL", (v) => v.toString(), (v) => new URL(v))
    ];
    __name(compositeTransformation, "compositeTransformation");
    __name2(compositeTransformation, "compositeTransformation");
    symbolRule = compositeTransformation((s, superJson) => {
      if (isSymbol(s)) {
        const isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
      }
      return false;
    }, (s, superJson) => {
      const identifier = superJson.symbolRegistry.getIdentifier(s);
      return [
        "symbol",
        identifier
      ];
    }, (v) => v.description, (_, a, superJson) => {
      const value = superJson.symbolRegistry.getValue(a[1]);
      if (!value) {
        throw new Error("Trying to deserialize unknown symbol");
      }
      return value;
    });
    constructorToName = [
      Int8Array,
      Uint8Array,
      Int16Array,
      Uint16Array,
      Int32Array,
      Uint32Array,
      Float32Array,
      Float64Array,
      Uint8ClampedArray
    ].reduce((obj, ctor) => {
      obj[ctor.name] = ctor;
      return obj;
    }, {});
    typedArrayRule = compositeTransformation(isTypedArray, (v) => [
      "typed-array",
      v.constructor.name
    ], (v) => [
      ...v
    ], (v, a) => {
      const ctor = constructorToName[a[1]];
      if (!ctor) {
        throw new Error("Trying to deserialize unknown typed array");
      }
      return new ctor(v);
    });
    __name(isInstanceOfRegisteredClass, "isInstanceOfRegisteredClass");
    __name2(isInstanceOfRegisteredClass, "isInstanceOfRegisteredClass");
    classRule = compositeTransformation(isInstanceOfRegisteredClass, (clazz, superJson) => {
      const identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
      return [
        "class",
        identifier
      ];
    }, (clazz, superJson) => {
      const allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
      if (!allowedProps) {
        return {
          ...clazz
        };
      }
      const result = {};
      allowedProps.forEach((prop) => {
        result[prop] = clazz[prop];
      });
      return result;
    }, (v, a, superJson) => {
      const clazz = superJson.classRegistry.getValue(a[1]);
      if (!clazz) {
        throw new Error(`Trying to deserialize unknown class '${a[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
      }
      return Object.assign(Object.create(clazz.prototype), v);
    });
    customRule = compositeTransformation((value, superJson) => {
      return !!superJson.customTransformerRegistry.findApplicable(value);
    }, (value, superJson) => {
      const transformer = superJson.customTransformerRegistry.findApplicable(value);
      return [
        "custom",
        transformer.name
      ];
    }, (value, superJson) => {
      const transformer = superJson.customTransformerRegistry.findApplicable(value);
      return transformer.serialize(value);
    }, (v, a, superJson) => {
      const transformer = superJson.customTransformerRegistry.findByName(a[1]);
      if (!transformer) {
        throw new Error("Trying to deserialize unknown custom value");
      }
      return transformer.deserialize(v);
    });
    compositeRules = [
      classRule,
      symbolRule,
      customRule,
      typedArrayRule
    ];
    transformValue = /* @__PURE__ */ __name2((value, superJson) => {
      const applicableCompositeRule = findArr(compositeRules, (rule) => rule.isApplicable(value, superJson));
      if (applicableCompositeRule) {
        return {
          value: applicableCompositeRule.transform(value, superJson),
          type: applicableCompositeRule.annotation(value, superJson)
        };
      }
      const applicableSimpleRule = findArr(simpleRules, (rule) => rule.isApplicable(value, superJson));
      if (applicableSimpleRule) {
        return {
          value: applicableSimpleRule.transform(value, superJson),
          type: applicableSimpleRule.annotation
        };
      }
      return void 0;
    }, "transformValue");
    simpleRulesByAnnotation = {};
    simpleRules.forEach((rule) => {
      simpleRulesByAnnotation[rule.annotation] = rule;
    });
    untransformValue = /* @__PURE__ */ __name2((json, type, superJson) => {
      if (isArray(type)) {
        switch (type[0]) {
          case "symbol":
            return symbolRule.untransform(json, type, superJson);
          case "class":
            return classRule.untransform(json, type, superJson);
          case "custom":
            return customRule.untransform(json, type, superJson);
          case "typed-array":
            return typedArrayRule.untransform(json, type, superJson);
          default:
            throw new Error("Unknown transformation: " + type);
        }
      } else {
        const transformation = simpleRulesByAnnotation[type];
        if (!transformation) {
          throw new Error("Unknown transformation: " + type);
        }
        return transformation.untransform(json, superJson);
      }
    }, "untransformValue");
    getNthKey = /* @__PURE__ */ __name2((value, n) => {
      if (n > value.size) throw new Error("index out of bounds");
      const keys = value.keys();
      while (n > 0) {
        keys.next();
        n--;
      }
      return keys.next().value;
    }, "getNthKey");
    __name(validatePath, "validatePath");
    __name2(validatePath, "validatePath");
    getDeep = /* @__PURE__ */ __name2((object, path) => {
      validatePath(path);
      for (let i = 0; i < path.length; i++) {
        const key = path[i];
        if (isSet(object)) {
          object = getNthKey(object, +key);
        } else if (isMap(object)) {
          const row = +key;
          const type = +path[++i] === 0 ? "key" : "value";
          const keyOfRow = getNthKey(object, row);
          switch (type) {
            case "key":
              object = keyOfRow;
              break;
            case "value":
              object = object.get(keyOfRow);
              break;
          }
        } else {
          object = object[key];
        }
      }
      return object;
    }, "getDeep");
    setDeep = /* @__PURE__ */ __name2((object, path, mapper) => {
      validatePath(path);
      if (path.length === 0) {
        return mapper(object);
      }
      let parent = object;
      for (let i = 0; i < path.length - 1; i++) {
        const key = path[i];
        if (isArray(parent)) {
          const index = +key;
          parent = parent[index];
        } else if (isPlainObject(parent)) {
          parent = parent[key];
        } else if (isSet(parent)) {
          const row = +key;
          parent = getNthKey(parent, row);
        } else if (isMap(parent)) {
          const isEnd = i === path.length - 2;
          if (isEnd) {
            break;
          }
          const row = +key;
          const type = +path[++i] === 0 ? "key" : "value";
          const keyOfRow = getNthKey(parent, row);
          switch (type) {
            case "key":
              parent = keyOfRow;
              break;
            case "value":
              parent = parent.get(keyOfRow);
              break;
          }
        }
      }
      const lastKey = path[path.length - 1];
      if (isArray(parent)) {
        parent[+lastKey] = mapper(parent[+lastKey]);
      } else if (isPlainObject(parent)) {
        parent[lastKey] = mapper(parent[lastKey]);
      }
      if (isSet(parent)) {
        const oldValue = getNthKey(parent, +lastKey);
        const newValue = mapper(oldValue);
        if (oldValue !== newValue) {
          parent.delete(oldValue);
          parent.add(newValue);
        }
      }
      if (isMap(parent)) {
        const row = +path[path.length - 2];
        const keyToRow = getNthKey(parent, row);
        const type = +lastKey === 0 ? "key" : "value";
        switch (type) {
          case "key": {
            const newKey = mapper(keyToRow);
            parent.set(newKey, parent.get(keyToRow));
            if (newKey !== keyToRow) {
              parent.delete(keyToRow);
            }
            break;
          }
          case "value": {
            parent.set(keyToRow, mapper(parent.get(keyToRow)));
            break;
          }
        }
      }
      return object;
    }, "setDeep");
    enableLegacyPaths = /* @__PURE__ */ __name2((version) => version < 1, "enableLegacyPaths");
    __name(traverse, "traverse");
    __name2(traverse, "traverse");
    __name(applyValueAnnotations, "applyValueAnnotations");
    __name2(applyValueAnnotations, "applyValueAnnotations");
    __name(applyReferentialEqualityAnnotations, "applyReferentialEqualityAnnotations");
    __name2(applyReferentialEqualityAnnotations, "applyReferentialEqualityAnnotations");
    isDeep = /* @__PURE__ */ __name2((object, superJson) => isPlainObject(object) || isArray(object) || isMap(object) || isSet(object) || isError(object) || isInstanceOfRegisteredClass(object, superJson), "isDeep");
    __name(addIdentity, "addIdentity");
    __name2(addIdentity, "addIdentity");
    __name(generateReferentialEqualityAnnotations, "generateReferentialEqualityAnnotations");
    __name2(generateReferentialEqualityAnnotations, "generateReferentialEqualityAnnotations");
    walker = /* @__PURE__ */ __name2((object, identities, superJson, dedupe, path = [], objectsInThisPath = [], seenObjects = /* @__PURE__ */ new Map()) => {
      const primitive = isPrimitive(object);
      if (!primitive) {
        addIdentity(object, path, identities);
        const seen = seenObjects.get(object);
        if (seen) {
          return dedupe ? {
            transformedValue: null
          } : seen;
        }
      }
      if (!isDeep(object, superJson)) {
        const transformed2 = transformValue(object, superJson);
        const result2 = transformed2 ? {
          transformedValue: transformed2.value,
          annotations: [
            transformed2.type
          ]
        } : {
          transformedValue: object
        };
        if (!primitive) {
          seenObjects.set(object, result2);
        }
        return result2;
      }
      if (includes(objectsInThisPath, object)) {
        return {
          transformedValue: null
        };
      }
      const transformationResult = transformValue(object, superJson);
      const transformed = transformationResult?.value ?? object;
      const transformedValue = isArray(transformed) ? [] : {};
      const innerAnnotations = {};
      forEach(transformed, (value, index) => {
        if (index === "__proto__" || index === "constructor" || index === "prototype") {
          throw new Error(`Detected property ${index}. This is a prototype pollution risk, please remove it from your object.`);
        }
        const recursiveResult = walker(value, identities, superJson, dedupe, [
          ...path,
          index
        ], [
          ...objectsInThisPath,
          object
        ], seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if (isArray(recursiveResult.annotations)) {
          innerAnnotations[escapeKey(index)] = recursiveResult.annotations;
        } else if (isPlainObject(recursiveResult.annotations)) {
          forEach(recursiveResult.annotations, (tree, key) => {
            innerAnnotations[escapeKey(index) + "." + key] = tree;
          });
        }
      });
      const result = isEmptyObject(innerAnnotations) ? {
        transformedValue,
        annotations: !!transformationResult ? [
          transformationResult.type
        ] : void 0
      } : {
        transformedValue,
        annotations: !!transformationResult ? [
          transformationResult.type,
          innerAnnotations
        ] : innerAnnotations
      };
      if (!primitive) {
        seenObjects.set(object, result);
      }
      return result;
    }, "walker");
    __name(getType2, "getType2");
    __name2(getType2, "getType");
    __name(isArray2, "isArray2");
    __name2(isArray2, "isArray");
    __name(isPlainObject2, "isPlainObject2");
    __name2(isPlainObject2, "isPlainObject");
    __name(assignProp, "assignProp");
    __name2(assignProp, "assignProp");
    __name(copy, "copy");
    __name2(copy, "copy");
    _SuperJSON = (_a24 = class {
      /**
       * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
       */
      constructor({ dedupe = false } = {}) {
        this.classRegistry = new ClassRegistry();
        this.symbolRegistry = new Registry((s) => s.description ?? "");
        this.customTransformerRegistry = new CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
      }
      serialize(object) {
        const identities = /* @__PURE__ */ new Map();
        const output = walker(object, identities, this, this.dedupe);
        const res = {
          json: output.transformedValue
        };
        if (output.annotations) {
          res.meta = {
            ...res.meta,
            values: output.annotations
          };
        }
        const equalityAnnotations = generateReferentialEqualityAnnotations(identities, this.dedupe);
        if (equalityAnnotations) {
          res.meta = {
            ...res.meta,
            referentialEqualities: equalityAnnotations
          };
        }
        if (res.meta) res.meta.v = 1;
        return res;
      }
      deserialize(payload, options) {
        const { json, meta } = payload;
        let result = options?.inPlace ? json : copy(json);
        if (meta?.values) {
          result = applyValueAnnotations(result, meta.values, meta.v ?? 0, this);
        }
        if (meta?.referentialEqualities) {
          result = applyReferentialEqualityAnnotations(result, meta.referentialEqualities, meta.v ?? 0);
        }
        return result;
      }
      stringify(object) {
        return JSON.stringify(this.serialize(object));
      }
      parse(string) {
        return this.deserialize(JSON.parse(string), {
          inPlace: true
        });
      }
      registerClass(v, options) {
        this.classRegistry.register(v, options);
      }
      registerSymbol(v, identifier) {
        this.symbolRegistry.register(v, identifier);
      }
      registerCustom(transformer, name) {
        this.customTransformerRegistry.register({
          name,
          ...transformer
        });
      }
      allowErrorProps(...props) {
        this.allowedErrorProps.push(...props);
      }
    }, __name(_a24, "_SuperJSON"), _a24);
    __name2(_SuperJSON, "SuperJSON");
    SuperJSON = _SuperJSON;
    SuperJSON.defaultInstance = new SuperJSON();
    SuperJSON.serialize = SuperJSON.defaultInstance.serialize.bind(SuperJSON.defaultInstance);
    SuperJSON.deserialize = SuperJSON.defaultInstance.deserialize.bind(SuperJSON.defaultInstance);
    SuperJSON.stringify = SuperJSON.defaultInstance.stringify.bind(SuperJSON.defaultInstance);
    SuperJSON.parse = SuperJSON.defaultInstance.parse.bind(SuperJSON.defaultInstance);
    SuperJSON.registerClass = SuperJSON.defaultInstance.registerClass.bind(SuperJSON.defaultInstance);
    SuperJSON.registerSymbol = SuperJSON.defaultInstance.registerSymbol.bind(SuperJSON.defaultInstance);
    SuperJSON.registerCustom = SuperJSON.defaultInstance.registerCustom.bind(SuperJSON.defaultInstance);
    SuperJSON.allowErrorProps = SuperJSON.defaultInstance.allowErrorProps.bind(SuperJSON.defaultInstance);
    serialize = SuperJSON.serialize;
    deserialize = SuperJSON.deserialize;
    stringify = SuperJSON.stringify;
    parse = SuperJSON.parse;
    registerClass = SuperJSON.registerClass;
    registerCustom = SuperJSON.registerCustom;
    registerSymbol = SuperJSON.registerSymbol;
    allowErrorProps = SuperJSON.allowErrorProps;
    MAX_ENTRIES = 200;
    MAX_OK_API_ENTRIES = 20;
    MAX_STRING = 2e3;
    MAX_SERIALIZED_BYTES = 256 * 1024;
    ERROR_SNAPSHOT_TTL_MS = 5e3;
    MAX_STACK_LINES = 20;
    __name(clip, "clip");
    __name2(clip, "clip");
    __name(utf8Bytes, "utf8Bytes");
    __name2(utf8Bytes, "utf8Bytes");
    _CsReportCollector = (_a25 = class {
      constructor() {
        __publicField(this, "entries", []);
        __publicField(this, "lastError", null);
      }
      push(entry) {
        this.entries.push(entry);
        if (this.entries.length > MAX_ENTRIES) {
          this.entries.splice(0, this.entries.length - MAX_ENTRIES);
        }
        const okApi = this.entries.filter((e) => e.kind === "api" && e.level === "debug");
        if (okApi.length > MAX_OK_API_ENTRIES) {
          const drop = new Set(okApi.slice(0, okApi.length - MAX_OK_API_ENTRIES));
          this.entries = this.entries.filter((e) => !drop.has(e));
        }
      }
      recordLog(level, msg, data) {
        this.push({
          ts: Date.now(),
          level,
          kind: "log",
          msg: clip(redactText(msg)),
          ...data === void 0 ? {} : {
            data: redactValue(data, {
              maxStringLength: 500
            })
          }
        });
      }
      /** 전역 오류 훅·Alpine 표현식 오류 — 링버퍼 기록 + 마지막 오류 스냅샷 보관 */
      recordError(input) {
        const stack = input.stack ? redactText(input.stack.split("\n").slice(0, MAX_STACK_LINES).join("\n")) : void 0;
        const message = clip(redactText(input.message));
        this.push({
          ts: Date.now(),
          level: "error",
          kind: "error",
          msg: message,
          ...stack ? {
            data: {
              stack
            }
          } : {}
        });
        this.lastError = {
          at: Date.now(),
          snapshot: {
            message,
            occurredAt: (/* @__PURE__ */ new Date()).toISOString(),
            ...input.code ? {
              code: input.code
            } : {},
            ...input.requestId ? {
              requestId: input.requestId
            } : {},
            ...stack ? {
              stack
            } : {}
          }
        };
      }
      /**
      * API 호출 요약. 실패(ok=false)는 상태·코드·requestId 까지, 성공은 경로·ms 만
      * level=debug 로 기록해 별도 상한(20건)을 받는다.
      */
      recordApi(input) {
        this.push({
          ts: Date.now(),
          level: input.ok ? "debug" : "error",
          kind: "api",
          msg: clip(redactText(input.path)),
          data: input.ok ? {
            ms: input.ms
          } : {
            status: input.status,
            code: input.code,
            requestId: input.requestId,
            ms: input.ms
          }
        });
      }
      /** 화면 이동 — "어디서 어디로 가다가"를 운영자가 읽을 수 있게 (§5.2) */
      recordNav(from, to) {
        this.push({
          ts: Date.now(),
          level: "info",
          kind: "nav",
          msg: `${redactText(from)} \u2192 ${redactText(to)}`
        });
      }
      /** 마지막 오류 스냅샷 — TTL(5초) 안일 때만 돌려준다 (§4.1 A 자동 연결) */
      peekLastError(now = Date.now()) {
        if (!this.lastError || now - this.lastError.at > ERROR_SNAPSHOT_TTL_MS) {
          return null;
        }
        return this.lastError.snapshot;
      }
      /** 오류 다이얼로그가 명시적으로 스냅샷을 밀어 넣을 때 (tRPC 오류 등) */
      setLastError(snapshot) {
        this.lastError = {
          at: Date.now(),
          snapshot
        };
      }
      /** 리포트 첨부용 스냅샷 — 직렬화 상한을 넘으면 오래된 항목부터 버린다 */
      snapshot() {
        let list = [
          ...this.entries
        ];
        while (list.length > 0 && utf8Bytes(JSON.stringify(list)) > MAX_SERIALIZED_BYTES) {
          list = list.slice(Math.max(1, Math.floor(list.length / 10)));
        }
        return list;
      }
      clear() {
        this.entries = [];
        this.lastError = null;
      }
    }, __name(_a25, "_CsReportCollector"), _a25);
    __name2(_CsReportCollector, "CsReportCollector");
    CsReportCollector = _CsReportCollector;
    csCollector = new CsReportCollector();
    __name(collectEnvContext, "collectEnvContext");
    __name2(collectEnvContext, "collectEnvContext");
    hooksInstalled = false;
    __name(installCsReportHooks, "installCsReportHooks");
    __name2(installCsReportHooks, "installCsReportHooks");
    LOG_LEVELS = {
      silent: Number.POSITIVE_INFINITY,
      fatal: 60,
      error: 50,
      warn: 40,
      info: 30,
      debug: 20,
      trace: 10
    };
    __name(createConsoleLogger, "createConsoleLogger");
    __name2(createConsoleLogger, "createConsoleLogger");
    SDKLogger = (_a92 = (_a26 = class {
      constructor() {
        __publicField(this, "logger");
        __publicField(this, "config", {});
        this.logger = createConsoleLogger("warn");
      }
      configure(config) {
        this.config = config;
        if (config.customLogger) {
          this.logger = config.customLogger;
        } else if (config.silent) {
          this.logger = createConsoleLogger("silent");
        } else if (config.debug) {
          this.logger = createConsoleLogger("debug");
        } else {
          this.logger = createConsoleLogger("warn");
        }
      }
      getLogger() {
        return this.logger;
      }
      createServiceLogger(serviceName) {
        return this.logger.child({
          service: serviceName
        });
      }
      debug(...args) {
        if (!this.config.silent) {
          this.logger.debug(...args);
        }
      }
      info(...args) {
        if (!this.config.silent) {
          this.logger.info(...args);
        }
      }
      warn(...args) {
        if (!this.config.silent) {
          this.logger.warn(...args);
        }
      }
      error(...args) {
        if (!this.config.silent) {
          this.logger.error(...args);
        }
      }
    }, __name(_a26, "_a9"), _a26), __name2(_a92, "SDKLogger"), _a92);
    sdkLogger = new SDKLogger();
    logger = sdkLogger.getLogger();
    PREFIX = "enc:v1:";
    cachedKey = null;
    cachedPem = null;
    __name(getSubtle, "getSubtle");
    __name2(getSubtle, "getSubtle");
    __name(pemToDer, "pemToDer");
    __name2(pemToDer, "pemToDer");
    __name(bytesToBase64, "bytesToBase64");
    __name2(bytesToBase64, "bytesToBase64");
    __name(importKey, "importKey");
    __name2(importKey, "importKey");
    __name(encryptPassword, "encryptPassword");
    __name2(encryptPassword, "encryptPassword");
    _AccountService = (_a27 = class {
      constructor(client) {
        __publicField(this, "client");
        __publicField(this, "logger");
        __publicField(this, "publicKeyPem", null);
        this.client = client;
        this.logger = sdkLogger.createServiceLogger("AccountService");
      }
      async encrypt(password) {
        try {
          if (!this.publicKeyPem) {
            const result = await this.client.trpc.auth.publicKey.query();
            this.publicKeyPem = result.publicKeyPem;
          }
          return await encryptPassword(password, this.publicKeyPem);
        } catch (error) {
          this.logger.warn({
            error
          }, "Password encryption unavailable, falling back to plaintext");
          return password;
        }
      }
      /** 통합 로그인 (Account 우선 + 레거시 Employee 폴백) */
      async login(params) {
        const encryptedParams = {
          ...params,
          password: await this.encrypt(params.password)
        };
        const result = await this.client.trpc.account.login.mutate(encryptedParams);
        if (result.mode === "two_factor" || result.mode === "captcha") {
          return result;
        }
        this.client.setTokens(result.accessToken, result.refreshToken);
        this.logger.info({
          mode: result.mode
        }, "Account login successful");
        return result;
      }
      /** 회원 정보 + 소속 워크스페이스 목록 (account 세션 필요) */
      async me() {
        return this.client.trpc.account.me.query();
      }
      /** 소속 워크스페이스 목록 (account 세션 필요) */
      async workspaces() {
        return this.client.trpc.account.workspaces.query();
      }
      /** 워크스페이스 입장 — 조직 스코프 세션으로 전환 */
      async selectWorkspace(organizationId) {
        const result = await this.client.trpc.account.selectWorkspace.mutate({
          organizationId
        });
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /**
      * owner 암묵 grant 입장 — Employee 멤버십 없이 소유 조직에 진입.
      * (meta account — 허브의 ownerEntry 항목 전용)
      */
      async enterOwnedWorkspace(organizationId) {
        const result = await this.client.trpc.account.enterOwnedWorkspace.mutate({
          organizationId
        });
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /** 플랫폼 스태프: 내 유효 grant 목록 — 허브 "지원 중인 조직" 섹션 */
      async myGrants() {
        return this.client.trpc.platform.myGrants.query();
      }
      /** OrganizationGrant 입장 — support 대행/impersonation 세션 (meta account Phase B) */
      async enterGrantedWorkspace(grantId) {
        const result = await this.client.trpc.account.enterGrantedWorkspace.mutate({
          grantId
        });
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /** 워크스페이스 생성 후 바로 입장 (조직 스코프 세션 반환) */
      async createWorkspace(params) {
        const result = await this.client.trpc.account.createWorkspace.mutate(params);
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /** 허브 초대 인박스 — 내 계정 이메일로 온 유효한 초대 목록 (account 세션 필요) */
      async pendingInvites() {
        return this.client.trpc.account.pendingInvites.query();
      }
      /** 허브에서 초대 수락 — account 세션 기반, 비밀번호 재입력 없음 */
      async acceptInvite(inviteId) {
        return this.client.trpc.account.acceptInvite.mutate({
          inviteId
        });
      }
      /** 레거시 직원 셀프 업그레이드 — 본인 이메일로 계정 연결 인증 메일 발송 */
      async requestSelfUpgrade() {
        return this.client.trpc.account.requestSelfUpgrade.mutate();
      }
      /** 조직 세션 → account 세션 전환 (워크스페이스 허브로 돌아가기) */
      async toAccountSession() {
        const result = await this.client.trpc.account.toAccountSession.mutate();
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /** account 세션 로그아웃 */
      async logout() {
        try {
          await this.client.trpc.account.logout.mutate();
        } catch (error) {
          this.logger.warn({
            error
          }, "Account logout API call failed, clearing tokens locally");
        } finally {
          this.client.clearTokens();
        }
      }
    }, __name(_a27, "_AccountService"), _a27);
    __name2(_AccountService, "AccountService");
    AccountService = _AccountService;
    _AiService = (_a28 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 조직 AI 플래그 — 위젯 노출 판단용 */
      async status() {
        return this.client.trpc.ai.status.query();
      }
      async guidanceCatalog(input) {
        return this.client.trpc.ai.guidanceCatalog.query(input);
      }
      async resolveGuidanceAction(input) {
        return this.client.trpc.ai.resolveGuidanceAction.query(input);
      }
      async createConversation(input = {}) {
        return this.client.trpc.ai.createConversation.mutate(input);
      }
      async chat(input) {
        return this.client.trpc.ai.chat.mutate(input);
      }
      async history(input) {
        return this.client.trpc.ai.history.query(input);
      }
      async listConversations(input = {}) {
        return this.client.trpc.ai.listConversations.query(input);
      }
      /** 병원 관리자가 직원 앱 AI 어시스턴트를 켜고 끈다(ai:manage) — 마스터 플래그가 꺼진 조직은 서버가 거절한다 */
      async updateEmployeeAppSettings(input) {
        return this.client.trpc.ai.updateEmployeeAppSettings.mutate(input);
      }
      async feedback(input) {
        return this.client.trpc.ai.feedback.mutate(input);
      }
      async usageSummary(input) {
        return this.client.trpc.ai.usageSummary.query(input);
      }
      /** 채팅 스트리밍 구독 — chat 뮤테이션 호출 전에 구독해야 delta를 놓치지 않는다 */
      subscribeToStream(conversationId, onData, onError) {
        const subscription = this.client.trpc.ai.onStream.subscribe({
          conversationId
        }, {
          onData: /* @__PURE__ */ __name2((data) => onData(data), "onData"),
          onError: /* @__PURE__ */ __name2((err) => onError?.(err), "onError")
        });
        return subscription;
      }
    }, __name(_a28, "_AiService"), _a28);
    __name2(_AiService, "AiService");
    AiService = _AiService;
    _AllowanceService = (_a29 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.allowance.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.allowance.get.query(id);
      }
      async create(input) {
        return this.client.trpc.allowance.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.allowance.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.allowance.delete.mutate(id);
      }
      async approve(ids) {
        return this.client.trpc.allowance.approve.mutate({
          ids
        });
      }
      async cancel(ids) {
        return this.client.trpc.allowance.cancel.mutate({
          ids
        });
      }
      async getSourceDetail(id) {
        return this.client.trpc.allowance.getSourceDetail.query(id);
      }
      async batchCreate(input) {
        return this.client.trpc.allowance.batchCreate.mutate(input);
      }
    }, __name(_a29, "_AllowanceService"), _a29);
    __name2(_AllowanceService, "AllowanceService");
    AllowanceService = _AllowanceService;
    _AnnualLeavePromotionService = (_a30 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async openSigner(input) {
        return this.client.trpc.annualLeavePromotion.openSigner.mutate(input);
      }
      async list(input = {}) {
        return this.client.trpc.annualLeavePromotion.list.query(input);
      }
      async firstNotice(input) {
        return this.client.trpc.annualLeavePromotion.firstNotice.mutate(input);
      }
      async retryFirstNotice(promotionId) {
        return this.client.trpc.annualLeavePromotion.retryFirstNotice.mutate({
          promotionId
        });
      }
      async templates() {
        return this.client.trpc.annualLeavePromotion.templates.query();
      }
      async templateManageUrl() {
        return this.client.trpc.annualLeavePromotion.templateManageUrl.query();
      }
      async batchPreflight(input) {
        return this.client.trpc.annualLeavePromotion.batchPreflight.mutate(input);
      }
      async batchCreate(input) {
        return this.client.trpc.annualLeavePromotion.batchCreate.mutate(input);
      }
      async batchStatus(batchId) {
        return this.client.trpc.annualLeavePromotion.batchStatus.query({
          batchId
        });
      }
      async batchList(input = {}) {
        return this.client.trpc.annualLeavePromotion.batchList.query(input);
      }
      async batchCancel(batchId, reason) {
        return this.client.trpc.annualLeavePromotion.batchCancel.mutate({
          batchId,
          reason
        });
      }
      async batchRetryFailed(batchId) {
        return this.client.trpc.annualLeavePromotion.batchRetryFailed.mutate({
          batchId
        });
      }
      async reminder(input) {
        return this.client.trpc.annualLeavePromotion.reminder.mutate(input);
      }
      async reissue(input) {
        return this.client.trpc.annualLeavePromotion.reissue.mutate(input);
      }
      async designateSecond(input) {
        return this.client.trpc.annualLeavePromotion.designateSecond.mutate(input);
      }
    }, __name(_a30, "_AnnualLeavePromotionService"), _a30);
    __name2(_AnnualLeavePromotionService, "AnnualLeavePromotionService");
    AnnualLeavePromotionService = _AnnualLeavePromotionService;
    _AppOnboardingService = (_a31 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      // ── 관리자 ──
      /** 체크리스트 7단계 상태 + 집계(전체·팀별) */
      async summary(input) {
        return this.client.trpc.appOnboarding.summary.query(input ?? {});
      }
      /** 직원별 단계 목록(필터·페이지) */
      async listStatus(input) {
        return this.client.trpc.appOnboarding.listStatus.query(input);
      }
      /** 안내 문구 미리보기(직원을 주면 그 직원 값으로) */
      async previewGuide(input) {
        return this.client.trpc.appOnboarding.previewGuide.query(input ?? {});
      }
      /** 관리자 본인에게 테스트 발송 */
      async sendGuideTest(input) {
        return this.client.trpc.appOnboarding.sendGuideTest.mutate(input);
      }
      /** 앱 안내 발송(선택·전체·미안내·미완료·실패) */
      async sendGuide(input) {
        return this.client.trpc.appOnboarding.sendGuide.mutate(input);
      }
      async sendHistory(input) {
        return this.client.trpc.appOnboarding.sendHistory.query(input ?? {});
      }
      /** 온보딩 안내 공지 게시(6단계) */
      async postNotice(input) {
        return this.client.trpc.appOnboarding.postNotice.mutate(input ?? {});
      }
      /** 배포 완료 보고용 행(직원별 + 팀별) */
      async report() {
        return this.client.trpc.appOnboarding.report.query();
      }
      /** 관리자가 「완료」/「다시 열기」 */
      async setCompleted(input) {
        return this.client.trpc.appOnboarding.setCompleted.mutate(input);
      }
      // ── 직원 앱 ──
      /** 로그인 뒤 앱이 자기 정보를 남긴다(설치·첫 로그인·버전) */
      async heartbeat(input) {
        return this.client.trpc.appOnboarding.heartbeat.mutate(input);
      }
      async myTutorial() {
        return this.client.trpc.appOnboarding.myTutorial.query();
      }
      async completeTutorial(input) {
        return this.client.trpc.appOnboarding.completeTutorial.mutate(input);
      }
    }, __name(_a31, "_AppOnboardingService"), _a31);
    __name2(_AppOnboardingService, "AppOnboardingService");
    AppOnboardingService = _AppOnboardingService;
    _ApprovalFlowService = (_a33 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 한 건의 결재 단계(결재자 이름·직책·시각·사유·대신 처리) */
      async steps(requestType, requestId) {
        return this.client.trpc.approvalFlow.steps.query({
          requestType,
          requestId
        });
      }
      /** 여러 건의 결재 단계 — 목록 화면의 「내 차례」 표시용 */
      async stepsByRequests(requestType, requestIds) {
        return this.client.trpc.approvalFlow.stepsByRequests.query({
          requestType,
          requestIds
        });
      }
      /** 결재함 숫자 — 내가 결재자인 대기 단계 수(종류별)와 가장 오래된 신청일 */
      async inboxSummary() {
        return this.client.trpc.approvalFlow.inboxSummary.query();
      }
      /** 결재할 문서 — 내가 현 단계 결재자인 대기 건(신청자 · 종류 · 핵심 내용 · 단계), 오래된 것부터 */
      async inbox(input) {
        return this.client.trpc.approvalFlow.inbox.query(input ?? {});
      }
      /** 결재한 문서 — 내가 처리한 단계(본인 단계 + 대신 처리)와 문서의 최종 상태, 최근 것부터. from/to = 결재한 날(조직 시간대) */
      async decided(input) {
        return this.client.trpc.approvalFlow.decided.query(input ?? {});
      }
      /** 신청 폼이 열릴 때 — 후보(이름·팀·직책) · 기본 결재선 · 내 결재선(재검증) · 지금 적용될 결재선 · 안내 */
      async lineContext(requestType) {
        return this.client.trpc.approvalFlow.lineContext.query({
          requestType
        });
      }
      /** 내 결재선 저장 — 그 종류의 다음 신청부터 자동 적용 */
      async saveMyLine(requestType, approverIds) {
        return this.client.trpc.approvalFlow.saveMyLine.mutate({
          requestType,
          approverIds
        });
      }
      /** 내 결재선 삭제 — 다음 신청부터 기본 결재선 */
      async clearMyLine(requestType) {
        return this.client.trpc.approvalFlow.clearMyLine.mutate({
          requestType
        });
      }
      /* ── 5단계 관리자 설정(setting:update) ── */
      /** 병원 설정 「결재선」 카드 — 정책 · 종류별 템플릿 · 종류별 템플릿 후보(조직 전체 범위 승인자) */
      async templates() {
        return this.client.trpc.approvalFlow.templates.query();
      }
      /** 병원 기본 결재선 템플릿 저장(종류별 1개) */
      async saveTemplate(requestType, approverIds) {
        return this.client.trpc.approvalFlow.saveTemplate.mutate({
          requestType,
          approverIds
        });
      }
      /** 병원 기본 결재선 템플릿 삭제 → 자동 기본 */
      async clearTemplate(requestType) {
        return this.client.trpc.approvalFlow.clearTemplate.mutate({
          requestType
        });
      }
      /** 결재자 바꾸기 후보 — 이 신청의 후보 − 신청자 − 아직 처리되지 않은 단계의 결재자(바꿀 권한이 있을 때만) */
      async replaceCandidates(requestType, requestId) {
        return this.client.trpc.approvalFlow.replaceCandidates.query({
          requestType,
          requestId
        });
      }
      /** 결재자 바꾸기 — 아직 처리되지 않은 단계의 결재자를 같은 후보 안의 다른 사람으로(관리자) */
      async replaceApprover(input) {
        return this.client.trpc.approvalFlow.replaceApprover.mutate(input);
      }
      /* ── 결재선 후속(approvalLine 라우터) — 나의 결재선 여러 개 · 팀 기본 결재선 · 변경 이력 ── */
      /** 나의 결재선 전부(네 종류, 재검증) + 실제 정책(병원 AND 팀) */
      async myLines() {
        return this.client.trpc.approvalLine.myLines.query();
      }
      /** 나의 결재선 만들기·수정 — id 가 있으면 수정. isDefault 를 켜면 같은 종류의 다른 기본은 꺼진다 */
      async saveMyNamedLine(input) {
        return this.client.trpc.approvalLine.saveMyLine.mutate(input);
      }
      /** 나의 결재선 삭제 */
      async deleteMyLine(id) {
        return this.client.trpc.approvalLine.deleteMyLine.mutate({
          id
        });
      }
      /** 나의 결재선 기본 지정 켜기·끄기 */
      async setMyLineDefault(id, isDefault) {
        return this.client.trpc.approvalLine.setMyLineDefault.mutate({
          id,
          isDefault
        });
      }
      /** 내 결재선 변경 이력 */
      async myChangeLogs(limit) {
        return this.client.trpc.approvalLine.myChangeLogs.query(limit ? {
          limit
        } : void 0);
      }
      /** 결재선을 관리할 수 있는 팀(팀장은 자기 팀, 시스템 관리자는 전부) */
      async managedTeams() {
        return this.client.trpc.approvalLine.managedTeams.query();
      }
      /** 팀 결재선 설정 화면 — 팀 · 경로 · 정책 · 종류별 템플릿/상속/후보 */
      /** 팀별 결재선 표 — 관리할 수 있는 팀 전부(트리 순서)의 종류별 결재선 · 출처 · 직원 직접 지정 */
      async teamOverview() {
        return this.client.trpc.approvalLine.teamOverview.query();
      }
      async teamContext(teamId) {
        return this.client.trpc.approvalLine.teamContext.query({
          teamId
        });
      }
      /** 팀 기본 결재선 저장(종류별 1개) */
      async saveTeamTemplate(teamId, requestType, approverIds) {
        return this.client.trpc.approvalLine.saveTeamTemplate.mutate({
          teamId,
          requestType,
          approverIds
        });
      }
      /** 팀 기본 결재선 비우기 */
      async clearTeamTemplate(teamId, requestType) {
        return this.client.trpc.approvalLine.clearTeamTemplate.mutate({
          teamId,
          requestType
        });
      }
      /** 팀의 직원 수정 허용 — true/false/null(정하지 않음) */
      async saveTeamSettings(teamId, allowCustom) {
        return this.client.trpc.approvalLine.saveTeamSettings.mutate({
          teamId,
          allowCustom
        });
      }
      /** 한 팀의 결재선 변경 이력 */
      async teamChangeLogs(teamId, limit) {
        return this.client.trpc.approvalLine.teamChangeLogs.query({
          teamId,
          limit
        });
      }
      /** 병원 전체 변경 이력(시스템 관리자) */
      async orgChangeLogs(input) {
        return this.client.trpc.approvalLine.orgChangeLogs.query(input);
      }
    }, __name(_a33, "_ApprovalFlowService"), _a33);
    __name2(_ApprovalFlowService, "ApprovalFlowService");
    ApprovalFlowService = _ApprovalFlowService;
    _AttendanceCorrectionService = (_a34 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async request(input) {
        return this.client.trpc.attendanceCorrection.request.mutate(input);
      }
      async mine(input = {}) {
        return this.client.trpc.attendanceCorrection.mine.query(input);
      }
      async cancel(id) {
        return this.client.trpc.attendanceCorrection.cancel.mutate({
          id
        });
      }
      /** 이날 정정 요청을 낼 수 있는가 — 앞날 · 잠김 사유 · 검토 중인 내 요청 */
      async dayStatus(date) {
        return this.client.trpc.attendanceCorrection.dayStatus.query({
          date
        });
      }
      async list(input = {}) {
        return this.client.trpc.attendanceCorrection.list.query(input);
      }
      /** 검토 팝업 — 승인하면 바뀔 기록 · 근무시간 미리 보기(저장하지 않는다) */
      async preview(id) {
        return this.client.trpc.attendanceCorrection.preview.query({
          id
        });
      }
      async approve(id) {
        return this.client.trpc.attendanceCorrection.approve.mutate({
          id
        });
      }
      async reject(id, rejectionReason) {
        return this.client.trpc.attendanceCorrection.reject.mutate({
          id,
          rejectionReason
        });
      }
    }, __name(_a34, "_AttendanceCorrectionService"), _a34);
    __name2(_AttendanceCorrectionService, "AttendanceCorrectionService");
    AttendanceCorrectionService = _AttendanceCorrectionService;
    _AttendanceRateService = (_a35 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 산정연도 직원별 출근율 목록 */
      async list(input) {
        return this.client.trpc.attendanceRate.list.query(input);
      }
      /** 단일 직원 소정근로일수 설정(행 [수정]) */
      async getSetting(input) {
        return this.client.trpc.attendanceRate.getSetting.query(input);
      }
      /** 소정근로일수 설정 저장(일괄/개별) */
      async saveSettings(input) {
        return this.client.trpc.attendanceRate.saveSettings.mutate(input);
      }
    }, __name(_a35, "_AttendanceRateService"), _a35);
    __name2(_AttendanceRateService, "AttendanceRateService");
    AttendanceRateService = _AttendanceRateService;
    _AttendanceService = (_a36 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /**
      * Check in (clock in)
      * @param params - Optional parameters for check-in
      */
      async checkIn(params) {
        return this.client.trpc.attendance.checkIn.mutate(params || {});
      }
      /**
      * Check out (clock out)
      * @param params - Optional parameters for check-out
      */
      async checkOut(params) {
        return this.client.trpc.attendance.checkOut.mutate(params || {});
      }
      /**
      * Create attendance record (manual entry)
      * @param params - Attendance creation parameters
      */
      async create(params) {
        return this.client.trpc.attendance.create.mutate(params);
      }
      /**
      * Update attendance record
      * @param params - Attendance update parameters
      */
      async update(params) {
        return this.client.trpc.attendance.update.mutate(params);
      }
      /**
      * 근태 수정 — 시간 구분 직접 입력(수동 오버라이드). 출퇴근 시간 + 8개 구분 + 휴게를
      * 직접 저장한다. 소정 4종은 Attendance 에, 초과 4종은 manual OvertimeRecord 로 반영된다.
      */
      async saveManualHours(params) {
        return this.client.trpc.attendance.saveManualHours.mutate(params);
      }
      /**
      * Get single attendance record by ID
      * @param attendanceId - Attendance record ID
      */
      async get(attendanceId) {
        return this.client.trpc.attendance.get.query(attendanceId);
      }
      /**
      * Get attendance records with filtering and pagination
      * @param params - Query parameters
      */
      async list(params) {
        return this.client.trpc.attendance.list.query(params || {});
      }
      /**
      * Delete attendance record (soft delete)
      * @param attendanceId - Attendance record ID
      */
      async delete(attendanceId) {
        return this.client.trpc.attendance.delete.mutate(attendanceId);
      }
      /**
      * Bulk create attendance records
      * @param params - Bulk creation parameters
      */
      async bulkCreate(params) {
        return this.client.trpc.attendance.bulkCreate.mutate(params);
      }
      /**
      * Get work hours summary with 52-hour compliance check
      * @param params - Summary query parameters
      */
      async getWorkHoursSummary(params) {
        return this.client.trpc.attendance.workHoursSummary.query(params);
      }
      /**
      * 전체 근무기록 — 출퇴근·연장근무·외근을 일별 타임라인으로 합친 조회.
      * from/to 는 조직 로컬 "YYYY-MM-DD", employeeId 를 비우면 본인.
      */
      /** 팀 근태 — 하루(MED-966). 팀 범위 이상 근태 조회 권한자 */
      async teamDaily(date) {
        return this.client.trpc.attendance.teamDaily.query({
          date
        });
      }
      /** 팀 근태 — 한 달 요약(MED-966) */
      async teamMonthly(year, month) {
        return this.client.trpc.attendance.teamMonthly.query({
          year,
          month
        });
      }
      async workLog(params) {
        return this.client.trpc.attendance.workLog.query(params);
      }
      /**
      * Get today's attendance status for an employee
      * @param employeeId - Optional employee ID (defaults to current user)
      */
      async getTodayStatus(employeeId) {
        return this.client.trpc.attendance.todayStatus.query({
          employeeId
        });
      }
      /** 직원의 날짜 D 근무형태(서버 판정) — 근태 수정 창의 듀티(3교대) 표시 등. date 를 비우면 조직의 오늘. */
      async getEffectiveShift(employeeId, date) {
        return this.client.trpc.attendance.effectiveShift.query({
          employeeId,
          date
        });
      }
      // Helper methods for common operations
      /**
      * Check if employee has checked in today
      * @param employeeId - Optional employee ID
      */
      async hasCheckedInToday(employeeId) {
        const status = await this.getTodayStatus(employeeId);
        return status.hasCheckedIn;
      }
      /**
      * Check if employee has checked out today
      * @param employeeId - Optional employee ID
      */
      async hasCheckedOutToday(employeeId) {
        const status = await this.getTodayStatus(employeeId);
        return status.hasCheckedOut;
      }
      /**
      * Get attendance records for a specific date range
      * @param startDate - Start date
      * @param endDate - End date
      * @param employeeId - Optional employee ID
      */
      async getByDateRange(startDate, endDate, employeeId) {
        return this.list({
          filter: {
            employeeId,
            dateRange: {
              from: startDate,
              to: endDate
            }
          }
        });
      }
      /**
      * Get attendance records for current month
      * @param employeeId - Optional employee ID
      */
      async getCurrentMonthAttendance(employeeId) {
        const now = /* @__PURE__ */ new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return this.getByDateRange(startOfMonth, endOfMonth, employeeId);
      }
      /**
      * Get attendance records for current week
      * @param employeeId - Optional employee ID
      */
      async getCurrentWeekAttendance(employeeId) {
        const now = /* @__PURE__ */ new Date();
        const dayOfWeek = now.getDay();
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - dayOfWeek);
        startOfWeek.setHours(0, 0, 0, 0);
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);
        return this.getByDateRange(startOfWeek, endOfWeek, employeeId);
      }
      /**
      * Get late attendance records
      * @param params - Query parameters
      */
      async getLateAttendance(params) {
        return this.list({
          filter: {
            ...params,
            isLate: true
          }
        });
      }
      /**
      * Get overtime attendance records
      * @param params - Query parameters
      */
      async getOvertimeAttendance(params) {
        return this.list({
          filter: {
            ...params,
            hasOvertime: true
          }
        });
      }
      /**
      * Check weekly 52-hour compliance for an employee
      * @param employeeId - Employee ID
      * @param year - Year
      * @param week - Week number
      */
      async checkWeeklyCompliance(employeeId, year, week) {
        const summary = await this.getWorkHoursSummary({
          employeeId,
          period: {
            year,
            week
          }
        });
        return {
          isCompliant: summary.complianceStatus.weeklyLimit,
          violations: summary.complianceStatus.violations,
          totalHours: summary.totalRegularHours + summary.totalOvertimeHours + summary.totalNightShiftHours + summary.totalWeekendHours + summary.totalHolidayHours
        };
      }
      /**
      * Get monthly work hours summary
      * @param employeeId - Employee ID
      * @param year - Year
      * @param month - Month (1-12)
      */
      async getMonthlyWorkHours(employeeId, year, month) {
        return this.getWorkHoursSummary({
          employeeId,
          period: {
            year,
            month
          }
        });
      }
      /**
      * Get yearly work hours summary
      * @param employeeId - Employee ID
      * @param year - Year
      */
      async getYearlyWorkHours(employeeId, year) {
        return this.getWorkHoursSummary({
          employeeId,
          period: {
            year
          }
        });
      }
      /**
      * Create manual attendance entry for multiple employees
      * @param employeeIds - Array of employee IDs
      * @param date - Date
      * @param checkIn - Check-in time (HH:MM)
      * @param checkOut - Check-out time (HH:MM)
      * @param reason - Reason for manual entry
      * @param breakMinutes - Break duration in minutes
      */
      async createBulkManualEntry(employeeIds, date, checkIn, checkOut, reason, breakMinutes = 60) {
        return this.bulkCreate({
          employeeIds,
          date,
          checkInTime: checkIn,
          checkOutTime: checkOut,
          reason,
          breakMinutes
        });
      }
      /**
      * Quick check-in with current location
      * @param location - GPS coordinates
      */
      async quickCheckIn(location2) {
        const params = location2 ? {
          location: {
            latitude: location2.coords.latitude,
            longitude: location2.coords.longitude,
            accuracy: location2.coords.accuracy
          }
        } : void 0;
        return this.checkIn(params);
      }
      /**
      * Quick check-out with current location
      * @param location - GPS coordinates
      */
      async quickCheckOut(location2) {
        const params = location2 ? {
          location: {
            latitude: location2.coords.latitude,
            longitude: location2.coords.longitude,
            accuracy: location2.coords.accuracy
          }
        } : void 0;
        return this.checkOut(params);
      }
      /**
      * Register field work (외근)
      */
      async registerFieldWork(params) {
        return this.client.trpc.attendance.registerFieldWork.mutate(params);
      }
      /**
      * List field work entries (외근) for the current user.
      */
      async listFieldWork(params) {
        return this.client.trpc.attendance.listFieldWork.query(params);
      }
      /**
      * Get attendance status text
      * @param employeeId - Optional employee ID
      */
      async getStatusText(employeeId) {
        const status = await this.getTodayStatus(employeeId);
        if (!status.hasCheckedIn) {
          return "Not checked in";
        }
        if (!status.hasCheckedOut) {
          if (status.checkInTime) {
            return `Checked in at ${new Date(status.checkInTime).toLocaleTimeString()}`;
          }
          return "Checked in";
        }
        return `Completed - ${status.totalHours} hours`;
      }
      /**
      * Calculate total work hours for a period
      * @param attendanceRecords - Array of attendance records
      */
      calculateTotalHours(attendanceRecords) {
        return attendanceRecords.reduce((sum, record) => sum + record.totalHours, 0);
      }
      /**
      * Format work hours for display
      * @param hours - Number of hours
      */
      formatWorkHours(hours) {
        const wholeHours = Math.floor(hours);
        const minutes = Math.round((hours - wholeHours) * 60);
        return `${wholeHours}h ${minutes}m`;
      }
      /**
      * Recalculate attendance from secom events for an employee in a date range.
      * Deletes non-manual attendance records and re-runs the secom processor — 근무형태는 앱 출근과 같은 순서로 다시 판정한다.
      */
      async recalculateFromSecom(input) {
        return this.client.trpc.attendance.recalculateFromSecom.mutate(input);
      }
      /** 근태 내역 스냅샷 시트 갱신 — [근태 업데이트] 버튼. */
      async updateAttendanceSummary(sheetViewId) {
        return this.client.trpc.attendance.updateAttendanceSummary.mutate({
          sheetViewId
        });
      }
      /** 근태 내역 스냅샷에 미반영된 소스 변경이 있는지 (알림 아이콘). */
      async attendanceSummaryHasUpdates(sheetViewId) {
        return this.client.trpc.attendance.attendanceSummaryHasUpdates.query({
          sheetViewId
        });
      }
    }, __name(_a36, "_AttendanceService"), _a36);
    __name2(_AttendanceService, "AttendanceService");
    AttendanceService = _AttendanceService;
    _AuthService = (_a37 = class {
      constructor(client) {
        __publicField(this, "client");
        __publicField(this, "logger");
        __publicField(this, "publicKeyPem", null);
        this.client = client;
        this.logger = sdkLogger.createServiceLogger("AuthService");
      }
      /**
      * Fetch and cache the server's RSA public key for password transport encryption.
      * Falls back to plaintext (legacy path) if the server doesn't expose `auth.publicKey`
      * or Web Crypto is unavailable — the server still accepts unprefixed plaintext.
      */
      async encrypt(password) {
        try {
          if (!this.publicKeyPem) {
            const result = await this.client.trpc.auth.publicKey.query();
            this.publicKeyPem = result.publicKeyPem;
          }
          return await encryptPassword(password, this.publicKeyPem);
        } catch (error) {
          this.logger.warn({
            error
          }, "Password encryption unavailable, falling back to plaintext");
          return password;
        }
      }
      /**
      * Login with email/phone and password
      */
      async login(params) {
        this.logger.debug({
          identifier: params.identifier
        }, "Attempting login");
        try {
          const encryptedParams = {
            ...params,
            password: await this.encrypt(params.password)
          };
          const result = await this.client.trpc.auth.login.mutate(encryptedParams);
          if ("captchaRequired" in result) {
            return result;
          }
          if ("twoFactorRequired" in result) {
            this.logger.info({
              identifier: params.identifier
            }, "Login needs two-factor code");
            return result;
          }
          this.client.setTokens(result.accessToken, result.refreshToken);
          this.logger.info({
            userId: result.user.id
          }, "Login successful");
          return result;
        } catch (error) {
          this.logger.error({
            error,
            identifier: params.identifier
          }, "Login failed");
          throw error;
        }
      }
      /** 앱 설치 안내 로그인 링크 토큰 → 로그인 ID·임시 비밀번호(없거나 기한 지남·이미 변경이면 null) */
      async loginPrefill(token) {
        return this.client.trpc.auth.loginPrefill.mutate({
          token
        });
      }
      /**
      * Register a new user
      */
      async register(params) {
        const encryptedParams = {
          ...params,
          password: await this.encrypt(params.password)
        };
        const result = await this.client.trpc.auth.register.mutate(encryptedParams);
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /**
      * Logout and clear tokens
      */
      async logout() {
        this.logger.debug("Logging out");
        try {
          await this.client.trpc.auth.logout.mutate();
          this.logger.info("Logout successful");
        } catch (error) {
          this.logger.warn({
            error
          }, "Logout API call failed, clearing tokens locally");
        } finally {
          this.client.clearTokens();
        }
      }
      /**
      * Refresh access token
      */
      async refreshToken(refreshToken) {
        const token = refreshToken || this.client.getRefreshToken();
        if (!token) {
          throw new Error("No refresh token available");
        }
        const result = await this.client.trpc.auth.refreshToken.mutate({
          refreshToken: token
        });
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /**
      * Get current user information
      */
      async getCurrentUser() {
        if (!this.client.isAuthenticated()) {
          throw new Error("Not authenticated");
        }
        return this.client.trpc.auth.me.query();
      }
      /**
      * Change password
      */
      async changePassword(currentPassword, newPassword, confirmPassword) {
        if (!this.client.isAuthenticated()) {
          throw new Error("Not authenticated");
        }
        await this.client.trpc.auth.changePassword.mutate({
          currentPassword: await this.encrypt(currentPassword),
          newPassword: await this.encrypt(newPassword),
          confirmPassword: await this.encrypt(confirmPassword)
        });
      }
      /**
      * Check if self-service password reset is available (public, no auth required)
      */
      async passwordResetAvailable() {
        const result = await this.client.trpc.auth.passwordResetAvailable.query();
        return result.available;
      }
      /**
      * Request password reset — server auto-detects delivery (SMS first, email fallback)
      */
      async requestPasswordReset(identifier) {
        await this.client.trpc.auth.requestPasswordReset.mutate({
          identifier
        });
      }
      /**
      * List login methods enabled for an organization (or globally if no code given).
      * Used by the login page to render the correct tabs (password / phone OTP).
      */
      async availableLoginMethods(organizationCode) {
        const result = await this.client.trpc.auth.availableLoginMethods.query(organizationCode ? {
          organizationCode
        } : void 0);
        return result.methods;
      }
      /**
      * Request a 6-digit SMS login code (휴대폰 인증 로그인).
      * Returns generic success regardless of outcome to prevent identifier enumeration.
      */
      async requestLoginCode(identifier, organizationCode) {
        await this.client.trpc.auth.requestLoginCode.mutate({
          identifier,
          organizationCode
        });
      }
      /**
      * Verify the SMS login code and complete login. On success, tokens are set on the client
      * and the same response shape as `login()` is returned.
      */
      async loginWithCode(identifier, code, organizationCode, captchaToken) {
        const result = await this.client.trpc.auth.loginWithCode.mutate({
          identifier,
          code,
          organizationCode,
          captchaToken
        });
        if ("captchaRequired" in result || "twoFactorRequired" in result) {
          return result;
        }
        this.client.setTokens(result.accessToken, result.refreshToken);
        this.logger.info({
          userId: result.user.id
        }, "OTP login successful");
        return result;
      }
      /**
      * Reset password with token
      */
      async resetPassword(token, newPassword, confirmPassword) {
        await this.client.trpc.auth.resetPassword.mutate({
          token,
          newPassword: await this.encrypt(newPassword),
          confirmPassword: await this.encrypt(confirmPassword)
        });
      }
      /**
      * Admin: reset employee password. The temporary password is ALWAYS delivered via SMS
      * to the employee — it is never returned in the response for security reasons.
      * Fails with BAD_REQUEST if the employee has no phone, or INTERNAL_SERVER_ERROR if SMS fails.
      */
      async adminResetPassword(employeeId) {
        return this.client.trpc.auth.adminResetPassword.mutate({
          employeeId
        });
      }
    }, __name(_a37, "_AuthService"), _a37);
    __name2(_AuthService, "AuthService");
    AuthService = _AuthService;
    _CertificationTypeService = (_a38 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter) {
        return this.client.trpc.certificationType.list.query(filter);
      }
      async create(input) {
        return this.client.trpc.certificationType.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.certificationType.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.certificationType.delete.mutate(id);
      }
    }, __name(_a38, "_CertificationTypeService"), _a38);
    __name2(_CertificationTypeService, "CertificationTypeService");
    CertificationTypeService = _CertificationTypeService;
    _ChatDeviceLinkService = (_a39 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async create(ephemeralPublicKey, options) {
        return this.client.trpc.chatDeviceLink.create.mutate({
          ephemeralPublicKey,
          ...options?.requesterPushToken ? {
            requesterPushToken: options.requesterPushToken
          } : {}
        });
      }
      async listPending() {
        return this.client.trpc.chatDeviceLink.listPending.query();
      }
      async approve(input) {
        return this.client.trpc.chatDeviceLink.approve.mutate(input);
      }
      async claim(requestId) {
        return this.client.trpc.chatDeviceLink.claim.mutate({
          requestId
        });
      }
      async cancel(requestId) {
        return this.client.trpc.chatDeviceLink.cancel.mutate({
          requestId
        });
      }
    }, __name(_a39, "_ChatDeviceLinkService"), _a39);
    __name2(_ChatDeviceLinkService, "ChatDeviceLinkService");
    ChatDeviceLinkService = _ChatDeviceLinkService;
    _ChatKeyService = (_a40 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async getMine() {
        return this.client.trpc.chatKey.getMine.query();
      }
      /** 복구 코드로 감싼 내 백업 — 새 기기에서 복구 코드로 풀 때. */
      async getMyBackup() {
        return this.client.trpc.chatKey.getMyBackup.query();
      }
      async register(input) {
        return this.client.trpc.chatKey.register.mutate(input);
      }
      async updateBackup(input) {
        return this.client.trpc.chatKey.updateBackup.mutate(input);
      }
      async publicKeys(employeeIds) {
        return this.client.trpc.chatKey.publicKeys.query({
          employeeIds
        });
      }
      /** 한 직원의 공개키 이력(E9) — 옛 version 의 서명 검증·키 변경 시각 */
      async history(employeeId) {
        return this.client.trpc.chatKey.history.query({
          employeeId
        });
      }
      async recoveryPublicKey() {
        return this.client.trpc.chatKey.recoveryPublicKey.query();
      }
    }, __name(_a40, "_ChatKeyService"), _a40);
    __name2(_ChatKeyService, "ChatKeyService");
    ChatKeyService = _ChatKeyService;
    _ChatRecoveryService = (_a41 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(status, limit) {
        return this.client.trpc.chatRecovery.list.query({
          status,
          limit
        });
      }
      /** 당사자(1~2명)의 대화방 목록 — 요청 화면의 「대화방 고르기」. 조회는 감사에 남는다 */
      async conversationsOf(employeeIds, period = {}) {
        return this.client.trpc.chatRecovery.conversationsOf.query({
          employeeIds,
          ...period
        });
      }
      /** 제출 전 미리보기 — 이 범위로 고정될 방·메시지 수 */
      async previewScope(scope) {
        return this.client.trpc.chatRecovery.previewScope.query({
          scope
        });
      }
      async get(requestId) {
        return this.client.trpc.chatRecovery.get.query({
          requestId
        });
      }
      async audit(requestId) {
        return this.client.trpc.chatRecovery.audit.query({
          requestId
        });
      }
      async create(input) {
        return this.client.trpc.chatRecovery.create.mutate(input);
      }
      async approve(requestId) {
        return this.client.trpc.chatRecovery.approve.mutate({
          requestId
        });
      }
      async reject(requestId, reason) {
        return this.client.trpc.chatRecovery.reject.mutate({
          requestId,
          reason
        });
      }
      async documentUrl(requestId, storagePath) {
        return this.client.trpc.chatRecovery.documentUrl.mutate({
          requestId,
          storagePath
        });
      }
      async claimHandoff(requestId) {
        return this.client.trpc.chatRecovery.claimHandoff.mutate({
          requestId
        });
      }
      async complete(input) {
        return this.client.trpc.chatRecovery.complete.mutate(input);
      }
      /** handoff 를 받은 뒤 — 범위 메시지의 암호문을 쪽 단위로(브라우저가 푼다) */
      async messages(requestId, page = 1, limit = 200) {
        return this.client.trpc.chatRecovery.messages.query({
          requestId,
          page,
          limit
        });
      }
      async attachmentUrl(requestId, storagePath) {
        return this.client.trpc.chatRecovery.attachmentUrl.mutate({
          requestId,
          storagePath
        });
      }
    }, __name(_a41, "_ChatRecoveryService"), _a41);
    __name2(_ChatRecoveryService, "ChatRecoveryService");
    ChatRecoveryService = _ChatRecoveryService;
    _ConversationKeyService = (_a43 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async epochs(conversationId) {
        return this.client.trpc.conversationKey.epochs.query({
          conversationId
        });
      }
      async myEnvelopes(conversationId) {
        return this.client.trpc.conversationKey.myEnvelopes.query({
          conversationId
        });
      }
      async missingRecipients(conversationId) {
        return this.client.trpc.conversationKey.missingRecipients.query({
          conversationId
        });
      }
      /** 이 기기에 현재 세대 키가 없다 — 키를 가진 멤버 기기에 봉투를 달라고 깨운다(2026-10-15). */
      async requestEnvelopes(conversationId) {
        return this.client.trpc.conversationKey.requestEnvelopes.mutate({
          conversationId
        });
      }
      async publish(input) {
        return this.client.trpc.conversationKey.publish.mutate(input);
      }
    }, __name(_a43, "_ConversationKeyService"), _a43);
    __name2(_ConversationKeyService, "ConversationKeyService");
    ConversationKeyService = _ConversationKeyService;
    _ConversationService = (_a44 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.conversation.list.query({
          filter,
          pagination
        });
      }
      /** 현재 사용자의 모든 활성 대화방에서 안 읽은 메시지 수 합계 */
      async unreadCount() {
        return this.client.trpc.conversation.unreadCount.query();
      }
      async get(id) {
        return this.client.trpc.conversation.get.query(id);
      }
      async create(input) {
        return this.client.trpc.conversation.create.mutate(input);
      }
      /** 「나와의 대화」 — 있으면 그 방, 없으면 만들어서 id 를 돌려준다 (MED-903) */
      async ensureSelf() {
        return this.client.trpc.conversation.ensureSelf.mutate();
      }
      /** Legacy single-member add */
      async addMember(input) {
        return this.client.trpc.conversation.addMember.mutate(input);
      }
      /** Bulk invite — handles direct→group conversion + system messages */
      async addMembers(input) {
        return this.client.trpc.conversation.addMembers.mutate(input);
      }
      /** 대화방 알림 끄기/켜기 — 단체방만, 사용자별 (MED-942) */
      async setMuted(input) {
        return this.client.trpc.conversation.setMuted.mutate(input);
      }
      /** 「지금 이 방을 보고 있다」 heartbeat — 보고 있는 방의 푸시를 서버가 보내지 않는다(null = 보는 방 없음) */
      async setViewing(input) {
        return this.client.trpc.conversation.setViewing.mutate(input);
      }
      /** Leave a conversation (soft-leave, history preserved) */
      async leave(conversationId) {
        return this.client.trpc.conversation.leave.mutate({
          conversationId
        });
      }
      /** Set per-user custom room name (null to clear) */
      async updateMemberSettings(conversationId, customName) {
        return this.client.trpc.conversation.updateMemberSettings.mutate({
          conversationId,
          customName
        });
      }
      /** Get active members of a conversation */
      async getMembers(conversationId) {
        return this.client.trpc.conversation.getMembers.query(conversationId);
      }
      /** Remove a member (owner-only) */
      async removeMember(conversationId, employeeId, attestation) {
        return this.client.trpc.conversation.removeMember.mutate({
          conversationId,
          employeeId,
          attestation
        });
      }
      /** Owner-only: transfer ownership to another active member (방장 위임) */
      async transferOwnership(conversationId, newOwnerId) {
        return this.client.trpc.conversation.transferOwnership.mutate({
          conversationId,
          newOwnerId
        });
      }
      /** Group-room owner-only: dissolve the room (방장이 나가면서 방 해체) */
      async leaveAndDissolve(conversationId) {
        return this.client.trpc.conversation.leaveAndDissolve.mutate({
          conversationId
        });
      }
      /** Owner-only: approve a pending join request (team-mandatory rooms). */
      async approveMember(conversationId, employeeId) {
        return this.client.trpc.conversation.approveMember.mutate({
          conversationId,
          employeeId
        });
      }
      /**
      * 팀장 없는 팀 단톡방의 입장 대기 — 시스템 관리자에게만 목록이 온다(그 밖에는 빈 목록).
      * 승인 · 거절은 approveMember / removeMember 로 한다.
      */
      async teamRoomJoinRequests(teamId) {
        return this.client.trpc.conversation.teamRoomJoinRequests.query({
          teamId
        });
      }
    }, __name(_a44, "_ConversationService"), _a44);
    __name2(_ConversationService, "ConversationService");
    ConversationService = _ConversationService;
    _DeductionImportService = (_a45 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** Decode an uploaded eCount xlsx (base64) and return a preview + the org's D-codes. */
      async parse(input) {
        return this.client.trpc.deductionImport.parse.mutate(input);
      }
      /** Build a staging SheetView from matched rows; commit via sheetView.commitToRecords. */
      async createStagingSheet(input) {
        return this.client.trpc.deductionImport.createStagingSheet.mutate(input);
      }
    }, __name(_a45, "_DeductionImportService"), _a45);
    __name2(_DeductionImportService, "DeductionImportService");
    DeductionImportService = _DeductionImportService;
    _DeductionService = (_a46 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.deduction.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.deduction.get.query(id);
      }
      async create(input) {
        return this.client.trpc.deduction.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.deduction.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.deduction.delete.mutate(id);
      }
      async approve(ids) {
        return this.client.trpc.deduction.approve.mutate({
          ids
        });
      }
      async cancel(ids) {
        return this.client.trpc.deduction.cancel.mutate({
          ids
        });
      }
      async review(year, month, employeeId) {
        return this.client.trpc.deduction.review.query({
          year,
          month,
          employeeId
        });
      }
    }, __name(_a46, "_DeductionService"), _a46);
    __name2(_DeductionService, "DeductionService");
    DeductionService = _DeductionService;
    _DeviceCredentialService = (_a47 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 내 기기 자격증명 목록(회수된 것 제외) */
      async list() {
        return this.client.trpc.deviceCredential.list.query();
      }
      async revoke(input) {
        return this.client.trpc.deviceCredential.revoke.mutate(input);
      }
      /* 기기 키 */
      async registerDeviceKey(input) {
        return this.client.trpc.deviceCredential.registerDeviceKey.mutate(input);
      }
      async deviceKeyChallenge(input) {
        return this.client.trpc.deviceCredential.deviceKeyChallenge.mutate(input);
      }
      /** 서명 검증 뒤 세션 발급 — 토큰은 여기서 바로 심는다(비밀번호 로그인과 같은 응답). */
      async deviceKeyLogin(input) {
        const result = await this.client.trpc.deviceCredential.deviceKeyLogin.mutate(input);
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
      /* 패스키 */
      async passkeyRegisterOptions() {
        return this.client.trpc.deviceCredential.passkeyRegisterOptions.mutate();
      }
      async passkeyRegisterVerify(input) {
        return this.client.trpc.deviceCredential.passkeyRegisterVerify.mutate(input);
      }
      async passkeyLoginOptions(input) {
        return this.client.trpc.deviceCredential.passkeyLoginOptions.mutate(input ?? void 0);
      }
      async passkeyLoginVerify(input) {
        const result = await this.client.trpc.deviceCredential.passkeyLoginVerify.mutate(input);
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
    }, __name(_a47, "_DeviceCredentialService"), _a47);
    __name2(_DeviceCredentialService, "DeviceCredentialService");
    DeviceCredentialService = _DeviceCredentialService;
    _DocumentService = (_a48 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.document.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.document.get.query(id);
      }
      async upload(input) {
        return this.client.trpc.document.upload.mutate(input);
      }
      async update(input) {
        return this.client.trpc.document.update.mutate(input);
      }
      async cancel(id) {
        return this.client.trpc.document.cancel.mutate(id);
      }
      /** 관리자 기안 — 대상 직원 명의의 인사처리 문서(인사발령품의서) */
      async createHrAction(input) {
        return this.client.trpc.document.createHrAction.mutate(input);
      }
      async review(input) {
        return this.client.trpc.document.review.mutate(input);
      }
    }, __name(_a48, "_DocumentService"), _a48);
    __name2(_DocumentService, "DocumentService");
    DocumentService = _DocumentService;
    _DocumentTemplateService = (_a49 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list() {
        return this.client.trpc.documentTemplate.list.query();
      }
      async get(id) {
        return this.client.trpc.documentTemplate.get.query(id);
      }
      async create(input) {
        return this.client.trpc.documentTemplate.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.documentTemplate.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.documentTemplate.delete.mutate(id);
      }
      async variables() {
        return this.client.trpc.documentTemplate.variables.query();
      }
      async preview(input) {
        return this.client.trpc.documentTemplate.preview.query(input);
      }
    }, __name(_a49, "_DocumentTemplateService"), _a49);
    __name2(_DocumentTemplateService, "DocumentTemplateService");
    DocumentTemplateService = _DocumentTemplateService;
    _EducationSubsidyService = (_a50 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.educationSubsidy.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.educationSubsidy.get.query(id);
      }
      async create(input) {
        return this.client.trpc.educationSubsidy.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.educationSubsidy.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.educationSubsidy.delete.mutate(id);
      }
      async approve(ids) {
        return this.client.trpc.educationSubsidy.approve.mutate({
          ids
        });
      }
    }, __name(_a50, "_EducationSubsidyService"), _a50);
    __name2(_EducationSubsidyService, "EducationSubsidyService");
    EducationSubsidyService = _EducationSubsidyService;
    _EmployeeCertificationService = (_a51 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter) {
        return this.client.trpc.employeeCertification.list.query(filter);
      }
      async summary() {
        return this.client.trpc.employeeCertification.summary.query();
      }
      async create(input) {
        return this.client.trpc.employeeCertification.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.employeeCertification.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.employeeCertification.delete.mutate(id);
      }
      async export(filter) {
        return this.client.trpc.employeeCertification.export.mutate(filter);
      }
      /** Self-service: employee submits their own certification */
      async submitMy(input) {
        return this.client.trpc.employeeCertification.submitMy.mutate(input);
      }
    }, __name(_a51, "_EmployeeCertificationService"), _a51);
    __name2(_EmployeeCertificationService, "EmployeeCertificationService");
    EmployeeCertificationService = _EmployeeCertificationService;
    __name(quietForbiddenContext, "quietForbiddenContext");
    __name2(quietForbiddenContext, "quietForbiddenContext");
    _EmployeeService = (_a53 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** Verify RRN front 6 digits for payslip access */
      async verifyRrn(rrnFront) {
        return this.client.trpc.employee.verifyRrn.mutate({
          rrnFront
        });
      }
      /**
      * Lightweight contact list for messenger (name, teams).
      * Any authenticated employee can see all contacts in their organization.
      */
      async getContacts(input) {
        return this.client.trpc.employee.contacts.query(input);
      }
      /**
      * 메신저 연락처 프로필 — 사진 · 소속 팀 · 역할 · 직무/직군/직위 · 이메일, 병원이 공개하면 전화번호.
      * 재직 중이 아니거나 다른 병원 직원이면 null.
      */
      async getContactProfile(id) {
        return this.client.trpc.employee.contactProfile.query({
          id
        });
      }
      /**
      * 직원 카드(표의 이름을 누르면 뜨는 팝오버) — 이름 · 상태 · 사번 · 직무 · 소속 팀 · 병동 배정.
      * 보는 사람의 직원 조회 범위 안에서만 내려오고(밖이면 FORBIDDEN), 없는 직원이면 null.
      */
      async getEmployeeCard(id) {
        return this.client.trpc.employee.card.query({
          id
        });
      }
      /**
      * 오늘의 축하 대상(생일 · 입사 N주년) — 직원 앱 홈 카드용.
      * 조직 타임존 기준 오늘, 이름·팀·N주년만 내려온다(생년월일은 포함되지 않는다).
      */
      async getCelebrations() {
        return this.client.trpc.employee.celebrations.query();
      }
      /**
      * Get all employees with optional filters
      */
      async getEmployees(filters) {
        return this.client.trpc.employee.list.query({
          filter: filters,
          pagination: filters
        });
      }
      /**
      * 소속 한 줄의 근무 · 주 소속 저장(직원 수정 화면). 직원 수정 권한으로 저장되고,
      * 주 소속 줄이면 서버가 직원 근무(근태·연차 기준)까지 맞춘다.
      */
      async updateMembershipShift(input) {
        return this.client.trpc.employee.updateMembershipShift.mutate(input);
      }
      /**
      * Get employee by ID
      */
      async getEmployee(employeeId) {
        return this.client.trpc.employee.get.query(employeeId);
      }
      /**
      * 직원 추가 패널 미리보기 — 저장하면 행이 들어갈 시트(조직 설정 「신규 입사자 시트 자동 추가」가 켜져 있을 때).
      * `background: true` — 패널이 스스로 부르는 보조 조회라 권한(employee:create 전체)이 없어도 권한 모달을 띄우지 않는다.
      */
      async previewNewEmployeeSheets(hireDate, opts) {
        return this.client.trpc.employee.previewNewEmployeeSheets.query({
          hireDate: hireDate || void 0
        }, quietForbiddenContext(opts));
      }
      /** 직원 추가 패널의 사번 미리보기 — 같은 이유로 배경 조회 */
      async previewNextEmployeeNumber(opts) {
        return this.client.trpc.employee.previewNextEmployeeNumber.query(void 0, quietForbiddenContext(opts));
      }
      /**
      * Create a new employee
      */
      async createEmployee(params) {
        return this.client.trpc.employee.create.mutate(params);
      }
      /**
      * Update an employee
      */
      async updateEmployee(params) {
        return this.client.trpc.employee.update.mutate({
          ...params
        });
      }
      /**
      * Upsert the employee's employment contract (append-only versioning —
      * supersedes the active contract and creates a merged new version, or
      * bootstraps v1 when none exists). Pass only the changed fields.
      */
      async upsertContract(params) {
        return this.client.trpc.employee.upsertContract.mutate(params);
      }
      /**
      * Delete an employee (soft delete)
      */
      async deleteEmployee(employeeId) {
        return this.client.trpc.employee.delete.mutate(employeeId);
      }
      /** 직원 계정(Account) 초대 메일 발송 — 회원 계정 연결 경로 */
      async sendAccountInvite(employeeId) {
        return this.client.trpc.employee.sendAccountInvite.mutate({
          employeeId
        });
      }
      /**
      * Confirm profile picture after presigned-URL upload
      */
      async confirmProfilePicture(input) {
        return this.client.trpc.employee.confirmProfilePicture.mutate(input);
      }
      /**
      * Remove the caller's own profile picture (resets to the initial avatar)
      */
      async removeProfilePicture() {
        return this.client.trpc.employee.removeProfilePicture.mutate();
      }
      /** 본인 서명/도장 이미지 조회 (내 정보 서명 섹션 미리보기) */
      async mySignature() {
        return this.client.trpc.employee.mySignature.query();
      }
      /** 내 근로형태(포괄임금 월 시간 기준, MED-965) — 지정이 없으면 null */
      async myWorkPattern() {
        return this.client.trpc.employee.myWorkPattern.query();
      }
      /** 본인 서명/도장 이미지 등록(data URI)·삭제(null) — 결재문서 {{서명}} 자리에 삽입 */
      async setMySignature(image) {
        return this.client.trpc.employee.setMySignature.mutate({
          image
        });
      }
      /** 직원이 신청할 수 있는 증명서 양식(재직·경력·퇴직) + 양식별 신청 입력 항목 */
      async certificateTemplates() {
        return this.client.trpc.employee.certificateTemplates.query();
      }
      /** 인사처리 서류(사직서·휴직신청서…) 종류별 첨부 필수 여부 — 조직 결재 서식의 「첨부 파일」 설정 반영(MED-902) */
      async hrActionAttachmentPolicy() {
        return this.client.trpc.employee.hrActionAttachmentPolicy.query();
      }
      /**
      * 증명서 신청 — 문자열이면 용도만(재직증명서 기본), 객체면 양식·용도·부가 항목(제출처·주소·수량·비고)
      */
      async requestCertificate(input) {
        const payload = typeof input === "string" || input === void 0 ? {
          purpose: input || "\uC81C\uCD9C\uC6A9"
        } : input;
        return this.client.trpc.employee.requestCertificate.mutate(payload);
      }
      async myCertificateRequests() {
        return this.client.trpc.employee.myCertificateRequests.query();
      }
      /** 본인 대기 중 증명서 신청 취소 */
      async cancelCertificateRequest(id) {
        return this.client.trpc.employee.cancelCertificateRequest.mutate(id);
      }
      async approveCertificate(input) {
        return this.client.trpc.employee.approveCertificate.mutate(input);
      }
      async previewCertificate(id) {
        return this.client.trpc.employee.previewCertificate.query(id);
      }
      async rejectCertificate(id, reason) {
        return this.client.trpc.employee.rejectCertificate.mutate({
          id,
          reason
        });
      }
      /** 신규 직원 대량 추가 — dryRun=true 검증, false 커밋 (All-or-Nothing). */
      async bulkCreateValidated(input) {
        return this.client.trpc.employee.bulkCreateValidated.mutate(input);
      }
      /** 직원 정보 대량 수정 — 식별키 매칭 + All-or-Nothing. */
      async bulkUpdateValidated(input) {
        return this.client.trpc.employee.bulkUpdateValidated.mutate(input);
      }
      async exportRoster(filter) {
        return this.client.trpc.employee.exportRoster.mutate(filter);
      }
      async statusHistory(employeeId) {
        return this.client.trpc.employee.statusHistory.query(employeeId);
      }
      async createLeaveRecord(input) {
        return this.client.trpc.employee.createLeaveRecord.mutate(input);
      }
      async returnFromLeave(employeeId) {
        return this.client.trpc.employee.returnFromLeave.mutate(employeeId);
      }
      /** 퇴직 취소(재직 복귀) — 실수로 퇴직 처리한 직원을 되돌린다(MED-834). 사유 필수. */
      async cancelTermination(input) {
        return this.client.trpc.employee.cancelTermination.mutate(input);
      }
      async bulkAssignRole(employeeIds, roleId) {
        return this.client.trpc.employee.bulkAssignRole.mutate({
          employeeIds,
          roleId
        });
      }
      /** 근무 그룹·근무 형태 일괄 배정 — shiftId 를 주면 그룹도 그 형태의 그룹으로 맞춰진다. */
      async bulkAssignShift(employeeIds, shiftGroupId, shiftId) {
        return this.client.trpc.employee.bulkAssignShift.mutate({
          employeeIds,
          shiftGroupId,
          shiftId
        });
      }
      /** 「부 그룹 제거」 — 주 소속이 아닌 소속 줄의 근무 그룹·형태를 비운다(MED-924). 주 소속·직원 근무는 그대로. */
      async clearSecondaryShiftGroups(employeeIds) {
        return this.client.trpc.employee.clearSecondaryShiftGroups.mutate({
          employeeIds
        });
      }
      async certificateHistory(filter) {
        return this.client.trpc.employee.certificateHistory.query(filter);
      }
    }, __name(_a53, "_EmployeeService"), _a53);
    __name2(_EmployeeService, "EmployeeService");
    EmployeeService = _EmployeeService;
    _EntityPickerService = (_a54 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async directory(input) {
        return this.client.trpc.entityPicker.directory.query(input);
      }
    }, __name(_a54, "_EntityPickerService"), _a54);
    __name2(_EntityPickerService, "EntityPickerService");
    EntityPickerService = _EntityPickerService;
    _ESignService = (_a55 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async listHerebyTemplates() {
        return this.client.trpc.eSign.listHerebyTemplates.query();
      }
      async integrationStatus() {
        return this.client.trpc.eSign.integrationStatus.query();
      }
      async provisionIntegration() {
        return this.client.trpc.eSign.provisionIntegration.mutate();
      }
      async send(input) {
        return this.client.trpc.eSign.send.mutate(input);
      }
      async list(input = {}) {
        return this.client.trpc.eSign.list.query(input);
      }
      async getById(id) {
        return this.client.trpc.eSign.getById.query(id);
      }
      async syncStatus(input) {
        return this.client.trpc.eSign.syncStatus.mutate(input);
      }
      // 목록 새로고침 시 미완료 레코드 여러 건의 Hereby 상태를 한 번에 동기화한다.
      async syncStatuses(input) {
        return this.client.trpc.eSign.syncStatuses.mutate(input);
      }
      async integrationHealth() {
        return this.client.trpc.eSign.integrationHealth.query();
      }
      // Phase 3.1: re-issue a fresh login-token redirect URL on every "열기" click.
      async openContract(id) {
        return this.client.trpc.eSign.openContract.mutate(id);
      }
    }, __name(_a55, "_ESignService"), _a55);
    __name2(_ESignService, "ESignService");
    ESignService = _ESignService;
    _FixedIncentiveService = (_a56 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.fixedIncentive.list.query({
          filter,
          pagination
        });
      }
      /** Active incentive presets — 유형 picker source on 인센티브 세션 sheets. */
      async listPresets() {
        return this.client.trpc.fixedIncentive.listPresets.query();
      }
      /** 병원별 자기 등록 스위치 (`incentive.self_registration`) — 기본 꺼짐(opt-in). */
      async getSelfRegistrationConfig() {
        return this.client.trpc.fixedIncentive.getSelfRegistrationConfig.query();
      }
      async get(id) {
        return this.client.trpc.fixedIncentive.get.query(id);
      }
      async create(input) {
        return this.client.trpc.fixedIncentive.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.fixedIncentive.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.fixedIncentive.delete.mutate(id);
      }
      async approve(ids) {
        return this.client.trpc.fixedIncentive.approve.mutate({
          ids
        });
      }
      /**
      * IR-3 합산 확인 승인 — (year, month, incentiveType) 의 PENDING 전건
      * 일괄 승인. 팀장은 자기 팀원 건만 승인된다(서버 scope 필터).
      */
      async approveByType(year, month, incentiveType) {
        return this.client.trpc.fixedIncentive.approveByType.mutate({
          year,
          month,
          incentiveType
        });
      }
      // ── IR-4 주말 당직 치료 세션 전자결재 ────────────────────────────
      /**
      * 당직 인원 픽커용 내 팀 동료 목록. workDate 를 주면 그 날짜에 출근
      * 기록이 있는 동료가 `onDuty: true` 로 표시된다 (IR-4 프리필).
      */
      async listMyTeammates(input) {
        return this.client.trpc.fixedIncentive.listMyTeammates.query(input ?? {});
      }
      /** 치료 세션 신청 (당직 치료사 본인 상신). */
      async requestTreatmentSession(input) {
        return this.client.trpc.fixedIncentive.requestTreatmentSession.mutate(input);
      }
      /** 신청 목록 — self 는 본인, 팀장/관리자는 스코프 내 전체. */
      async listTreatmentSessionRequests(input = {}) {
        return this.client.trpc.fixedIncentive.listTreatmentSessionRequests.query(input);
      }
      /** 신청 승인 → 세션 생성. */
      async approveTreatmentSessionRequest(id) {
        return this.client.trpc.fixedIncentive.approveTreatmentSessionRequest.mutate({
          id
        });
      }
      /** 신청 반려 (사유 필수). */
      async rejectTreatmentSessionRequest(id, rejectionReason) {
        return this.client.trpc.fixedIncentive.rejectTreatmentSessionRequest.mutate({
          id,
          rejectionReason
        });
      }
      /** 신청 취소 (본인·대기 상태만). */
      async cancelTreatmentSessionRequest(id) {
        return this.client.trpc.fixedIncentive.cancelTreatmentSessionRequest.mutate({
          id
        });
      }
      /**
      * Treatment-session upsert. Creates or updates a session of N
      * therapists in one shot, computing per-person amounts server-side
      * and fanning out to N FixedIncentive rows. Used by team-manager
      * registration and hr-system therapy-daily edit.
      */
      async upsertTreatmentSession(input) {
        return this.client.trpc.fixedIncentive.upsertTreatmentSession.mutate(input);
      }
    }, __name(_a56, "_FixedIncentiveService"), _a56);
    __name2(_FixedIncentiveService, "FixedIncentiveService");
    FixedIncentiveService = _FixedIncentiveService;
    _GeneralAffairsService = (_a57 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      // --- Dashboard ---
      async dashboard() {
        return this.client.trpc.generalAffairs.dashboard.query();
      }
      // --- Training ---
      async listTrainings(filter, pagination) {
        return this.client.trpc.generalAffairs.training.list.query({
          filter,
          pagination
        });
      }
      async getTraining(id) {
        return this.client.trpc.generalAffairs.training.get.query(id);
      }
      async createTraining(input) {
        return this.client.trpc.generalAffairs.training.create.mutate(input);
      }
      async updateTraining(input) {
        return this.client.trpc.generalAffairs.training.update.mutate(input);
      }
      async deleteTraining(id) {
        return this.client.trpc.generalAffairs.training.delete.mutate(id);
      }
      async listCompletions(filter, pagination) {
        return this.client.trpc.generalAffairs.training.completions.query({
          filter,
          pagination
        });
      }
      async addCompletion(input) {
        return this.client.trpc.generalAffairs.training.addCompletion.mutate(input);
      }
      async updateCompletion(input) {
        return this.client.trpc.generalAffairs.training.updateCompletion.mutate(input);
      }
      async deleteCompletion(id) {
        return this.client.trpc.generalAffairs.training.deleteCompletion.mutate(id);
      }
      async trainingDashboard() {
        return this.client.trpc.generalAffairs.training.dashboard.query();
      }
      // --- Tasks ---
      async listTasks(filter, pagination) {
        return this.client.trpc.generalAffairs.task.list.query({
          filter,
          pagination
        });
      }
      async getTask(id) {
        return this.client.trpc.generalAffairs.task.get.query(id);
      }
      async createTask(input) {
        return this.client.trpc.generalAffairs.task.create.mutate(input);
      }
      async updateTask(input) {
        return this.client.trpc.generalAffairs.task.update.mutate(input);
      }
      async deleteTask(id) {
        return this.client.trpc.generalAffairs.task.delete.mutate(id);
      }
      async listExecutions(filter, pagination) {
        return this.client.trpc.generalAffairs.task.executions.query({
          filter,
          pagination
        });
      }
      async createExecution(input) {
        return this.client.trpc.generalAffairs.task.createExecution.mutate(input);
      }
      async updateExecution(input) {
        return this.client.trpc.generalAffairs.task.updateExecution.mutate(input);
      }
      // --- Notices ---
      async listNotices(filter, pagination) {
        return this.client.trpc.generalAffairs.notice.list.query({
          filter,
          pagination
        });
      }
      async getNotice(id) {
        return this.client.trpc.generalAffairs.notice.get.query(id);
      }
      async createNotice(input) {
        return this.client.trpc.generalAffairs.notice.create.mutate(input);
      }
      async updateNotice(input) {
        return this.client.trpc.generalAffairs.notice.update.mutate(input);
      }
      async deleteNotice(id) {
        return this.client.trpc.generalAffairs.notice.delete.mutate(id);
      }
      async publishNotice(id) {
        return this.client.trpc.generalAffairs.notice.publish.mutate(id);
      }
      /** 특정 공지를 확인한 직원 목록 (확인 내역 팝업) */
      /** 관리자가 직원 대신 공지 확인 처리 (데이터 조율용, CS-LOC-260909-0009). */
      async acknowledgeNoticeOnBehalf(input) {
        return this.client.trpc.generalAffairs.notice.acknowledgeOnBehalf.mutate(input);
      }
      /** 게시 후 확인 인원 표시값만 변경 (CS-LOC-260909-0009). */
      async setNoticeAcknowledgedCountOverride(input) {
        return this.client.trpc.generalAffairs.notice.setAcknowledgedCountOverride.mutate(input);
      }
      /** 게시된 공지의 수정 이력 — 수정 전 판들, 최신 판이 먼저 (MED-974) */
      async listNoticeRevisions(noticeId) {
        return this.client.trpc.generalAffairs.notice.revisions.query(noticeId);
      }
      async getNoticeAcknowledgedEmployees(noticeId) {
        return this.client.trpc.generalAffairs.notice.getAcknowledgedEmployees.query(noticeId);
      }
      /** 공지 게시 대상 팀 선택용 — 조직의 활성 팀 목록 */
      async listNoticeTeams() {
        return this.client.trpc.generalAffairs.notice.listTeams.query();
      }
      // --- Employee-facing Notices ---
      async listPublishedNotices(filter, pagination) {
        return this.client.trpc.generalAffairs.notice.listPublished.query({
          filter,
          pagination
        });
      }
      async acknowledgeNotice(noticeId) {
        return this.client.trpc.generalAffairs.notice.acknowledge.mutate(noticeId);
      }
      async unreadNoticeCount() {
        return this.client.trpc.generalAffairs.notice.unreadCount.query();
      }
    }, __name(_a57, "_GeneralAffairsService"), _a57);
    __name2(_GeneralAffairsService, "GeneralAffairsService");
    GeneralAffairsService = _GeneralAffairsService;
    _GradePromotionService = (_a58 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async detect() {
        return this.client.trpc.gradePromotion.detect.mutate();
      }
      // biome-ignore lint/suspicious/noExplicitAny: dynamic filter
      async list(filter) {
        return this.client.trpc.gradePromotion.list.query(filter);
      }
      async approve(ids) {
        return this.client.trpc.gradePromotion.approve.mutate({
          ids
        });
      }
      async reject(ids, reason) {
        return this.client.trpc.gradePromotion.reject.mutate({
          ids,
          reason
        });
      }
      async getSettings() {
        return this.client.trpc.gradePromotion.getSettings.query();
      }
      // biome-ignore lint/suspicious/noExplicitAny: dynamic input
      async updateSettings(input) {
        return this.client.trpc.gradePromotion.updateSettings.mutate(input);
      }
    }, __name(_a58, "_GradePromotionService"), _a58);
    __name2(_GradePromotionService, "GradePromotionService");
    GradePromotionService = _GradePromotionService;
    _ImpersonationService = (_a59 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 시작 모달용 대상 요약 — 이름·사번·역할 칩·유효 권한 수·admin 접근 가능 여부 */
      async preview(employeeId) {
        return this.client.trpc.impersonation.preview.query({
          employeeId
        });
      }
      /** 세션 발급 — 응답은 로그인 응답 모양 + impersonation 메타 */
      async start(input) {
        return this.client.trpc.impersonation.start.mutate(input);
      }
      /** 현재 미리보기 세션 종료 — grant 회수 + 토큰 무효화 */
      async end() {
        return this.client.trpc.impersonation.end.mutate();
      }
    }, __name(_a59, "_ImpersonationService"), _a59);
    __name2(_ImpersonationService, "ImpersonationService");
    ImpersonationService = _ImpersonationService;
    _InventoryService = (_a60 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      // ── Categories ──
      async listCategories(filter) {
        return this.client.trpc.inventory.listCategories.query(filter);
      }
      async getCategory(id) {
        return this.client.trpc.inventory.getCategory.query(id);
      }
      async createCategory(input) {
        return this.client.trpc.inventory.createCategory.mutate(input);
      }
      async updateCategory(input) {
        return this.client.trpc.inventory.updateCategory.mutate(input);
      }
      async deleteCategory(id) {
        return this.client.trpc.inventory.deleteCategory.mutate(id);
      }
      // ── Items ──
      async listItems(filter) {
        return this.client.trpc.inventory.listItems.query(filter);
      }
      async getItem(id) {
        return this.client.trpc.inventory.getItem.query(id);
      }
      async createItem(input) {
        return this.client.trpc.inventory.createItem.mutate(input);
      }
      async updateItem(input) {
        return this.client.trpc.inventory.updateItem.mutate(input);
      }
      async deleteItem(id) {
        return this.client.trpc.inventory.deleteItem.mutate(id);
      }
      async adjustQuantity(input) {
        return this.client.trpc.inventory.adjustQuantity.mutate(input);
      }
      async markRefund(input) {
        return this.client.trpc.inventory.markRefund.mutate(input);
      }
      // ── Dashboard ──
      async getExpirationAlerts() {
        return this.client.trpc.inventory.getExpirationAlerts.query();
      }
      async getDashboardSummary() {
        return this.client.trpc.inventory.getDashboardSummary.query();
      }
    }, __name(_a60, "_InventoryService"), _a60);
    __name2(_InventoryService, "InventoryService");
    InventoryService = _InventoryService;
    _InviteService = (_a61 = class {
      constructor(client) {
        __publicField(this, "client");
        __publicField(this, "logger");
        __publicField(this, "publicKeyPem", null);
        this.client = client;
        this.logger = sdkLogger.createServiceLogger("InviteService");
      }
      async encrypt(password) {
        try {
          if (!this.publicKeyPem) {
            const result = await this.client.trpc.auth.publicKey.query();
            this.publicKeyPem = result.publicKeyPem;
          }
          return await encryptPassword(password, this.publicKeyPem);
        } catch (error) {
          this.logger.warn({
            error
          }, "Password encryption unavailable, falling back to plaintext");
          return password;
        }
      }
      /** 초대 정보 조회 (수락 페이지 초기 로드) */
      async info(token) {
        return this.client.trpc.invite.info.query({
          token
        });
      }
      /** 초대 수락 — 성공 시 세션 토큰이 저장된다 (mode: workspace | account) */
      async accept(token, password) {
        const result = await this.client.trpc.invite.accept.mutate({
          token,
          password: await this.encrypt(password)
        });
        this.client.setTokens(result.accessToken, result.refreshToken);
        this.logger.info({
          mode: result.mode
        }, "Invite accepted");
        return result;
      }
    }, __name(_a61, "_InviteService"), _a61);
    __name2(_InviteService, "InviteService");
    InviteService = _InviteService;
    _ItemCodeService = (_a63 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      // ── Allowance Item Codes ──
      async listAllowanceCodes(filter) {
        return this.client.trpc.itemCode.listAllowanceCodes.query(filter);
      }
      async createAllowanceCode(input) {
        return this.client.trpc.itemCode.createAllowanceCode.mutate(input);
      }
      async bulkCreateAllowanceCodes(input) {
        return this.client.trpc.itemCode.bulkCreateAllowanceCodes.mutate(input);
      }
      async updateAllowanceCode(input) {
        return this.client.trpc.itemCode.updateAllowanceCode.mutate(input);
      }
      async deleteAllowanceCode(id) {
        return this.client.trpc.itemCode.deleteAllowanceCode.mutate(id);
      }
      // ── Deduction Item Codes ──
      async listDeductionCodes(filter) {
        return this.client.trpc.itemCode.listDeductionCodes.query(filter);
      }
      async createDeductionCode(input) {
        return this.client.trpc.itemCode.createDeductionCode.mutate(input);
      }
      async bulkCreateDeductionCodes(input) {
        return this.client.trpc.itemCode.bulkCreateDeductionCodes.mutate(input);
      }
      async updateDeductionCode(input) {
        return this.client.trpc.itemCode.updateDeductionCode.mutate(input);
      }
      async deleteDeductionCode(id) {
        return this.client.trpc.itemCode.deleteDeductionCode.mutate(id);
      }
    }, __name(_a63, "_ItemCodeService"), _a63);
    __name2(_ItemCodeService, "ItemCodeService");
    ItemCodeService = _ItemCodeService;
    _JobDutyService = (_a64 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 직무 목록(기본 근무·허용 근무형태·직원 수·근무형태 분포 포함). activeOnly 로 선택지용 활성 목록만. */
      async list(input) {
        return this.client.trpc.jobDuty.list.query(input);
      }
      async create(input) {
        return this.client.trpc.jobDuty.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.jobDuty.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.jobDuty.delete.mutate(id);
      }
      /** 직무 기본 근무 일괄 재적용 — dryRun(미리보기) → 적용 2단계. 직무·직원을 안 주면 직무가 있는 직원 전체. */
      async reapplyDefaultShifts(input) {
        return this.client.trpc.jobDuty.reapplyDefaultShifts.mutate(input);
      }
      /** 근무 유형 폼 「기본으로 쓰는 직무」 — 이 근무형태를 기본 근무로 쓰는 직무 목록을 통째로 저장한다. */
      async setDefaultShift(shiftId, jobDutyIds) {
        return this.client.trpc.jobDuty.setDefaultShift.mutate({
          shiftId,
          jobDutyIds
        });
      }
    }, __name(_a64, "_JobDutyService"), _a64);
    __name2(_JobDutyService, "JobDutyService");
    JobDutyService = _JobDutyService;
    _LeaveImportService = (_a65 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async preview(input) {
        return this.client.trpc.leaveImport.preview.mutate(input);
      }
      async run(input) {
        return this.client.trpc.leaveImport.run.mutate(input);
      }
      /** 시트 「연차 신청 리스트」 → 미리보기 (파일 대신 sheetViewId) */
      async previewSheet(sheetViewId) {
        return this.client.trpc.leaveImport.previewSheet.mutate({
          sheetViewId
        });
      }
      /** 시트 「연차 신청 리스트」 → 검증(dryRun)/반영. 이미 이관된 행은 오류 없이 건너뛴다 */
      async runSheet(input) {
        return this.client.trpc.leaveImport.runSheet.mutate(input);
      }
      async listBatches() {
        return this.client.trpc.leaveImport.listBatches.query();
      }
      async revert(batchId) {
        return this.client.trpc.leaveImport.revert.mutate({
          batchId
        });
      }
    }, __name(_a65, "_LeaveImportService"), _a65);
    __name2(_LeaveImportService, "LeaveImportService");
    LeaveImportService = _LeaveImportService;
    _LeaveRequestService = (_a66 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.leaveRequest.list.query({
          filter,
          pagination
        });
      }
      /** 휴가 건을 휴가신청서 서식(A4 인쇄 HTML)으로 렌더링 */
      async renderForm(id) {
        return this.client.trpc.leaveRequest.renderForm.query(id);
      }
      async get(id) {
        return this.client.trpc.leaveRequest.get.query(id);
      }
      async create(input) {
        return this.client.trpc.leaveRequest.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.leaveRequest.update.mutate(input);
      }
      /** 승인된 휴가 취소 신청(MED-959) — 시작 전이면 전체, 시작 뒤면 오늘부터 남은 날 */
      async requestCancel(id, reason) {
        return this.client.trpc.leaveRequest.requestCancel.mutate({
          id,
          reason
        });
      }
      /** 결재 전 취소 신청 철회 */
      async withdrawCancelRequest(id) {
        return this.client.trpc.leaveRequest.withdrawCancelRequest.mutate(id);
      }
      /** 취소 신청 결재(관리자) — approve=false 면 거절(휴가 그대로) */
      async resolveCancelRequest(id, approve, rejectionReason) {
        return this.client.trpc.leaveRequest.resolveCancelRequest.mutate({
          id,
          approve,
          rejectionReason
        });
      }
      async cancel(id) {
        return this.client.trpc.leaveRequest.cancel.mutate(id);
      }
      async approve(input) {
        return this.client.trpc.leaveRequest.approve.mutate(input);
      }
      async request(input) {
        return this.client.trpc.leaveRequest.request.mutate(input);
      }
      async reject(input) {
        return this.client.trpc.leaveRequest.reject.mutate(input);
      }
      /** 연차 현황 — basis 를 주면 그 기준으로 본다(적용 기준과 다르면 참고 환산, 응답 basis.reference=true) */
      async listBalances(filter) {
        return this.client.trpc.leaveRequest.listBalances.query(filter || {});
      }
      async myBalance(asOfDate) {
        return this.client.trpc.leaveRequest.myBalance.query(asOfDate ? {
          asOfDate
        } : void 0);
      }
      async getBalance(employeeId, asOfDate) {
        return this.client.trpc.leaveRequest.getBalance.query({
          employeeId,
          asOfDate
        });
      }
      /** [상세] 적용된 규칙 탭 + [조정] 팝업 공통 데이터 — 적용 규칙·기간·잔여·소정근로시간 */
      /** 퇴사 정산 기준값 — 입사일 기준 잔여(적용 기준이 회계년도여도 입사일 기준으로 환산) */
      async settlementBalance(employeeId, asOfDate) {
        return this.client.trpc.leaveRequest.settlementBalance.query({
          employeeId,
          asOfDate
        });
      }
      async balanceRuleDetail(employeeId) {
        return this.client.trpc.leaveRequest.balanceRuleDetail.query({
          employeeId
        });
      }
      /** [상세] 조정 내역 탭 — 수동 ADJUST 원장 목록 */
      async listBalanceAdjustments(employeeId) {
        return this.client.trpc.leaveRequest.listBalanceAdjustments.query({
          employeeId
        });
      }
      /** [조정] — 잔여를 목표값(일)으로 맞추는 수동 조정 (8시간=1일, 1시간 단위) */
      async adjustBalance(input) {
        return this.client.trpc.leaveRequest.adjustBalance.mutate(input);
      }
      async listEntitlementRules() {
        return this.client.trpc.leaveRequest.listEntitlementRules.query();
      }
      // ── 산정 기준(입사일/회계연도) 변경 예약 ──
      async listBasisChanges() {
        return this.client.trpc.leaveRequest.listBasisChanges.query();
      }
      async scheduleBasisChange(input) {
        return this.client.trpc.leaveRequest.scheduleBasisChange.mutate(input);
      }
      async cancelBasisChange(id) {
        return this.client.trpc.leaveRequest.cancelBasisChange.mutate({
          id
        });
      }
      /**
      * 연차 정책을 저장하기 전에 영향을 미리 본다 — 새로 켜지는 차단 검사 때문에
      * 승인 불가가 될 대기 신청 목록을 돌려준다. 아무것도 바꾸지 않는다.
      */
      /** 신청 전 차감 미리보기(MED-958) — 본인 기준 운영 규칙으로 센 일수·제외일 */
      async estimateDeduction(input) {
        return this.client.trpc.leaveRequest.estimateDeduction.query(input);
      }
      async previewPolicyImpact(policy) {
        return this.client.trpc.leaveRequest.previewPolicyImpact.query(policy);
      }
      async upsertEntitlementRule(input) {
        return this.client.trpc.leaveRequest.upsertEntitlementRule.mutate(input);
      }
      async deleteEntitlementRule(id) {
        return this.client.trpc.leaveRequest.deleteEntitlementRule.mutate(id);
      }
      /**
      * 보정 이전 공휴일 소진 이력 — 읽기 전용 리포트(자동 수정 없음).
      * 유급휴일이 연차로 차감된 원장 엔트리 목록 + 추정 과차감 분(분 단위).
      */
      async holidayConsumptionReport() {
        return this.client.trpc.leaveRequest.holidayConsumptionReport.query();
      }
    }, __name(_a66, "_LeaveRequestService"), _a66);
    __name2(_LeaveRequestService, "LeaveRequestService");
    LeaveRequestService = _LeaveRequestService;
    _ManagementDashboardService = (_a67 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async laborCostByTeam(year, months) {
        return this.client.trpc.managementDashboard.laborCostByTeam.query({
          year,
          months
        });
      }
      async dailyLaborCost(year, month) {
        return this.client.trpc.managementDashboard.dailyLaborCost.query({
          year,
          month
        });
      }
      async incentiveSummary(year, month, page = 1, limit = 20) {
        return this.client.trpc.managementDashboard.incentiveSummary.query({
          year,
          month,
          page,
          limit
        });
      }
      /** IR-5 원장 당일 현황 — 오늘/어제 인센티브 발생 요약. */
      async incentiveDailySnapshot() {
        return this.client.trpc.managementDashboard.incentiveDailySnapshot.query();
      }
      async staffingOverview(date) {
        return this.client.trpc.managementDashboard.staffingOverview.query({
          date
        });
      }
      async teamLaborCost(year, month) {
        return this.client.trpc.managementDashboard.teamLaborCost.query({
          year,
          month
        });
      }
      /** 월별 청구 금액 목록 (연도 지정 시 그 해만) */
      async revenueList(year) {
        return this.client.trpc.managementDashboard.revenueList.query({
          year
        });
      }
      /** 월별 청구 금액 저장. claimAmount 0 → 해당 월 입력 취소(소프트 삭제). */
      async revenueUpsert(yearMonth, claimAmount) {
        return this.client.trpc.managementDashboard.revenueUpsert.mutate({
          yearMonth,
          claimAmount
        });
      }
      /** 월별 청구 금액 삭제 */
      async revenueRemove(yearMonth) {
        return this.client.trpc.managementDashboard.revenueRemove.mutate({
          yearMonth
        });
      }
    }, __name(_a67, "_ManagementDashboardService"), _a67);
    __name2(_ManagementDashboardService, "ManagementDashboardService");
    ManagementDashboardService = _ManagementDashboardService;
    _MessageService = (_a68 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(input) {
        return this.client.trpc.message.list.query(input);
      }
      async send(input) {
        return this.client.trpc.message.send.mutate(input);
      }
      async markRead(input) {
        return this.client.trpc.message.markRead.mutate(input);
      }
      /** 내가 보낸 메시지 삭제 — 참여자 전원 화면에서 「삭제된 메시지입니다」 자리 표시로 바뀐다 (MED-941) */
      async delete(input) {
        return this.client.trpc.message.delete.mutate(input);
      }
      /** 이모지 반응 토글(2026-10-20) — 같은 이모지를 다시 보내면 뺀다. 응답 `active` 가 붙었는지 */
      async react(input) {
        return this.client.trpc.message.react.mutate(input);
      }
      /** 대화방 고정 메시지(2026-10-20) — `messageId: null` 은 해제 */
      async pin(input) {
        return this.client.trpc.message.pin.mutate(input);
      }
      /** 방의 반응 전부 + 고정 메시지 — 방을 열 때 메시지 목록과 따로 한 번 읽는다 */
      async extras(input) {
        return this.client.trpc.message.extras.query(input);
      }
      async search(input) {
        return this.client.trpc.message.search.query(input);
      }
      async sendWithAttachments(input) {
        return this.client.trpc.message.sendWithAttachments.mutate(input);
      }
      /** 방 구독 — 새 메시지(kind 없음)·삭제(`deleted`)·읽음(`read`)·반응(`reaction`)·고정(`pinned`)이 같은 줄로 온다. */
      subscribeToMessages(conversationId, onData, onError, onStarted) {
        const subscription = this.client.trpc.message.onNewMessage.subscribe({
          conversationId
        }, {
          onStarted: /* @__PURE__ */ __name2(() => onStarted?.(), "onStarted"),
          onData: /* @__PURE__ */ __name2((data) => onData(data), "onData"),
          onError: /* @__PURE__ */ __name2((err) => onError?.(err), "onError")
        });
        return subscription;
      }
      subscribeToConversationUpdates(onData, onError) {
        const subscription = this.client.trpc.message.onConversationUpdate.subscribe(void 0, {
          onData: /* @__PURE__ */ __name2((data) => onData(data), "onData"),
          onError: /* @__PURE__ */ __name2((err) => onError?.(err), "onError")
        });
        return subscription;
      }
      /** 방 키 봉투 이벤트(2026-10-15) — 봉투 도착(envelopes)·봉투 요청(request). 직원 단위. */
      subscribeToChatKeyEvents(onData, onError) {
        const subscription = this.client.trpc.message.onChatKeyEvent.subscribe(void 0, {
          onData: /* @__PURE__ */ __name2((data) => onData(data), "onData"),
          onError: /* @__PURE__ */ __name2((err) => onError?.(err), "onError")
        });
        return subscription;
      }
      subscribeToReadSync(onData, onError) {
        const subscription = this.client.trpc.message.onReadSync.subscribe(void 0, {
          onData: /* @__PURE__ */ __name2((data) => onData(data), "onData"),
          onError: /* @__PURE__ */ __name2((err) => onError?.(err), "onError")
        });
        return subscription;
      }
    }, __name(_a68, "_MessageService"), _a68);
    __name2(_MessageService, "MessageService");
    MessageService = _MessageService;
    _ModuleRegistryService = (_a69 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list() {
        return this.client.trpc.moduleRegistry.list.query();
      }
    }, __name(_a69, "_ModuleRegistryService"), _a69);
    __name2(_ModuleRegistryService, "ModuleRegistryService");
    ModuleRegistryService = _ModuleRegistryService;
    NOTIFICATION_SETTINGS_CHANGED_EVENT = "hereby:notification-settings-changed";
    __name(announceSettingsChanged, "announceSettingsChanged");
    __name2(announceSettingsChanged, "announceSettingsChanged");
    _NotificationService = (_a70 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      // ── Preference Settings (sparse per-type per-channel matrix) ──
      /** Get all preference overrides for current user: { [eventType]: { [channel]: enabled } } */
      async getSettings() {
        return this.client.trpc.notification.getSettings.query();
      }
      /** Upsert a single preference: eventType + channel + enabled */
      async updateSettings(input) {
        const result = await this.client.trpc.notification.updateSettings.mutate(input);
        announceSettingsChanged();
        return result;
      }
      // ── Device Token ──
      /** 메신저 푸시 포맷(MED-893, D4) */
      async getMessengerPushFormat() {
        return this.client.trpc.notification.getMessengerPushFormat.query();
      }
      async updateMessengerPushFormat(format) {
        const result = await this.client.trpc.notification.updateMessengerPushFormat.mutate({
          format
        });
        announceSettingsChanged();
        return result;
      }
      /** 휴대폰 알림 방해 금지 시간(MED-967) — { start, end } HH:MM 또는 null(끔) */
      async getPushQuietHours() {
        return this.client.trpc.notification.getPushQuietHours.query();
      }
      async updatePushQuietHours(quietHours) {
        const result = await this.client.trpc.notification.updatePushQuietHours.mutate({
          quietHours
        });
        announceSettingsChanged();
        return result;
      }
      async registerDevice(input) {
        return this.client.trpc.deviceToken.register.mutate(input);
      }
      async unregisterDevice(input) {
        return this.client.trpc.deviceToken.unregister.mutate(input);
      }
      // ── Inbox (reads from NotificationDelivery joined with NotificationEvent) ──
      async getInbox(filter) {
        return this.client.trpc.notification.inboxList.query(filter);
      }
      async getUnreadCount() {
        const result = await this.client.trpc.notification.inboxUnreadCount.query();
        return result.count;
      }
      async markRead(id) {
        return this.client.trpc.notification.inboxMarkRead.mutate(id);
      }
      async markAllRead() {
        return this.client.trpc.notification.inboxMarkAllRead.mutate();
      }
      async dismiss(id) {
        return this.client.trpc.notification.inboxDismiss.mutate(id);
      }
      /** 알림함 새 행 실시간 구독 — WebSocket(tRPC subscription). 끊기면 onError, 호출부가 다시 건다. */
      subscribeToInbox(onData, onError) {
        return this.client.trpc.notification.onInbox.subscribe(void 0, {
          onData: /* @__PURE__ */ __name2((data) => onData(data), "onData"),
          onError: /* @__PURE__ */ __name2((err) => onError?.(err), "onError")
        });
      }
      async getActionItems() {
        return this.client.trpc.notification.actionItems.query();
      }
      // ── Mute Settings ──
      async getMuteList() {
        return this.client.trpc.notification.muteList.query();
      }
      async mute(input) {
        const result = await this.client.trpc.notification.muteCreate.mutate(input);
        announceSettingsChanged();
        return result;
      }
      async unmute(id) {
        const result = await this.client.trpc.notification.muteDelete.mutate(id);
        announceSettingsChanged();
        return result;
      }
    }, __name(_a70, "_NotificationService"), _a70);
    __name2(_NotificationService, "NotificationService");
    NotificationService = _NotificationService;
    _NurseSchedulerService = (_a71 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      // --- Ward (physical hospital unit, separate from Team) ---
      /**
      * `background: true` — 다른 화면(팀 수정 · 직원 수정)이 선택지를 채우려 배경으로 읽는 호출. 권한이 없어도
      * 권한 모달을 띄우지 않는다(호출부가 빈 목록으로 넘어간다).
      */
      async listWards(filter, opts) {
        return this.client.trpc.nurseScheduler.ward.list.query(filter, quietForbiddenContext(opts));
      }
      async getWard(id) {
        return this.client.trpc.nurseScheduler.ward.get.query(id);
      }
      async createWard(input) {
        return this.client.trpc.nurseScheduler.ward.create.mutate(input);
      }
      async updateWard(input) {
        return this.client.trpc.nurseScheduler.ward.update.mutate(input);
      }
      async deleteWard(id) {
        return this.client.trpc.nurseScheduler.ward.delete.mutate(id);
      }
      /** 병동 관리 「직원 배정」 미리보기 — 실행과 같은 입력으로 직원마다 바뀌는 것 · 부수 효과를 돌려준다(DB 변경 없음).
      *  읽기지만 mutation 이다 — 직원이 20명쯤 넘으면 GET URL 이 batch 링크 한도(1800자)를 넘어 요청이 아예 나가지 않는다. */
      async previewWardAssign(input) {
        return this.client.trpc.nurseScheduler.ward.assignPreview.mutate(input);
      }
      /** 병동 관리 「직원 배정」 실행 — 연결 팀 · 겸임/이동(지금 · 예약) · 근무 동반을 직원마다 한 번에 적용한다. */
      async assignEmployeesToWard(input) {
        return this.client.trpc.nurseScheduler.ward.assignEmployees.mutate(input);
      }
      /** 병동 배정 해제 — 고른 직원의 그 병동 배정만 끝낸다(팀 소속 · 근무는 그대로). 되살릴 id 를 결과에 담아 준다. */
      async unassignEmployeesFromWard(input) {
        return this.client.trpc.nurseScheduler.ward.unassignEmployees.mutate(input);
      }
      /** 해제 되돌리기 — 방금 끝낸 배정을 그대로 되살린다. */
      async restoreWardAssignments(input) {
        return this.client.trpc.nurseScheduler.ward.restoreAssignments.mutate(input);
      }
      // --- Schedule group (스케줄러 — 병동 안에서 근무표를 나누는 단위) ---
      /** 조직의 스케줄러 목록(병동 이름 포함). wardId 로 한 병동만. */
      async listScheduleGroups(filter, opts) {
        return this.client.trpc.nurseScheduler.scheduleGroup.list.query(filter, quietForbiddenContext(opts));
      }
      async getScheduleGroup(id) {
        return this.client.trpc.nurseScheduler.scheduleGroup.get.query(id);
      }
      async createScheduleGroup(input) {
        return this.client.trpc.nurseScheduler.scheduleGroup.create.mutate(input);
      }
      async updateScheduleGroup(input) {
        return this.client.trpc.nurseScheduler.scheduleGroup.update.mutate(input);
      }
      async deleteScheduleGroup(id) {
        return this.client.trpc.nurseScheduler.scheduleGroup.delete.mutate(id);
      }
      /** 스케줄러 편성 설정 — 교대 매핑(기본 시간대) · 지원 근무형태 · 교육 정책 · 포함 직군 */
      async getScheduleGroupSettings(scheduleGroupId) {
        return this.client.trpc.nurseScheduler.scheduleGroup.getSettings.query({
          scheduleGroupId
        });
      }
      async updateScheduleGroupSettings(input) {
        return this.client.trpc.nurseScheduler.scheduleGroup.updateSettings.mutate(input);
      }
      // --- Hospital-wide config ---
      async getConfig() {
        return this.client.trpc.nurseScheduler.config.get.query();
      }
      async updateConfig(input) {
        return this.client.trpc.nurseScheduler.config.update.mutate(input);
      }
      // --- Profile ---
      async listProfiles(filter, pagination) {
        return this.client.trpc.nurseScheduler.profile.list.query({
          filter,
          pagination
        });
      }
      async getProfile(employeeId, opts) {
        return this.client.trpc.nurseScheduler.profile.get.query(employeeId, quietForbiddenContext(opts));
      }
      /** 자동등록 후보 — 병동 연결 팀 소속원 + 직무 조건에 맞는 재직·휴직 직원 중 이 스케줄러 미등록자. */
      async listAutoRegisterCandidates(input) {
        return this.client.trpc.nurseScheduler.profile.autoRegisterCandidates.query(input);
      }
      async createProfile(input) {
        return this.client.trpc.nurseScheduler.profile.create.mutate(input);
      }
      async updateProfile(input) {
        return this.client.trpc.nurseScheduler.profile.update.mutate(input);
      }
      async deleteProfile(id) {
        return this.client.trpc.nurseScheduler.profile.delete.mutate(id);
      }
      // --- Ward reservation (예약 이동) ---
      async createWardReservation(input) {
        return this.client.trpc.nurseScheduler.reservation.create.mutate(input);
      }
      async updateWardReservation(input) {
        return this.client.trpc.nurseScheduler.reservation.update.mutate(input);
      }
      async cancelWardReservation(id) {
        return this.client.trpc.nurseScheduler.reservation.cancel.mutate(id);
      }
      // --- Schedule ---
      async listSchedules(filter, pagination) {
        return this.client.trpc.nurseScheduler.schedule.list.query({
          filter,
          pagination
        });
      }
      async getSchedule(id) {
        return this.client.trpc.nurseScheduler.schedule.get.query(id);
      }
      /** 스케줄러(없으면 병동 기본)·연·월의 최신 근무표(entries 포함) 1건 — 없으면 null. list+get 2왕복 대체. */
      async findScheduleByPeriod(input) {
        return this.client.trpc.nurseScheduler.schedule.findByPeriod.query(input);
      }
      async createSchedule(input) {
        return this.client.trpc.nurseScheduler.schedule.create.mutate(input);
      }
      async generateSchedule(scheduleId) {
        return this.client.trpc.nurseScheduler.schedule.generate.mutate({
          scheduleId
        });
      }
      async getGenerationStatus(scheduleId) {
        return this.client.trpc.nurseScheduler.schedule.generationStatus.query(scheduleId);
      }
      async cancelGeneration(scheduleId) {
        return this.client.trpc.nurseScheduler.schedule.cancelGeneration.mutate({
          scheduleId
        });
      }
      async confirmSchedule(scheduleId) {
        return this.client.trpc.nurseScheduler.schedule.confirm.mutate({
          scheduleId
        });
      }
      async publishSchedule(scheduleId) {
        return this.client.trpc.nurseScheduler.schedule.publish.mutate({
          scheduleId
        });
      }
      async revertScheduleToEditing(scheduleId) {
        return this.client.trpc.nurseScheduler.schedule.revertToEditing.mutate({
          scheduleId
        });
      }
      async deleteSchedule(id) {
        return this.client.trpc.nurseScheduler.schedule.delete.mutate(id);
      }
      // --- Entry ---
      async updateEntry(input) {
        return this.client.trpc.nurseScheduler.entry.update.mutate(input);
      }
      async batchUpdateEntries(input) {
        return this.client.trpc.nurseScheduler.entry.batchUpdate.mutate(input);
      }
      async batchDeleteEntries(input) {
        return this.client.trpc.nurseScheduler.entry.batchDelete.mutate(input);
      }
      async validateSchedule(scheduleId) {
        return this.client.trpc.nurseScheduler.entry.validate.query({
          scheduleId
        });
      }
      /** 겸임 중복 근무 — 이 근무표 직원이 같은 날 다른 근무표에도 근무로 배정된 셀(표시용, 저장은 막지 않음). */
      async getScheduleConflicts(scheduleId) {
        return this.client.trpc.nurseScheduler.entry.conflicts.query({
          scheduleId
        });
      }
      // --- Preference ---
      async listPreferences(filter, pagination) {
        return this.client.trpc.nurseScheduler.preference.list.query({
          filter,
          pagination
        });
      }
      async getMyPreference(year, month, employeeId) {
        return this.client.trpc.nurseScheduler.preference.get.query({
          year,
          month,
          employeeId
        });
      }
      async createPreference(input) {
        return this.client.trpc.nurseScheduler.preference.create.mutate(input);
      }
      async updatePreference(input) {
        return this.client.trpc.nurseScheduler.preference.update.mutate(input);
      }
      async submitPreference(id) {
        return this.client.trpc.nurseScheduler.preference.submit.mutate({
          id
        });
      }
      /** 수간호사가 종이 취합본을 대신 입력. (employeeId, year, month) upsert + SUBMITTED. */
      async upsertPreferenceByManager(input) {
        return this.client.trpc.nurseScheduler.preference.upsertByManager.mutate(input);
      }
      // --- WorkTypeChange ---
      async listWorkTypeChanges(filter, pagination) {
        return this.client.trpc.nurseScheduler.workTypeChange.list.query({
          filter,
          pagination
        });
      }
      async requestWorkTypeChange(input) {
        return this.client.trpc.nurseScheduler.workTypeChange.request.mutate(input);
      }
      async cancelWorkTypeChange(id) {
        return this.client.trpc.nurseScheduler.workTypeChange.cancel.mutate(id);
      }
      async approveWorkTypeChange(id) {
        return this.client.trpc.nurseScheduler.workTypeChange.approve.mutate({
          id
        });
      }
      async rejectWorkTypeChange(id, rejectionReason) {
        return this.client.trpc.nurseScheduler.workTypeChange.reject.mutate({
          id,
          rejectionReason
        });
      }
      // --- Ward Settings ---
      async getWardSettings(wardId) {
        return this.client.trpc.nurseScheduler.wardSettings.get.query({
          wardId
        });
      }
      async updateWardSettings(input) {
        return this.client.trpc.nurseScheduler.wardSettings.update.mutate(input);
      }
      // --- Daily Record ---
      async upsertDailyPatientCount(input) {
        return this.client.trpc.nurseScheduler.dailyRecord.upsert.mutate(input);
      }
      async getDailyPatientCount(wardId, date) {
        return this.client.trpc.nurseScheduler.dailyRecord.get.query({
          wardId,
          date
        });
      }
      async getDailyPatientCountRange(wardId, startDate, endDate) {
        return this.client.trpc.nurseScheduler.dailyRecord.getRange.query({
          wardId,
          startDate,
          endDate
        });
      }
    }, __name(_a71, "_NurseSchedulerService"), _a71);
    __name2(_NurseSchedulerService, "NurseSchedulerService");
    NurseSchedulerService = _NurseSchedulerService;
    _OffsiteWorkService = (_a73 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.offsiteWork.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.offsiteWork.get.query(id);
      }
      /** 외근 유형 목록 (활성) — 신청·보고서 유형 select 공통 사용 */
      async listTypes() {
        return this.client.trpc.offsiteWork.listTypes.query();
      }
      /** Admin 외근 유형 관리 — 전체 목록 (비활성 포함) */
      async listAllTypes() {
        return this.client.trpc.offsiteWork.listAllTypes.query();
      }
      async createType(input) {
        return this.client.trpc.offsiteWork.createType.mutate(input);
      }
      async updateType(input) {
        return this.client.trpc.offsiteWork.updateType.mutate(input);
      }
      async deleteType(id) {
        return this.client.trpc.offsiteWork.deleteType.mutate(id);
      }
      /** Works 외근 신청 */
      async request(input) {
        return this.client.trpc.offsiteWork.request.mutate(input);
      }
      /** Works: 대기 상태 외근 신청 취소 */
      async cancelRequest(id) {
        return this.client.trpc.offsiteWork.cancelRequest.mutate({
          id
        });
      }
      /** Works 외근 보고서 제출 — 시간·유형은 신청 기본값에서 수정 가능 */
      async submitReport(id, actualHours, summary, opts) {
        return this.client.trpc.offsiteWork.submitReport.mutate({
          id,
          actualHours,
          summary,
          startTime: opts?.startTime,
          endTime: opts?.endTime,
          typeId: opts?.typeId
        });
      }
      async approve(ids) {
        return this.client.trpc.offsiteWork.approve.mutate({
          ids
        });
      }
      /** Admin 일괄 반려 — 사유 필수 (이력 모달 표시용) */
      async reject(ids, reason) {
        return this.client.trpc.offsiteWork.reject.mutate({
          ids,
          reason
        });
      }
      /**
      * Admin: 승인 이후 단계 (APPROVED / REPORT_PENDING / REPORT_APPROVED) 외근 취소.
      * 사유 필수. 보고서 승인분에 부착됐던 attendance row 도 함께 무효화된다.
      */
      async cancelApproved(id, reason) {
        return this.client.trpc.offsiteWork.cancelApproved.mutate({
          id,
          reason
        });
      }
      /** Admin 보고서 일괄 승인 (REPORT_PENDING → REPORT_APPROVED) + 근태 반영 */
      async approveReport(ids) {
        return this.client.trpc.offsiteWork.approveReport.mutate({
          ids
        });
      }
      /** Admin 보고서 반려 (REPORT_PENDING → REPORT_REJECTED, 사유 필수) */
      async rejectReport(id, reason) {
        return this.client.trpc.offsiteWork.rejectReport.mutate({
          id,
          reason
        });
      }
      /** 이력 모달 — 결재자/결재일시/사유 entries 를 반환 */
      async history(id) {
        return this.client.trpc.offsiteWork.history.query(id);
      }
      /** 외근 건을 외근신청서 서식(A4 인쇄 HTML)으로 렌더링 */
      async renderForm(id) {
        return this.client.trpc.offsiteWork.renderForm.query(id);
      }
    }, __name(_a73, "_OffsiteWorkService"), _a73);
    __name2(_OffsiteWorkService, "OffsiteWorkService");
    OffsiteWorkService = _OffsiteWorkService;
    _OrganizationHolidayService = (_a74 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(year) {
        return this.client.trpc.organizationHoliday.list.query({
          year
        });
      }
      async create(input) {
        return this.client.trpc.organizationHoliday.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.organizationHoliday.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.organizationHoliday.delete.mutate({
          id
        });
      }
      /**
      * 국가 공휴일의 조직별 적용/제외 토글 — 제외하면 이 조직에서 유급휴일이 아니게 된다
      * (연차 차감 제외·신청 차단·휴일 분류에서 모두 빠짐 — 노동절을 일반 근무일로 쓰는 조직 등).
      * recurring=true면 매년 반복 제외(MM-DD 저장).
      */
      async setNationalHolidayApplied(input) {
        return this.client.trpc.organizationHoliday.setNationalHolidayApplied.mutate(input);
      }
      /**
      * 국가 공휴일 동기화 — 공공데이터포털 특일정보 API → national_holidays(판정 정본).
      * 대체공휴일·임시공휴일 발표 반영용. 연도 생략 시 작년·올해·내년을 동기화한다.
      */
      async syncNationalHolidays(years) {
        return this.client.trpc.organizationHoliday.syncNationalHolidays.mutate(years ? {
          years
        } : void 0);
      }
      /**
      * 연도별 준법 상태 — 빈 달력 경고(emptyCalendarWarning)·공휴일 제외 실효 여부·
      * 휴일근무 실효 모드(안전 폴백 반영)를 돌려준다. admin 경고 배너용.
      */
      async complianceStatus(year) {
        return this.client.trpc.organizationHoliday.complianceStatus.query({
          year
        });
      }
      async listSubstitutions(year) {
        return this.client.trpc.organizationHoliday.listSubstitutions.query(year ? {
          year
        } : void 0);
      }
      async upsertSubstitution(input) {
        return this.client.trpc.organizationHoliday.upsertSubstitution.mutate(input);
      }
      async deleteSubstitution(id) {
        return this.client.trpc.organizationHoliday.deleteSubstitution.mutate({
          id
        });
      }
      /** 기간 내 유급휴일 분류(휴일근로/휴일대체, 안전 폴백 반영) — 급여·스케줄 계층 전달용 */
      async classifyHolidayWork(startDate, endDate) {
        return this.client.trpc.organizationHoliday.classifyHolidayWork.query({
          startDate,
          endDate
        });
      }
    }, __name(_a74, "_OrganizationHolidayService"), _a74);
    __name2(_OrganizationHolidayService, "OrganizationHolidayService");
    OrganizationHolidayService = _OrganizationHolidayService;
    _OrganizationParameterService = (_a75 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(input = {}) {
        return this.client.trpc.organizationParameter.list.query(input);
      }
      async getValue(input) {
        return this.client.trpc.organizationParameter.getValue.query(input);
      }
      async create(input) {
        return this.client.trpc.organizationParameter.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.organizationParameter.update.mutate(input);
      }
      async delete(input) {
        return this.client.trpc.organizationParameter.delete.mutate(input);
      }
      async history(input) {
        return this.client.trpc.organizationParameter.history.query(input);
      }
    }, __name(_a75, "_OrganizationParameterService"), _a75);
    __name2(_OrganizationParameterService, "OrganizationParameterService");
    OrganizationParameterService = _OrganizationParameterService;
    _OrganizationService = (_a76 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /**
      * Create a new organization (public endpoint)
      * @param input Organization creation data including admin details
      * @returns Created organization and admin employee
      */
      async create(input) {
        return this.client.trpc.organization.create.mutate(input);
      }
      /**
      * Get organization by ID (super admin only)
      * @param id Organization ID
      * @returns Organization details
      */
      async getById(id) {
        return this.client.trpc.organization.getById.query({
          id
        });
      }
      /**
      * Get current organization
      * @returns Current organization details
      */
      async getCurrent() {
        return this.client.trpc.organization.getCurrent.query();
      }
      /**
      * 직원 앱 첫화면 레이아웃(병원별 카드 노출·순서) — 권한 관문 없음, 해석된 값
      */
      async getEmployeeHomeLayout() {
        return this.client.trpc.organization.getEmployeeHomeLayout.query();
      }
      /** 신청 시간 단위(분) — 연장·외근 신청/보고, 시간 단위 휴가의 시각 선택 간격(15/30/60, 기본 30 · MED-901) */
      async getRequestTimeStep() {
        return this.client.trpc.organization.getRequestTimeStep.query();
      }
      /** 직원 앱 화면 캡처 제한 켬/끔 — 권한 관문 없음, 해석된 값(설정 키가 없으면 켬) */
      async getScreenCaptureProtection() {
        return this.client.trpc.organization.getScreenCaptureProtection.query();
      }
      /**
      * List all organizations (super admin only)
      * @param query Query parameters for filtering and pagination
      * @returns Paginated list of organizations
      */
      async list(query) {
        return this.client.trpc.organization.list.query(query || {});
      }
      /**
      * Update organization
      * @param id Organization ID
      * @param data Update data
      * @returns Updated organization
      */
      async update(id, data) {
        return this.client.trpc.organization.update.mutate({
          id,
          data
        });
      }
      /**
      * Update organization settings
      * @param settings Settings to update
      * @returns Updated settings
      */
      async updateSettings(settings) {
        return this.client.trpc.organization.updateSettings.mutate({
          settings
        });
      }
      /**
      * Suspend organization (super admin only)
      * @param id Organization ID
      * @param reason Suspension reason
      * @returns Updated organization
      */
      async suspend(id, reason) {
        return this.client.trpc.organization.suspend.mutate({
          id,
          reason
        });
      }
      /**
      * Reactivate organization (super admin only)
      * @param id Organization ID
      * @returns Updated organization
      */
      async reactivate(id) {
        return this.client.trpc.organization.reactivate.mutate({
          id
        });
      }
      /**
      * Get organization statistics
      * @returns Organization statistics including employee counts, payroll totals, etc.
      */
      async getStatistics() {
        return this.client.trpc.organization.getStatistics.query();
      }
      /**
      * Delete organization (soft delete, super admin only)
      * @param id Organization ID
      * @param reason Deletion reason
      * @param confirmationCode Confirmation code
      * @returns Success status
      */
      async delete(id, reason, confirmationCode) {
        return this.client.trpc.organization.delete.mutate({
          id,
          reason,
          confirmationCode
        });
      }
    }, __name(_a76, "_OrganizationService"), _a76);
    __name2(_OrganizationService, "OrganizationService");
    OrganizationService = _OrganizationService;
    _OvertimeService = (_a77 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.overtime.list.query({
          filter,
          pagination
        });
      }
      /** 활성 연장근무 유형 목록 (Works 신청·보고서 select). 관리형 OvertimeType 마스터. */
      async listTypes() {
        return this.client.trpc.overtime.listTypes.query();
      }
      /** Admin 유형 관리 — 전체 유형(비활성 포함) + 사용 건수 */
      async listAllTypes() {
        return this.client.trpc.overtime.listAllTypes.query();
      }
      async createType(input) {
        return this.client.trpc.overtime.createType.mutate(input);
      }
      async updateType(input) {
        return this.client.trpc.overtime.updateType.mutate(input);
      }
      async deleteType(id) {
        return this.client.trpc.overtime.deleteType.mutate(id);
      }
      async get(id) {
        return this.client.trpc.overtime.get.query(id);
      }
      async create(input) {
        return this.client.trpc.overtime.create.mutate(input);
      }
      /** Employee self-service overtime request */
      async request(input) {
        return this.client.trpc.overtime.request.mutate(input);
      }
      /** Employee self-service: cancel overtime request */
      async cancelRequest(id) {
        return this.client.trpc.overtime.cancelRequest.mutate({
          id
        });
      }
      /** Employee self-service: request cancellation of an APPROVED overtime (기획서 §3.1) */
      async requestCancel(id, reason) {
        return this.client.trpc.overtime.requestCancel.mutate({
          id,
          reason
        });
      }
      /** Employee self-service: submit overtime report — shiftId로 유형 변경 가능 (승인 건이 기본값) */
      async submitReport(id, actualHours, summary, opts) {
        return this.client.trpc.overtime.submitReport.mutate({
          id,
          actualHours,
          summary,
          category: opts?.category
        });
      }
      async update(input) {
        return this.client.trpc.overtime.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.overtime.delete.mutate(id);
      }
      async approve(ids) {
        return this.client.trpc.overtime.approve.mutate({
          ids
        });
      }
    }, __name(_a77, "_OvertimeService"), _a77);
    __name2(_OvertimeService, "OvertimeService");
    OvertimeService = _OvertimeService;
    _PayrollService = (_a78 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.payroll.list.query({
          filter,
          pagination
        });
      }
      async getPayrollRecords(filters) {
        return this.client.trpc.payroll.list.query({
          filter: filters,
          pagination: filters
        });
      }
      async approvePayroll(payrollId) {
        return this.client.trpc.payroll.approve.mutate({
          payrollIds: [
            payrollId
          ]
        });
      }
      async processPayment(payrollId, paidAt) {
        return this.client.trpc.payroll.processPayment.mutate({
          payrollIds: [
            payrollId
          ],
          paymentDate: paidAt || /* @__PURE__ */ new Date(),
          paymentMethod: "bank_transfer"
        });
      }
      async generateForPeriod(year, month) {
        return this.client.trpc.payroll.generateForPeriod.mutate({
          period: {
            year,
            month
          }
        });
      }
      async refreshForPeriod(year, month) {
        return this.client.trpc.payroll.refreshForPeriod.mutate({
          period: {
            year,
            month
          }
        });
      }
      async bulkApprove(payrollIds, approverNotes) {
        return this.client.trpc.payroll.approve.mutate({
          payrollIds,
          approverNotes
        });
      }
      async generateSummary(year, month) {
        return this.client.trpc.payroll.summary.query({
          year,
          month
        });
      }
      async validate(year, month) {
        return this.client.trpc.payroll.validate.query({
          year,
          month
        });
      }
      async confirm(year, month, force) {
        return this.client.trpc.payroll.confirm.mutate({
          year,
          month,
          force
        });
      }
      async confirmByIds(payrollIds) {
        return this.client.trpc.payroll.confirmByIds.mutate({
          payrollIds
        });
      }
      /**
      * 이카운트 내보내기 미리보기(MED-934) — 이 급여대장의 집계 열을 시트 순서대로(열 이름·코드·합계),
      * 처음 체크를 끌 열 key(이 기간 마지막 내보내기 → 저장된 선택 → 기본급 계열).
      */
      async ecountExportPreview(year, month, sheetViewId) {
        return this.client.trpc.payroll.ecountExportPreview.query({
          year,
          month,
          sheetViewId
        });
      }
      async exportEcount(year, month, excludeConfigIds, sheetViewId, rememberSelection, excludeColumnKeys) {
        return this.client.trpc.payroll.exportEcount.mutate({
          year,
          month,
          excludeConfigIds,
          excludeColumnKeys,
          sheetViewId,
          rememberSelection
        });
      }
      async cancelConfirm(year, month) {
        return this.client.trpc.payroll.cancelConfirm.mutate({
          year,
          month
        });
      }
      async cancelConfirmByIds(payrollIds) {
        return this.client.trpc.payroll.cancelConfirmByIds.mutate({
          payrollIds
        });
      }
      /** Confirm one 급여대장 row → upsert a PayrollRecord snapshot from
      *  the row's aggregate cell totals. */
      async confirmLedgerRow(sheetViewId, sheetRowId) {
        return this.client.trpc.payroll.confirmLedgerRow.mutate({
          sheetViewId,
          sheetRowId
        });
      }
      /** Bulk 전체 확정 — confirms every eligible 급여대장 row in one shot. */
      async confirmAllLedgerRows(sheetViewId) {
        return this.client.trpc.payroll.confirmAllLedgerRows.mutate({
          sheetViewId
        });
      }
      /** Bulk 전체 취소 — flips every CONFIRMED row back to DRAFT. PAID rows skipped. */
      async cancelAllLedgerConfirmations(sheetViewId) {
        return this.client.trpc.payroll.cancelAllLedgerConfirmations.mutate({
          sheetViewId
        });
      }
      /** Revert `confirmLedgerRow` — CONFIRMED → DRAFT. PAID records refuse. */
      async cancelLedgerConfirmation(sheetViewId, sheetRowId) {
        return this.client.trpc.payroll.cancelLedgerConfirmation.mutate({
          sheetViewId,
          sheetRowId
        });
      }
      async sendToEmployee(payrollIds) {
        return this.client.trpc.payroll.sendToEmployee.mutate({
          payrollIds
        });
      }
      async adjustmentCheck(year, month) {
        return this.client.trpc.payroll.adjustmentCheck.query({
          year,
          month
        });
      }
      // biome-ignore lint/suspicious/noExplicitAny: Dynamic input from router schema
      async createTaxBracket(input) {
        return this.client.trpc.payroll.createTaxBracket.mutate(input);
      }
      async getActiveTaxBrackets(effectiveYear) {
        return this.client.trpc.payroll.getActiveTaxBrackets.query(effectiveYear);
      }
      // --- Cell Memo ---
      async createCellMemo(input) {
        return this.client.trpc.payrollCellMemo.create.mutate(input);
      }
      async resolveCellMemo(id) {
        return this.client.trpc.payrollCellMemo.resolve.mutate({
          id
        });
      }
      /** Edit an open memo's text (author-only, G-1). */
      async updateCellMemo(id, memo) {
        return this.client.trpc.payrollCellMemo.update.mutate({
          id,
          memo
        });
      }
      /** Soft-delete an open memo (author-only, G-1). */
      async deleteCellMemo(id) {
        return this.client.trpc.payrollCellMemo.delete.mutate({
          id
        });
      }
      async listCellMemos(year, month) {
        return this.client.trpc.payrollCellMemo.listForPeriod.query({
          year,
          month
        });
      }
      async cellMemoHistory(filter) {
        return this.client.trpc.payrollCellMemo.history.query(filter);
      }
      /** Sheet-cell-keyed memo create (workbook-rooted memos). */
      async createCellMemoForSheet(input) {
        return this.client.trpc.payrollCellMemo.createForCell.mutate(input);
      }
      /** All memos on a single sheet (workbook overlay + tooltips). */
      async listCellMemosForSheet(sheetViewId, status = "open") {
        return this.client.trpc.payrollCellMemo.listForSheet.query({
          sheetViewId,
          status
        });
      }
      /** OPEN-memo count for one sheet — toolbar 메모 이력 badge. */
      async unresolvedMemoCountForSheet(sheetViewId) {
        return this.client.trpc.payrollCellMemo.unresolvedCountForSheet.query({
          sheetViewId
        });
      }
    }, __name(_a78, "_PayrollService"), _a78);
    __name2(_PayrollService, "PayrollService");
    PayrollService = _PayrollService;
    _PermissionRequestService = (_a79 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /**
      * Submit an access permission request. Fires a notification to org admins
      * (users holding `employee:manage` / `employee:approve`) who can review
      * the request in their 알림 inbox.
      */
      async create(input) {
        return this.client.trpc.permissionRequest.create.mutate(input);
      }
    }, __name(_a79, "_PermissionRequestService"), _a79);
    __name2(_PermissionRequestService, "PermissionRequestService");
    PermissionRequestService = _PermissionRequestService;
    _RecurringAllowanceService = (_a80 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      list(input) {
        return this.client.trpc.recurringAllowance.list.query(input ?? {});
      }
      create(input) {
        return this.client.trpc.recurringAllowance.create.mutate(input);
      }
      /** 정정(같은 chain v+1) — 금액·라벨·종료일·메모 */
      correct(input) {
        return this.client.trpc.recurringAllowance.correct.mutate(input);
      }
      /** 종료 — validUntil 지정. 다음 달부터 시트에서 빠진다 */
      end(id, validUntil) {
        return this.client.trpc.recurringAllowance.end.mutate({
          id,
          validUntil
        });
      }
    }, __name(_a80, "_RecurringAllowanceService"), _a80);
    __name2(_RecurringAllowanceService, "RecurringAllowanceService");
    RecurringAllowanceService = _RecurringAllowanceService;
    _ResignationService = (_a81 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.resignation.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.resignation.get.query(id);
      }
      async create(input) {
        return this.client.trpc.resignation.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.resignation.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.resignation.delete.mutate(id);
      }
      // biome-ignore lint/suspicious/noExplicitAny: Dynamic input
      async simulateSettlement(input) {
        return this.client.trpc.resignation.simulateSettlement.query(input);
      }
      // biome-ignore lint/suspicious/noExplicitAny: Dynamic input
      async calculateSettlement(input) {
        return this.client.trpc.resignation.calculateSettlement.mutate(input);
      }
      async cancelSettlement(resignationId) {
        return this.client.trpc.resignation.cancelSettlement.mutate({
          resignationId
        });
      }
    }, __name(_a81, "_ResignationService"), _a81);
    __name2(_ResignationService, "ResignationService");
    ResignationService = _ResignationService;
    _RoleService = (_a83 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(query) {
        return this.client.trpc.role.list.query(query || {});
      }
      async getById(id) {
        return this.client.trpc.role.getById.query({
          id
        });
      }
      async create(input) {
        return this.client.trpc.role.create.mutate(input);
      }
      async update(id, data) {
        return this.client.trpc.role.update.mutate({
          id,
          data
        });
      }
      async delete(id) {
        return this.client.trpc.role.delete.mutate({
          id
        });
      }
      async listPermissions() {
        return this.client.trpc.role.listPermissions.query();
      }
      async updatePermissions(roleId, permissionIds) {
        return this.client.trpc.role.updatePermissions.mutate({
          roleId,
          permissionIds
        });
      }
    }, __name(_a83, "_RoleService"), _a83);
    __name2(_RoleService, "RoleService");
    RoleService = _RoleService;
    _SalaryGradeService = (_a84 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.salaryGrade.list.query({
          filter,
          pagination
        });
      }
      async availableYears() {
        return this.client.trpc.salaryGrade.availableYears.query();
      }
      async get(id) {
        return this.client.trpc.salaryGrade.get.query(id);
      }
      async create(input) {
        return this.client.trpc.salaryGrade.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.salaryGrade.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.salaryGrade.delete.mutate(id);
      }
      async getByCategory(filter) {
        return this.client.trpc.salaryGrade.getByCategory.query({
          filter
        });
      }
      async listEmployeeAssignments() {
        return this.client.trpc.salaryGrade.listEmployeeAssignments.query();
      }
      async assignGradeToEmployee(input) {
        return this.client.trpc.salaryGrade.assignGradeToEmployee.mutate(input);
      }
    }, __name(_a84, "_SalaryGradeService"), _a84);
    __name2(_SalaryGradeService, "SalaryGradeService");
    SalaryGradeService = _SalaryGradeService;
    _ScheduledActionService = (_a85 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      list(input) {
        return this.client.trpc.scheduledAction.list.query(input ?? {});
      }
      /** 관리 페이지 목록 — 서버가 시행월·소유자·검색까지 거르고 페이지로 자른다(총 건수·소유자 목록 포함). */
      page(input) {
        return this.client.trpc.scheduledAction.page.query(input);
      }
      /** 상세 — 변경 전 값·만든/적용한/취소한 사람·이관 이력. */
      detail(id) {
        return this.client.trpc.scheduledAction.detail.query(id);
      }
      /** 상단 요약 — 필터와 상관없는 실패·확인 대기·예약됨·7일 안 시행·이관 필요 건수. */
      summary() {
        return this.client.trpc.scheduledAction.summary.query();
      }
      /** 자동 처리 기록의 실패를 「확인함」으로 — 진행 중 목록·실패 건수에서 빠진다. */
      acknowledge(id) {
        return this.client.trpc.scheduledAction.acknowledge.mutate(id);
      }
      cancel(id) {
        return this.client.trpc.scheduledAction.cancel.mutate(id);
      }
      /** 시행일을 기다리지 않고 지금 실행 — FAILED 는 다시 실행. 권한은 소유자 기준으로 서버가 판정. */
      run(id) {
        return this.client.trpc.scheduledAction.run.mutate(id);
      }
      /** 「이 달에 시행되는 변경」(T9) — 예약 액션 + 원천 시행일 요약. payroll:read org-wide. */
      monthOverview(year, month) {
        return this.client.trpc.scheduledAction.monthOverview.query({
          year,
          month
        });
      }
      /** 승인(D7) — AI 제안(확인 대기)을 예약으로. 시행일이 오늘 이하면 바로 실행. */
      approve(id) {
        return this.client.trpc.scheduledAction.approve.mutate(id);
      }
      /** dry-run(T8) — 같은 코드를 끝까지 돌리고 롤백한 결과(영향·diff·확인 사유). */
      dryRun(id) {
        return this.client.trpc.scheduledAction.dryRun.mutate(id);
      }
      /** 소유자 이관(T8) — 새 소유자 권한으로 dry-run 이 통과해야 바뀐다. */
      transfer(id, toOwnerId) {
        return this.client.trpc.scheduledAction.transfer.mutate({
          id,
          toOwnerId
        });
      }
      /** 셀 예약 값(MED-825) — 「N월부터 이 칸은 X」. 시행월 시트가 이미 있으면 서버가 바로 실행해 결과 상태를 돌려준다. */
      createSheetCell(input) {
        return this.client.trpc.scheduledAction.createSheetCell.mutate(input);
      }
    }, __name(_a85, "_ScheduledActionService"), _a85);
    __name2(_ScheduledActionService, "ScheduledActionService");
    ScheduledActionService = _ScheduledActionService;
    _ScreenCaptureService = (_a86 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async report(input) {
        return this.client.trpc.screenCapture.report.mutate(input);
      }
      async list(input) {
        return this.client.trpc.screenCapture.list.query(input);
      }
    }, __name(_a86, "_ScreenCaptureService"), _a86);
    __name2(_ScreenCaptureService, "ScreenCaptureService");
    ScreenCaptureService = _ScreenCaptureService;
    _SearchHistoryService = (_a87 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 한 컨텍스트의 이력(사용 횟수·마지막 사용 시각 포함) */
      async list(input) {
        return this.client.trpc.searchHistory.list.query(input);
      }
      /** 검색어 사용 기록 — 민감 패턴이면 서버가 `saved: false` 로 저장하지 않는다 */
      async record(input) {
        return this.client.trpc.searchHistory.record.mutate(input);
      }
      /** 즐겨찾기(별) 켬/끔 — 고정된 검색어는 「자주 찾는 검색어」 맨 위에 남는다 */
      async pin(input) {
        return this.client.trpc.searchHistory.pin.mutate(input);
      }
      /** 검색어 한 줄 삭제 */
      async remove(input) {
        return this.client.trpc.searchHistory.remove.mutate(input);
      }
      /** 컨텍스트의 이력 전부 삭제 */
      async clear(input) {
        return this.client.trpc.searchHistory.clear.mutate(input);
      }
    }, __name(_a87, "_SearchHistoryService"), _a87);
    __name2(_SearchHistoryService, "SearchHistoryService");
    SearchHistoryService = _SearchHistoryService;
    _SecomEventService = (_a88 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async ingestEvents(events) {
        return this.client.trpc.secomEvent.ingestEvents.mutate({
          events
        });
      }
      async processPending() {
        return this.client.trpc.secomEvent.processPending.mutate();
      }
      async listEvents(filter) {
        return this.client.trpc.secomEvent.listEvents.query(filter || {});
      }
      async getEvent(id) {
        return this.client.trpc.secomEvent.getEvent.query({
          id
        });
      }
    }, __name(_a88, "_SecomEventService"), _a88);
    __name2(_SecomEventService, "SecomEventService");
    SecomEventService = _SecomEventService;
    _SecurityService = (_a89 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async overview() {
        return this.client.trpc.security.overview.query();
      }
      async sessions() {
        return this.client.trpc.security.sessions.query();
      }
      async revokeSession(input) {
        return this.client.trpc.security.revokeSession.mutate(input);
      }
      /** 패스키 전용 로그인 켜기/끄기 — 켜려면 등록된 키가 있어야 한다 */
      async setPasskeyOnly(input) {
        return this.client.trpc.security.setPasskeyOnly.mutate(input);
      }
      /** 현재 기기 외 모두 로그아웃 */
      async revokeOtherSessions() {
        return this.client.trpc.security.revokeOtherSessions.mutate();
      }
      async twoFactorSetupStart() {
        return this.client.trpc.security.twoFactorSetupStart.mutate();
      }
      async twoFactorSetupConfirm(input) {
        return this.client.trpc.security.twoFactorSetupConfirm.mutate(input);
      }
      async twoFactorDisable(input) {
        return this.client.trpc.security.twoFactorDisable.mutate(input);
      }
      /** 로그인 2단계 — 코드가 맞으면 세션을 심는다 */
      async verifyTwoFactor(input) {
        const result = await this.client.trpc.auth.verifyTwoFactor.mutate(input);
        this.client.setTokens(result.accessToken, result.refreshToken);
        return result;
      }
    }, __name(_a89, "_SecurityService"), _a89);
    __name2(_SecurityService, "SecurityService");
    SecurityService = _SecurityService;
    _SheetCellService = (_a90 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async set(input) {
        return this.client.trpc.sheetCell.set.mutate(input);
      }
      async clear(input) {
        return this.client.trpc.sheetCell.clear.mutate(input);
      }
      async batchSet(input) {
        return this.client.trpc.sheetCell.batchSet.mutate(input);
      }
      async batchClear(input) {
        return this.client.trpc.sheetCell.batchClear.mutate(input);
      }
      /**
      * Apply a style patch to one or more cells (Phase 3 formatting
      * toolbar). Patch fields with `null` clear that style attribute;
      * fields absent leave the existing value alone. Server creates a
      * style-only SheetCell row if the target doesn't exist yet — the
      * resolver still reads source-record values for the cell content;
      * the row only carries the formatting.
      */
      async setStyle(input) {
        return this.client.trpc.sheetCell.setStyle.mutate(input);
      }
      /**
      * 칸 하나의 값 변경 이력 (SHT-11) — 「누가·언제·얼마에서 얼마로」, 최신순.
      * 칸 상세 패널의 「변경 이력」 탭이 읽는다.
      */
      async history(input) {
        return this.client.trpc.sheetCell.history.query(input);
      }
      /**
      * 이력 한 줄 되돌리기 — 그 칸을 「바뀌기 전 값」으로 돌린다. 되돌린 것도
      * 이력에 남는다.
      */
      async revertChange(input) {
        return this.client.trpc.sheetCell.revertChange.mutate(input);
      }
      /**
      * 한 동작(붙여넣기 한 번)을 통째로 되돌린다. 그 사이 다른 사람이 고친 칸은
      * 건너뛰고 `skipped` 로 돌려준다.
      */
      async revertChangeBatch(input) {
        return this.client.trpc.sheetCell.revertChangeBatch.mutate(input);
      }
      /** 시트 전체의 값 변경 이력 — 「히스토리」 목록. */
      async sheetHistory(input) {
        return this.client.trpc.sheetCell.sheetHistory.query(input);
      }
      /** List every styled cell on a sheet — feeds the client style cache. */
      async listStyles(input) {
        return this.client.trpc.sheetCell.listStyles.query(input);
      }
    }, __name(_a90, "_SheetCellService"), _a90);
    __name2(_SheetCellService, "SheetCellService");
    SheetCellService = _SheetCellService;
    _SheetRowService = (_a91 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async create(input) {
        return this.client.trpc.sheetRow.create.mutate(input);
      }
      /**
      * Bulk-create rows in one round-trip. Prefer this over
      * `Promise.all(rows.map(create))` — the parallel path batches into a
      * single tRPC URL that exceeds the path-length limit past ~30 rows.
      */
      /** 행 추가 「부서 / 팀」 후보 — 고른 팀(하위 팀 포함)의 재직 직원, 이미 있는 행·입사일 가드 표시 */
      async teamMemberCandidates(input) {
        return this.client.trpc.sheetRow.teamMemberCandidates.query(input);
      }
      async batchCreate(input) {
        return this.client.trpc.sheetRow.batchCreate.mutate(input);
      }
      async update(input) {
        return this.client.trpc.sheetRow.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.sheetRow.delete.mutate({
          id
        });
      }
      /** 삭제한 행 되살리기 — 실행취소(⌘Z)가 부른다. */
      async restore(id) {
        return this.client.trpc.sheetRow.restore.mutate({
          id
        });
      }
      /** 여러 행 한 번에 삭제(MED-835). 같은 시트의 수동 행만. */
      async batchDelete(input) {
        return this.client.trpc.sheetRow.batchDelete.mutate(input);
      }
      /** 여러 행 되살리기 — 일괄 삭제의 실행취소. */
      async batchRestore(input) {
        return this.client.trpc.sheetRow.batchRestore.mutate(input);
      }
      async reorder(input) {
        return this.client.trpc.sheetRow.reorder.mutate(input);
      }
      /**
      * 시트 및 범위 보호 — toggle row-level protection on a single
      * SheetRow. When `locked: true`, record-update mutations touching
      * this row are rejected by assertSheetRowNotLocked. Cleared by
      * `setLock({ locked: false })`.
      */
      /** text→식별 전환 시 직원 자동 매핑 (B-4) — 일치 행 연결 + 미일치 사유 반환. */
      async linkEmployeesFromColumn(input) {
        return this.client.trpc.sheetRow.linkEmployeesFromColumn.mutate(input);
      }
      async setLock(input) {
        return this.client.trpc.sheetRow.setLock.mutate(input);
      }
      /** List every protected SheetRow on a sheet — drives the protection modal. */
      async listProtected(input) {
        return this.client.trpc.sheetRow.listProtected.query(input);
      }
    }, __name(_a91, "_SheetRowService"), _a91);
    __name2(_SheetRowService, "SheetRowService");
    SheetRowService = _SheetRowService;
    _SheetTemplateService = (_a93 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** List system + org templates, optionally narrowed by kind. */
      async list(input = {}) {
        return this.client.trpc.sheetTemplate.list.query(input);
      }
      async get(id) {
        return this.client.trpc.sheetTemplate.get.query({
          id
        });
      }
      async create(input) {
        return this.client.trpc.sheetTemplate.create.mutate(input);
      }
      /** Clone an existing sheet's settings into a new template. */
      async saveSheetAsTemplate(input) {
        return this.client.trpc.sheetTemplate.saveSheetAsTemplate.mutate(input);
      }
      /**
      * Apply a template — creates a new SheetView for the given period.
      * Calls the `applyToPeriod` procedure because tRPC reserves `apply` as
      * a router key (Function-prototype name collision).
      */
      async apply(input) {
        return this.client.trpc.sheetTemplate.applyToPeriod.mutate(input);
      }
      /**
      * Apply every member of a template set (퇴사 정산 등) for one period.
      * Transactional on the server — partial set = no set. Returns
      * `{ sheets, count }` with created/reused sheets in member order.
      */
      async applySet(input) {
        return this.client.trpc.sheetTemplate.applySet.mutate(input);
      }
      async update(input) {
        return this.client.trpc.sheetTemplate.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.sheetTemplate.delete.mutate({
          id
        });
      }
      // ── 병원 공통 수식 템플릿 (UP-002-S2-b) ──────────────────────────
      /** 우리 병원 수식 템플릿 목록. */
      async listFormulaTemplates() {
        return this.client.trpc.sheetTemplate.listFormulaTemplates.query();
      }
      /** 현재 수식을 병원 공통 템플릿으로 저장 (급여 관리 권한자). */
      async createFormulaTemplate(input) {
        return this.client.trpc.sheetTemplate.createFormulaTemplate.mutate(input);
      }
      /** 병원 공통 수식 템플릿 삭제 (급여 관리 권한자). */
      async deleteFormulaTemplate(id) {
        return this.client.trpc.sheetTemplate.deleteFormulaTemplate.mutate({
          id
        });
      }
      // ── 열 북마크 (MED-845) ───────────────────────────────────────────
      /** 우리 병원 열 북마크 목록 — 수식 편집기 「북마크한 열」 칩. */
      async listColumnBookmarks() {
        return this.client.trpc.sheetTemplate.listColumnBookmarks.query();
      }
      /** 열 북마크 추가 (급여 관리 권한자). 같은 열이 이미 있으면 그 행을 돌려준다. */
      async createColumnBookmark(input) {
        return this.client.trpc.sheetTemplate.createColumnBookmark.mutate(input);
      }
      /** 열 북마크 삭제 (급여 관리 권한자). */
      async deleteColumnBookmark(id) {
        return this.client.trpc.sheetTemplate.deleteColumnBookmark.mutate({
          id
        });
      }
    }, __name(_a93, "_SheetTemplateService"), _a93);
    __name2(_SheetTemplateService, "SheetTemplateService");
    SheetTemplateService = _SheetTemplateService;
    _SheetViewService = (_a94 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /**
      * List sheets for a (year, month). Auto-upserts defaults on first visit.
      * Returns shared sheets + the caller's private sheets.
      */
      async list(input) {
        return this.client.trpc.sheetView.list.query(input);
      }
      /** Get a single sheet by id (with config links). */
      async get(id) {
        return this.client.trpc.sheetView.get.query({
          id
        });
      }
      /** Treatment-catalog item list for format="treatmentcount" pickers. */
      async treatmentCatalog() {
        return this.client.trpc.sheetView.treatmentCatalog.query();
      }
      /**
      * Sync a category 치료일 sheet from its fixed_incentive session
      * records (one row per sessionId). Idempotent — safe on every open.
      */
      async syncTreatmentSessions(id) {
        return this.client.trpc.sheetView.syncTreatmentSessions.mutate({
          id
        });
      }
      /** Export a sheet's layout + ref hints as a portable template. */
      async exportTemplate(id) {
        return this.client.trpc.sheetView.exportTemplate.query({
          id
        });
      }
      /** Create a new sheet from an exported template payload. */
      async importTemplate(input) {
        return this.client.trpc.sheetView.importTemplate.mutate(input);
      }
      /**
      * Upload a CSV / XLSX file to create a sheet populated with the file's
      * rows. Distinct from `importTemplate` (which imports the sheet SHAPE
      * from a JSON template, zero data) — this imports DATA only and
      * infers a minimal column layout from the header row.
      */
      async importData(input) {
        return this.client.trpc.sheetView.importData.mutate(input);
      }
      /** Create a custom sheet. */
      async create(input) {
        return this.client.trpc.sheetView.create.mutate(input);
      }
      /** Update sheet name / visibility / layout / filters / configs. */
      async update(input) {
        return this.client.trpc.sheetView.update.mutate(input);
      }
      /** Soft delete. Defaults re-upsert on next list(). */
      async delete(id) {
        return this.client.trpc.sheetView.delete.mutate({
          id
        });
      }
      /**
      * Trash inbox — every soft-deleted sheet the caller had permission to
      * delete (scoped by visibility the same way `delete` is). Spans every
      * period because users typically remember "I deleted that yesterday",
      * not "I deleted that for January". Newest-deleted first.
      */
      async listTrashed() {
        return this.client.trpc.sheetView.listTrashed.query();
      }
      /** Restore a soft-deleted sheet (clears deletedAt). */
      async restore(id) {
        return this.client.trpc.sheetView.restore.mutate({
          id
        });
      }
      /**
      * Ensure the sheet has a slug (formula-ref anchor). Idempotent —
      * returns the existing slug or assigns a generated custom_* one.
      */
      async ensureSlug(id) {
        return this.client.trpc.sheetView.ensureSlug.mutate({
          id
        });
      }
      /** Idempotent default upsert for a (year, month). */
      async ensureDefaults(input) {
        return this.client.trpc.sheetView.ensureDefaults.mutate(input);
      }
      /** Carry shared customs from one period to another. */
      async carryForward(input) {
        return this.client.trpc.sheetView.carryForward.mutate(input);
      }
      /**
      * Read-only carry-forward preview — what would be created without
      * committing. Powers the confirmation modal before calling carryForward.
      */
      /**
      * 상시 시트 새 버전 — (year, month) 부터 적용되는 사본(행·셀 포함). 그 달부터는
      * 새 버전이 보이고 참조되며, 이전 달은 예전 버전을 그대로 읽는다.
      */
      async createEvergreenVersion(input) {
        return this.client.trpc.sheetView.createEvergreenVersion.mutate(input);
      }
      async carryForwardPreview(input) {
        return this.client.trpc.sheetView.carryForwardPreview.query(input);
      }
      /**
      * Cross-sheet search inside a period — returns the sheets that have rows
      * matching the query, with per-sheet match counts.
      */
      async searchAcrossPeriod(input) {
        return this.client.trpc.sheetView.searchAcrossPeriod.query(input);
      }
      /**
      * Manually lock or unlock a sheet (separate from period freeze).
      * 잠금 해제는 작업 완료 표시도 함께 해제하며, 그 경우 응답의
      * `workDoneCleared` 가 true 로 온다.
      */
      async setLock(input) {
        return this.client.trpc.sheetView.setLock.mutate(input);
      }
      /**
      * 시트 작업 완료 표시 토글. 완료는 잠금을 포함하므로 done=true 는
      * 잠금까지 함께 걸고, done=false 는 둘 다 해제한다. 잠금만 따로
      * 걸려면 setLock 을 쓴다.
      */
      async setWorkDone(input) {
        return this.client.trpc.sheetView.setWorkDone.mutate(input);
      }
      /**
      * [설정 완료] — 시트 수명주기 설정 중 → 사용 중 전이 (UP-008).
      * 완료하면 구조 변경이 서버에서도 잠기고 이력에 기록이 남는다.
      * 이미 사용 중이면 `alreadyActive: true` 로 멱등 성공한다.
      */
      async completeSetup(input) {
        return this.client.trpc.sheetView.completeSetup.mutate(input);
      }
      /**
      * 「시트 재설정」 — 사용 중 → 설정 중 복귀. 완료(workDone)·보호(locked)
      * 시트는 먼저 그 잠금을 풀어야 하며, 실행 이력이 남는다.
      */
      async reopenSetup(input) {
        return this.client.trpc.sheetView.reopenSetup.mutate(input);
      }
      /** 설정 완료/재설정 이력 (히스토리 드로어 리스트, 최신순 + 실행자 이름). */
      async listSetupEvents(input) {
        return this.client.trpc.sheetView.listSetupEvents.query(input);
      }
      /**
      * Set or clear the sheet's auto-populate rule. Pass `rule: null` to
      * turn it off (sheet stays pure manual). Next `queryRows` runs the
      * executor and materializes auto rows from the source table.
      */
      async setAutoPopulate(input) {
        return this.client.trpc.sheetView.setAutoPopulate.mutate(input);
      }
      /**
      * Set or clear the sheet's compute config — which codeModule runs on
      * "🧮 계산 실행", with what parameters, and which column / rate config
      * it commits into. Pass `config: null` to disable.
      */
      async setComputeConfig(input) {
        return this.client.trpc.sheetView.setComputeConfig.mutate(input);
      }
      /**
      * Run the codeModule against the sheet's rows. Writes the output
      * values into cells whose column has `kind="computed"` + a matching
      * `computedKey`. User overrides (literal cells) are preserved.
      */
      async runCompute(input) {
        return this.client.trpc.sheetView.runCompute.mutate(input);
      }
      /**
      * Commit the sheet's resolved values to allowance / deduction records.
      * Upserts by `(sourceSheetId, sourceSheetRowId)` lineage — running
      * twice updates the records in place.
      */
      async commitToRecords(input) {
        return this.client.trpc.sheetView.commitToRecords.mutate(input);
      }
      /**
      * Commit-status summary for the sheet header — last commit time, who
      * committed, and whether any row/cell changed since (the "변경됨"
      * flag). Read-only; safe to poll on sheet open / after edits.
      */
      async commitStatus(input) {
        return this.client.trpc.sheetView.commitStatus.query(input);
      }
      /**
      * Source sheets feeding a 급여대장 + each one's commit status — powers
      * the "전체 커밋" hover detail (어떤 시트가 아직 커밋 안 됐는지).
      */
      async ledgerCommitSources(input) {
        return this.client.trpc.sheetView.ledgerCommitSources.query(input);
      }
      /** "전체 커밋" — commit every source sheet feeding a 급여대장 at once. */
      async commitLedgerSources(input) {
        return this.client.trpc.sheetView.commitLedgerSources.mutate(input);
      }
      /**
      * Commit a master-data sheet's literal-cell overrides back to the
      * source entity table (호봉 정의 → salary_grades, 인센티브 프리셋 →
      * incentive_presets). Updates rows by `sourceRecordId` and clears
      * the literal cells on success so the sheet falls back to live
      * source values on next resolve.
      *
      * No-op for sheets that aren't master-data system templates.
      */
      async commitMasterOverrides(input) {
        return this.client.trpc.sheetView.commitMasterOverrides.mutate(input);
      }
      /**
      * XLSX export. Pass `sheetId` for a single tab, or `year`+`month` for
      * the whole period. Returns `{ filename, base64 }` so the caller can
      * trigger a download.
      */
      async exportXlsx(input) {
        return this.client.trpc.sheetView.exportXlsx.query(input);
      }
      /**
      * The hot path — fetch the row data for a sheet (live join).
      * Returns one row per record, or one empty row per employee with no
      * records this period.
      */
      async queryRows(id) {
        return this.client.trpc.sheetView.queryRows.query({
          id
        });
      }
      /**
      * Paginated row fetch for large sheets. Returns `{ rows, totalCount,
      * offset, limit }`; the workbook adapter uses this to paint a first
      * batch fast (500 rows by default) and stream the rest in the
      * background. The materializers (autoPopulate, column-level
      * sourceTable) only run on the first page (offset 0).
      */
      async queryRowsPage(input) {
        return this.client.trpc.sheetView.queryRowsPage.query(input);
      }
      /* ── 접근 권한 (팀·개인 공유) — docs/internal/design-sheet-access-control.md ── */
      /** 시트의 grant 목록 + 내 역할. 읽을 수 있는 시트면 누구나. */
      async listGrants(sheetViewId) {
        return this.client.trpc.sheetView.listGrants.query({
          sheetViewId
        });
      }
      /** grant 추가·역할 변경(upsert). 시트 editor 필요. */
      async setGrant(input) {
        return this.client.trpc.sheetView.setGrant.mutate(input);
      }
      /** grant 회수. 시트 editor 필요. */
      async removeGrant(grantId) {
        return this.client.trpc.sheetView.removeGrant.mutate({
          grantId
        });
      }
    }, __name(_a94, "_SheetViewService"), _a94);
    __name2(_SheetViewService, "SheetViewService");
    SheetViewService = _SheetViewService;
    _ShiftGroupService = (_a95 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 근무 그룹 목록 (하위 근무 유형 중첩 포함) */
      async list() {
        return this.client.trpc.shiftGroup.list.query();
      }
      async create(input) {
        return this.client.trpc.shiftGroup.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.shiftGroup.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.shiftGroup.delete.mutate(id);
      }
    }, __name(_a95, "_ShiftGroupService"), _a95);
    __name2(_ShiftGroupService, "ShiftGroupService");
    ShiftGroupService = _ShiftGroupService;
    _ShiftService = (_a96 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 근무 유형 목록. `{ schedulerOnly: true }` 로 스케줄러 연동 그룹의 활성 유형만 받는다. */
      async list(input) {
        return this.client.trpc.shift.list.query(input);
      }
      /** 근무시간 자기 선택용 — org 시프트 목록 + 최근 출근 기록 기반 추천 */
      async recommendForMe() {
        return this.client.trpc.shift.recommendForMe.query();
      }
      /** 본인 근무시간 확정 (self-only — 별도 권한 불필요) */
      async setMyShift(shiftId) {
        return this.client.trpc.shift.setMyShift.mutate({
          shiftId
        });
      }
      async create(input) {
        return this.client.trpc.shift.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.shift.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.shift.delete.mutate(id);
      }
    }, __name(_a96, "_ShiftService"), _a96);
    __name2(_ShiftService, "ShiftService");
    ShiftService = _ShiftService;
    _SignupService = (_a97 = class {
      constructor(client) {
        __publicField(this, "client");
        __publicField(this, "logger");
        __publicField(this, "publicKeyPem", null);
        this.client = client;
        this.logger = sdkLogger.createServiceLogger("SignupService");
      }
      async encrypt(password) {
        try {
          if (!this.publicKeyPem) {
            const result = await this.client.trpc.auth.publicKey.query();
            this.publicKeyPem = result.publicKeyPem;
          }
          return await encryptPassword(password, this.publicKeyPem);
        } catch (error) {
          this.logger.warn({
            error
          }, "Password encryption unavailable, falling back to plaintext");
          return password;
        }
      }
      /** 1단계: 관리자 정보 + 기업명 → PENDING Account 생성 + 인증 메일 발송 */
      async start(params) {
        const encryptedParams = {
          ...params,
          password: await this.encrypt(params.password)
        };
        const result = await this.client.trpc.signup.start.mutate(encryptedParams);
        this.logger.info({
          email: params.email
        }, "Signup started");
        return result;
      }
      /** 인증 메일 재발송 */
      async resend(email) {
        return this.client.trpc.signup.resend.mutate({
          email
        });
      }
      /** 2단계: 이메일 토큰 + 비밀번호 재입력 → 인증 완료 + account 세션 발급 */
      async verify(token, password) {
        const result = await this.client.trpc.signup.verify.mutate({
          token,
          password: await this.encrypt(password)
        });
        this.client.setTokens(result.accessToken, result.refreshToken);
        this.logger.info("Signup email verified");
        return result;
      }
    }, __name(_a97, "_SignupService"), _a97);
    __name2(_SignupService, "SignupService");
    SignupService = _SignupService;
    _StorageService = (_a98 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** Request a presigned upload URL from the API */
      async getUploadUrl(filename, contentType, category, conversationId, size) {
        return this.client.trpc.storage.getUploadUrl.mutate({
          filename,
          contentType,
          category,
          ...conversationId && {
            conversationId
          },
          ...typeof size === "number" ? {
            size
          } : {}
        });
      }
      /** 프로필 사진 URL 묶음(최대 300개) — 목록 아바타용. 없는 키는 빠진다 */
      async getProfilePictureUrls(keys) {
        if (keys.length === 0) {
          return {};
        }
        const { urls } = await this.client.trpc.storage.getProfilePictureUrls.query({
          keys
        });
        return urls;
      }
      /** Get a presigned download URL for a stored file */
      async getDownloadUrl(key) {
        return this.client.trpc.storage.getDownloadUrl.query({
          key
        });
      }
      /**
      * 진행률이 있는 업로드(2026-10-20) — fetch 는 올리는 쪽 진행률을 주지 않아 XMLHttpRequest 로 PUT 한다.
      * `onProgress(loaded, total)` 은 바이트 단위, `signal` 로 취소(AbortError).
      */
      async uploadFileWithProgress(file, category, conversationId, contentType, onProgress, signal) {
        const filename = file.name || "file";
        const { url, key } = await this.getUploadUrl(filename, contentType, category, conversationId, file.size);
        if (signal?.aborted) {
          throw Object.assign(new Error("aborted"), {
            name: "AbortError"
          });
        }
        await new Promise((resolve2, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open("PUT", url);
          xhr.setRequestHeader("Content-Type", contentType);
          xhr.upload.onprogress = (e) => {
            if (e.lengthComputable) {
              onProgress?.(e.loaded, e.total);
            }
          };
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              onProgress?.(file.size, file.size);
              resolve2();
            } else {
              reject(new Error(`S3 upload failed: ${xhr.status}`));
            }
          };
          xhr.onerror = () => reject(new Error("S3 upload failed: network"));
          xhr.onabort = () => reject(Object.assign(new Error("aborted"), {
            name: "AbortError"
          }));
          signal?.addEventListener("abort", () => xhr.abort(), {
            once: true
          });
          xhr.send(file);
        });
        return {
          key
        };
      }
      /**
      * Upload a file directly to S3 via presigned URL.
      * Handles the full flow: get presigned URL → PUT file to S3.
      */
      async uploadFile(file, category, conversationId, contentType) {
        const effectiveType = contentType || file.type;
        const { url, key } = await this.getUploadUrl(file.name, effectiveType, category, conversationId, file.size);
        const response = await fetch(url, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": effectiveType
          }
        });
        if (!response.ok) {
          throw new Error(`S3 upload failed: ${response.status} ${response.statusText}`);
        }
        return {
          key
        };
      }
    }, __name(_a98, "_StorageService"), _a98);
    __name2(_StorageService, "StorageService");
    StorageService = _StorageService;
    _TeamDriveService = (_a99 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 조직의 전체 폴더 목록 */
      async listFolders() {
        return this.client.trpc.teamDrive.listFolders.query();
      }
      /** 특정 위치(folderId 미지정 = 루트)의 파일 목록 */
      async listFiles(input) {
        return this.client.trpc.teamDrive.listFiles.query(input ?? {});
      }
      /** 폴더 생성 */
      async createFolder(input) {
        return this.client.trpc.teamDrive.createFolder.mutate(input);
      }
      /** 업로드 완료된 파일 메타데이터 등록 (presigned PUT 이후) */
      async createFile(input) {
        return this.client.trpc.teamDrive.createFile.mutate(input);
      }
      /** 폴더 이름·설명 수정 (상위 변경은 moveItems) */
      async updateFolder(input) {
        return this.client.trpc.teamDrive.updateFolder.mutate(input);
      }
      /** 파일 이름 변경 — 확장자는 허용 목록 안이어야 한다 */
      async renameFile(input) {
        return this.client.trpc.teamDrive.renameFile.mutate(input);
      }
      /** 폴더·파일 삭제(소프트) — 폴더는 하위까지. 단건도 길이 1 배열로 */
      async deleteItems(input) {
        return this.client.trpc.teamDrive.deleteItems.mutate(input);
      }
      /* ── 휴지통 ── */
      /** 휴지통 목록 — 묶음의 꼭대기만 (관리자는 전체, 그 외는 본인이 지운 것) */
      async listTrash() {
        return this.client.trpc.teamDrive.listTrash.query();
      }
      /** 복원 — 같은 묶음의 하위 폴더·파일·공유 링크·grant 까지. 원래 위치가 없으면 루트로 */
      async restoreItems(input) {
        return this.client.trpc.teamDrive.restoreItems.mutate(input);
      }
      /** 영구 삭제 — DB 행과 스토리지 오브젝트까지. 되돌릴 수 없다 */
      async purgeItems(input) {
        return this.client.trpc.teamDrive.purgeItems.mutate(input);
      }
      /** 휴지통 비우기 — 내가 볼 수 있는 항목 전부 영구 삭제 */
      async emptyTrash() {
        return this.client.trpc.teamDrive.emptyTrash.mutate();
      }
      /** 폴더·파일 이동 — targetFolderId null = 루트. 단건도 길이 1 배열로 */
      async moveItems(input) {
        return this.client.trpc.teamDrive.moveItems.mutate(input);
      }
      /**
      * 파일 URL 발급 — 서버가 권한(접근 role 또는 공유 토큰)을 검사하고 **2분짜리 티켓**이 붙은
      * 브로커 URL(`/drive/files/:id/content?ticket=…`)을 준다. 헤더를 못 붙이는 자리(새 탭·네이티브
      * 열기)에만 쓰고, 화면 안 미리보기·다운로드는 fetchFileBlob 을 쓴다. presigned URL 은 더 이상 없다.
      */
      async getDownloadUrl(input) {
        const result = await this.client.trpc.teamDrive.getDownloadUrl.query(input);
        return {
          ...result,
          url: `${this.client.getBaseUrl()}${result.path}`
        };
      }
      /**
      * 파일 바이트를 Bearer 인증으로 받아 Blob 으로 돌려준다 — 브로커 라우트가 요청마다 로그인·권한을
      * 검사한다. 미리보기(`URL.createObjectURL`)·다운로드에 쓴다. 공유 링크로 진입했으면 shareToken 을 넘긴다.
      */
      async fetchFileBlob(fileId, shareToken) {
        const token = this.client.getAccessToken();
        const query = shareToken ? `?share=${encodeURIComponent(shareToken)}` : "";
        const response = await fetch(`${this.client.getBaseUrl()}/drive/files/${encodeURIComponent(fileId)}/content${query}`, {
          headers: token ? {
            Authorization: `Bearer ${token}`
          } : {}
        });
        if (!response.ok) {
          let message = "\uD30C\uC77C\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694.";
          try {
            const body = await response.json();
            if (body?.error) {
              message = body.error;
            }
          } catch {
          }
          throw new Error(message);
        }
        return response.blob();
      }
      /* ── 접근 제어 (권한 관리) ── */
      async setAccessMode(input) {
        return this.client.trpc.teamDrive.setAccessMode.mutate(input);
      }
      async listGrants(input) {
        return this.client.trpc.teamDrive.listGrants.query(input);
      }
      async addGrant(input) {
        return this.client.trpc.teamDrive.addGrant.mutate(input);
      }
      async removeGrant(grantId) {
        return this.client.trpc.teamDrive.removeGrant.mutate({
          grantId
        });
      }
      /* ── 공유 링크 ── */
      async createShareLink(input) {
        return this.client.trpc.teamDrive.createShareLink.mutate(input);
      }
      async listShareLinks(fileId) {
        return this.client.trpc.teamDrive.listShareLinks.query({
          fileId
        });
      }
      async revokeShareLink(linkId) {
        return this.client.trpc.teamDrive.revokeShareLink.mutate({
          linkId
        });
      }
      async resolveShareLink(token) {
        return this.client.trpc.teamDrive.resolveShareLink.query({
          token
        });
      }
    }, __name(_a99, "_TeamDriveService"), _a99);
    __name2(_TeamDriveService, "TeamDriveService");
    TeamDriveService = _TeamDriveService;
    _TeamManagerService = (_a100 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async dashboard() {
        return this.client.trpc.teamManager.dashboard.query();
      }
      async recentActivity() {
        return this.client.trpc.teamManager.recentActivity.query();
      }
      async myTeams() {
        return this.client.trpc.teamManager.myTeams.query();
      }
      async teamMembers(teamId) {
        return this.client.trpc.teamManager.teamMembers.query({
          teamId
        });
      }
      // Leave requests
      async listLeaveRequests(input) {
        return this.client.trpc.teamManager.leaveRequest.list.query(input ?? {});
      }
      /** 휴가 승인 — confirmOveruse(MED-968): 초과 사용 확인 정책에서 잔여보다 많은 신청을 확인하고 승인할 때 true */
      async approveLeaveRequests(ids, opts = {}) {
        return this.client.trpc.teamManager.leaveRequest.approve.mutate({
          ids,
          confirmOveruse: opts.confirmOveruse
        });
      }
      async rejectLeaveRequests(ids, rejectionReason) {
        return this.client.trpc.teamManager.leaveRequest.reject.mutate({
          ids,
          rejectionReason
        });
      }
      async revertLeaveRequests(ids) {
        return this.client.trpc.teamManager.leaveRequest.revert.mutate({
          ids
        });
      }
      // Overtime
      async listOvertime(input) {
        return this.client.trpc.teamManager.overtime.list.query(input ?? {});
      }
      async approveOvertime(ids) {
        return this.client.trpc.teamManager.overtime.approve.mutate({
          ids
        });
      }
      async rejectOvertime(ids, rejectionReason) {
        return this.client.trpc.teamManager.overtime.reject.mutate({
          ids,
          rejectionReason
        });
      }
      async approveOvertimeReport(ids) {
        return this.client.trpc.teamManager.overtime.approveReport.mutate({
          ids
        });
      }
      async rejectOvertimeReport(ids, rejectionReason) {
        return this.client.trpc.teamManager.overtime.rejectReport.mutate({
          ids,
          rejectionReason
        });
      }
      /** 승인 후 취소 요청 처리 — approve=true면 취소 확정, false면 요청 거절 */
      /** 휴가 취소 신청 결재(MED-959) — 팀장 앱 · 직원 앱 결재함 */
      async resolveLeaveCancelRequest(id, approve, rejectionReason) {
        return this.client.trpc.teamManager.leaveRequest.resolveCancelRequest.mutate({
          id,
          approve,
          rejectionReason
        });
      }
      async resolveOvertimeCancelRequest(id, approve) {
        return this.client.trpc.teamManager.overtime.resolveCancelRequest.mutate({
          id,
          approve
        });
      }
      // Offsite work (외근)
      async listOffsiteWork(input) {
        return this.client.trpc.teamManager.offsiteWork.list.query(input ?? {});
      }
      async approveOffsiteWork(ids) {
        return this.client.trpc.teamManager.offsiteWork.approve.mutate({
          ids
        });
      }
      async rejectOffsiteWork(ids, rejectionReason) {
        return this.client.trpc.teamManager.offsiteWork.reject.mutate({
          ids,
          rejectionReason
        });
      }
      async approveOffsiteWorkReport(ids) {
        return this.client.trpc.teamManager.offsiteWork.approveReport.mutate({
          ids
        });
      }
      async rejectOffsiteWorkReport(ids, rejectionReason) {
        return this.client.trpc.teamManager.offsiteWork.rejectReport.mutate({
          ids,
          rejectionReason
        });
      }
      // Treatment categories
      async treatmentCategories() {
        return this.client.trpc.teamManager.treatmentCategories.query();
      }
      // Attendance summary
      async attendanceSummary(year, month) {
        return this.client.trpc.teamManager.attendanceSummary.query({
          year,
          month
        });
      }
      // Incentive preset categories
      async incentivePresetCategories() {
        return this.client.trpc.teamManager.incentivePresetCategories.query();
      }
      // Incentives
      async listIncentives(input) {
        return this.client.trpc.teamManager.incentive.list.query(input ?? {});
      }
      async createIncentive(input) {
        return this.client.trpc.teamManager.incentive.create.mutate(input);
      }
      async approveIncentives(ids) {
        return this.client.trpc.teamManager.incentive.approve.mutate({
          ids
        });
      }
      /** 인센티브 반려(결재선 MED-900) — 사유 필수, 네 종류가 같은 버튼을 가진다 */
      async rejectIncentives(ids, rejectionReason) {
        return this.client.trpc.teamManager.incentive.reject.mutate({
          ids,
          rejectionReason
        });
      }
      // Documents
      async listDocuments(input) {
        return this.client.trpc.teamManager.document.list.query(input ?? {});
      }
      async approveDocuments(ids) {
        return this.client.trpc.teamManager.document.approve.mutate({
          ids
        });
      }
      async rejectDocuments(ids, rejectionReason) {
        return this.client.trpc.teamManager.document.reject.mutate({
          ids,
          rejectionReason
        });
      }
      // Certificates
      async listCertificates(input) {
        return this.client.trpc.teamManager.certificate.list.query(input ?? {});
      }
      async approveCertificates(ids) {
        return this.client.trpc.teamManager.certificate.approve.mutate({
          ids
        });
      }
      async rejectCertificates(ids, rejectionReason) {
        return this.client.trpc.teamManager.certificate.reject.mutate({
          ids,
          rejectionReason
        });
      }
      // Unified document management (certificates + documents)
      async listDocumentManagement(status, kind = "all", filters) {
        return this.client.trpc.teamManager.documentManagement.list.query({
          status,
          kind,
          ...filters
        });
      }
      /**
      * 증명서 건을 실제 발급 모양으로 렌더(저장 없음) — 결재 미리보기.
      * 증명서 원장 행은 `certificate`, 구 경로 서류 원장의 파일 없는 요청 행은 `document`.
      */
      async previewCertificateDocument(id, source = "certificate") {
        return this.client.trpc.teamManager.documentManagement.previewCertificate.query({
          id,
          source
        });
      }
      async approveDocumentManagement(id, source) {
        return this.client.trpc.teamManager.documentManagement.approve.mutate({
          id,
          source
        });
      }
      async rejectDocumentManagement(id, source, rejectionReason) {
        return this.client.trpc.teamManager.documentManagement.reject.mutate({
          id,
          source,
          rejectionReason
        });
      }
      /** 전자결재 건을 서식(휴가신청서·시간외근무신청서·외근신청서) HTML로 렌더링 */
      async renderDocumentForm(source, recordId) {
        return this.client.trpc.teamManager.documentForm.render.query({
          source,
          recordId
        });
      }
    }, __name(_a100, "_TeamManagerService"), _a100);
    __name2(_TeamManagerService, "TeamManagerService");
    TeamManagerService = _TeamManagerService;
    _TeamService = (_a101 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /**
      * Create a new team
      * @param input Team creation data
      * @returns Created team
      */
      async create(input) {
        return this.client.trpc.team.create.mutate(input);
      }
      /**
      * Get team by ID
      * @param id Team ID
      * @returns Team details with relations
      */
      async getById(id) {
        return this.client.trpc.team.getById.query({
          id
        });
      }
      /**
      * List teams with filters
      * @param query Query parameters for filtering, sorting, and pagination
      * @returns Paginated list of teams
      */
      async list(query) {
        return this.client.trpc.team.list.query(query || {});
      }
      /**
      * Update team
      * @param id Team ID
      * @param data Update data
      * @returns Updated team
      */
      async update(id, data) {
        return this.client.trpc.team.update.mutate({
          id,
          data
        });
      }
      /**
      * 근무 유형 폼의 「대표로 쓰는 팀」 저장 — teamIds 의 팀 대표 근무를 이 형태로 바꾸고,
      * 빠진 팀은 형태만 비운다(그룹만 대표로 남음).
      */
      async setRepresentativeShift(shiftId, teamIds) {
        return this.client.trpc.team.setRepresentativeShift.mutate({
          shiftId,
          teamIds
        });
      }
      /**
      * Add member to team
      * @param input Add member parameters
      * @returns Created team member
      */
      async addMember(input) {
        return this.client.trpc.team.addMember.mutate(input);
      }
      /**
      * Remove member from team
      * @param teamId Team ID
      * @param memberId Team member ID
      * @param reason Optional removal reason
      * @returns Success status
      */
      async removeMember(teamId, memberId, reason) {
        return this.client.trpc.team.removeMember.mutate({
          teamId,
          memberId,
          reason
        });
      }
      /**
      * Update team member
      * @param teamId Team ID
      * @param memberId Team member ID
      * @param data Update data
      * @returns Updated team member
      */
      async updateMember(teamId, memberId, data) {
        return this.client.trpc.team.updateMember.mutate({
          teamId,
          memberId,
          data
        });
      }
      /**
      * Perform bulk operations on team members
      * @param input Bulk operation parameters
      * @returns Results of each operation
      */
      async bulkMemberOperation(input) {
        return this.client.trpc.team.bulkMemberOperation.mutate(input);
      }
      /**
      * 팀 이동(MED-912) — 직원들을 다른 팀으로 한 번에 옮긴다(또는 겸직으로 추가). 직원마다 자동 승인된
      * 인사발령 문서가 남고, 발령일이 오늘 이전·오늘이면 바로, 미래면 시행일에 반영된다.
      */
      async moveMembers(input) {
        return this.client.trpc.teamMove.execute.mutate(input);
      }
      /**
      * 팀 관리 명단 — 조직 전체 직원(퇴직 · 비활성 포함)과 활성 소속을 가벼운 한 응답으로.
      * admin 팀 관리가 진입 때 한 번 읽어 팀별 명단 · 트리 인원 · 미소속을 모두 파생한다(MED-914).
      */
      /** 형제 팀 노출 순서 — 같은 상위 팀 아래 팀 id 를 보일 순서대로(MED-953) */
      async reorder(input) {
        return this.client.trpc.team.reorder.mutate(input);
      }
      async roster() {
        return this.client.trpc.team.roster.query();
      }
      /** 총괄 팀장(조직 전체) 목록 — 팀 관리 워크스페이스 헤더(MED-946) */
      async orgLeaders() {
        return this.client.trpc.team.orgLeaders.query();
      }
      /** 총괄 팀장 목록을 통째로 바꾼다 — 빈 배열이면 전원 해제 */
      async setOrgLeaders(leaderIds) {
        return this.client.trpc.team.setOrgLeaders.mutate({
          leaderIds
        });
      }
      /**
      * Get team composition with member details and statistics
      * @param teamId Team ID
      * @returns Team composition with members and statistics
      */
      async getComposition(teamId) {
        return this.client.trpc.team.getComposition.query({
          teamId
        });
      }
      /**
      * 팀 관리 병동 요약 — 선택한 팀(과 하위 팀) 중 병동이 연결된 팀마다
      * 인원 · 직군 · 근무 형태 · 수간호사 · 병동 정보. teamId 를 비우면 조직 전체 병동.
      * @param teamId Team ID (생략 시 조직 전체)
      */
      async wardSummary(teamId) {
        return this.client.trpc.team.wardSummary.query({
          teamId
        });
      }
      /**
      * 병동 하나의 요약 — 팀 관리 트리의 병동 노드. 팀 연결 여부와 무관하게 병동 배정(간호 프로필) 기준으로 센다.
      * @param wardId Ward ID
      */
      async wardSummaryForWard(wardId) {
        return this.client.trpc.team.wardSummary.query({
          wardId
        });
      }
      /**
      * Delete team (soft delete)
      * @param id Team ID
      * @returns Success status
      */
      async delete(id) {
        return this.client.trpc.team.delete.mutate({
          id
        });
      }
    }, __name(_a101, "_TeamService"), _a101);
    __name2(_TeamService, "TeamService");
    TeamService = _TeamService;
    _WorkPatternService = (_a102 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 근로형태 목록(임금산정시간·직무·기본 근무·직원 수 포함). activeOnly 로 선택지용 활성 목록만. */
      async list(input) {
        return this.client.trpc.workPattern.list.query(input);
      }
      async create(input) {
        return this.client.trpc.workPattern.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.workPattern.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.workPattern.delete.mutate(id);
      }
      /** 직원 파생값 재계산 — dryRun(기본)은 달라지는 직원·필드만 돌려주고, dryRun=false 가 근로계약 새 버전을 쓴다. */
      /** 근무 그룹에서 가져오기 — dryRun(미리보기) → 적용 2단계. */
      async importFromShiftGroups(input) {
        return this.client.trpc.workPattern.importFromShiftGroups.mutate(input);
      }
      async recompute(input) {
        return this.client.trpc.workPattern.recompute.mutate(input);
      }
    }, __name(_a102, "_WorkPatternService"), _a102);
    __name2(_WorkPatternService, "WorkPatternService");
    WorkPatternService = _WorkPatternService;
    _WorkTimeClosingService = (_a103 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      /** 마감 내역 목록 (마감 건별 확정/전체 인원 + 상태). */
      async list() {
        return this.client.trpc.workTimeClosing.list.query();
      }
      /** 마감 건 생성 (대상 미지정 시 재직 전원). */
      async create(input) {
        return this.client.trpc.workTimeClosing.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.workTimeClosing.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.workTimeClosing.delete.mutate(id);
      }
      /** 마감 건의 대상자 목록 (상태 필터 + 이름/사번 검색). */
      async listTargets(input) {
        return this.client.trpc.workTimeClosing.listTargets.query(input);
      }
      /** 선택 대상 확정(마감). */
      async confirmTargets(input) {
        return this.client.trpc.workTimeClosing.confirmTargets.mutate(input);
      }
      /** 선택 대상 확정 취소(해제). */
      async unconfirmTargets(input) {
        return this.client.trpc.workTimeClosing.unconfirmTargets.mutate(input);
      }
    }, __name(_a103, "_WorkTimeClosingService"), _a103);
    __name2(_WorkTimeClosingService, "WorkTimeClosingService");
    WorkTimeClosingService = _WorkTimeClosingService;
    _YearEndSettlementService = (_a104 = class {
      constructor(client) {
        __publicField(this, "client");
        this.client = client;
      }
      async list(filter, pagination) {
        return this.client.trpc.yearEndSettlement.list.query({
          filter,
          pagination
        });
      }
      async get(id) {
        return this.client.trpc.yearEndSettlement.get.query(id);
      }
      async create(input) {
        return this.client.trpc.yearEndSettlement.create.mutate(input);
      }
      async update(input) {
        return this.client.trpc.yearEndSettlement.update.mutate(input);
      }
      async delete(id) {
        return this.client.trpc.yearEndSettlement.delete.mutate(id);
      }
      async approve(id) {
        return this.client.trpc.yearEndSettlement.approve.mutate(id);
      }
      // biome-ignore lint/suspicious/noExplicitAny: Dynamic input
      async applyToPayroll(input) {
        return this.client.trpc.yearEndSettlement.applyToPayroll.mutate(input);
      }
    }, __name(_a104, "_YearEndSettlementService"), _a104);
    __name2(_YearEndSettlementService, "YearEndSettlementService");
    YearEndSettlementService = _YearEndSettlementService;
    defaultConfig = {
      baseUrl: "http://localhost:3000",
      headers: {},
      timeout: 3e4,
      timeoutOverrides: {
        "ai.chat": 18e4
      },
      debug: false
    };
    IMPERSONATION_RETURN_KEY = "hereby_impersonation_return";
    IMPERSONATION_NOTICE_KEY = "hereby_impersonation_notice";
    __name(storage, "storage");
    __name2(storage, "storage");
    __name(readImpersonationReturn, "readImpersonationReturn");
    __name2(readImpersonationReturn, "readImpersonationReturn");
    __name(saveImpersonationReturn, "saveImpersonationReturn");
    __name2(saveImpersonationReturn, "saveImpersonationReturn");
    __name(clearImpersonationReturn, "clearImpersonationReturn");
    __name2(clearImpersonationReturn, "clearImpersonationReturn");
    __name(takeImpersonationNotice, "takeImpersonationNotice");
    __name2(takeImpersonationNotice, "takeImpersonationNotice");
    restoredThisPage = false;
    __name(restoreImpersonationReturn, "restoreImpersonationReturn");
    __name2(restoreImpersonationReturn, "restoreImpersonationReturn");
    __name(recoverFromImpersonationExpiry, "recoverFromImpersonationExpiry");
    __name2(recoverFromImpersonationExpiry, "recoverFromImpersonationExpiry");
    IMPERSONATION_EXPIRED_NOTICE = "\uBBF8\uB9AC\uBCF4\uAE30\uAC00 \uB9CC\uB8CC\uB418\uC5B4 \uC6D0\uB798 \uC138\uC158\uC73C\uB85C \uB3CC\uC544\uC654\uC5B4\uC694";
    IMPERSONATION_ENDED_NOTICE = "\uAD8C\uD55C \uBBF8\uB9AC\uBCF4\uAE30\uB97C \uC885\uB8CC\uD588\uC5B4\uC694";
    __name(navigateAfterImpersonationExit, "navigateAfterImpersonationExit");
    __name2(navigateAfterImpersonationExit, "navigateAfterImpersonationExit");
    __name(restoredPageHasStaleSession, "restoredPageHasStaleSession");
    __name2(restoredPageHasStaleSession, "restoredPageHasStaleSession");
    historyGuardInstalled = false;
    __name(installImpersonationHistoryGuard, "installImpersonationHistoryGuard");
    __name2(installImpersonationHistoryGuard, "installImpersonationHistoryGuard");
    __name(mutationPathsFromUrl, "mutationPathsFromUrl");
    __name2(mutationPathsFromUrl, "mutationPathsFromUrl");
    __name(readBatchOutcomes, "readBatchOutcomes");
    __name2(readBatchOutcomes, "readBatchOutcomes");
    PERMISSION_CODE_RE = /^[\w-]+:[\w-]+(?:\.[\w-]+)?$/;
    __name(extractPermissionCode, "extractPermissionCode");
    __name2(extractPermissionCode, "extractPermissionCode");
    __name(shouldSurfaceForbidden, "shouldSurfaceForbidden");
    __name2(shouldSurfaceForbidden, "shouldSurfaceForbidden");
    HTTP_BATCH_MAX_ITEMS = 10;
    HTTP_BATCH_MAX_URL_LENGTH = 1800;
    WS_KEEPALIVE = {
      enabled: true,
      intervalMs: 15e3,
      pongTimeoutMs: 5e3
    };
    WS_RETRY_MAX_MS = 1e4;
    __name(wsRetryDelayMs, "wsRetryDelayMs");
    __name2(wsRetryDelayMs, "wsRetryDelayMs");
    WS_REOPENED_EVENT = "hereby:ws-reopened";
    __name(resolveRequestTimeout, "resolveRequestTimeout");
    __name2(resolveRequestTimeout, "resolveRequestTimeout");
    _HerebyClient = (_a105 = class {
      constructor(config = {}) {
        __publicField(this, "config");
        __publicField(this, "accessToken");
        __publicField(this, "refreshToken");
        __publicField(this, "onTokenRefresh");
        __publicField(this, "onAuthError");
        __publicField(this, "onMutationActivity");
        __publicField(this, "mutationSeq", 0);
        __publicField(this, "storage");
        __publicField(this, "wsClient");
        __publicField(this, "_refreshPromise");
        __publicField(this, "quietForbiddenPaths", /* @__PURE__ */ new Map());
        __publicField(this, "trpc");
        __publicField(this, "account");
        __publicField(this, "ai");
        __publicField(this, "auth");
        __publicField(this, "invite");
        __publicField(this, "signup");
        __publicField(this, "organization");
        __publicField(this, "organizationHoliday");
        __publicField(this, "organizationParameter");
        __publicField(this, "team");
        __publicField(this, "employee");
        __publicField(this, "payroll");
        __publicField(this, "attendance");
        __publicField(this, "attendanceRate");
        __publicField(this, "workTimeClosing");
        __publicField(this, "salaryGrade");
        __publicField(this, "gradePromotion");
        __publicField(this, "scheduledAction");
        __publicField(this, "recurringAllowance");
        __publicField(this, "overtime");
        __publicField(this, "offsiteWork");
        __publicField(this, "approvalFlow");
        __publicField(this, "attendanceCorrection");
        __publicField(this, "allowance");
        __publicField(this, "annualLeavePromotion");
        __publicField(this, "deduction");
        __publicField(this, "deductionImport");
        __publicField(this, "resignation");
        __publicField(this, "impersonation");
        __publicField(this, "yearEndSettlement");
        __publicField(this, "fixedIncentive");
        __publicField(this, "educationSubsidy");
        __publicField(this, "role");
        __publicField(this, "leaveImport");
        __publicField(this, "leaveRequest");
        __publicField(this, "conversation");
        __publicField(this, "message");
        __publicField(this, "chatKey");
        __publicField(this, "chatDeviceLink");
        __publicField(this, "deviceCredential");
        __publicField(this, "security");
        __publicField(this, "chatRecovery");
        __publicField(this, "conversationKey");
        __publicField(this, "notification");
        __publicField(this, "permissionRequest");
        __publicField(this, "nurseScheduler");
        __publicField(this, "document");
        __publicField(this, "teamDrive");
        __publicField(this, "teamManager");
        __publicField(this, "generalAffairs");
        __publicField(this, "appOnboarding");
        __publicField(this, "shift");
        __publicField(this, "shiftGroup");
        __publicField(this, "jobDuty");
        __publicField(this, "workPattern");
        __publicField(this, "managementDashboard");
        __publicField(this, "moduleRegistry");
        __publicField(this, "itemCode");
        __publicField(this, "fileStorage");
        __publicField(this, "employeeCertification");
        __publicField(this, "certificationType");
        __publicField(this, "inventory");
        __publicField(this, "screenCapture");
        __publicField(this, "secomEvent");
        __publicField(this, "sheetView");
        __publicField(this, "sheetRow");
        __publicField(this, "sheetCell");
        __publicField(this, "sheetTemplate");
        __publicField(this, "searchHistory");
        __publicField(this, "entityPicker");
        __publicField(this, "documentTemplate");
        __publicField(this, "eSign");
        const filteredConfig = Object.fromEntries(Object.entries(config).filter(([_, v]) => v !== void 0));
        this.config = {
          ...defaultConfig,
          ...filteredConfig
        };
        this.accessToken = config.accessToken;
        this.refreshToken = config.refreshToken;
        this.onTokenRefresh = config.onTokenRefresh;
        this.onAuthError = config.onAuthError;
        this.onMutationActivity = config.onMutationActivity;
        this.trpc = this.createTRPCClient();
        this.account = new AccountService(this);
        this.ai = new AiService(this);
        this.auth = new AuthService(this);
        this.invite = new InviteService(this);
        this.signup = new SignupService(this);
        this.organization = new OrganizationService(this);
        this.organizationHoliday = new OrganizationHolidayService(this);
        this.organizationParameter = new OrganizationParameterService(this);
        this.team = new TeamService(this);
        this.employee = new EmployeeService(this);
        this.payroll = new PayrollService(this);
        this.attendance = new AttendanceService(this);
        this.attendanceRate = new AttendanceRateService(this);
        this.workTimeClosing = new WorkTimeClosingService(this);
        this.salaryGrade = new SalaryGradeService(this);
        this.gradePromotion = new GradePromotionService(this);
        this.scheduledAction = new ScheduledActionService(this);
        this.recurringAllowance = new RecurringAllowanceService(this);
        this.overtime = new OvertimeService(this);
        this.offsiteWork = new OffsiteWorkService(this);
        this.approvalFlow = new ApprovalFlowService(this);
        this.attendanceCorrection = new AttendanceCorrectionService(this);
        this.allowance = new AllowanceService(this);
        this.annualLeavePromotion = new AnnualLeavePromotionService(this);
        this.deduction = new DeductionService(this);
        this.deductionImport = new DeductionImportService(this);
        this.resignation = new ResignationService(this);
        this.impersonation = new ImpersonationService(this);
        this.yearEndSettlement = new YearEndSettlementService(this);
        this.fixedIncentive = new FixedIncentiveService(this);
        this.educationSubsidy = new EducationSubsidyService(this);
        this.role = new RoleService(this);
        this.leaveImport = new LeaveImportService(this);
        this.leaveRequest = new LeaveRequestService(this);
        this.conversation = new ConversationService(this);
        this.message = new MessageService(this);
        this.chatKey = new ChatKeyService(this);
        this.chatDeviceLink = new ChatDeviceLinkService(this);
        this.deviceCredential = new DeviceCredentialService(this);
        this.security = new SecurityService(this);
        this.chatRecovery = new ChatRecoveryService(this);
        this.conversationKey = new ConversationKeyService(this);
        this.notification = new NotificationService(this);
        this.permissionRequest = new PermissionRequestService(this);
        this.nurseScheduler = new NurseSchedulerService(this);
        this.document = new DocumentService(this);
        this.teamDrive = new TeamDriveService(this);
        this.teamManager = new TeamManagerService(this);
        this.generalAffairs = new GeneralAffairsService(this);
        this.appOnboarding = new AppOnboardingService(this);
        this.shift = new ShiftService(this);
        this.shiftGroup = new ShiftGroupService(this);
        this.jobDuty = new JobDutyService(this);
        this.workPattern = new WorkPatternService(this);
        this.managementDashboard = new ManagementDashboardService(this);
        this.moduleRegistry = new ModuleRegistryService(this);
        this.itemCode = new ItemCodeService(this);
        this.fileStorage = new StorageService(this);
        this.employeeCertification = new EmployeeCertificationService(this);
        this.certificationType = new CertificationTypeService(this);
        this.inventory = new InventoryService(this);
        this.screenCapture = new ScreenCaptureService(this);
        this.secomEvent = new SecomEventService(this);
        this.sheetView = new SheetViewService(this);
        this.sheetRow = new SheetRowService(this);
        this.sheetCell = new SheetCellService(this);
        this.sheetTemplate = new SheetTemplateService(this);
        this.searchHistory = new SearchHistoryService(this);
        this.entityPicker = new EntityPickerService(this);
        this.documentTemplate = new DocumentTemplateService(this);
        this.eSign = new ESignService(this);
      }
      joinUrl(base, path) {
        const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
        return `${normalizedBase}${path}`;
      }
      /** API 기준 URL(끝 슬래시 없음) — tRPC 밖의 REST 경로(파일 브로커 등)를 만들 때 쓴다 */
      getBaseUrl() {
        return this.config.baseUrl.endsWith("/") ? this.config.baseUrl.slice(0, -1) : this.config.baseUrl;
      }
      setBaseUrl(baseUrl) {
        const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
        if (normalizedBaseUrl === this.config.baseUrl) {
          return;
        }
        this.config = {
          ...this.config,
          baseUrl: normalizedBaseUrl
        };
        this.trpc = this.createTRPCClient();
      }
      getWsUrl() {
        const base = this.config.baseUrl;
        const tokenParam = this.accessToken ? `?token=${this.accessToken}` : "";
        if (base.startsWith("http://") || base.startsWith("https://")) {
          const wsProtocol = base.startsWith("https://") ? "wss" : "ws";
          const host2 = base.replace(/^https?:\/\//, "");
          return `${wsProtocol}://${host2}/trpc-ws${tokenParam}`;
        }
        if (base.startsWith("/") && typeof window !== "undefined") {
          const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";
          return `${wsProtocol}://${window.location.host}${this.joinUrl(base, "/trpc-ws")}${tokenParam}`;
        }
        return this.joinUrl(base, `/trpc-ws${tokenParam}`);
      }
      createTRPCClient() {
        this.wsClient?.close();
        let opens = 0;
        this.wsClient = createWSClient({
          url: this.getWsUrl(),
          retryDelayMs: wsRetryDelayMs,
          keepAlive: {
            ...WS_KEEPALIVE
          },
          onOpen: /* @__PURE__ */ __name2(() => {
            opens += 1;
            if (opens > 1 && typeof window !== "undefined") {
              window.dispatchEvent(new CustomEvent(WS_REOPENED_EVENT));
            }
          }, "onOpen")
        });
        const quietForbiddenLink = /* @__PURE__ */ __name2(() => {
          return ({ next, op }) => observable((observer) => {
            const quiet2 = op.context?.quietForbidden === true;
            let counted = false;
            if (quiet2) {
              this.quietForbiddenPaths.set(op.path, (this.quietForbiddenPaths.get(op.path) ?? 0) + 1);
              counted = true;
            }
            const release = /* @__PURE__ */ __name2(() => {
              if (!counted) {
                return;
              }
              counted = false;
              const n = (this.quietForbiddenPaths.get(op.path) ?? 1) - 1;
              if (n <= 0) {
                this.quietForbiddenPaths.delete(op.path);
              } else {
                this.quietForbiddenPaths.set(op.path, n);
              }
            }, "release");
            const sub = next(op).subscribe({
              next: /* @__PURE__ */ __name2((value) => observer.next(value), "next"),
              error: /* @__PURE__ */ __name2((err) => {
                release();
                observer.error(err);
              }, "error"),
              complete: /* @__PURE__ */ __name2(() => {
                release();
                observer.complete();
              }, "complete")
            });
            return () => {
              release();
              sub.unsubscribe();
            };
          });
        }, "quietForbiddenLink");
        return createTRPCClient({
          links: [
            quietForbiddenLink,
            splitLink({
              condition: /* @__PURE__ */ __name2((op) => op.type === "subscription", "condition"),
              true: wsLink({
                transformer: SuperJSON,
                client: this.wsClient
              }),
              false: httpBatchLink({
                transformer: SuperJSON,
                url: this.joinUrl(this.config.baseUrl, "/trpc"),
                maxItems: HTTP_BATCH_MAX_ITEMS,
                maxURLLength: HTTP_BATCH_MAX_URL_LENGTH,
                headers: /* @__PURE__ */ __name2(() => {
                  const headers = {
                    ...this.config.headers
                  };
                  if (this.accessToken) {
                    headers.Authorization = `Bearer ${this.accessToken}`;
                  }
                  return headers;
                }, "headers"),
                // 쓰기 요청 알림(onMutationActivity)으로 한 번 감싼다 — 안쪽 전송(토큰
                // 갱신 재시도·오류 문구·CS 기록)은 그대로다.
                fetch: /* @__PURE__ */ __name2((url, options) => this.observeMutations(String(url), options, async () => {
                  const csPath = (() => {
                    try {
                      return new URL(String(url)).pathname;
                    } catch {
                      return String(url).split("?")[0];
                    }
                  })();
                  const controller = new AbortController();
                  const timeoutId = setTimeout(() => controller.abort(), resolveRequestTimeout(csPath, this.config.timeout, this.config.timeoutOverrides));
                  const csStartedAt = Date.now();
                  try {
                    const response = await fetch(url, {
                      ...options,
                      signal: controller.signal
                    });
                    const isRefreshCall = String(url).includes("auth.refreshToken");
                    if (response.status === 401 && this.refreshToken && !isRefreshCall) {
                      try {
                        await this.handleTokenRefresh();
                        const retryHeaders = {
                          ...options?.headers,
                          Authorization: `Bearer ${this.accessToken}`
                        };
                        return fetch(url, {
                          ...options,
                          headers: retryHeaders
                        });
                      } catch (refreshError) {
                        if (isDefinitiveAuthFailure(refreshError) && isTopLevelFrame()) {
                          if (recoverFromImpersonationExpiry(this)) {
                            return response;
                          }
                          this.clearTokens();
                        }
                        return response;
                      }
                    }
                    const contentType = response.headers.get("content-type") || "";
                    if (!contentType.includes("application/json") && response.status !== 204) {
                      throw new Error("\uC2E4\uD589 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694. \uC9C0\uC18D\uC801\uC73C\uB85C \uC624\uB958 \uBC1C\uC0DD\uC2DC \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.");
                    }
                    if (typeof window !== "undefined" && contentType.includes("application/json")) {
                      try {
                        const cloned = response.clone();
                        const body = await cloned.json();
                        const results = Array.isArray(body) ? body : [
                          body
                        ];
                        const firstError = results.map((r) => r?.error?.json).find((e) => e !== void 0);
                        csCollector.recordApi({
                          path: csPath,
                          ok: response.ok && !firstError,
                          status: response.status,
                          code: firstError?.data?.code,
                          requestId: response.headers.get("x-request-id") ?? firstError?.data?.requestId,
                          ms: Date.now() - csStartedAt
                        });
                        for (const result of results) {
                          const err = result?.error?.json;
                          if (err?.data?.code === "FORBIDDEN") {
                            const message = err.message ?? "";
                            const path = err.data.path;
                            if (!shouldSurfaceForbidden(path, this.quietForbiddenPaths)) {
                              continue;
                            }
                            const permissionCode = extractPermissionCode(message);
                            const event = new CustomEvent("hereby:permission-error", {
                              cancelable: true,
                              detail: {
                                message,
                                path,
                                permission: permissionCode
                              }
                            });
                            const proceeded = window.dispatchEvent(event);
                            if (proceeded) {
                              window.dispatchEvent(new CustomEvent("permission-denied", {
                                detail: {
                                  permission: permissionCode,
                                  message
                                }
                              }));
                            }
                            break;
                          }
                        }
                      } catch {
                      }
                    }
                    return response;
                  } catch (error) {
                    csCollector.recordApi({
                      path: csPath,
                      ok: false,
                      code: error instanceof Error && error.name === "AbortError" ? "TIMEOUT" : "NETWORK",
                      ms: Date.now() - csStartedAt
                    });
                    if (error instanceof Error && error.name === "AbortError") {
                      throw new Error("Request timeout");
                    }
                    if (error instanceof TypeError || error instanceof Error && /fetch|network|load failed/i.test(error.message)) {
                      throw new Error("\uC2E4\uD589 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694. \uC9C0\uC18D\uC801\uC73C\uB85C \uC624\uB958 \uBC1C\uC0DD\uC2DC \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.");
                    }
                    throw error;
                  } finally {
                    clearTimeout(timeoutId);
                  }
                }), "fetch")
              })
            })
          ]
        });
      }
      /**
      * 쓰기 요청(POST — httpBatchLink 는 query 를 GET 으로 보낸다)의 시작·끝을
      * `onMutationActivity` 로 알린다. 알릴 곳이 없거나 읽기 요청이면 그대로 보낸다.
      * 끝은 요청(op)마다 따로 — 배치 일부만 실패해도(HTTP 207) 그 요청만 실패로.
      * 콜백이 던지는 오류는 삼켜서 저장 흐름을 막지 않는다.
      */
      async observeMutations(url, options, send) {
        const listener = this.onMutationActivity;
        if (!listener || (options?.method ?? "GET").toUpperCase() !== "POST") {
          return send();
        }
        const paths = mutationPathsFromUrl(url);
        if (paths.length === 0) {
          return send();
        }
        const emit = /* @__PURE__ */ __name2((event) => {
          try {
            listener(event);
          } catch {
          }
        }, "emit");
        const ops = paths.map((path) => ({
          id: ++this.mutationSeq,
          path
        }));
        for (const op of ops) {
          emit({
            phase: "start",
            ...op
          });
        }
        let response;
        try {
          response = await send();
        } catch (error) {
          const message = error instanceof Error ? error.message : String(error);
          for (const op of ops) {
            emit({
              phase: "end",
              ...op,
              ok: false,
              message
            });
          }
          throw error;
        }
        const outcomes = await readBatchOutcomes(response, ops.length);
        ops.forEach((op, i) => {
          emit({
            phase: "end",
            ...op,
            ...outcomes[i] ?? {
              ok: response.ok
            }
          });
        });
        return response;
      }
      /**
      * Close WebSocket connection and clean up resources
      */
      destroy() {
        this.wsClient?.close();
        this.wsClient = void 0;
      }
      async handleTokenRefresh() {
        if (!this.refreshToken) {
          throw new Error("No refresh token available");
        }
        if (this._refreshPromise) {
          return this._refreshPromise;
        }
        if (this._adoptRotatedTokensFromStorage()) {
          return;
        }
        this._refreshPromise = (async () => {
          const rt = this.refreshToken;
          try {
            if (!rt) {
              throw new Error("No refresh token available");
            }
            const result = await this.trpc.auth.refreshToken.mutate({
              refreshToken: rt
            });
            this.setTokens(result.accessToken, result.refreshToken);
            if (this.onTokenRefresh) {
              this.onTokenRefresh({
                accessToken: result.accessToken,
                refreshToken: result.refreshToken
              });
            }
          } catch (error) {
            if (this._adoptRotatedTokensFromStorage(rt)) {
              return;
            }
            for (let i = 0; i < 3; i++) {
              await new Promise((resolve2) => setTimeout(resolve2, 150));
              if (this._adoptRotatedTokensFromStorage(rt)) {
                return;
              }
            }
            if (this.onAuthError) {
              this.onAuthError(error);
            }
            throw error;
          } finally {
            this._refreshPromise = void 0;
          }
        })();
        return this._refreshPromise;
      }
      /**
      * Pull rotated tokens from localStorage if another client/tab has
      * already refreshed. Returns true when storage carried a newer
      * refresh token than `expectedOldRT` (or the current in-memory
      * `refreshToken` when no expected value is passed).
      *
      * Used by `handleTokenRefresh` as both a pre-check (avoid burning a
      * stale RT on the server) and a post-check (recover from a 401 that
      * another client already cleared).
      */
      _adoptRotatedTokensFromStorage(expectedOldRT) {
        if (!this.storage) {
          return false;
        }
        const storedRT = this.storage.getRefreshToken();
        if (!storedRT) {
          return false;
        }
        const baseline = expectedOldRT ?? this.refreshToken;
        if (!baseline || storedRT === baseline) {
          return false;
        }
        const storedAT = this.storage.getAccessToken();
        if (storedAT) {
          this.accessToken = storedAT;
        }
        this.refreshToken = storedRT;
        this.trpc = this.createTRPCClient();
        if (this.onTokenRefresh && storedAT) {
          this.onTokenRefresh({
            accessToken: storedAT,
            refreshToken: storedRT
          });
        }
        return true;
      }
      /**
      * Load tokens from persistent storage (localStorage in browser)
      */
      loadTokens() {
        if (!this.storage) {
          this.initStorage();
        }
        if (this.storage) {
          const at = this.storage.getAccessToken();
          const rt = this.storage.getRefreshToken();
          if (at) {
            this.accessToken = at;
          }
          if (rt) {
            this.refreshToken = rt;
          }
          if (at) {
            this.trpc = this.createTRPCClient();
          }
        }
      }
      initStorage() {
        if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
          this.storage = {
            getAccessToken: /* @__PURE__ */ __name2(() => localStorage.getItem("hereby_access_token"), "getAccessToken"),
            getRefreshToken: /* @__PURE__ */ __name2(() => localStorage.getItem("hereby_refresh_token"), "getRefreshToken"),
            setTokens: /* @__PURE__ */ __name2((at, rt) => {
              localStorage.setItem("hereby_access_token", at);
              if (rt) {
                localStorage.setItem("hereby_refresh_token", rt);
              }
            }, "setTokens"),
            clearTokens: /* @__PURE__ */ __name2(() => {
              localStorage.removeItem("hereby_access_token");
              localStorage.removeItem("hereby_refresh_token");
            }, "clearTokens")
          };
          try {
            window.addEventListener("storage", (event) => {
              if (event.key === "hereby_refresh_token" && event.newValue && event.newValue !== this.refreshToken) {
                this._adoptRotatedTokensFromStorage();
              }
            });
          } catch {
          }
        }
      }
      /**
      * Set authentication tokens
      */
      setTokens(accessToken, refreshToken) {
        this.accessToken = accessToken;
        if (refreshToken) {
          this.refreshToken = refreshToken;
        }
        if (!this.storage) {
          this.initStorage();
        }
        this.storage?.setTokens(accessToken, refreshToken);
        this.trpc = this.createTRPCClient();
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("hereby:ws-reconnected"));
        }
      }
      /**
      * Clear authentication tokens
      */
      clearTokens() {
        this.accessToken = void 0;
        this.refreshToken = void 0;
        if (!this.storage) {
          this.initStorage();
        }
        this.storage?.clearTokens();
        this.trpc = this.createTRPCClient();
      }
      /**
      * Get current access token
      */
      getAccessToken() {
        return this.accessToken;
      }
      /**
      * Get current refresh token
      */
      getRefreshToken() {
        return this.refreshToken;
      }
      /**
      * Check if client is authenticated
      */
      isAuthenticated() {
        return !!this.accessToken;
      }
      /**
      * 저장된 access token의 세션 종류를 판별한다 (서명 검증 없이 페이로드만 디코드).
      * - "workspace": 조직 스코프 세션 (userId 보유 — 기존 로그인)
      * - "account": account 스코프 세션 (무소속 회원 — 허브로 라우팅)
      * - null: 토큰 없음/해석 불가
      */
      getSessionKind() {
        const token = this.accessToken;
        if (!token) {
          return null;
        }
        try {
          const payloadPart = token.split(".")[1];
          if (!payloadPart) {
            return null;
          }
          const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
          const payload = JSON.parse(atob(normalized));
          if (payload.userId || payload.ownerGrant || payload.grantId || payload.systemGrant) {
            return "workspace";
          }
          if (payload.accountId) {
            return "account";
          }
          return null;
        } catch {
          return null;
        }
      }
      /**
      * Update SDK configuration
      */
      updateConfig(config) {
        this.config = {
          ...this.config,
          ...config
        };
        if (config.accessToken !== void 0) {
          this.accessToken = config.accessToken;
        }
        if (config.refreshToken !== void 0) {
          this.refreshToken = config.refreshToken;
        }
        if (config.onTokenRefresh !== void 0) {
          this.onTokenRefresh = config.onTokenRefresh;
        }
        if (config.onAuthError !== void 0) {
          this.onAuthError = config.onAuthError;
        }
        if (config.onMutationActivity !== void 0) {
          this.onMutationActivity = config.onMutationActivity;
        }
        this.trpc = this.createTRPCClient();
      }
      /**
      * Enable debug mode
      */
      enableDebug() {
        this.config.debug = true;
      }
      /**
      * Disable debug mode
      */
      disableDebug() {
        this.config.debug = false;
      }
    }, __name(_a105, "_HerebyClient"), _a105);
    __name2(_HerebyClient, "HerebyClient");
    HerebyClient = _HerebyClient;
    __name(isPasskeyAvailable, "isPasskeyAvailable");
    __name2(isPasskeyAvailable, "isPasskeyAvailable");
    __name(registerPasskey, "registerPasskey");
    __name2(registerPasskey, "registerPasskey");
    __name(loginWithPasskey, "loginWithPasskey");
    __name2(loginWithPasskey, "loginWithPasskey");
    __name(resolve, "resolve");
    __name2(resolve, "resolve");
    __name(getActiveDeviceKey, "getActiveDeviceKey");
    __name2(getActiveDeviceKey, "getActiveDeviceKey");
    __name(registerDeviceKey, "registerDeviceKey");
    __name2(registerDeviceKey, "registerDeviceKey");
    __name(loginWithDeviceKey, "loginWithDeviceKey");
    __name2(loginWithDeviceKey, "loginWithDeviceKey");
    __name(forgetDeviceKey, "forgetDeviceKey");
    __name2(forgetDeviceKey, "forgetDeviceKey");
    DEFAULT_BRAND = "hereby Medical";
    DEFAULT_BRAND_FAMILY = "medical";
    SKIP_DEVICE_LOGIN_AUTO_KEY = "hereby:skip-device-login-auto";
    __name(detectEmbedded, "detectEmbedded");
    __name2(detectEmbedded, "detectEmbedded");
    __name(withBootRetry, "withBootRetry");
    __name2(withBootRetry, "withBootRetry");
    __name(endSessionOnBootFailure, "endSessionOnBootFailure");
    __name2(endSessionOnBootFailure, "endSessionOnBootFailure");
    __name(defaultDeviceName, "defaultDeviceName");
    __name2(defaultDeviceName, "defaultDeviceName");
    __name(createAlpinePlugin, "createAlpinePlugin");
    __name2(createAlpinePlugin, "createAlpinePlugin");
    devicePushToken = null;
    __name(setDevicePushToken, "setDevicePushToken");
    __name2(setDevicePushToken, "setDevicePushToken");
    __name(getDevicePushToken, "getDevicePushToken");
    __name2(getDevicePushToken, "getDevicePushToken");
    _ChatKeyManager = (_a106 = class {
      constructor(deps) {
        __publicField(this, "deps");
        __publicField(this, "pair", null);
        __publicField(this, "stored", null);
        __publicField(this, "state", "unknown");
        this.deps = deps;
      }
      get currentState() {
        return this.state;
      }
      /** 어느 직원의 관리자인지 — 로그인 직원이 바뀌면 호출자가 새로 만든다. */
      get employeeId() {
        return this.deps.employeeId;
      }
      /** 기기 키 + 서버 키를 맞춰 보고 상태를 정한다. 메신저 진입마다 부른다. */
      async ensure() {
        const [local, remote] = await Promise.all([
          this.deps.store.getAccount(this.deps.employeeId),
          this.deps.chatKey.getMine()
        ]);
        if (!remote) {
          this.pair = null;
          this.stored = null;
          this.state = "setup";
          return this.state;
        }
        if (local && local.organizationId === this.deps.organizationId && local.version === remote.version && local.bundle.ecdhPublicKey === remote.ecdhPublicKey) {
          this.stored = local;
          this.pair = await importAccountPrivateBundle(local.bundle);
          this.state = "ready";
          return this.state;
        }
        this.pair = null;
        this.stored = null;
        this.state = "restore";
        return this.state;
      }
      /** 복호에 쓰는 계정 키. ready 가 아니면 null. */
      getKeyPair() {
        return this.pair;
      }
      getKeyVersion() {
        return this.stored?.version ?? null;
      }
      /** 내 공개키(세대 봉투를 자기 자신에게 만들 때). ready 가 아니면 null. */
      getPublicKeys() {
        return this.stored ? {
          ecdhPublicKey: this.stored.bundle.ecdhPublicKey,
          ecdsaPublicKey: this.stored.bundle.ecdsaPublicKey
        } : null;
      }
      // ── 최초 설정 ──
      /**
      * 1단계: 키 쌍을 만든다(아직 서버에 없음). 복구 코드는 더 만들지 않는다(2026-10-15 결정) — 사용자가 복구 수단을
      * 직접 보관하지 않는다. 기기를 모두 잃으면 지난 대화는 다른 멤버 기기가 봉투를 다시 줄 수 있는 방에서만 돌아온다.
      */
      async beginSetup() {
        const pair = await generateAccountKeyPair();
        const bundle = await exportAccountPrivateBundle(pair);
        return {
          pair,
          bundle
        };
      }
      /** 2단계: 공개키를 등록하고 기기에 저장한다. 서버 백업은 없다. */
      async completeSetup(pending) {
        const { version } = await this.deps.chatKey.register({
          ecdhPublicKey: pending.bundle.ecdhPublicKey,
          ecdsaPublicKey: pending.bundle.ecdsaPublicKey
        });
        await this.saveLocal(pending.bundle, version);
        this.pair = pending.pair;
        await this.deps.requestPersistentStorage?.().catch(() => false);
      }
      // ── 복구 ──
      /** 새로 시작 — 새 키를 만든다. 지난 대화는 이 사람 화면에서만 안 보이고 회사 자료는 복구 봉투로 보존된다. */
      async resetWithNewKey() {
        return this.beginSetup();
      }
      // ── 새 기기 승인(이 기기가 새 기기) ──
      async startDeviceLink() {
        const ephemeral = await generateDeviceLinkKeyPair();
        const epk = await exportPublicKeySpki(ephemeral.publicKey);
        const token = getDevicePushToken();
        const created = await this.deps.chatDeviceLink.create(epk, token ? {
          requesterPushToken: token
        } : void 0);
        return {
          requestId: created.requestId,
          code: await deviceLinkCode(epk),
          privateKey: ephemeral.privateKey,
          expiresAt: new Date(created.expiresAt)
        };
      }
      /** 승인됐으면 봉투를 받아 키를 저장하고 true, 아직이면 false, 만료되면 throw. */
      async pollDeviceLink(session) {
        const result = await this.deps.chatDeviceLink.claim(session.requestId);
        if (result.status === "expired") {
          throw new Error("\uC694\uCCAD\uC774 \uB9CC\uB8CC\uB410\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uC791\uD574 \uC8FC\uC138\uC694.");
        }
        if (!result.payload) {
          return false;
        }
        const bundle = await openDeviceLinkPayload({
          ephemeralPrivateKey: session.privateKey,
          payload: result.payload,
          requestId: session.requestId
        });
        const remote = await this.deps.chatKey.getMine();
        this.pair = await importAccountPrivateBundle(bundle);
        await this.saveLocal(bundle, remote?.version ?? 1);
        return true;
      }
      async cancelDeviceLink(session) {
        await this.deps.chatDeviceLink.cancel(session.requestId).catch(() => void 0);
      }
      // ── 새 기기 승인(이 기기가 옛 기기) ──
      /** 내 계정으로 들어온 대기 요청과 각각의 6자리 코드. 키가 없는(ready 아님) 기기는 승인할 수 없어 빈 배열. */
      async listPendingDeviceLinks() {
        if (this.state !== "ready" || !this.stored) {
          return [];
        }
        const rows = await this.deps.chatDeviceLink.listPending();
        return Promise.all(rows.map(async (r) => ({
          requestId: r.requestId,
          code: await deviceLinkCode(r.ephemeralPublicKey),
          createdAt: new Date(r.createdAt),
          ephemeralPublicKey: r.ephemeralPublicKey
        })));
      }
      /** 사용자가 코드를 대조하고 승인했다 — 계정 키 묶음을 새 기기의 임시 공개키로 감싸 올린다. */
      async approveDeviceLink(requestId, ephemeralPublicKey) {
        if (!this.stored) {
          throw new Error("\uC774 \uAE30\uAE30\uC5D0 \uB300\uD654 \uC7A0\uAE08 \uD0A4\uAC00 \uC5C6\uC5B4\uC694.");
        }
        const payload = await sealDeviceLinkPayload({
          ephemeralPublicKey,
          bundle: this.stored.bundle,
          requestId
        });
        await this.deps.chatDeviceLink.approve({
          requestId,
          payload
        });
      }
      async rejectDeviceLink(requestId) {
        await this.deps.chatDeviceLink.cancel(requestId);
      }
      // ── 관리 ──
      /** 이 기기에서 키 삭제(공용 PC 등). 서버 키는 그대로라 다음 진입 때 restore 상태가 된다. */
      async forgetLocalKey() {
        await this.deps.store.deleteAccount(this.deps.employeeId);
        await this.deps.store.clearEpochKeys();
        this.pair = null;
        this.stored = null;
        this.state = "restore";
      }
      async fingerprint() {
        return this.stored ? fingerprintPublicKey(this.stored.bundle.ecdhPublicKey) : null;
      }
      async saveLocal(bundle, version) {
        const record = {
          employeeId: this.deps.employeeId,
          organizationId: this.deps.organizationId,
          version,
          // 평범한 객체로 다시 만든다 — UI(Alpine) 상태에서 온 묶음은 Proxy 라 IndexedDB 가 DataCloneError 로 거절한다
          // (CS-OKBEST-261009-0001 · MED-978: 서버 등록은 됐는데 이 기기 저장만 실패). 필드는 전부 문자열·숫자다.
          bundle: plainAccountBundle(bundle),
          savedAt: (/* @__PURE__ */ new Date()).toISOString()
        };
        await this.deps.store.putAccount(record);
        await this.deps.store.clearEpochKeys();
        this.stored = record;
        this.state = "ready";
      }
    }, __name(_a106, "_ChatKeyManager"), _a106);
    __name2(_ChatKeyManager, "ChatKeyManager");
    ChatKeyManager = _ChatKeyManager;
    __name(plainAccountBundle, "plainAccountBundle");
    __name2(plainAccountBundle, "plainAccountBundle");
    _ConversationKeyManager = (_a107 = class {
      constructor(deps) {
        __publicField(this, "deps");
        __publicField(this, "keys", /* @__PURE__ */ new Map());
        __publicField(this, "myEcdsaPublicKey", null);
        this.deps = deps;
      }
      get employeeId() {
        return this.deps.employeeId;
      }
      cacheKey(conversationId, epoch) {
        return `${conversationId}:${epoch}`;
      }
      /** 세대 키(AES-KW). 캐시·저장소에 없으면 null — 호출자가 `sync` 를 먼저 돌려야 한다. */
      async getRoomKey(conversationId, epoch) {
        const k = this.cacheKey(conversationId, epoch);
        const cached = this.keys.get(k);
        if (cached) {
          return cached;
        }
        const raw = await this.deps.store.getEpochKey(conversationId, epoch);
        if (!raw) {
          return null;
        }
        const key = await importRoomKey(raw);
        this.keys.set(k, key);
        return key;
      }
      async remember(conversationId, epoch, raw) {
        await this.deps.store.putEpochKey(conversationId, epoch, raw);
        this.keys.set(this.cacheKey(conversationId, epoch), await importRoomKey(raw));
      }
      /**
      * 세대 서명 검증(E9) — "trusted" | "server" | "untrusted".
      * 서명이 있으면: 약속값 = sha256(방 키) 이어야 하고, 서명자의 그 version ECDSA 공개키(고정값)로 서명이 맞아야 한다.
      * 서명이 없으면: 서버 이관 세대(reason migration, createdBy 없음)만 "server". 디렉터리가 없는 호출자는 전부 믿는다.
      */
      async verifyEpoch(conversationId, meta, raw) {
        if (!this.deps.directory) {
          return "trusted";
        }
        if (!meta) {
          return "untrusted";
        }
        if (!meta.signature) {
          return meta.reason === "migration" && !meta.createdBy ? "server" : "untrusted";
        }
        if (!meta.createdBy || meta.signerKeyVersion === null || !meta.keyCommitment) {
          return "untrusted";
        }
        if (await roomKeyCommitment(raw) !== meta.keyCommitment) {
          return "untrusted";
        }
        const signerKey = meta.createdBy === this.deps.employeeId ? await this.mySignerKey(meta.signerKeyVersion) : await this.deps.directory.ecdsaKeyForVersion(meta.createdBy, meta.signerKeyVersion);
        if (!signerKey) {
          return "untrusted";
        }
        const ok = await verifyBytes(signerKey, buildEpochAttestationBytes({
          organizationId: this.deps.organizationId,
          conversationId,
          epoch: meta.epoch,
          reason: meta.reason,
          keyCommitment: meta.keyCommitment
        }), meta.signature);
        return ok ? "trusted" : "untrusted";
      }
      /**
      * 내가 서명한 세대는 내 키로 — 지금 version 이면 호출자가 넣어 준 내 ECDSA 공개키, **옛 version 이면 서버 이력**에서.
      * 예전엔 지금 version 만 받아들여, 키를 다시 만든 뒤 **내가 예전 키로 연 세대**(1:1 방은 재설정할 때마다 내가 세대를
      * 올리므로 현재 세대가 거의 늘 내 서명이다)를 못 믿어 그 방이 영영 「서명을 확인할 수 없음」·보내기 막힘이 됐다
      * (2026-10-20 DM 보고, 로컬 재현: untrustedEpochs [4] · rekeyed false). 이력의 옛 키는 폐기된 키라 바꿔치기해 얻을 것이 없다.
      */
      async mySignerKey(version) {
        const account = this.deps.accountKey();
        if (!account) {
          return null;
        }
        if (account.version === version) {
          return this.myEcdsaPublicKey ?? null;
        }
        return this.deps.directory ? await this.deps.directory.ecdsaKeyForVersion(this.deps.employeeId, version) : null;
      }
      /**
      * 방을 열 때 한 번. `allowCreate` 는 조직이 암호화를 켰고 이 방이 암호화 대상(공식 알림 아님)일 때만 true.
      */
      async sync(conversationId, allowCreate) {
        const account = this.deps.accountKey();
        const result = {
          currentEpoch: null,
          haveCurrentKey: false,
          created: false,
          rotated: false,
          reopened: false,
          rekeyed: false,
          filled: 0,
          untrustedEpochs: [],
          serverMintedEpochs: [],
          heldForKeyChange: [],
          heldForMembership: []
        };
        if (!account) {
          return result;
        }
        const mine = await this.deps.conversationKey.myEnvelopes(conversationId);
        result.currentEpoch = mine.currentEpoch;
        const metaByEpoch = new Map((mine.epochs ?? []).map((e) => [
          e.epoch,
          e
        ]));
        for (const e of mine.envelopes) {
          if (e.recipientKeyVersion !== account.version) {
            continue;
          }
          if (await this.getRoomKey(conversationId, e.epoch)) {
            continue;
          }
          let raw;
          try {
            raw = await openEpochEnvelope({
              recipientEcdhPrivateKey: account.pair.ecdh.privateKey,
              envelope: e.envelope,
              header: {
                organizationId: this.deps.organizationId,
                conversationId,
                epoch: e.epoch,
                recipientEmployeeId: this.deps.employeeId,
                recipientKeyVersion: account.version
              }
            });
          } catch {
            continue;
          }
          const verdict = await this.verifyEpoch(conversationId, metaByEpoch.get(e.epoch), raw);
          if (verdict === "untrusted") {
            result.untrustedEpochs.push(e.epoch);
            continue;
          }
          if (verdict === "server") {
            result.serverMintedEpochs.push(e.epoch);
          }
          await this.remember(conversationId, e.epoch, raw);
        }
        if (mine.currentEpoch === null) {
          if (!allowCreate) {
            return result;
          }
          await this.openEpoch(conversationId, 1, "create", account);
          result.currentEpoch = 1;
          result.created = true;
        } else if (mine.stale && await this.getRoomKey(conversationId, mine.currentEpoch)) {
          const next = mine.currentEpoch + 1;
          await this.openEpoch(conversationId, next, "member_removed", account);
          result.currentEpoch = next;
          result.rotated = true;
        } else if (allowCreate && mine.otherHolders !== void 0 && !result.untrustedEpochs.includes(mine.currentEpoch) && !await this.getRoomKey(conversationId, mine.currentEpoch)) {
          const rekeyed = mine.envelopes.some((e) => e.recipientKeyVersion < account.version);
          if (mine.otherHolders === 0 || rekeyed) {
            const next = mine.currentEpoch + 1;
            await this.openEpoch(conversationId, next, "rotate", account);
            result.currentEpoch = next;
            result.rotated = true;
            result.reopened = mine.otherHolders === 0;
            result.rekeyed = rekeyed && mine.otherHolders !== 0;
          }
        }
        const fill = await this.fillMissing(conversationId);
        result.filled = fill.sent;
        result.heldForKeyChange = fill.heldForKeyChange;
        result.heldForMembership = fill.heldForMembership;
        result.haveCurrentKey = result.currentEpoch !== null && await this.getRoomKey(conversationId, result.currentEpoch) !== null;
        let missingPast = false;
        for (const e of mine.epochs ?? []) {
          if (e.epoch !== result.currentEpoch && !await this.getRoomKey(conversationId, e.epoch)) {
            missingPast = true;
            break;
          }
        }
        if (result.currentEpoch !== null && (!result.haveCurrentKey && (mine.otherHolders ?? 0) > 0 || missingPast)) {
          this.deps.conversationKey.requestEnvelopes?.(conversationId).catch(() => void 0);
        }
        return result;
      }
      async openEpoch(conversationId, epoch, reason, account) {
        const raw = generateRoomKey();
        const envelope = await sealEpochEnvelope({
          recipientEcdhPublicKey: account.ecdhPublicKey,
          roomKey: raw,
          header: {
            organizationId: this.deps.organizationId,
            conversationId,
            epoch,
            recipientEmployeeId: this.deps.employeeId,
            recipientKeyVersion: account.version
          }
        });
        const keyCommitment = await roomKeyCommitment(raw);
        const signature = await signBytes(account.pair.ecdsa.privateKey, buildEpochAttestationBytes({
          organizationId: this.deps.organizationId,
          conversationId,
          epoch,
          reason,
          keyCommitment
        }));
        await this.deps.conversationKey.publish({
          conversationId,
          epoch,
          reason,
          envelopes: [
            {
              recipientEmployeeId: this.deps.employeeId,
              recipientKeyVersion: account.version,
              envelope
            }
          ],
          attestation: {
            signerKeyVersion: account.version,
            keyCommitment,
            signature
          }
        });
        await this.remember(conversationId, epoch, raw);
      }
      /**
      * 합류 서명(E9) — **더는 봉투를 막지 않는다**(2026-10-20). 서버를 믿기로 한 결정(10-15, 상대 키 자동 수용)과 같은 선상이다.
      * 예전엔 사람이 넣은 멤버(addedBy 있음)는 넣은 사람 기기의 서명이 있어야 봉투를 줬는데, 서명 없이 만들어진 옛 1:1 방
      * (키가 생기기 전·옛 클라이언트가 만든 방)의 상대는 **모든 세대** 봉투가 영영 보류돼 아무것도 못 읽었다(dev 1:1 보고:
      * missingRecipients 가 1~9 세대 전부, membership.attestation null). 서명이 있으면 확인해 틀린 경우만 기록용으로 남긴다.
      */
      async membershipAllowed(conversationId, r) {
        const m = r.membership;
        const a = m?.attestation;
        if (!(this.deps.directory && m?.addedBy && a)) {
          return true;
        }
        if (!a.employeeIds.includes(r.employeeId)) {
          return true;
        }
        const signerKey = m.addedBy === this.deps.employeeId ? await this.mySignerKey(a.signerKeyVersion) : await this.deps.directory.ecdsaKeyForVersion(m.addedBy, a.signerKeyVersion);
        if (!signerKey) {
          return true;
        }
        const ok = await verifyBytes(signerKey, buildMembershipAttestationBytes({
          organizationId: this.deps.organizationId,
          conversationId: a.action === "create" ? null : conversationId,
          action: a.action,
          employeeIds: a.employeeIds,
          at: a.at
        }), a.signature);
        return ok;
      }
      /**
      * 봉투가 없는 멤버에게 내가 가진 세대 키를 봉투로 보낸다 — 받는 사람의 고정된 키에만(E9).
      * 디렉터리 응답이 어긋나거나 합류 서명이 **틀린** 경우만 보류하고 이름을 돌려준다(서명이 없는 멤버는 준다, 2026-10-20).
      */
      async fillMissing(conversationId) {
        const out = {
          sent: 0,
          heldForKeyChange: [],
          heldForMembership: []
        };
        const { currentEpoch, missing } = await this.deps.conversationKey.missingRecipients(conversationId);
        if (currentEpoch === null || missing.length === 0) {
          return out;
        }
        const others = [
          ...new Set(missing.map((m) => m.employeeId))
        ].filter((id) => id !== this.deps.employeeId);
        const infos = this.deps.directory ? await this.deps.directory.resolve(others) : null;
        const held = /* @__PURE__ */ new Set();
        const heldMembership = /* @__PURE__ */ new Set();
        const allowed = [];
        for (const m of missing) {
          if (infos && m.employeeId !== this.deps.employeeId) {
            const info = infos.get(m.employeeId);
            if (!info?.trusted || info.trusted.ecdhPublicKey !== m.ecdhPublicKey || info.trusted.version !== m.keyVersion) {
              held.add(m.employeeId);
              continue;
            }
          }
          if (!await this.membershipAllowed(conversationId, m)) {
            heldMembership.add(m.employeeId);
            continue;
          }
          allowed.push(m);
        }
        out.heldForKeyChange = [
          ...held
        ];
        out.heldForMembership = [
          ...heldMembership
        ];
        const byEpoch = /* @__PURE__ */ new Map();
        for (const m of allowed) {
          const list = byEpoch.get(m.epoch) ?? [];
          list.push(m);
          byEpoch.set(m.epoch, list);
        }
        for (const [epoch, recipients] of byEpoch) {
          const raw = await this.deps.store.getEpochKey(conversationId, epoch);
          if (!raw) {
            continue;
          }
          const envelopes = await Promise.all(recipients.map(async (r) => ({
            recipientEmployeeId: r.employeeId,
            recipientKeyVersion: r.keyVersion,
            envelope: await sealEpochEnvelope({
              recipientEcdhPublicKey: r.ecdhPublicKey,
              roomKey: raw,
              header: {
                organizationId: this.deps.organizationId,
                conversationId,
                epoch,
                recipientEmployeeId: r.employeeId,
                recipientKeyVersion: r.keyVersion
              }
            })
          })));
          await this.deps.conversationKey.publish({
            conversationId,
            epoch,
            envelopes
          });
          out.sent += envelopes.length;
        }
        return out;
      }
      /** 로그인 직원이 바뀌었을 때 메모리 캐시 비우기(저장소는 호출자가 clearEpochKeys). */
      clear() {
        this.keys.clear();
      }
    }, __name(_a107, "_ConversationKeyManager"), _a107);
    __name2(_ConversationKeyManager, "ConversationKeyManager");
    ConversationKeyManager = _ConversationKeyManager;
    __name(signMembershipChange, "signMembershipChange");
    __name2(signMembershipChange, "signMembershipChange");
    recoveryKeyCache = /* @__PURE__ */ new Map();
    __name(recoveryKey, "recoveryKey");
    __name2(recoveryKey, "recoveryKey");
    __name(newMessageId, "newMessageId");
    __name2(newMessageId, "newMessageId");
    __name(encryptOutgoingMessage, "encryptOutgoingMessage");
    __name2(encryptOutgoingMessage, "encryptOutgoingMessage");
    __name(decryptIncomingMessage, "decryptIncomingMessage");
    __name2(decryptIncomingMessage, "decryptIncomingMessage");
    __name(isEncryptedMessage, "isEncryptedMessage");
    __name2(isEncryptedMessage, "isEncryptedMessage");
    _PeerKeyDirectory = (_a108 = class {
      constructor(deps) {
        __publicField(this, "deps");
        this.deps = deps;
      }
      nowIso() {
        return (this.deps.now?.() ?? /* @__PURE__ */ new Date()).toISOString();
      }
      /** 서버의 지금 키를 받아 고정값과 대조 — 처음이면 고정, 같으면 same, 다르면 changed(pending 기록). */
      async resolve(employeeIds) {
        const out = /* @__PURE__ */ new Map();
        const ids = [
          ...new Set(employeeIds)
        ].filter(Boolean);
        if (ids.length === 0) {
          return out;
        }
        const remote = await this.deps.chatKey.publicKeys(ids);
        const byId = new Map(remote.map((r) => [
          r.employeeId,
          r
        ]));
        for (const id of ids) {
          const r = byId.get(id);
          const pin = await this.deps.store.getPeerPin(id);
          if (!r) {
            out.set(id, {
              employeeId: id,
              version: pin?.version ?? 0,
              ecdhPublicKey: pin?.ecdhPublicKey ?? "",
              ecdsaPublicKey: pin?.ecdsaPublicKey ?? "",
              status: "missing",
              trusted: pin ? pinTrusted(pin) : null
            });
            continue;
          }
          const now = this.nowIso();
          if (!pin) {
            await this.deps.store.putPeerPin({
              employeeId: id,
              version: r.version,
              ecdhPublicKey: r.ecdhPublicKey,
              ecdsaPublicKey: r.ecdsaPublicKey,
              firstSeenAt: now,
              lastSeenAt: now,
              pending: null
            });
            out.set(id, {
              ...r,
              status: "new",
              trusted: {
                ...r
              }
            });
            continue;
          }
          if (sameKey(pin, r)) {
            if (pin.pending) {
              await this.deps.store.putPeerPin({
                ...pin,
                pending: null,
                lastSeenAt: now
              });
            } else {
              await this.deps.store.putPeerPin({
                ...pin,
                lastSeenAt: now
              });
            }
            out.set(id, {
              ...r,
              status: "same",
              trusted: pinTrusted(pin)
            });
            continue;
          }
          await this.deps.store.putPeerPin({
            employeeId: id,
            version: r.version,
            ecdhPublicKey: r.ecdhPublicKey,
            ecdsaPublicKey: r.ecdsaPublicKey,
            firstSeenAt: now,
            lastSeenAt: now,
            pending: null
          });
          out.set(id, {
            ...r,
            status: "changed",
            trusted: {
              ...r
            }
          });
        }
        return out;
      }
      /** (레거시) 보류 중 키를 고정값으로 — 자동 수용 뒤에는 pending 이 남지 않아 false 를 돌려준다. */
      async acknowledge(employeeId) {
        const pin = await this.deps.store.getPeerPin(employeeId);
        if (!pin?.pending) {
          return false;
        }
        const now = this.nowIso();
        await this.deps.store.putPeerPin({
          employeeId,
          version: pin.pending.version,
          ecdhPublicKey: pin.pending.ecdhPublicKey,
          ecdsaPublicKey: pin.pending.ecdsaPublicKey,
          firstSeenAt: now,
          lastSeenAt: now,
          pending: null
        });
        return true;
      }
      async pinned(employeeId) {
        return this.deps.store.getPeerPin(employeeId);
      }
      /**
      * 서명 검증에 쓸 ECDSA 공개키 — 그 version 이 고정된 키면 그것, 확인 전(pending) version 이면 null(믿지 않음),
      * 고정 version 보다 **오래된** version 이면 서버 이력에서 가져온다(이미 폐기된 키라 바꿔치기해 얻을 것이 없다).
      */
      async ecdsaKeyForVersion(employeeId, version) {
        const pin = await this.deps.store.getPeerPin(employeeId);
        if (pin?.version === version) {
          return pin.ecdsaPublicKey;
        }
        const info = (await this.resolve([
          employeeId
        ])).get(employeeId);
        if (info && info.status !== "missing" && info.version === version) {
          return info.ecdsaPublicKey;
        }
        const history = await this.deps.chatKey.history(employeeId);
        return history.find((h) => h.version === version)?.ecdsaPublicKey ?? null;
      }
    }, __name(_a108, "_PeerKeyDirectory"), _a108);
    __name2(_PeerKeyDirectory, "PeerKeyDirectory");
    PeerKeyDirectory = _PeerKeyDirectory;
    __name(sameKey, "sameKey");
    __name2(sameKey, "sameKey");
    __name(pinTrusted, "pinTrusted");
    __name2(pinTrusted, "pinTrusted");
    ENCRYPTED_PUSH_KIND = "chat_message_encrypted";
    PUSH_BODY_MAX = 200;
    __name(isEncryptedPushData, "isEncryptedPushData");
    __name2(isEncryptedPushData, "isEncryptedPushData");
    __name(decryptPushBody, "decryptPushBody");
    __name2(decryptPushBody, "decryptPushBody");
    __name(sendTextToConversation, "sendTextToConversation");
    __name2(sendTextToConversation, "sendTextToConversation");
    __name(pollAsyncOperation, "pollAsyncOperation");
    __name2(pollAsyncOperation, "pollAsyncOperation");
    _HerebySDKError = (_a109 = class extends Error {
      constructor(message, code, statusCode, details) {
        super(message);
        __publicField(this, "code");
        __publicField(this, "statusCode");
        __publicField(this, "details");
        this.name = "HerebySDKError";
        this.code = code;
        this.statusCode = statusCode;
        this.details = details;
      }
    }, __name(_a109, "_HerebySDKError"), _a109);
    __name2(_HerebySDKError, "HerebySDKError");
    HerebySDKError = _HerebySDKError;
    _AuthenticationError = (_a110 = class extends HerebySDKError {
      constructor(message = "Authentication failed", details) {
        super(message, "AUTHENTICATION_ERROR", 401, details);
        this.name = "AuthenticationError";
      }
    }, __name(_a110, "_AuthenticationError"), _a110);
    __name2(_AuthenticationError, "AuthenticationError");
    AuthenticationError = _AuthenticationError;
    _AuthorizationError = (_a111 = class extends HerebySDKError {
      constructor(message = "Access denied", details) {
        super(message, "AUTHORIZATION_ERROR", 403, details);
        this.name = "AuthorizationError";
      }
    }, __name(_a111, "_AuthorizationError"), _a111);
    __name2(_AuthorizationError, "AuthorizationError");
    AuthorizationError = _AuthorizationError;
    _ValidationError = (_a112 = class extends HerebySDKError {
      constructor(message = "Validation failed", details) {
        super(message, "VALIDATION_ERROR", 400, details);
        this.name = "ValidationError";
      }
    }, __name(_a112, "_ValidationError"), _a112);
    __name2(_ValidationError, "ValidationError");
    ValidationError = _ValidationError;
    _NotFoundError = (_a113 = class extends HerebySDKError {
      constructor(message = "Resource not found", details) {
        super(message, "NOT_FOUND", 404, details);
        this.name = "NotFoundError";
      }
    }, __name(_a113, "_NotFoundError"), _a113);
    __name2(_NotFoundError, "NotFoundError");
    NotFoundError = _NotFoundError;
    _NetworkError = (_a114 = class extends HerebySDKError {
      constructor(message = "Network request failed", details) {
        super(message, "NETWORK_ERROR", 0, details);
        this.name = "NetworkError";
      }
    }, __name(_a114, "_NetworkError"), _a114);
    __name2(_NetworkError, "NetworkError");
    NetworkError = _NetworkError;
    _TimeoutError = (_a115 = class extends HerebySDKError {
      constructor(message = "Request timeout", details) {
        super(message, "TIMEOUT_ERROR", 408, details);
        this.name = "TimeoutError";
      }
    }, __name(_a115, "_TimeoutError"), _a115);
    __name2(_TimeoutError, "TimeoutError");
    TimeoutError = _TimeoutError;
    __name(parseTRPCError, "parseTRPCError");
    __name2(parseTRPCError, "parseTRPCError");
    __name(handleSDKError, "handleSDKError");
    __name2(handleSDKError, "handleSDKError");
    __name(fetchAllPages, "fetchAllPages");
    __name2(fetchAllPages, "fetchAllPages");
    _LocalStorageAdapter = (_a116 = class {
      constructor(prefix) {
        __publicField(this, "accessTokenKey", "hereby_access_token");
        __publicField(this, "refreshTokenKey", "hereby_refresh_token");
        if (prefix) {
          this.accessTokenKey = `${prefix}_access_token`;
          this.refreshTokenKey = `${prefix}_refresh_token`;
        }
      }
      getAccessToken() {
        if (typeof window === "undefined") {
          return null;
        }
        return localStorage.getItem(this.accessTokenKey);
      }
      getRefreshToken() {
        if (typeof window === "undefined") {
          return null;
        }
        return localStorage.getItem(this.refreshTokenKey);
      }
      setTokens(accessToken, refreshToken) {
        if (typeof window === "undefined") {
          return;
        }
        localStorage.setItem(this.accessTokenKey, accessToken);
        if (refreshToken) {
          localStorage.setItem(this.refreshTokenKey, refreshToken);
        }
      }
      clearTokens() {
        if (typeof window === "undefined") {
          return;
        }
        localStorage.removeItem(this.accessTokenKey);
        localStorage.removeItem(this.refreshTokenKey);
      }
    }, __name(_a116, "_LocalStorageAdapter"), _a116);
    __name2(_LocalStorageAdapter, "LocalStorageAdapter");
    LocalStorageAdapter = _LocalStorageAdapter;
    _SessionStorageAdapter = (_a117 = class {
      constructor(prefix) {
        __publicField(this, "accessTokenKey", "hereby_access_token");
        __publicField(this, "refreshTokenKey", "hereby_refresh_token");
        if (prefix) {
          this.accessTokenKey = `${prefix}_access_token`;
          this.refreshTokenKey = `${prefix}_refresh_token`;
        }
      }
      getAccessToken() {
        if (typeof window === "undefined") {
          return null;
        }
        return sessionStorage.getItem(this.accessTokenKey);
      }
      getRefreshToken() {
        if (typeof window === "undefined") {
          return null;
        }
        return sessionStorage.getItem(this.refreshTokenKey);
      }
      setTokens(accessToken, refreshToken) {
        if (typeof window === "undefined") {
          return;
        }
        sessionStorage.setItem(this.accessTokenKey, accessToken);
        if (refreshToken) {
          sessionStorage.setItem(this.refreshTokenKey, refreshToken);
        }
      }
      clearTokens() {
        if (typeof window === "undefined") {
          return;
        }
        sessionStorage.removeItem(this.accessTokenKey);
        sessionStorage.removeItem(this.refreshTokenKey);
      }
    }, __name(_a117, "_SessionStorageAdapter"), _a117);
    __name2(_SessionStorageAdapter, "SessionStorageAdapter");
    SessionStorageAdapter = _SessionStorageAdapter;
    _MemoryStorageAdapter = (_a118 = class {
      constructor() {
        __publicField(this, "accessToken", null);
        __publicField(this, "refreshToken", null);
      }
      getAccessToken() {
        return this.accessToken;
      }
      getRefreshToken() {
        return this.refreshToken;
      }
      setTokens(accessToken, refreshToken) {
        this.accessToken = accessToken;
        if (refreshToken) {
          this.refreshToken = refreshToken;
        }
      }
      clearTokens() {
        this.accessToken = null;
        this.refreshToken = null;
      }
    }, __name(_a118, "_MemoryStorageAdapter"), _a118);
    __name2(_MemoryStorageAdapter, "MemoryStorageAdapter");
    MemoryStorageAdapter = _MemoryStorageAdapter;
    _CookieStorageAdapter = (_a119 = class {
      constructor(prefix) {
        __publicField(this, "accessTokenKey", "hereby_access_token");
        __publicField(this, "refreshTokenKey", "hereby_refresh_token");
        if (prefix) {
          this.accessTokenKey = `${prefix}_access_token`;
          this.refreshTokenKey = `${prefix}_refresh_token`;
        }
      }
      getCookie(name) {
        if (typeof document === "undefined") {
          return null;
        }
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
          return parts.pop()?.split(";").shift() || null;
        }
        return null;
      }
      setCookie(name, value, days = 7) {
        if (typeof document === "undefined") {
          return;
        }
        const date = /* @__PURE__ */ new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
      }
      deleteCookie(name) {
        if (typeof document === "undefined") {
          return;
        }
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
      }
      getAccessToken() {
        return this.getCookie(this.accessTokenKey);
      }
      getRefreshToken() {
        return this.getCookie(this.refreshTokenKey);
      }
      setTokens(accessToken, refreshToken) {
        this.setCookie(this.accessTokenKey, accessToken);
        if (refreshToken) {
          this.setCookie(this.refreshTokenKey, refreshToken, 30);
        }
      }
      clearTokens() {
        this.deleteCookie(this.accessTokenKey);
        this.deleteCookie(this.refreshTokenKey);
      }
    }, __name(_a119, "_CookieStorageAdapter"), _a119);
    __name2(_CookieStorageAdapter, "CookieStorageAdapter");
    CookieStorageAdapter = _CookieStorageAdapter;
    __name(isValidEmail, "isValidEmail");
    __name2(isValidEmail, "isValidEmail");
    __name(isValidKoreanPhone, "isValidKoreanPhone");
    __name2(isValidKoreanPhone, "isValidKoreanPhone");
    __name(isValidKoreanRRN, "isValidKoreanRRN");
    __name2(isValidKoreanRRN, "isValidKoreanRRN");
    __name(validatePasswordStrength, "validatePasswordStrength");
    __name2(validatePasswordStrength, "validatePasswordStrength");
    __name(isValidBusinessNumber, "isValidBusinessNumber");
    __name2(isValidBusinessNumber, "isValidBusinessNumber");
    __name(formatKoreanPhone, "formatKoreanPhone");
    __name2(formatKoreanPhone, "formatKoreanPhone");
    __name(formatKRW, "formatKRW");
    __name2(formatKRW, "formatKRW");
    __name(isValidDateRange, "isValidDateRange");
    __name2(isValidDateRange, "isValidDateRange");
    __name(isKoreanHoliday, "isKoreanHoliday");
    __name2(isKoreanHoliday, "isKoreanHoliday");
    __name(calculateAgeFromRRN, "calculateAgeFromRRN");
    __name2(calculateAgeFromRRN, "calculateAgeFromRRN");
    __name(createHerebyClient, "createHerebyClient");
    __name2(createHerebyClient, "createHerebyClient");
    src_default = HerebyClient;
  }
});

// src/approval-decision.ts
import { LEAVE_OVERUSE_CONFIRM_PREFIX } from "@hereby/core/constants";

// src/dialog.ts
var DEFAULT_CONFIRM_LABEL = "\uD655\uC778";
var DEFAULT_TITLE = "\uD655\uC778";
function resolveTitle(title) {
  if (title === void 0) {
    return DEFAULT_TITLE;
  }
  return title === false ? "" : title;
}
__name(resolveTitle, "resolveTitle");
var DEFAULT_CANCEL_LABEL = "\uCDE8\uC18C";
function normalizeEmphasis(input) {
  if (!input) {
    return [];
  }
  return (Array.isArray(input) ? input : [
    input
  ]).filter(Boolean);
}
__name(normalizeEmphasis, "normalizeEmphasis");
function splitEmphasis(message, marks) {
  const valid = marks.filter(Boolean);
  if (valid.length === 0) {
    return [
      {
        text: message,
        bold: false
      }
    ];
  }
  const segments = [];
  let rest = message;
  while (rest) {
    let at = -1;
    let mark = "";
    for (const candidate of valid) {
      const found = rest.indexOf(candidate);
      if (found >= 0 && (at < 0 || found < at)) {
        at = found;
        mark = candidate;
      }
    }
    if (at < 0) {
      segments.push({
        text: rest,
        bold: false
      });
      break;
    }
    if (at > 0) {
      segments.push({
        text: rest.slice(0, at),
        bold: false
      });
    }
    segments.push({
      text: mark,
      bold: true
    });
    rest = rest.slice(at + mark.length);
  }
  return segments;
}
__name(splitEmphasis, "splitEmphasis");
var host = null;
function registerDialogHost(state3) {
  host = state3;
}
__name(registerDialogHost, "registerDialogHost");
function hasDialogHost() {
  return host !== null;
}
__name(hasDialogHost, "hasDialogHost");
function resetDialogHost() {
  host = null;
}
__name(resetDialogHost, "resetDialogHost");
function toRequest(opts) {
  return typeof opts === "string" ? {
    message: opts
  } : opts;
}
__name(toRequest, "toRequest");
function assignBodyExtras(state3, req) {
  state3.details = req.details ?? [];
  state3.table = req.table ?? null;
  state3.notice = req.notice ?? null;
  state3.footnote = req.footnote ?? "";
}
__name(assignBodyExtras, "assignBodyExtras");
function dismissOpenDialog() {
  if (!host?.open) {
    return false;
  }
  const resolve2 = host.resolver;
  const result = host.kind === "choice" ? "cancel" : host.kind === "prompt" ? null : false;
  host.open = false;
  host.resolver = null;
  resolve2?.(result);
  return true;
}
__name(dismissOpenDialog, "dismissOpenDialog");
function showAlert(opts) {
  const req = toRequest(opts);
  if (!host) {
    return;
  }
  host.resolver?.(false);
  host.kind = "alert";
  host.reportable = req.tone === "danger" && typeof document !== "undefined" && !!document.querySelector("[data-cs-report-host]");
  host.title = resolveTitle(req.title);
  host.message = req.message;
  host.confirmLabel = req.confirmLabel ?? DEFAULT_CONFIRM_LABEL;
  host.tone = req.tone ?? "default";
  host.emphasis = normalizeEmphasis(req.emphasis);
  assignBodyExtras(host, req);
  host.resolver = null;
  host.open = true;
}
__name(showAlert, "showAlert");
function showError(opts) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("hereby:cs-report-precapture"));
  }
  showAlert({
    ...toRequest(opts),
    tone: "danger"
  });
}
__name(showError, "showError");
function askConfirm(opts) {
  const req = toRequest(opts);
  if (!host) {
    return Promise.resolve(true);
  }
  const state3 = host;
  state3.resolver?.(false);
  return new Promise((resolve2) => {
    state3.kind = "confirm";
    state3.reportable = false;
    state3.title = resolveTitle(req.title);
    state3.message = req.message;
    state3.confirmLabel = req.confirmLabel ?? DEFAULT_CONFIRM_LABEL;
    state3.cancelLabel = req.cancelLabel ?? DEFAULT_CANCEL_LABEL;
    state3.tone = req.tone ?? "default";
    state3.emphasis = normalizeEmphasis(req.emphasis);
    assignBodyExtras(state3, req);
    state3.resolver = resolve2;
    state3.open = true;
  });
}
__name(askConfirm, "askConfirm");
function askChoice(opts) {
  if (!host) {
    return Promise.resolve("cancel");
  }
  const state3 = host;
  state3.resolver?.(false);
  return new Promise((resolve2) => {
    state3.kind = "choice";
    state3.reportable = false;
    state3.title = resolveTitle(opts.title);
    state3.message = opts.message;
    state3.confirmLabel = opts.confirmLabel ?? DEFAULT_CONFIRM_LABEL;
    state3.altLabel = opts.altLabel;
    state3.tone = opts.tone ?? "default";
    state3.emphasis = normalizeEmphasis(opts.emphasis);
    assignBodyExtras(state3, opts);
    state3.resolver = (v) => {
      resolve2(v === "confirm" || v === "alt" ? v : "cancel");
    };
    state3.open = true;
  });
}
__name(askChoice, "askChoice");
function showPrompt(opts) {
  const req = typeof opts === "string" ? {
    message: opts
  } : opts;
  if (!host) {
    return Promise.resolve(null);
  }
  const state3 = host;
  state3.resolver?.(false);
  return new Promise((resolve2) => {
    state3.kind = "prompt";
    state3.inputType = req.inputType ?? "text";
    state3.reportable = false;
    state3.title = resolveTitle(req.title);
    state3.message = req.message;
    state3.value = req.value ?? "";
    state3.placeholder = req.placeholder ?? "";
    state3.requireValue = req.requireValue ?? false;
    state3.confirmLabel = req.confirmLabel ?? DEFAULT_CONFIRM_LABEL;
    state3.cancelLabel = req.cancelLabel ?? DEFAULT_CANCEL_LABEL;
    state3.tone = req.tone ?? "default";
    state3.emphasis = normalizeEmphasis(req.emphasis);
    assignBodyExtras(state3, req);
    state3.resolver = (result) => {
      state3.value = "";
      resolve2(typeof result === "string" ? result : null);
    };
    state3.open = true;
  });
}
__name(showPrompt, "showPrompt");
function createDialogStore() {
  return {
    open: false,
    kind: "alert",
    title: "",
    message: "",
    confirmLabel: DEFAULT_CONFIRM_LABEL,
    cancelLabel: DEFAULT_CANCEL_LABEL,
    altLabel: "",
    tone: "default",
    emphasis: [],
    details: [],
    table: null,
    notice: null,
    footnote: "",
    value: "",
    inputType: "text",
    placeholder: "",
    requireValue: false,
    reportable: false,
    resolver: null,
    /**
    * Alpine 이 스토어 등록 직후 호출한다. 여기서의 `this` 는 반응형 프록시라,
    * 팩토리가 돌려준 원본이 아니라 이 프록시를 브리지에 등록해야 모듈에서
    * 바꾼 값이 화면에 반영된다.
    */
    init() {
      registerDialogHost(this);
    },
    /** 본문 조각(부분 굵게) — 템플릿이 x-for 로 돌면서 x-text 로 그린다. */
    get messageSegments() {
      return splitEmphasis(this.message ?? "", this.emphasis ?? []);
    },
    /** HTML 안 Alpine 식에서 쓰는 짧은 이름 — `await $store.dialog.ask('...')`. */
    ask(opts) {
      return askConfirm(opts);
    },
    choose(opts) {
      return askChoice(opts);
    },
    alert(opts) {
      showAlert(opts);
    },
    prompt(opts) {
      return showPrompt(opts);
    },
    /** requireValue 인데 입력이 비었으면 확인을 막는다(버튼 비활성 + Enter 무시). */
    get confirmDisabled() {
      return this.kind === "prompt" && this.requireValue && this.value.trim() === "";
    },
    /** 확인 — confirm 은 true, prompt 는 입력값(trim), choice 는 "confirm", alert 는 그냥 닫기. */
    accept() {
      if (this.confirmDisabled) {
        return;
      }
      if (this.kind === "choice") {
        this.settle("confirm");
        return;
      }
      this.settle(this.kind === "prompt" ? this.inputType === "password" ? this.value : this.value.trim() : true);
    },
    /**
    * 오류 얼럿의 「리포트 보내기」 — 다이얼로그를 닫고 CS 리포트 모달을 연다.
    * 오류 스냅샷은 SDK 수집기(마지막 오류)와 예비 캡처가 이미 들고 있다.
    */
    report() {
      this.settle(false);
      if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("hereby:cs-report-open"));
      }
    },
    /** 선택형의 가운데 버튼(대안). 다른 종류에서는 호출되지 않는다. */
    acceptAlt() {
      if (this.kind !== "choice") {
        return;
      }
      this.settle("alt");
    },
    /**
    * 취소 · Esc — confirm 은 false, prompt 는 null, choice 는 "cancel".
    * 선택형에는 취소 버튼이 없으므로 이 길은 Esc 전용이다.
    */
    cancel() {
      if (this.kind === "choice") {
        this.settle("cancel");
        return;
      }
      this.settle(this.kind === "prompt" ? null : false);
    },
    settle(result) {
      if (!this.open) {
        return;
      }
      this.open = false;
      const resolve2 = this.resolver;
      this.resolver = null;
      resolve2?.(result);
    }
  };
}
__name(createDialogStore, "createDialogStore");

// src/approval-decision.ts
var ALREADY_DONE = /이미 처리|Only pending|already (processed|approved|rejected)/i;
var NETWORK = /fetch|network|timeout|load failed|ECONN/i;
function readTrpcErrorCode(error) {
  const e = error;
  const code = e?.data?.code ?? e?.code;
  return typeof code === "string" ? code : null;
}
__name(readTrpcErrorCode, "readTrpcErrorCode");
function readMessage(error) {
  const e = error;
  return typeof e?.message === "string" ? e.message : "";
}
__name(readMessage, "readMessage");
function explainDecisionError(error) {
  const code = readTrpcErrorCode(error);
  const message = readMessage(error);
  if (code === "CONFLICT" || code === "BAD_REQUEST" && ALREADY_DONE.test(message)) {
    return {
      kind: "conflict",
      message: "\uC774\uBBF8 \uCC98\uB9AC\uB41C \uBB38\uC11C\uC608\uC694. \uCD5C\uC2E0 \uC0C1\uD0DC\uB85C \uAC31\uC2E0\uD588\uC5B4\uC694.",
      shouldRefresh: true
    };
  }
  if (code === "FORBIDDEN") {
    const base = message.trim().endsWith("\uC694.") ? message.trim() : "\uC9C0\uAE08\uC740 \uB2E4\uB978 \uC0AC\uB78C \uCC28\uB840\uC608\uC694.";
    return {
      kind: "forbidden",
      message: `${base} \uCD5C\uC2E0 \uC0C1\uD0DC\uB85C \uAC31\uC2E0\uD588\uC5B4\uC694.`,
      shouldRefresh: true
    };
  }
  if (!code && (error instanceof TypeError || NETWORK.test(message))) {
    return {
      kind: "network",
      message: "\uCC98\uB9AC \uACB0\uACFC\uB97C \uD655\uC778\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694. \uCD5C\uC2E0 \uC0C1\uD0DC\uB97C \uB2E4\uC2DC \uBD88\uB7EC\uC654\uC5B4\uC694.",
      shouldRefresh: true
    };
  }
  return {
    kind: "other",
    message: message || "\uCC98\uB9AC\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694.",
    shouldRefresh: false
  };
}
__name(explainDecisionError, "explainDecisionError");
function decisionResultMessage(result, fallback = "\uCC98\uB9AC\uD588\uC5B4\uC694.") {
  const r = result;
  return typeof r?.message === "string" && r.message.trim() ? r.message : fallback;
}
__name(decisionResultMessage, "decisionResultMessage");
async function handleDecisionError(error, opts = {}) {
  const view = explainDecisionError(error);
  if (view.shouldRefresh && opts.refresh) {
    try {
      await opts.refresh();
    } catch {
    }
  }
  if (!opts.silent) {
    if (view.kind === "other") {
      showError(view.message);
    } else {
      showAlert(view.message);
    }
  }
  return view;
}
__name(handleDecisionError, "handleDecisionError");
async function withOveruseConfirm(run2) {
  try {
    return await run2(false);
  } catch (error) {
    if (!isOveruseConfirmError(error)) {
      throw error;
    }
    const ok = await askConfirm({
      message: readMessage(error),
      confirmLabel: "\uCD08\uACFC \uC2B9\uC778",
      tone: "danger"
    });
    if (!ok) {
      return null;
    }
    return run2(true);
  }
}
__name(withOveruseConfirm, "withOveruseConfirm");
function isOveruseConfirmError(error) {
  return readTrpcErrorCode(error) === "PRECONDITION_FAILED" && readMessage(error).startsWith(LEAVE_OVERUSE_CONFIRM_PREFIX);
}
__name(isOveruseConfirmError, "isOveruseConfirmError");

// src/chat-device-link-watch.ts
init_dist();

// src/components/messenger-helpers.ts
import { isPushAllowed, minuteOfDayInTimezone } from "@hereby/core/constants";
function buildConversationItem(c, currentUserId) {
  let contactName = c.customName || c.title || "";
  let contactRole = "";
  let contactProfilePicture = null;
  if (c.type === "direct" && Array.isArray(c.members)) {
    const peer = c.members.find((m) => m.employeeId !== currentUserId);
    contactProfilePicture = peer?.profilePicture ?? null;
  }
  if (!contactName && c.type === "direct" && c.members) {
    const other = c.members.find((m) => m.employeeId !== currentUserId);
    if (other) {
      contactName = `${other.lastName || ""}${other.firstName || ""}`.trim();
      contactRole = "";
    } else {
      contactName = "\uC54C \uC218 \uC5C6\uC74C";
    }
  } else if (c.type === "group") {
    if (!contactName) {
      contactName = c.title || "\uADF8\uB8F9";
    }
    const memberCount = c.members?.length || 0;
    contactRole = `${memberCount}\uBA85`;
  } else if (c.type === "department") {
    if (!contactName) {
      contactName = c.title || "\uBD80\uC11C \uB2E8\uD1A1\uBC29";
    }
    const memberCount = c.members?.length || 0;
    contactRole = `${memberCount}\uBA85`;
  } else if (c.type === "workflow") {
    contactName = contactName || "\uACF5\uC2DD \uC548\uB0B4";
    contactRole = "\uB2F5\uC7A5\uD560 \uC218 \uC5C6\uB294 \uC2DC\uC2A4\uD15C \uC548\uB0B4";
  } else if (c.type === "self") {
    contactName = c.customName || "\uB098\uC640\uC758 \uB300\uD654";
    contactRole = "\uB098\uC5D0\uAC8C \uBCF4\uB0B4\uB294 \uBA54\uBAA8\xB7\uD30C\uC77C";
  }
  const memberNames = Array.isArray(c.members) ? c.members.map((m) => `${m.lastName || ""}${m.firstName || ""}`.trim()) : [];
  const memberIds = Array.isArray(c.members) ? c.members.map((m) => m.employeeId).filter(Boolean) : [];
  return {
    id: c.id,
    type: c.type || "direct",
    title: c.title || "",
    contactName: contactName || "\uB300\uD654",
    contactRole,
    contactProfilePicture,
    memberNames,
    memberIds,
    lastMessage: c.lastMessageContent || "",
    lastMessageTime: c.lastMessageAt || c.createdAt || "",
    unreadCount: c.unreadCount || 0,
    // 목록을 새로 불러오면 '방금 도착' 표시는 리셋된다 — 실시간 수신에서만 켠다.
    hasNewMessage: false,
    isPinned: false,
    customName: c.customName || void 0,
    // 알림을 꺼 둔 방(MED-942) — 종 꺼짐 표시·브라우저 알림 생략의 근거.
    muted: Boolean(c.muted),
    // 암호화 세대(MED-894) — null 이면 평문 방. 세대 키 동기화·암복호 판단의 근거.
    encryptionEpoch: typeof c.encryptionEpoch === "number" ? c.encryptionEpoch : null,
    encryptionEpochStale: Boolean(c.encryptionEpochStale),
    // 암호화 방의 마지막 메시지(암호문) — decryptConversationPreviews 가 기기 키로 풀어 lastMessage 를 채운다.
    lastMessageEncrypted: c.lastMessage ? {
      ...c.lastMessage
    } : null
  };
}
__name(buildConversationItem, "buildConversationItem");
function encryptedPreviewText(source, plain, labels) {
  if (source.isDeleted) {
    return labels.deleted;
  }
  if (!plain) {
    return null;
  }
  if (plain.text) {
    return source.type === "image" || source.type === "file" ? `${labels.file} ${plain.text}` : plain.text;
  }
  const names = (plain.attachments ?? []).map((a) => a.name).join(", ");
  return names ? `${labels.file} ${names}` : null;
}
__name(encryptedPreviewText, "encryptedPreviewText");
function canMuteConversation(conv) {
  return conv.type === "group" || conv.type === "department" || conv.type === "channel" || conv.type === "direct";
}
__name(canMuteConversation, "canMuteConversation");
function canLeaveFromList(conv) {
  return conv.type !== "self" && conv.type !== "workflow" && conv.type !== "department";
}
__name(canLeaveFromList, "canLeaveFromList");
function conversationMenuItems(conv) {
  if (!conv) {
    return [];
  }
  const items = [];
  if ((conv.unreadCount ?? 0) > 0) {
    items.push({
      key: "mark_read",
      icon: "ic-check",
      labelKey: "messenger.mark_read"
    });
  }
  if (canMuteConversation(conv)) {
    items.push(conv.muted ? {
      key: "unmute",
      icon: "ic-bell",
      labelKey: "messenger.mute_off"
    } : {
      key: "mute",
      icon: "ic-bell-off",
      labelKey: "messenger.mute_on"
    });
  }
  if (canLeaveFromList(conv)) {
    items.push({
      key: "leave",
      icon: "ic-logout",
      labelKey: "messenger.leave_room",
      danger: true
    });
  }
  return items;
}
__name(conversationMenuItems, "conversationMenuItems");
var MESSAGE_GROUP_WINDOW_MS = 5 * 6e4;
function isMessageContinuation(prev, cur, windowMs = MESSAGE_GROUP_WINDOW_MS) {
  if (!prev || prev.type === "system" || cur.type === "system" || prev.senderId !== cur.senderId) {
    return false;
  }
  const a = new Date(prev.timestamp).getTime();
  const b = new Date(cur.timestamp).getTime();
  if (Number.isNaN(a) || Number.isNaN(b)) {
    return false;
  }
  const gap = b - a;
  return gap >= 0 && gap <= windowMs;
}
__name(isMessageContinuation, "isMessageContinuation");
function senderMenuItems(conv) {
  const items = [
    {
      key: "view_profile",
      icon: "ic-user",
      labelKey: "messenger.view_profile"
    }
  ];
  if (!conv) {
    return items;
  }
  if (conv.type !== "direct") {
    items.push({
      key: "direct_chat",
      icon: "ic-message",
      labelKey: "messenger.direct_chat"
    });
  }
  if (conv.type === "group" || conv.type === "department" || conv.type === "channel") {
    items.push({
      key: "mention",
      icon: "ic-at-sign",
      labelKey: "messenger.mention_user"
    });
  }
  return items;
}
__name(senderMenuItems, "senderMenuItems");
var UNASSIGNED_TEAM_KEY = "__unassigned__";
function compareTeamMeta(a, b) {
  const ao = a.sortOrder;
  const bo = b.sortOrder;
  if (ao !== null && bo !== null && ao !== bo) {
    return ao - bo;
  }
  if (ao !== null && bo === null) {
    return -1;
  }
  if (ao === null && bo !== null) {
    return 1;
  }
  return a.name.localeCompare(b.name, "ko", {
    numeric: true
  }) || a.id.localeCompare(b.id);
}
__name(compareTeamMeta, "compareTeamMeta");
function ancestryOf(id, meta) {
  const chain = [];
  const seen = /* @__PURE__ */ new Set();
  let cur = meta.get(id);
  while (cur && !seen.has(cur.id)) {
    seen.add(cur.id);
    chain.unshift(cur);
    cur = cur.parentTeamId ? meta.get(cur.parentTeamId) : void 0;
  }
  return chain;
}
__name(ancestryOf, "ancestryOf");
function compareTeamTreePosition(aId, bId, meta) {
  const a = ancestryOf(aId, meta);
  const b = ancestryOf(bId, meta);
  const n = Math.min(a.length, b.length);
  for (let i = 0; i < n; i++) {
    if (a[i].id !== b[i].id) {
      return compareTeamMeta(a[i], b[i]);
    }
  }
  return a.length - b.length;
}
__name(compareTeamTreePosition, "compareTeamTreePosition");
function isTeamWithin(id, rootId, meta) {
  return ancestryOf(id, meta).some((t) => t.id === rootId);
}
__name(isTeamWithin, "isTeamWithin");
function groupContactsByTeam(contacts, unassignedLabel, options = {}) {
  const byTeam = /* @__PURE__ */ new Map();
  const meta = /* @__PURE__ */ new Map();
  for (const contact of contacts) {
    for (const team of contact.teams) {
      if (!meta.has(team.id)) {
        meta.set(team.id, {
          id: team.id,
          name: team.name,
          sortOrder: typeof team.sortOrder === "number" ? team.sortOrder : null,
          parentTeamId: team.parentTeamId ?? null
        });
      }
    }
  }
  const unassigned = {
    key: UNASSIGNED_TEAM_KEY,
    name: unassignedLabel,
    contacts: [],
    ids: []
  };
  for (const contact of contacts) {
    if (contact.teams.length === 0) {
      unassigned.contacts.push(contact);
      unassigned.ids.push(contact.id);
      continue;
    }
    for (const team of contact.teams) {
      let group = byTeam.get(team.id);
      if (!group) {
        group = {
          key: team.id,
          name: team.name,
          contacts: [],
          ids: []
        };
        byTeam.set(team.id, group);
      }
      if (!group.ids.includes(contact.id)) {
        group.contacts.push(contact);
        group.ids.push(contact.id);
      }
    }
  }
  let groups = [
    ...byTeam.values()
  ].sort((a, b) => compareTeamTreePosition(a.key, b.key, meta));
  const filterTeamId = options.filterTeamId ?? null;
  if (filterTeamId) {
    return groups.filter((g) => isTeamWithin(g.key, filterTeamId, meta));
  }
  const pinned = options.pinnedTeamIds ?? [];
  if (pinned.length > 0) {
    const rank = new Map(pinned.map((id, i) => [
      id,
      i
    ]));
    const top = groups.filter((g) => rank.has(g.key)).sort((a, b) => (rank.get(a.key) ?? 0) - (rank.get(b.key) ?? 0));
    groups = [
      ...top,
      ...groups.filter((g) => !rank.has(g.key))
    ];
  }
  if (unassigned.contacts.length > 0) {
    groups.push(unassigned);
  }
  return groups;
}
__name(groupContactsByTeam, "groupContactsByTeam");
function contactMatchesTerm(contact, term) {
  return contact.name.toLowerCase().includes(term) || contact.role.toLowerCase().includes(term) || contact.team.toLowerCase().includes(term) || contact.teams.some((t) => t.name.toLowerCase().includes(term));
}
__name(contactMatchesTerm, "contactMatchesTerm");
function contactMeta(contact) {
  const parts = [
    contact.team,
    contact.role
  ].filter(Boolean);
  return [
    ...new Set(parts)
  ].join(" \xB7 ");
}
__name(contactMeta, "contactMeta");
function findTeamConversation(conversations, team, teams) {
  const sharedName = teams.some((t) => t.key !== team.key && t.name === team.name);
  return conversations.find((c) => c.type === "group" && c.title === team.name && (!sharedName || (c.memberIds ?? []).some((id) => team.ids.includes(id))));
}
__name(findTeamConversation, "findTeamConversation");
function selectionState(ids, selected) {
  let picked = 0;
  for (const id of ids) {
    if (selected.has(id)) {
      picked++;
    }
  }
  if (picked === 0) {
    return "none";
  }
  return picked === ids.length ? "all" : "some";
}
__name(selectionState, "selectionState");
function toggleSelection(selected, ids) {
  const next = new Set(selected);
  if (selectionState(ids, selected) === "all") {
    for (const id of ids) {
      next.delete(id);
    }
  } else {
    for (const id of ids) {
      next.add(id);
    }
  }
  return next;
}
__name(toggleSelection, "toggleSelection");
function sortNoticesUnacknowledgedFirst(notices) {
  const pending = /* @__PURE__ */ __name((n) => n.requiresAcknowledgment && !n.isAcknowledged, "pending");
  return [
    ...notices.filter(pending),
    ...notices.filter((n) => !pending(n))
  ];
}
__name(sortNoticesUnacknowledgedFirst, "sortNoticesUnacknowledgedFirst");
function messengerListNotices(notices, readIds) {
  return sortNoticesUnacknowledgedFirst(notices).filter((n) => n.requiresAcknowledgment ? !n.isAcknowledged : !readIds.has(n.id));
}
__name(messengerListNotices, "messengerListNotices");
var NOTICE_READ_EVENT = "hereby:notice-read";
var READ_NOTICES_KEY = "hereby.messenger.readNotices";
var READ_NOTICES_MAX = 200;
function readNoticeIds(userId) {
  try {
    const raw = localStorage.getItem(`${READ_NOTICES_KEY}.${userId}`);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((k) => typeof k === "string") : []);
  } catch (_e) {
    return /* @__PURE__ */ new Set();
  }
}
__name(readNoticeIds, "readNoticeIds");
function writeNoticeIds(userId, ids) {
  try {
    localStorage.setItem(`${READ_NOTICES_KEY}.${userId}`, JSON.stringify([
      ...ids
    ].slice(-READ_NOTICES_MAX)));
  } catch (_e) {
  }
}
__name(writeNoticeIds, "writeNoticeIds");
function contactProfileRows(p) {
  const rows = p.teams.filter((t) => t.name).map((t, i) => ({
    key: `team:${t.id || i}`,
    label: "\uC18C\uC18D",
    value: t.roleName ? `${t.name} \xB7 ${t.roleName}` : t.name
  }));
  const fields = [
    [
      "\uC9C1\uBB34",
      p.jobDuty
    ],
    [
      "\uC9C1\uAD70",
      p.jobCategory
    ],
    [
      "\uC9C1\uC704",
      p.position
    ],
    [
      "\uC774\uBA54\uC77C",
      p.email
    ]
  ];
  for (const [label, value] of fields) {
    if (value) {
      rows.push({
        key: label,
        label,
        value
      });
    }
  }
  if (p.phoneShared && p.phone) {
    rows.push({
      key: "phone",
      label: "\uC804\uD654\uBC88\uD638",
      value: p.phone
    });
  }
  return rows;
}
__name(contactProfileRows, "contactProfileRows");
function shouldSendOnEnter(e) {
  return !(e.isComposing || e.shiftKey || e.coarsePointer);
}
__name(shouldSendOnEnter, "shouldSendOnEnter");
function applyMembersToItem(item, members) {
  const memberIds = members.map((m) => m.employeeId);
  const memberNames = members.map((m) => m.name);
  const contactRole = item.type === "group" || item.type === "department" ? `${memberIds.length}\uBA85` : item.contactRole;
  return {
    ...item,
    memberIds,
    memberNames,
    contactRole
  };
}
__name(applyMembersToItem, "applyMembersToItem");
function hasMessengerBackLayer(state3) {
  if (state3.previewImageUrl) {
    return true;
  }
  if (state3.groupSelectMode || state3.showGroupTitleSheet) {
    return true;
  }
  return state3.activeView !== "conversations" && state3.activeView !== "contacts";
}
__name(hasMessengerBackLayer, "hasMessengerBackLayer");
function isCoarsePointer() {
  return typeof window !== "undefined" && !!window.matchMedia?.("(pointer: coarse)").matches;
}
__name(isCoarsePointer, "isCoarsePointer");
function canDeleteMessage(msg) {
  if (!msg.isMine || msg.isDeleted) {
    return false;
  }
  if (msg.type === "system" || msg.origin === "workflow") {
    return false;
  }
  if (msg.status === "sending" || msg.status === "failed" || msg.id.startsWith("m_")) {
    return false;
  }
  return true;
}
__name(canDeleteMessage, "canDeleteMessage");
function removeMemberFromItem(item, employeeId) {
  if (!(item.members || item.memberIds)) {
    return item;
  }
  const members = item.members?.filter((m) => m.employeeId !== employeeId);
  const memberIds = item.memberIds?.filter((id) => id !== employeeId);
  const count = memberIds?.length ?? members?.length ?? 0;
  const contactRole = item.type === "group" || item.type === "department" ? `${count}\uBA85` : item.contactRole;
  return {
    ...item,
    ...members ? {
      members
    } : {},
    ...memberIds ? {
      memberIds
    } : {},
    contactRole
  };
}
__name(removeMemberFromItem, "removeMemberFromItem");
function applyMessageDeletion(messages, messageId) {
  const index = messages.findIndex((m) => m.id === messageId);
  if (index < 0) {
    return {
      found: false,
      wasLast: false
    };
  }
  const target = messages[index];
  target.isDeleted = true;
  target.content = "";
  target.attachments = [];
  target.action = null;
  for (const m of messages) {
    if (m.replyTo && m.replyTo.id === messageId) {
      m.replyTo.isDeleted = true;
      m.replyTo.content = "";
    }
  }
  return {
    found: true,
    wasLast: index === messages.length - 1
  };
}
__name(applyMessageDeletion, "applyMessageDeletion");
function clampMenuPosition(point, viewport, menu = {
  width: 160,
  height: 44
}) {
  const margin = 8;
  return {
    x: Math.max(margin, Math.min(point.x, viewport.width - menu.width - margin)),
    y: Math.max(margin, Math.min(point.y, viewport.height - menu.height - margin))
  };
}
__name(clampMenuPosition, "clampMenuPosition");
function canOpenMessageMenu(msg) {
  if (msg.isDeleted || msg.type === "system" || msg.origin === "workflow") {
    return false;
  }
  if (msg.status === "sending" || msg.status === "failed" || msg.id.startsWith("m_")) {
    return false;
  }
  return true;
}
__name(canOpenMessageMenu, "canOpenMessageMenu");
function summarizeReplyTarget(msg) {
  const content = msg.isDeleted ? "" : msg.content;
  return {
    id: msg.id,
    senderId: msg.senderId,
    senderName: msg.senderName,
    content: content.length > 80 ? `${content.slice(0, 80)}\u2026` : content,
    type: msg.type,
    isDeleted: msg.isDeleted
  };
}
__name(summarizeReplyTarget, "summarizeReplyTarget");
function replyPreviewText(reply, labels) {
  if (reply.isDeleted) {
    return "";
  }
  if (reply.type === "image") {
    return reply.content ? `${labels.image} ${reply.content}` : labels.image;
  }
  if (reply.type === "file") {
    return reply.content ? `${labels.file} ${reply.content}` : labels.file;
  }
  return reply.content;
}
__name(replyPreviewText, "replyPreviewText");
var MENTION_ALL_ID = "__all__";
function mentionQueryAt(text, caret) {
  const before = text.slice(0, caret);
  const m = /(^|\s)@([^\s@]{0,30})$/.exec(before);
  if (!m) {
    return null;
  }
  return {
    start: before.length - m[2].length - 1,
    query: m[2]
  };
}
__name(mentionQueryAt, "mentionQueryAt");
function insertMention(text, start, caret, name) {
  const inserted = `@${name} `;
  return {
    text: `${text.slice(0, start)}${inserted}${text.slice(caret)}`,
    caret: start + inserted.length
  };
}
__name(insertMention, "insertMention");
function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
__name(escapeRegExp, "escapeRegExp");
function hasMentionToken(text, name) {
  return new RegExp(`(^|\\s)@${escapeRegExp(name)}(?=\\s|$|[.,!?~])`).test(text);
}
__name(hasMentionToken, "hasMentionToken");
function collectMentions(text, picked, allLabel) {
  const all = picked.some((p) => p.employeeId === MENTION_ALL_ID) && hasMentionToken(text, allLabel);
  const seen = /* @__PURE__ */ new Set();
  const users = [];
  for (const p of picked) {
    if (p.employeeId === MENTION_ALL_ID || seen.has(p.employeeId)) {
      continue;
    }
    if (hasMentionToken(text, p.name)) {
      seen.add(p.employeeId);
      users.push({
        employeeId: p.employeeId,
        name: p.name
      });
    }
  }
  if (!all && users.length === 0) {
    return null;
  }
  return {
    all,
    users
  };
}
__name(collectMentions, "collectMentions");
function mentionsToInput(meta) {
  if (!meta) {
    return void 0;
  }
  return {
    all: meta.all,
    employeeIds: meta.users.map((u) => u.employeeId)
  };
}
__name(mentionsToInput, "mentionsToInput");
function escapeHtmlText(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
__name(escapeHtmlText, "escapeHtmlText");
function linkifyEscapedText(escaped) {
  return escaped.replace(/https?:\/\/[^\s<]+/g, (raw) => {
    let url = raw;
    let tail = "";
    while (url.length > 0 && /[.,!?;:)\]」』》'"]$/.test(url)) {
      tail = url.slice(-1) + tail;
      url = url.slice(0, -1);
    }
    if (!url) {
      return raw;
    }
    return `<a class="ds-bubble__link" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>${tail}`;
  });
}
__name(linkifyEscapedText, "linkifyEscapedText");
function renderMessageHtml(content, mentions, allLabel) {
  let html = linkifyEscapedText(escapeHtmlText(content));
  if (!mentions) {
    return html;
  }
  const entries = [
    ...mentions.all ? [
      {
        employeeId: MENTION_ALL_ID,
        name: allLabel
      }
    ] : [],
    ...mentions.users
  ].sort((a, b) => b.name.length - a.name.length);
  for (const u of entries) {
    const token = escapeHtmlText(`@${u.name}`);
    const re = new RegExp(`(^|\\s)(${escapeRegExp(token)})(?=\\s|$|&|[.,!?~])`, "g");
    html = html.replace(re, (_m, lead, tok) => `${lead}<span class="ds-mention" data-employee-id="${escapeHtmlText(u.employeeId)}">${tok}</span>`);
  }
  return html;
}
__name(renderMessageHtml, "renderMessageHtml");
function mentionsMe(mentions, meId) {
  if (!mentions) {
    return false;
  }
  return mentions.all || mentions.users.some((u) => u.employeeId === meId);
}
__name(mentionsMe, "mentionsMe");
function isMessengerPreviewBlocked(currentUser) {
  return currentUser?.impersonating === true;
}
__name(isMessengerPreviewBlocked, "isMessengerPreviewBlocked");
function isPendingLocalMessage(m) {
  return m.status === "sending" || m.status === "failed" || m.id.startsWith("m_");
}
__name(isPendingLocalMessage, "isPendingLocalMessage");
function timeOf(m) {
  const t = new Date(m.timestamp).getTime();
  return Number.isNaN(t) ? 0 : t;
}
__name(timeOf, "timeOf");
function mergeLatestMessagePage(current2, latest) {
  if (latest.length === 0) {
    return {
      messages: [
        ...current2
      ],
      added: 0,
      replaced: false
    };
  }
  const pending = current2.filter(isPendingLocalMessage);
  const confirmed = current2.filter((m) => !isPendingLocalMessage(m));
  const latestIds = new Set(latest.map((m) => m.id));
  const sendingContents = pending.filter((m) => m.status === "sending").map((m) => m.content);
  const confirmedIds = new Set(confirmed.map((m) => m.id));
  const shadowedServerIds = /* @__PURE__ */ new Set();
  for (const m of latest) {
    if (!m.isMine || confirmedIds.has(m.id)) {
      continue;
    }
    const at = sendingContents.indexOf(m.content);
    if (at >= 0) {
      sendingContents.splice(at, 1);
      shadowedServerIds.add(m.id);
    }
  }
  const usableLatest = latest.filter((m) => !shadowedServerIds.has(m.id));
  const overlaps = confirmed.some((m) => latestIds.has(m.id));
  if (confirmed.length > 0 && !overlaps) {
    const newest = Math.max(...confirmed.map(timeOf));
    const oldestLatest = Math.min(...usableLatest.map(timeOf));
    if (usableLatest.length > 0 && oldestLatest > newest) {
      return {
        messages: [
          ...usableLatest,
          ...pending
        ],
        added: usableLatest.length,
        replaced: true
      };
    }
  }
  const serverById = new Map(usableLatest.map((m) => [
    m.id,
    m
  ]));
  let added = 0;
  const merged = confirmed.map((m) => {
    const server = serverById.get(m.id);
    return server?.isDeleted && !m.isDeleted ? server : m;
  });
  for (const m of usableLatest) {
    if (!confirmedIds.has(m.id)) {
      merged.push(m);
      added++;
    }
  }
  merged.sort((a, b) => timeOf(a) - timeOf(b));
  return {
    messages: [
      ...merged,
      ...pending
    ],
    added,
    replaced: false
  };
}
__name(mergeLatestMessagePage, "mergeLatestMessagePage");
function shouldResync(state3, now, minGapMs = 2e3) {
  return !state3.inFlight && now - state3.lastAt >= minGapMs;
}
__name(shouldResync, "shouldResync");
var CHAT_NEAR_BOTTOM_PX = 160;
function isChatNearBottom(el2) {
  return el2.scrollHeight - el2.scrollTop - el2.clientHeight < CHAT_NEAR_BOTTOM_PX;
}
__name(isChatNearBottom, "isChatNearBottom");
function formatNewMessageCount(n) {
  if (!Number.isFinite(n) || n <= 0) {
    return "";
  }
  return n > 99 ? "99+" : String(Math.floor(n));
}
__name(formatNewMessageCount, "formatNewMessageCount");
function unreadMemberIds(message, memberIds, readStates, viewerId) {
  const at = Date.parse(message.timestamp);
  if (Number.isNaN(at)) {
    return [];
  }
  return memberIds.filter((id) => {
    if (id === message.senderId || id === viewerId) {
      return false;
    }
    const read = readStates[id];
    const readAt = read ? Date.parse(read) : Number.NaN;
    return Number.isNaN(readAt) || readAt < at;
  });
}
__name(unreadMemberIds, "unreadMemberIds");
function applyMemberRead(readStates, employeeId, lastReadAt) {
  const prev = readStates[employeeId];
  if (prev && Date.parse(prev) >= Date.parse(lastReadAt)) {
    return readStates;
  }
  return {
    ...readStates,
    [employeeId]: lastReadAt
  };
}
__name(applyMemberRead, "applyMemberRead");
function subscribeRetryDelayMs(attempt) {
  const n = Math.max(1, Math.floor(attempt));
  return Math.min(3e3 * 2 ** (n - 1), 3e4);
}
__name(subscribeRetryDelayMs, "subscribeRetryDelayMs");
function localChatNotificationAllowed(settings, now, timezone) {
  if (!settings) {
    return true;
  }
  return isPushAllowed({
    pushEnabled: settings.pushEnabled,
    mutedAll: settings.mutedAll,
    categoryEnabled: settings.categoryEnabled,
    quietHours: settings.quietHours,
    minuteOfDay: settings.quietHours ? minuteOfDayInTimezone(now, timezone) : void 0
  }).allowed;
}
__name(localChatNotificationAllowed, "localChatNotificationAllowed");
function buildLocalChatNotification(params) {
  const format = params.format || "name_only";
  const title = format === "generic" ? params.labels.genericTitle : params.senderName || params.labels.genericTitle;
  const body = format === "name_body" && params.body ? params.body : params.labels.genericBody;
  return {
    title,
    body
  };
}
__name(buildLocalChatNotification, "buildLocalChatNotification");
async function loadLocalNotifySource(sdk, now = /* @__PURE__ */ new Date()) {
  if (!sdk?.notification) {
    return null;
  }
  try {
    const [prefs, mutes, quiet2, format] = await Promise.all([
      sdk.notification.getSettings(),
      sdk.notification.getMuteList(),
      sdk.notification.getPushQuietHours(),
      sdk.notification.getMessengerPushFormat()
    ]);
    const t = now.getTime();
    return {
      prefs: prefs ?? {},
      mutedAll: (mutes || []).some((m) => m.muteType === "all" && (!m.expiresAt || new Date(m.expiresAt).getTime() >= t)),
      quietHours: quiet2?.quietHours ?? null,
      format: format?.format ?? null
    };
  } catch {
    return null;
  }
}
__name(loadLocalNotifySource, "loadLocalNotifySource");
function localNotifySettingsFor(source, category) {
  if (!source) {
    return null;
  }
  return {
    pushEnabled: source.prefs["*"]?.push,
    mutedAll: source.mutedAll,
    categoryEnabled: source.prefs[`category:${category}`]?.push,
    quietHours: source.quietHours,
    format: source.format
  };
}
__name(localNotifySettingsFor, "localNotifySettingsFor");
function aggregateUploadProgress(sizes, loaded) {
  const total = sizes.reduce((a, b) => a + Math.max(0, b), 0);
  if (total <= 0) {
    return 1;
  }
  const done = sizes.reduce((sum, size, i) => sum + Math.min(Math.max(0, loaded[i] ?? 0), size), 0);
  return Math.min(1, done / total);
}
__name(aggregateUploadProgress, "aggregateUploadProgress");
var DOUBLE_TAP_WINDOW_MS = 350;
function registerTap(prev, messageId, now, windowMs = DOUBLE_TAP_WINDOW_MS) {
  if (prev && prev.messageId === messageId && now - prev.at <= windowMs) {
    return {
      doubleTap: true,
      next: null
    };
  }
  return {
    doubleTap: false,
    next: {
      messageId,
      at: now
    }
  };
}
__name(registerTap, "registerTap");
var LAST_REACTION_KEY = "hereby:lastReaction";
function readLastReaction(allowed, fallback, storage2 = typeof localStorage === "undefined" ? null : localStorage) {
  try {
    const saved = storage2?.getItem(LAST_REACTION_KEY);
    return saved && allowed.includes(saved) ? saved : fallback;
  } catch {
    return fallback;
  }
}
__name(readLastReaction, "readLastReaction");
function writeLastReaction(emoji, storage2 = typeof localStorage === "undefined" ? null : localStorage) {
  try {
    storage2?.setItem(LAST_REACTION_KEY, emoji);
  } catch {
  }
}
__name(writeLastReaction, "writeLastReaction");
function canCopyMessage(msg) {
  if (msg.isDeleted || msg.isUnreadable || msg.type === "system") {
    return false;
  }
  return msg.content.trim().length > 0;
}
__name(canCopyMessage, "canCopyMessage");
function canForwardMessage(msg) {
  if (msg.isDeleted || msg.isUnreadable || msg.type === "system" || msg.origin === "workflow") {
    return false;
  }
  if (msg.status === "sending" || msg.status === "uploading" || msg.status === "failed") {
    return false;
  }
  const hasFiles = msg.attachments.some((a) => Boolean(a.storagePath));
  return hasFiles || msg.content.trim().length > 0;
}
__name(canForwardMessage, "canForwardMessage");
function forwardTargets(conversations, currentId, query) {
  const term = query.trim().toLowerCase();
  return conversations.filter((c) => {
    if (c.id === currentId || c.type === "workflow") {
      return false;
    }
    if (!term) {
      return true;
    }
    return c.contactName.toLowerCase().includes(term) || (c.memberNames ?? []).some((n) => n.toLowerCase().includes(term));
  });
}
__name(forwardTargets, "forwardTargets");
function chatDraftStorageKey(userId) {
  return `hereby:chatDrafts:${userId}`;
}
__name(chatDraftStorageKey, "chatDraftStorageKey");
function readChatDrafts(storage2, key) {
  try {
    const raw = storage2?.getItem(key);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    const out = {};
    for (const [id, v] of Object.entries(parsed)) {
      const d = v;
      if (d && typeof d.text === "string" && d.text.length > 0) {
        out[id] = {
          text: d.text,
          replyToId: typeof d.replyToId === "string" ? d.replyToId : null,
          updatedAt: typeof d.updatedAt === "number" ? d.updatedAt : 0
        };
      }
    }
    return out;
  } catch {
    return {};
  }
}
__name(readChatDrafts, "readChatDrafts");
function updateChatDraft(drafts, conversationId, draft, now = Date.now(), storage2 = null, key = "") {
  const next = {
    ...drafts
  };
  const text = draft?.text ?? "";
  if (text.trim().length === 0) {
    delete next[conversationId];
  } else {
    next[conversationId] = {
      text,
      replyToId: draft?.replyToId ?? null,
      updatedAt: now
    };
  }
  const ids = Object.keys(next).sort((a, b) => next[b].updatedAt - next[a].updatedAt);
  for (const id of ids.slice(200)) {
    delete next[id];
  }
  if (storage2 && key) {
    try {
      if (Object.keys(next).length === 0) {
        storage2.removeItem(key);
      } else {
        storage2.setItem(key, JSON.stringify(next));
      }
    } catch {
    }
  }
  return next;
}
__name(updateChatDraft, "updateChatDraft");
var GENERIC_IMAGE_NAME = /^(image|blob|clipboard|screenshot|스크린샷)?(\.[a-z0-9]+)?$/i;
function screenshotFileName(now, mime) {
  const pad3 = /* @__PURE__ */ __name((n) => String(n).padStart(2, "0"), "pad");
  const ext = mime === "image/jpeg" ? "jpg" : mime === "image/gif" ? "gif" : mime === "image/webp" ? "webp" : "png";
  return `\uC2A4\uD06C\uB9B0\uC0F7 ${now.getFullYear()}-${pad3(now.getMonth() + 1)}-${pad3(now.getDate())} ${pad3(now.getHours())}.${pad3(now.getMinutes())}.${pad3(now.getSeconds())}.${ext}`;
}
__name(screenshotFileName, "screenshotFileName");
function imageFilesFromClipboard(data, now = /* @__PURE__ */ new Date()) {
  if (!data) {
    return [];
  }
  const picked = [];
  const seen = /* @__PURE__ */ new Set();
  const push = /* @__PURE__ */ __name((f) => {
    if (f?.type.startsWith("image/") && !seen.has(f)) {
      seen.add(f);
      picked.push(f);
    }
  }, "push");
  for (const f of Array.from(data.files ?? [])) {
    push(f);
  }
  if (picked.length === 0) {
    for (const item of Array.from(data.items ?? [])) {
      if (item.kind === "file" && item.type.startsWith("image/")) {
        push(item.getAsFile());
      }
    }
  }
  return picked.map((f, i) => {
    if (!GENERIC_IMAGE_NAME.test(f.name)) {
      return f;
    }
    const stamp = new Date(now.getTime() + i * 1e3);
    return new File([
      f
    ], screenshotFileName(stamp, f.type), {
      type: f.type,
      lastModified: f.lastModified
    });
  });
}
__name(imageFilesFromClipboard, "imageFilesFromClipboard");

// src/chat-device-link-watch.ts
var state = {
  prompting: false,
  rejected: /* @__PURE__ */ new Set(),
  pending: []
};
function forgetDeviceLink(requestId) {
  state.pending = state.pending.filter((l) => l.requestId !== requestId);
}
__name(forgetDeviceLink, "forgetDeviceLink");
function markDeviceLinkRejected(requestId) {
  state.rejected.add(requestId);
  forgetDeviceLink(requestId);
}
__name(markDeviceLinkRejected, "markDeviceLinkRejected");
async function checkPendingDeviceLinks(manager, t, options = {}) {
  try {
    state.pending = await manager.listPendingDeviceLinks();
  } catch {
    return state.pending;
  }
  if (options.prompt === false || state.prompting) {
    return state.pending;
  }
  if (!hasDialogHost()) {
    return state.pending;
  }
  const link = state.pending.find((l) => !state.rejected.has(l.requestId));
  if (!link) {
    return state.pending;
  }
  state.prompting = true;
  try {
    const ok = await askConfirm({
      message: t("messenger.lock.approve_prompt", {
        code: link.code
      }),
      confirmLabel: t("messenger.lock.approve_button"),
      cancelLabel: t("messenger.lock.reject_button")
    });
    if (ok) {
      try {
        await manager.approveDeviceLink(link.requestId, link.ephemeralPublicKey);
        forgetDeviceLink(link.requestId);
        showAlert(t("messenger.lock.approve_done"));
      } catch {
        showError(t("messenger.lock.approve_failed"));
      }
    } else {
      markDeviceLinkRejected(link.requestId);
      await manager.rejectDeviceLink(link.requestId).catch(() => void 0);
    }
  } finally {
    state.prompting = false;
  }
  return state.pending;
}
__name(checkPendingDeviceLinks, "checkPendingDeviceLinks");
var POLL_MS = 2e4;
var watchTimer = null;
var watchManager = null;
var watchStore = null;
function watchKeyManager(store) {
  const user = store.currentUser;
  const employeeId = user?.id || "";
  if (!(employeeId && store.sdk)) {
    return null;
  }
  if (!watchManager || watchManager.employeeId !== employeeId) {
    watchStore ?? (watchStore = createDefaultChatKeyStore());
    watchManager = {
      employeeId,
      manager: new ChatKeyManager({
        employeeId,
        organizationId: user?.organizationId || "",
        store: watchStore,
        chatKey: store.sdk.chatKey,
        chatDeviceLink: store.sdk.chatDeviceLink
      })
    };
  }
  return watchManager.manager;
}
__name(watchKeyManager, "watchKeyManager");
async function tickChatDeviceLinkWatch(store) {
  if (!store?.authenticated || store.currentUser?.messengerEncryption !== true || isMessengerPreviewBlocked(store.currentUser) || store.hasPermission?.("conversation:read") !== true) {
    return;
  }
  const manager = watchKeyManager(store);
  if (!manager) {
    return;
  }
  try {
    if (await manager.ensure() !== "ready") {
      return;
    }
  } catch {
    return;
  }
  await checkPendingDeviceLinks(manager, store.t.bind(store));
}
__name(tickChatDeviceLinkWatch, "tickChatDeviceLinkWatch");
function startChatDeviceLinkWatch(getStore) {
  if (watchTimer || typeof window === "undefined") {
    return;
  }
  const tick = /* @__PURE__ */ __name(() => {
    if (typeof document !== "undefined" && document.hidden) {
      return;
    }
    tickChatDeviceLinkWatch(getStore()).catch(() => void 0);
  }, "tick");
  watchTimer = setInterval(tick, POLL_MS);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      tick();
    }
  });
  window.addEventListener("hereby:push-received", (e) => {
    const data = e.detail?.data;
    if (data?.chatDeviceLinkRequestId) {
      tick();
    }
  });
  setTimeout(tick, 3e3);
}
__name(startChatDeviceLinkWatch, "startChatDeviceLinkWatch");

// src/components/AddEmployeePanel.ts
import { compareTeamOrder } from "@hereby/core/constants";

// src/positionFloatingMenu.ts
function measuredWidth(el2) {
  const rect = typeof el2.getBoundingClientRect === "function" ? el2.getBoundingClientRect() : null;
  if (rect?.width) {
    return Math.round(rect.width);
  }
  if (typeof getComputedStyle === "function") {
    const w = Number.parseFloat(getComputedStyle(el2).width);
    if (Number.isFinite(w) && w > 0) {
      return w;
    }
  }
  return 0;
}
__name(measuredWidth, "measuredWidth");
function positionFloatingMenu(triggerEl, menuEl) {
  if (!(triggerEl && menuEl)) {
    return;
  }
  const rect = triggerEl.getBoundingClientRect();
  const root = menuEl.closest(".ds-modal, .ds-mini-modal");
  const rootRect = root?.getBoundingClientRect();
  const menuHeight = menuEl.offsetHeight;
  const menuWidth = menuEl.offsetWidth || measuredWidth(menuEl);
  const leftBase = rootRect?.left ?? 0;
  const topBase = rootRect?.top ?? 0;
  const spaceBelow = rootRect ? rootRect.bottom - rect.bottom : window.innerHeight - rect.bottom;
  const rightBound = rootRect ? (rootRect.right ?? rootRect.left + (rootRect.width ?? 0)) - leftBase : window.innerWidth;
  let left = rect.left - leftBase;
  if (menuWidth && Number.isFinite(rightBound)) {
    left = Math.min(left, rightBound - menuWidth - 4);
  }
  left = Math.max(4, left);
  menuEl.style.left = `${left}px`;
  menuEl.style.top = `${spaceBelow < menuHeight + 8 ? Math.max(4, rect.bottom - topBase - menuHeight - 4) : rect.bottom - topBase + 4}px`;
}
__name(positionFloatingMenu, "positionFloatingMenu");

// src/utils/esc-guard.ts
var permissionModalOpen = false;
var permissionModalClosedAt = 0;
function setPermissionModalOpen(open) {
  if (permissionModalOpen && !open) {
    permissionModalClosedAt = Date.now();
  }
  permissionModalOpen = open;
}
__name(setPermissionModalOpen, "setPermissionModalOpen");
function permissionModalOwnsEsc() {
  return permissionModalOpen || Date.now() - permissionModalClosedAt < 500;
}
__name(permissionModalOwnsEsc, "permissionModalOwnsEsc");
var escLayers = /* @__PURE__ */ new Set();
var escDispatcherInstalled = false;
function isShown(el2) {
  return !!el2 && getComputedStyle(el2).display !== "none";
}
__name(isShown, "isShown");
function zOf(el2) {
  const z = Number.parseInt(getComputedStyle(el2).zIndex, 10);
  return Number.isFinite(z) ? z : 0;
}
__name(zOf, "zOf");
function handleEscapeCapture(event) {
  if (event.key !== "Escape" || event.defaultPrevented) {
    return;
  }
  if (permissionModalOwnsEsc()) {
    return;
  }
  let best = null;
  for (const layer of escLayers) {
    const el2 = layer.getEl();
    if (isShown(el2) && (!best || zOf(el2) >= best.z)) {
      best = {
        z: zOf(el2),
        layer
      };
    }
  }
  if (!best) {
    return;
  }
  const registered = [
    ...escLayers
  ].map((l) => l.getEl()).filter(isShown);
  const legacyTop = [
    ...document.querySelectorAll(".ds-modal-backdrop")
  ].filter((el2) => isShown(el2) && !registered.some((r) => r === el2 || r.contains(el2))).reduce((max, el2) => Math.max(max, zOf(el2)), Number.NEGATIVE_INFINITY);
  if (legacyTop > best.z) {
    return;
  }
  event.stopImmediatePropagation();
  event.preventDefault();
  best.layer.close();
}
__name(handleEscapeCapture, "handleEscapeCapture");
function registerEscLayer(getEl, close) {
  const layer = {
    getEl,
    close
  };
  escLayers.add(layer);
  if (!escDispatcherInstalled && typeof window !== "undefined") {
    window.addEventListener("keydown", handleEscapeCapture, true);
    escDispatcherInstalled = true;
  }
  return () => {
    escLayers.delete(layer);
  };
}
__name(registerEscLayer, "registerEscLayer");

// src/utils/fetch-all-pages.ts
async function fetchAllPages2(fetcher, pageSize = 1e3, maxPages = 100) {
  const out = [];
  for (let page = 1; page <= maxPages; page++) {
    const result = await fetcher(page, pageSize);
    const items = Array.isArray(result) ? result : result?.items ?? [];
    out.push(...items);
    if (items.length < pageSize) {
      break;
    }
  }
  return out;
}
__name(fetchAllPages2, "fetchAllPages");

// src/utils/rrn.ts
function validateRrn(rrn, t) {
  const digits = rrn.replace(/\D/g, "");
  if (digits.length < 13) {
    return "";
  }
  const yy = digits.slice(0, 2);
  const mm = digits.slice(2, 4);
  const dd = digits.slice(4, 6);
  const c = digits[6];
  let century;
  if (c === "9" || c === "0") {
    century = "18";
  } else if (c === "1" || c === "2" || c === "5" || c === "6") {
    century = "19";
  } else if (c === "3" || c === "4" || c === "7" || c === "8") {
    century = "20";
  } else {
    return t("employee.rrn_invalid");
  }
  const year = Number.parseInt(`${century}${yy}`, 10);
  const month = Number.parseInt(mm, 10);
  const day = Number.parseInt(dd, 10);
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return t("employee.rrn_invalid_date");
  }
  const probe = new Date(year, month - 1, day);
  if (probe.getFullYear() !== year || probe.getMonth() !== month - 1 || probe.getDate() !== day) {
    return t("employee.rrn_invalid_date");
  }
  const weights = [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    2,
    3,
    4,
    5
  ];
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number.parseInt(digits[i], 10) * weights[i];
  }
  const expected = (11 - sum % 11) % 10;
  if (expected !== Number.parseInt(digits[12], 10)) {
    return t("employee.rrn_invalid_checksum");
  }
  return "";
}
__name(validateRrn, "validateRrn");

// src/utils/store-access.ts
function herebyStore(ctx) {
  return ctx.$store.hereby;
}
__name(herebyStore, "herebyStore");
function appStore(ctx, name) {
  return ctx.$store?.[name];
}
__name(appStore, "appStore");
function alpineMagics(ctx) {
  return ctx;
}
__name(alpineMagics, "alpineMagics");

// src/utils/ward-scheduler-hint.ts
function wardSchedulerHint(notes) {
  const labels = [];
  for (const note of notes) {
    if (!note || note.otherActiveCount < 1) {
      continue;
    }
    const label = note.wardName ? `${note.wardName} \xB7 ${note.schedulerName}` : note.schedulerName;
    if (!labels.includes(label)) {
      labels.push(label);
    }
  }
  if (labels.length === 0) {
    return null;
  }
  return `${labels.map((l) => `\u300C${l}\u300D`).join(", ")} \uC2A4\uCF00\uC904\uB7EC\uC5D0 \uBC30\uC815\uD588\uC5B4\uC694. \uB2E4\uB978 \uC2A4\uCF00\uC904\uB7EC\uB85C \uC62E\uAE30\uB824\uBA74 \uC2A4\uCF00\uC904\uB7EC \u203A \uAC04\uD638\uC0AC\uC5D0\uC11C \uBC14\uAFD4 \uC8FC\uC138\uC694.`;
}
__name(wardSchedulerHint, "wardSchedulerHint");

// src/components/add-employee-probation.ts
function probationEntered(f) {
  return !!f.probationEndDate;
}
__name(probationEntered, "probationEntered");
function probationValid(f) {
  if (!probationEntered(f)) {
    return true;
  }
  if (f.hireDate && f.probationEndDate < f.hireDate) {
    return false;
  }
  return (f.probationBaseSalary ?? 0) > 0 || (f.probationHourlyRate ?? 0) > 0;
}
__name(probationValid, "probationValid");
function buildProbationInput(f) {
  if (!probationEntered(f)) {
    return void 0;
  }
  const out = {
    endDate: f.probationEndDate
  };
  if ((f.probationBaseSalary ?? 0) > 0) {
    out.baseSalary = f.probationBaseSalary;
  }
  if ((f.probationHourlyRate ?? 0) > 0) {
    out.hourlyRate = f.probationHourlyRate;
  }
  return out;
}
__name(buildProbationInput, "buildProbationInput");
function probationValuesLabel(f, labels) {
  const parts = [];
  if ((f.probationBaseSalary ?? 0) > 0) {
    parts.push(`${labels.baseSalary} ${Number(f.probationBaseSalary).toLocaleString()}${labels.won}`);
  }
  if ((f.probationHourlyRate ?? 0) > 0) {
    parts.push(`${labels.hourlyRate} ${Number(f.probationHourlyRate).toLocaleString()}${labels.won}`);
  }
  return parts.join(" \xB7 ");
}
__name(probationValuesLabel, "probationValuesLabel");

// src/components/AddEmployeePanel.ts
var DAUM_POSTCODE_SRC = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
function addEmployeePanelComponent(opts = {}) {
  return {
    showAddEmployee: false,
    /* Self-contained save-confirm (the panel is mounted standalone, so it can't
    rely on a host app's closeConfirm). X / 취소 / Esc route through
    attemptClosePanel() so typed input never silently disappears. */
    showCloseConfirm: false,
    /* Pristine snapshot taken when the panel opens — an untouched form closes
    directly; the confirm only appears once something was typed. */
    closeBaseline: "",
    attemptClosePanel() {
      if (this.addEmployeeResult || JSON.stringify(this.addEmployeeForm) === this.closeBaseline) {
        this.showAddEmployee = false;
        return;
      }
      this.showCloseConfirm = true;
    },
    confirmClosePanel() {
      this.showCloseConfirm = false;
      this.showAddEmployee = false;
    },
    dismissClosePanel() {
      this.showCloseConfirm = false;
    },
    /* 알림(notice) 팝업 — 네이티브 alert() 대체 공용 커스텀 팝업(성공/오류/안내 공용).
    마크업은 모달 루트 바깥(형제)에 두어, 모달이 열리기 전 참조 데이터 로드 실패도 표시된다.
    tone은 성공/오류 구분용(현재 시각 스타일은 동일, 향후 확장 여지). */
    notice: {
      show: false,
      tone: "success",
      message: ""
    },
    showNotice(message, tone = "success") {
      this.notice = {
        show: true,
        tone,
        message
      };
    },
    closeNotice() {
      this.notice.show = false;
    },
    /** 패널 위 레이어 팝업이 막 닫힌 시각(ms) — ESC 연타/키리피트로 패널까지 닫히는 것을 막는 가드 키. */
    topLayerClosedAt: 0,
    /**
    * ESC 처리 — 패널 위 레이어 팝업(알림·미리보기·주소검색·저장확인)을 위에서부터 "하나씩만" 닫는다.
    * 팝업을 막 닫은 직후(연타/키리피트, <500ms)에는 패널이 통째로 닫히지 않도록 유예한다.
    * notice는 모달 루트 바깥이라 패널이 닫혀 있어도 먼저 닫는다.
    */
    escapeClose() {
      if (permissionModalOwnsEsc()) {
        return;
      }
      if (this.notice.show) {
        this.closeNotice();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (!this.showAddEmployee) {
        return;
      }
      if (this.previewOpen) {
        this.closePreview();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.shiftRefOpen) {
        this.shiftRefOpen = false;
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.addrSearchOpen) {
        this.closeAddrSearch();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.showCloseConfirm) {
        this.dismissClosePanel();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (Date.now() - this.topLayerClosedAt < 500) {
        return;
      }
      this.attemptClosePanel();
    },
    attemptSaveEmployee() {
      if (!this.addFormValid()) {
        return;
      }
      if (!this.validateDuplicates()) {
        return;
      }
      this.saveNewEmployee();
    },
    /* 미리보기 모달 — 등록 전 입력값을 실시간으로 검토하는 읽기 전용 팝업(패널 위에 겹쳐 표시).
    기존 4단계 위저드의 '확인' 단계를 상시 열람 가능하게 옮긴 것. 입력을 바꾸지 않으므로
    저장확인 가드 없이 X/Esc로 바로 닫힌다(공통 모달 가이드). */
    previewOpen: false,
    openPreview() {
      this.previewOpen = true;
    },
    closePreview() {
      this.previewOpen = false;
    },
    /* 등록된 근무 유형 참고 팝업 — 근무 그룹 드롭다운 옆 버튼으로 여는 읽기 전용 목록(패널 위 레이어).
    입력을 바꾸지 않으므로 저장확인 가드 없이 X/닫기/Esc 로 닫힌다. */
    shiftRefOpen: false,
    // '근무 유형 전체 보기' 팝업용 — 활성 근무형태가 있는 근무 그룹만 {id, name, shifts}로.
    // 그룹-유무로 빈 상태를 판정해, 유형이 전부 그룹 미지정(레거시)이면 빈 메시지가 정상 노출된다.
    shiftRefGroups() {
      return this.shiftGroups.map((g) => ({
        id: g.id,
        name: g.name,
        shifts: this.shifts.filter((s) => s.groupId === g.id && s.isActive !== false)
      })).filter((grp) => grp.shifts.length > 0);
    },
    /**
    * 팀의 대표 근무(teams.shiftGroupId / shiftId) — 소속을 고를 때 **기본으로 선택**할 값.
    * 제한이 아니라 기본값이라, 줄에서 조직 전체 그룹·형태로 언제든 바꿀 수 있다.
    *
    * 드롭다운에 실제로 있는 값만 돌려준다: 삭제·비활성 그룹이나 그룹 밖 형태를 넣으면 select 는
    * 빈칸인데 폼에는 값이 남아 필수 검사만 통과하는 상태가 된다. 형태가 무효면 그룹만 채운다.
    */
    teamRepresentativeShift(teamId) {
      const team = this.teams.find((t) => t.id === teamId);
      const groupId = team?.shiftGroupId || "";
      const group = groupId ? this.shiftGroups.find((g) => g.id === groupId && g.isActive !== false) : null;
      if (!group) {
        return {
          shiftGroupId: "",
          shiftId: ""
        };
      }
      const shiftId = team?.shiftId || "";
      const shiftOk = !!shiftId && this.shifts.some((x) => x.id === shiftId && x.groupId === groupId && x.isActive !== false);
      return {
        shiftGroupId: groupId,
        shiftId: shiftOk ? shiftId : ""
      };
    },
    /** 직무 마스터 목록(활성만) — 직무 드롭다운 선택지. 비어 있으면 안내를 띄운다(먼저 설정에서 등록). */
    jobDuties: [],
    jobDutiesLoaded: false,
    jobDutyOptions() {
      return this.jobDuties.filter((d) => d.isActive !== false);
    },
    selectedJobDuty() {
      const id = this.addEmployeeForm.jobDutyId;
      return id ? this.jobDuties.find((d) => d.id === id) ?? null : null;
    },
    selectedJobDutyName() {
      return this.selectedJobDuty()?.name || "";
    },
    /**
    * 직무의 기본 근무(job_duties.shiftGroupId / shiftId) — 팀 대표 근무보다 먼저 보는 기본값.
    * 병원은 근로형태가 팀이 아니라 직무로 갈린다(같은 통합병동 팀 안에서도 간호사·요양보호사의 근무가 다르다).
    * 팀 대표와 같은 규칙으로 드롭다운에 실제로 있는 값만 돌려준다(그룹이 없으면 빈 값, 형태가 무효면 그룹만).
    */
    // ── 근로형태(포괄임금 시간 기준) — 선택. 직무를 고르면 그 직무의 기본 근로형태가 먼저 들어간다.
    workPatterns: [],
    workPatternsLoaded: false,
    /** 근로형태 선택지 — 활성만. 고른 직무에 속한 것을 앞에, 직무 미지정을 뒤에(다른 직무 전용은 뺀다). */
    workPatternOptions() {
      const dutyId = this.addEmployeeForm.jobDutyId;
      const current2 = this.addEmployeeForm.workPatternId;
      const list = this.workPatterns.filter((w) => w.id === current2 || w.isActive !== false && (!(w.jobDutyId && dutyId) || w.jobDutyId === dutyId));
      return [
        ...list
      ].sort((a, b) => Number(!!b.jobDutyId) - Number(!!a.jobDutyId));
    },
    selectedWorkPattern() {
      const id = this.addEmployeeForm.workPatternId;
      return id ? this.workPatterns.find((w) => w.id === id) ?? null : null;
    },
    selectedWorkPatternName() {
      return this.selectedWorkPattern()?.name ?? "";
    },
    /** 근로형태 기본 근무 — 직무 기본 근무와 같은 판정(드롭다운에 실제로 있는 값만). */
    workPatternDefaultShift() {
      const wp = this.selectedWorkPattern();
      const groupId = wp?.shiftGroupId || "";
      const group = groupId ? this.shiftGroups.find((g) => g.id === groupId && g.isActive !== false) : null;
      if (!group) {
        return {
          shiftGroupId: "",
          shiftId: ""
        };
      }
      const shiftId = wp?.shiftId || "";
      const ok = !!shiftId && this.shifts.some((x) => x.id === shiftId && x.groupId === groupId && x.isActive !== false);
      return {
        shiftGroupId: groupId,
        shiftId: ok ? shiftId : ""
      };
    },
    /** 근로형태를 바꾸면 직무를 바꿨을 때와 같은 규칙으로 자동 채운 근무 줄만 다시 채운다. */
    onWorkPatternChange() {
      this.onJobDutyChange(true);
    },
    /**
    * 직무·근로형태의 기본 근무 — 근로형태 기본 근무가 있으면 그것, 없으면 직무 기본 근무(팀 대표보다 먼저).
    * 이름은 유지한다 — 안내 문구·출처 판정(rowShiftSource "jobDuty")이 이 하나를 본다.
    */
    jobDutyDefaultShift() {
      const fromPattern = this.workPatternDefaultShift();
      if (fromPattern.shiftGroupId) {
        return fromPattern;
      }
      const duty = this.selectedJobDuty();
      const groupId = duty?.shiftGroupId || "";
      const group = groupId ? this.shiftGroups.find((g) => g.id === groupId && g.isActive !== false) : null;
      if (!group) {
        return {
          shiftGroupId: "",
          shiftId: ""
        };
      }
      const shiftId = duty?.shiftId || "";
      const shiftOk = !!shiftId && this.shifts.some((x) => x.id === shiftId && x.groupId === groupId && x.isActive !== false);
      return {
        shiftGroupId: groupId,
        shiftId: shiftOk ? shiftId : ""
      };
    },
    /** 새 소속 줄의 기본 근무 — 직무 기본 근무 → 팀 대표 근무 → 미지정(직접 선택). */
    defaultShiftForTeam(teamId) {
      const fromDuty = this.jobDutyDefaultShift();
      return fromDuty.shiftGroupId ? fromDuty : this.teamRepresentativeShift(teamId);
    },
    /** 한 소속 줄의 근무가 직무 기본 근무 그대로인지 — 「직무 기본 근무」 안내 노출용(팀 대표보다 먼저 판정). */
    rowUsesJobDutyDefault(m) {
      const d = this.jobDutyDefaultShift();
      return !!d.shiftGroupId && d.shiftGroupId === m.shiftGroupId && d.shiftId === m.shiftId;
    },
    /** 줄의 근무가 어느 기준으로 채워졌는지 — "jobDuty" · "team" · ""(직접 선택). 안내 문구가 이 값을 본다. */
    rowShiftSource(m) {
      if (this.rowUsesJobDutyDefault(m)) {
        return "jobDuty";
      }
      return this.rowUsesTeamRepresentative(m) ? "team" : "";
    },
    /**
    * 직무를 바꾸면 자동으로 채워졌던 줄(빈 줄 · 팀 대표 그대로 · 이전 직무 기본값 그대로)만 새 기본 근무로 다시 잡는다.
    * 사용자가 직접 고른 줄은 그대로 둔다.
    */
    lastJobDutyDefault: null,
    onJobDutyChange(keepWorkPattern = false) {
      if (!keepWorkPattern) {
        const dutyDefault = this.selectedJobDuty()?.defaultWorkPatternId || "";
        const wp = this.workPatterns.find((w) => w.id === dutyDefault);
        this.addEmployeeForm.workPatternId = wp && wp.isActive !== false ? wp.id : "";
      }
      const prev = this.lastJobDutyDefault;
      const rows = this.addEmployeeForm.addMemberships;
      const next = this.jobDutyDefaultShift();
      for (const m of rows) {
        const auto = !m.shiftGroupId || this.rowUsesTeamRepresentative(m) || !!prev?.shiftGroupId && prev.shiftGroupId === m.shiftGroupId && prev.shiftId === m.shiftId;
        if (!auto) {
          continue;
        }
        const target = next.shiftGroupId ? next : this.teamRepresentativeShift(m.teamId);
        m.shiftGroupId = target.shiftGroupId;
        m.shiftId = target.shiftId;
      }
      this.lastJobDutyDefault = next.shiftGroupId ? next : null;
      if (rows.length > 0) {
        this.syncPrimaryShift();
      }
    },
    /** 한 소속 줄의 근무가 그 팀 대표 근무 그대로인지 — 「소속 팀 대표 근무」 안내 노출용. */
    rowUsesTeamRepresentative(m) {
      const rep = this.teamRepresentativeShift(m.teamId);
      return !!rep.shiftGroupId && rep.shiftGroupId === m.shiftGroupId && rep.shiftId === m.shiftId;
    },
    /** 줄의 근무 그룹 선택지 — 조직 전체 활성 그룹(제한 없음). 이미 고른 값이 비활성이면 그 값만 남긴다. */
    rowShiftGroupOptions(current2) {
      return this.shiftGroups.filter((g) => g.isActive !== false || g.id === current2);
    },
    /** 근무 그룹 id → 이름(고정 표시용). 목록에 없으면 빈 문자열. */
    shiftGroupName(groupId) {
      const g = this.shiftGroups.find((x) => x.id === groupId);
      return g?.name || "";
    },
    /**
    * 한 소속 줄에서 고를 수 있는 근무 형태 — 그 줄의 근무 그룹 하위 활성 형태만.
    * 직무에 허용 근무형태 목록이 있으면 그 형태들을 앞에 둔다(제한이 아니라 순서 — 나머지도 고를 수 있다).
    */
    rowShifts(groupId) {
      const list = this.shifts.filter((s) => s.isActive !== false && (groupId ? s.groupId === groupId : !s.groupId));
      const allowed = new Set(this.selectedJobDuty()?.allowedShiftIds ?? []);
      if (allowed.size === 0) {
        return list;
      }
      return [
        ...list.filter((s) => allowed.has(s.id)),
        ...list.filter((s) => !allowed.has(s.id))
      ];
    },
    /** 줄의 근무 그룹이 바뀌면 그 그룹에 속하지 않는 근무 형태는 비운다. */
    onRowShiftGroupChange(idx) {
      const m = this.addEmployeeForm.addMemberships[idx];
      if (!m) {
        return;
      }
      const cur = this.shifts.find((s) => s.id === m.shiftId);
      if (cur && cur.groupId !== (m.shiftGroupId || void 0)) {
        m.shiftId = "";
      }
      this.syncPrimaryShift();
    },
    /** 주 소속을 바꾼다 — 출퇴근 기준 시각·연차가 보는 근무와 급여 시트의 팀이 이 줄로 옮겨간다. */
    setPrimaryTeam(teamId) {
      this.addEmployeeForm.primaryTeamId = teamId;
      this.syncPrimaryShift();
    },
    /**
    * 기준 소속의 근무 배정을 직원 단위 값(employees.shiftGroupId / shiftId)에 복사한다.
    * 근태(chooseAttendanceSchedule)·연차(loadWorkPattern)는 지금도 직원 단위 값 하나만 보므로,
    * 소속별 값을 늘리되 판정 경로는 건드리지 않기 위한 다리다.
    */
    syncPrimaryShift() {
      const rows = this.addEmployeeForm.addMemberships;
      if (rows.length === 0) {
        this.addEmployeeForm.primaryTeamId = "";
        this.addEmployeeForm.shiftGroupId = "";
        this.addEmployeeForm.shiftId = "";
        return;
      }
      const primary = rows.find((m) => m.teamId === this.addEmployeeForm.primaryTeamId) || rows[0];
      this.addEmployeeForm.primaryTeamId = primary.teamId;
      this.addEmployeeForm.shiftGroupId = primary.shiftGroupId || "";
      this.addEmployeeForm.shiftId = primary.shiftId || "";
    },
    addEmployeeSaving: false,
    addEmployeeResult: null,
    addEmployeeForm: {
      // 기본정보 — 필수(성·이름·사번) + 기타 인적사항(이메일·전화번호)
      lastName: "",
      firstName: "",
      email: "",
      phone: "",
      employeeNumber: "",
      autoGenerateEmployeeNumber: false,
      countryCode: "+82",
      // 인사정보(입사일) · 기본정보-기타 인적사항(생년월일·주민번호·주소)
      hireDate: "",
      birthDate: "",
      isLunarBirth: false,
      // 급여 지급 대상 여부 — true 면 급여 미지급 대상(급여대장·급여 생성·명세서 제외). 기본 대상.
      payrollExcluded: false,
      // 주민등록번호 — 앞 6자리(YYMMDD)·뒤 7자리를 따로 입력받아 결합값을 저장.
      // 미입력 가능(선택 항목, 2026-07 재추가); 13자리가 채워지면 검증 후에만 전송.
      residentNumberFront: "",
      residentNumberBack: "",
      residentNumber: "",
      // 주소 — 우편번호 검색(공통 모달)으로만 채워지는 구조화 입력.
      // address = 선택한 기본 주소(도로명/지번), postalCode = 5자리 우편번호,
      // addressDetail = 상세주소(주소 선택 시 필수).
      address: "",
      postalCode: "",
      addressDetail: "",
      teamId: "",
      roleId: "",
      shiftId: "",
      shiftGroupId: "",
      attendanceMethod: "",
      // 직무 — 직무 마스터(job_duties)에서 고른 id. 필수. 서버가 이름 사본(jobDuty)을 함께 채운다.
      jobDutyId: "",
      // 근로형태(선택) — 지정하면 근로계약의 월 근로시간·연장·야간·포괄시간이 근로형태에서 채워진다
      workPatternId: "",
      // 소속 (팀·역할) — 직원 정보 수정 팝업과 동일하게 여러 팀을 각각 역할과 함께 배정.
      // roleId "" 는 '역할 없이' (등록 후 기본 역할 없음).
      addMemberships: [],
      /**
      * 주 소속의 팀 id — 이 줄의 근무 배정이 직원 단위 값(shiftGroupId / shiftId)으로
      * 저장돼 출퇴근 기준 시각·연차 판정에 쓰인다. 소속이 하나면 그 줄이 곧 기준이다.
      */
      primaryTeamId: "",
      // 자격증/면허 — 입사 시에는 유형만(여러 개) 등록. 사본·상세는 입사 후
      // Works 제출 → 문서 결재 → 대장 반영 흐름으로 이어진다.
      // 유형 체크박스: 체크 = 행 추가. '기타'도 일반 유형처럼 고정 라벨로만 등록한다.
      certEnabled: true,
      certRows: [],
      // 근로계약
      contractType: "permanent",
      wageType: "monthly",
      salaryGradeId: "",
      baseSalary: 0,
      hobongAmount: 0,
      longevityAmount: 0,
      mealAllowance: 0,
      transportAllowance: 0,
      positionAllowance: 0,
      standardWeeklyHours: 40,
      maxWeeklyHours: 52,
      // 수습 종료 후(MED-823) — 종료일을 채우면 다음 날부터의 새 계약을 예약한다(선택)
      probationEndDate: "",
      probationBaseSalary: 0,
      probationHourlyRate: 0,
      // 인사정보: 초기 상태 (등록 시 결정)
      status: "INACTIVE"
    },
    addFormErrors: {
      email: "",
      phone: "",
      employeeNumber: ""
    },
    /** 주민등록번호 검증 오류(i18n 키). ""이면 정상/미완성. */
    rrnError: "",
    previewEmployeeNumber: "",
    // 패널 카테고리(좌측 메뉴) — 자유 이동. 필수 누락 카테고리는 메뉴에 빨간 점(!addCatValid).
    addEmployeeCats: [
      "basic",
      "hr",
      "cert",
      "contract"
    ],
    addEmployeeCat: "basic",
    // 소속(팀·역할) 추가 캐스케이딩 메뉴 상태 (팀 선택 → 역할 선택).
    affPicker: false,
    affStep: "team",
    affSelTeam: "",
    // Reference data (injected from parent or loaded)
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    teams: [],
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    roles: [],
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    shifts: [],
    // 근무 그룹 목록 (근무 배정 그룹 선택용)
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    shiftGroups: [],
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    employees: [],
    // 활성 자격 유형(커스텀 설정) — 비었으면 certTypeOptions 폴백 사용
    certTypeConfigs: [],
    // 활성 호봉 목록 (호봉 정의 시트 정본, status=active 만). 호봉 선택 시
    // 기본급/호봉수당이 표 값으로 자동 채워지고 잠긴다(정책: 표 정본 우선).
    salaryGrades: [],
    // biome-ignore lint/suspicious/noExplicitAny: SDK type from Alpine store
    sdk: null,
    dataReady: false,
    _t(key, vars) {
      try {
        return herebyStore(this).t(key, vars) || key;
      } catch {
        return key;
      }
    },
    /** Per-team collapsed state for the team-picker tree (persisted). */
    teamPickerCollapsed: (() => {
      try {
        const raw = localStorage.getItem("admin:teamPickerCollapsed");
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    })(),
    toggleTeamPickerCollapsed(teamId) {
      this.teamPickerCollapsed = {
        ...this.teamPickerCollapsed,
        [teamId]: !this.teamPickerCollapsed[teamId]
      };
      try {
        localStorage.setItem("admin:teamPickerCollapsed", JSON.stringify(this.teamPickerCollapsed));
      } catch {
      }
    },
    /**
    * Depth-first flat view of teams (roots → children → grandchildren) with
    * `treeDepth`, `treeIsLeaf`, and `treeChildCount`. Collapse retired: the
    * tree always renders fully expanded so no team can be hidden.
    */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic team rows
    teamTreeFlat() {
      const list = this.teams;
      const byParent = /* @__PURE__ */ new Map();
      for (const t of list) {
        const pid = t.parentTeamId || "";
        if (!byParent.has(pid)) {
          byParent.set(pid, []);
        }
        byParent.get(pid)?.push(t);
      }
      for (const arr of byParent.values()) {
        arr.sort((a, b) => compareTeamOrder(a, b));
      }
      const out = [];
      const walk = /* @__PURE__ */ __name((parentId, depth) => {
        const kids = byParent.get(parentId) || [];
        for (const t of kids) {
          const childCount = (byParent.get(t.id) || []).length;
          out.push({
            ...t,
            treeDepth: depth,
            treeIsLeaf: childCount === 0,
            treeChildCount: childCount,
            treeCollapsed: false
          });
          if (childCount > 0) {
            walk(t.id, depth + 1);
          }
        }
      }, "walk");
      walk("", 0);
      return out;
    },
    async init() {
      if (this.dataReady) {
        return;
      }
      const store = herebyStore(this);
      if (!store || store.isLoading || !store.currentUser || !store.sdk) {
        return;
      }
      this.sdk = store.sdk;
      this.dataReady = true;
    },
    async loadReferenceData() {
      if (!this.sdk) {
        const store = herebyStore(this);
        if (store?.sdk) {
          this.sdk = store.sdk;
          this.dataReady = true;
        }
      }
      if (!this.sdk) {
        return;
      }
      try {
        const [teams, roles, shifts, shiftGroups, emps, certTypes, grades, jobDuties] = await Promise.all([
          fetchAllPages2((page, limit) => this.sdk.team.list({
            page,
            limit
          }), 100),
          fetchAllPages2((page, limit) => this.sdk.role.list({
            includePermissions: false,
            page,
            limit
          }), 100),
          this.sdk.shift.list(),
          this.sdk.shiftGroup.list(),
          fetchAllPages2((page, limit) => this.sdk.employee.getEmployees({
            page,
            limit
          }), 1e3),
          this.sdk.certificationType?.list({
            activeOnly: true
          }).catch(() => []),
          // 활성 호봉만 — 호봉 정의 시트에서 [반영]된 정본. 실패해도 폼은
          // 자유 입력으로 동작해야 하므로 빈 목록으로 폴백.
          this.sdk.salaryGrade?.list({
            status: "active"
          }, {
            page: 1,
            limit: 500
          }).catch(() => null),
          // 직무 마스터(활성만) — 실패해도 폼은 열려야 하므로 빈 목록으로 폴백(직무 필수라 등록은 막힌다)
          this.sdk.jobDuty?.list({
            activeOnly: true
          }).catch(() => null)
        ]);
        this.teams = teams || [];
        this.roles = roles || [];
        this.shifts = shifts?.items || shifts || [];
        this.shiftGroups = shiftGroups?.items || shiftGroups || [];
        this.jobDuties = jobDuties?.items ?? [];
        this.jobDutiesLoaded = true;
        try {
          const wps = await this.sdk.workPattern?.list({
            activeOnly: true
          });
          this.workPatterns = wps?.items ?? [];
        } catch {
          this.workPatterns = [];
        }
        this.workPatternsLoaded = true;
        this.employees = emps || [];
        this.certTypeConfigs = Array.isArray(certTypes) ? certTypes.map((c) => ({
          code: c.code,
          name: c.name
        })) : [];
        const gradeItems = grades?.items;
        this.salaryGrades = Array.isArray(gradeItems) ? gradeItems.map((g) => ({
          id: g.id,
          grade: Number(g.grade),
          baseSalary: Number(g.baseSalary) || 0,
          hobongAmount: Number(g.hobongAmount) || 0,
          effectiveYear: Number(g.effectiveYear),
          categoryName: g.salaryGradeCategory?.name ?? ""
        })) : [];
      } catch (err) {
        this.showNotice(`\uCC38\uC870 \uB370\uC774\uD130 \uB85C\uB4DC \uC2E4\uD328: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    /** 드롭다운 라벨 — "카테고리 3호봉 (2026)" 또는 카테고리 없이 "3호봉 (2026)". */
    salaryGradeLabel(g) {
      const cat = g.categoryName ? `${g.categoryName} ` : "";
      return `${cat}${g.grade}${this._t("grades.grade_suffix") || "\uD638\uBD09"} (${g.effectiveYear})`;
    },
    /** 호봉 선택 → 표 정본 값으로 기본급/호봉수당 자동 채움(잠금은 HTML
    *  :disabled 가 salaryGradeId 존재 여부로 처리). 미선택("")으로
    *  되돌리면 값은 남기되 다시 자유 입력 가능. */
    onSalaryGradeChange() {
      const id = this.addEmployeeForm.salaryGradeId;
      if (!id) {
        return;
      }
      const g = this.salaryGrades.find((x) => x.id === id);
      if (g) {
        this.addEmployeeForm.baseSalary = g.baseSalary;
        this.addEmployeeForm.hobongAmount = g.hobongAmount;
      }
    },
    openAddEmployee(detail) {
      this.addEmployeeForm = {
        lastName: "",
        firstName: "",
        email: "",
        phone: "",
        employeeNumber: "",
        autoGenerateEmployeeNumber: false,
        countryCode: "+82",
        hireDate: "",
        birthDate: "",
        isLunarBirth: false,
        payrollExcluded: false,
        residentNumberFront: "",
        residentNumberBack: "",
        residentNumber: "",
        address: "",
        postalCode: "",
        addressDetail: "",
        teamId: "",
        roleId: "",
        shiftId: "",
        shiftGroupId: "",
        // 병동 화면에서 열었을 때 그 병동 — 저장하면 서버가 이 병동에 배정한다(연결 팀이 없어도).
        wardId: "",
        wardName: "",
        attendanceMethod: "",
        jobDutyId: "",
        workPatternId: "",
        addMemberships: [],
        primaryTeamId: "",
        certEnabled: true,
        certRows: [],
        contractType: "permanent",
        wageType: "monthly",
        salaryGradeId: "",
        baseSalary: 0,
        hobongAmount: 0,
        longevityAmount: 0,
        mealAllowance: 0,
        transportAllowance: 0,
        positionAllowance: 0,
        standardWeeklyHours: 40,
        maxWeeklyHours: 52,
        probationEndDate: "",
        probationBaseSalary: 0,
        probationHourlyRate: 0,
        status: "INACTIVE"
      };
      this.addEmployeeSaving = false;
      this.addEmployeeResult = null;
      this.previewEmployeeNumber = "";
      this.rrnError = "";
      this.addFormErrors = {
        email: "",
        phone: "",
        employeeNumber: ""
      };
      this.addEmployeeCat = "basic";
      this.affPicker = false;
      this.affStep = "team";
      this.affSelTeam = "";
      this.addrSearchOpen = false;
      this.previewOpen = false;
      this.notice = {
        show: false,
        tone: "success",
        message: ""
      };
      if (detail?.teamId) {
        this.addEmployeeForm.addMemberships.push({
          teamId: detail.teamId,
          teamName: detail.teamName || "",
          roleId: "",
          roleName: "",
          // 근무 그룹은 팀 목록이 온 뒤에 채운다(_loadAfterOpen) — 이 시점엔 teams 가 비어 있다.
          shiftGroupId: "",
          shiftId: ""
        });
        this.addEmployeeForm.primaryTeamId = detail.teamId;
      }
      if (detail?.wardId) {
        this.addEmployeeForm.wardId = detail.wardId;
        this.addEmployeeForm.wardName = detail.wardName || "";
      }
      this.closeBaseline = JSON.stringify(this.addEmployeeForm);
      this.showAddEmployee = true;
      this._loadAfterOpen();
    },
    /**
    * 신규 입사자 시트 자동 추가 미리보기(MED-109 확인 Flow) — 조직 설정이 켜져 있으면 「저장하면 이 시트에 행이
    * 들어가요」를 검토 단계에 보여 준다. 입사일이 바뀌면 다시 읽는다(그 달 이후 입사자는 그 달 시트에서 빠짐).
    */
    sheetAutoAddPreview: null,
    sheetAutoAddPreviewKey: "",
    async refreshSheetAutoAddPreview() {
      if (!(this.sdk && this.showAddEmployee)) {
        return;
      }
      const hireDate = String(this.addEmployeeForm.hireDate || "");
      if (this.sheetAutoAddPreviewKey === hireDate && this.sheetAutoAddPreview) {
        return;
      }
      this.sheetAutoAddPreviewKey = hireDate;
      try {
        this.sheetAutoAddPreview = await this.sdk.employee.previewNewEmployeeSheets(/^\d{4}-\d{2}-\d{2}$/.test(hireDate) ? hireDate : void 0, {
          background: true
        });
      } catch {
        this.sheetAutoAddPreview = null;
      }
    },
    /** 미리보기 문구용 — 실제로 들어갈 시트만 */
    sheetAutoAddTargets() {
      return (this.sheetAutoAddPreview?.sheets ?? []).filter((s) => !s.hireBlocked);
    },
    sheetLabel(s) {
      return s.isEvergreen ? s.name : `${s.name} (${s.year}.${String(s.month).padStart(2, "0")})`;
    },
    async _loadAfterOpen() {
      if (!this.sdk) {
        await this.init();
      }
      if (!this.sdk) {
        return;
      }
      this.sheetAutoAddPreviewKey = "";
      this.refreshSheetAutoAddPreview();
      await this.loadReferenceData();
      let filled = false;
      for (const m of this.addEmployeeForm.addMemberships) {
        if (!m.shiftGroupId) {
          const rep = this.defaultShiftForTeam(m.teamId);
          m.shiftGroupId = rep.shiftGroupId;
          m.shiftId = rep.shiftId;
          filled = filled || !!rep.shiftGroupId;
        }
      }
      if (this.addEmployeeForm.addMemberships.length > 0) {
        this.syncPrimaryShift();
      }
      if (filled) {
        this.closeBaseline = JSON.stringify(this.addEmployeeForm);
      }
      this.fetchPreviewEmployeeNumber();
    },
    async fetchPreviewEmployeeNumber() {
      if (!this.sdk) {
        return;
      }
      try {
        const result = await this.sdk.employee.previewNextEmployeeNumber({
          background: true
        });
        this.previewEmployeeNumber = result?.employeeNumber || "";
      } catch {
        this.previewEmployeeNumber = "";
      }
    },
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    /**
    * 미리보기 사번 라벨 — 직접 입력값이 우선이고, 자동 생성 체크 시에만
    * 서버 previewNextEmployeeNumber 결과를 보조값으로 노출한다.
    */
    get previewEmployeeNumberLabel() {
      const f = this.addEmployeeForm;
      return f.employeeNumber || (f.autoGenerateEmployeeNumber ? this.previewEmployeeNumber : "") || "-";
    },
    /** 조직 로컬 오늘 날짜로 입사일을 즉시 채운다. */
    setHireDateToday() {
      const store = herebyStore(this);
      this.addEmployeeForm.hireDate = store?.todayLocal?.() || (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
    },
    /**
    * 생년월일 → 주민등록번호 앞 6자리(YYMMDD) 단방향 동기화(직원 정보 수정 팝업과 동일 UX).
    * 생년월일을 비우면 뒷자리·음력 체크도 함께 비운다(뒷자리 칸은 생년월일이 있어야 활성화).
    */
    syncRrnFromBirth() {
      const f = this.addEmployeeForm;
      f.residentNumberFront = (f.birthDate || "").replace(/-/g, "").slice(2);
      if (!f.birthDate) {
        f.residentNumberBack = "";
        f.isLunarBirth = false;
      }
      f.residentNumber = f.residentNumberBack ? `${f.residentNumberFront}-${f.residentNumberBack}` : f.residentNumberFront;
      this.rrnError = this.validateRrn(f.residentNumber);
    },
    // ── 카테고리(좌측 메뉴) 이동/표시 ────────────────────────────────────
    addCatLabel(id) {
      if (id === "basic") {
        return this._t("employee.basic_info");
      }
      if (id === "hr") {
        return this._t("employee.hr_info");
      }
      if (id === "cert") {
        return this._t("employee.certification_register");
      }
      return this._t("employee.contract");
    },
    addEmployeeGoCat(id) {
      this.addEmployeeCat = id;
    },
    /** 좌측 메뉴 빨간 점 = !addCatValid — 필수값이 비어 있는 동안 표시, 모두 입력되면 사라짐. */
    addCatValid(id) {
      if (id === "basic") {
        return this.addBasicValid();
      }
      if (id === "hr") {
        return this.addHrValid();
      }
      if (id === "cert") {
        return this.addCertValid();
      }
      return this.addContractValid();
    },
    addBasicValid() {
      const f = this.addEmployeeForm;
      if (!(f.lastName && f.firstName)) {
        return false;
      }
      if (f.email && !this.isValidEmail(f.email)) {
        return false;
      }
      if (!(f.employeeNumber || f.autoGenerateEmployeeNumber)) {
        return false;
      }
      if (this.addBirthDateError()) {
        return false;
      }
      if (this.rrnError) {
        return false;
      }
      return true;
    },
    // ── 주소 — 우편번호 검색(공통 모달 + Daum 우편번호 서비스) ─────────────
    /** 주소 검색 모달 표시 여부. */
    addrSearchOpen: false,
    /** 스크립트 로드 프로미스(1회) — 실패 시 버려서 다음 시도에 재로드한다. */
    daumPostcodePromise: null,
    /** Daum 우편번호 서비스 스크립트를 lazy 로드한다(키 불필요·프론트 전용). */
    _loadDaumPostcode() {
      if (window.daum?.Postcode) {
        return Promise.resolve(window.daum);
      }
      if (!this.daumPostcodePromise) {
        this.daumPostcodePromise = new Promise((resolve2, reject) => {
          const script = document.createElement("script");
          script.src = DAUM_POSTCODE_SRC;
          script.onload = () => {
            if (window.daum?.Postcode) {
              resolve2(window.daum);
            } else {
              this.daumPostcodePromise = null;
              reject(new Error("\uC8FC\uC18C \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC5B4\uC694."));
            }
          };
          script.onerror = () => {
            this.daumPostcodePromise = null;
            reject(new Error("\uC8FC\uC18C \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB124\uD2B8\uC6CC\uD06C\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694."));
          };
          document.head.appendChild(script);
        });
      }
      return this.daumPostcodePromise;
    },
    /** '검색' 클릭 — 공통 모달을 열고 컨테이너에 주소 검색(도로명·지번 리스트)을 마운트한다. */
    async openAddrSearch() {
      this.addrSearchOpen = true;
      try {
        const daum = await this._loadDaumPostcode();
        if (!this.addrSearchOpen) {
          return;
        }
        const box = document.getElementById("addEmpAddrEmbed");
        if (!box) {
          return;
        }
        box.innerHTML = "";
        new daum.Postcode({
          oncomplete: /* @__PURE__ */ __name((data) => this.applyAddrSelection(data), "oncomplete"),
          width: "100%",
          height: "100%"
        }).embed(box);
      } catch (err) {
        this.addrSearchOpen = false;
        this.showNotice(err instanceof Error ? err.message : String(err), "danger");
      }
    },
    closeAddrSearch() {
      this.addrSearchOpen = false;
    },
    /**
    * 주소 리스트에서 항목 클릭 — 사용자가 선택한 표기(도로명/지번)를 기본 주소로,
    * 우편번호(5자리)를 함께 채운다. 상세주소는 비우고 활성화해 바로 이어서 입력하게 한다.
    */
    applyAddrSelection(data) {
      const f = this.addEmployeeForm;
      const road = data.roadAddress || "";
      const jibun = data.jibunAddress || "";
      f.address = data.userSelectedType === "J" ? jibun || road : road || jibun;
      f.postalCode = data.zonecode || "";
      f.addressDetail = "";
      this.addrSearchOpen = false;
      setTimeout(() => document.getElementById("addEmpAddrDetail")?.focus(), 0);
    },
    /** 주소 선택 해제(X) — 주소는 선택 항목이라 잘못 선택했을 때 비울 수 있어야 한다. */
    clearAddress() {
      const f = this.addEmployeeForm;
      f.address = "";
      f.postalCode = "";
      f.addressDetail = "";
    },
    /** 생년월일이 오늘(조직 타임존)보다 미래면 오류 문구, 아니면 "". */
    addBirthDateError() {
      const bd = this.addEmployeeForm.birthDate;
      if (!bd) {
        return "";
      }
      const store = herebyStore(this);
      const today = store?.todayLocal?.() || (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
      return bd > today ? "\uC0DD\uB144\uC6D4\uC77C\uC740 \uBBF8\uB798 \uB0A0\uC9DC\uC77C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." : "";
    },
    /**
    * 주민번호 뒷 7자리 입력 핸들러 — 숫자만 남겨 결합값을 동기화하고 검증한다.
    * 앞 6자리는 생년월일에서만 파생(disabled)되므로 여기서는 건드리지 않는다.
    */
    onResidentNumberInput() {
      const f = this.addEmployeeForm;
      f.residentNumberBack = (f.residentNumberBack || "").replace(/\D/g, "").slice(0, 7);
      f.residentNumber = f.residentNumberBack ? `${f.residentNumberFront}-${f.residentNumberBack}` : f.residentNumberFront;
      this.rrnError = this.validateRrn(f.residentNumber);
    },
    /** Validate full RRN. Returns "" if valid or incomplete; localized error otherwise. */
    validateRrn(rrn) {
      return validateRrn(rrn, (k) => this._t(k));
    },
    addHrValid() {
      const f = this.addEmployeeForm;
      return !!(f.hireDate && f.addMemberships.length > 0 && // 소속마다 근무 그룹이 있어야 한다 — 팀 기본값이 있는 줄은 자동으로 채워져 있고,
      // 기본값이 없는 팀의 줄만 직접 고르면 된다.
      f.addMemberships.every((m) => !!m.shiftGroupId) && f.jobDutyId);
    },
    addCertValid() {
      const f = this.addEmployeeForm;
      return !f.certEnabled || f.certRows.some((r) => !!r.type);
    },
    addContractValid() {
      const f = this.addEmployeeForm;
      return !!(f.contractType && f.wageType) && probationValid(f);
    },
    /** 「수습 종료 후」 블록이 채워졌지만 규칙에 안 맞는가 — 블록 아래 안내와 카테고리 빨간 점이 함께 쓴다. */
    addProbationInvalid() {
      return probationEntered(this.addEmployeeForm) && !probationValid(this.addEmployeeForm);
    },
    /** 미리보기 한 줄 — 「2026-12-31 까지 수습 · 다음 날부터 기본급 3,000,000원」. 블록이 비면 "". */
    addProbationReviewLabel() {
      const f = this.addEmployeeForm;
      if (!probationEntered(f)) {
        return "";
      }
      return this._t("contract.probation_review", {
        date: f.probationEndDate,
        values: probationValuesLabel(f, {
          baseSalary: this._t("settings.base_salary"),
          hourlyRate: this._t("contract.probation_after_hourly_rate"),
          won: this._t("common.won_suffix")
        })
      });
    },
    addFormValid() {
      return this.addBasicValid() && this.addHrValid() && this.addCertValid() && this.addContractValid();
    },
    // ── 자격유형 체크박스 (체크 = certRows에 행 추가, 해제 = 제거) ──
    certHasType(value) {
      return this.addEmployeeForm.certRows.some((r) => r.type === value);
    },
    certToggleType(value) {
      const rows = this.addEmployeeForm.certRows;
      const idx = rows.findIndex((r) => r.type === value);
      if (idx >= 0) {
        rows.splice(idx, 1);
      } else {
        rows.push({
          type: value
        });
      }
    },
    /** 유형이 선택된 행 수 — "{n}개의 자격증 제출을 요청합니다." 안내 문구에 사용 */
    get certSelectedCount() {
      return this.addEmployeeForm.certRows.filter((r) => !!r.type).length;
    },
    /** 자격 유형 코드 → 표시 라벨(체크박스 그리드와 동일). 옵션에 없으면 기본 이름으로 폴백. */
    certTypeLabel(type) {
      const opt = this.certTypeOptions.find((o) => o.value === type);
      return opt?.label || this.certTypeDefaultName(type);
    },
    /** 미리보기 — 선택된 자격증/면허 이름을 사람이 읽을 라벨로 결합한다. 유형 미선택 행은 제외. */
    get previewCertNames() {
      return this.addEmployeeForm.certRows.filter((r) => !!r.type).map((r) => this.certTypeLabel(r.type)).join(", ");
    },
    /** 이메일·전화번호·사번 중복 검사. 오류가 있으면 false. */
    validateDuplicates() {
      const f = this.addEmployeeForm;
      this.addFormErrors = {
        email: "",
        phone: "",
        employeeNumber: ""
      };
      const allEmps = this.employees;
      let hasError = false;
      if (f.email) {
        const dupEmail = allEmps.find(
          // biome-ignore lint/suspicious/noExplicitAny: dynamic employee data
          (e) => e.email?.toLowerCase() === f.email.toLowerCase()
        );
        if (dupEmail) {
          this.addFormErrors.email = "\uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC778 \uC774\uBA54\uC77C\uC785\uB2C8\uB2E4.";
          hasError = true;
        }
      }
      if (f.phone) {
        const rawPhone = f.phone.replace(/-/g, "");
        const dupPhone = allEmps.find(
          // biome-ignore lint/suspicious/noExplicitAny: dynamic employee data
          (e) => (e.phone || "").replace(/-/g, "") === rawPhone
        );
        if (dupPhone) {
          this.addFormErrors.phone = "\uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC778 \uBC88\uD638\uC785\uB2C8\uB2E4.";
          hasError = true;
        }
      }
      if (f.employeeNumber && !f.autoGenerateEmployeeNumber) {
        const wanted = String(f.employeeNumber).toUpperCase();
        const dupNum = allEmps.find(
          // biome-ignore lint/suspicious/noExplicitAny: dynamic employee data
          (e) => String(e.employeeNumber ?? "").toUpperCase() === wanted
        );
        if (dupNum) {
          this.addFormErrors.employeeNumber = "\uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC778 \uC0AC\uBC88\uC785\uB2C8\uB2E4.";
          hasError = true;
        }
      }
      return !hasError;
    },
    async saveNewEmployee() {
      const f = this.addEmployeeForm;
      if (!this.addFormValid()) {
        return;
      }
      if (!this.validateDuplicates()) {
        return;
      }
      if (!herebyStore(this).hasPermission("team:update")) {
        this.showNotice(this._t("employee.team_permission_required"), "danger");
        return;
      }
      this.addEmployeeSaving = true;
      try {
        const params = {
          lastName: f.lastName,
          firstName: f.firstName,
          hireDate: f.hireDate,
          status: f.status
        };
        if (f.email) {
          params.email = f.email;
        }
        if (f.phone) {
          params.phone = f.phone;
        }
        if (f.employeeNumber) {
          params.employeeNumber = f.employeeNumber;
        }
        if (f.birthDate) {
          params.birthDate = f.birthDate;
          params.isLunarBirth = f.isLunarBirth;
        }
        if (f.payrollExcluded) {
          params.payrollExcluded = true;
        }
        const rrnDigits = (f.residentNumber || "").replace(/\D/g, "");
        if (rrnDigits.length === 13 && this.validateRrn(f.residentNumber) === "") {
          params.residentNumber = f.residentNumber;
        }
        if (f.address) {
          params.address = {
            street: f.address,
            ...f.postalCode ? {
              postalCode: f.postalCode
            } : {},
            ...(f.addressDetail || "").trim() ? {
              detail: f.addressDetail.trim()
            } : {}
          };
        }
        if (f.shiftGroupId) {
          params.shiftGroupId = f.shiftGroupId;
        }
        if (f.shiftId) {
          params.shiftId = f.shiftId;
        }
        if (f.attendanceMethod) {
          params.attendanceMethod = f.attendanceMethod;
        }
        if (f.jobDutyId) {
          params.jobDutyId = f.jobDutyId;
        }
        if (f.workPatternId) {
          params.workPatternId = f.workPatternId;
        }
        if (f.wardId) {
          params.wardId = f.wardId;
        }
        const allowances = {};
        if (f.mealAllowance > 0) {
          allowances.meal = f.mealAllowance;
        }
        if (f.transportAllowance > 0) {
          allowances.transportation = f.transportAllowance;
        }
        if (f.positionAllowance > 0) {
          allowances.position = f.positionAllowance;
        }
        params.contract = {
          contractType: f.contractType,
          wageType: f.wageType,
          // 호봉 배정 — 선택 시 FK 기록, 미선택은 자유 입력 계약.
          salaryGradeId: f.salaryGradeId || void 0,
          baseSalary: f.baseSalary || 0,
          hobongAmount: f.hobongAmount || 0,
          longevityAmount: f.longevityAmount || 0,
          allowances: Object.keys(allowances).length > 0 ? allowances : void 0,
          standardWeeklyHours: f.standardWeeklyHours,
          maxWeeklyHours: f.maxWeeklyHours
        };
        const probation = buildProbationInput(f);
        if (probation) {
          params.probation = probation;
        }
        const schedulerNotes = [];
        const result = await this.sdk.employee.createEmployee(params);
        schedulerNotes.push(result?.wardAssignment?.scheduler);
        const newEmployeeId = result?.id;
        const membershipFailedTeams = [];
        if (newEmployeeId) {
          const ordered = [
            ...f.addMemberships
          ].sort((a, b) => Number(b.teamId === f.primaryTeamId) - Number(a.teamId === f.primaryTeamId));
          for (const m of ordered) {
            try {
              const member = await this.sdk.team.addMember({
                teamId: m.teamId,
                employeeId: newEmployeeId,
                // 근무 배정은 소속마다 — 주 소속 줄의 근무는 서버가 직원 근무(근태·연차)로 맞춘다.
                shiftGroupId: m.shiftGroupId || null,
                shiftId: m.shiftId || null,
                isPrimary: m.teamId === f.primaryTeamId
              });
              schedulerNotes.push(member?.wardAssignment?.scheduler);
              if (m.roleId && member?.id) {
                await this.sdk.team.updateMember(m.teamId, member.id, {
                  roleId: m.roleId
                });
              }
            } catch {
              membershipFailedTeams.push(m.teamName || m.teamId);
            }
          }
        }
        if (f.certEnabled && newEmployeeId) {
          for (const row of f.certRows) {
            if (!row.type) {
              continue;
            }
            try {
              await this.sdk.employeeCertification.create({
                employeeId: newEmployeeId,
                type: row.type,
                name: this.certTypeDefaultName(row.type)
              });
            } catch {
            }
          }
        }
        this.addEmployeeResult = {
          password: result?.temporaryPassword || "",
          employeeNumber: result?.employeeNumber || "",
          employeeId: newEmployeeId || "",
          smsSent: false,
          smsSending: false,
          membershipFailedTeams,
          wardSchedulerHint: wardSchedulerHint(schedulerNotes),
          // 신규 입사자 시트 자동 추가 결과 — 어느 시트에 행이 들어갔는지 완료 화면에 보여 준다
          sheetAutoAdd: result?.sheetAutoAdd ?? null
        };
        await this.loadReferenceData();
        opts.onComplete?.(newEmployeeId || void 0);
      } catch (err) {
        this.showNotice(`${this._t("admin.create_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      } finally {
        this.addEmployeeSaving = false;
      }
    },
    async sendNewEmployeePassword() {
      const r = this.addEmployeeResult;
      if (!r || r.smsSent || r.smsSending || !r.employeeId) {
        return;
      }
      r.smsSending = true;
      try {
        const result = await this.sdk.auth.adminResetPassword(r.employeeId);
        if (result?.smsSent) {
          r.smsSent = true;
          r.password = "";
          this.showNotice(this._t("admin.temp_password_sent"), "success");
        } else {
          this.showNotice(result?.message || this._t("admin.temp_password_sent"), "success");
        }
      } catch (err) {
        this.showNotice(`${this._t("admin.password_reset_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      } finally {
        r.smsSending = false;
      }
    },
    formatPhone(val) {
      return val.replace(/\D/g, "").slice(0, 11);
    },
    formatRrn(val) {
      const digits = val.replace(/\D/g, "").slice(0, 13);
      if (digits.length <= 6) {
        return digits;
      }
      return `${digits.slice(0, 6)}-${digits.slice(6)}`;
    },
    certTypeDefaultName(type) {
      const map2 = {
        nursing: "\uAC04\uD638\uC0AC \uBA74\uD5C8",
        nurse_aide: "\uAC04\uD638\uC870\uBB34\uC0AC \uC790\uACA9\uC99D",
        physical_therapist: "\uBB3C\uB9AC\uCE58\uB8CC\uC0AC \uBA74\uD5C8",
        occupational_therapist: "\uC791\uC5C5\uCE58\uB8CC\uC0AC \uBA74\uD5C8",
        speech_therapist: "\uC5B8\uC5B4\uCE58\uB8CC\uC0AC \uBA74\uD5C8",
        radiologist: "\uBC29\uC0AC\uC120\uC0AC \uBA74\uD5C8",
        clinical_lab: "\uC784\uC0C1\uBCD1\uB9AC\uC0AC \uBA74\uD5C8",
        pharmacist: "\uC57D\uC0AC \uBA74\uD5C8",
        dietitian: "\uC601\uC591\uC0AC \uBA74\uD5C8",
        social_worker: "\uC0AC\uD68C\uBCF5\uC9C0\uC0AC \uC790\uACA9\uC99D",
        medical_doctor: "\uC758\uC0AC \uBA74\uD5C8",
        dentist: "\uCE58\uACFC\uC758\uC0AC \uBA74\uD5C8",
        emergency_medical: "\uC751\uAE09\uAD6C\uC870\uC0AC \uC790\uACA9\uC99D",
        care_worker: "\uC694\uC591\uBCF4\uD638\uC0AC \uC790\uACA9\uC99D",
        other: "\uAE30\uD0C0"
      };
      return map2[type] || type;
    },
    /** 면허/자격 유형 목록 (자격증/면허 등록 카테고리 — 입사 시 유형만 등록). */
    get certTypeOptions() {
      if (this.certTypeConfigs.length > 0) {
        return this.certTypeConfigs.map((c) => ({
          value: c.code,
          label: c.name
        }));
      }
      return [
        {
          value: "nursing",
          label: "\uAC04\uD638\uC0AC"
        },
        {
          value: "nurse_aide",
          label: "\uAC04\uD638\uC870\uBB34\uC0AC"
        },
        {
          value: "physical_therapist",
          label: "\uBB3C\uB9AC\uCE58\uB8CC\uC0AC"
        },
        {
          value: "occupational_therapist",
          label: "\uC791\uC5C5\uCE58\uB8CC\uC0AC"
        },
        {
          value: "speech_therapist",
          label: "\uC5B8\uC5B4\uCE58\uB8CC\uC0AC"
        },
        {
          value: "radiologist",
          label: "\uBC29\uC0AC\uC120\uC0AC"
        },
        {
          value: "clinical_lab",
          label: "\uC784\uC0C1\uBCD1\uB9AC\uC0AC"
        },
        {
          value: "pharmacist",
          label: "\uC57D\uC0AC"
        },
        {
          value: "dietitian",
          label: "\uC601\uC591\uC0AC"
        },
        {
          value: "social_worker",
          label: "\uC0AC\uD68C\uBCF5\uC9C0\uC0AC"
        },
        {
          value: "medical_doctor",
          label: "\uC758\uC0AC"
        },
        {
          value: "dentist",
          label: "\uCE58\uACFC\uC758\uC0AC"
        },
        {
          value: "emergency_medical",
          label: "\uC751\uAE09\uAD6C\uC870\uC0AC"
        },
        {
          value: "care_worker",
          label: "\uC694\uC591\uBCF4\uD638\uC0AC"
        },
        {
          value: "other",
          label: "\uAE30\uD0C0"
        }
      ];
    },
    // ── 소속(팀·역할) 피커 — 직원 정보 수정 팝업과 동일한 캐스케이딩 흐름 ──────
    /** 역할 관리에서 활성화된 역할만 (피커에 노출). */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic role rows
    activeRoles() {
      return this.roles.filter((r) => r.isActive !== false);
    },
    /** [+ 팀 추가] — 팀 선택 단계부터 시작. */
    affStartAdd() {
      this.affPicker = !this.affPicker;
      this.affStep = "team";
      this.affSelTeam = "";
    },
    affPickTeam(teamId) {
      this.affSelTeam = teamId;
      this.affStep = "role";
    },
    /** 역할 선택(또는 '역할 없이 추가') → 소속 행 추가. 이미 추가된 팀은 무시. */
    affPickRole(roleId) {
      const teamId = this.affSelTeam;
      if (!teamId) {
        this.affPicker = false;
        return;
      }
      const exists = this.addEmployeeForm.addMemberships.some((m) => m.teamId === teamId);
      if (!exists) {
        const team = this.teams.find((t) => t.id === teamId);
        const role = roleId ? this.roles.find((r) => r.id === roleId) : null;
        this.addEmployeeForm.addMemberships.push({
          teamId,
          teamName: team?.name || "",
          roleId: roleId || "",
          roleName: role?.name || "",
          // 직무 기본 근무 → 팀 대표 근무 순서로 기본 선택된다(없으면 미지정) — 줄에서 조직 전체 근무로 바꿀 수 있다.
          ...this.defaultShiftForTeam(teamId)
        });
        if (!this.addEmployeeForm.primaryTeamId) {
          this.addEmployeeForm.primaryTeamId = teamId;
        }
        this.syncPrimaryShift();
      }
      this.affPicker = false;
      this.affStep = "team";
      this.affSelTeam = "";
    },
    affRemove(idx) {
      const removed = this.addEmployeeForm.addMemberships[idx];
      this.addEmployeeForm.addMemberships.splice(idx, 1);
      if (removed && this.addEmployeeForm.primaryTeamId === removed.teamId) {
        this.addEmployeeForm.primaryTeamId = "";
      }
      this.syncPrimaryShift();
    },
    /** 소속 칩의 팀 세그먼트에서 팀 변경 — 로컬 배열만 수정(직원 생성 전이라 서버 반영 없음). */
    affChangeTeam(idx, teamId) {
      const m = this.addEmployeeForm.addMemberships[idx];
      const team = this.teams.find((t) => t.id === teamId);
      if (!(m && team)) {
        return;
      }
      const dup = this.addEmployeeForm.addMemberships.some((x, i) => i !== idx && x.teamId === teamId);
      if (dup) {
        return;
      }
      const wasPrimary = this.addEmployeeForm.primaryTeamId === m.teamId;
      m.teamId = teamId;
      m.teamName = team.name || "";
      const rep = this.defaultShiftForTeam(teamId);
      m.shiftGroupId = rep.shiftGroupId;
      m.shiftId = rep.shiftId;
      if (wasPrimary) {
        this.addEmployeeForm.primaryTeamId = teamId;
      }
      this.syncPrimaryShift();
    },
    /** 소속 칩의 역할 세그먼트에서 역할 변경(null = 역할 없음) — 로컬 배열만 수정. */
    affChangeRole(idx, roleId) {
      const m = this.addEmployeeForm.addMemberships[idx];
      if (!m) {
        return;
      }
      const role = roleId ? this.roles.find((r) => r.id === roleId) : null;
      m.roleId = roleId || "";
      m.roleName = role?.name || "";
    },
    positionFloatingMenu(triggerEl, menuEl) {
      positionFloatingMenu(triggerEl, menuEl);
    }
  };
}
__name(addEmployeePanelComponent, "addEmployeePanelComponent");

// src/components/AiAssistant.ts
import { AiFeedbackRating, AiMessageRole, AiMessageStatus } from "@hereby/core/enums";

// src/icons.ts
var ICONS = {
  // ─── Brand & chrome ──────────────────────────────────────────────────────
  //
  // BI 심볼의 그라디언트 stop 은 **hex 하드코딩이 규격**이다 (토큰 규칙의 예외).
  // BI 자산은 CSS 변수가 없는 곳(이메일 HTML·단독 SVG·외부 배포)에서도 열려야 하는데
  // var() 를 쓰면 그런 곳에서 심볼이 검게 렌더된다. 토큰으로 "고치지" 말 것.
  // 마스터의 값은 토큰과 동일하고(orange-400 / hr-red-400 / yellow-400), 패밀리는
  // 대응 토큰이 없는 전용 3-stop 이다. 규칙 정본: docs/ko/design-system/foundations/brand.md
  //
  // 그라디언트 id 는 문서 전역이므로 심볼마다 다른 id 를 쓴다 — 겹치면 브라우저가
  // 먼저 나온 정의를 써서 엉뚱한 그라디언트로 칠해진다.
  "logo-hereby": `<svg width="24" height="24" viewBox="5 3 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M29.0008 7.53951C29.0008 6.13698 27.8643 5 26.4624 5C25.7612 5 25.1262 5.28419 24.6668 5.744L20.1154 10.2964C19.8051 10.6565 19.3463 10.885 18.8338 10.885C17.8991 10.885 17.1415 10.127 17.1415 9.19201C17.1415 8.64207 17.1547 8.09031 17.1547 7.53951C17.1547 6.13698 16.0182 5 14.6162 5C13.915 5 13.28 5.28419 12.8206 5.744L9.14537 9.42604C7.17841 11.4139 7 12.2967 7 15.228L7.00042 19.8443L7.00415 24.5911C7.0721 25.9329 8.18114 27 9.53931 27C10.2405 27 10.8747 26.715 11.3341 26.2552L13.6129 23.9767C13.6129 23.9767 15.5806 22.0541 15.8908 21.6974C16.2011 21.3406 16.6581 21.115 17.1679 21.115C18.1025 21.115 18.8602 21.873 18.8602 22.808C18.8602 23.4021 18.8353 23.9971 18.8503 24.5911C18.9183 25.9329 20.0273 27 21.3855 27C22.0866 27 22.7208 26.715 23.1802 26.2552L26.8563 22.5891C28.8233 20.6013 29.0017 19.7184 29.0017 16.7871L29.0008 7.53951Z" fill="url(#lnb-hereby-grad)"/><defs><linearGradient id="lnb-hereby-grad" x1="27.2369" y1="20.0341" x2="8.32716" y2="12.9674" gradientUnits="userSpaceOnUse"><stop stop-color="#F8884F"/><stop offset="0.5" stop-color="#FF4141"/><stop offset="0.956731" stop-color="#F6BC3D"/></linearGradient></defs></svg>`,
  // Family BI 심볼 — 패밀리 사이트(hereby Medical / hereby Sign / hereby Works)가 주체인 화면에서 쓴다.
  // 마스터 심볼과 그라디언트가 다르다(패밀리 전용 3-stop). 규칙 정본:
  // docs/ko/design-system/foundations/brand.md
  "logo-hereby-medical": `<svg width="24" height="24" viewBox="1 6 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M29 29.0002C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V11.0002C1 8.23882 3.23858 6.00024 6 6.00024H24C26.7614 6.00024 29 8.23882 29 11.0002V29.0002Z" fill="url(#lnb-hereby-medical-grad)"/><path d="M29 29.0002C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V11.0002C1 8.23882 3.23858 6.00024 6 6.00024H24C26.7614 6.00024 29 8.23882 29 11.0002V29.0002Z M29 29.0002C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V11.0002C1 8.23882 3.23858 6.00024 6 6.00024H24C26.7614 6.00024 29 8.23882 29 11.0002V29.0002ZM12.7695 11.385C12.2172 11.385 11.7695 11.8327 11.7695 12.385V15.7698C11.7695 16.3219 11.3217 16.7697 10.7695 16.7698H7.38477C6.83248 16.7698 6.38477 17.2175 6.38477 17.7698V22.2317C6.38485 22.7839 6.83253 23.2317 7.38477 23.2317H10.7695C11.3217 23.2318 11.7695 23.6795 11.7695 24.2317V27.6155C11.7696 28.1677 12.2173 28.6155 12.7695 28.6155H17.2305C17.7826 28.6154 18.2304 28.1676 18.2305 27.6155V24.2317C18.2305 23.6794 18.6782 23.2317 19.2305 23.2317H22.6152C23.1674 23.2316 23.6152 22.7839 23.6152 22.2317V17.7698C23.6152 17.2175 23.1675 16.7699 22.6152 16.7698H19.2305C18.6782 16.7698 18.2305 16.322 18.2305 15.7698V12.385C18.2305 11.8328 17.7827 11.3851 17.2305 11.385H12.7695Z" fill-rule="evenodd" fill="#FFFFFF"/><defs><linearGradient id="lnb-hereby-medical-grad" x1="27.3846" y1="34.0002" x2="1.2256" y2="8.99501" gradientUnits="userSpaceOnUse"><stop stop-color="#FE4D43"/><stop offset="0.389423" stop-color="#FF7732"/><stop offset="0.956731" stop-color="#FFAF00"/></linearGradient></defs></svg>`,
  "logo-hereby-sign": `<svg width="24" height="24" viewBox="1 6 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M29 29.0002C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V11.0002C1 8.23882 3.23858 6.00024 6 6.00024H24C26.7614 6.00024 29 8.23882 29 11.0002V29.0002Z" fill="url(#lnb-hereby-sign-grad)"/><path d="M29 29.0002C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V11.0002C1 8.23882 3.23858 6.00024 6 6.00024H24C26.7614 6.00024 29 8.23882 29 11.0002V29.0002Z M24 6.00024C26.7614 6.00024 29 8.23882 29 11.0002V29.0002C29 29.3273 28.9672 29.6468 28.9072 29.9563L22.8584 23.9075C24.0031 20.1552 22.0177 15.8184 17.8389 14.5813L9.00586 11.9661C8.50881 11.8191 8.14419 12.4335 8.51074 12.8L12.9375 17.2268L15.8809 18.2073C17.8689 18.8701 18.4709 21.386 17.0078 22.8772L16.9678 22.9172C15.4766 24.3801 12.9606 23.7782 12.2979 21.7903L11.3193 18.8489L6.86523 14.3948C6.50066 14.0302 5.88938 14.3892 6.03027 14.885L8.55859 23.7639C9.77607 28.0394 14.237 30.061 18.0459 28.8157L23.2305 34.0002H6C3.23874 34.0002 1.00026 31.7614 1 29.0002V10.9993C1.00026 8.23807 3.23874 6.00024 6 6.00024H24Z" fill-rule="evenodd" fill="#FFFFFF"/><defs><linearGradient id="lnb-hereby-sign-grad" x1="27.3846" y1="34.0002" x2="1.2256" y2="8.99501" gradientUnits="userSpaceOnUse"><stop stop-color="#FE4D43"/><stop offset="0.389423" stop-color="#FF7732"/><stop offset="0.956731" stop-color="#FFAF00"/></linearGradient></defs></svg>`,
  "logo-hereby-works": `<svg width="24" height="24" viewBox="1 6 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 6L9.84668 6.00684C10.4852 6.01277 10.9998 6.5323 11 7.1709C11 8.45672 12.0423 9.49991 13.3281 9.5H16.667C17.8751 9.49984 18.869 8.58102 18.9883 7.4043L19.0059 7.04688C19.0656 6.45858 19.5629 6 20.167 6H21V5.99902H24C26.7614 5.99902 29 8.23858 29 11V29C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V10.999C1.00026 8.23782 3.23874 5.99902 6 5.99902H9V6Z" fill="url(#lnb-hereby-works-grad)"/><path d="M9 6L9.84668 6.00684C10.4852 6.01277 10.9998 6.5323 11 7.1709C11 8.45672 12.0423 9.49991 13.3281 9.5H16.667C17.8751 9.49984 18.869 8.58102 18.9883 7.4043L19.0059 7.04688C19.0656 6.45858 19.5629 6 20.167 6H21V5.99902H24C26.7614 5.99902 29 8.23858 29 11V29C29 31.7617 26.7614 34.0002 24 34.0002H6C3.23858 34.0002 1 31.7617 1 29.0002V10.999C1.00026 8.23782 3.23874 5.99902 6 5.99902H9V6Z M9 6L9.84668 6.00684C10.4852 6.01277 10.9998 6.5323 11 7.1709C11 8.45672 12.0423 9.49991 13.3281 9.5H16.667C17.8751 9.49984 18.869 8.58102 18.9883 7.4043L19.0059 7.04688C19.0656 6.45858 19.5629 6 20.167 6H21V5.99902H24C26.7614 5.99902 29 8.23858 29 11V29C28.9998 31.5921 27.027 33.7232 24.501 33.9746C23.3816 29.7949 19.5534 26.7159 15 26.7158C10.4464 26.7158 6.61726 29.7947 5.49805 33.9746C2.9725 33.7228 1.00025 31.5918 1 29V10.999C1.00026 8.23782 3.23874 5.99902 6 5.99902H9V6ZM15 15C12.2846 15 10.0833 17.2017 10.083 19.917C10.0833 22.6323 12.2846 24.8339 15 24.834C17.7154 24.834 19.9167 22.6324 19.917 19.917C19.9167 17.2016 17.7154 15 15 15Z" fill-rule="evenodd" fill="#FFFFFF"/><defs><linearGradient id="lnb-hereby-works-grad" x1="27.3846" y1="34" x2="1.22473" y2="8.9948" gradientUnits="userSpaceOnUse"><stop stop-color="#FE4D43"/><stop offset="0.389423" stop-color="#FF7732"/><stop offset="0.956731" stop-color="#FFAF00"/></linearGradient></defs></svg>`,
  // Family BI 심볼 — **outline 케이스**. 그라디언트를 쓰지 않고 워드마크와 **한 색**으로 묶이는
  // 조합형이라, 여기 등록된 것은 어두운 배경용(흰색) 하나다. 밝은 배경이 필요하면 그때는
  // `#1B1B1B` 본을 따로 등록한다 — outline 은 색이 배경에서 갈리므로 이름에 배경이 붙는다.
  // 기본형은 언제나 위의 `fill` 이다. 규칙 정본: docs/ko/design-system/foundations/brand.md
  "logo-hereby-medical-outline-on-dark": `<svg viewBox="2 18.5 93 93" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="hereby \uBA54\uB514\uCEEC \uC2EC\uBCFC"><path d="M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894ZM41.092 36.386C39.257 36.386 37.77 37.873 37.77 39.707V50.95C37.77 52.783 36.283 54.271 34.449 54.271H23.207C21.372 54.271 19.885 55.758 19.885 57.593V72.412C19.885 74.247 21.372 75.734 23.207 75.734H34.449C36.283 75.734 37.77 77.221 37.77 79.055V90.294C37.77 92.128 39.257 93.616 41.092 93.616H55.908C57.742 93.615 59.23 92.128 59.23 90.294V79.055C59.23 77.221 60.717 75.734 62.551 75.734H73.793C75.627 75.734 77.115 74.247 77.115 72.412V57.593C77.115 55.758 75.628 54.271 73.793 54.271H62.551C60.717 54.271 59.23 52.784 59.23 50.95V39.707C59.23 37.873 57.743 36.386 55.908 36.386H41.092Z" fill="#FFFFFF"/></svg>`,
  // Family BI **lockup** (symbol + wordmark as one asset) — ratio is fixed by viewBox;
  // the consumer sets the size in CSS. The wordmark is a path (correct regardless of font
  // loading). Gradient stop-color stays hardcoded hex — the official token exception, since
  // var() renders the symbol black where CSS variables do not exist.
  // Rule source: docs/ko/design-system/foundations/brand.md
  "logo-lockup-hereby-medical": `<svg viewBox="0 0 865 130" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="hereby Medical"><path d="M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894Z" fill="url(#bi-lockup-medical-grad)"/><path d="M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894Z M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894ZM41.092 36.386C39.257 36.386 37.77 37.873 37.77 39.707V50.95C37.77 52.783 36.283 54.271 34.449 54.271H23.207C21.372 54.271 19.885 55.758 19.885 57.593V72.412C19.885 74.247 21.372 75.734 23.207 75.734H34.449C36.283 75.734 37.77 77.221 37.77 79.055V90.294C37.77 92.128 39.257 93.616 41.092 93.616H55.908C57.742 93.615 59.23 92.128 59.23 90.294V79.055C59.23 77.221 60.717 75.734 62.551 75.734H73.793C75.627 75.734 77.115 74.247 77.115 72.412V57.593C77.115 55.758 75.628 54.271 73.793 54.271H62.551C60.717 54.271 59.23 52.784 59.23 50.95V39.707C59.23 37.873 57.743 36.386 55.908 36.386H41.092Z" fill-rule="evenodd" fill="#FFFFFF"/><path d="M153.8 100.5L141 100.5L141 29.5L153.8 29.5L153.8 54.2Q156 50 160 47.95Q164 45.9 169 45.9Q177.9 45.9 182.5 51.55Q187.1 57.2 187.1 66.2L187.1 100.5L174.3 100.5L174.3 69.3Q174.3 56.3 165.2 56.3Q159.9 56.3 156.85 59.7Q153.8 63.1 153.8 69.6L153.8 100.5M222.9 101.7Q214.9 101.7 209 98.25Q203.1 94.8 199.9 88.5Q196.7 82.2 196.7 73.8Q196.7 65.4 199.9 59.1Q203.1 52.8 208.95 49.35Q214.8 45.9 222.6 45.9Q230.2 45.9 235.9 49.3Q241.6 52.7 244.75 59.1Q247.9 65.5 247.9 74.5L247.9 77.4L210 77.4Q210.3 84.4 213.8 87.95Q217.3 91.5 223 91.5Q231.7 91.5 234.1 84.1L247.2 84.9Q245 92.7 238.55 97.2Q232.1 101.7 222.9 101.7M210 68.8L234.7 68.8Q234.2 62.3 230.95 59.15Q227.7 56 222.6 56Q217.4 56 214.1 59.3Q210.8 62.6 210 68.8M270.7 100.5L257.9 100.5L257.9 47.1L269.9 47.1L270.2 57.5Q271.8 52.1 274.9 49.6Q278 47.1 283 47.1L287.9 47.1L287.9 58.1L282.9 58.1Q276.8 58.1 273.75 60.85Q270.7 63.6 270.7 69.7L270.7 100.5M317.9 101.7Q309.9 101.7 304 98.25Q298.1 94.8 294.9 88.5Q291.7 82.2 291.7 73.8Q291.7 65.4 294.9 59.1Q298.1 52.8 303.95 49.35Q309.8 45.9 317.6 45.9Q325.2 45.9 330.9 49.3Q336.6 52.7 339.75 59.1Q342.9 65.5 342.9 74.5L342.9 77.4L305 77.4Q305.3 84.4 308.8 87.95Q312.3 91.5 318 91.5Q326.7 91.5 329.1 84.1L342.2 84.9Q340 92.7 333.55 97.2Q327.1 101.7 317.9 101.7M305 68.8L329.7 68.8Q329.2 62.3 325.95 59.15Q322.7 56 317.6 56Q312.4 56 309.1 59.3Q305.8 62.6 305 68.8M381.6 101.7Q376 101.7 371.8 99.3Q367.6 96.9 365.4 92.6L365.1 100.5L352.9 100.5L352.9 29.5L365.7 29.5L365.7 54.7Q367.8 51.1 371.95 48.5Q376.1 45.9 381.6 45.9Q388.5 45.9 393.55 49.35Q398.6 52.8 401.35 59.05Q404.1 65.3 404.1 73.8Q404.1 82.3 401.35 88.55Q398.6 94.8 393.55 98.25Q388.5 101.7 381.6 101.7M378.7 91.3Q384.2 91.3 387.5 86.65Q390.8 82 390.8 73.8Q390.8 65.5 387.55 60.9Q384.3 56.3 378.8 56.3Q372.6 56.3 369.15 60.9Q365.7 65.5 365.7 73.8Q365.7 82 369.15 86.65Q372.6 91.3 378.7 91.3M425.1 115.5L416 115.5L416 105.6L422.8 105.6Q425.4 105.6 426.65 104.8Q427.9 104 428.6 102.1L430.1 98.4L426.4 98.4L407.3 47.1L420.6 47.1L434 86.4L446.8 47.1L460.1 47.1L439.2 106.1Q437.4 111.1 434.15 113.3Q430.9 115.5 425.1 115.5" fill="#1B1B1B"/><path d="M494 100.5V29.5H511.5L531.1 84.5L550.7 29.5H568.2V100.5H555.2V51.5L537.3 100.4H524.9L507 51.5V100.5ZM605.3 101.7Q597.3 101.7 591.4 98.25Q585.5 94.8 582.3 88.5Q579.1 82.2 579.1 73.8Q579.1 65.4 582.3 59.1Q585.5 52.8 591.35 49.35Q597.2 45.9 605 45.9Q612.6 45.9 618.3 49.3Q624 52.7 627.15 59.1Q630.3 65.5 630.3 74.5V77.4H592.4Q592.7 84.4 596.2 87.95Q599.7 91.5 605.4 91.5Q614.1 91.5 616.5 84.1L629.6 84.9Q627.4 92.7 620.95 97.2Q614.5 101.7 605.3 101.7ZM592.4 68.8H617.1Q616.6 62.3 613.35 59.15Q610.1 56 605 56Q599.8 56 596.5 59.3Q593.2 62.6 592.4 68.8ZM659.3 101.7Q652.5 101.7 647.55 98.3Q642.6 94.9 639.9 88.65Q637.2 82.4 637.2 73.8Q637.2 65.3 639.95 59Q642.7 52.7 647.65 49.3Q652.6 45.9 659.3 45.9Q664.9 45.9 669.15 48.2Q673.4 50.5 675.6 54.7V29.5H688.4V100.5H676.2L675.9 92.6Q673.7 96.9 669.3 99.3Q664.9 101.7 659.3 101.7ZM663.2 91.3Q669.1 91.3 672.35 86.75Q675.6 82.2 675.6 73.8Q675.6 65.3 672.4 60.8Q669.2 56.3 663.2 56.3Q657.4 56.3 653.95 60.95Q650.5 65.6 650.5 73.8Q650.5 81.8 653.95 86.55Q657.4 91.3 663.2 91.3ZM700.8 100.5V47.1H713.6V100.5ZM700.6 40V28.6H713.9V40ZM749.9 101.7Q741.9 101.7 736 98.25Q730.1 94.8 726.85 88.5Q723.6 82.2 723.6 73.8Q723.6 65.4 726.85 59.1Q730.1 52.8 736 49.35Q741.9 45.9 749.9 45.9Q760.1 45.9 766.85 51.2Q773.6 56.5 774.8 66L761.6 66.7Q760.8 61.6 757.65 58.95Q754.5 56.3 749.9 56.3Q743.7 56.3 740.3 60.9Q736.9 65.5 736.9 73.8Q736.9 82.1 740.3 86.7Q743.7 91.3 749.9 91.3Q754.6 91.3 757.75 88.6Q760.9 85.9 761.6 80.2L774.8 80.8Q773.7 90.4 766.95 96.05Q760.2 101.7 749.9 101.7ZM800 101.7Q791.6 101.7 786.5 97.9Q781.4 94.1 781.4 87.1Q781.4 80.2 785.7 76.3Q790 72.4 798.8 70.7L816.5 67.2Q816.5 55.8 806.2 55.8Q801.6 55.8 798.9 57.95Q796.2 60.1 795.3 64.1L782.3 63.5Q783.9 55.1 790.1 50.5Q796.3 45.9 806.2 45.9Q817.6 45.9 823.45 51.65Q829.3 57.4 829.3 68.1V87.5Q829.3 89.6 830.05 90.4Q830.8 91.2 832.3 91.2H834V100.5Q832.3 100.9 829.3 100.9Q825 100.9 822 99.1Q819 97.3 818.2 92.4V92.3Q816.2 96.5 811.35 99.1Q806.5 101.7 800 101.7ZM802.6 92.4Q809 92.4 812.75 88.7Q816.5 85 816.5 78.9V75.9L802.7 78.7Q798.4 79.6 796.55 81.35Q794.7 83.1 794.7 85.9Q794.7 92.4 802.6 92.4ZM854.3 100.5Q848.4 100.5 844.95 97.5Q841.5 94.5 841.5 87.9V29.5H854.3V86.6Q854.3 90.6 858.3 90.6H862.2V100.5Z" fill="#1B1B1B"/><defs><linearGradient id="bi-lockup-medical-grad" x1="89.63" y1="111.5" x2="2.75" y2="28.45" gradientUnits="userSpaceOnUse"><stop stop-color="#FE4D43"/><stop offset="0.389423" stop-color="#FF7732"/><stop offset="0.956731" stop-color="#FFAF00"/></linearGradient></defs></svg>`,
  // `hereby Sign` 락업 — 702×130(brand.md 의 고정 비율). medical·works 와 **같은 방식으로**
  // 조립돼 있다: 컨테이너(그라디언트) + 컨테이너·심볼을 합친 evenodd 흰 면 + `hereby` + 서비스명.
  // 좌표·그라디언트는 BI 데모(docs/.vitepress/theme/components/DemoBrandLogo.vue)의 정본
  // 상수에서 그대로 왔다 — 같은 레시피로 medical·works 를 다시 만들면 여기 등록된 것과
  // 한 글자도 다르지 않다(2026-09-23 대조). 눈대중으로 비율을 맞추지 말 것.
  "logo-lockup-hereby-sign": `<svg viewBox="0 0 702 130" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="hereby Sign"><path d="M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894Z" fill="url(#bi-lockup-sign-grad)"/><path d="M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894Z M78.393 18.501C87.565 18.501 95 25.936 95 35.108V94.894C95 95.98 94.891 97.041 94.692 98.069L74.601 77.978C78.403 65.515 71.809 51.111 57.929 47.002L28.591 38.316C26.94 37.828 25.729 39.868 26.946 41.086L41.65 55.789L51.426 59.046C58.029 61.247 60.028 69.603 55.169 74.556L55.036 74.689C50.083 79.548 41.726 77.549 39.525 70.946L36.275 61.177L21.481 46.383C20.27 45.172 18.24 46.364 18.708 48.011L27.105 77.502C31.149 91.702 45.966 98.417 58.617 94.281L75.837 111.501H18.607C9.436 111.501 2.001 104.065 2 94.894V35.105C2.001 25.934 9.436 18.501 18.607 18.501H78.393Z" fill-rule="evenodd" fill="#FFFFFF"/><path d="M153.8 100.5L141 100.5L141 29.5L153.8 29.5L153.8 54.2Q156 50 160 47.95Q164 45.9 169 45.9Q177.9 45.9 182.5 51.55Q187.1 57.2 187.1 66.2L187.1 100.5L174.3 100.5L174.3 69.3Q174.3 56.3 165.2 56.3Q159.9 56.3 156.85 59.7Q153.8 63.1 153.8 69.6L153.8 100.5M222.9 101.7Q214.9 101.7 209 98.25Q203.1 94.8 199.9 88.5Q196.7 82.2 196.7 73.8Q196.7 65.4 199.9 59.1Q203.1 52.8 208.95 49.35Q214.8 45.9 222.6 45.9Q230.2 45.9 235.9 49.3Q241.6 52.7 244.75 59.1Q247.9 65.5 247.9 74.5L247.9 77.4L210 77.4Q210.3 84.4 213.8 87.95Q217.3 91.5 223 91.5Q231.7 91.5 234.1 84.1L247.2 84.9Q245 92.7 238.55 97.2Q232.1 101.7 222.9 101.7M210 68.8L234.7 68.8Q234.2 62.3 230.95 59.15Q227.7 56 222.6 56Q217.4 56 214.1 59.3Q210.8 62.6 210 68.8M270.7 100.5L257.9 100.5L257.9 47.1L269.9 47.1L270.2 57.5Q271.8 52.1 274.9 49.6Q278 47.1 283 47.1L287.9 47.1L287.9 58.1L282.9 58.1Q276.8 58.1 273.75 60.85Q270.7 63.6 270.7 69.7L270.7 100.5M317.9 101.7Q309.9 101.7 304 98.25Q298.1 94.8 294.9 88.5Q291.7 82.2 291.7 73.8Q291.7 65.4 294.9 59.1Q298.1 52.8 303.95 49.35Q309.8 45.9 317.6 45.9Q325.2 45.9 330.9 49.3Q336.6 52.7 339.75 59.1Q342.9 65.5 342.9 74.5L342.9 77.4L305 77.4Q305.3 84.4 308.8 87.95Q312.3 91.5 318 91.5Q326.7 91.5 329.1 84.1L342.2 84.9Q340 92.7 333.55 97.2Q327.1 101.7 317.9 101.7M305 68.8L329.7 68.8Q329.2 62.3 325.95 59.15Q322.7 56 317.6 56Q312.4 56 309.1 59.3Q305.8 62.6 305 68.8M381.6 101.7Q376 101.7 371.8 99.3Q367.6 96.9 365.4 92.6L365.1 100.5L352.9 100.5L352.9 29.5L365.7 29.5L365.7 54.7Q367.8 51.1 371.95 48.5Q376.1 45.9 381.6 45.9Q388.5 45.9 393.55 49.35Q398.6 52.8 401.35 59.05Q404.1 65.3 404.1 73.8Q404.1 82.3 401.35 88.55Q398.6 94.8 393.55 98.25Q388.5 101.7 381.6 101.7M378.7 91.3Q384.2 91.3 387.5 86.65Q390.8 82 390.8 73.8Q390.8 65.5 387.55 60.9Q384.3 56.3 378.8 56.3Q372.6 56.3 369.15 60.9Q365.7 65.5 365.7 73.8Q365.7 82 369.15 86.65Q372.6 91.3 378.7 91.3M425.1 115.5L416 115.5L416 105.6L422.8 105.6Q425.4 105.6 426.65 104.8Q427.9 104 428.6 102.1L430.1 98.4L426.4 98.4L407.3 47.1L420.6 47.1L434 86.4L446.8 47.1L460.1 47.1L439.2 106.1Q437.4 111.1 434.15 113.3Q430.9 115.5 425.1 115.5" fill="#1B1B1B"/><path d="M520.8 102.1Q512 102.1 505.6 99Q499.2 95.9 495.55 90.35Q491.9 84.8 491.3 77.4L504.5 76.6Q505.4 83.5 509.5 87.2Q513.6 90.9 521 90.9Q527.3 90.9 530.75 88.55Q534.2 86.2 534.2 81.7Q534.2 79 532.9 76.9Q531.6 74.8 527.9 73Q524.2 71.2 516.9 69.5Q508.1 67.5 502.8 64.95Q497.5 62.4 495.1 58.55Q492.7 54.7 492.7 48.9Q492.7 42.7 495.8 37.95Q498.9 33.2 504.6 30.55Q510.3 27.9 518.3 27.9Q526.8 27.9 532.75 30.95Q538.7 34 542.05 39.3Q545.4 44.6 546.2 51.5L533.1 52.1Q532.4 46.3 528.6 42.7Q524.8 39.1 518.1 39.1Q512.5 39.1 509.25 41.7Q506 44.3 506 48.4Q506 51.3 507.35 53.2Q508.7 55.1 512.2 56.5Q515.7 57.9 522 59.3Q531.5 61.4 537.1 64.45Q542.7 67.5 545.1 71.6Q547.5 75.7 547.5 81Q547.5 87.5 544.15 92.25Q540.8 97 534.85 99.55Q528.9 102.1 520.8 102.1ZM560.7 100.5V47.1H573.5V100.5ZM560.5 40V28.6H573.8V40ZM609.4 116.7Q598.9 116.7 592.9 112.5Q586.9 108.3 585.1 101.5L598.3 100.6Q599.3 103.7 601.75 105.35Q604.2 107 609.4 107Q615.3 107 618.5 104.35Q621.7 101.7 621.7 96.1V89.3Q619.8 93.2 615.6 95.55Q611.4 97.9 606.2 97.9Q599.6 97.9 594.45 94.65Q589.3 91.4 586.4 85.55Q583.5 79.7 583.5 72Q583.5 64.3 586.4 58.45Q589.3 52.6 594.35 49.25Q599.4 45.9 606 45.9Q611.7 45.9 615.9 48.5Q620.1 51.1 622.1 55.4V47.1H634.6V95.8Q634.6 106.1 627.7 111.4Q620.8 116.7 609.4 116.7ZM609.2 87.9Q614.9 87.9 618.35 83.65Q621.8 79.4 621.8 71.9Q621.9 64.5 618.45 60.2Q615 55.9 609.2 55.9Q603.3 55.9 600.05 60.25Q596.8 64.6 596.8 71.9Q596.8 79.2 600.15 83.55Q603.5 87.9 609.2 87.9ZM648.6 100.5V47.1H660.2L660.5 56.2Q662.7 50.7 666.95 48.3Q671.2 45.9 676.5 45.9Q685.3 45.9 690 51.55Q694.7 57.2 694.7 66.2V100.5H681.9V70.3Q681.9 63.5 679.85 59.9Q677.8 56.3 672.6 56.3Q667.4 56.3 664.4 59.9Q661.4 63.5 661.4 70.3V100.5Z" fill="#1B1B1B"/><defs><linearGradient id="bi-lockup-sign-grad" x1="89.63" y1="111.5" x2="2.75" y2="28.45" gradientUnits="userSpaceOnUse"><stop stop-color="#FE4D43"/><stop offset="0.389423" stop-color="#FF7732"/><stop offset="0.956731" stop-color="#FFAF00"/></linearGradient></defs></svg>`,
  "logo-lockup-hereby-works": `<svg viewBox="0 0 790 130" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="hereby Works"><path d="M28.57 18.5L31.38 18.52C33.50 18.54 35.21 20.27 35.21 22.39C35.21 26.66 38.68 30.12 42.95 30.12L54.04 30.12C58.05 30.12 61.35 27.07 61.75 23.16L61.81 21.98C62.00 20.02 63.66 18.5 65.66 18.5L68.43 18.5L68.43 18.50L78.39 18.50C87.56 18.50 95.0 25.94 95.0 35.11L95.0 94.89C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894L2.0 35.10C2.00 25.93 9.44 18.50 18.61 18.50L28.57 18.50L28.57 18.5Z" fill="url(#bi-lockup-works-grad)"/><path d="M28.57 18.5L31.38 18.52C33.50 18.54 35.21 20.27 35.21 22.39C35.21 26.66 38.68 30.12 42.95 30.12L54.04 30.12C58.05 30.12 61.35 27.07 61.75 23.16L61.81 21.98C62.00 20.02 63.66 18.5 65.66 18.5L68.43 18.5L68.43 18.50L78.39 18.50C87.56 18.50 95.0 25.94 95.0 35.11L95.0 94.89C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894L2.0 35.10C2.00 25.93 9.44 18.50 18.61 18.50L28.57 18.50L28.57 18.5Z M28.57 18.5L31.38 18.52C33.50 18.54 35.21 20.27 35.21 22.39C35.21 26.66 38.68 30.12 42.95 30.12L54.04 30.12C58.05 30.12 61.35 27.07 61.75 23.16L61.81 21.98C62.00 20.02 63.66 18.5 65.66 18.5L68.43 18.5L68.43 18.50L78.39 18.50C87.56 18.50 95.0 25.94 95.0 35.11L95.0 94.89C95.00 103.50 88.45 110.58 80.06 111.42C76.34 97.53 63.62 87.31 48.5 87.31C33.38 87.31 20.66 97.53 16.94 111.42C8.55 110.58 2.00 103.50 2.0 94.89L2.0 35.10C2.00 25.93 9.44 18.50 18.61 18.50L28.57 18.50L28.57 18.5M48.5 48.39C39.48 48.39 32.17 55.71 32.17 64.72C32.17 73.74 39.48 81.06 48.5 81.06C57.52 81.06 64.83 73.74 64.83 64.72C64.83 55.71 57.52 48.39 48.5 48.39" fill-rule="evenodd" fill="#FFFFFF"/><path d="M153.8 100.5L141 100.5L141 29.5L153.8 29.5L153.8 54.2Q156 50 160 47.95Q164 45.9 169 45.9Q177.9 45.9 182.5 51.55Q187.1 57.2 187.1 66.2L187.1 100.5L174.3 100.5L174.3 69.3Q174.3 56.3 165.2 56.3Q159.9 56.3 156.85 59.7Q153.8 63.1 153.8 69.6L153.8 100.5M222.9 101.7Q214.9 101.7 209 98.25Q203.1 94.8 199.9 88.5Q196.7 82.2 196.7 73.8Q196.7 65.4 199.9 59.1Q203.1 52.8 208.95 49.35Q214.8 45.9 222.6 45.9Q230.2 45.9 235.9 49.3Q241.6 52.7 244.75 59.1Q247.9 65.5 247.9 74.5L247.9 77.4L210 77.4Q210.3 84.4 213.8 87.95Q217.3 91.5 223 91.5Q231.7 91.5 234.1 84.1L247.2 84.9Q245 92.7 238.55 97.2Q232.1 101.7 222.9 101.7M210 68.8L234.7 68.8Q234.2 62.3 230.95 59.15Q227.7 56 222.6 56Q217.4 56 214.1 59.3Q210.8 62.6 210 68.8M270.7 100.5L257.9 100.5L257.9 47.1L269.9 47.1L270.2 57.5Q271.8 52.1 274.9 49.6Q278 47.1 283 47.1L287.9 47.1L287.9 58.1L282.9 58.1Q276.8 58.1 273.75 60.85Q270.7 63.6 270.7 69.7L270.7 100.5M317.9 101.7Q309.9 101.7 304 98.25Q298.1 94.8 294.9 88.5Q291.7 82.2 291.7 73.8Q291.7 65.4 294.9 59.1Q298.1 52.8 303.95 49.35Q309.8 45.9 317.6 45.9Q325.2 45.9 330.9 49.3Q336.6 52.7 339.75 59.1Q342.9 65.5 342.9 74.5L342.9 77.4L305 77.4Q305.3 84.4 308.8 87.95Q312.3 91.5 318 91.5Q326.7 91.5 329.1 84.1L342.2 84.9Q340 92.7 333.55 97.2Q327.1 101.7 317.9 101.7M305 68.8L329.7 68.8Q329.2 62.3 325.95 59.15Q322.7 56 317.6 56Q312.4 56 309.1 59.3Q305.8 62.6 305 68.8M381.6 101.7Q376 101.7 371.8 99.3Q367.6 96.9 365.4 92.6L365.1 100.5L352.9 100.5L352.9 29.5L365.7 29.5L365.7 54.7Q367.8 51.1 371.95 48.5Q376.1 45.9 381.6 45.9Q388.5 45.9 393.55 49.35Q398.6 52.8 401.35 59.05Q404.1 65.3 404.1 73.8Q404.1 82.3 401.35 88.55Q398.6 94.8 393.55 98.25Q388.5 101.7 381.6 101.7M378.7 91.3Q384.2 91.3 387.5 86.65Q390.8 82 390.8 73.8Q390.8 65.5 387.55 60.9Q384.3 56.3 378.8 56.3Q372.6 56.3 369.15 60.9Q365.7 65.5 365.7 73.8Q365.7 82 369.15 86.65Q372.6 91.3 378.7 91.3M425.1 115.5L416 115.5L416 105.6L422.8 105.6Q425.4 105.6 426.65 104.8Q427.9 104 428.6 102.1L430.1 98.4L426.4 98.4L407.3 47.1L420.6 47.1L434 86.4L446.8 47.1L460.1 47.1L439.2 106.1Q437.4 111.1 434.15 113.3Q430.9 115.5 425.1 115.5" fill="#1B1B1B"/><path d="M508.7 100.5 489.7 29.5H503.4L516.4 82.5L529.5 29.5H541.6L554.7 82.5L567.6 29.5H581.4L562.4 100.5H548L535.6 51.9L523.2 100.5ZM610.5 101.7Q602.6 101.7 596.65 98.25Q590.7 94.8 587.45 88.55Q584.2 82.3 584.2 73.8Q584.2 65.3 587.45 59.05Q590.7 52.8 596.65 49.35Q602.6 45.9 610.5 45.9Q618.4 45.9 624.3 49.35Q630.2 52.8 633.45 59.05Q636.7 65.3 636.7 73.8Q636.7 82.3 633.45 88.55Q630.2 94.8 624.3 98.25Q618.4 101.7 610.5 101.7ZM610.5 91.3Q616.6 91.3 620 86.7Q623.4 82.1 623.4 73.8Q623.4 65.5 620 60.9Q616.6 56.3 610.5 56.3Q604.3 56.3 600.9 60.9Q597.5 65.5 597.5 73.8Q597.5 82.1 600.9 86.7Q604.3 91.3 610.5 91.3ZM646.6 100.5V47.1H658.6L658.9 57.5Q660.5 52.1 663.6 49.6Q666.7 47.1 671.7 47.1H676.6V58.1H671.6Q665.5 58.1 662.45 60.85Q659.4 63.6 659.4 69.7V100.5ZM684.9 100.5V29.5H697.7V71.2L719.6 47.1H735.4L714.5 69.3L736.1 100.5H721.7L706.1 76.9L697.7 85.8V100.5ZM763 101.7Q750.8 101.7 744.8 96.6Q738.8 91.5 738.2 83.7L751.3 83.1Q752 87.3 754.65 89.6Q757.3 91.9 763.1 91.9Q767.6 91.9 769.95 90.45Q772.3 89 772.3 85.9Q772.3 84.1 771.45 82.9Q770.6 81.7 768.15 80.8Q765.7 79.9 761 79Q752.9 77.6 748.3 75.55Q743.7 73.5 741.85 70.4Q740 67.3 740 62.7Q740 55.3 745.75 50.6Q751.5 45.9 762.6 45.9Q770.3 45.9 775.25 48.35Q780.2 50.8 782.75 54.85Q785.3 58.9 785.7 63.9L772.7 64.5Q772.5 60.7 770.1 58.2Q767.7 55.7 762.4 55.7Q757.9 55.7 755.55 57.5Q753.2 59.3 753.2 62.3Q753.2 65.5 755.45 67.05Q757.7 68.6 763.7 69.6Q771.9 70.8 776.7 72.9Q781.5 75 783.55 78.15Q785.6 81.3 785.6 85.7Q785.6 93.4 779.45 97.55Q773.3 101.7 763 101.7Z" fill="#1B1B1B"/><defs><linearGradient id="bi-lockup-works-grad" x1="89.63" y1="111.5" x2="2.75" y2="28.45" gradientUnits="userSpaceOnUse"><stop stop-color="#FE4D43"/><stop offset="0.389423" stop-color="#FF7732"/><stop offset="0.956731" stop-color="#FFAF00"/></linearGradient></defs></svg>`,
  // 영문 락업의 **outline 케이스**. 심볼·`hereby`·`Medical` 이 전부 한 색이라 그라디언트도
  // `defs` 도 없다 — 위의 fill 본(`logo-lockup-hereby-medical`)과 좌표는 같고 색만 다르다.
  "logo-lockup-hereby-medical-outline-on-dark": `<svg viewBox="0 0 865 130" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="hereby Medical"><path d="M95 94.894C95 104.066 87.565 111.501 78.393 111.501H18.607C9.435 111.501 2 104.066 2 94.894V35.108C2 25.936 9.435 18.501 18.607 18.501H78.393C87.565 18.501 95 25.936 95 35.108V94.894ZM41.092 36.386C39.257 36.386 37.77 37.873 37.77 39.707V50.95C37.77 52.783 36.283 54.271 34.449 54.271H23.207C21.372 54.271 19.885 55.758 19.885 57.593V72.412C19.885 74.247 21.372 75.734 23.207 75.734H34.449C36.283 75.734 37.77 77.221 37.77 79.055V90.294C37.77 92.128 39.257 93.616 41.092 93.616H55.908C57.742 93.615 59.23 92.128 59.23 90.294V79.055C59.23 77.221 60.717 75.734 62.551 75.734H73.793C75.627 75.734 77.115 74.247 77.115 72.412V57.593C77.115 55.758 75.628 54.271 73.793 54.271H62.551C60.717 54.271 59.23 52.784 59.23 50.95V39.707C59.23 37.873 57.743 36.386 55.908 36.386H41.092Z" fill="#FFFFFF"/><path d="M153.8 100.5L141 100.5L141 29.5L153.8 29.5L153.8 54.2Q156 50 160 47.95Q164 45.9 169 45.9Q177.9 45.9 182.5 51.55Q187.1 57.2 187.1 66.2L187.1 100.5L174.3 100.5L174.3 69.3Q174.3 56.3 165.2 56.3Q159.9 56.3 156.85 59.7Q153.8 63.1 153.8 69.6L153.8 100.5M222.9 101.7Q214.9 101.7 209 98.25Q203.1 94.8 199.9 88.5Q196.7 82.2 196.7 73.8Q196.7 65.4 199.9 59.1Q203.1 52.8 208.95 49.35Q214.8 45.9 222.6 45.9Q230.2 45.9 235.9 49.3Q241.6 52.7 244.75 59.1Q247.9 65.5 247.9 74.5L247.9 77.4L210 77.4Q210.3 84.4 213.8 87.95Q217.3 91.5 223 91.5Q231.7 91.5 234.1 84.1L247.2 84.9Q245 92.7 238.55 97.2Q232.1 101.7 222.9 101.7M210 68.8L234.7 68.8Q234.2 62.3 230.95 59.15Q227.7 56 222.6 56Q217.4 56 214.1 59.3Q210.8 62.6 210 68.8M270.7 100.5L257.9 100.5L257.9 47.1L269.9 47.1L270.2 57.5Q271.8 52.1 274.9 49.6Q278 47.1 283 47.1L287.9 47.1L287.9 58.1L282.9 58.1Q276.8 58.1 273.75 60.85Q270.7 63.6 270.7 69.7L270.7 100.5M317.9 101.7Q309.9 101.7 304 98.25Q298.1 94.8 294.9 88.5Q291.7 82.2 291.7 73.8Q291.7 65.4 294.9 59.1Q298.1 52.8 303.95 49.35Q309.8 45.9 317.6 45.9Q325.2 45.9 330.9 49.3Q336.6 52.7 339.75 59.1Q342.9 65.5 342.9 74.5L342.9 77.4L305 77.4Q305.3 84.4 308.8 87.95Q312.3 91.5 318 91.5Q326.7 91.5 329.1 84.1L342.2 84.9Q340 92.7 333.55 97.2Q327.1 101.7 317.9 101.7M305 68.8L329.7 68.8Q329.2 62.3 325.95 59.15Q322.7 56 317.6 56Q312.4 56 309.1 59.3Q305.8 62.6 305 68.8M381.6 101.7Q376 101.7 371.8 99.3Q367.6 96.9 365.4 92.6L365.1 100.5L352.9 100.5L352.9 29.5L365.7 29.5L365.7 54.7Q367.8 51.1 371.95 48.5Q376.1 45.9 381.6 45.9Q388.5 45.9 393.55 49.35Q398.6 52.8 401.35 59.05Q404.1 65.3 404.1 73.8Q404.1 82.3 401.35 88.55Q398.6 94.8 393.55 98.25Q388.5 101.7 381.6 101.7M378.7 91.3Q384.2 91.3 387.5 86.65Q390.8 82 390.8 73.8Q390.8 65.5 387.55 60.9Q384.3 56.3 378.8 56.3Q372.6 56.3 369.15 60.9Q365.7 65.5 365.7 73.8Q365.7 82 369.15 86.65Q372.6 91.3 378.7 91.3M425.1 115.5L416 115.5L416 105.6L422.8 105.6Q425.4 105.6 426.65 104.8Q427.9 104 428.6 102.1L430.1 98.4L426.4 98.4L407.3 47.1L420.6 47.1L434 86.4L446.8 47.1L460.1 47.1L439.2 106.1Q437.4 111.1 434.15 113.3Q430.9 115.5 425.1 115.5" fill="#FFFFFF"/><path d="M494 100.5V29.5H511.5L531.1 84.5L550.7 29.5H568.2V100.5H555.2V51.5L537.3 100.4H524.9L507 51.5V100.5ZM605.3 101.7Q597.3 101.7 591.4 98.25Q585.5 94.8 582.3 88.5Q579.1 82.2 579.1 73.8Q579.1 65.4 582.3 59.1Q585.5 52.8 591.35 49.35Q597.2 45.9 605 45.9Q612.6 45.9 618.3 49.3Q624 52.7 627.15 59.1Q630.3 65.5 630.3 74.5V77.4H592.4Q592.7 84.4 596.2 87.95Q599.7 91.5 605.4 91.5Q614.1 91.5 616.5 84.1L629.6 84.9Q627.4 92.7 620.95 97.2Q614.5 101.7 605.3 101.7ZM592.4 68.8H617.1Q616.6 62.3 613.35 59.15Q610.1 56 605 56Q599.8 56 596.5 59.3Q593.2 62.6 592.4 68.8ZM659.3 101.7Q652.5 101.7 647.55 98.3Q642.6 94.9 639.9 88.65Q637.2 82.4 637.2 73.8Q637.2 65.3 639.95 59Q642.7 52.7 647.65 49.3Q652.6 45.9 659.3 45.9Q664.9 45.9 669.15 48.2Q673.4 50.5 675.6 54.7V29.5H688.4V100.5H676.2L675.9 92.6Q673.7 96.9 669.3 99.3Q664.9 101.7 659.3 101.7ZM663.2 91.3Q669.1 91.3 672.35 86.75Q675.6 82.2 675.6 73.8Q675.6 65.3 672.4 60.8Q669.2 56.3 663.2 56.3Q657.4 56.3 653.95 60.95Q650.5 65.6 650.5 73.8Q650.5 81.8 653.95 86.55Q657.4 91.3 663.2 91.3ZM700.8 100.5V47.1H713.6V100.5ZM700.6 40V28.6H713.9V40ZM749.9 101.7Q741.9 101.7 736 98.25Q730.1 94.8 726.85 88.5Q723.6 82.2 723.6 73.8Q723.6 65.4 726.85 59.1Q730.1 52.8 736 49.35Q741.9 45.9 749.9 45.9Q760.1 45.9 766.85 51.2Q773.6 56.5 774.8 66L761.6 66.7Q760.8 61.6 757.65 58.95Q754.5 56.3 749.9 56.3Q743.7 56.3 740.3 60.9Q736.9 65.5 736.9 73.8Q736.9 82.1 740.3 86.7Q743.7 91.3 749.9 91.3Q754.6 91.3 757.75 88.6Q760.9 85.9 761.6 80.2L774.8 80.8Q773.7 90.4 766.95 96.05Q760.2 101.7 749.9 101.7ZM800 101.7Q791.6 101.7 786.5 97.9Q781.4 94.1 781.4 87.1Q781.4 80.2 785.7 76.3Q790 72.4 798.8 70.7L816.5 67.2Q816.5 55.8 806.2 55.8Q801.6 55.8 798.9 57.95Q796.2 60.1 795.3 64.1L782.3 63.5Q783.9 55.1 790.1 50.5Q796.3 45.9 806.2 45.9Q817.6 45.9 823.45 51.65Q829.3 57.4 829.3 68.1V87.5Q829.3 89.6 830.05 90.4Q830.8 91.2 832.3 91.2H834V100.5Q832.3 100.9 829.3 100.9Q825 100.9 822 99.1Q819 97.3 818.2 92.4V92.3Q816.2 96.5 811.35 99.1Q806.5 101.7 800 101.7ZM802.6 92.4Q809 92.4 812.75 88.7Q816.5 85 816.5 78.9V75.9L802.7 78.7Q798.4 79.6 796.55 81.35Q794.7 83.1 794.7 85.9Q794.7 92.4 802.6 92.4ZM854.3 100.5Q848.4 100.5 844.95 97.5Q841.5 94.5 841.5 87.9V29.5H854.3V86.6Q854.3 90.6 858.3 90.6H862.2V100.5Z" fill="#FFFFFF"/></svg>`,
  // ─── Icons ───────────────────────────────────────────────────────────────
  // 이름 오름차순. 새 아이콘은 제자리에 끼워 넣는다.
  "ic-align-center": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 6h16M7 12h10M5 18h14"/></svg>`,
  "ic-align-left": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 6h16M4 12h10M4 18h14"/></svg>`,
  "ic-align-right": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 6h16M10 12h10M6 18h14"/></svg>`,
  "ic-approval": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 7h10M7 12h10M7 17h6" stroke-linecap="round"/><path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/></svg>`,
  "ic-arrow-down": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(3.25 2.8536)"><path d="M4.74991 0C5.16402 9.24293e-05 5.49979 0.336002 5.49991 0.75V7.93945L8.22843 5.21094L8.23722 5.2041L8.31534 5.13965L8.32608 5.13086L8.33682 5.12305C8.62825 4.93087 9.02404 4.96365 9.28018 5.21973C9.53628 5.4759 9.569 5.8717 9.37686 6.16309L9.36905 6.1748L9.36026 6.18457L9.29581 6.2627L9.28897 6.27148L5.6337 9.92676C5.14558 10.4148 4.35427 10.4148 3.86612 9.92676L0.219637 6.28027C-0.0731657 5.9874 -0.0732589 5.51262 0.219637 5.21973C0.512498 4.92705 0.987316 4.92693 1.28018 5.21973L3.99991 7.93945V0.75C4.00003 0.335965 4.3357 0 4.74991 0Z" fill="currentColor"/></g></svg>`,
  "ic-arrow-right": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>`,
  "ic-arrow-up": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(3.25 2.8536)"><path d="M3.86609 0.36607C4.35423 -0.122024 5.14553 -0.122023 5.63367 0.36607L9.28894 4.02134L9.29578 4.03013L9.36023 4.10826L9.36902 4.11802L9.37683 4.12974C9.56889 4.42114 9.53628 4.81697 9.28015 5.0731C9.02403 5.3291 8.62819 5.36188 8.33679 5.16978L8.32605 5.16197L8.31531 5.15318L8.23718 5.08873L8.22839 5.08189L5.49988 2.35337V9.54283C5.49967 9.95676 5.16396 10.2928 4.74988 10.2928C4.33572 10.2928 4.00009 9.95679 3.99988 9.54283V2.35337L1.28015 5.0731C0.987313 5.3658 0.512454 5.36566 0.219606 5.0731C-0.0732693 4.78023 -0.0731345 4.30543 0.219606 4.01255L3.86609 0.36607Z" fill="currentColor"/></g></svg>`,
  "ic-award": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="9" r="5"/><path d="m8.5 13-1.5 8 5-3 5 3-1.5-8"/></svg>`,
  "ic-badge-check": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>`,
  // 「취소」 — 지우는 것(ic-trash)이 아니라 **무르는 것**. 원천 기록을 취소 상태로
  // 돌리는 자리에 쓴다(시트 우클릭 「행 취소」). 휴지통과 섞이면 사용자가 데이터가
  // 사라지는 줄 안다.
  "ic-ban": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M5.64 5.64l12.72 12.72"/></svg>`,
  "ic-bell": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/><path d="M10.268 21a2 2 0 0 0 3.464 0"/></svg>`,
  "ic-at-sign": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"/></svg>`,
  "ic-reply": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/></svg>`,
  "ic-bell-off": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742"/><path d="M8.668 3.01A6 6 0 0 1 18 8c0 2.1.3 3.6.77 4.8"/><path d="m2 2 20 20"/></svg>`,
  "ic-bell-fill": `<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326Z"/><path stroke="none" d="M9.3 20h5.4a2.7 2.7 0 0 1-5.4 0z"/></svg>`,
  "ic-building": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>`,
  "ic-cake": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/><path d="M4 16s.7-1 2-1 2.7 2 4 2 2.7-2 4-2 2.7 2 4 2 2-1 2-1"/><path d="M2 21h20"/><path d="M7 8v3M12 8v3M17 8v3"/><path d="M7 4h.01M12 4h.01M17 4h.01"/></svg>`,
  "ic-calculator": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8"/><path d="M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15v4M8 19h4"/></svg>`,
  "ic-calendar": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="2"/><path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M7 13h2M11 13h2M15 13h2M7 16.5h2M11 16.5h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-calendar-check": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="2"/><path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M8.7 14.6l2.2 2.2 4.4-4.6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  "ic-calendar-clock": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20.5 11V7a2 2 0 0 0-2-2h-13a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="16.8" cy="16.8" r="3.7" stroke="currentColor" stroke-width="2"/><path d="M16.8 15.2v1.6l1.2.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  "ic-camera": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" /></svg>`,
  "ic-camera-fill": `<svg viewBox="1.20 1.20 21.60 21.60" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9zM15 13a3 3 0 11-6 0 3 3 0 016 0z"/></svg>`,
  "ic-cap": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 7l9-4 9 4-9 4-9-4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M21 7v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M5 9v5c0 1.5 3 3 7 3s7-1.5 7-3V9" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>`,
  "ic-cap-fill": `<svg viewBox="1.1 -1.4 22.8 22.8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 7l9-4 9 4-9 4-9-4zM5 9v5c0 1.5 3 3 7 3s7-1.5 7-3V9M20 7a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0z"/></svg>`,
  "ic-cash": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" /></svg>`,
  "ic-cell-merge": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 9V4h5M4 15v5h5M20 9V4h-5M20 15v5h-5"/><path d="M2 12h8M7.5 9l3 3-3 3M22 12h-8M16.5 9l-3 3 3 3"/></svg>`,
  "ic-chart-bar": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 19.5h16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M7.5 19.5v-5.5M12 19.5v-10M16.5 19.5v-3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-chart-up": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>`,
  "ic-check": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>`,
  "ic-check-circle": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>`,
  "ic-check-circle-fill": `<svg viewBox="-1.5 -1.5 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="var(--color-bg-elevated)"/><g transform="translate(2 2)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM8.35352 4.64648C8.15825 4.45122 7.84175 4.45122 7.64648 4.64648L5.5 6.79297L4.35352 5.64648C4.15825 5.45122 3.84175 5.45122 3.64648 5.64648C3.45122 5.84175 3.45122 6.15825 3.64648 6.35352L5.00488 7.71191C5.27825 7.98524 5.72176 7.98527 5.99512 7.71191L8.35352 5.35352C8.54877 5.15827 8.54874 4.84175 8.35352 4.64648Z" fill="currentColor"/></g></svg>`,
  "ic-chevron-double-down": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 13l5 5 5-5"/><path d="M7 6l5 5 5-5"/></svg>`,
  "ic-chevron-double-up": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17 11l-5-5-5 5"/><path d="M17 18l-5-5-5 5"/></svg>`,
  "ic-chevron-down": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>`,
  "ic-chevron-left": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>`,
  "ic-chevron-left-double": `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(0.853 1.25)"><path d="M4.12974 0.123147C4.42098 -0.0686657 4.81691 -0.0363665 5.0731 0.219826C5.32904 0.475996 5.36166 0.871957 5.16978 1.16319L5.16197 1.17393L5.15318 1.18467L5.08873 1.26279L5.08189 1.27158L1.60337 4.7501L5.0731 8.21983C5.34745 8.49442 5.36465 8.92932 5.12486 9.22373L5.0731 9.28037C4.78024 9.57323 4.30542 9.57298 4.01255 9.28037L0.36607 5.63389C-0.122024 5.14574 -0.122023 4.35445 0.36607 3.86631L4.02134 0.211037L4.03013 0.204201L4.10826 0.139748L4.119 0.130959L4.12974 0.123147Z" fill="currentColor"/><path d="M9.12974 0.123147C9.42098 -0.0686754 9.81691 -0.0363644 10.0731 0.219826C10.329 0.475995 10.3617 0.871952 10.1698 1.16319L10.162 1.17393L10.1532 1.18467L10.0887 1.26279L10.0819 1.27158L6.60337 4.7501L10.0731 8.21983C10.3475 8.49442 10.3647 8.92932 10.1249 9.22373L10.0731 9.28037C9.78024 9.57323 9.30542 9.57298 9.01255 9.28037L5.36607 5.63389C4.87798 5.14574 4.87798 4.35445 5.36607 3.86631L9.02134 0.211037L9.03013 0.204201L9.10826 0.139748L9.119 0.130959L9.12974 0.123147Z" fill="currentColor"/></g></svg>`,
  "ic-chevron-right": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>`,
  "ic-chevron-up": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg>`,
  "ic-clipboard": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15a2.25 2.25 0 012.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" /></svg>`,
  "ic-clipboard-check": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="3.5" width="14" height="17" rx="2" stroke="currentColor" stroke-width="2"/><path d="M9 11l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 2.5h6v3H9z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>`,
  "ic-clipboard-copy": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z" clip-rule="evenodd" /><path fill-rule="evenodd" d="M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375Zm6.75 5.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Zm-2.625-4.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm0 3a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z" clip-rule="evenodd" /></svg>`,
  "ic-clock": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="2"/><path d="M12 7.5V12l3.2 1.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  "ic-clock-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .284.16.544.415.67l4 2a.75.75 0 1 0 .67-1.34l-3.585-1.79V6Z" clip-rule="evenodd" /></svg>`,
  "ic-clock-plus": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="11.5" cy="12.5" r="7.5" stroke="currentColor" stroke-width="2"/><path d="M11.5 8.8v3.7l2.6 1.6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.5 3.5v4M16.5 5.5h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-close": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.5 4.5l15 15M19.5 4.5l-15 15"/></svg>`,
  // 네 모서리에서 가운데로 모이는 축소 화살표 — `ic-expand` 의 짝이다. 전체화면 **종료**
  // 버튼처럼 "좁아진다"를 말해야 하는 자리에 쓴다(`ic-minimize` 는 꺾쇠, 즉 범위 표시다).
  "ic-collapse": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 21L15 15M15 19.8V15h4.8M3 21L9 15M9 19.8V15H4.2M21 3L15 9M15 4.2V9h4.8M3 3L9 9M9 4.2V9H4.2"/></svg>`,
  "ic-copy": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`,
  "ic-cube": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>`,
  "ic-document": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" /></svg>`,
  // 문서 + 돋보기 — 「검색 결과」(직원 앱 메신저 대화방 검색 막대, 2026-10-08). 문서 오른쪽 아래를 돋보기 자리로 비워 두 선이 겹치지 않는다.
  "ic-document-search": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h6.3l4.7 4.7V10"/><path d="M12.3 3.5v4.7H17"/><path d="M8 11.5h4M8 15h2"/><circle cx="16.5" cy="15.5" r="3.5"/><path d="M19 18l2.5 2.5"/></svg>`,
  "ic-document-list": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h4"/></svg>`,
  "ic-dots-grid": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 6a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 6a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 6a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 12a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 18a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 18a.75 .75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 18a.75 .75 0 11-1.5 0 .75.75 0 011.5 0z" /></svg>`,
  "ic-dots-horizontal": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" /></svg>`,
  "ic-dots-vertical": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12.75 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 18.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" /></svg>`,
  "ic-download": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" /></svg>`,
  "ic-edit": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>`,
  "ic-employee": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="8" r="3.5" stroke="currentColor" stroke-width="2"/><path d="M5 19.5c0-3.5 3.13-5.5 7-5.5s7 2 7 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-employee-fill": `<svg viewBox="1.41 1.41 21.18 21.18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 19.5c0-3.5 3.13-5.5 7-5.5s7 2 7 5.5M12 4.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 1 0 0 -7z"/></svg>`,
  "ic-eraser": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 21l-4.3-4.3a2.4 2.4 0 0 1 0-3.4l9.6-9.6a2.4 2.4 0 0 1 3.4 0l5.6 5.6a2.4 2.4 0 0 1 0 3.4L13.5 21"/><path d="M21 21H7"/><path d="M5.5 11.5l7 7"/></svg>`,
  "ic-exclamation": `<svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11Z"/><path d="M8 2.5C8.55228 2.5 9 2.94772 9 3.5V8.5C9 9.05228 8.55228 9.5 8 9.5C7.44772 9.5 7 9.05228 7 8.5V3.5C7 2.94772 7.44772 2.5 8 2.5Z"/></svg>`,
  "ic-exclamation-circle": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><path d="M12 16h.01"/></svg>`,
  // 네 모서리로 뻗는 확장 화살표 — `ic-maximize`(모서리 꺾쇠)와 **다른 뜻이 아니라 다른 그림**이다.
  // 꺾쇠는 "여기까지가 화면"을, 화살표는 "넓어진다"를 말한다. 전체화면 **진입** 버튼처럼
  // 동작을 말해야 하는 자리에 쓴다. 각 모서리는 대각선 + 그 끝의 꺾쇠 두 획으로 화살촉을 만든다.
  "ic-expand": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 15L21 21M21 16.2V21h-4.8M9 15L3 21M3 16.2V21h4.8M15 9L21 3M21 7.8V3h-4.8M9 9L3 3M3 7.8V3h4.8"/></svg>`,
  "ic-export": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 15V3"/><path d="M7 8l5-5 5 5"/><path d="M5 21h14"/></svg>`,
  "ic-external-link": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 3h7v7m0-7L10 14m-1-9H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-3"/></svg>`,
  "ic-eye": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>`,
  "ic-eye-off": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/><path d="M4.5 19.5 19.5 4.5"/></svg>`,
  "ic-file-plus": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 3.5h6.3l4.7 4.7v10.3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M13.3 3.5V8.2H18" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M11.5 12.3v5M9 14.8h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-file-text": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 3.5h6.3l4.7 4.7v10.3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M13.3 3.5V8.2H18" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 13h6M9 16.5h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-file-xlsx": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 1.5C12.3284 1.5 13 2.17157 13 3V4H13.5C14.0523 4 14.5 4.44772 14.5 5V11C14.5 11.5523 14.0523 12 13.5 12H13V13C13 13.8284 12.3284 14.5 11.5 14.5H4.5C3.67157 14.5 3 13.8284 3 13V12H2.5C1.94772 12 1.5 11.5523 1.5 11V5C1.5 4.44772 1.94772 4 2.5 4H3V3C3 2.17157 3.67157 1.5 4.5 1.5H11.5ZM4 13C4 13.2761 4.22386 13.5 4.5 13.5H11.5C11.7761 13.5 12 13.2761 12 13V12H4V13ZM9.89746 6.625C9.71025 6.54678 9.46183 6.48721 9.18945 6.54004L9.07129 6.57031C8.79438 6.65446 8.58706 6.85875 8.50977 7.11719L8.48438 7.23145C8.44266 7.53293 8.57808 7.80838 8.85156 7.98535L8.84961 7.98926H8.85938L8.87012 7.99414C8.87998 7.99848 8.89489 8.00473 8.91309 8.0127C8.95023 8.02895 9.00396 8.05276 9.06836 8.08008C9.19741 8.13483 9.37244 8.20693 9.55469 8.27539C9.59928 8.29206 9.69283 8.33108 9.76953 8.39258C9.84646 8.45442 9.90313 8.53606 9.88574 8.63672C9.85956 8.77852 9.69716 8.93538 9.44141 8.93555C9.19663 8.93555 8.96173 8.83392 8.8125 8.66699C8.71321 8.55619 8.54257 8.54794 8.43262 8.64844L8.42773 8.65332C8.32081 8.7521 8.31241 8.91799 8.40918 9.02637L8.41406 9.03223C8.66825 9.31638 9.04331 9.48047 9.44141 9.48047C9.92721 9.48029 10.3384 9.16661 10.415 8.73242C10.4435 8.56995 10.4202 8.38129 10.3174 8.20703C10.2141 8.03252 10.0309 7.87225 9.74219 7.76367C9.62994 7.72173 9.46822 7.65673 9.33496 7.60156C9.26862 7.5741 9.2089 7.54929 9.16602 7.53125C9.1448 7.52233 9.12715 7.51481 9.11523 7.50977C9.10954 7.50736 9.10469 7.50524 9.10156 7.50391C9.10016 7.50331 9.09852 7.50237 9.09766 7.50195C9.03672 7.45981 9.008 7.39026 9.01758 7.30957L9.0293 7.2627C9.04979 7.20684 9.10055 7.1303 9.22656 7.0918C9.40479 7.03688 9.57429 7.07529 9.7002 7.12891C9.81545 7.17805 9.89319 7.23881 9.90723 7.25C10.0189 7.34561 10.1885 7.33165 10.2822 7.21875L10.291 7.20801L10.3203 7.16406C10.3776 7.05733 10.3552 6.92085 10.2598 6.83887L10.252 6.83203C10.2515 6.83161 10.2388 6.82229 10.2246 6.81152C10.208 6.79898 10.1838 6.78078 10.1533 6.76074C10.0923 6.7206 10.0043 6.66969 9.89746 6.625ZM4.78906 6.58496C4.72942 6.58496 4.64285 6.60306 4.56934 6.69238L3.90234 7.5498L3.23535 6.69238C3.16181 6.60328 3.0753 6.58496 3.01562 6.58496C2.94105 6.58499 2.87385 6.6131 2.82129 6.66602C2.76863 6.71884 2.74031 6.786 2.74023 6.86035C2.74033 6.9181 2.75682 6.97382 2.78906 7.01953L2.79102 7.02246L3.55176 8L2.79785 8.96875C2.76034 9.01808 2.74023 9.07759 2.74023 9.13965C2.74038 9.2144 2.76847 9.28215 2.82129 9.33496C2.87404 9.38746 2.94144 9.4159 3.01562 9.41602C3.09951 9.41602 3.17532 9.38052 3.22754 9.31738L3.90234 8.4502L4.57715 9.31738C4.62936 9.38053 4.70516 9.41602 4.78906 9.41602C4.86328 9.41591 4.93063 9.38846 4.9834 9.33594C5.03623 9.28275 5.06433 9.21506 5.06445 9.14062C5.06445 9.07829 5.04496 9.01937 5.00684 8.96973L4.25293 8.00098L5.01367 7.02246L5.01562 7.01953C5.04752 6.97346 5.06436 6.91775 5.06445 6.86035C5.06438 6.78599 5.03608 6.71885 4.9834 6.66602C4.93055 6.61317 4.86352 6.58507 4.78906 6.58496ZM12.9844 6.58496C12.9247 6.58496 12.8382 6.60306 12.7646 6.69238L12.0977 7.5498L11.4307 6.69238C11.3571 6.60328 11.2706 6.58496 11.2109 6.58496C11.1364 6.58499 11.0692 6.6131 11.0166 6.66602C10.9639 6.71884 10.9356 6.786 10.9355 6.86035C10.9356 6.9181 10.9521 6.97382 10.9844 7.01953L10.9863 7.02246L11.7471 8L10.9932 8.96875C10.9556 9.01808 10.9355 9.07759 10.9355 9.13965C10.9357 9.2144 10.9638 9.28215 11.0166 9.33496C11.0694 9.38746 11.1368 9.4159 11.2109 9.41602C11.2948 9.41602 11.3706 9.38052 11.4229 9.31738L12.0977 8.4502L12.7725 9.31738C12.8247 9.38053 12.9005 9.41602 12.9844 9.41602C13.0586 9.41591 13.1259 9.38846 13.1787 9.33594C13.2315 9.28275 13.2596 9.21506 13.2598 9.14062C13.2598 9.07829 13.2403 9.01937 13.2021 8.96973L12.4482 8.00098L13.209 7.02246L13.2109 7.01953C13.2428 6.97346 13.2597 6.91775 13.2598 6.86035C13.2597 6.78599 13.2314 6.71885 13.1787 6.66602C13.1259 6.61317 13.0588 6.58507 12.9844 6.58496ZM5.9082 6.58398C5.83384 6.5841 5.76668 6.6123 5.71387 6.66504C5.66108 6.71795 5.63281 6.78584 5.63281 6.86035V9.13965C5.63299 9.21435 5.66108 9.28218 5.71387 9.33496C5.76661 9.38741 5.83405 9.4159 5.9082 9.41602H7.60059C7.67501 9.41596 7.74304 9.3877 7.7959 9.33496C7.84862 9.2818 7.87683 9.214 7.87695 9.13965C7.87692 9.06521 7.84863 8.99721 7.7959 8.94434C7.743 8.89144 7.67513 8.86334 7.60059 8.86328H6.18457V6.86035C6.18457 6.78584 6.15631 6.71795 6.10352 6.66504C6.05059 6.61218 5.98276 6.58398 5.9082 6.58398ZM4.5 2.5C4.22386 2.5 4 2.72386 4 3V4H12V3C12 2.72386 11.7761 2.5 11.5 2.5H4.5Z" fill="currentColor"/></svg>`,
  "ic-filter": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 4H3l7 8.5V19l4 2v-8.5L21 4z"/></svg>`,
  "ic-folder": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 7a2 2 0 0 1 2-2h3.6a2 2 0 0 1 1.4.6L12.4 7H18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/></svg>`,
  "ic-folder-fill": `<svg viewBox="1.33 1.33 21.33 21.33" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 7a2 2 0 0 1 2-2h3.6a2 2 0 0 1 1.4.6L12.4 7H18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/></svg>`,
  "ic-folder-doc-check": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.2 13.8V4a1.5 1.5 0 0 1 1.5-1.5h6.6A1.5 1.5 0 0 1 16.8 4v9.8"/><path d="m9.6 8.2 1.7 1.7 3.3-3.3"/><path d="M3.2 13.8v-2.4a1.8 1.8 0 0 1 1.8-1.8h.7a1.8 1.8 0 0 1 1.5.8"/><path d="M16.8 10.4h2a1.8 1.8 0 0 1 1.8 1.8v1.6"/><path d="M3.2 13.8h17.6v5.1a1.8 1.8 0 0 1-1.8 1.8H5a1.8 1.8 0 0 1-1.8-1.8Z"/></svg>`,
  "ic-folder-open": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.056 13.91l1.108-2.216A1.528 1.528 0 0 1 9.532 10.854H18.518a1.528 1.528 0 0 1 1.482 1.91l-1.184 4.585a1.528 1.528 0 0 1-1.482 1.146H5.528a1.528 1.528 0 0 1-1.528-1.528V7.033a1.528 1.528 0 0 1 1.528-1.528h2.98a1.528 1.528 0 0 1 1.291.688l0.619.917a1.528 1.528 0 0 0 1.276.688H16.225a1.528 1.528 0 0 1 1.528 1.528v1.528"/></svg>`,
  "ic-folders": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 8V6a2 2 0 0 1 2-2h3.2a2 2 0 0 1 1.4.6L14.8 6H20a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"/><path d="M2 10a2 2 0 0 1 2-2h3.2a2 2 0 0 1 1.4.6L9.8 10H15a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2Z"/></svg>`,
  "ic-function": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 5h-2a3 3 0 0 0-3 3v0M8 11h6M7 19c2.5 0 3-1.5 3-4V8"/></svg>`,
  "ic-gauge": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 16.5a8 8 0 1 1 14 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M12 14.5l3.6-3.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="14.5" r="1.2" stroke="currentColor" stroke-width="2"/></svg>`,
  "ic-globe": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z"/></svg>`,
  "ic-grip": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="9" cy="6" r="1.75"/><circle cx="15" cy="6" r="1.75"/><circle cx="9" cy="12" r="1.75"/><circle cx="15" cy="12" r="1.75"/><circle cx="9" cy="18" r="1.75"/><circle cx="15" cy="18" r="1.75"/></svg>`,
  "ic-hash": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"/></svg>`,
  "ic-hospital": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3.5 18.5V11.5h17v7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 14.5h17M7 11.5V8.5h6V11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M9 8.5V5h2v3.5" stroke="currentColor" stroke-width="2"/></svg>`,
  "ic-hundred": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 9.5L5 8v8"/><ellipse cx="11.5" cy="12" rx="3" ry="4"/><ellipse cx="18.5" cy="12" rx="3" ry="4"/></svg>`,
  "ic-id-card": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="4" width="14" height="16.5" rx="2" stroke="currentColor" stroke-width="2"/><path d="M10 4V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="12" cy="10.2" r="2.2" stroke="currentColor" stroke-width="2"/><path d="M8.7 16.8c0-1.7 1.4-2.7 3.3-2.7s3.3 1 3.3 2.7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-import": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>`,
  "ic-in-progress": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 3a9 9 0 0 1 0 18"/><path d="M12 21a9 9 0 0 1 0-18" stroke-dasharray="2.2 4.4"/><path d="m8.5 12 2.5 2.5 5-5"/></svg>`,
  "ic-inbox": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/></svg>`,
  "ic-info-circle": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><path d="M12 8h.01"/></svg>`,
  "ic-info-circle-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25a9.75 9.75 0 1 1 0 19.5 9.75 9.75 0 0 1 0-19.5zM12 6.9a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2zM10.9 11a1.1 1.1 0 0 1 2.2 0v5a1.1 1.1 0 0 1-2.2 0z"/></svg>`,
  "ic-key": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/></svg>`,
  "ic-letter-spacing": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 5v14M20 5v14"/><path d="M8 12h8"/><path d="M10 9.5L7.5 12l2.5 2.5M14 9.5l2.5 2.5L14 14.5"/></svg>`,
  "ic-lightbulb": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8.6 13.4a5.6 5.6 0 1 1 6.8 0c-.85.66-1.4 1.53-1.4 2.4v.2h-4v-.2c0-.87-.55-1.74-1.4-2.4z"/><path d="M9.8 19h4.4"/><path d="M10.6 21.6h2.8"/></svg>`,
  "ic-link": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>`,
  "ic-list-check": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 6.4l1.4 1.4 2.5-2.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 13.4l1.4 1.4 2.5-2.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.5 6.8H20M11.5 13.8H20M4.5 19.8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  "ic-lock": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>`,
  "ic-lock-fill": `<svg viewBox="-2 -2 28 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clip-rule="evenodd" /></svg>`,
  "ic-logout": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  "ic-mail": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>`,
  "ic-map-pin": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21c-4.2-3.7-6.5-7-6.5-10a6.5 6.5 0 1 1 13 0c0 3-2.3 6.3-6.5 10z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="12" cy="10.7" r="2.4" stroke="currentColor" stroke-width="2"/></svg>`,
  "ic-map-pin-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22c-4.85-4.27-7.5-8.08-7.5-11.5a7.5 7.5 0 1 1 15 0c0 3.42-2.65 7.23-7.5 11.5zM12 7.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5z"/></svg>`,
  "ic-matrix": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="1.5"/><path d="M4 12h16M12 4v16"/></svg>`,
  "ic-megaphone": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46" /></svg>`,
  // 전체화면 켜기/끄기 — admin 스케줄러·시트의 전체화면 토글. 글리프는 currentColor 만 쓴다(색·크기는 래퍼가).
  "ic-maximize": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5"/></svg>`,
  "ic-minimize": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 3v5H3M16 3v5h5M3 16h5v5M21 16h-5v5"/></svg>`,
  "ic-menu": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>`,
  "ic-menu-fill": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.5 2C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H3.5C2.67157 14 2 13.3284 2 12.5V3.5C2 2.67157 2.67157 2 3.5 2H12.5ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H11C11.2761 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.2761 10 11 10H5ZM5 7.5C4.72386 7.5 4.5 7.72386 4.5 8C4.5 8.27614 4.72386 8.5 5 8.5H11C11.2761 8.5 11.5 8.27614 11.5 8C11.5 7.72386 11.2761 7.5 11 7.5H5ZM5 5C4.72386 5 4.5 5.22386 4.5 5.5C4.5 5.77614 4.72386 6 5 6H11C11.2761 6 11.5 5.77614 11.5 5.5C11.5 5.22386 11.2761 5 11 5H5Z" fill="currentColor"/></svg>`,
  "ic-merge": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="4" y="5" width="16" height="14" rx="1.5"/><path d="M9 9l3 3-3 3M15 9l-3 3 3 3"/></svg>`,
  "ic-message": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-9 8.33 9.5 9.5 0 0 1-4-.9L3 20l1.1-3.3A8.38 8.38 0 0 1 3 11.5 8.5 8.5 0 0 1 12 3a8.38 8.38 0 0 1 9 8.5z"/></svg>`,
  "ic-message-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M2.25 12c0-4.97 4.03-9 9-9s9 4.03 9 9c0 1.657-.45 3.21-1.232 4.54l.867 4.607-4.607-.867A8.961 8.961 0 0111.25 21c-4.97 0-9-4.03-9-9zM8.125 12a1 1 0 11-2 0 1 1 0 012 0zm4.125 0a1 1 0 11-2 0 1 1 0 012 0zm4.125 0a1 1 0 11-2 0 1 1 0 012 0z" clip-rule="evenodd" /></svg>`,
  "ic-message-plus": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-9 8.33 9.5 9.5 0 0 1-4-.9L3 20l1.1-3.3A8.38 8.38 0 0 1 3 11.5 8.5 8.5 0 0 1 12 3a8.38 8.38 0 0 1 9 8.5z"/><path d="M12 8.5v6M9 11.5h6"/></svg>`,
  "ic-minus": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" /></svg>`,
  "ic-money": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.2v9.6"/><path d="M14.6 9.6c0-1-1.2-1.8-2.6-1.8s-2.6.8-2.6 1.9 1 1.6 2.6 1.9 2.6.9 2.6 1.9-1.2 1.8-2.6 1.8-2.6-.8-2.6-1.8"/></svg>`,
  "ic-money-fill": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(2 2)"><path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6.25879 2.07617C5.97964 1.92885 5.61749 1.99486 5.4668 2.28613C5.40144 2.41284 5.43248 2.6795 5.42969 2.8418C5.42919 2.88189 5.4015 2.91711 5.3623 2.92773C4.93463 3.04447 4.58631 3.27575 4.31738 3.62207C3.90938 4.14734 3.9008 5.05272 4.25586 5.58984C4.66587 6.21029 5.42978 6.42636 6.10938 6.62695C6.46585 6.73207 6.80456 6.93556 6.81836 7.34082C6.83713 7.90232 6.40666 8.23281 5.84277 8.17969C5.43505 8.14137 5.27135 7.86995 5.08594 7.55859C4.99157 7.40016 4.73196 7.43066 4.53516 7.43066C4.34936 7.43117 4.22213 7.45313 4.15332 7.49707C3.93385 7.63714 3.99315 7.88135 4.09375 8.08984C4.35362 8.62633 4.78606 8.97189 5.3916 9.12695C5.41268 9.13194 5.42773 9.15078 5.42773 9.17188L5.42871 9.6084C5.42871 9.61399 5.43002 9.61908 5.43164 9.62402C5.4965 9.82632 5.63268 9.94765 5.83887 9.98828C6.10948 10.0416 6.49849 9.90546 6.51367 9.59277C6.51992 9.45285 6.52151 9.31362 6.51758 9.17578C6.51709 9.15591 6.53052 9.1384 6.5498 9.13379C7.32269 8.94589 7.7941 8.47705 7.96191 7.72754C8.05394 7.31678 7.97832 6.88524 7.75781 6.53125C7.31137 5.81398 6.5631 5.64111 5.8125 5.38867L5.67676 5.33496C5.37234 5.19613 5.17421 4.96071 5.17969 4.60059C5.1825 4.44989 5.24133 4.30014 5.35742 4.15234C5.71285 3.70052 6.41114 3.73668 6.70508 4.24414C6.75553 4.33187 6.79688 4.40502 6.82812 4.46387C6.86731 4.53614 6.94046 4.5857 7.02344 4.5957C7.19521 4.6168 7.37772 4.602 7.5625 4.59766C7.9391 4.5886 8.01632 4.30892 7.88281 4.00488C7.62921 3.42909 7.19027 3.06644 6.56543 2.91797C6.54219 2.91237 6.5259 2.89327 6.52344 2.87012C6.49496 2.56381 6.60471 2.2591 6.25879 2.07617Z" fill="currentColor"/></g></svg>`,
  // ic-money 의 반대 짝 — 「급여 확정 취소」. -off 접미사는 레지스트리 관례대로
  // **원본 글리프 + 사선**이다(ic-trash-off 와 같은 방식).
  "ic-money-off": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.2v9.6"/><path d="M14.6 9.6c0-1-1.2-1.8-2.6-1.8s-2.6.8-2.6 1.9 1 1.6 2.6 1.9 2.6.9 2.6 1.9-1.2 1.8-2.6 1.8-2.6-.8-2.6-1.8"/><path d="M5.6 5.6l12.8 12.8"/></svg>`,
  "ic-moon": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>`,
  "ic-note": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/><path d="M9 13h4M9 16.5h6"/></svg>`,
  // ic-note 의 반대 짝 — 「메모 삭제」. 메모를 휴지통으로 그리면 같은 메뉴의
  // 「행 삭제」와 섞여 어느 쪽이 지워지는지 그림만으로는 갈리지 않는다.
  "ic-note-off": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/><path d="M3.5 3.5l17 17"/></svg>`,
  "ic-organization": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="9" y="3" width="6" height="4.5" rx="1"/><rect x="3" y="16.5" width="6" height="4.5" rx="1"/><rect x="15" y="16.5" width="6" height="4.5" rx="1"/><path d="M12 7.5v6.5"/><path d="M6 16.5v-2.5h12v2.5"/></svg>`,
  "ic-organization-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="8" y="2" width="8" height="6.5" rx="1.6"/><rect x="2" y="15.5" width="8" height="6.5" rx="1.6"/><rect x="14" y="15.5" width="8" height="6.5" rx="1.6"/><rect x="11" y="8" width="2" height="5.6"/><rect x="5" y="13" width="14" height="2" rx="1"/><rect x="5" y="13" width="2" height="3"/><rect x="17" y="13" width="2" height="3"/></svg>`,
  "ic-paint-roller": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="2" y="2" width="16" height="6" rx="2"/><path d="M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="8" y="16" width="4" height="6" rx="1"/></svg>`,
  "ic-palette": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 3a9 9 0 0 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.4-1-.24-.27-.39-.62-.39-1.01 0-.83.68-1.5 1.5-1.5H16a5 5 0 0 0 5-5c0-4.42-4-8-9-8z"/><circle cx="7.5" cy="10.5" r=".6"/><circle cx="12" cy="7.5" r=".6"/><circle cx="16.5" cy="10.5" r=".6"/></svg>`,
  "ic-panel": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" stroke-linejoin="round"/><path d="M9 4v16" stroke-linecap="round"/></svg>`,
  "ic-paperclip": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" /></svg>`,
  // 컨페티는 **곡선 스트리머 3개 + 점 4개**다. 직선 하나로 줄이면 20px에서 폭죽이 아니라
  // 슬래시(/)로 읽힌다 — 2026-09 교체 전 형태가 그랬다.
  "ic-party": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.8 11.3 2 22l10.7-3.79"/><path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"/><path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"/><path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11-.11.7-.72 1.22-1.43 1.22H14"/><path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"/><path d="M4 3h.01"/><path d="M22 8h.01"/><path d="M15 2h.01"/><path d="M22 20h.01"/></svg>`,
  "ic-pencil-square": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>`,
  "ic-phone": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>`,
  "ic-pin": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/></svg>`,
  // ic-pin 의 해제 짝(열 고정 해제 · 시트 상단 고정 해제). -off 는 레지스트리 관례대로
  // **원본 글리프 + 사선**이다.
  "ic-pin-off": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/><path d="M3.5 3.5l17 17"/></svg>`,
  "ic-plus": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>`,
  "ic-print": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 9V3h12v6"/><path d="M6 18H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1"/><rect x="6" y="14" width="12" height="7" rx="1"/></svg>`,
  "ic-puzzle": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 4a1.5 1.5 0 0 1 3 0c0 .8.7 1.2 1.3 1H15a1 1 0 0 1 1 1v1.7c-.2.6.2 1.3 1 1.3a1.5 1.5 0 0 1 0 3c-.8 0-1.2.7-1 1.3V16a1 1 0 0 1-1 1h-1.7c-.6-.2-1.3.2-1.3 1a1.5 1.5 0 0 1-3 0c0-.8-.7-1.2-1.3-1H5a1 1 0 0 1-1-1v-1.7c.2-.6-.2-1.3-1-1.3a1.5 1.5 0 0 1 0-3c.8 0 1.2-.7 1-1.3V6a1 1 0 0 1 1-1h1.7C8.3 5.2 9 4.8 9 4z"/></svg>`,
  "ic-question-circle": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9.6 9.2a2.5 2.5 0 1 1 3.3 2.4c-.6.2-.9.7-.9 1.3v.5" /><path d="M12 16.8h.01" /></svg>`,
  "ic-question-circle-fill": `<svg viewBox="0.4 0.4 19.2 19.2" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"/></svg>`,
  "ic-redo": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 14l5-5-5-5"/><path d="M20 9H9a5 5 0 0 0 0 10h1"/></svg>`,
  "ic-refresh": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>`,
  "ic-save": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><path d="M17 21v-8H7v8M7 3v5h8"/></svg>`,
  "ic-scissors": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M8.6 8.6L20 20M8.6 15.4L20 4M12 12l1.5 1.5"/></svg>`,
  "ic-search": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>`,
  "ic-send": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" /></svg>`,
  "ic-setting": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>`,
  "ic-setting-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065zM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5z"/></svg>`,
  "ic-shield-check": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>`,
  "ic-signature": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 16.5c2.4 0 3.2-9 5.8-9 1.9 0 1 6.2 2.7 6.2 1.3 0 1.4-2.8 2.9-2.8 1.2 0 1.5 1.9 2.8 1.9.9 0 1.4-.6 1.8-1.1"/><path d="M3 20.5h18"/></svg>`,
  "ic-sliders": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.5 8h7M17.5 8h2M4.5 16h3M13.5 16h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="13.5" cy="8" r="2" stroke="currentColor" stroke-width="2"/><circle cx="9.5" cy="16" r="2" stroke="currentColor" stroke-width="2"/></svg>`,
  "ic-sort": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 4v16M4 7l3-3 3 3M17 20V4M14 17l3 3 3-3"/></svg>`,
  // 오름차순 / 내림차순. 기존 ic-sort 는 「정렬」 일반(양방향 화살표)이라
  // 오름·내림 두 항목에 같이 쓰면 그림만으로는 갈리지 않는다. 화살표 방향과
  // 막대 길이 순서 **두 축**으로 갈라 16px 에서도 구분되게 했다.
  "ic-sort-asc": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 20V4"/><path d="M3 7l3-3 3 3"/><path d="M12 5h4"/><path d="M12 11h6"/><path d="M12 17h8"/></svg>`,
  "ic-sort-desc": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 4v16"/><path d="M3 17l3 3 3-3"/><path d="M12 5h8"/><path d="M12 11h6"/><path d="M12 17h4"/></svg>`,
  "ic-sparkle": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/></svg>`,
  "ic-sparkles": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z"/></svg>`,
  "ic-spinner": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle opacity="0.25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path opacity="0.75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>`,
  "ic-split": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="4" y="5" width="16" height="14" rx="1.5"/><path d="M12 5v14M8 9.5l-2.5 2.5L8 14.5M16 9.5l2.5 2.5L16 14.5"/></svg>`,
  "ic-star": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`,
  "ic-star-fill": `<svg viewBox="1.09 0.60 21.82 21.82" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`,
  "ic-sun": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" /></svg>`,
  "ic-table": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="3.5" y="4.5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="2"/><path d="M3.5 9.5h17M3.5 14.5h17M10 9.5v10M15.5 9.5v10" stroke="currentColor" stroke-width="2"/></svg>`,
  "ic-tag": `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 5.7A1.7 1.7 0 0 1 5.7 4h5a2 2 0 0 1 1.4.6l7.3 7.3a2 2 0 0 1 0 2.8l-4.7 4.7a2 2 0 0 1-2.8 0L4.6 12.1a2 2 0 0 1-.6-1.4V5.7z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="8.4" cy="8.4" r="1.3" stroke="currentColor" stroke-width="2"/></svg>`,
  "ic-tag-fill": `<svg viewBox="1.32 1.32 21.33 21.33" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5.7A1.7 1.7 0 0 1 5.7 4h5a2 2 0 0 1 1.4.6l7.3 7.3a2 2 0 0 1 0 2.8l-4.7 4.7a2 2 0 0 1-2.8 0L4.6 12.1a2 2 0 0 1-.6-1.4V5.7zM8.4 7.1000000000000005a1.3 1.3 0 1 0 0 2.6a1.3 1.3 0 1 0 0 -2.6z"/></svg>`,
  "ic-team": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="9.5" cy="7.8" r="3.6"/><path d="M2.8 19.5c0-3.5 3-5.6 6.7-5.6s6.7 2.1 6.7 5.6"/><path d="M15.4 4.6a3.6 3.6 0 0 1 0 6.4"/><path d="M17.6 14.3c2.2.7 3.6 2.5 3.6 5.2"/></svg>`,
  "ic-team-fill": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(1 2)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 6C11.7614 6 14 8.23858 14 11V12H0V11C3.22139e-08 8.23858 2.23858 6 5 6C5.7111 6 6.38754 6.14842 7 6.41602C7.61246 6.14842 8.2889 6 9 6ZM5 7C2.79086 7 1 8.79086 1 11H4C4 9.42102 4.73193 8.01301 5.875 7.09668C5.59334 7.03382 5.30061 7 5 7Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C10.6569 0 12 1.34315 12 3C12 4.65685 10.6569 6 9 6C8.23053 6 7.53103 5.70772 7 5.23145C6.46897 5.70772 5.76947 6 5 6C3.34315 6 2 4.65685 2 3C2 1.34315 3.34315 0 5 0C5.76924 0 6.46902 0.291562 7 0.767578C7.53098 0.291562 8.23076 0 9 0ZM5 1C3.89543 1 3 1.89543 3 3C3 4.10457 3.89543 5 5 5C5.53313 5 6.0155 4.78925 6.37402 4.44922C6.13636 4.01949 6 3.52584 6 3C6 2.47386 6.1361 1.97971 6.37402 1.5498C6.01555 1.21005 5.53289 1 5 1Z" fill="currentColor"/></g></svg>`,
  "ic-terminal": `<svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 11 5.293 8.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd"/></svg>`,
  "ic-thumbs-up": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904"/></svg>`,
  "ic-thumbs-up-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.493 18.75c-.425 0-.82-.236-.975-.632A7.48 7.48 0 016 15.375c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75 2.25 2.25 0 012.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23h-.777zM2.331 10.977a11.969 11.969 0 00-.831 4.398 12 12 0 00.52 3.507c.26.85 1.084 1.368 1.973 1.368H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 01-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227z"/></svg>`,
  "ic-thumbs-down": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="rotate(180 12 12)"><path stroke-linecap="round" stroke-linejoin="round" d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904"/></g></svg>`,
  "ic-thumbs-down-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="rotate(180 12 12)"><path d="M7.493 18.75c-.425 0-.82-.236-.975-.632A7.48 7.48 0 016 15.375c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75 2.25 2.25 0 012.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23h-.777zM2.331 10.977a11.969 11.969 0 00-.831 4.398 12 12 0 00.52 3.507c.26.85 1.084 1.368 1.973 1.368H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 01-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227z"/></g></svg>`,
  "ic-transpose": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 3L4 7l4 4M4 7h16M16 21l4-4-4-4M20 17H4"/></svg>`,
  "ic-trash": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M10 11v6M14 11v6"/></svg>`,
  "ic-trash-off": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/><path d="M3.5 3.5l17 17"/></svg>`,
  // 트리(줄기 + 가지 끝 네모 두 개) — 「결재선」 메뉴(인사 관리) 첫 쓰임새. 자립형 · currentColor · 2px round
  "ic-tree": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 4.5h4.5"/><path d="M9.5 4.5v13"/><path d="M9.5 11h4"/><path d="M9.5 17.5h4"/><rect x="13.5" y="8.5" width="5" height="5" rx="1.5"/><rect x="13.5" y="15" width="5" height="5" rx="1.5"/></svg>`,
  "ic-undo": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-1"/></svg>`,
  "ic-unlock": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 7.5-2"/></svg>`,
  "ic-upload": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>`,
  "ic-user": `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="5.5" r="2.25" stroke="currentColor" stroke-width="1.3333" fill="none"/><path d="M2.5 13.25c0-2.35 2.1-4.125 5.5-4.125s5.5 1.775 5.5 4.125" stroke="currentColor" stroke-width="1.3333" stroke-linecap="round" fill="none"/></svg>`,
  "ic-user-arrow-right": `<svg viewBox="-4 -4 32 32" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.6667" d="M9 11a4 4 0 100-8 4 4 0 000 8zM16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M16 11h6m-2.5-2.5L22 11l-2.5 2.5"/></svg>`,
  // 사람 → 화살표(소유자 이관) — ic-user-arrow-right 와 같은 그림을 표준 틀(0 0 24 24 · 선 2)로. 그쪽은 바깥 여백이 든
  // 틀(-4 -4 32 32)이라 다른 24 아이콘 옆에 두면 75% 크기로 작아 보인다(예약된 변경 더보기 열). 기존 쓰임은 그대로 둔다.
  "ic-user-transfer": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 11a4 4 0 100-8 4 4 0 000 8zM16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M16 11h6m-2.5-2.5L22 11l-2.5 2.5"/></svg>`,
  "ic-user-crown": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 6.5V3.5l2 1.5L12 2.5l2 2.5 2-1.5v3z" /><circle cx="12" cy="12" r="3.25" /><path d="M5.5 21a6.5 6.5 0 0113 0" /></svg>`,
  "ic-user-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4 21v-1c0-3.31 3.58-6 8-6s8 2.69 8 6v1" /></svg>`,
  "ic-user-x": `<svg viewBox="-4 -4 32 32" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.6667" d="M9 11a4 4 0 100-8 4 4 0 000 8zM16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M17 7l5 5m0-5l-5 5"/></svg>`,
  "ic-user-plus": `<svg viewBox="-4 -4 32 32" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.6667" d="M9 11a4 4 0 100-8 4 4 0 000 8zM16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M19 8v6M22 11h-6"/></svg>`,
  "ic-users": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
  "ic-users-group": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" /></svg>`,
  "ic-warning": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 3L2 20h20L12 3z"/><path d="M12 10v4M12 17.5h.01"/></svg>`,
  "ic-warning-fill": `<svg viewBox="1.728 0.767 16.544 16.544" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>`,
  "ic-workspace": `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M7 6V4.5A1.5 1.5 0 0 1 8.5 3h7A1.5 1.5 0 0 1 17 4.5V6"/><path d="M9 10.5h6M9 14h6"/></svg>`,
  "ic-workspace-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 2h7A2.5 2.5 0 0 1 18 4.5V5h-2v-.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V5H6v-.5A2.5 2.5 0 0 1 8.5 2zM5 5h14a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM9 9.5h6a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zM9 13h6a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2z"/></svg>`,
  "ic-x-circle-fill": `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" /></svg>`
};
function getIcon(name, opts) {
  const svg = ICONS[name] ?? "";
  if (!svg || opts?.stroke === void 0) {
    return svg;
  }
  return applyStroke(svg, opts.stroke);
}
__name(getIcon, "getIcon");
function applyStroke(svg, width) {
  const replaced = svg.replace(/stroke-width="[^"]*"/g, `stroke-width="${width}"`);
  if (replaced !== svg) {
    return replaced;
  }
  return svg.replace(/^<svg/, `<svg stroke-width="${width}"`);
}
__name(applyStroke, "applyStroke");
function hasIcon(name) {
  return name in ICONS;
}
__name(hasIcon, "hasIcon");
function iconNames() {
  return Object.keys(ICONS);
}
__name(iconNames, "iconNames");
function createIconPlugin() {
  return /* @__PURE__ */ __name(function herebyIconPlugin(Alpine) {
    Alpine.magic("icon", () => (name, opts) => getIcon(name, opts));
    const templates = /* @__PURE__ */ new WeakMap();
    Alpine.directive("icon", (el2, { expression: name }, { cleanup }) => {
      if (!Object.prototype.hasOwnProperty.call(ICONS, name)) {
        Alpine.mutateDom(() => el2.replaceChildren());
        return;
      }
      const doc = el2.ownerDocument;
      let icons = templates.get(doc);
      if (!icons) {
        icons = /* @__PURE__ */ new Map();
        templates.set(doc, icons);
      }
      let template = icons.get(name);
      if (!template) {
        const holder = doc.createElement("template");
        holder.innerHTML = getIcon(name);
        const svg = holder.content.firstElementChild;
        if (!svg) {
          return;
        }
        template = svg;
        icons.set(name, template);
      }
      const icon = template.cloneNode(true);
      Alpine.mutateDom(() => el2.replaceChildren(icon));
      cleanup(() => {
        Alpine.mutateDom(() => {
          if (icon.parentNode === el2) {
            el2.removeChild(icon);
          }
        });
      });
    });
  }, "herebyIconPlugin");
}
__name(createIconPlugin, "createIconPlugin");

// src/guidance/highlight.ts
function createGuidanceHighlight(target, options, onClose) {
  const toneClass = options.tone ? ` ds-guidance--${options.tone}` : "";
  const outline = document.createElement("div");
  outline.className = `ds-guidance-outline${toneClass}`;
  outline.setAttribute("aria-hidden", "true");
  const hint = document.createElement("div");
  hint.className = `ds-guidance-hint${toneClass}`;
  const body = document.createElement("span");
  body.className = "ds-guidance-hint__body";
  body.id = `guidance-${crypto.randomUUID()}`;
  body.setAttribute("role", "status");
  const title = document.createElement("strong");
  title.className = "ds-guidance-hint__title";
  title.textContent = options.title;
  const description = document.createElement("span");
  description.className = "ds-guidance-hint__description";
  description.textContent = options.description;
  body.append(title, description);
  const close = document.createElement("button");
  close.type = "button";
  close.className = "ds-guidance-hint__close ds-btn ds-btn--icon ds-btn--white ds-btn--xs";
  close.setAttribute("aria-label", "\uC704\uCE58 \uC548\uB0B4 \uB2EB\uAE30");
  const closeIcon = document.createElement("span");
  closeIcon.className = "ds-ico";
  closeIcon.innerHTML = getIcon("ic-close");
  close.append(closeIcon);
  close.addEventListener("click", onClose);
  hint.append(body, close);
  target.setAttribute("aria-describedby", [
    target.getAttribute("aria-describedby"),
    body.id
  ].filter(Boolean).join(" "));
  document.body.append(outline, hint);
  const reveal = requestAnimationFrame(() => hint.classList.add("is-visible"));
  let previousGeometry = "";
  function update2() {
    const rect = target.getBoundingClientRect();
    const viewport = window.visualViewport;
    const leftEdge = viewport?.offsetLeft ?? 0;
    const topEdge = viewport?.offsetTop ?? 0;
    const dockWidth = Number.parseFloat(document.body.style.getPropertyValue("--ds-ai-dock-w")) || 0;
    const rightEdge = Math.min(leftEdge + (viewport?.width ?? window.innerWidth), window.innerWidth - dockWidth);
    const bottomEdge = topEdge + (viewport?.height ?? window.innerHeight);
    let left = Math.max(leftEdge, rect.left);
    let top = Math.max(topEdge, rect.top);
    let right = Math.min(rightEdge, rect.right);
    let bottom = Math.min(bottomEdge, rect.bottom);
    for (let parent = target.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
      const style = getComputedStyle(parent);
      const bounds = parent.getBoundingClientRect();
      if (/(auto|scroll|hidden|clip)/.test(style.overflowX)) {
        left = Math.max(left, bounds.left);
        right = Math.min(right, bounds.right);
      }
      if (/(auto|scroll|hidden|clip)/.test(style.overflowY)) {
        top = Math.max(top, bounds.top);
        bottom = Math.min(bottom, bounds.bottom);
      }
    }
    const hidden = right <= left || bottom <= top;
    if (outline.hidden !== hidden) {
      outline.hidden = hidden;
      hint.hidden = hidden;
      previousGeometry = "";
    }
    if (hidden) {
      return;
    }
    const maxWidth = `${rightEdge - leftEdge - 24}px`;
    if (hint.style.maxWidth !== maxWidth) {
      hint.style.maxWidth = maxWidth;
    }
    const hintRect = hint.getBoundingClientRect();
    const geometry = [
      left,
      top,
      right,
      bottom,
      leftEdge,
      topEdge,
      rightEdge,
      bottomEdge,
      hintRect.width,
      hintRect.height
    ].join(":");
    if (geometry === previousGeometry) {
      return;
    }
    previousGeometry = geometry;
    const outlineLeft = Math.max(leftEdge, left - 4);
    const outlineTop = Math.max(topEdge, top - 4);
    const outlineRight = Math.min(rightEdge, right + 4);
    const outlineBottom = Math.min(bottomEdge, bottom + 4);
    Object.assign(outline.style, {
      left: `${outlineLeft}px`,
      top: `${outlineTop}px`,
      width: `${outlineRight - outlineLeft}px`,
      height: `${outlineBottom - outlineTop}px`
    });
    const x = Math.max(leftEdge + 12, Math.min(right - hintRect.width, rightEdge - hintRect.width - 12));
    const above = top - hintRect.height - 12 >= topEdge + 12;
    const y = above ? top - hintRect.height - 12 : bottom + 12;
    hint.dataset.placement = above ? "top" : "bottom";
    hint.style.left = `${x}px`;
    hint.style.top = `${Math.max(topEdge + 12, Math.min(y, bottomEdge - hintRect.height - 12))}px`;
    hint.style.setProperty("--ds-guidance-arrow-x", `${Math.max(16, Math.min((left + right) / 2 - x, hintRect.width - 16))}px`);
  }
  __name(update2, "update");
  update2();
  return {
    update: update2,
    remove() {
      const describedBy = (target.getAttribute("aria-describedby") ?? "").split(/\s+/).filter((id) => id && id !== body.id).join(" ");
      if (describedBy) {
        target.setAttribute("aria-describedby", describedBy);
      } else {
        target.removeAttribute("aria-describedby");
      }
      cancelAnimationFrame(reveal);
      close.removeEventListener("click", onClose);
      outline.remove();
      hint.remove();
    }
  };
}
__name(createGuidanceHighlight, "createGuidanceHighlight");

// src/guidance/navigation.ts
function createGuidanceNavigation(deps) {
  let revision = 0;
  let active = null;
  let navigating = false;
  const snapshot = /* @__PURE__ */ __name(() => JSON.stringify([
    deps.identity(),
    deps.context()
  ]), "snapshot");
  return {
    open: false,
    loading: false,
    busy: false,
    message: "",
    catalog: {
      items: [],
      columns: []
    },
    columnKey: "",
    /** 앱이 안내를 위해 AI 페이지를 닫는 동안에는 자기 이동을 취소하지 않습니다. */
    cancelPending() {
      if (!navigating) {
        this.cancel();
        this.open = false;
      }
    },
    cancel() {
      revision++;
      navigating = false;
      active?.abort();
      active = null;
      this.busy = false;
      this.loading = false;
    },
    async load() {
      this.cancel();
      const request3 = revision;
      const original = snapshot();
      this.open = true;
      this.message = "";
      this.loading = true;
      this.catalog = {
        items: [],
        columns: []
      };
      this.columnKey = "";
      try {
        const result = await deps.catalog(deps.context());
        if (request3 !== revision) {
          return;
        }
        if (original !== snapshot()) {
          throw new Error("\uD604\uC7AC \uC0AC\uC6A9\uC790\uB098 \uD654\uBA74\uC774 \uBC14\uB00C\uC5C8\uC5B4\uC694. \uBAA9\uB85D\uC744 \uB2E4\uC2DC \uC5F4\uC5B4 \uC8FC\uC138\uC694.");
        }
        this.catalog = result;
      } catch (error) {
        if (request3 === revision) {
          this.message = error instanceof Error ? error.message : "\uAE30\uB2A5 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
        }
      } finally {
        if (request3 === revision) {
          this.loading = false;
        }
      }
    },
    async run(capabilityId, originalSheetId, columnKey) {
      this.cancel();
      const request3 = revision;
      const original = snapshot();
      const context = deps.context();
      this.message = "";
      if (originalSheetId && originalSheetId !== context.sheet?.sheetViewId) {
        this.message = "\uC774 \uB2F5\uBCC0\uC740 \uB2E4\uB978 \uC2DC\uD2B8\uC758 \uC548\uB0B4\uC608\uC694. \uC6D0\uB798 \uC2DC\uD2B8\uB97C \uC5F4\uAC70\uB098 \uD604\uC7AC \uC2DC\uD2B8\uC5D0\uC11C \uB2E4\uC2DC \uC9C8\uBB38\uD574 \uC8FC\uC138\uC694.";
        return;
      }
      this.busy = true;
      const controller = new AbortController();
      active = controller;
      try {
        const action = await deps.resolve({
          ...context,
          capabilityId,
          ...columnKey ? {
            columnKey
          } : {}
        });
        if (request3 !== revision) {
          return;
        }
        if (original !== snapshot()) {
          throw new Error("\uD604\uC7AC \uC0AC\uC6A9\uC790\uB098 \uD654\uBA74\uC774 \uBC14\uB00C\uC5C8\uC5B4\uC694. \uB2E4\uC2DC \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.");
        }
        navigating = true;
        await deps.navigate(action, controller.signal);
        if (request3 === revision) {
          this.open = false;
          this.message = "";
        }
      } catch (error) {
        if (request3 === revision) {
          this.message = error instanceof Error ? error.message : "\uC704\uCE58 \uC548\uB0B4\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
        }
      } finally {
        if (request3 === revision) {
          navigating = false;
          this.busy = false;
        }
      }
    }
  };
}
__name(createGuidanceNavigation, "createGuidanceNavigation");
function isGuidanceElementVisible(element) {
  if (!(element instanceof HTMLElement && element.isConnected) || element.getClientRects().length === 0) {
    return false;
  }
  for (let node = element; node; node = node.parentElement) {
    const style = getComputedStyle(node);
    if (style.display === "none" || style.visibility === "hidden" || node.hidden || node.hasAttribute("x-cloak")) {
      return false;
    }
  }
  return true;
}
__name(isGuidanceElementVisible, "isGuidanceElementVisible");
function assertGuidanceCanNavigate(additionalSelector) {
  const selectors = [
    ".ds-modal-backdrop",
    '[role="dialog"]',
    '[role="alertdialog"]'
  ];
  if (additionalSelector) {
    selectors.push(additionalSelector);
  }
  const overlays = document.querySelectorAll(selectors.join(", "));
  if (Array.from(overlays).some(isGuidanceElementVisible)) {
    throw new Error("\uC5F4\uB824 \uC788\uB294 \uCC3D\uC758 \uC791\uC5C5\uC744 \uB9C8\uCE58\uAC70\uB098 \uB2EB\uC740 \uB4A4 \uB2E4\uC2DC \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.");
  }
}
__name(assertGuidanceCanNavigate, "assertGuidanceCanNavigate");
function locateGuidanceTarget(find2, signal, current2 = () => true, timeoutMs = 5e3) {
  return new Promise((resolve2, reject) => {
    const observer = new MutationObserver(check);
    const timeout = setTimeout(() => finish(new Error("\uD654\uBA74\uC5D0\uC11C \uC548\uB0B4 \uC704\uCE58\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC5B4\uC694. \uBB38\uC11C\uB97C \uD655\uC778\uD558\uAC70\uB098 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.")), timeoutMs);
    const poll = setInterval(check, 100);
    function finish(error, element) {
      observer.disconnect();
      clearTimeout(timeout);
      clearInterval(poll);
      signal.removeEventListener("abort", abort);
      if (error) {
        reject(error);
      } else if (element) {
        resolve2(element);
      }
    }
    __name(finish, "finish");
    function abort() {
      finish(new Error("\uC704\uCE58 \uC548\uB0B4\uB97C \uCDE8\uC18C\uD588\uC5B4\uC694."));
    }
    __name(abort, "abort");
    function check() {
      if (signal.aborted) {
        return abort();
      }
      if (!current2()) {
        return finish(new Error("\uD654\uBA74\uC774 \uBC14\uB00C\uC5B4 \uC704\uCE58 \uC548\uB0B4\uB97C \uC911\uB2E8\uD588\uC5B4\uC694."));
      }
      const element = find2();
      if (isGuidanceElementVisible(element)) {
        finish(void 0, element);
      }
    }
    __name(check, "check");
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        "style",
        "class",
        "hidden"
      ]
    });
    signal.addEventListener("abort", abort, {
      once: true
    });
    check();
  });
}
__name(locateGuidanceTarget, "locateGuidanceTarget");
var clearActiveHighlight;
async function highlightGuidanceTarget(find2, signal, current2 = () => true, options = {
  title: "\uC548\uB0B4 \uC704\uCE58",
  description: "\uD45C\uC2DC\uD55C \uC704\uCE58\uC5D0\uC11C \uC791\uC5C5\uC744 \uC2DC\uC791\uD558\uC138\uC694."
}) {
  clearActiveHighlight?.();
  const element = await locateGuidanceTarget(find2, signal, current2);
  if (signal.aborted || !current2()) {
    throw new Error("\uC704\uCE58 \uC548\uB0B4\uB97C \uCDE8\uC18C\uD588\uC5B4\uC694.");
  }
  if (options.scroll !== false) {
    element.scrollIntoView({
      block: "center",
      inline: "nearest",
      behavior: "instant"
    });
  }
  const highlight = createGuidanceHighlight(element, options, clear);
  const onKey = /* @__PURE__ */ __name((event) => {
    if (event.key === "Escape") {
      clear();
    }
  }, "onKey");
  const monitor = setInterval(() => {
    if (current2() && isGuidanceElementVisible(element)) {
      highlight.update();
    } else {
      clear();
    }
  }, 200);
  function clear() {
    highlight.remove();
    clearInterval(monitor);
    signal.removeEventListener("abort", clear);
    element.removeEventListener("click", clear, true);
    document.removeEventListener("keydown", onKey);
    document.removeEventListener("scroll", highlight.update, true);
    window.removeEventListener("resize", highlight.update);
    window.visualViewport?.removeEventListener("resize", highlight.update);
    window.visualViewport?.removeEventListener("scroll", highlight.update);
    if (clearActiveHighlight === clear) {
      clearActiveHighlight = void 0;
    }
  }
  __name(clear, "clear");
  signal.addEventListener("abort", clear, {
    once: true
  });
  element.addEventListener("click", clear, {
    capture: true,
    once: true
  });
  document.addEventListener("keydown", onKey);
  document.addEventListener("scroll", highlight.update, {
    capture: true,
    passive: true
  });
  window.addEventListener("resize", highlight.update);
  window.visualViewport?.addEventListener("resize", highlight.update);
  window.visualViewport?.addEventListener("scroll", highlight.update);
  clearActiveHighlight = clear;
}
__name(highlightGuidanceTarget, "highlightGuidanceTarget");

// src/utils/ai-menu-match.ts
var normalize = /* @__PURE__ */ __name((text) => text.toLowerCase().replace(/\s+/g, ""), "normalize");
function score(query, entry) {
  const label = normalize(entry.label);
  if (label === query) {
    return 5;
  }
  if (label.startsWith(query)) {
    return 4;
  }
  if (label.includes(query) || query.includes(label)) {
    return 3;
  }
  for (const keyword of entry.keywords ?? []) {
    const k = normalize(keyword);
    if (!k) {
      continue;
    }
    if (k === query || k.includes(query) || query.includes(k)) {
      return 2;
    }
  }
  return 0;
}
__name(score, "score");
function matchMenuEntries(query, catalog, limit = 4) {
  const q = normalize(query);
  if (q.length < 2) {
    return [];
  }
  return catalog.map((entry, index) => ({
    entry,
    index,
    s: score(q, entry)
  })).filter((row) => row.s > 0).sort((a, b) => b.s - a.s || a.index - b.index).slice(0, limit).map((row) => row.entry);
}
__name(matchMenuEntries, "matchMenuEntries");

// src/utils/ai-report-description.ts
var AI_REPORT_PREFILL_LIMIT = 1400;
var QUESTION_MAX = 300;
var ELLIPSIS = "\u2026 (\uC774\uD558 \uC0DD\uB7B5 \u2014 \uC804\uBB38\uC740 \uCF58\uC194 AI \uB300\uD654\uC5D0\uC11C)";
function clip2(text, max) {
  const t = text.trim();
  if (t.length <= max) {
    return t;
  }
  return `${t.slice(0, Math.max(0, max - ELLIPSIS.length)).trimEnd()}${ELLIPSIS}`;
}
__name(clip2, "clip");
function buildAiReportDescription(input) {
  const limit = input.limit ?? AI_REPORT_PREFILL_LIMIT;
  const head = `${input.intro}

${input.ask}
`;
  const question = input.question?.trim() ? clip2(input.question, QUESTION_MAX) : "";
  const blocks = [];
  if (question) {
    blocks.push(`--- \uC9C8\uBB38 ---
${question}`);
  }
  const answerRaw = input.answer?.trim() ?? "";
  if (answerRaw) {
    const used = head.length + blocks.join("\n\n").length + "\n\n--- \uB2F5\uBCC0 ---\n".length + 2;
    const room = limit - used;
    if (room >= 80) {
      blocks.push(`--- \uB2F5\uBCC0 ---
${clip2(answerRaw, room)}`);
    }
  }
  if (blocks.length === 0) {
    return head;
  }
  return `${head}

${blocks.join("\n\n")}`;
}
__name(buildAiReportDescription, "buildAiReportDescription");

// src/utils/drawer-swipe.ts
var LOCK_DISTANCE_PX = 8;
var DRAWER_FLICK_VELOCITY = 0.5;
function lockDrawerAxis(dx, dy, open) {
  if (Math.abs(dx) < LOCK_DISTANCE_PX && Math.abs(dy) < LOCK_DISTANCE_PX) {
    return null;
  }
  const towardDrawer = open ? dx > 0 : dx < 0;
  return towardDrawer && Math.abs(dx) > Math.abs(dy) ? "swipe" : "scroll";
}
__name(lockDrawerAxis, "lockDrawerAxis");
function drawerOffset(input) {
  const { dx, width, open } = input;
  const raw = open ? dx : width + dx;
  return Math.min(width, Math.max(0, raw));
}
__name(drawerOffset, "drawerOffset");
function shouldDrawerStayOpen(input) {
  const { offset, width, velocity } = input;
  if (velocity >= DRAWER_FLICK_VELOCITY) {
    return false;
  }
  if (velocity <= -DRAWER_FLICK_VELOCITY) {
    return true;
  }
  return offset < width / 2;
}
__name(shouldDrawerStayOpen, "shouldDrawerStayOpen");
function isInHorizontalScroller(target, stop) {
  let el2 = target instanceof Element ? target : null;
  while (el2 && el2 !== stop) {
    if (el2.scrollWidth > el2.clientWidth + 1) {
      const overflowX = getComputedStyle(el2).overflowX;
      if (overflowX === "auto" || overflowX === "scroll") {
        return true;
      }
    }
    el2 = el2.parentElement;
  }
  return false;
}
__name(isInHorizontalScroller, "isInHorizontalScroller");

// src/utils/embedded-document.ts
function isEmbeddedDocument() {
  try {
    return typeof window !== "undefined" && window.self !== window.top;
  } catch {
    return false;
  }
}
__name(isEmbeddedDocument, "isEmbeddedDocument");
var EMBEDDED_DOCUMENT_CLASS = "ds-embedded";
function markEmbeddedDocument() {
  if (typeof document === "undefined" || !isEmbeddedDocument()) {
    return;
  }
  document.documentElement.classList.add(EMBEDDED_DOCUMENT_CLASS);
}
__name(markEmbeddedDocument, "markEmbeddedDocument");

// src/utils/markdown.ts
function escapeHtml(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
__name(escapeHtml, "escapeHtml");
var CODE_SENTINEL = "\uE000";
var LINK_SENTINEL = "\uE001";
function isSafeHref(href) {
  return /^https?:\/\/[^\s<>"]+$/i.test(href);
}
__name(isSafeHref, "isSafeHref");
function renderInline(escaped) {
  const codeSpans = [];
  const withCode = escaped.replace(/`([^`]+)`/g, (_, code) => {
    codeSpans.push(code);
    return `${CODE_SENTINEL}${codeSpans.length - 1}${CODE_SENTINEL}`;
  });
  const links = [];
  const withLinks = withCode.replace(/\[([^\]\n]+)\]\(([^)\s]+)\)/g, (whole, label, href) => {
    if (!isSafeHref(href)) {
      return whole;
    }
    const text = label.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    links.push(`<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`);
    return `${LINK_SENTINEL}${links.length - 1}${LINK_SENTINEL}`;
  });
  const bolded = withLinks.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  return bolded.replace(/\uE001(\d+)\uE001/g, (_, idx) => links[Number(idx)]).replace(/\uE000(\d+)\uE000/g, (_, idx) => `<code>${codeSpans[Number(idx)]}</code>`);
}
__name(renderInline, "renderInline");
function isTableRow(line) {
  return line.trimStart().startsWith("|");
}
__name(isTableRow, "isTableRow");
function isTableSeparator(line) {
  return /^\s*\|?[\s:|-]+\|[\s:|-]*$/.test(line) && line.includes("-");
}
__name(isTableSeparator, "isTableSeparator");
function splitTableCells(line) {
  let row = line.trim();
  if (row.startsWith("|")) {
    row = row.slice(1);
  }
  if (row.endsWith("|")) {
    row = row.slice(0, -1);
  }
  return row.split("|").map((cell) => renderInline(cell.trim()));
}
__name(splitTableCells, "splitTableCells");
function renderMarkdown(source) {
  const lines = escapeHtml(source).split("\n");
  const html = [];
  let paragraph = [];
  const flushParagraph = /* @__PURE__ */ __name(() => {
    if (paragraph.length > 0) {
      html.push(`<p>${paragraph.map(renderInline).join("<br>")}</p>`);
      paragraph = [];
    }
  }, "flushParagraph");
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line.trimStart().startsWith("```")) {
      flushParagraph();
      const code = [];
      i++;
      while (i < lines.length && !lines[i].trimStart().startsWith("```")) {
        code.push(lines[i]);
        i++;
      }
      i++;
      html.push(`<pre><code>${code.join("\n")}</code></pre>`);
      continue;
    }
    if (isTableRow(line) && i + 1 < lines.length && isTableSeparator(lines[i + 1])) {
      flushParagraph();
      const headers = splitTableCells(line);
      i += 2;
      const rows = [];
      while (i < lines.length && isTableRow(lines[i]) && !isTableSeparator(lines[i])) {
        rows.push(splitTableCells(lines[i]));
        i++;
      }
      const thead = `<thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>`;
      const tbody = `<tbody>${rows.map((cells) => `<tr>${cells.map((c) => `<td>${c}</td>`).join("")}</tr>`).join("")}</tbody>`;
      html.push(`<table>${thead}${tbody}</table>`);
      continue;
    }
    const ulMatch = /^\s*[-*]\s+(.*)$/.exec(line);
    const olMatch = /^\s*\d+\.\s+(.*)$/.exec(line);
    if (ulMatch || olMatch) {
      flushParagraph();
      const ordered = !!olMatch;
      const items = [];
      while (i < lines.length) {
        const m = ordered ? /^\s*\d+\.\s+(.*)$/.exec(lines[i]) : /^\s*[-*]\s+(.*)$/.exec(lines[i]);
        if (!m) {
          break;
        }
        items.push(`<li>${renderInline(m[1])}</li>`);
        i++;
      }
      const tag = ordered ? "ol" : "ul";
      html.push(`<${tag}>${items.join("")}</${tag}>`);
      continue;
    }
    const headingMatch = /^\s*#{1,4}\s+(.*)$/.exec(line);
    if (headingMatch) {
      flushParagraph();
      html.push(`<h4>${renderInline(headingMatch[1])}</h4>`);
      i++;
      continue;
    }
    if (/^\s*---+\s*$/.test(line)) {
      flushParagraph();
      html.push("<hr>");
      i++;
      continue;
    }
    if (line.trim() === "") {
      flushParagraph();
      i++;
      continue;
    }
    paragraph.push(line);
    i++;
  }
  flushParagraph();
  return html.join("");
}
__name(renderMarkdown, "renderMarkdown");

// src/utils/pasted-content.ts
import { AI_ATTACHMENT_LIMITS } from "@hereby/core/constants";
var LONG_TEXT_CHARS = 1500;
var LONG_TEXT_LINES = 8;
function stripHtml(s) {
  return s.replace(/<br\s*\/?>/gi, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").trim();
}
__name(stripHtml, "stripHtml");
function rowsFromHtmlTable(html) {
  const table = /<table[\s\S]*?<\/table>/i.exec(html)?.[0];
  if (!table) {
    return null;
  }
  const rows = [];
  for (const tr of table.match(/<tr[\s\S]*?<\/tr>/gi) ?? []) {
    const cells = (tr.match(/<t[dh][^>]*>[\s\S]*?<\/t[dh]>/gi) ?? []).map(stripHtml);
    if (cells.length > 0) {
      rows.push(cells);
    }
  }
  return rows.length > 0 ? rows : null;
}
__name(rowsFromHtmlTable, "rowsFromHtmlTable");
function rowsFromTsv(text) {
  const lines = text.replace(/\r\n?/g, "\n").split("\n");
  while (lines.length > 0 && lines[lines.length - 1].trim() === "") {
    lines.pop();
  }
  if (lines.length < 2 || !lines.some((l) => l.includes("	"))) {
    return null;
  }
  return lines.map((l) => l.split("	").map((c) => c.trim()));
}
__name(rowsFromTsv, "rowsFromTsv");
function clipRows(rows) {
  const originalRows = rows.length;
  const originalCols = Math.max(0, ...rows.map((r) => r.length));
  const clipped = rows.slice(0, AI_ATTACHMENT_LIMITS.maxRows).map((r) => r.slice(0, AI_ATTACHMENT_LIMITS.maxCols).map((c) => c.length > AI_ATTACHMENT_LIMITS.maxCellChars ? `${c.slice(0, AI_ATTACHMENT_LIMITS.maxCellChars)}\u2026` : c));
  return {
    rows: clipped,
    originalRows,
    originalCols
  };
}
__name(clipRows, "clipRows");
function attachmentFromClipboard(payload, context) {
  const text = payload.text ?? "";
  const rows = rowsFromTsv(text) ?? (payload.html ? rowsFromHtmlTable(payload.html) : null);
  if (rows) {
    const clipped = clipRows(rows);
    const width = Math.max(0, ...clipped.rows.map((r) => r.length));
    const columns = context && context.columns.length === width ? context.columns.slice(0, width) : void 0;
    return {
      kind: "table",
      rows: clipped.rows,
      ...columns ? {
        columns
      } : {},
      ...clipped.originalRows > clipped.rows.length || clipped.originalCols > width ? {
        originalRows: clipped.originalRows,
        originalCols: clipped.originalCols
      } : {},
      ...columns && context?.sheetName ? {
        sheetName: context.sheetName
      } : {}
    };
  }
  const trimmed = text.trim();
  const lines = trimmed.split(/\r?\n/).length;
  if (trimmed.length >= LONG_TEXT_CHARS || lines >= LONG_TEXT_LINES) {
    const cut = trimmed.length > AI_ATTACHMENT_LIMITS.maxTextChars;
    return {
      kind: "text",
      text: cut ? trimmed.slice(0, AI_ATTACHMENT_LIMITS.maxTextChars) : trimmed,
      ...cut ? {
        originalChars: trimmed.length
      } : {}
    };
  }
  return null;
}
__name(attachmentFromClipboard, "attachmentFromClipboard");
function describeAttachment(attachment) {
  if (attachment.kind === "text") {
    const n = attachment.originalChars ?? attachment.text.length;
    return `\uD14D\uC2A4\uD2B8 ${n.toLocaleString("ko-KR")}\uC790${attachment.originalChars ? " (\uC798\uB9BC)" : ""}`;
  }
  const width = Math.max(attachment.columns?.length ?? 0, ...attachment.rows.map((r) => r.length));
  const cut = (attachment.originalRows ?? 0) > attachment.rows.length || (attachment.originalCols ?? 0) > width;
  return `\uD45C ${attachment.rows.length}\uD589 \xD7 ${width}\uC5F4${cut ? " (\uC798\uB9BC)" : ""}${attachment.sheetName ? ` \xB7 ${attachment.sheetName}` : ""}`;
}
__name(describeAttachment, "describeAttachment");
function splitStoredUserMessage(content) {
  const match = /(?:^|\n\n)(\[붙여넣은 (?:표|텍스트)[^\]]*\])\n([\s\S]*)$/.exec(content);
  if (!match) {
    return {
      text: content,
      attachmentLabel: null,
      attachmentBody: null
    };
  }
  return {
    text: content.slice(0, match.index).trim(),
    attachmentLabel: match[1].slice(1, -1),
    attachmentBody: match[2]
  };
}
__name(splitStoredUserMessage, "splitStoredUserMessage");

// src/components/AiAssistant.ts
var STREAM_RECOVERY_GRACE_MS = 15e4;
var STREAM_RECOVERY_POLL_MS = 4e3;
function shouldRecoverFromStream(params) {
  return !params.isLimit && params.aiMessageId === null && params.errorCode === null;
}
__name(shouldRecoverFromStream, "shouldRecoverFromStream");
var DOCK_MIN_WIDTH = 360;
var DOCK_MAX_WIDTH = 800;
var DOCK_CONTENT_RESERVE = 720;
var DOCK_DEFAULT_WIDTH = 384;
var DOCK_MIN_VIEWPORT = 1280;
var EMBED_DOCK_MESSAGE = "hereby:tm:ai-dock";
var DOCK_WIDTH_KEY = "hereby:aiDockWidth";
var FLOATING_PANEL_OPEN_EVENT = "hereby:floating-panel-open";
var AI_ASSISTANT_OPEN_EVENT = "hereby:ai-assistant-open";
var DOCK_BODY_CLASS = "ds-ai-dock-open";
var AI_FAB_BODY_CLASS = "ds-has-ai-fab";
var DOCK_RESIZING_BODY_CLASS = "ds-ai-dock-resizing";
var DOCK_WIDTH_VAR = "--ds-ai-dock-w";
function readStoredDockWidth() {
  try {
    const v = Number.parseInt(localStorage.getItem(DOCK_WIDTH_KEY) || "", 10);
    return Number.isFinite(v) ? v : DOCK_DEFAULT_WIDTH;
  } catch {
    return DOCK_DEFAULT_WIDTH;
  }
}
__name(readStoredDockWidth, "readStoredDockWidth");
var FAILED_TURN_COPY = "\uC751\uB2F5 \uC0DD\uC131\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.";
async function writeClipboardText(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
  }
  try {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand("copy");
    area.remove();
    return ok;
  } catch {
    return false;
  }
}
__name(writeClipboardText, "writeClipboardText");
var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function isUuid(value) {
  return UUID_RE.test(value);
}
__name(isUuid, "isUuid");
function readTurnFailure(error) {
  const data = error?.data;
  if (!data || typeof data !== "object") {
    return {
      aiMessageId: null,
      errorCode: null,
      requestId: null
    };
  }
  const d = data;
  const detail = d.detail && typeof d.detail === "object" ? d.detail : null;
  const aiMessageId = typeof detail?.aiMessageId === "string" && isUuid(detail.aiMessageId) ? detail.aiMessageId : null;
  return {
    aiMessageId,
    errorCode: typeof detail?.aiErrorCode === "string" ? detail.aiErrorCode : null,
    requestId: typeof d.requestId === "string" ? d.requestId : null
  };
}
__name(readTurnFailure, "readTurnFailure");
var PENDING_HINT_AFTER_SEC = 20;
var PENDING_TIMEOUT_HINT_AFTER_SEC = 120;
function pendingStatusText(input) {
  let label;
  if (input.stage === "finalizing") {
    label = "\uC5F0\uACB0\uC774 \uBA3C\uC800 \uB04A\uACA8 \uB2F5\uBCC0\uC744 \uC2A4\uD2B8\uB9BC\uC73C\uB85C \uBC1B\uB294 \uC911";
  } else if (input.activeToolLabel) {
    label = `${input.activeToolLabel} \uC911`;
  } else if (input.stage === "tool_planned" && input.stageLabel) {
    label = `${input.stageLabel} \uC900\uBE44 \uC911`;
  } else if (input.stage === "answering") {
    label = "\uB2F5\uBCC0 \uC791\uC131 \uC911";
  } else if (input.stage === "iteration" && input.iteration > 1) {
    label = `\uC870\uD68C \uACB0\uACFC\uB97C \uBC18\uC601\uD574 \uB2F5\uC744 \uB9CC\uB4DC\uB294 \uC911 (${input.iteration}\uBC88\uC9F8)`;
  } else if (input.hasThinking) {
    label = "\uC0DD\uAC01\uD558\uB294 \uC911";
  } else if (input.stage === "iteration") {
    label = "\uC9C8\uBB38\uC744 \uC774\uD574\uD558\uACE0 \uACC4\uD68D\uD558\uB294 \uC911";
  } else {
    label = input.elapsedSec < 3 ? "\uC9C8\uBB38\uC744 \uBCF4\uB0B4\uB294 \uC911" : "\uC0DD\uAC01\uD558\uB294 \uC911";
  }
  const elapsed = input.elapsedSec >= 1 ? `${input.elapsedSec}\uCD08` : "";
  const hint = input.elapsedSec >= PENDING_TIMEOUT_HINT_AFTER_SEC ? "\uACE7 \uC2DC\uAC04 \uC81C\uD55C(3\uBD84)\uC5D0 \uAC78\uB824\uC694. \uACC4\uC18D \uB2F5\uC774 \uC5C6\uC73C\uBA74 \uC9C8\uBB38\uC744 \uB098\uB220 \uB2E4\uC2DC \uBCF4\uB0B4 \uC8FC\uC138\uC694." : input.elapsedSec >= PENDING_HINT_AFTER_SEC ? "\uC2DC\uD2B8\uB97C \uC5EC\uB7EC \uBC88 \uC77D\uAC70\uB098 \uACC4\uC0B0\uC774 \uB9CE\uC73C\uBA74 1~3\uBD84 \uAC78\uB9B4 \uC218 \uC788\uC5B4\uC694." : "";
  return {
    label,
    elapsed,
    hint
  };
}
__name(pendingStatusText, "pendingStatusText");
function formatAiDuration(latencyMs) {
  if (latencyMs == null || !Number.isFinite(latencyMs) || latencyMs < 0) {
    return "";
  }
  const tenths = Math.round(latencyMs / 100);
  const minutes = Math.floor(tenths / 600);
  const seconds = (tenths % 600 / 10).toFixed(1);
  return minutes > 0 ? `${minutes}\uBD84 ${seconds}\uCD08` : `${seconds}\uCD08`;
}
__name(formatAiDuration, "formatAiDuration");
function toChangeSetView(raw) {
  const cs = raw;
  return {
    ...cs,
    busy: false,
    confirmed: Boolean(cs.confirmed),
    error: null,
    showAllDiff: Boolean(cs.showAllDiff)
  };
}
__name(toChangeSetView, "toChangeSetView");
var USAGE_NOTICE_KEY = "hereby:aiUsageNotice";
var GUIDANCE_START_LIMIT = 3;
var GUIDANCE_ENTRY_META = {
  "leave.approval.admin": {
    icon: "ic-calendar-check",
    keywords: [
      "\uD734\uAC00",
      "\uC5F0\uCC28",
      "\uACB0\uC7AC",
      "\uC2B9\uC778",
      "\uBC18\uB824"
    ]
  },
  "employee.register.admin": {
    icon: "ic-user-plus",
    keywords: [
      "\uC9C1\uC6D0 \uCD94\uAC00",
      "\uC9C1\uC6D0 \uB4F1\uB85D",
      "\uC785\uC0AC",
      "\uC2E0\uADDC \uC9C1\uC6D0"
    ]
  },
  "attendance.admin": {
    icon: "ic-clock",
    keywords: [
      "\uADFC\uD0DC",
      "\uCD9C\uADFC",
      "\uD1F4\uADFC",
      "\uADFC\uBB34 \uAE30\uB85D"
    ]
  }
};
function formatTokens(n) {
  return n >= 1e4 ? `${(n / 1e3).toFixed(n >= 1e5 ? 0 : 1)}k` : n.toLocaleString("ko-KR");
}
__name(formatTokens, "formatTokens");
function aiAssistantComponent(opts = {}) {
  return {
    enabled: false,
    guidanceEnabled: false,
    navigationSupported: Boolean(opts.onGuidanceAction),
    navigation: null,
    navigationContext() {
      const app = opts.app;
      if (app !== "admin" && app !== "employee-app" && app !== "hr-system") {
        throw new Error("\uC774 \uC571\uC5D0\uC11C\uB294 \uC704\uCE58 \uC548\uB0B4\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694.");
      }
      const sheet = opts.getContext?.().sheet;
      return {
        version: 1,
        app,
        ...app === "hr-system" && sheet ? {
          sheet: {
            sheetViewId: sheet.sheetViewId,
            year: sheet.year,
            month: sheet.month
          }
        } : {}
      };
    },
    ensureNavigation() {
      if (!this.navigation) {
        this.navigation = createGuidanceNavigation({
          context: /* @__PURE__ */ __name(() => this.navigationContext(), "context"),
          identity: /* @__PURE__ */ __name(() => JSON.stringify([
            herebyStore(this).currentUser,
            opts.getContext?.().tab,
            opts.getContext?.().path,
            this.suspended,
            this.isOpen
          ]), "identity"),
          catalog: /* @__PURE__ */ __name((context) => herebyStore(this).sdk.ai.guidanceCatalog(context), "catalog"),
          resolve: /* @__PURE__ */ __name((input) => herebyStore(this).sdk.ai.resolveGuidanceAction(input), "resolve"),
          navigate: /* @__PURE__ */ __name(async (action, signal) => {
            if (!opts.onGuidanceAction || this.isSending) {
              throw new Error("\uB2F5\uBCC0\uC774 \uB05D\uB09C \uB4A4 \uB2E4\uC2DC \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.");
            }
            await opts.onGuidanceAction(action, signal);
            if (!this.dockActive) {
              this.navigation?.cancelPending();
              this.isOpen = false;
              this.applyDockLayout();
            }
          }, "navigate")
        });
      }
      return this.navigation;
    },
    /** 기능 바로가기 첫 화면 — 카탈로그를 한 번 읽었는가 / 「기능 전체 보기」로 펼쳤는가 */
    guidanceStartRequested: false,
    guidanceStartExpanded: false,
    /** 빈 대화에서 기능 바로가기 목록을 첫 화면으로 그리는가(admin). 직원 앱 업무 바로가기가 있으면 그쪽이 이긴다. */
    get showGuidanceStart() {
      return opts.guidanceStartScreen === true && !this.hasStartScreen && this.navigationSupported && this.guidanceEnabled && this.hasAiPermission && this.view === "chat" && this.messages.length === 0 && !this.isSending && !this.historyLoading;
    },
    /** 대화 중 「기능 바로가기」 버튼 — 첫 화면에서 기능을 고르는 마운트(admin)에는 없다. */
    get showGuidanceButton() {
      return this.navigationSupported && this.guidanceEnabled && opts.guidanceStartScreen !== true;
    },
    get guidanceStartItems() {
      const items = this.navigation?.catalog.items ?? [];
      return this.guidanceStartExpanded ? items : items.slice(0, GUIDANCE_START_LIMIT);
    },
    get guidanceStartHasMore() {
      return !this.guidanceStartExpanded && (this.navigation?.catalog.items.length ?? 0) > GUIDANCE_START_LIMIT;
    },
    guidanceStartIcon(id) {
      return GUIDANCE_ENTRY_META[id]?.icon ?? "ic-sparkle";
    },
    /** 기능 바로가기 카탈로그를 쓰는 마운트인가(admin · 시스템 어드민 「문서 안내」가 켜진 조직) */
    get usesGuidanceCatalog() {
      return opts.guidanceStartScreen === true && this.navigationSupported && this.guidanceEnabled && this.hasAiPermission;
    },
    /** 입력 중 팝오버가 맞춰 볼 기능 목록 — 첫 화면과 같은 카탈로그를 메뉴 항목 모양으로 바꾼다. */
    get guidanceMenuCatalog() {
      if (!this.usesGuidanceCatalog) {
        return [];
      }
      return (this.navigation?.catalog.items ?? []).map((item) => ({
        id: item.id,
        label: item.title,
        keywords: [
          item.description,
          ...GUIDANCE_ENTRY_META[item.id]?.keywords ?? []
        ],
        icon: this.guidanceStartIcon(item.id),
        guidance: true
      }));
    },
    /** 첫 화면이 보일 때 카탈로그를 한 번 읽는다. */
    async ensureGuidanceStart() {
      if (this.showGuidanceStart) {
        await this.ensureGuidanceCatalog();
      }
    },
    /** 카탈로그를 한 번 읽는다(첫 화면 · 입력칸 포커스) — 위치 안내가 진행 중이면 끊지 않도록 건너뛴다. */
    async ensureGuidanceCatalog() {
      if (this.guidanceStartRequested || !this.usesGuidanceCatalog) {
        return;
      }
      const navigation = this.ensureNavigation();
      if (navigation.busy || navigation.loading) {
        return;
      }
      this.guidanceStartRequested = true;
      await navigation.load();
      navigation.open = false;
      if (navigation.message) {
        this.guidanceStartRequested = false;
      }
    },
    async showGuidanceCatalog() {
      if (!(this.hasAiPermission && this.guidanceEnabled && opts.onGuidanceAction)) {
        return;
      }
      this.guidanceStartExpanded = false;
      await this.ensureNavigation().load();
    },
    async executeGuidanceAction(capabilityId, sheetViewId, columnKey) {
      if (!(this.hasAiPermission && this.guidanceEnabled && opts.onGuidanceAction) || this.isSending) {
        return;
      }
      await this.ensureNavigation().run(capabilityId, sheetViewId, columnKey);
    },
    canNavigateGuidance(guidance) {
      if (!(this.navigationSupported && this.guidanceEnabled) || guidance?.availability !== "available" || !guidance.capabilityId) {
        return false;
      }
      const id = guidance.capabilityId;
      return opts.app === "admin" ? id.endsWith(".admin") : opts.app === "employee-app" ? id.endsWith(".employee") : opts.app === "hr-system" && id.startsWith("sheet.");
    },
    /**
    * 사용자 AI 권한(opts.permission, 기본 ai:execute). 조직이 AI 를 켰는데 사용자에게 권한이
    * 없으면 FAB 은 그대로 두고 패널 안에서 권한 없음을 보여 준다 — 상시 노출 기능은 화면을 가리는
    * 권한 모달 대신 위젯 안에서 안내한다(사용자 결정 2026-09-29 · MED-789). AI API 는 부르지 않는다.
    */
    /**
    * 게터라 스토어를 볼 때마다 다시 계산된다 — 권한 미리보기 시작·종료로 사용자가 바뀌거나
    * 위젯이 activate() 밖에서 켜져도 값이 낡지 않는다. 전에는 activate() 가 `enabled` 면 바로
    * 돌아가 이 값을 한 번도 계산하지 못해, ai:execute 를 가진 급여 관리자도 안내만 봤다(MED-811).
    */
    get hasAiPermission() {
      return herebyStore(this)?.hasPermission?.(opts.permission ?? "ai:execute") === true;
    },
    /** 권한 없음 안내의 「권한 요청」이 공용 권한 모달에 넘기는 코드 */
    requiredPermission: opts.permission ?? "ai:execute",
    title: opts.title ?? "AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
    /** 마지막 답변의 사용량 — 80/100% 배너와 첫 사용 안내의 숫자가 읽는다 */
    usage: null,
    /** 한도 초과로 거절된 마지막 서버 문구 — 100% 배너 */
    limitMessage: null,
    /** 첫 사용 안내(토큰을 많이 쓴다) 표시 여부 — 사용자·조직별 1회, 시트 어시스턴트만 */
    usageNoticeVisible: false,
    isOpen: false,
    isSending: false,
    input: "",
    get canRequestGuidancePermission() {
      return typeof document !== "undefined" && document.querySelector('[x-data^="permissionDeniedModal("]') !== null;
    },
    messages: [],
    /** 입력줄 위에 떠 있는 붙여넣기 첨부(표·긴 텍스트) — 전송 때 ai.chat 의 attachment 로 나간다(MED-859) */
    attachment: null,
    /** 진행 중 응답의 스트리밍 버퍼 */
    streamText: "",
    /** 요약된 생각 과정 스트리밍 버퍼 (Claude 데스크톱식 표시, 저장 안 함) */
    thinkingText: "",
    /**
    * 이번 턴의 스트림 `done`(messageId · 본문). HTTP 응답보다 먼저 올 수 있고, 응답이 끊겨도 온다 —
    * 응답 실패 뒤 이어받기의 근거. 전송 시작 때 비운다.
    */
    streamDone: null,
    /** 진행 단계(서버 status 이벤트) · 경과 시간 — 「무엇을 하는 중」 표시 */
    pendingStage: "idle",
    pendingIteration: 0,
    pendingStageLabel: null,
    activeToolLabel: null,
    pendingStartedAt: 0,
    pendingElapsedSec: 0,
    pendingTimer: null,
    /** 답변 스트리밍이 시작된 뒤 생각 과정을 펼쳐볼지 여부 */
    showThinking: false,
    /** 실행 중인 tool 이름 (조회 중 표시) */
    activeTool: null,
    /** 이번 턴에 완료된 tool 호출 로그 */
    toolLog: [],
    conversationId: null,
    subscription: null,
    reconnectHandler: null,
    /** 'chat' = 대화 화면, 'list' = 이전 대화 목록 */
    view: "chat",
    conversations: [],
    historyLoading: false,
    /**
    * 첫 오픈 1회만 사용량 안내·대화 목록을 읽는다. 처음 열면 **새 대화**로 시작한다 — 떠 있는 패널·도크·페이지 모드(직원 앱)
    * 모두(2026-10-08). 지난 대화는 사이드바·서랍에서 연다. 닫았다 다시 열면 닫기 직전 화면이 그대로다.
    */
    bootstrapped: false,
    /**
    * 닫아 둔 사이에 답변이 도착했음 — FAB 에 점 하나로만 알린다(개수는 세지 않는다).
    * 전송은 패널이 열려 있어야 하므로 실제로 켜지는 경로는 **답변을 기다리다 패널을
    * 닫은 경우** 하나다. 그 하나가 정확히 사용자가 놓치는 상황이라 표시가 필요하다.
    */
    hasNewAnswer: false,
    /* ── 도크(우측 스티키 패널) ─────────────────────────────────────────────
    * **어시스턴트는 도크로만 열린다** — 떠 있는 창 모드는 없다(2026-09-04 사용자 결정).
    * 채팅 패널과 나란히 띄우면 384px 짜리 둘이 **80% 겹쳐서** 뒤쪽을 읽을 수 없었는데,
    * 순서를 z 로 바꾸는 것은 불가능하다: 어시스턴트는 모달(50) **위**(65)여야 하고
    * 채팅은 모달 **아래**(44)여야 해서, 채팅을 어시스턴트 위로 올리면 모달의 확정
    * 버튼을 덮는다(2026-08 회귀). 도크는 본문을 밀어내고 채팅이 그 왼쪽으로 비키므로
    * **겹침 자체가 사라진다** — z 를 하나도 건드리지 않고 풀리는 유일한 길이다.
    *
    * 좁은 화면(<1280)에서는 도크를 쓸 수 없어 예전의 떠 있는 패널로 폴백한다.
    * 그 구간에서는 채팅과 다시 겹치지만, 도크 자체가 비활성인 구간이라 감수한다.
    */
    /** 도크 폭(px). 실제 렌더는 이 값이 아니라 `--ds-ai-dock-w` 를 CSS 가 읽는다. */
    dockWidth: DOCK_DEFAULT_WIDTH,
    /** 이 화면이 도크를 감당할 수 있나 — 태블릿 이하(<1280)에서는 false. */
    dockAllowed: false,
    /**
    * 호스트 앱이 위젯을 화면에서 잠시 치웠나 — admin 이 시트 임베드 동안 자기 위젯을
    * 감출 때 `setSuspended(true)` 로 알린다(dashboard.html x-effect). 대화·열림 상태는
    * 그대로 두고 **도크가 body 에 건 여백만 거둔다**: wrapper 를 display:none 으로
    * 감추는 것만으로는 `body.ds-ai-dock-open` 의 padding-right 가 남아 임베드된
    * 시트가 도크 폭만큼 오른쪽이 비어 보인다. 다시 돌아오면 도크가 그 자리에 복원된다.
    */
    suspended: false,
    /** 좌우 핸들을 끌고 있는 중 */
    dockResizing: false,
    dockViewportHandler: null,
    floatingPanelHandler: null,
    /** 지금 도크로 떠 있나 — 열려 있고 화면이 감당하면 **항상** 도크다(고를 여지가 없다). */
    get dockActive() {
      return this.isOpen && this.dockAllowed;
    },
    /** 페이지 모드(직원 앱) — FAB·도크·ESC 없이 화면 한 장이 대화다 */
    get isPageMode() {
      return opts.mode === "page";
    },
    /** 첫 사용 안내 문구 — 시트는 기본 문구, 그 밖은 마운트가 넘긴 문구 */
    get firstUseNoticeText() {
      return opts.firstUseNotice ?? "\uC2DC\uD2B8 \uC5B4\uC2DC\uC2A4\uD134\uD2B8\uB294 \uC2DC\uD2B8 \uAD6C\uC870\uC640 \uD45C\uBCF8 \uD589\uC744 \uC77D\uC5B4 \uC77C\uBC18 \uCC44\uD305\uBCF4\uB2E4 \uD1A0\uD070\uC744 \uB9CE\uC774 \uC368\uC694.";
    },
    /** 첫 화면 업무 바로가기 — 호스트가 매번 다시 계산할 수 있게 게터다(권한·병원 설정에 따라 줄어든다). */
    get startActions() {
      return opts.getStartActions?.() ?? [];
    },
    /** 업무 바로가기가 있으면 빈 대화 대신 첫 화면을 그린다. */
    get hasStartScreen() {
      return this.startActions.length > 0;
    },
    examplePrompts: opts.examplePrompts ?? [],
    composerPlaceholder: opts.composerPlaceholder ?? "\uBB34\uC5C7\uC774\uB4E0 \uBB3C\uC5B4\uBCF4\uC138\uC694",
    /** 입력칸에 포커스가 있는가 — 페이지 모드는 이때만 예시 질문을 입력줄 위에 띄운다(레퍼런스: 입력칸을 누르면 제안이 뜬다) */
    composerFocused: false,
    /** 입력칸을 누른 뒤 아직 아무것도 안 쳤을 때 입력줄 위에 띄울 예시 질문.
    *  처음 묻기 전 안내라서, 이 대화에서 한 번이라도 물었으면(사용자 메시지 1개 이상) 다시 띄우지 않는다(2026-10-06). */
    get showComposerSuggestions() {
      return this.isPageMode && this.composerFocused && !this.isSending && this.input.trim() === "" && this.examplePrompts.length > 0 && !this.messages.some((m) => m.role === "user");
    },
    startBrandIcon: opts.startBrandIcon ?? "",
    startHeading: opts.startHeading ?? "",
    /**
    * 입력 중인 글로 맞춘 메뉴(AI 없이, 즉시). 보내는 중이면 비운다. 직원 앱은 호스트 메뉴(getMenuCatalog)를,
    * admin 은 기능 바로가기 카탈로그(guidanceMenuCatalog)를 맞춘다 — 팝오버 모양은 같다.
    */
    get menuMatches() {
      if (this.isSending) {
        return [];
      }
      const catalog = [
        ...opts.getMenuCatalog?.() ?? [],
        ...this.guidanceMenuCatalog
      ];
      return catalog.length ? matchMenuEntries(this.input, catalog) : [];
    },
    /** 팝오버 줄을 눌렀을 때 — 기능이면 그 화면으로 가서 하이라이트, 메뉴면 호스트가 화면을 연다. */
    pickMenuEntry(entry) {
      if (!entry.guidance) {
        this.runStartAction(entry.id);
        return;
      }
      this.input = "";
      queueMicrotask(() => this.autosizeComposer());
      return this.executeGuidanceAction(entry.id);
    },
    /** 업무 바로가기·메뉴 결과 — 화면 이동은 호스트가 한다. 입력 중이던 글은 비운다(다른 화면으로 떠나므로). */
    runStartAction(id) {
      this.input = "";
      queueMicrotask(() => this.autosizeComposer());
      opts.onStartAction?.(id);
    },
    /** 예시 질문 — 입력줄에 넣고 그대로 보낸다. */
    askExample(text) {
      if (this.isSending) {
        return;
      }
      this.composerFocused = false;
      this.input = text;
      return this.send();
    },
    get emptyStateText() {
      return opts.emptyStateText ?? "\uC9C1\uC6D0\xB7\uD734\uAC00\xB7\uADFC\uD0DC\xB7\uAE09\uC5EC\uC5D0 \uB300\uD574 \uBB3C\uC5B4\uBCF4\uC138\uC694.\n\uB0B4 \uAD8C\uD55C \uBC94\uC704\uC758 \uB370\uC774\uD130\uB9CC \uC870\uD68C\uB418\uBA70,\n\uB2F5\uBCC0\uC740 \uBD80\uC815\uD655\uD560 \uC218 \uC788\uC5B4\uC694.";
    },
    /** 하한 · 기본 폭은 마크업(aria-valuemin·Home 키)도 읽는다 — 숫자를 두 곳에 적지 않는다. */
    get dockMinWidth() {
      return DOCK_MIN_WIDTH;
    },
    get dockDefaultWidth() {
      return DOCK_DEFAULT_WIDTH;
    },
    /** 이 화면에서 허용되는 도크 상한 — 본문이 읽을 수 없게 좁아지지 않도록 화면에 종속시킨다. */
    get dockMaxWidth() {
      const room = window.innerWidth - DOCK_CONTENT_RESERVE;
      return Math.max(DOCK_MIN_WIDTH, Math.min(DOCK_MAX_WIDTH, room));
    },
    /**
    * 도크 관련 화면 상태를 `<body>` 에 한 번에 반영한다.
    *
    * 폭을 Alpine 바인딩이 아니라 **CSS 변수 한 개**로 내보내는 이유: 본문 밀어내기
    * (`body` padding) · 모달 딤의 오른쪽 여백 · 채팅 FAB 비킴이 전부 같은 값을 읽어야
    * 하는데, 세 곳에 각각 바인딩을 걸면 드래그 한 프레임마다 Alpine 이 패널 서브트리를
    * 다시 그린다(임베드된 시트가 매 프레임 가상화 그리드를 재계산한다).
    */
    applyDockLayout() {
      if (typeof document === "undefined") {
        return;
      }
      const active = this.dockActive && !this.suspended;
      document.body.classList.toggle(DOCK_BODY_CLASS, active);
      if (active) {
        document.body.style.setProperty(DOCK_WIDTH_VAR, `${this.dockRenderWidth}px`);
      } else {
        document.body.style.removeProperty(DOCK_WIDTH_VAR);
      }
      if (isEmbeddedDocument()) {
        window.parent.postMessage({
          type: EMBED_DOCK_MESSAGE,
          open: active,
          width: active ? this.dockRenderWidth : 0
        }, "*");
      }
    },
    /**
    * 실제로 그리는 폭 — 고른 폭(`dockWidth`)을 **이 화면의 허용 범위로 물린 값**이다.
    *
    * 둘을 갈라 두는 것이 핵심이다. 예전에는 창을 줄일 때마다 `dockWidth` 자체를 물려
    * 덮어썼는데, 그러면 **줄인 폭이 그대로 굳어 다시 넓혀도 안 돌아왔다** — 800 으로
    * 쓰던 사람이 창을 900px 로 줄였다 되돌리면 360 으로 남았다(실측). 고른 값은
    * 사용자의 것이니 건드리지 않고, 좁은 화면에서는 **표시만** 줄인다.
    */
    get dockRenderWidth() {
      return Math.round(Math.max(DOCK_MIN_WIDTH, Math.min(this.dockMaxWidth, this.dockWidth)));
    },
    /** 호스트 앱이 위젯을 치우거나 되돌릴 때 — body 의 도크 여백을 같이 거두고 되살린다. */
    setSuspended(next) {
      if (this.suspended === next) {
        return;
      }
      if (next) {
        this.navigation?.cancelPending();
      }
      this.suspended = next;
      this.applyDockLayout();
    },
    /** 사용자가 고른 폭을 바꾼다(드래그·키보드). 화면에 반영은 `dockRenderWidth` 가 한다. */
    setDockWidth(next) {
      this.dockWidth = Math.round(Math.max(DOCK_MIN_WIDTH, Math.min(this.dockMaxWidth, next)));
      this.applyDockLayout();
    },
    /**
    * 화면 폭이 바뀔 때마다 도크 사용 가능 여부를 다시 판정한다.
    * 열려 있는 채로 창을 좁히면 도크가 떠 있는 창으로, 다시 넓히면 도크로 자동 전환된다 —
    * 마크업이 한 벌이라 대화는 그대로 남는다.
    * **고른 폭은 건드리지 않는다** — 상한은 `dockRenderWidth` 가 그릴 때만 적용한다.
    */
    syncDockViewport() {
      const allowed = window.innerWidth >= DOCK_MIN_VIEWPORT;
      if (this.dockAllowed && !allowed && this.isOpen) {
        this.navigation?.cancelPending();
        this.isOpen = false;
      }
      this.dockAllowed = allowed;
      this.applyDockLayout();
    },
    /**
    * 좌측 핸들 드래그로 폭 조절. 도크가 오른쪽에 붙어 있어 **왼쪽으로 끌수록 넓어진다**
    * (dx 부호가 트리뷰 리사이저와 반대다).
    *
    * ⚠️ 드래그 중 `<body>` 에 표식을 붙여 **iframe 의 포인터 이벤트를 죽인다.** admin 은
    * 급여·근태·드라이브·팀관리를 iframe 으로 품는데, 커서가 iframe 위로 들어가는 순간
    * 포인터 이벤트가 자식 문서로 가서 부모가 못 받고 드래그가 그 자리에 굳는다.
    */
    startDockResize(event) {
      if (!this.dockActive) {
        return;
      }
      const startX = event.clientX;
      const startWidth = this.dockRenderWidth;
      this.dockResizing = true;
      document.body.classList.add(DOCK_RESIZING_BODY_CLASS);
      const onMove = /* @__PURE__ */ __name((e) => this.setDockWidth(startWidth - (e.clientX - startX)), "onMove");
      const onUp = /* @__PURE__ */ __name(() => {
        this.dockResizing = false;
        document.body.classList.remove(DOCK_RESIZING_BODY_CLASS);
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onUp);
        try {
          localStorage.setItem(DOCK_WIDTH_KEY, String(this.dockWidth));
        } catch {
        }
      }, "onUp");
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
      window.addEventListener("pointercancel", onUp);
      event.preventDefault();
    },
    /** 키보드로도 폭을 조절할 수 있어야 한다 — 마우스 전용 핸들은 접근성 결손이다. */
    nudgeDockWidth(step) {
      this.setDockWidth(this.dockWidth + step);
      try {
        localStorage.setItem(DOCK_WIDTH_KEY, String(this.dockWidth));
      } catch {
      }
    },
    /**
    * 인증 완료 후 노출 조건(권한 + 조직 플래그) 평가 — 멱등.
    * 스토어 init(세션 복원)이 컴포넌트 init보다 늦게 끝나므로 init에서 한 번 체크하는
    * 방식은 항상 미인증 상태를 본다. 템플릿 루트의
    * `x-effect="if ($store.hereby.authenticated) activate()"`가 인증 상태를 반응형으로
    * 구독해 로그인/세션 복원이 완료되는 순간 호출한다 ($watch는 $store 경로에 발화 안 함).
    */
    async activate() {
      if (this.enabled) {
        return;
      }
      const store = herebyStore(this);
      if (!this.hasAiPermission && this.isPageMode) {
        return;
      }
      try {
        const status = await store.sdk.ai.status();
        this.guidanceEnabled = status.guidance === true;
        this.enabled = status.enabled && (!opts.requireModule || status.modules[opts.requireModule] === true);
      } catch {
        this.enabled = false;
      }
      if (this.isPageMode) {
        if (this.enabled && !this.reconnectHandler) {
          this.reconnectHandler = () => {
            if (this.conversationId) {
              this.subscribe(this.conversationId);
            }
          };
          window.addEventListener("hereby:ws-reconnected", this.reconnectHandler);
        }
        return;
      }
      document.body.classList.toggle(AI_FAB_BODY_CLASS, this.enabled);
      if (this.enabled && !this.reconnectHandler) {
        this.reconnectHandler = () => {
          if (this.conversationId) {
            this.subscribe(this.conversationId);
          }
        };
        window.addEventListener("hereby:ws-reconnected", this.reconnectHandler);
        window.addEventListener("hereby:sheet-change-set-reverted", (event) => {
          const id = event.detail?.changeSetId;
          if (!id) {
            return;
          }
          for (const message of this.messages) {
            for (const cs of message.changeSets ?? []) {
              if (cs.id === id) {
                cs.status = "reverted";
              }
            }
          }
        });
      }
      if (this.enabled && !this.dockViewportHandler) {
        this.dockWidth = readStoredDockWidth();
        this.dockViewportHandler = () => this.syncDockViewport();
        window.addEventListener("resize", this.dockViewportHandler);
        this.floatingPanelHandler = (event) => {
          if (event.detail === "ai" || !this.isOpen || this.dockActive) {
            return;
          }
          this.navigation?.cancelPending();
          this.isOpen = false;
          this.applyDockLayout();
        };
        window.addEventListener(FLOATING_PANEL_OPEN_EVENT, this.floatingPanelHandler);
        registerEscLayer(() => this.isOpen && !this.dockActive ? document.querySelector('[data-testid="ai-panel"]') : null, () => {
          this.navigation?.cancelPending();
          this.isOpen = false;
          this.applyDockLayout();
        });
        this.syncDockViewport();
      }
    },
    destroy() {
      this.navigation?.cancel();
      document.body.classList.remove(AI_FAB_BODY_CLASS);
      this.subscription?.unsubscribe();
      this.subscription = null;
      if (this.reconnectHandler) {
        window.removeEventListener("hereby:ws-reconnected", this.reconnectHandler);
        this.reconnectHandler = null;
      }
      if (this.dockViewportHandler) {
        window.removeEventListener("resize", this.dockViewportHandler);
        this.dockViewportHandler = null;
      }
      if (this.floatingPanelHandler) {
        window.removeEventListener(FLOATING_PANEL_OPEN_EVENT, this.floatingPanelHandler);
        this.floatingPanelHandler = null;
      }
      this.navigation?.cancelPending();
      this.isOpen = false;
      this.applyDockLayout();
    },
    /**
    * 페이지 모드에서 화면이 열릴 때 — 호스트(직원 앱 더보기)가 x-effect 로 부른다. 처음 열면 새 대화(첫 화면)이고
    * 목록만 읽어 서랍에 둔다. 닫았다 다시 열면 같은 대화가 그대로다(Alpine 인스턴스가 살아 있다).
    */
    async openPage() {
      if (!this.enabled) {
        await this.activate();
      }
      if (!this.enabled) {
        return;
      }
      this.isOpen = true;
      this.hasNewAnswer = false;
      if (!this.bootstrapped) {
        this.bootstrapped = true;
        this.initUsageNotice();
        this.refreshConversations();
      }
    },
    toggle() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen) {
        this.navigation?.cancelPending();
      }
      if (this.isOpen) {
        this.hasNewAnswer = false;
      }
      if (this.isOpen && !this.bootstrapped && this.hasAiPermission) {
        this.bootstrapped = true;
        this.initUsageNotice();
        this.refreshConversations();
      }
      if (this.isOpen) {
        window.dispatchEvent(new CustomEvent(AI_ASSISTANT_OPEN_EVENT));
      }
      if (this.isOpen && !this.dockAllowed) {
        window.dispatchEvent(new CustomEvent(FLOATING_PANEL_OPEN_EVENT, {
          detail: "ai"
        }));
      }
      this.applyDockLayout();
    },
    /** 저장된 대화를 열어 히스토리를 불러오고 스트림을 다시 구독한다 */
    async openConversation(conversationId) {
      if (this.isSending) {
        return;
      }
      const sdk = herebyStore(this).sdk;
      this.closeHistoryDrawer();
      this.historyLoading = true;
      this.view = "chat";
      try {
        const history = await sdk.ai.history({
          conversationId
        });
        this.conversationId = conversationId;
        this.messages = history.map((message) => {
          const failed = message.status === AiMessageStatus.ERROR;
          return {
            id: message.id,
            role: message.role === AiMessageRole.ASSISTANT ? "assistant" : "user",
            content: failed ? FAILED_TURN_COPY : message.content,
            guidance: message.guidance ?? null,
            feedback: message.feedback ?? null,
            createdAt: message.createdAt ?? null,
            latencyMs: message.latencyMs ?? null,
            tokens: message.tokens ?? null,
            module: message.module ?? null,
            promptVersion: message.promptVersion ?? null,
            ...failed ? {
              failed: true,
              errorCode: message.errorCode ?? null
            } : {},
            changeSets: (message.changeSets ?? []).map(toChangeSetView)
          };
        });
        this.subscribe(conversationId);
        this.scrollToBottom();
      } catch {
      } finally {
        this.historyLoading = false;
      }
    },
    /**
    * 이전 대화 사이드바(떠 있는 패널·도크) — 헤더 왼쪽 패널 아이콘이 켜고 끈다. 페이지 모드(직원 앱)는
    * 화면이 좁아 본문 옆에 두지 않고 오른쪽 서랍(openHistory)으로 띄운다.
    */
    // 늘 펼친 채로 시작한다(2026-10-08 사용자 지시) — 접은 상태는 기억하지 않는다.
    historySidebarOpen: true,
    toggleHistorySidebar() {
      this.historySidebarOpen = !this.historySidebarOpen;
      if (this.historySidebarOpen) {
        this.refreshConversations();
      }
    },
    async refreshConversations() {
      try {
        this.conversations = await herebyStore(this).sdk.ai.listConversations({
          app: opts.app
        });
      } catch {
      }
    },
    /**
    * 이전 대화 서랍(페이지 모드 · 직원 앱) — 앱 헤더 오른쪽 「이전 대화」 가 열고 닫는다(호스트가 app-ai-history 이벤트로
    * openHistory 를 부른다). 예전엔 대화 화면을 목록 화면으로 통째로 바꿨는데, Claude · ChatGPT 모바일 앱처럼
    * 대화 위로 밀려 나오는 서랍으로 바꿨다(2026-10-08). **오른쪽에서** 나오는 것은 앱 헤더 왼쪽에 「뒤로(<)」 가 있어서다.
    * 답변을 기다리는 중에도 연다 — 목록은 볼 수 있고, 행은 isSending 동안 눌리지 않는다(openConversation).
    */
    historyDrawerOpen: false,
    /**
    * 손가락으로 끄는 중인 서랍 위치 — 열린 자리에서 오른쪽으로 밀려난 px(0 = 다 열림, 서랍 폭 = 다 닫힘).
    * 손을 대고 있지 않으면 null 이고, 그때 위치는 historyDrawerOpen 이 정한다(CSS 전환).
    */
    historyDrawerDrag: null,
    drawerGesture: null,
    async openHistory() {
      if (this.historyDrawerOpen) {
        this.closeHistoryDrawer();
        return;
      }
      this.historyDrawerOpen = true;
      await this.refreshConversations();
    },
    closeHistoryDrawer() {
      this.historyDrawerOpen = false;
      this.historyDrawerDrag = null;
      this.drawerGesture = null;
    },
    /** 서랍 끌기 동안 바르는 인라인 변수 — 위치와 딤 진하기. 끌지 않을 때는 비워 CSS 가 is-open 으로 정한다. */
    get historyDrawerStyle() {
      const drag = this.historyDrawerDrag;
      const width = this.drawerGesture?.width ?? 0;
      if (drag === null || width <= 0) {
        return "";
      }
      return `--ds-ai-drawer-offset: ${drag}px; --ds-ai-drawer-progress: ${1 - drag / width}`;
    },
    /**
    * 서랍 제스처 시작 — 닫혀 있으면 대화 화면에서 왼쪽으로 밀어 열고, 열려 있으면 서랍 · 딤에서 오른쪽으로 밀어 닫는다.
    * 표 · 코드 블록처럼 가로로 스크롤되는 곳에서 시작하면 그 스크롤에 양보한다.
    */
    drawerTouchStart(e, drawer) {
      if (!(this.isPageMode && drawer) || e.touches.length !== 1) {
        return;
      }
      if (!this.historyDrawerOpen && isInHorizontalScroller(e.target, e.currentTarget)) {
        return;
      }
      const t = e.touches[0];
      this.drawerGesture = {
        open: this.historyDrawerOpen,
        width: drawer.offsetWidth,
        startX: t.clientX,
        startY: t.clientY,
        axis: null,
        lastX: t.clientX,
        lastT: e.timeStamp,
        velocity: 0
      };
    },
    drawerTouchMove(e) {
      const g = this.drawerGesture;
      if (!g || e.touches.length !== 1) {
        return;
      }
      const t = e.touches[0];
      const dx = t.clientX - g.startX;
      if (g.axis === null) {
        g.axis = lockDrawerAxis(dx, t.clientY - g.startY, g.open);
      }
      if (g.axis !== "swipe") {
        if (g.axis === "scroll") {
          this.drawerGesture = null;
        }
        return;
      }
      if (e.cancelable) {
        e.preventDefault();
      }
      const dt = e.timeStamp - g.lastT;
      if (dt > 0) {
        g.velocity = (t.clientX - g.lastX) / dt;
      }
      g.lastX = t.clientX;
      g.lastT = e.timeStamp;
      this.historyDrawerDrag = drawerOffset({
        dx,
        width: g.width,
        open: g.open
      });
    },
    drawerTouchEnd() {
      const g = this.drawerGesture;
      const offset = this.historyDrawerDrag;
      this.drawerGesture = null;
      this.historyDrawerDrag = null;
      if (!g || g.axis !== "swipe" || offset === null) {
        return;
      }
      const stayOpen = shouldDrawerStayOpen({
        offset,
        width: g.width,
        velocity: g.velocity
      });
      if (stayOpen && !g.open) {
        this.openHistory();
      } else if (!stayOpen && g.open) {
        this.closeHistoryDrawer();
      }
    },
    /** 새 대화 시작 — 실제 생성은 첫 전송 시(ensureConversation) */
    newConversation() {
      if (this.isSending) {
        return;
      }
      this.subscription?.unsubscribe();
      this.subscription = null;
      this.conversationId = null;
      this.messages = [];
      this.view = "chat";
      this.guidanceStartExpanded = false;
      this.closeHistoryDrawer();
    },
    close() {
      this.navigation?.cancelPending();
      this.isOpen = false;
    },
    /**
    * 도크를 접어 **원래의 플로팅 버튼(FAB)으로 되돌린다.** 도크 헤더의 X 가 이걸 부른다.
    *
    * 이름이 `close` 가 아닌 이유가 동작의 전부다 — 대화를 끝내는 게 아니라 **표시 방식만**
    * 되돌린다. 대화는 같은 Alpine 인스턴스에 그대로 남아 있어서, FAB 을 다시 누르면
    * 하던 대화가 이어진다.
    */
    undock() {
      this.navigation?.cancelPending();
      this.isOpen = false;
      this.applyDockLayout();
    },
    async ensureConversation() {
      if (this.conversationId) {
        return this.conversationId;
      }
      const sdk = herebyStore(this).sdk;
      const { id } = await sdk.ai.createConversation({
        app: opts.app
      });
      this.conversationId = id;
      this.subscribe(id);
      return id;
    },
    subscribe(conversationId) {
      const sdk = herebyStore(this).sdk;
      this.subscription?.unsubscribe();
      this.subscription = sdk.ai.subscribeToStream(conversationId, (event) => this.handleStreamEvent(conversationId, event));
    },
    /** 스트림 이벤트 한 건 — 구독 콜백에서 떼어 둔 것은 테스트가 이벤트를 직접 넣기 위해서다 */
    handleStreamEvent(conversationId, event) {
      if (event.type === "delta") {
        this.streamText += event.text;
        this.scrollToBottom();
      } else if (event.type === "thinking") {
        this.thinkingText += event.text;
        this.scrollToBottom();
      } else if (event.type === "tool_start") {
        this.activeTool = event.name;
        this.activeToolLabel = event.label ?? event.name;
        this.scrollToBottom();
      } else if (event.type === "tool_end") {
        this.toolLog.push({
          name: event.name,
          label: event.label ?? event.name,
          ok: event.ok
        });
        this.activeTool = null;
        this.activeToolLabel = null;
      } else if (event.type === "status") {
        this.pendingStage = event.stage;
        if (event.stage === "iteration") {
          this.pendingIteration = event.iteration;
          this.pendingStageLabel = null;
        } else if (event.stage === "tool_planned") {
          this.pendingStageLabel = event.label;
        }
      } else if (event.type === "done") {
        this.streamDone = {
          conversationId,
          messageId: event.messageId,
          content: event.content,
          guidance: event.guidance,
          createdAt: event.createdAt,
          latencyMs: event.latencyMs
        };
      }
    },
    /** 전송 뒤에 저장된 어시스턴트 답변이 있는지 history 로 확인한다 — 스트림이 끊긴 경우의 예비 경로 */
    async findSavedAnswer(conversationId, startedAt) {
      try {
        const history = await herebyStore(this).sdk.ai.history({
          conversationId
        });
        const answer = [
          ...history
        ].reverse().find((m) => m.role === AiMessageRole.ASSISTANT && m.status !== AiMessageStatus.ERROR && new Date(m.createdAt).getTime() >= startedAt - 1e3);
        return answer ? {
          messageId: answer.id,
          content: answer.content,
          guidance: answer.guidance ?? null,
          createdAt: answer.createdAt ?? null,
          latencyMs: answer.latencyMs ?? null
        } : null;
      } catch {
        return null;
      }
    },
    /**
    * HTTP 응답이 실패한 뒤 스트림 `done` 으로 턴을 마무리한다. 이미 도착했으면 즉시, 아니면
    * 상한까지 기다린다. 성공하면 답변 말풍선을 넣고 true — 토큰·모듈·변경 세트는 history 로 채운다
    * (`done` 에는 사용량·변경 세트가 없다). 재조회가 실패해도 확보한 안내·시간 정보는 유지한다.
    */
    async finishTurnFromStream(conversationId, startedAt) {
      const grace = opts.streamRecoveryGraceMs ?? STREAM_RECOVERY_GRACE_MS;
      this.pendingStage = "finalizing";
      const matches = /* @__PURE__ */ __name(() => this.streamDone !== null && this.streamDone.conversationId === conversationId, "matches");
      const pollEveryMs = opts.streamRecoveryPollMs ?? STREAM_RECOVERY_POLL_MS;
      let lastPoll = Date.now();
      let fromHistory = null;
      while (!(matches() || fromHistory) && Date.now() - startedAt < grace) {
        await new Promise((resolve2) => setTimeout(resolve2, 250));
        if (Date.now() - lastPoll >= pollEveryMs) {
          lastPoll = Date.now();
          fromHistory = await this.findSavedAnswer(conversationId, startedAt);
        }
      }
      const done = matches() ? this.streamDone : fromHistory;
      if (!done) {
        return false;
      }
      let view = {
        id: done.messageId,
        role: "assistant",
        content: done.content,
        guidance: done.guidance ?? null,
        createdAt: done.createdAt ?? null,
        latencyMs: done.latencyMs ?? null,
        feedback: null
      };
      try {
        const history = await herebyStore(this).sdk.ai.history({
          conversationId
        });
        const row = history.find((m) => m.id === done.messageId);
        if (row) {
          view = {
            ...view,
            content: row.content || done.content,
            guidance: row.guidance ?? null,
            createdAt: row.createdAt ?? view.createdAt,
            latencyMs: row.latencyMs ?? view.latencyMs,
            tokens: row.tokens ?? null,
            module: row.module ?? null,
            promptVersion: row.promptVersion ?? null,
            changeSets: (row.changeSets ?? []).map(toChangeSetView)
          };
        }
      } catch {
      }
      this.messages.push(view);
      this.limitMessage = null;
      return true;
    },
    /**
    * 전송 진입점 하나 — 키보드 Enter 와 「전송」 버튼이 같이 쓴다.
    * 리포트 모드면 대화가 아니라 신고 접수로 갈라진다.
    */
    /** 휴대폰(손가락 입력)인가 — Enter 판정과 키보드 Enter 키 모양(`enterkeyhint`)이 본다(메신저와 같은 규칙). */
    get composerCoarsePointer() {
      return isCoarsePointer();
    },
    onEnter(event) {
      if (event) {
        if (!shouldSendOnEnter({
          isComposing: event.isComposing,
          shiftKey: event.shiftKey,
          coarsePointer: this.composerCoarsePointer
        })) {
          return;
        }
        event.preventDefault();
      }
      this.send();
    },
    /**
    * 입력칸 자동 높이 — 내용 높이만큼 늘리고, 최대 높이(DS CSS `max-height`)를 넘으면 안에서
    * 스크롤한다. 전송 뒤에는 비운 값 기준으로 다시 재어 한 줄로 돌아온다. `rows="1"` 이
    * 바닥이라 `height:auto` 로 잠깐 되돌려야 줄어드는 쪽도 맞게 잰다.
    */
    autosizeComposer(el2) {
      const field = el2 instanceof HTMLTextAreaElement ? el2 : this.$refs?.composer;
      if (!(field instanceof HTMLTextAreaElement)) {
        return;
      }
      field.style.height = "auto";
      field.style.height = `${field.scrollHeight}px`;
    },
    formatDuration: formatAiDuration,
    /** 메시지 시각(조직 타임존 HH:mm) — 메신저 `messageTime` 과 같은 표기(MED-883) */
    messageTime(createdAt) {
      if (!createdAt) {
        return "";
      }
      const d = new Date(createdAt);
      return Number.isNaN(d.getTime()) ? "" : herebyStore(this).formatTime(d);
    },
    /**
    * 날짜 구분선 라벨 — 앞 메시지와 날이 다를 때만 「오늘」·「어제」·「10월 2일」(다른 해면 연도 포함).
    * 메신저 `messageDateLabel` 과 같은 규칙. 히스토리로 예전 대화를 열면 언제 주고받았는지가
    * 이 줄로 읽힌다.
    */
    messageDateLabel(createdAt, index) {
      if (!createdAt) {
        return "";
      }
      const current2 = new Date(createdAt);
      if (Number.isNaN(current2.getTime())) {
        return "";
      }
      const store = herebyStore(this);
      const currentDay = store.formatDateISO(current2);
      const prev = index > 0 ? this.messages[index - 1]?.createdAt : null;
      if (prev) {
        const prevDate = new Date(prev);
        if (!Number.isNaN(prevDate.getTime()) && store.formatDateISO(prevDate) === currentDay) {
          return "";
        }
      }
      const today = store.todayLocal();
      if (currentDay === today) {
        return "\uC624\uB298";
      }
      if (currentDay === store.formatDateISO(new Date(Date.now() - 864e5))) {
        return "\uC5B4\uC81C";
      }
      const sameYear = currentDay.slice(0, 4) === today.slice(0, 4);
      return store.formatDateCustom(current2, {
        ...sameYear ? {} : {
          year: "numeric"
        },
        month: "long",
        day: "numeric"
      });
    },
    /**
    * 입력줄 붙여넣기 — 표(TSV·HTML table)나 긴 텍스트면 입력줄에 풀지 않고 첨부 칩으로 받는다.
    * 한 줄 `<input>` 은 탭·줄바꿈을 뭉개므로(운영 대화 048091a4… 의 「8월 간호부 수당」 표가 한 줄로 들어갔다)
    * 가로채는 것이 유일한 길이다. 짧은 한 줄은 그대로 둔다(preventDefault 안 함).
    */
    onComposerPaste(event) {
      const data = event.clipboardData;
      if (!data) {
        return;
      }
      const text = data.getData("text/plain") ?? "";
      const html = data.getData("text/html") || void 0;
      const context = opts.getPasteContext?.(text) ?? null;
      const attachment = attachmentFromClipboard({
        text,
        html
      }, context);
      if (!attachment) {
        return;
      }
      event.preventDefault();
      this.attachment = attachment;
    },
    removeAttachment() {
      this.attachment = null;
    },
    get attachmentLabel() {
      return this.attachment ? describeAttachment(this.attachment) : "";
    },
    /** 칩 아래 미리보기 — 표는 앞 3행, 텍스트는 앞 160자 */
    get attachmentPreview() {
      const a = this.attachment;
      if (!a) {
        return [];
      }
      if (a.kind === "text") {
        return [
          [
            `${a.text.slice(0, 160)}${a.text.length > 160 ? "\u2026" : ""}`
          ]
        ];
      }
      const head = a.columns ? [
        a.columns
      ] : [];
      return [
        ...head,
        ...a.rows.slice(0, 3)
      ];
    },
    /** 저장된 사용자 메시지(입력 + 첨부 블록)를 말풍선용으로 가른다 */
    userMessageParts(content) {
      return splitStoredUserMessage(content);
    },
    get canSend() {
      return !this.isSending && (this.input.trim().length > 0 || this.attachment !== null);
    },
    async send() {
      const message = this.input.trim();
      const attachment = this.attachment;
      if (!(message || attachment) || this.isSending) {
        return;
      }
      const sdk = herebyStore(this).sdk;
      this.isSending = true;
      this.input = "";
      queueMicrotask(() => this.autosizeComposer());
      this.streamText = "";
      this.thinkingText = "";
      this.showThinking = false;
      this.activeTool = null;
      this.toolLog = [];
      this.streamDone = null;
      this._startPendingClock();
      this.messages.push({
        id: `local-${crypto.randomUUID()}`,
        role: "user",
        createdAt: /* @__PURE__ */ new Date(),
        content: message,
        feedback: null,
        ...attachment ? {
          attachmentLabel: describeAttachment(attachment)
        } : {}
      });
      this.attachment = null;
      this.scrollToBottom();
      const startedAt = Date.now();
      let conversationId = null;
      try {
        conversationId = await this.ensureConversation();
        const context = {
          app: opts.app,
          ...opts.getContext?.() ?? {}
        };
        const result = await sdk.ai.chat({
          conversationId,
          message,
          context,
          ...attachment ? {
            attachment
          } : {}
        });
        this.messages.push({
          id: result.messageId,
          role: "assistant",
          content: result.content,
          createdAt: result.createdAt ?? null,
          latencyMs: result.latencyMs ?? null,
          guidance: result.guidance ?? null,
          feedback: null,
          tokens: result.usage.turnTokens,
          module: result.module,
          promptVersion: result.promptVersion,
          changeSets: (result.changeSets ?? []).map(toChangeSetView)
        });
        this.usage = result.usage;
        this.limitMessage = null;
      } catch (error) {
        const serverMessage = error instanceof Error && error.message ? error.message : "";
        const isLimit = /상한/.test(serverMessage);
        if (isLimit) {
          this.limitMessage = serverMessage;
        }
        const failure = readTurnFailure(error);
        if (conversationId && shouldRecoverFromStream({
          isLimit,
          aiMessageId: failure.aiMessageId,
          errorCode: failure.errorCode
        }) && await this.finishTurnFromStream(conversationId, startedAt)) {
          return;
        }
        this.messages.push({
          id: failure.aiMessageId ?? `error-${crypto.randomUUID()}`,
          role: "assistant",
          content: isLimit ? serverMessage : FAILED_TURN_COPY,
          feedback: null,
          failed: true,
          createdAt: /* @__PURE__ */ new Date(),
          errorCode: failure.errorCode,
          requestId: failure.requestId
        });
      } finally {
        this.isSending = false;
        if (this.isPageMode ? this.historyDrawerOpen : this.historySidebarOpen) {
          this.refreshConversations();
        }
        this.streamText = "";
        this.thinkingText = "";
        this.showThinking = false;
        this.activeTool = null;
        this.toolLog = [];
        this._stopPendingClock();
        if (!this.isOpen) {
          this.hasNewAnswer = true;
        }
        this.scrollToBottom();
      }
    },
    /** 대기 시계 — 1초마다 경과 시간을 올려 라벨·안내가 갱신되게 한다 */
    _startPendingClock() {
      this.pendingStage = "idle";
      this.pendingIteration = 0;
      this.pendingStageLabel = null;
      this.activeToolLabel = null;
      this.pendingStartedAt = Date.now();
      this.pendingElapsedSec = 0;
      this._stopPendingClock();
      this.pendingTimer = setInterval(() => {
        this.pendingElapsedSec = Math.floor((Date.now() - this.pendingStartedAt) / 1e3);
      }, 1e3);
    },
    _stopPendingClock() {
      if (this.pendingTimer) {
        clearInterval(this.pendingTimer);
        this.pendingTimer = null;
      }
    },
    /** 상태 줄 문구 — pendingStatusText 의 입력을 컴포넌트 상태에서 모은다 */
    pendingStatus() {
      return pendingStatusText({
        stage: this.pendingStage,
        iteration: this.pendingIteration,
        stageLabel: this.pendingStageLabel,
        activeToolLabel: this.activeToolLabel,
        hasThinking: this.thinkingText.length > 0,
        elapsedSec: this.pendingElapsedSec
      });
    },
    /** 어시스턴트 응답(마크다운)을 x-html용 안전한 HTML로 변환 */
    md(content) {
      return renderMarkdown(content);
    },
    /* ── 사용량 표시·경고 (design-sheet-ai-features 결정 ⑫) ─────────────────────── */
    /** 답변 아래 한 줄 — "이번 답변 12.3k 토큰" */
    tokenLabel(message) {
      return message.tokens != null ? `${formatTokens(message.tokens)} \uD1A0\uD070` : "";
    },
    /** 이번 달 사용률 — 한도가 있는 축 중 높은 쪽. 한도가 없으면 null(경고 없음) */
    get usageRatio() {
      const u = this.usage;
      if (!u) {
        return null;
      }
      const month = u.monthLimit ? u.monthTokens / u.monthLimit * 100 : null;
      const module = u.moduleLimit ? u.moduleTokens / u.moduleLimit * 100 : null;
      if (month === null && module === null) {
        return null;
      }
      if (module !== null && (month === null || module >= month)) {
        return {
          pct: Math.round(module),
          scope: "module"
        };
      }
      return {
        pct: Math.round(month),
        scope: "month"
      };
    },
    /** 입력줄 위 경고 — 80% 이상이면 경고, 한도 초과 거절이 있었으면 그 문구 */
    get usageWarning() {
      if (this.limitMessage) {
        return {
          level: "danger",
          text: this.limitMessage
        };
      }
      const ratio = this.usageRatio;
      if (!ratio || ratio.pct < 80) {
        return null;
      }
      const label = ratio.scope === "module" ? "\uC2DC\uD2B8 \uC5B4\uC2DC\uC2A4\uD134\uD2B8" : "AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8";
      return {
        level: ratio.pct >= 100 ? "danger" : "warning",
        text: ratio.pct >= 100 ? `\uC774\uBC88 \uB2EC ${label} \uD1A0\uD070 \uC0C1\uD55C\uC5D0 \uB3C4\uB2EC\uD588\uC5B4\uC694. \uB2E4\uC74C \uC9C8\uBB38\uBD80\uD130 \uC774\uC6A9\uC774 \uB9C9\uD600\uC694.` : `\uC774\uBC88 \uB2EC ${label} \uD1A0\uD070\uC758 ${ratio.pct}%\uB97C \uC37C\uC5B4\uC694. \uC0C1\uD55C\uC5D0 \uB2FF\uC73C\uBA74 \uC774\uC6A9\uC774 \uB9C9\uD600\uC694.`
      };
    },
    /** 이번 달 요약 문구 — 첫 사용 안내에 붙는다 */
    get usageSummaryLabel() {
      const u = this.usage;
      if (!u) {
        return "";
      }
      const scopeTokens = opts.requireModule === "sheet" ? u.moduleTokens : u.monthTokens;
      const scopeLimit = opts.requireModule === "sheet" ? u.moduleLimit : u.monthLimit;
      return scopeLimit ? `\uC774\uBC88 \uB2EC ${formatTokens(scopeTokens)} / ${formatTokens(scopeLimit)} \uD1A0\uD070` : `\uC774\uBC88 \uB2EC ${formatTokens(scopeTokens)} \uD1A0\uD070 (\uC0C1\uD55C \uC5C6\uC74C)`;
    },
    usageNoticeKey() {
      const store = herebyStore(this);
      const user = store.currentUser ?? {};
      return `${USAGE_NOTICE_KEY}:${user.organizationId ?? "org"}:${user.id ?? "me"}`;
    },
    /** 첫 열기 때 1회 — 「다시 보지 않기」 전까지. 시트 어시스턴트와 첫 사용 문구를 넘긴 마운트만 */
    initUsageNotice() {
      if (opts.requireModule !== "sheet" && !opts.firstUseNotice) {
        return;
      }
      try {
        this.usageNoticeVisible = localStorage.getItem(this.usageNoticeKey()) !== "1";
      } catch {
        this.usageNoticeVisible = true;
      }
    },
    dismissUsageNotice() {
      this.usageNoticeVisible = false;
      try {
        localStorage.setItem(this.usageNoticeKey(), "1");
      } catch {
      }
    },
    /* ── 변경 세트 카드 (E3) — 제안은 카드로 보이고 사람이 [적용] 을 눌러야 시트에 닿는다 ── */
    changeSetKindLabel(cs) {
      return {
        cells: "\uC140 \uAC12 \uBCC0\uACBD",
        rows: "\uD589 \uCD94\uAC00",
        layout: "\uC5F4 \uAD6C\uC131 \uBCC0\uACBD",
        import: "\uC5C5\uB85C\uB4DC \uBC18\uC601"
      }[cs.kind] ?? cs.kind;
    },
    changeSetStatusLabel(cs) {
      return {
        proposed: "\uC801\uC6A9 \uB300\uAE30",
        approved: "\uC2B9\uC778\uB428",
        applied: "\uC801\uC6A9\uB428",
        rejected: "\uCDE8\uC18C\uB428",
        reverted: "\uB418\uB3CC\uB9BC"
      }[cs.status] ?? cs.status;
    },
    /** 위험 배지 문구 — 하나라도 있으면 2차 확인이 필요하다 */
    changeSetRiskLabels(cs) {
      const out = [];
      if (cs.risk.commitColumns.length > 0) {
        out.push(`\uAE09\uC5EC \uBC18\uC601 \uC5F4 ${cs.risk.commitColumns.length}\uAC1C`);
      }
      if (cs.risk.locked) {
        out.push("\uBCF4\uD638\uB41C \uC2DC\uD2B8");
      }
      if (cs.risk.resignedRows > 0) {
        out.push(`\uD1F4\uC9C1\uC790 \uD589 ${cs.risk.resignedRows}\uAC1C`);
      }
      if (cs.risk.manyRows) {
        out.push("100\uD589 \uCD08\uACFC");
      }
      if (cs.risk.structureLocked) {
        out.push("\uC124\uC815 \uB2E4\uC2DC \uC5F4\uAE30 \uD544\uC694");
      }
      if (cs.risk.removedColumns && cs.risk.removedColumns.length > 0) {
        out.push(`\uC5F4 \uC0AD\uC81C ${cs.risk.removedColumns.length}\uAC1C`);
      }
      return out;
    },
    formatCellValue(value) {
      if (value === null || value === void 0 || value === "") {
        return "(\uBE48\uCE78)";
      }
      return typeof value === "number" ? value.toLocaleString("ko-KR") : String(value);
    },
    async applyChangeSet(cs) {
      if (cs.busy || cs.status === "applied") {
        return;
      }
      if (cs.risk.requiresConfirm && !cs.confirmed) {
        cs.error = "\uC704\uD5D8 \uD56D\uBAA9\uC744 \uD655\uC778\uD588\uB2E4\uB294 \uCCB4\uD06C\uAC00 \uD544\uC694\uD574\uC694.";
        return;
      }
      cs.busy = true;
      cs.error = null;
      try {
        const sdk = herebyStore(this).sdk;
        const updated = await sdk.trpc.sheetChangeSet.execute.mutate({
          id: cs.id,
          confirmed: Boolean(cs.confirmed)
        });
        Object.assign(cs, updated, {
          busy: false
        });
        window.dispatchEvent(new CustomEvent("hereby:sheet-change-set-applied", {
          detail: {
            sheetViewId: cs.sheetViewId,
            changeSetId: cs.id,
            kind: cs.kind
          }
        }));
      } catch (error) {
        cs.error = error instanceof Error && error.message ? error.message : "\uC801\uC6A9\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694.";
      } finally {
        cs.busy = false;
      }
    },
    async rejectChangeSet(cs) {
      if (cs.busy || cs.status !== "proposed") {
        return;
      }
      cs.busy = true;
      try {
        const sdk = herebyStore(this).sdk;
        const updated = await sdk.trpc.sheetChangeSet.reject.mutate({
          id: cs.id
        });
        Object.assign(cs, updated, {
          busy: false
        });
      } catch (error) {
        cs.error = error instanceof Error && error.message ? error.message : "\uCDE8\uC18C\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694.";
      } finally {
        cs.busy = false;
      }
    },
    async revertChangeSet(cs) {
      if (cs.busy || cs.status !== "applied") {
        return;
      }
      cs.busy = true;
      cs.error = null;
      try {
        const sdk = herebyStore(this).sdk;
        const updated = await sdk.trpc.sheetChangeSet.revert.mutate({
          id: cs.id
        });
        Object.assign(cs, updated, {
          busy: false
        });
        window.dispatchEvent(new CustomEvent("hereby:sheet-change-set-applied", {
          detail: {
            sheetViewId: cs.sheetViewId,
            changeSetId: cs.id,
            kind: cs.kind,
            reverted: true
          }
        }));
      } catch (error) {
        cs.error = error instanceof Error && error.message ? error.message : "\uB418\uB3CC\uB9AC\uC9C0 \uBABB\uD588\uC5B4\uC694.";
      } finally {
        cs.busy = false;
      }
    },
    /**
    * 신고 본문에 인용할 질문·답변(MED-882). 질문은 그 답변 **바로 앞** 사용자 메시지에서 첨부 블록을
    * 뗀 글. 직원 앱 대화는 콘솔(AI 모니터링)도 본문을 가리는 정책이라 인용하지 않는다 — 신고
    * 티켓이 운영 채널로 흘러가면 그 정책이 뚫린다.
    */
    _reportQuote(message) {
      if (opts.app === "employee-app") {
        return {
          question: null,
          answer: null
        };
      }
      const list = this.messages;
      const idx = list.findIndex((m) => m.id === message.id);
      let question = null;
      for (let i = (idx >= 0 ? idx : list.length) - 1; i >= 0; i--) {
        if (list[i].role === "user") {
          question = splitStoredUserMessage(list[i].content).text || null;
          break;
        }
      }
      const answer = message.role === "assistant" && !message.failed ? message.content : null;
      return {
        question,
        answer
      };
    },
    /** 카드의 「문제 신고」 — 답변 신고와 같은 경로에 changeSetId 를 더한다 */
    reportChangeSet(message, cs) {
      if (!this.conversationId) {
        return;
      }
      window.dispatchEvent(new CustomEvent("hereby:cs-report-open", {
        detail: {
          prefill: {
            type: "bug",
            title: `${this.title} \uBCC0\uACBD \uC138\uD2B8 \uBB38\uC81C`,
            description: buildAiReportDescription({
              intro: `[${this.title}] \uC81C\uC548\uB41C \uBCC0\uACBD(${cs.summary})\uC5D0 \uBB38\uC81C\uAC00 \uC788\uC5B4\uC694.`,
              ask: "\uC5B4\uB5A4 \uC810\uC774 \uC798\uBABB\uB410\uB294\uC9C0 \uC801\uC5B4 \uC8FC\uC138\uC694:",
              ...this._reportQuote(message)
            })
          },
          ai: {
            conversationId: this.conversationId,
            messageId: message.id,
            ...message.promptVersion ? {
              promptVersion: message.promptVersion
            } : {},
            ...message.module ? {
              module: message.module
            } : {},
            sheetViewId: cs.sheetViewId,
            changeSetId: cs.id
          }
        }
      }));
    },
    /**
    * 실패 말풍선의 「문제 신고」 — 「응답 생성에 실패했습니다」 를 사용자가 신고할 길이 없던 것을
    * 메운다. 서버가 실패 턴을 기록했으면 그 메시지 id 를 context.ai 로, 원인 코드·요청 ID 는
    * 오류 스냅샷으로 첨부한다(수집기의 마지막 오류가 5초 TTL 이라 여기서 다시 밀어 넣는다).
    */
    reportFailure(message) {
      if (!message.failed) {
        return;
      }
      const store = herebyStore(this);
      store.csReport?.noteError({
        message: `AI \uC751\uB2F5 \uC0DD\uC131 \uC2E4\uD328${message.errorCode ? ` (${message.errorCode})` : ""}`,
        occurredAt: (/* @__PURE__ */ new Date()).toISOString(),
        ...message.errorCode ? {
          code: message.errorCode
        } : {},
        ...message.requestId ? {
          requestId: message.requestId
        } : {}
      });
      const sheet = opts.getContext?.().sheet;
      const persisted = this.conversationId && isUuid(message.id);
      window.dispatchEvent(new CustomEvent("hereby:cs-report-open", {
        detail: {
          prefill: {
            type: "bug",
            title: `${this.title} \uC751\uB2F5 \uC0DD\uC131 \uC2E4\uD328`,
            description: buildAiReportDescription({
              intro: `[${this.title}] \uB2F5\uBCC0\uC744 \uBC1B\uC9C0 \uBABB\uD588\uC5B4\uC694.`,
              ask: "\uBB34\uC5C7\uC744 \uBB3C\uC5C8\uB294\uC9C0, \uC5B8\uC81C\uBD80\uD130 \uADF8\uB7F0\uC9C0 \uC801\uC5B4 \uC8FC\uC138\uC694:",
              question: this._reportQuote(message).question
            })
          },
          ...persisted ? {
            ai: {
              conversationId: this.conversationId,
              messageId: message.id,
              ...message.module ? {
                module: message.module
              } : {},
              ...sheet?.sheetViewId ? {
                sheetViewId: sheet.sheetViewId
              } : {}
            }
          } : {}
        }
      }));
    },
    /* ── 문제 신고 (결정 ①) — 공용 CS 리포트 모달을 열고 대화·답변 메타를 첨부한다 ── */
    reportProblem(message) {
      if (!this.conversationId || message.role !== "assistant" || message.failed) {
        return;
      }
      const sheet = opts.getContext?.().sheet;
      window.dispatchEvent(new CustomEvent("hereby:cs-report-open", {
        detail: {
          prefill: {
            type: "bug",
            title: `${this.title} \uB2F5\uBCC0 \uBB38\uC81C`,
            description: buildAiReportDescription({
              intro: `[${this.title}] \uB2F5\uBCC0\uC5D0 \uBB38\uC81C\uAC00 \uC788\uC5B4\uC694.`,
              ask: "\uC5B4\uB5A4 \uC810\uC774 \uC798\uBABB\uB410\uB294\uC9C0 \uC801\uC5B4 \uC8FC\uC138\uC694:",
              ...this._reportQuote(message)
            })
          },
          ai: {
            conversationId: this.conversationId,
            messageId: message.id,
            ...message.promptVersion ? {
              promptVersion: message.promptVersion
            } : {},
            ...message.module ? {
              module: message.module
            } : {},
            ...sheet?.sheetViewId ? {
              sheetViewId: sheet.sheetViewId
            } : {}
          }
        }
      }));
    },
    /** 방금 복사한 메시지 id — 버튼이 잠깐 「복사됨」 으로 바뀐다 */
    copiedId: null,
    /**
    * 메시지 복사(CS-OKBEST-260923-0004) — 마크다운 원문을 평문으로 클립보드에 쓴다.
    * 클립보드 API 가 막힌 환경(http · 권한 거부)은 숨은 textarea + execCommand 로 폴백한다.
    */
    async copyMessage(message) {
      const text = message.content ?? "";
      if (!text) {
        return;
      }
      const ok = await writeClipboardText(text);
      if (!ok) {
        return;
      }
      this.copiedId = message.id;
      window.setTimeout(() => {
        if (this.copiedId === message.id) {
          this.copiedId = null;
        }
      }, 1500);
    },
    /** 응답별 👍/👎 피드백 (설계 §8-2) — 응답당 1회만, 변경 불가. 2026-09-23 마크업 복원(AI 모니터링이 집계) */
    async rate(message, rating) {
      if (message.role !== "assistant" || message.failed || message.id.startsWith("local-")) {
        return;
      }
      if (message.feedback) {
        return;
      }
      const value = rating === "up" ? AiFeedbackRating.UP : AiFeedbackRating.DOWN;
      const sdk = herebyStore(this).sdk;
      try {
        await sdk.ai.feedback({
          messageId: message.id,
          rating: value
        });
        message.feedback = {
          rating: value
        };
      } catch {
      }
    },
    scrollToBottom() {
      const self = this;
      self.$nextTick?.(() => {
        const el2 = self.$refs?.aiMessages;
        if (el2) {
          el2.scrollTop = el2.scrollHeight;
        }
      });
    }
  };
}
__name(aiAssistantComponent, "aiAssistantComponent");

// src/components/AppHeader.ts
function resolveFlag(value) {
  return typeof value === "function" ? value() : value;
}
__name(resolveFlag, "resolveFlag");
function appHeaderComponent(opts = {}) {
  const getLeading = opts.getLeading;
  const getLeadingAccent = opts.getLeadingAccent;
  const getLeadingAccentAfter = opts.getLeadingAccentAfter;
  const onBack = opts.onBack;
  const showBack = opts.showBack ?? true;
  const backLabel = opts.backLabel ?? "\uB4A4\uB85C";
  const solid = opts.solid ?? false;
  const divider = opts.divider ?? false;
  const collapseOnScroll = opts.collapseOnScroll ?? false;
  const showBell = opts.showBell ?? false;
  const onBellClick = opts.onBellClick;
  const showAvatar = opts.showAvatar ?? false;
  const getAvatarImage = opts.getAvatarImage;
  const getAvatarInitial = opts.getAvatarInitial;
  const onAvatarClick = opts.onAvatarClick;
  const getActions = opts.getActions;
  const getTabs = opts.getTabs;
  const getActiveTab = opts.getActiveTab;
  const onTabSelect = opts.onTabSelect;
  const getTabActions = opts.getTabActions;
  const getSearch = opts.getSearch;
  return {
    get appHeaderLeading() {
      return getLeading ? getLeading() : "";
    },
    /** 제목 앞 강조 조각(대화방 이름 등). 빈 문자열이면 렌더되지 않는다. */
    get appHeaderLeadingAccent() {
      return getLeadingAccent?.() ?? "";
    },
    /** 제목 뒤 강조 조각(인원수 등). 빈 문자열이면 렌더되지 않는다. */
    get appHeaderLeadingAccentAfter() {
      return getLeadingAccentAfter?.() ?? "";
    },
    /* ── 검색 오버레이 ── */
    get appHeaderSearch() {
      return getSearch?.() ?? null;
    },
    /** 검색 UI 를 그릴지. 이게 참이면 제목·아이콘 줄은 렌더되지 않는다. */
    get appHeaderSearchActive() {
      return Boolean(this.appHeaderSearch?.active);
    },
    /** input 은 x-model 대신 값·핸들러를 각각 물린다 — 상태 주인이 호출부이기 때문. */
    get appHeaderSearchKeyword() {
      return this.appHeaderSearch?.keyword ?? "";
    },
    get appHeaderSearchPlaceholder() {
      return this.appHeaderSearch?.placeholder ?? "";
    },
    get appHeaderSearchSubmitLabel() {
      return this.appHeaderSearch?.submitLabel ?? "\uAC80\uC0C9";
    },
    get appHeaderSearchCancelLabel() {
      return this.appHeaderSearch?.cancelLabel ?? "\uAC80\uC0C9 \uB2EB\uAE30";
    },
    appHeaderSearchInput(keyword) {
      this.appHeaderSearch?.onInput(keyword);
    },
    appHeaderSearchSubmit() {
      this.appHeaderSearch?.onSubmit();
    },
    appHeaderSearchCancel() {
      this.appHeaderSearch?.onCancel();
    },
    /** onBack이 있으면 2depth — 백버튼 렌더 + 제목 강조. showBack이 false면 그 화면만 1depth. */
    get appHeaderShowBack() {
      return Boolean(onBack) && resolveFlag(showBack);
    },
    /** depth · 배경 · 구분선 modifier를 합친다(서로 독립). */
    get appHeaderRootClass() {
      const isSolid = resolveFlag(solid);
      const hasDivider = resolveFlag(divider);
      const cls = [];
      if (this.appHeaderShowBack) {
        cls.push("ds-app-header--depth2");
      }
      if (isSolid) {
        cls.push("ds-app-header--solid");
      }
      if (hasDivider) {
        cls.push("ds-app-header--divider");
      }
      if ((isSolid || hasDivider) && !this.appHeaderHasTabs) {
        cls.push("ds-app-header--pad-bottom");
      }
      if (resolveFlag(collapseOnScroll) && this.appHeaderHasTabs && !this.appHeaderSearchActive) {
        cls.push("ds-app-header--collapsible");
      }
      return cls.join(" ");
    },
    get appHeaderBackLabel() {
      return backLabel;
    },
    get appHeaderBackSvg() {
      return getIcon("ic-chevron-left");
    },
    appHeaderBack() {
      onBack?.();
    },
    get appHeaderShowBell() {
      return resolveFlag(showBell);
    },
    /** onBellClick을 받았는가 — 참이면 드롭다운 대신 앱 핸들러를 부르는 벨을 그린다. */
    get appHeaderBellIsLink() {
      return Boolean(onBellClick);
    },
    appHeaderBellClick() {
      onBellClick?.();
    },
    get appHeaderShowAvatar() {
      return resolveFlag(showAvatar);
    },
    get appHeaderActions() {
      const actions2 = getActions ? getActions() : [];
      return actions2.filter((action) => !action.hidden?.());
    },
    appHeaderActionSvg(action) {
      if (action.iconSvg) {
        return action.iconSvg;
      }
      return action.icon ? getIcon(action.icon) : "";
    },
    appHeaderRunAction(action) {
      action.onClick?.();
    },
    /** Image URL to render, or "" to fall back to the initial. */
    get appHeaderAvatarImage() {
      if (getAvatarImage) {
        return getAvatarImage() ?? "";
      }
      return herebyStore(this).currentUserProfilePictureUrl;
    },
    get appHeaderAvatarInitial() {
      if (getAvatarInitial) {
        return getAvatarInitial();
      }
      const name = herebyStore(this).currentUser?.name;
      return typeof name === "string" ? name.charAt(0) : "";
    },
    /** 이미지 404 시 이니셜로 폴백 (PageHeader와 동일 처리). */
    appHeaderAvatarError() {
      if (getAvatarImage) {
        return;
      }
      herebyStore(this).currentUserProfilePictureUrl = "";
    },
    appHeaderAvatarClick() {
      onAvatarClick?.();
    },
    /* ── 탭 줄 ─────────────────────────────────────────────────────────
    탭 아이템은 DS 탭 스타일(.ds-tab-item)을 그대로 재사용한다.
    ⚠️ 활성 클래스는 `tab-active`다 — `is-active`가 아니다(TabNav와 동일 규칙). */
    get appHeaderTabs() {
      return getTabs ? getTabs() : [];
    },
    get appHeaderHasTabs() {
      return this.appHeaderTabs.length > 0;
    },
    get appHeaderTabActions() {
      const actions2 = getTabActions ? getTabActions() : [];
      return actions2.filter((action) => !action.hidden?.());
    },
    get appHeaderActiveTab() {
      return getActiveTab ? getActiveTab() : "";
    },
    appHeaderTabIsActive(id) {
      return this.appHeaderActiveTab === id;
    },
    appHeaderTabClass(tab) {
      return this.appHeaderTabIsActive(tab.id) ? "tab-active" : "";
    },
    appHeaderTabHasBadge(tab) {
      return tab.badge !== void 0 && tab.badge !== null && `${tab.badge}` !== "";
    },
    appHeaderTabSelect(tab) {
      if (tab.disabled) {
        return;
      }
      onTabSelect?.(tab.id);
    }
  };
}
__name(appHeaderComponent, "appHeaderComponent");

// src/components/ApprovalSteps.ts
import { approvalOutcomeFromSteps, approvalStepReadText, approvalStepReplaceable, approvalStepStatusView } from "@hereby/core/constants";
var OUTCOME_VIEW = {
  approved: {
    label: "\uCD5C\uC885 \uC2B9\uC778",
    tone: "green"
  },
  rejected: {
    label: "\uBC18\uB824",
    tone: "red"
  }
};
function approvalStepsComponent(opts = {}) {
  const getState = opts.getState;
  const getLoading = opts.getLoading;
  const viewerId = opts.viewerId;
  const size = opts.size ?? "md";
  const labelSize = opts.labelSize ?? "sm";
  const onReplace = opts.onReplace;
  return {
    apsCompact: opts.compact === true,
    apsHideTitle: opts.hideTitle === true,
    get apsRootClass() {
      const cls = [];
      if (size === "lg") {
        cls.push("ds-approval-steps--lg");
      }
      if (this.apsCompact) {
        cls.push("ds-approval-steps--compact");
      }
      return cls.join(" ");
    },
    get apsLabelClass() {
      return `ds-label ds-label--${labelSize} ds-label--square`;
    },
    get apsState() {
      return getState ? getState() ?? null : null;
    },
    get apsLoading() {
      return getLoading ? getLoading() : false;
    },
    get apsSteps() {
      const steps = this.apsState?.steps ?? [];
      return [
        ...steps
      ].sort((a, b) => a.stepOrder - b.stepOrder);
    },
    /** 단계 줄이 없는 예전 신청(= 승인 권한자 누구나 처리) */
    get apsIsLegacy() {
      const state3 = this.apsState;
      return !!state3 && (state3.isLegacy || state3.steps.length === 0);
    },
    /** 데이터 자체가 없음(로딩 아님) */
    get apsEmpty() {
      return !(this.apsLoading || this.apsState);
    },
    get apsTotal() {
      return this.apsSteps.length;
    },
    get apsViewerId() {
      return (typeof viewerId === "function" ? viewerId() : viewerId) ?? null;
    },
    get apsOutcome() {
      return approvalOutcomeFromSteps(this.apsSteps);
    },
    get apsOutcomeLabel() {
      const outcome = this.apsOutcome;
      return outcome ? OUTCOME_VIEW[outcome].label : "";
    },
    get apsOutcomeClass() {
      const outcome = this.apsOutcome;
      return outcome ? `${this.apsLabelClass} ds-label--${OUTCOME_VIEW[outcome].tone}` : "";
    },
    get apsTitle() {
      return this.apsIsLegacy ? "\uACB0\uC7AC\uC120" : `\uACB0\uC7AC\uC120 \xB7 ${this.apsTotal}\uB2E8\uACC4`;
    },
    /** 목록 칸용 한 줄 — 「1/2단계 · 이채원 님 확인 중」 · 「2/2 완료」 · 「반려됨」 · 「결재자 지정 없음」 */
    get apsCompactLine() {
      if (this.apsIsLegacy) {
        return "\uACB0\uC7AC\uC790 \uC9C0\uC815 \uC5C6\uC74C";
      }
      const current2 = this.apsSteps.find((s) => s.status === "pending");
      if (current2) {
        const read = current2.viewedAt === void 0 ? "" : current2.viewedAt ? " \xB7 \uD655\uC778\uD568" : " \xB7 \uC544\uC9C1 \uD655\uC778 \uC804";
        return `${current2.stepOrder}/${this.apsTotal}\uB2E8\uACC4 \xB7 ${current2.approverName} \uB2D8 \uD655\uC778 \uC911${read}`;
      }
      const outcome = this.apsOutcome;
      if (outcome === "approved") {
        return `${this.apsTotal}/${this.apsTotal} \uC644\uB8CC`;
      }
      return outcome === "rejected" ? "\uBC18\uB824\uB428" : "";
    },
    apsItemClass(step) {
      return `is-${step.status}`;
    },
    apsIsMe(step) {
      const me = this.apsViewerId;
      return !!me && step.approverId === me;
    },
    apsStatusLabel(step) {
      return approvalStepStatusView(step.status).label;
    },
    apsStatusClass(step) {
      return `${this.apsLabelClass} ds-label--${approvalStepStatusView(step.status).tone}`;
    },
    apsRoleText(step) {
      return step.approverTitle ? `\xB7 ${step.approverTitle}` : "";
    },
    /** 상태 칩 옆 설명 — 처리됐으면 시각(+ 대신 처리), 확인 중이면 「지금 이분 차례예요」 */
    apsDecidedText(step) {
      if (step.status === "approved" || step.status === "rejected") {
        const parts = [];
        if (step.decidedAt) {
          parts.push(this.apsFormatDateTime(step.decidedAt));
        }
        if (step.decidedByName) {
          parts.push(`${step.decidedByName} \uB2D8\uC774 \uB300\uC2E0 \uCC98\uB9AC`);
        }
        return parts.join(" \xB7 ");
      }
      if (step.status === "pending") {
        return "\uC9C0\uAE08 \uC774\uBD84 \uCC28\uB840\uC608\uC694";
      }
      return "";
    },
    /** 결재자 확인(열람) 줄(MED-964) — 「알림 보냄 · 10. 08. 09:00 · 아직 확인 전」 / 「확인함 · 10. 08. 10:30」 */
    apsReadText(step) {
      return approvalStepReadText(step, (v) => this.apsFormatDateTime(v));
    },
    /** 아직 확인 전인 차례 단계 — 줄을 주의 색으로 */
    apsUnread(step) {
      return step.status === "pending" && step.viewedAt === null;
    },
    apsReasonText(step) {
      return step.reason ? `\uC0AC\uC720: ${step.reason}` : "";
    },
    /** 「바꾸기」 버튼 — 호스트가 열어 주고(onReplace) · 서버가 허락했고(canReplace) · 아직 처리되지 않은 단계 */
    apsCanReplace(step) {
      return !!onReplace && this.apsState?.canReplace === true && approvalStepReplaceable(step.status);
    },
    apsReplace(step) {
      if (this.apsCanReplace(step)) {
        onReplace?.(step);
      }
    },
    /** 바뀐 단계의 이력 한 줄 — 「최급여 님에서 바뀜 · 김관리 님 · 2026. 10. 07. 15:10」. 안 바뀐 단계는 빈 문자열 */
    apsReplacedText(step) {
      if (!step.replacedFromName) {
        return "";
      }
      const parts = [
        `${step.replacedFromName} \uB2D8\uC5D0\uC11C \uBC14\uB01C`
      ];
      if (step.replacedByName) {
        parts.push(`${step.replacedByName} \uB2D8`);
      }
      if (step.replacedAt) {
        parts.push(this.apsFormatDateTime(step.replacedAt));
      }
      return parts.join(" \xB7 ");
    },
    /** 조직 시간대 포맷(스토어) — 스토어가 없는 환경(테스트)에서는 ISO 앞부분 */
    apsFormatDateTime(value) {
      try {
        return herebyStore(this).formatDateTime(value);
      } catch {
        const iso = value instanceof Date ? value.toISOString() : String(value);
        return iso.slice(0, 16).replace("T", " ");
      }
    }
  };
}
__name(approvalStepsComponent, "approvalStepsComponent");

// src/components/AuthGate.ts
function authGateComponent() {
  return {
    mode: "login",
    get ready() {
      return !herebyStore(this).isLoading;
    },
    get authenticated() {
      return herebyStore(this).authenticated;
    },
    switchToLogin() {
      this.mode = "login";
    },
    switchToRegister() {
      this.mode = "register";
    }
  };
}
__name(authGateComponent, "authGateComponent");

// src/components/BottomNav.ts
var ITEM_SELECTOR = ".ds-bottom-nav__item";
var ITEM_BODY_SELECTOR = ".ds-bottom-nav__item-body";
var GLOW_SELECTOR = ".ds-bottom-nav__glow";
var POP_FALLBACK_MS = 600;
function bottomNavComponent(opts = {}) {
  const getItems = opts.getItems;
  const getActive = opts.getActive;
  const onSelect = opts.onSelect;
  const badgeMax = opts.badgeMax ?? 99;
  const getAction = opts.getAction;
  const onAction = opts.onAction;
  let tabsEl = null;
  let glowEl = null;
  let observer = null;
  let frame = 0;
  let dragId = null;
  let dragRects = [];
  let clickGuard = false;
  let popTimer = 0;
  return {
    /** 지금 손가락이 닿아 있는 탭 id — `.is-pressing`(눌림 0.96). 끌면 손가락 아래 탭으로 옮겨 간다. */
    bottomNavPressId: null,
    /** 방금 선택되어 아이콘이 튕기는 중인 탭 id — `.is-pop`. animationend(또는 폴백 타이머)에 거둔다. */
    bottomNavPopId: null,
    /** 실행 버튼(원)을 누르고 있는가 — `.is-pressing`(눌림 0.96). */
    bottomNavActionPressing: false,
    /** Visible items — `hidden()` entries are dropped before render. */
    get bottomNavItems() {
      const items = getItems ? getItems() : [];
      return items.filter((item) => !item.hidden?.());
    },
    get bottomNavActiveId() {
      return getActive ? getActive() : "";
    },
    bottomNavIsActive(id) {
      return this.bottomNavActiveId === id;
    },
    /** State modifier classes for one item (.ds-bottom-nav__item). */
    bottomNavItemClass(item) {
      const cls = [];
      if (this.bottomNavIsActive(item.id)) {
        cls.push("is-active");
      }
      if (item.disabled) {
        cls.push("is-disabled");
      }
      if (this.bottomNavPressId === item.id) {
        cls.push("is-pressing");
      }
      if (this.bottomNavPopId === item.id) {
        cls.push("is-pop");
      }
      return cls.join(" ");
    },
    /**
    * 활성 항목은 activeIconSvg → activeIcon 순으로 먼저 찾고, 없으면 기본
    * 아이콘으로 폴백한다(활성 변형은 선택 사항).
    */
    bottomNavIconSvg(item) {
      if (this.bottomNavIsActive(item.id)) {
        if (item.activeIconSvg) {
          return item.activeIconSvg;
        }
        if (item.activeIcon) {
          return getIcon(item.activeIcon);
        }
      }
      if (item.iconSvg) {
        return item.iconSvg;
      }
      return item.icon ? getIcon(item.icon) : "";
    },
    /** "" when the badge should be hidden. */
    bottomNavBadgeText(item) {
      const raw = item.badge?.();
      if (raw === null || raw === void 0 || raw === "") {
        return "";
      }
      if (typeof raw === "number") {
        if (raw <= 0) {
          return "";
        }
        return raw > badgeMax ? `${badgeMax}+` : String(raw);
      }
      return String(raw);
    },
    /** 실행 버튼 — 없으면 null(템플릿이 버튼을 빼고 한 줄형으로 그린다). */
    get bottomNavAction() {
      return getAction?.() ?? null;
    },
    bottomNavActionIconSvg(action) {
      return getIcon(action.icon);
    },
    bottomNavRunAction(action) {
      onAction?.(action.id);
    },
    /**
    * 탭 선택 — 키보드(Enter · Space)와 pointer 떼기 양쪽이 여기로 온다. pointer 로 골랐으면 곧이어 오는 click 은
    * clickGuard 로 한 번 거른다(같은 탭을 두 번 고르지 않도록).
    */
    bottomNavSelect(item) {
      if (clickGuard) {
        return;
      }
      this.bottomNavChoose(item.id);
    },
    /** 선택의 실제 — 호스트에 알리고, 바뀐 탭이면 아이콘을 한 번 튕기고, 다음 틱에 유리 자리를 맞춘다. */
    bottomNavChoose(id) {
      const item = this.bottomNavItems.find((it) => it.id === id);
      if (!item || item.disabled) {
        this.bottomNavPlaceGlow();
        return;
      }
      if (!this.bottomNavIsActive(id)) {
        this.bottomNavPop(id);
      }
      onSelect?.(id);
      magics(this).$nextTick(() => this.bottomNavPlaceGlow());
    },
    bottomNavPop(id) {
      this.bottomNavPopId = null;
      requestAnimationFrame(() => {
        this.bottomNavPopId = id;
      });
      clearTimeout(popTimer);
      popTimer = window.setTimeout(() => {
        if (this.bottomNavPopId === id) {
          this.bottomNavPopId = null;
        }
      }, POP_FALLBACK_MS);
    },
    bottomNavPopEnd(item) {
      if (this.bottomNavPopId === item.id) {
        this.bottomNavPopId = null;
      }
    },
    /**
    * 캡슐(__tabs)의 x-init — 유리 DOM 을 잡고, 캡슐 크기가 바뀔 때(글자 배율 · 숨겼다 다시 보임 · 탭 수 변화로 폭 변동)
    * 유리를 **움직임 없이** 다시 놓는다. 탭을 눌러 옮기는 애니메이션은 x-effect(활성 변경) 경로가 맡는다.
    */
    bottomNavMount(el2) {
      tabsEl = el2;
      glowEl = el2.querySelector(GLOW_SELECTOR);
      if (typeof ResizeObserver === "undefined") {
        return;
      }
      observer?.disconnect();
      observer = new ResizeObserver(() => {
        if (frame) {
          return;
        }
        frame = requestAnimationFrame(() => {
          frame = 0;
          this.bottomNavPlaceGlow(void 0, false, true);
        });
      });
      observer.observe(el2);
    },
    destroy() {
      observer?.disconnect();
      observer = null;
      if (frame) {
        cancelAnimationFrame(frame);
        frame = 0;
      }
      clearTimeout(popTimer);
      tabsEl = null;
      glowEl = null;
    },
    /**
    * 선택 유리를 탭 위에 놓는다. 기본은 활성 탭 · 들림 없음 · 애니메이션(is-ready 가 붙어 있으면 CSS 전환).
    * instant = 전환 없이 바로(첫 배치 · 크기 변동 · 숨겼다 다시 보일 때 — 0 에서 날아오는 모습 방지).
    * 좌표는 offsetLeft 다 — getBoundingClientRect 는 호스트가 내비에 건 zoom 만큼 어긋난다(직원 앱 ×1.2).
    */
    bottomNavPlaceGlow(id, lift = false, instant = false) {
      const tabs = tabsEl;
      const glow = glowEl;
      if (!(tabs && glow)) {
        return;
      }
      if (tabs.offsetWidth === 0 || glow.offsetWidth === 0) {
        glow.classList.remove("is-ready");
        return;
      }
      const targetId = id ?? this.bottomNavActiveId;
      const btn = tabs.querySelector(`${ITEM_SELECTOR}[data-nav-id="${CSS.escape(targetId)}"]`);
      const body = btn?.querySelector(ITEM_BODY_SELECTOR);
      if (!(btn && body)) {
        return;
      }
      const x = btn.offsetLeft + body.offsetLeft;
      const w = body.offsetWidth;
      const animate = !instant && glow.classList.contains("is-ready");
      if (!animate) {
        glow.classList.remove("is-ready");
      }
      glow.style.setProperty("--ds-bottom-nav-glow-x", `${x}px`);
      glow.style.setProperty("--ds-bottom-nav-glow-w", `${w}px`);
      glow.classList.toggle("is-lift", lift);
      if (!animate) {
        glow.getBoundingClientRect();
        glow.classList.add("is-ready");
      }
    },
    /** 손가락이 닿음 — 그 탭이 눌리고(0.96), 유리는 **현재 활성 탭 자리에서** 부풀어 뜬다(1.08). */
    bottomNavPointerDown(event) {
      if (event.button !== 0 || !tabsEl) {
        return;
      }
      const btn = event.target?.closest(ITEM_SELECTOR);
      const id = btn?.dataset.navId;
      if (!(btn && id) || btn.hasAttribute("disabled")) {
        return;
      }
      dragRects = Array.from(tabsEl.querySelectorAll(ITEM_SELECTOR)).map((el2) => {
        const r = el2.getBoundingClientRect();
        return {
          id: el2.dataset.navId ?? "",
          left: r.left,
          right: r.right,
          disabled: el2.hasAttribute("disabled")
        };
      });
      dragId = id;
      this.bottomNavPressId = id;
      this.bottomNavPlaceGlow(this.bottomNavActiveId, true);
      try {
        tabsEl.setPointerCapture(event.pointerId);
      } catch {
      }
    },
    /** 누른 채 좌우로 끌기 — 손가락 아래 탭으로 눌림과 유리(들린 채)가 따라간다. 떼는 자리에서 선택된다. */
    bottomNavPointerMove(event) {
      if (dragId === null) {
        return;
      }
      const under = dragRects.find((r) => event.clientX >= r.left && event.clientX <= r.right);
      if (!under || under.disabled || under.id === dragId) {
        return;
      }
      dragId = under.id;
      this.bottomNavPressId = under.id;
      this.bottomNavPlaceGlow(under.id, true);
    },
    /** 손가락을 뗌 — 손가락 아래 탭을 고르고, 유리는 스프링으로 그 자리에 내려앉는다(들림 해제는 선택 경로가 한다). */
    bottomNavPointerUp(event) {
      if (dragId === null) {
        return;
      }
      const id = dragId;
      dragId = null;
      dragRects = [];
      this.bottomNavPressId = null;
      this.bottomNavPlaceGlow(id, false);
      try {
        tabsEl?.releasePointerCapture(event.pointerId);
      } catch {
      }
      clickGuard = true;
      window.setTimeout(() => {
        clickGuard = false;
      }, 0);
      this.bottomNavChoose(id);
    },
    /** 누름 취소(시스템 제스처 · 스크롤 가로채기) — 눌림을 풀고 유리를 활성 탭 자리에 내려놓는다. */
    bottomNavPointerCancel() {
      if (dragId === null) {
        return;
      }
      dragId = null;
      dragRects = [];
      this.bottomNavPressId = null;
      this.bottomNavPlaceGlow(this.bottomNavActiveId, false);
    }
  };
}
__name(bottomNavComponent, "bottomNavComponent");
function magics(ctx) {
  return ctx;
}
__name(magics, "magics");

// src/components/ChangePasswordForm.ts
import { describeUserPasswordPolicy, userPasswordPolicyError } from "@hereby/core/constants";
function changePasswordFormComponent(opts = {}) {
  return {
    title: opts.title ?? "",
    subtitle: opts.subtitle ?? "",
    newPassword: "",
    confirmPassword: "",
    showNewPassword: false,
    error: "",
    fieldErrors: {},
    isLoading: false,
    success: false,
    /** 병원 설정의 일반 비밀번호 규칙 — 로그인 응답·auth.me 가 currentUser.passwordPolicy 로 준다. */
    get passwordPolicy() {
      const user = herebyStore(this).currentUser;
      return user?.passwordPolicy ?? null;
    },
    /** 새 비밀번호 칸 안내 — 예: 「4자 이상」 / 「8자 이상, 대문자·소문자·숫자·특수문자 포함」 */
    get passwordHint() {
      return describeUserPasswordPolicy(this.passwordPolicy);
    },
    /**
    * 「비밀번호 규칙은 이후 설정에서 변경할 수 있어요」 안내를 보일지 — 규칙을 실제로 바꿀 수 있는 사람
    * (병원 설정 수정 권한 `setting:update.*` 또는 시스템 관리자)만. 콘솔이 만든 병원 관리자가 첫 로그인 때
    * 기본 규칙을 보고 「이게 고정인가」 하지 않게. 일반 직원에겐 바꿀 수 없는 설정이라 숨긴다.
    */
    get canChangePasswordRule() {
      const user = herebyStore(this).currentUser;
      return user?.isSystemAdmin === true || (user?.permissions ?? []).some((p) => p.startsWith("setting:update"));
    },
    init() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (!this.title) {
        this.title = t("auth.change_password_title");
      }
      if (!this.subtitle) {
        this.subtitle = t("auth.change_password_subtitle");
      }
    },
    validate() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      const errs = {};
      const policyError = userPasswordPolicyError(this.newPassword, this.passwordPolicy);
      if (policyError) {
        errs.newPassword = policyError;
      }
      if (this.newPassword !== this.confirmPassword) {
        errs.confirmPassword = t("auth.password_mismatch");
      }
      this.fieldErrors = errs;
      return Object.keys(errs).length === 0;
    },
    async submit() {
      if (!this.validate()) {
        return;
      }
      this.error = "";
      this.isLoading = true;
      try {
        const store = herebyStore(this);
        await store.changePassword(this.newPassword, this.confirmPassword);
        this.success = true;
        opts.onSuccess?.();
        setTimeout(() => {
          appStore(this, "router")?.navigate("/");
        }, 500);
      } catch (e) {
        const err = e;
        this.error = err.message || herebyStore(this).t("auth.change_password_failed");
      } finally {
        this.isLoading = false;
      }
    }
  };
}
__name(changePasswordFormComponent, "changePasswordFormComponent");

// src/utils/tab-attention.ts
var FRAME_MS = 500;
var FRAME_TONES = [
  "--color-primary",
  "--color-neutral-900"
];
var BUBBLE_ICON = "ic-message-fill";
var BUBBLE_VIEWBOX = "1.75 2.57 19 19";
var DOT_TOKEN = "--color-red-500";
var DOT = {
  cx: 17.5,
  cy: 5.8,
  r: 3.3,
  gap: 4.6
};
var PNG_SIZE = 64;
var MANAGED_ICON_ATTR = "data-tab-attention";
var state2 = null;
function showTabAttention(title) {
  if (typeof document === "undefined" || isEmbeddedDocument()) {
    return;
  }
  if (state2) {
    if (state2.title !== title) {
      if (document.title === state2.title) {
        document.title = title;
      }
      state2.title = title;
    }
    return;
  }
  const originalTitle = document.title;
  document.title = title;
  const frames = buildFrameHrefs();
  const detachedIcons = [];
  let managedIcon = null;
  let stopTicker = /* @__PURE__ */ __name(() => {
  }, "stopTicker");
  if (frames) {
    const icons = Array.from(document.querySelectorAll('link[rel~="icon"]'));
    for (const el2 of icons) {
      if (el2.parentNode) {
        detachedIcons.push({
          el: el2,
          parent: el2.parentNode,
          next: el2.nextSibling
        });
        el2.parentNode.removeChild(el2);
      }
    }
    managedIcon = document.createElement("link");
    managedIcon.rel = "icon";
    managedIcon.type = frames[0].startsWith("data:image/png") ? "image/png" : "image/svg+xml";
    managedIcon.setAttribute(MANAGED_ICON_ATTR, "");
    document.head.appendChild(managedIcon);
    let index = 0;
    const icon = managedIcon;
    const paint = /* @__PURE__ */ __name(() => {
      icon.href = frames[index % frames.length];
      index++;
    }, "paint");
    paint();
    stopTicker = startTicker(FRAME_MS, paint);
  }
  state2 = {
    title,
    originalTitle,
    detachedIcons,
    managedIcon,
    stopTicker
  };
}
__name(showTabAttention, "showTabAttention");
function clearTabAttention() {
  if (!state2) {
    return;
  }
  const { title, originalTitle, detachedIcons, managedIcon, stopTicker } = state2;
  state2 = null;
  stopTicker();
  managedIcon?.remove();
  for (const { el: el2, parent, next } of detachedIcons) {
    parent.insertBefore(el2, next && next.parentNode === parent ? next : null);
  }
  if (document.title === title) {
    document.title = originalTitle;
  }
}
__name(clearTabAttention, "clearTabAttention");
function buildFrameHrefs() {
  const root = getComputedStyle(document.documentElement);
  const colors = FRAME_TONES.map((token) => root.getPropertyValue(token).trim());
  const dot = root.getPropertyValue(DOT_TOKEN).trim();
  if (!dot || colors.some((color) => !color)) {
    return null;
  }
  return buildPngFrames(colors, dot) ?? buildSvgFrames(colors, dot);
}
__name(buildFrameHrefs, "buildFrameHrefs");
function buildPngFrames(colors, dot) {
  try {
    if (typeof Path2D === "undefined") {
      return null;
    }
    const doc = new DOMParser().parseFromString(getIcon(BUBBLE_ICON), "image/svg+xml");
    const shapes = Array.from(doc.querySelectorAll("path")).map((path) => ({
      d: path.getAttribute("d") || "",
      rule: path.getAttribute("fill-rule") === "evenodd" ? "evenodd" : "nonzero"
    }));
    if (shapes.length === 0 || shapes.some((shape) => !shape.d)) {
      return null;
    }
    const [x, y, size] = BUBBLE_VIEWBOX.split(" ").map(Number);
    const scale = PNG_SIZE / size;
    return colors.map((color) => {
      const canvas = document.createElement("canvas");
      canvas.width = PNG_SIZE;
      canvas.height = PNG_SIZE;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        throw new Error("no 2d context");
      }
      ctx.setTransform(scale, 0, 0, scale, -x * scale, -y * scale);
      ctx.fillStyle = color;
      for (const shape of shapes) {
        ctx.fill(new Path2D(shape.d), shape.rule);
      }
      ctx.globalCompositeOperation = "destination-out";
      ctx.beginPath();
      ctx.arc(DOT.cx, DOT.cy, DOT.gap, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalCompositeOperation = "source-over";
      ctx.fillStyle = dot;
      ctx.beginPath();
      ctx.arc(DOT.cx, DOT.cy, DOT.r, 0, Math.PI * 2);
      ctx.fill();
      return canvas.toDataURL("image/png");
    });
  } catch {
    return null;
  }
}
__name(buildPngFrames, "buildPngFrames");
function buildSvgFrames(colors, dot) {
  const bubble = getIcon(BUBBLE_ICON).replace(
    /^<svg/,
    // ds-icon-exempt: 새 그림이 아니라 레지스트리 ic-message-fill 에 파비콘 캔버스 속 크기만 덧붙인다
    '<svg width="24" height="24"'
  );
  return colors.map((color) => {
    const svg = (
      // ds-icon-exempt: 런타임에 토큰 색을 박아 만드는 파비콘 프레임(아이콘은 레지스트리 ic-message-fill)
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${BUBBLE_VIEWBOX}"><mask id="dot-gap"><rect width="24" height="24" fill="white"/><circle cx="${DOT.cx}" cy="${DOT.cy}" r="${DOT.gap}" fill="black"/></mask><g color="${color}" mask="url(#dot-gap)">${bubble}</g><circle cx="${DOT.cx}" cy="${DOT.cy}" r="${DOT.r}" fill="${dot}"/></svg>`
    );
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  });
}
__name(buildSvgFrames, "buildSvgFrames");
function startTicker(ms, onTick) {
  let intervalId = null;
  const fallback = /* @__PURE__ */ __name(() => {
    if (intervalId === null) {
      intervalId = setInterval(onTick, ms);
    }
  }, "fallback");
  let worker = null;
  let scriptUrl = "";
  try {
    scriptUrl = URL.createObjectURL(new Blob([
      `setInterval(function(){postMessage(0)},${ms});`
    ], {
      type: "text/javascript"
    }));
    worker = new Worker(scriptUrl);
    worker.onmessage = onTick;
    worker.onerror = () => {
      worker?.terminate();
      worker = null;
      fallback();
    };
  } catch {
    worker = null;
    fallback();
  }
  return () => {
    worker?.terminate();
    worker = null;
    if (scriptUrl) {
      URL.revokeObjectURL(scriptUrl);
    }
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };
}
__name(startTicker, "startTicker");

// src/utils/unread-arrivals.ts
function createUnreadArrivalTracker(startedAtMs = Date.now()) {
  let startedAt = startedAtMs;
  const known = /* @__PURE__ */ new Map();
  const pending = /* @__PURE__ */ new Set();
  return {
    observe(items) {
      let arrived = false;
      for (const item of items) {
        const count = item.unreadCount || 0;
        const previous = known.get(item.id);
        known.set(item.id, count);
        if (count <= 0) {
          pending.delete(item.id);
        } else if (previous === void 0) {
          const sentAt = item.lastMessageTime ? Date.parse(item.lastMessageTime) : Number.NaN;
          if (sentAt > startedAt) {
            pending.add(item.id);
            arrived = true;
          }
        } else if (count > previous) {
          pending.add(item.id);
          arrived = true;
        }
      }
      return {
        pending: pending.size > 0,
        arrived
      };
    },
    reset(nextStartedAtMs = Date.now()) {
      startedAt = nextStartedAtMs;
      known.clear();
      pending.clear();
    }
  };
}
__name(createUnreadArrivalTracker, "createUnreadArrivalTracker");

// src/components/Messenger.ts
init_dist();
import { decryptFile, encryptFile, fromBase64Url as fromBase64Url2, toBase64Url as toBase64Url2 } from "@hereby/core/chat-crypto";
import { applyReactionChange, DEFAULT_MESSAGE_REACTION, formatBytes, groupReactionChips, MESSAGE_REACTION_EMOJIS, messageAttachmentLimit } from "@hereby/core/constants";

// src/image-viewer-gestures.ts
var VIEWER_MIN_SCALE = 1;
var VIEWER_MAX_SCALE = 4;
var VIEWER_DOUBLE_TAP_SCALE = 2.5;
var VIEWER_SWIPE_MIN_PX = 48;
var IDENTITY = {
  scale: 1,
  tx: 0,
  ty: 0
};
function distance(a, b) {
  return Math.hypot(a.x - b.x, a.y - b.y);
}
__name(distance, "distance");
function applyPinch(start, startDistance, nowDistance, center, limits = {
  min: VIEWER_MIN_SCALE,
  max: VIEWER_MAX_SCALE
}) {
  const ratio = startDistance > 0 ? nowDistance / startDistance : 1;
  const scale = Math.min(limits.max, Math.max(limits.min, start.scale * ratio));
  const k = scale / start.scale;
  return {
    scale,
    tx: center.x - (center.x - start.tx) * k,
    ty: center.y - (center.y - start.ty) * k
  };
}
__name(applyPinch, "applyPinch");
function clampOffset(t, stage, image) {
  const w = image.width * t.scale;
  const h = image.height * t.scale;
  const maxX = Math.max(0, (w - stage.width) / 2);
  const maxY = Math.max(0, (h - stage.height) / 2);
  return {
    scale: t.scale,
    tx: Math.min(maxX, Math.max(-maxX, t.tx)) + 0,
    ty: Math.min(maxY, Math.max(-maxY, t.ty)) + 0
  };
}
__name(clampOffset, "clampOffset");
function toggleDoubleTap(t, point, scale = VIEWER_DOUBLE_TAP_SCALE) {
  if (t.scale > 1.01) {
    return {
      ...IDENTITY
    };
  }
  return {
    scale,
    tx: point.x - point.x * scale,
    ty: point.y - point.y * scale
  };
}
__name(toggleDoubleTap, "toggleDoubleTap");
function swipeDirection(dx, dy, scale, minPx = VIEWER_SWIPE_MIN_PX) {
  if (scale > 1.01 || Math.abs(dx) < minPx || Math.abs(dx) < Math.abs(dy) * 1.2) {
    return null;
  }
  return dx > 0 ? "prev" : "next";
}
__name(swipeDirection, "swipeDirection");
function attachViewerGestures(stage, h) {
  let pinchStart = null;
  let dragStart = null;
  let moved = false;
  let lastTapAt = 0;
  const stageSize = /* @__PURE__ */ __name(() => ({
    width: stage.clientWidth,
    height: stage.clientHeight
  }), "stageSize");
  const toStage = /* @__PURE__ */ __name((clientX, clientY) => {
    const r = stage.getBoundingClientRect();
    return {
      x: clientX - r.left - r.width / 2,
      y: clientY - r.top - r.height / 2
    };
  }, "toStage");
  const clamp2 = /* @__PURE__ */ __name((t) => clampOffset(t, stageSize(), h.imageSize()), "clamp");
  const onTouchStart = /* @__PURE__ */ __name((e) => {
    if (e.touches.length === 2) {
      const a = e.touches[0];
      const b = e.touches[1];
      pinchStart = {
        t: h.getTransform(),
        dist: distance({
          x: a.clientX,
          y: a.clientY
        }, {
          x: b.clientX,
          y: b.clientY
        })
      };
      dragStart = null;
      moved = true;
      return;
    }
    if (e.touches.length === 1) {
      const t = e.touches[0];
      dragStart = {
        x: t.clientX,
        y: t.clientY,
        t: h.getTransform()
      };
      moved = false;
    }
  }, "onTouchStart");
  const onTouchMove = /* @__PURE__ */ __name((e) => {
    if (pinchStart && e.touches.length === 2) {
      e.preventDefault();
      const a = e.touches[0];
      const b = e.touches[1];
      const center = toStage((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
      const dist = distance({
        x: a.clientX,
        y: a.clientY
      }, {
        x: b.clientX,
        y: b.clientY
      });
      h.setTransform(clamp2(applyPinch(pinchStart.t, pinchStart.dist, dist, center)), false);
      return;
    }
    if (dragStart && e.touches.length === 1) {
      const t = e.touches[0];
      const dx = t.clientX - dragStart.x;
      const dy = t.clientY - dragStart.y;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) {
        moved = true;
      }
      if (dragStart.t.scale > 1.01) {
        e.preventDefault();
        h.setTransform(clamp2({
          scale: dragStart.t.scale,
          tx: dragStart.t.tx + dx,
          ty: dragStart.t.ty + dy
        }), false);
      }
    }
  }, "onTouchMove");
  const onTouchEnd = /* @__PURE__ */ __name((e) => {
    if (pinchStart) {
      if (e.touches.length === 0) {
        const t = h.getTransform();
        if (t.scale <= 1.01) {
          h.setTransform({
            ...IDENTITY
          }, true);
        }
        pinchStart = null;
      }
      return;
    }
    if (!dragStart) {
      return;
    }
    const changed = e.changedTouches[0];
    const dx = changed ? changed.clientX - dragStart.x : 0;
    const dy = changed ? changed.clientY - dragStart.y : 0;
    const start = dragStart;
    dragStart = null;
    const dir = swipeDirection(dx, dy, start.t.scale);
    if (dir) {
      h.onSwipe(dir);
      return;
    }
    if (!moved) {
      const now = Date.now();
      if (now - lastTapAt < 300) {
        lastTapAt = 0;
        const p = changed ? toStage(changed.clientX, changed.clientY) : {
          x: 0,
          y: 0
        };
        h.setTransform(clamp2(toggleDoubleTap(h.getTransform(), p)), true);
      } else {
        lastTapAt = now;
        if (start.t.scale <= 1.01) {
          setTimeout(() => {
            if (lastTapAt === now) {
              lastTapAt = 0;
              h.onTap?.();
            }
          }, 300);
        }
      }
    }
  }, "onTouchEnd");
  const onWheel = /* @__PURE__ */ __name((e) => {
    if (!e.ctrlKey && Math.abs(e.deltaY) < 1) {
      return;
    }
    e.preventDefault();
    const t = h.getTransform();
    const center = toStage(e.clientX, e.clientY);
    const dist = 100;
    const next = applyPinch(t, dist, dist * (e.deltaY < 0 ? 1.1 : 0.9), center);
    h.setTransform(clamp2(next), false);
  }, "onWheel");
  const onMouseDown = /* @__PURE__ */ __name((e) => {
    if (e.button !== 0) {
      return;
    }
    dragStart = {
      x: e.clientX,
      y: e.clientY,
      t: h.getTransform()
    };
    moved = false;
  }, "onMouseDown");
  const onMouseMove = /* @__PURE__ */ __name((e) => {
    if (!dragStart || dragStart.t.scale <= 1.01) {
      return;
    }
    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) {
      moved = true;
    }
    e.preventDefault();
    h.setTransform(clamp2({
      scale: dragStart.t.scale,
      tx: dragStart.t.tx + dx,
      ty: dragStart.t.ty + dy
    }), false);
  }, "onMouseMove");
  const onMouseUp = /* @__PURE__ */ __name(() => {
    dragStart = null;
  }, "onMouseUp");
  const onDblClick = /* @__PURE__ */ __name((e) => {
    e.preventDefault();
    h.setTransform(clamp2(toggleDoubleTap(h.getTransform(), toStage(e.clientX, e.clientY))), true);
  }, "onDblClick");
  stage.addEventListener("touchstart", onTouchStart, {
    passive: true
  });
  stage.addEventListener("touchmove", onTouchMove, {
    passive: false
  });
  stage.addEventListener("touchend", onTouchEnd);
  stage.addEventListener("touchcancel", onTouchEnd);
  stage.addEventListener("wheel", onWheel, {
    passive: false
  });
  stage.addEventListener("mousedown", onMouseDown);
  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", onMouseUp);
  stage.addEventListener("dblclick", onDblClick);
  return () => {
    stage.removeEventListener("touchstart", onTouchStart);
    stage.removeEventListener("touchmove", onTouchMove);
    stage.removeEventListener("touchend", onTouchEnd);
    stage.removeEventListener("touchcancel", onTouchEnd);
    stage.removeEventListener("wheel", onWheel);
    stage.removeEventListener("mousedown", onMouseDown);
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
    stage.removeEventListener("dblclick", onDblClick);
  };
}
__name(attachViewerGestures, "attachViewerGestures");

// src/utils/image-thumbnail.ts
async function makeImageThumbnail(file, maxEdge = 512, quality = 0.8) {
  if (typeof createImageBitmap !== "function" || typeof document === "undefined") {
    return null;
  }
  let bitmap;
  try {
    bitmap = await createImageBitmap(file, {
      resizeWidth: maxEdge,
      resizeQuality: "medium"
    }).catch(() => createImageBitmap(file));
    if (bitmap.width < maxEdge && bitmap.height < maxEdge) {
      const natural = await createImageBitmap(file);
      if (natural.width <= bitmap.width) {
        bitmap.close();
        bitmap = natural;
      } else {
        natural.close();
      }
    }
  } catch {
    return null;
  }
  try {
    const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return null;
    }
    ctx.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise((resolve2) => canvas.toBlob((b) => resolve2(b), "image/jpeg", quality));
    return blob ? {
      blob,
      width,
      height
    } : null;
  } finally {
    bitmap.close();
  }
}
__name(makeImageThumbnail, "makeImageThumbnail");

// src/utils/image-encode.ts
var IMAGE_ENCODE_MAX_EDGE = 2048;
var IMAGE_ENCODE_QUALITY = 0.85;
var IMAGE_ENCODE_TIMEOUT_MS = 2e4;
var IMAGE_ENCODE_MIN_BYTES = 1024 * 1024;
function shouldEncodeImage(file) {
  const t = (file.type || "").toLowerCase();
  if (!t.startsWith("image/") || t === "image/gif" || t === "image/svg+xml") {
    return false;
  }
  return file.size >= IMAGE_ENCODE_MIN_BYTES;
}
__name(shouldEncodeImage, "shouldEncodeImage");
function withTimeout(promise, ms) {
  return new Promise((resolve2, reject) => {
    const timer = setTimeout(() => reject(new Error("image encode timeout")), ms);
    promise.then((v) => {
      clearTimeout(timer);
      resolve2(v);
    }, (e) => {
      clearTimeout(timer);
      reject(e);
    });
  });
}
__name(withTimeout, "withTimeout");
async function encodeImageForUpload(file) {
  if (!shouldEncodeImage(file)) {
    return file;
  }
  const encoded = await makeImageThumbnail(file, IMAGE_ENCODE_MAX_EDGE, IMAGE_ENCODE_QUALITY);
  if (!encoded || encoded.blob.size >= file.size) {
    return file;
  }
  const name = file.name.replace(/\.[^.]+$/, "") || "image";
  return new File([
    encoded.blob
  ], `${name}.jpg`, {
    type: "image/jpeg",
    lastModified: Date.now()
  });
}
__name(encodeImageForUpload, "encodeImageForUpload");

// src/utils/notice-labels.ts
import { NoticeCategory, NoticePriority } from "@hereby/core/enums";
var NOTICE_PRIORITY_LABEL_COLOR = {
  [NoticePriority.URGENT]: "ds-label--red",
  [NoticePriority.HIGH]: "ds-label--primary",
  // 기본값은 신호가 없어야 한다 — 흰 칩 + 테두리. `--white` 는 배경이 거의 흰색(#fdfdfd)이라
  // 테두리가 없으면 흰 카드 위에서 칩으로 안 보인다. 그래서 이 값만 --line 을 함께 준다
  // (다른 칩들이 틴트인 총무 목록에서도 이 칩만 아웃라인으로 뜬다 — 의도한 것).
  [NoticePriority.NORMAL]: "ds-label--white ds-label--line",
  [NoticePriority.LOW]: "ds-label--light-gray"
};
var NOTICE_CATEGORY_LABEL_COLOR = {
  [NoticeCategory.SAFETY]: "ds-label--yellow",
  [NoticeCategory.TRAINING_DEADLINE]: "ds-label--green",
  [NoticeCategory.POLICY]: "ds-label--blue",
  [NoticeCategory.FACILITY]: "ds-label--aqua",
  // 분류 「일반」은 gray — 중요도 「일반」이 white 를 가져갔다. 둘 다 white 면 가장 흔한 조합
  // (중요도 일반 + 분류 일반)에서 똑같은 칩 두 개가 나란히 뜬다.
  [NoticeCategory.GENERAL]: "ds-label--gray"
};
function noticePriorityLabelColor(priority) {
  return NOTICE_PRIORITY_LABEL_COLOR[priority] ?? "ds-label--gray";
}
__name(noticePriorityLabelColor, "noticePriorityLabelColor");
function noticeCategoryLabelColor(category) {
  return NOTICE_CATEGORY_LABEL_COLOR[category] ?? "ds-label--white";
}
__name(noticeCategoryLabelColor, "noticeCategoryLabelColor");
var NOTICE_PRIORITY_LABEL_KEY = {
  [NoticePriority.URGENT]: "general_affairs.priority_urgent",
  [NoticePriority.HIGH]: "general_affairs.priority_high",
  [NoticePriority.NORMAL]: "general_affairs.priority_normal",
  [NoticePriority.LOW]: "general_affairs.priority_low"
};
var NOTICE_CATEGORY_LABEL_KEY = {
  [NoticeCategory.TRAINING_DEADLINE]: "general_affairs.notice_cat_training_deadline",
  [NoticeCategory.FACILITY]: "general_affairs.notice_cat_facility",
  [NoticeCategory.SAFETY]: "general_affairs.notice_cat_safety",
  [NoticeCategory.POLICY]: "general_affairs.notice_cat_policy",
  [NoticeCategory.GENERAL]: "general_affairs.notice_cat_general"
};
function noticePriorityLabelKey(priority) {
  return NOTICE_PRIORITY_LABEL_KEY[priority] ?? NOTICE_PRIORITY_LABEL_KEY[NoticePriority.NORMAL];
}
__name(noticePriorityLabelKey, "noticePriorityLabelKey");
function noticeCategoryLabelKey(category) {
  return NOTICE_CATEGORY_LABEL_KEY[category] ?? NOTICE_CATEGORY_LABEL_KEY[NoticeCategory.GENERAL];
}
__name(noticeCategoryLabelKey, "noticeCategoryLabelKey");

// src/utils/save-blob.ts
function saveBlob(blob, filename, mime) {
  const event = new CustomEvent("hereby:save-file", {
    cancelable: true,
    detail: {
      blob,
      filename,
      mime
    }
  });
  if (!window.dispatchEvent(event)) {
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "file";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1e4);
}
__name(saveBlob, "saveBlob");

// src/components/Messenger.ts
var VIEWING_HEARTBEAT_MS = 15e3;
var ROOM_SEARCH_PAGE = 100;
var ROOM_SEARCH_LOCAL_LIMIT = 1e3;
function showToastMessage(ctx, message) {
  const toast = appStore(ctx, "toast");
  const fn = toast?.success ?? toast?.show ?? toast?.info;
  fn?.call(toast, message);
}
__name(showToastMessage, "showToastMessage");
function mapMessageItem(message, currentUserId) {
  const fallbackSenderName = message.sender ? `${message.sender.lastName || ""}${message.sender.firstName || ""}`.trim() : "\uC54C \uC218 \uC5C6\uC74C";
  const isDeleted = Boolean(message.deletedAt);
  return {
    id: message.id,
    conversationId: message.conversationId,
    senderId: message.senderId,
    senderName: message.senderNameSnapshot || message.senderName || fallbackSenderName,
    senderEmail: message.senderEmailSnapshot || message.senderEmail || void 0,
    senderProfilePicture: message.senderProfilePicture ?? message.sender?.profilePicture ?? null,
    content: isDeleted ? "" : message.content || "",
    timestamp: message.createdAt || "",
    isMine: message.senderId === currentUserId,
    type: message.type || "text",
    attachments: isDeleted ? [] : message.attachments || [],
    action: isDeleted ? null : message.action || null,
    isDeleted,
    replyTo: message.replyTo ? {
      ...message.replyTo
    } : null,
    mentions: isDeleted ? null : message.mentions || null,
    origin: message.origin || null,
    workflowPurpose: message.workflowPurpose || null,
    workflowTitle: message.workflowTitle || null,
    // 암호화 메시지는 풀기 전까지 읽을 수 없음으로 두고, decryptMessageItems 가 본문을 채운다(MED-893).
    ...isEncryptedMessage(message) && !isDeleted ? {
      isUnreadable: true,
      encrypted: {
        ciphertext: message.ciphertext,
        keyEpoch: message.keyEpoch,
        keyWrap: message.keyWrap,
        encVersion: message.encVersion ?? 1
      }
    } : {}
  };
}
__name(mapMessageItem, "mapMessageItem");
var EXPANDED_TEAMS_KEY = "hereby:expandedTeams";
function readExpandedTeams() {
  try {
    const raw = localStorage.getItem(EXPANDED_TEAMS_KEY);
    return raw ? new Set(JSON.parse(raw)) : null;
  } catch {
    return null;
  }
}
__name(readExpandedTeams, "readExpandedTeams");
function writeExpandedTeams(expanded) {
  try {
    localStorage.setItem(EXPANDED_TEAMS_KEY, JSON.stringify([
      ...expanded
    ]));
  } catch {
  }
}
__name(writeExpandedTeams, "writeExpandedTeams");
function messengerComponent(opts = {}) {
  return {
    loaded: false,
    /** 실시간 누락 보정(MED-961) — 복귀·재연결·온라인 전환이 몰려와도 서버는 한 번만 다시 읽는다. */
    resyncState: {
      inFlight: false,
      lastAt: 0
    },
    /**
    * 화면 안 브라우저 알림이 따를 휴대폰 알림 설정(2026-10-12) — 푸시 스위치·전체 알림·메신저 종류·방해 금지·표시 방식.
    * 예전에는 화면 안 알림이 이 설정을 전혀 안 봐서 「휴대폰 설정이 웹에는 안 먹는다」로 보였다. null = 아직 못 읽음(종전대로 띄움).
    */
    localNotifySettings: null,
    /** 이 페이지에 웹 푸시 구독이 있다(직원 앱 PWA) — 서비스 워커가 같은 알림을 띄우므로 화면 안 알림은 겹치지 않게 뺀다 */
    hasWebPushSubscription: false,
    // biome-ignore lint/suspicious/noExplicitAny: SDK client type
    sdk: null,
    apiBaseUrl: "",
    currentUserId: "",
    activeView: "conversations",
    /** 호스트가 상단 앱바를 제공한다 → 채팅·공지 상세의 자체 헤더 줄을 숨긴다. */
    useHostHeader: opts.hostHeader === true,
    refreshing: false,
    ptrCleanup: null,
    /** 컴포넌트 루트(init 의 $el) — 핸들러 안에서는 $el 이 그 요소라 루트를 따로 들고 있는다. */
    rootEl: null,
    init() {
      const sectionName = opts.sectionName;
      document.addEventListener("app-back-button", (e) => {
        if (sectionName) {
          if (appStore(this, "router")?.section !== sectionName) {
            return;
          }
        }
        if (hasMessengerBackLayer(this)) {
          e.preventDefault();
          this.goBack();
        }
      });
      let touchStartX = 0;
      let touchStartY = 0;
      const el2 = this.$el;
      this.rootEl = el2 ?? null;
      if (el2) {
        registerEscLayer(() => this.msgMenu.open ? el2.querySelector("[data-testid='messenger-message-menu-panel']") : null, () => this.closeMessageMenu());
        registerEscLayer(() => this.previewImageUrl ? el2.querySelector(".ds-lightbox-backdrop") : null, () => this.closeImagePreview());
        registerEscLayer(() => this.forwardPicker.open ? el2.querySelector("[data-testid='messenger-forward-picker']") : null, () => this.closeForwardPicker());
        registerEscLayer(() => this.selectCopy.open ? el2.querySelector("[data-testid='messenger-select-copy']") : null, () => this.closeSelectCopy());
        registerEscLayer(() => this.mentionPicker.open ? el2.querySelector("[data-testid='messenger-mention-picker']") : null, () => this.closeMentionPicker());
        registerEscLayer(() => this.senderMenu.open ? el2.querySelector("[data-testid='messenger-sender-menu-panel']") : null, () => this.closeSenderMenu());
        registerEscLayer(() => this.convMenu.open ? el2.querySelector("[data-testid='messenger-conv-menu-panel']") : null, () => this.closeConversationMenu());
        el2.addEventListener("touchstart", (e) => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, {
          passive: true
        });
        el2.addEventListener("touchend", (e) => {
          if (this.activeView === "conversations" || this.activeView === "contacts") {
            return;
          }
          if (this.useHostHeader) {
            return;
          }
          const touch = e.changedTouches[0];
          const dx = touch.clientX - touchStartX;
          const dy = Math.abs(touch.clientY - touchStartY);
          if (touchStartX < 40 && dx > 80 && dy < dx * 0.5) {
            this.goBack();
          }
        }, {
          passive: true
        });
      }
      document.addEventListener("visibilitychange", () => this.syncViewingPresence());
      window.addEventListener("pagehide", () => {
        this.syncViewingPresence(true);
        this.saveCurrentDraft();
      });
      this.viewingPresenceTimer = setInterval(() => this.syncViewingPresence(), 5e3);
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
          this.markViewedConversationRead();
          this.resyncFromServer();
          this.chatLockCheckPendingLinks();
        }
      });
      window.addEventListener("hereby:push-received", (e) => {
        const data = e.detail?.data;
        if (data?.chatDeviceLinkRequestId) {
          this.chatLockCheckPendingLinks();
        }
      });
      window.addEventListener("hereby:app-state", (e) => {
        const active = e.detail?.active !== false;
        this.appInBackground = !active;
        this.syncViewingPresence();
        if (active) {
          this.markViewedConversationRead();
          this.resyncFromServer();
          this.chatLockCheckPendingLinks();
        }
      });
      window.addEventListener("hereby:conversation-touched", (e) => {
        const detail = e.detail;
        if (detail?.conversationId) {
          this.bumpConversation(detail.conversationId, detail.preview ?? "");
        }
      });
      window.addEventListener(WS_REOPENED_EVENT, () => this.resyncFromServer());
      window.addEventListener("online", () => this.resyncFromServer());
      window.addEventListener("hereby:notification-settings-changed", () => this.loadLocalNotifySettings());
      window.addEventListener("hereby:ws-reconnected", () => {
        this.sdk = herebyStore(this).sdk;
        this.subscribeToConversationUpdates();
        if (this.selectedConversation) {
          this.subscribeToConversation(this.selectedConversation.id);
        }
        this.resyncFromServer();
      });
      const messengerStore = appStore(this, "messenger");
      if (messengerStore) {
        this.$watch(() => messengerStore.pendingConversationId, (id) => {
          if (id && this.loaded) {
            messengerStore.pendingConversationId = null;
            this.openConversationById(id);
          }
        });
        this.$watch(() => messengerStore.pendingNoticeId, (id) => {
          if (id && this.loaded) {
            messengerStore.pendingNoticeId = null;
            this.openNoticeById(id);
          }
        });
        alpineMagics(this).$watch(() => messengerStore.pendingDirectChat, (req) => {
          if (req && this.loaded) {
            messengerStore.pendingDirectChat = null;
            this.openDirectChatWithDraft(req);
          }
        });
        alpineMagics(this).$watch(() => messengerStore.pendingSelfChat, (on) => {
          if (on && this.loaded) {
            messengerStore.pendingSelfChat = false;
            this.openSelfChat();
          }
        });
        window.addEventListener("hereby:open-chat-lock", () => {
          if (this.loaded) {
            this.openChatLockSettings();
          } else {
            messengerStore.pendingLockSettings = true;
          }
        });
        alpineMagics(this).$watch(() => messengerStore.pendingLockSettings, (on) => {
          if (on && this.loaded) {
            messengerStore.pendingLockSettings = false;
            this.openChatLockSettings();
          }
        });
      }
    },
    contacts: [],
    /** 연락처 응답의 나 — 팀 묶음·그룹 선택·초대 후보에는 안 들어가고, 이름 검색(나와의 대화 입구)에만 쓴다.
    연락처 목록에 따로 「내 프로필」 줄은 두지 않는다 — 내 프로필은 앱 상단 아바타가 맡는다(사용자 결정 2026-10-06, MED-903) */
    myContact: null,
    conversations: [],
    channels: [],
    messages: [],
    selectedConversation: null,
    /** 네이티브 앱이 백그라운드에 있다(`hereby:app-state`) — 그동안 보던 방도 「보고 있지 않음」. */
    appInBackground: false,
    messageInput: "",
    /** 메신저 밖에서 채워 준 문구 — 손대지 않고 방을 나가면 지운다(다른 방 입력칸에 따라가지 않게). */
    prefilledDraft: "",
    searchTerm: "",
    // Conversation search
    convSearchTerm: "",
    // Message search
    msgSearchKeyword: "",
    msgSearchResults: [],
    msgSearchTotal: 0,
    showMsgSearch: false,
    /** 「내가 보낸 메시지만」 — 보낸 사람 = 나 필터. 켜면 키워드 없이도 검색된다 (MED-903) */
    msgSearchMine: false,
    /**
    * 대화방 안 검색(hostHeader · 직원 앱, 2026-10-08 — 카카오톡 대화방 검색) — 결과 목록을 펼치지 않고 대화 속 일치 메시지를
    * 하나씩 짚는다. 지금 짚은 결과의 순번(msgSearchResults 는 최신순이라 0 = 가장 최근). 아직 짚은 게 없으면 -1.
    */
    msgSearchIndex: -1,
    /** 검색을 한 번이라도 실행했나 — 아래 막대가 「결과 없음」 과 「아직 검색 전」 을 가른다. */
    msgSearchDone: false,
    /** 대화방 안 검색의 서버 페이지 — 지금까지 받은 서버 결과 수 · 서버가 알려 준 전체 수. ▲ 로 끝에 닿으면 다음 묶음을 더 받는다. */
    msgSearchServerLoaded: 0,
    msgSearchServerTotal: 0,
    msgSearchLoadingMore: false,
    // Attachments
    pendingFiles: [],
    /** 방별 임시 저장(2026-10-21) — 본문·답글 대상은 localStorage(기기·사용자별), 첨부 대기 파일은 메모리. 방을 바꿔도 각자 남는다 */
    drafts: null,
    draftFiles: /* @__PURE__ */ new Map(),
    /** 올리는 중인 첨부 묶음(2026-10-20) — 말풍선 id → 파일·캡션·취소 핸들. 다시 보내기·취소가 여기서 찾는다. */
    uploadJobs: /* @__PURE__ */ new Map(),
    sendingAttachment: false,
    // Image preview overlay
    previewImageUrl: "",
    /* ── 사진 확대보기(2026-10-20) — 이 방의 사진 첨부를 모아 좌우로 넘기고, 핀치/두 번 탭으로 확대하고, 내려받는다 ── */
    previewItems: [],
    previewIndex: 0,
    previewTransform: {
      ...IDENTITY
    },
    previewAnimate: false,
    previewLoading: false,
    previewSeq: 0,
    previewDetachGestures: null,
    previewImageSize: {
      width: 0,
      height: 0
    },
    previewImageName: "",
    /** 내 메시지의 「삭제」 메뉴(MED-941) — hover 의 ⋯ 버튼·우클릭·길게 누르기가 같은 메뉴를 연다. */
    msgMenu: {
      open: false,
      messageId: "",
      x: 0,
      y: 0
    },
    /** 방의 이모지 반응(2026-10-20) — 메시지 id → 반응 줄. 방을 열 때 `message.extras` 로 한 번 읽고 실시간으로 갱신한다. */
    reactions: {},
    /** 방의 고정 메시지(2026-10-20) — 헤더 아래 띠. null 이면 없음 */
    pinnedMessage: null,
    pinnedById: null,
    /** 두 번 두드리기 판정용 마지막 두드림(모바일) */
    lastTap: null,
    /** 「보내기」(다른 방으로 전달) 대상 고르기 */
    forwardPicker: {
      open: false,
      messageId: "",
      query: "",
      busy: false
    },
    /** 「선택 복사」 — 본문을 글자 선택이 되는 창에 띄워 드래그한 부분만 복사한다(모바일 말풍선은 선택이 꺼져 있어서) */
    selectCopy: {
      open: false,
      messageId: ""
    },
    /** 답글 대상(MED-944) — 입력창 위에 원문 미리보기가 뜨고, 보내면 그 원문을 인용한다. 방을 바꾸면 비운다. */
    replyTarget: null,
    /** @멘션 후보 팝업(MED-943) — 입력칸에서 `@` 뒤를 치면 방 참여자 목록이 뜬다. */
    mentionPicker: {
      open: false,
      query: "",
      start: 0,
      index: 0
    },
    /** 현재 방의 참여자(나 제외) — 방을 열 때 한 번 읽는다. */
    mentionCandidates: [],
    mentionCandidatesFor: "",
    /** 이번 입력에서 후보 목록으로 **골라 넣은** 사람 — 보낼 때 본문에 `@이름` 이 남은 사람만 멘션이 된다. */
    pickedMentions: [],
    msgPressTimer: null,
    /** 길게 누르기로 메뉴가 열렸다 — 손을 떼는 touchend 의 합성 click 을 막는다. */
    msgPressFired: false,
    /** 대화 목록 행의 바로가기 메뉴(2026-10-13) — 우클릭·길게 누르기. 읽음으로 표시 · 알림 끄기/켜기 · 나가기 */
    convMenu: {
      open: false,
      conversationId: "",
      x: 0,
      y: 0
    },
    convPressTimer: null,
    convPressFired: false,
    /** 받은 말풍선 아바타 메뉴(2026-10-13) — 프로필 보기 · 1:1 채팅 · 멘션 */
    senderMenu: {
      open: false,
      employeeId: "",
      name: "",
      x: 0,
      y: 0
    },
    /** 보낸 사람 프로필 사진 URL(직원 id → URL) — 방을 바꿔도 같은 사람이면 다시 받지 않는다 */
    /**
    * 보낸 사람 아바타(2026-10-13 수정) — 사람(id)당 **가장 최근 메시지가 실은 사진 경로** 를 기억하고, URL 은 경로별로 받는다.
    * 예전엔 id 당 URL 하나를 처음 받은 뒤 바꾸지 않아, 사진을 바꿔도 캐시된 옛 메시지의 경로로 먼저 받으면 그 사람의
    * 아바타가 전부 옛 사진에 머물렀다. 이제 더 새 메시지의 경로가 이긴다.
    */
    senderPicturePaths: {},
    senderAvatarUrls: {},
    senderAvatarPending: /* @__PURE__ */ new Set(),
    /** 보고 있는 방 presence — 마지막으로 서버에 보낸 방 id(null = 보는 방 없음)와 보낸 시각 */
    viewingPresenceTimer: null,
    viewingPresenceSent: null,
    viewingPresenceAt: 0,
    // Pagination for message history
    currentPage: 1,
    totalPages: 1,
    loadingOlderMessages: false,
    /** 더 예전 메시지가 서버에 없다(커서 조회 결과) — 「이전 메시지」 버튼을 감춘다 */
    olderExhausted: false,
    /** 「이전 메시지」 를 눌러 끝까지 갔다 — 버튼 자리에 「대화의 처음이에요」(2026-10-13 사용자 요청). 첫 페이지만으로 끝난 작은 방은 표시하지 않는다. */
    get reachedHistoryStart() {
      return this.messages.length > 0 && this.currentPage > 1 && (this.olderExhausted || this.currentPage >= this.totalPages);
    },
    /** 펼친 팀(MED-962) — 처음엔 모두 접혀 있고 내 소속 팀만 펼친다. 손댄 뒤에는 기기에 기억한다(null = 아직 안 손댐) */
    expandedTeams: readExpandedTeams(),
    /** 연락처 「부서 거르기」(MED-962) — entityPicker 선택(팀 하나). 비면 전체 */
    contactTeamFilter: [],
    /**
    * 연락처 검색 방식(2026-10-12) — 「이름」 은 이름·직책 검색칸, 「부서」 는 팀 피커. 둘을 늘 같이 보이던 것이 불편해
    * 검색칸에 커서가 있을 때만 아래에 고르는 줄을 띄운다(고른 부서가 있으면 그 줄은 계속 보인다).
    */
    contactSearchMode: "name",
    contactSearchFocus: false,
    /** 읽음 영수증(MED-963) — 지금 방 멤버가 마지막으로 읽은 시각(employeeId → ISO). 목록 응답과 방 구독이 채운다 */
    readStates: {},
    /** 「읽음 상태」 모달 — 숫자를 누른 메시지의 읽은/안 읽은 사람 */
    readStatus: {
      open: false,
      messageId: ""
    },
    // Group chat creation
    groupSelectMode: false,
    groupSelectedIds: /* @__PURE__ */ new Set(),
    groupTitle: "",
    groupCreating: false,
    showGroupTitleSheet: false,
    // Member drawer
    showMemberDrawer: false,
    drawerMembers: [],
    drawerLeftMembers: [],
    drawerPendingMembers: [],
    drawerMyRole: "",
    showTransferOwnership: false,
    showDissolveConfirm: false,
    roomNameInput: "",
    // Chat invite modal
    showChatInvite: false,
    chatInviteSelectedIds: /* @__PURE__ */ new Set(),
    chatInviteSearch: "",
    chatInviting: false,
    notices: [],
    selectedNotice: null,
    noticeUnreadCount: 0,
    noticesLoaded: false,
    showAllNotices: false,
    noticesHidden: false,
    /** 접힌 공지 목록에 보이는 건수 — 나머지는 「더보기」 뒤에 있다(마크업이 이 값 하나를 쓴다). */
    noticePreviewCount: 3,
    /** 공지 본문을 끝까지 봤는가 — 하단 고정 「확인 했어요」의 활성 조건(updateNoticeReadEnd). */
    noticeReadEnd: false,
    autoScrollConversationId: "",
    autoScrollUntilMs: 0,
    autoScrollReleaseTimer: null,
    /** 맨 아래를 벗어나 있는 동안 상대에게서 온 새 메시지 수 — 0 이 아니면 입력줄 위 「새 메시지 n개」 알약이 뜬다.
    *  맨 아래로 돌아가면(직접 스크롤 · 알약 탭 · 내가 보냄 · 방 전환) 0. 셈은 noteIncomingMessages 하나가 한다. */
    newMessagesBelow: 0,
    // biome-ignore lint/suspicious/noExplicitAny: subscription unsubscribe handle
    messageSubscription: null,
    /** 방 구독이 오류로 끊긴 뒤 다시 붙인 횟수 — 0 이면 정상. 재시도 간격(3s → 최대 30s)과 복구 뒤 재동기화를 가른다 */
    messageSubscribeRetries: 0,
    // biome-ignore lint/suspicious/noExplicitAny: subscription unsubscribe handle
    conversationUpdateSubscription: null,
    // biome-ignore lint/suspicious/noExplicitAny: subscription unsubscribe handle
    readSyncSubscription: null,
    // biome-ignore lint/suspicious/noExplicitAny: subscription handle
    chatKeyEventSubscription: null,
    // biome-ignore lint/style/useNamingConvention: internal property prefixed with underscore by convention
    _chatKeyEventHandler: null,
    // biome-ignore lint/style/useNamingConvention: internal property prefixed with underscore by convention
    _convUpdateHandler: null,
    /** 권한 미리보기 세션(MED-889) — 목록·연락처·공지를 읽지 않고 안내만 그린다. */
    get previewBlocked() {
      return isMessengerPreviewBlocked(herebyStore(this).currentUser);
    },
    // ── 대화 잠금 · 계정 키(MED-892 E4, 설계 §5) ──
    chatLockState: "unknown",
    chatLockBusy: false,
    /** 열린 모달 — setup(최초 설정) · restore(새 기기) · settings(관리) */
    chatLockModal: null,
    chatLockPending: null,
    /** 화면에 한 번 보여 주는 복구 코드(최초 설정·재발급) */
    chatLockRestoreMode: "choose",
    chatLockDeviceSession: null,
    chatLockDeviceTimer: null,
    chatLockFingerprint: "",
    chatLockPendingLinks: [],
    /** 옛 기기 역할 — 대기 중 승인 요청을 주기적으로 본다(새 기기가 요청하면 푸시로도 깨운다) */
    chatLockPendingTimer: null,
    // biome-ignore lint/style/useNamingConvention: internal property prefixed with underscore
    _chatKeyManager: null,
    // biome-ignore lint/style/useNamingConvention: internal property prefixed with underscore
    _conversationKeyManager: null,
    /** 지금 열린 방의 세대 키 상태(MED-894) — null 이면 아직 동기화 전 */
    roomKeySync: null,
    roomKeySyncing: false,
    // ── 상대 키 고정·안전 번호(E9, MED-897) ──
    // biome-ignore lint/style/useNamingConvention: private-ish cache, same convention as _conversationKeyManager
    _peerKeyDirectory: null,
    /** 이 방 멤버 중 대화 잠금 키가 바뀌어 아직 확인하지 않은 사람 */
    /** 환경 공용 복구 공개키(E3) — 세션에 한 번 읽는다. undefined = 아직, null = 이 환경엔 없음 */
    recoveryKeyInfo: void 0,
    /** 이 세션에서 푼 본문 — 답글 인용·목록 미리보기가 쓴다 */
    decryptedTextById: /* @__PURE__ */ new Map(),
    /** 목록 미리보기를 풀려고 서버에서 세대 봉투를 가져와 본 (방:세대) — 세션에 한 번만, 실패해도 다시 안 한다 */
    previewKeyFetched: /* @__PURE__ */ new Set(),
    /** 조직이 대화 암호화를 켰는가(auth.me messengerEncryption). 꺼져 있으면 잠금 UI 전체가 없다. */
    get chatLockEnabled() {
      const store = this.$store?.hereby;
      return store?.currentUser?.messengerEncryption === true;
    },
    // biome-ignore lint/style/useNamingConvention: internal property prefixed with underscore
    _chatKeyStore: null,
    getChatKeyStore() {
      if (!this._chatKeyStore) {
        this._chatKeyStore = createDefaultChatKeyStore();
      }
      return this._chatKeyStore;
    },
    /**
    * 메시지 캐시(2026-10-13) — 서버 응답 항목을 그대로(암호문은 암호문대로) 기기 보호 키로 감싸 저장한다.
    * 다음 진입은 캐시를 먼저 그리고 그 뒤 것만 받는다(`loadMessages`). 실패는 조용히 — 캐시는 있으면 빠른 것일 뿐.
    */
    cacheMessages(payloads) {
      if (!this.currentUserId || payloads.length === 0) {
        return;
      }
      this.getChatKeyStore().putCachedMessages(this.currentUserId, payloads.filter((m) => m.id && m.conversationId && m.createdAt).map((m) => ({
        id: m.id,
        conversationId: m.conversationId,
        // 서버 항목의 createdAt 은 Date(superjson) — 정렬·커서는 ISO 문자열로 통일한다(String(date) 는 요일 문자열)
        createdAt: new Date(m.createdAt).toISOString(),
        payload: JSON.parse(JSON.stringify(m))
      }))).catch(() => void 0);
    },
    getChatKeyManager() {
      const store = herebyStore(this);
      const user = store.currentUser;
      const employeeId = user?.id || "";
      if (!this._chatKeyManager || this._chatKeyManager.employeeId !== employeeId) {
        this._chatKeyManager = new ChatKeyManager({
          employeeId,
          organizationId: user?.organizationId || "",
          store: this.getChatKeyStore(),
          chatKey: store.sdk.chatKey,
          chatDeviceLink: store.sdk.chatDeviceLink,
          requestPersistentStorage: /* @__PURE__ */ __name(() => typeof navigator !== "undefined" && navigator.storage?.persist ? navigator.storage.persist() : Promise.resolve(false), "requestPersistentStorage")
        });
      }
      return this._chatKeyManager;
    },
    /** 대화방 키 세대 관리자 — 계정 키 관리자와 같은 저장소를 쓴다(세대 키 캐시). */
    /** 상대 공개키 고정(TOFU)·변경 감지(E9) — 세대 봉투와 세대 서명 검증이 전부 이 디렉터리의 고정값을 쓴다 */
    getPeerKeyDirectory() {
      if (!this._peerKeyDirectory) {
        this._peerKeyDirectory = new PeerKeyDirectory({
          store: this.getChatKeyStore(),
          chatKey: herebyStore(this).sdk.chatKey
        });
      }
      return this._peerKeyDirectory;
    },
    getConversationKeyManager() {
      const keyManager = this.getChatKeyManager();
      if (!this._conversationKeyManager || this._conversationKeyManager.employeeId !== keyManager.employeeId) {
        const store = herebyStore(this);
        const user = store.currentUser;
        this._conversationKeyManager = new ConversationKeyManager({
          employeeId: user?.id || "",
          organizationId: user?.organizationId || "",
          store: this.getChatKeyStore(),
          conversationKey: store.sdk.conversationKey,
          directory: this.getPeerKeyDirectory(),
          accountKey: /* @__PURE__ */ __name(() => {
            const pair = keyManager.getKeyPair();
            const version = keyManager.getKeyVersion();
            const ecdhPublicKey = keyManager.getPublicKeys()?.ecdhPublicKey;
            return pair && version !== null && ecdhPublicKey ? {
              pair,
              version,
              ecdhPublicKey
            } : null;
          }, "accountKey")
        });
      }
      this._conversationKeyManager.myEcdsaPublicKey = keyManager.getPublicKeys()?.ecdsaPublicKey ?? null;
      return this._conversationKeyManager;
    },
    /**
    * 멤버 변경 서명(E9) — 방 생성·초대·내보내기에 내 기기 서명을 붙인다. 대화 잠금 키가 없으면(암호화 꺼짐·
    * 키 준비 전) undefined — 서버는 서명 없는 변경도 받되, 다른 기기는 그 멤버에게 봉투를 주지 않는다.
    */
    async membershipAttestation(action, conversationId, employeeIds) {
      if (!this.chatLockEnabled || employeeIds.length === 0) {
        return void 0;
      }
      const keyManager = this.getChatKeyManager();
      const pair = keyManager.getKeyPair();
      const version = keyManager.getKeyVersion();
      if (!pair || version === null) {
        return void 0;
      }
      const user = herebyStore(this).currentUser;
      try {
        return await signMembershipChange({
          organizationId: user?.organizationId || "",
          pair,
          keyVersion: version,
          conversationId,
          action,
          employeeIds
        });
      } catch {
        return void 0;
      }
    },
    /** 현재 세대의 서명을 믿을 수 없나(E9) — 보내기를 막는 조건 */
    get roomKeyUntrusted() {
      const r = this.roomKeySync;
      return Boolean(r && r.currentEpoch !== null && r.untrustedEpochs.includes(r.currentEpoch));
    },
    /** 보내기가 막혔을 때 사용자에게 보일 이유 */
    roomKeyBlockedMessage() {
      return herebyStore(this).t(this.roomKeyUntrusted ? "messenger.lock.untrusted_epoch_send" : "messenger.lock.key_missing_send");
    },
    async getRecoveryKeyInfo() {
      if (this.recoveryKeyInfo === void 0) {
        try {
          this.recoveryKeyInfo = await this.sdk.chatKey.recoveryPublicKey() ?? null;
        } catch {
          this.recoveryKeyInfo = void 0;
          return null;
        }
      }
      return this.recoveryKeyInfo;
    },
    /** 암호화 메시지들의 본문을 푼다(MED-893). 못 푸는 것은 isUnreadable 로 남긴다. 같은 배열을 제자리에서 바꾼다. */
    async decryptMessageItems(items) {
      const organizationId = herebyStore(this).currentUser?.organizationId || "";
      const rooms = this.getConversationKeyManager();
      const indexed = [];
      await Promise.all(items.map(async (item) => {
        if (!item.encrypted || item.isDeleted) {
          return;
        }
        const plain = await decryptIncomingMessage(rooms, organizationId, {
          id: item.id,
          conversationId: item.conversationId,
          senderId: item.senderId,
          ...item.encrypted
        });
        if (!plain) {
          item.isUnreadable = true;
          return;
        }
        item.isUnreadable = false;
        item.content = plain.text;
        this.decryptedTextById.set(item.id, plain.text);
        if (plain.attachments && plain.attachments.length > 0) {
          item.attachments = plain.attachments.map((a) => ({
            filename: a.storagePath.split("/").pop() || a.name,
            originalName: a.name,
            mimeType: a.mime,
            size: a.size,
            storagePath: a.storagePath,
            fileKey: a.fileKey,
            fileIv: a.fileIv,
            thumbStoragePath: a.thumbStoragePath,
            thumbKey: a.thumbKey,
            thumbIv: a.thumbIv,
            width: a.width,
            height: a.height
          }));
          if (!item.content) {
            item.content = plain.attachments.map((a) => a.name).join(", ");
          }
        }
        indexed.push({
          messageId: item.id,
          conversationId: item.conversationId,
          senderId: item.senderId,
          senderName: item.senderName,
          text: plain.text,
          createdAt: item.timestamp,
          type: item.type
        });
        if (item.replyTo && !item.replyTo.isDeleted && !item.replyTo.content) {
          const quoted = this.decryptedTextById.get(item.replyTo.id);
          if (quoted) {
            item.replyTo.content = quoted.length > 80 ? `${quoted.slice(0, 80)}\u2026` : quoted;
          }
        }
      }));
      if (indexed.length > 0) {
        this.getChatKeyStore().putSearchEntries(indexed).catch(() => void 0);
      }
    },
    /** 암호화 대상 방인가 — 조직이 켰고 공식 알림 방이 아니다. */
    isEncryptableConversation(conv) {
      return this.chatLockEnabled && conv.type !== "workflow";
    },
    /**
    * 방을 열 때 세대 키를 맞춘다(MED-894): 내 봉투 풀기 → 첫 세대 만들기 / stale 이면 세대 올리기 → 못 받은 멤버 채우기.
    * 계정 키가 아직 없으면(설정·복구 모달 중) 건너뛰고, 키가 생긴 뒤 다시 열 때 한다.
    */
    /** 목록이 알려 준 현재 세대의 키가 이미 기기에 있나 — 있으면 방을 열 때 서버 동기화를 기다리지 않아도 된다 */
    async hasCurrentRoomKeyLocally(conv) {
      if (!this.isEncryptableConversation(conv)) {
        return true;
      }
      if (this.getChatKeyManager().currentState !== "ready" || typeof conv.encryptionEpoch !== "number" || conv.encryptionEpochStale) {
        return false;
      }
      try {
        return await this.getConversationKeyManager().getRoomKey(conv.id, conv.encryptionEpoch) !== null;
      } catch {
        return false;
      }
    },
    async syncRoomKeys(conv) {
      if (!this.isEncryptableConversation(conv) || this.roomKeySyncing) {
        return;
      }
      if (this.getChatKeyManager().currentState !== "ready") {
        this.roomKeySync = null;
        return;
      }
      this.roomKeySyncing = true;
      try {
        const result = await this.getConversationKeyManager().sync(conv.id, true);
        this.roomKeySync = result;
        if (result.currentEpoch !== null) {
          conv.encryptionEpoch = result.currentEpoch;
          conv.encryptionEpochStale = false;
        }
        if (result.currentEpoch !== null && !result.haveCurrentKey) {
          console.warn("[messenger] room key not held after sync", conv.id, {
            currentEpoch: result.currentEpoch,
            untrustedEpochs: result.untrustedEpochs,
            heldForKeyChange: result.heldForKeyChange,
            heldForMembership: result.heldForMembership
          });
        }
      } catch (error) {
        console.warn("[messenger] room key sync failed", conv.id, error);
        this.roomKeySync = null;
      } finally {
        this.roomKeySyncing = false;
      }
    },
    /**
    * 봉투가 없는 멤버에게 내가 가진 세대 키를 채운다(E6) — 초대 직후·메시지 보낸 뒤처럼 「다른 멤버가 방을 열 때까지
    * 기다리면 안 되는」 순간에 부른다. 세대 상태는 바꾸지 않으므로 syncRoomKeys 보다 가볍다. 실패는 삼킨다(다음 동기화가 맞춘다).
    */
    async fillRoomKeyEnvelopes(conv) {
      if (!(conv && this.isEncryptableConversation(conv) && conv.encryptionEpoch)) {
        return;
      }
      if (this.getChatKeyManager().currentState !== "ready") {
        return;
      }
      try {
        const fill = await this.getConversationKeyManager().fillMissing(conv.id);
        if (this.roomKeySync && this.selectedConversation?.id === conv.id) {
          this.roomKeySync = {
            ...this.roomKeySync,
            heldForKeyChange: fill.heldForKeyChange,
            heldForMembership: fill.heldForMembership
          };
        }
      } catch {
      }
    },
    /** 기기 키와 서버 키를 맞춰 보고, 없으면 설정/복구 모달을 연다. 있으면 다른 기기의 승인 요청을 확인한다. */
    async ensureChatKeys() {
      if (!this.chatLockEnabled) {
        this.chatLockState = "off";
        return;
      }
      try {
        const state3 = await this.getChatKeyManager().ensure();
        this.chatLockState = state3;
        if (state3 === "setup") {
          await this.startChatLockSetup({
            silent: true
          });
        } else if (state3 === "restore") {
          this.openChatLockRestore();
        } else if (state3 === "ready") {
          this.chatLockCheckPendingLinks();
          this.startChatLockPendingPoll();
        }
      } catch {
      }
    },
    /**
    * 암호화 플래그 보정 — 로그인 응답의 사용자 정보에 `messengerEncryption` 이 빠진 채(옛 서버·옛 세션) 암호화된 방이
    * 보이면 대화 잠금 UI 가 통째로 꺼져 암호문만 남는다. 방 목록에 세대가 있는 방이 있으면 auth.me 로 사용자 정보를
    * 다시 받아 플래그를 채우고 키 상태를 맞춘다.
    */
    async ensureEncryptionFlag() {
      if (this.chatLockEnabled) {
        return;
      }
      const hasEncryptedRoom = this.conversations.some((c) => typeof c.encryptionEpoch === "number" && c.encryptionEpoch > 0);
      if (!hasEncryptedRoom) {
        return;
      }
      try {
        const store = herebyStore(this);
        const fresh = await store.sdk.auth.getCurrentUser();
        if (fresh && typeof fresh === "object") {
          store.currentUser = {
            ...store.currentUser ?? {},
            ...fresh
          };
        }
      } catch {
        return;
      }
      if (this.chatLockEnabled) {
        await this.ensureChatKeys();
      }
    },
    /** 이 기기에 키가 없어 대화를 못 읽는 상태인데 모달을 닫아 둔 경우 — 목록 위 띠로 다시 안내한다 */
    get chatLockMissingKey() {
      if (!this.chatLockEnabled || this.chatLockModal !== null || this.chatLockBusy) {
        return null;
      }
      return this.chatLockState === "setup" || this.chatLockState === "restore" ? this.chatLockState : null;
    },
    /**
    * 옛 기기 역할의 주기 확인(20초) — 예전에는 메신저를 처음 열 때 한 번만 봐서, 웹을 열어 둔 채 모바일로 로그인하면
    * 웹에 승인 창이 끝내 뜨지 않았다(새 기기 요청은 10분 뒤 만료). 푸시·탭 복귀로도 깨우지만 주기 확인이 바닥이다.
    */
    startChatLockPendingPoll() {
      if (this.chatLockPendingTimer) {
        return;
      }
      this.chatLockPendingTimer = setInterval(() => {
        if (this.chatLockState !== "ready" || typeof document !== "undefined" && document.hidden) {
          return;
        }
        this.chatLockCheckPendingLinks();
      }, 2e4);
    },
    stopChatLockPendingPoll() {
      if (this.chatLockPendingTimer) {
        clearInterval(this.chatLockPendingTimer);
        this.chatLockPendingTimer = null;
      }
    },
    openChatLockSetup() {
      this.chatLockPending = null;
      this.chatLockModal = "setup";
    },
    /**
    * 최초 설정 — 한 번에 끝낸다(2026-10-15): 키를 만들어 등록하고 기기에 저장. 복구 코드는 없다 — 사용자가 복구 수단을
    * 직접 보관하지 않는다. 기기를 모두 잃으면 다른 멤버 기기가 봉투를 다시 줄 수 있는 방만 지난 대화가 돌아온다.
    */
    async startChatLockSetup(options) {
      if (this.chatLockBusy) {
        return;
      }
      this.chatLockBusy = true;
      this.chatLockState = "creating";
      try {
        const pending = await this.getChatKeyManager().beginSetup();
        this.chatLockPending = pending;
        await this.getChatKeyManager().completeSetup(pending);
        this.chatLockState = "ready";
        this.chatLockPending = null;
        this.chatLockModal = null;
        if (options?.silent) {
          showToastMessage(this, herebyStore(this).t("messenger.lock.setup_done"));
        } else {
          showAlert(herebyStore(this).t("messenger.lock.setup_done"));
        }
        this.chatLockCheckPendingLinks();
        this.startChatLockPendingPoll();
        if (this.selectedConversation) {
          this.roomKeySync = null;
          await this.syncRoomKeys(this.selectedConversation);
          await this.decryptMessageItems(this.messages.filter((m) => m.isUnreadable));
        }
      } catch {
        this.chatLockState = "setup";
        if (!options?.silent) {
          showError(herebyStore(this).t("messenger.lock.setup_failed"));
        }
      } finally {
        this.chatLockBusy = false;
      }
    },
    openChatLockRestore() {
      this.chatLockRestoreMode = "choose";
      this.chatLockModal = "restore";
    },
    /** 새 기기: 다른 기기의 승인 기다리기 — 6자리 코드를 보여 주고 3초마다 확인. */
    async chatLockUseDevice() {
      if (this.chatLockBusy) {
        return;
      }
      this.chatLockBusy = true;
      try {
        this.chatLockDeviceSession = await this.getChatKeyManager().startDeviceLink();
        this.chatLockRestoreMode = "device";
        this.chatLockStopDevicePoll();
        this.chatLockDeviceTimer = setInterval(() => {
          this.chatLockPollDevice();
        }, 3e3);
      } catch {
        showError(herebyStore(this).t("messenger.lock.device_start_failed"));
      } finally {
        this.chatLockBusy = false;
      }
    },
    async chatLockPollDevice() {
      const session = this.chatLockDeviceSession;
      if (!session) {
        return;
      }
      try {
        if (session.expiresAt.getTime() < Date.now()) {
          throw new Error("expired");
        }
        const done = await this.getChatKeyManager().pollDeviceLink(session);
        if (done) {
          this.chatLockStopDevicePoll();
          this.chatLockDeviceSession = null;
          this.chatLockState = "ready";
          this.chatLockModal = null;
          showAlert(herebyStore(this).t("messenger.lock.device_done"));
        }
      } catch {
        this.chatLockStopDevicePoll();
        this.chatLockDeviceSession = null;
        this.chatLockRestoreMode = "choose";
        showError(herebyStore(this).t("messenger.lock.device_expired"));
      }
    },
    chatLockStopDevicePoll() {
      if (this.chatLockDeviceTimer) {
        clearInterval(this.chatLockDeviceTimer);
        this.chatLockDeviceTimer = null;
      }
    },
    async chatLockCancelDevice() {
      this.chatLockStopDevicePoll();
      if (this.chatLockDeviceSession) {
        await this.getChatKeyManager().cancelDeviceLink(this.chatLockDeviceSession);
        this.chatLockDeviceSession = null;
      }
      this.chatLockRestoreMode = "choose";
    },
    /** 새 기기: 복구 코드로 서버 백업을 푼다. */
    /** 새 기기: 승인해 줄 기기가 없어 새 키로 시작 — 지난 대화는 다른 멤버 기기가 봉투를 다시 주는 방에서만 돌아온다. */
    async chatLockStartFresh() {
      const t = herebyStore(this).t.bind(herebyStore(this));
      const ok = await askConfirm({
        message: t("messenger.lock.start_fresh_confirm"),
        confirmLabel: t("messenger.lock.start_fresh_button"),
        tone: "danger"
      });
      if (!ok) {
        return;
      }
      this.chatLockModal = null;
      this.openChatLockSetup();
      await this.startChatLockSetup();
    },
    async openChatLockSettings() {
      if (!this.chatLockEnabled) {
        return;
      }
      const manager = this.getChatKeyManager();
      if (manager.currentState === "unknown") {
        await this.ensureChatKeys();
      }
      if (manager.currentState !== "ready") {
        return;
      }
      this.chatLockFingerprint = await manager.fingerprint() ?? "";
      this.chatLockModal = "settings";
      this.chatLockCheckPendingLinks();
    },
    async chatLockForgetDevice() {
      const t = herebyStore(this).t.bind(herebyStore(this));
      const ok = await askConfirm({
        message: t("messenger.lock.forget_confirm"),
        confirmLabel: t("messenger.lock.forget_button"),
        tone: "danger"
      });
      if (!ok) {
        return;
      }
      await this.getChatKeyManager().forgetLocalKey();
      this.chatLockState = "restore";
      this.chatLockModal = null;
      this.openChatLockRestore();
    },
    async chatLockResetKey() {
      const t = herebyStore(this).t.bind(herebyStore(this));
      const ok = await askConfirm({
        message: t("messenger.lock.reset_confirm"),
        confirmLabel: t("messenger.lock.reset_button"),
        tone: "danger"
      });
      if (!ok) {
        return;
      }
      this.chatLockModal = null;
      this.openChatLockSetup();
      await this.startChatLockSetup();
    },
    /** 옛 기기: 내 계정으로 들어온 새 기기 승인 요청을 보여 준다. */
    /**
    * 대기 중 승인 요청 확인 — 전역 감시(chat-device-link-watch)와 같은 함수를 써서 한 요청을 두 번 묻지 않는다.
    * 설정 모달이 열려 있으면 묻지 않고 목록만 채운다(모달이 승인/거절 버튼으로 보여 준다).
    */
    async chatLockCheckPendingLinks() {
      if (this.chatLockState !== "ready") {
        return;
      }
      const t = herebyStore(this).t.bind(herebyStore(this));
      this.chatLockPendingLinks = await checkPendingDeviceLinks(this.getChatKeyManager(), t, {
        prompt: this.chatLockModal !== "settings"
      });
    },
    async chatLockApprove(link) {
      const t = herebyStore(this).t.bind(herebyStore(this));
      try {
        await this.getChatKeyManager().approveDeviceLink(link.requestId, link.ephemeralPublicKey);
        forgetDeviceLink(link.requestId);
        this.chatLockPendingLinks = this.chatLockPendingLinks.filter((l) => l.requestId !== link.requestId);
        showAlert(t("messenger.lock.approve_done"));
      } catch {
        showError(t("messenger.lock.approve_failed"));
      }
    },
    async chatLockReject(link) {
      markDeviceLinkRejected(link.requestId);
      await this.getChatKeyManager().rejectDeviceLink(link.requestId).catch(() => void 0);
      this.chatLockPendingLinks = this.chatLockPendingLinks.filter((l) => l.requestId !== link.requestId);
    },
    closeChatLockModal() {
      this.chatLockStopDevicePoll();
      if (this.chatLockDeviceSession) {
        this.getChatKeyManager().cancelDeviceLink(this.chatLockDeviceSession).catch(() => void 0);
        this.chatLockDeviceSession = null;
      }
      this.chatLockModal = null;
    },
    async loadData() {
      this.sdk = herebyStore(this).sdk;
      if (!this.sdk) {
        return;
      }
      if (this.previewBlocked) {
        this.loaded = true;
        return;
      }
      this.apiBaseUrl = import.meta.env?.API_BASE_URL || "";
      this.currentUserId = herebyStore(this).currentUser?.id || "";
      this.readNotices = readNoticeIds(this.currentUserId);
      if (this.chatLockEnabled) {
        this.ensureChatKeys();
      }
      await Promise.allSettled([
        this.loadContacts(),
        this.loadConversations(),
        this.loadNotices()
      ]);
      await this.ensureEncryptionFlag();
      this.loaded = true;
      this.subscribeToConversationUpdates();
      this.loadLocalNotifySettings();
      this.initPullToRefresh();
      const store = appStore(this, "messenger");
      if (store?.pendingConversationId) {
        const id = store.pendingConversationId;
        store.pendingConversationId = null;
        await this.openConversationById(id);
      }
      if (store?.pendingNoticeId) {
        const id = store.pendingNoticeId;
        store.pendingNoticeId = null;
        await this.openNoticeById(id);
      }
      if (store?.pendingDirectChat) {
        const req = store.pendingDirectChat;
        store.pendingDirectChat = null;
        await this.openDirectChatWithDraft(req);
      }
      if (store?.pendingSelfChat) {
        store.pendingSelfChat = false;
        await this.openSelfChat();
      }
      if (store?.pendingLockSettings) {
        store.pendingLockSettings = false;
        await this.openChatLockSettings();
      }
    },
    /**
    * 그 사람과의 1:1 대화를 열고 입력칸에 문구를 채운다 — **보내지 않는다**(보내기는 사용자가 누른다).
    * 방은 서버 conversation.create 가 찾아 준다(이미 있으면 그 방 id 를 돌려줌) — 이름으로 찾는
    * startConversation 과 달리 동명이인이어도 맞는 방이 열린다.
    */
    async openDirectChatWithDraft(req) {
      let convId = "";
      try {
        const result = await this.sdk.conversation.create({
          type: "direct",
          memberIds: [
            req.employeeId
          ],
          attestation: await this.membershipAttestation("create", null, [
            req.employeeId
          ])
        });
        convId = result?.data?.id || result?.id || "";
      } catch (_e) {
        showToastMessage(this, "\uB300\uD654\uBC29\uC744 \uC5F4\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.");
        return;
      }
      if (!convId) {
        return;
      }
      let conv = this.conversations.find((c) => c.id === convId);
      if (!conv) {
        await this.loadConversations();
        conv = this.conversations.find((c) => c.id === convId);
      }
      if (!conv) {
        conv = {
          id: convId,
          type: "direct",
          title: "",
          contactName: req.name,
          contactRole: "",
          memberIds: [
            this.currentUserId,
            req.employeeId
          ],
          lastMessage: "",
          lastMessageTime: (/* @__PURE__ */ new Date()).toISOString(),
          unreadCount: 0,
          isPinned: false
        };
        this.conversations.unshift(conv);
      }
      await this.openConversation(conv);
      this.messageInput = req.draft;
      this.prefilledDraft = req.draft;
      alpineMagics(this).$nextTick?.(() => this.focusMessageInput());
    },
    /**
    * 공지 id로 상세를 연다 — 홈 공지 카드에서 넘어올 때. 목록에 없으면(홈이 먼저
    * 새 공지를 봤거나 메신저 목록이 오래됐으면) 한 번 다시 읽고 찾는다.
    */
    async openNoticeById(id) {
      let notice = this.notices.find((n) => n.id === id);
      if (!notice) {
        await this.loadNotices();
        notice = this.notices.find((n) => n.id === id);
      }
      if (notice) {
        await this.viewNotice(notice);
      }
    },
    /** Override in wrapper to add pull-to-refresh behavior */
    initPullToRefresh() {
    },
    async refresh() {
      this.refreshing = true;
      await Promise.allSettled([
        this.loadContacts(),
        this.loadConversations(),
        this.loadNotices()
      ]);
      this.refreshing = false;
    },
    async loadContacts() {
      try {
        const allContacts = await fetchAllPages2((page, limit) => this.sdk.employee.getContacts({
          page,
          limit
        }), 200);
        const toContact = /* @__PURE__ */ __name((c) => {
          const teams = c.teams || [];
          return {
            id: c.id,
            name: c.name || "",
            role: c.roleName || "",
            team: teams[0]?.name || herebyStore(this).t("messenger.unassigned"),
            teams,
            status: "offline",
            profilePicture: c.profilePicture ?? null
          };
        }, "toContact");
        const me = allContacts.find((c) => c.id === this.currentUserId);
        this.myContact = me ? toContact(me) : null;
        this.contacts = allContacts.filter((c) => c.id !== this.currentUserId).map(toContact);
      } catch (e) {
        console.error("[Messenger] loadContacts failed:", e);
        this.contacts = [];
        this.myContact = null;
      }
    },
    async loadConversations() {
      try {
        const result = await this.sdk.conversation.list({}, {
          page: 1,
          limit: 50,
          sortBy: "lastMessageAt",
          sortOrder: "desc"
        });
        const items = result?.items || [];
        const hadNewMessage = new Set(this.conversations.filter((c) => c.hasNewMessage).map((c) => c.id));
        const built = [];
        for (const c of items) {
          try {
            const item = buildConversationItem(c, this.currentUserId);
            if (item.unreadCount > 0 && hadNewMessage.has(item.id)) {
              item.hasNewMessage = true;
            }
            built.push(item);
          } catch (error) {
            console.warn("[messenger] conversation skipped", c?.id, error);
          }
        }
        this.conversations = built;
        await this.decryptConversationPreviews(this.conversations);
        this.channels = this.conversations.filter((c) => c.type === "channel").map((c) => ({
          id: c.id,
          name: c.title || c.contactName,
          lastMessage: c.lastMessage,
          lastMessageTime: c.lastMessageTime,
          unreadCount: c.unreadCount
        }));
        this.conversations = this.conversations.filter((c) => c.type !== "channel");
        await this.syncGlobalUnreadCount();
      } catch (error) {
        console.warn("[messenger] conversation list reload failed; keeping the current list", error);
        if (!this.loaded) {
          this.conversations = [];
          this.channels = [];
        }
      }
    },
    /* ── Navigation ── */
    /* ── 실시간 누락 보정 (MED-961) ── */
    /**
    * 서버 기준으로 다시 맞춘다 — 대화 목록 전체 + 열린 방의 최신 페이지.
    * 실시간 이벤트(WebSocket)는 끊긴 사이에 온 것을 되살리지 않는다. 휴대폰은 백그라운드·망 전환에서 소켓이 조용히 죽어,
    * 「채팅이 몇 분 늦게 오거나 안 온다」「뒤로 갔다 오면 방금 대화가 안 보이고 검색해야 보인다」로 보였다(10/8 현장).
    * 복귀·재연결·온라인 전환이 한꺼번에 와도 한 번만 돈다(shouldResync).
    */
    async resyncFromServer() {
      if (!(this.loaded && this.sdk) || this.previewBlocked) {
        return;
      }
      if (!shouldResync(this.resyncState, Date.now())) {
        return;
      }
      this.resyncState.inFlight = true;
      try {
        await this.loadConversations();
        if (this.activeView === "chat" && this.selectedConversation) {
          await this.syncOpenConversationMessages();
        }
        await this.markViewedConversationRead();
      } finally {
        this.resyncState.inFlight = false;
        this.resyncState.lastAt = Date.now();
      }
    },
    /** 열린 방의 최신 페이지를 서버에서 다시 읽어 화면 목록에 합친다 — 화면을 통째로 갈지 않아 스크롤·이미지가 그대로다. */
    async syncOpenConversationMessages() {
      const conv = this.selectedConversation;
      if (!conv) {
        return;
      }
      const nearBottom = this.isChatAtLiveBottom();
      try {
        const result = await this.sdk.message.list({
          conversationId: conv.id,
          pagination: {
            page: 1,
            limit: 50
          }
        });
        if (this.selectedConversation?.id !== conv.id) {
          return;
        }
        const latest = (result?.items || []).map((m) => mapMessageItem(m, this.currentUserId));
        await this.decryptMessageItems(latest);
        this.cacheMessages(result?.items || []);
        const known = new Set(this.messages.map((m) => m.id));
        const freshFromOthers = latest.filter((m) => !(known.has(m.id) || m.isMine)).length;
        const merged = mergeLatestMessagePage(this.messages, latest);
        this.messages = merged.messages;
        this.totalPages = result?.totalPages || this.totalPages;
        if (merged.replaced) {
          this.currentPage = 1;
        }
        this.refreshConversationPreview(conv.id);
        if (merged.added > 0) {
          this.noteIncomingMessages(freshFromOthers, nearBottom);
        }
      } catch (_e) {
      }
    },
    closeImagePreview() {
      this.previewSeq++;
      this.previewImageUrl = "";
      this.previewImageName = "";
      this.previewItems = [];
      this.previewIndex = 0;
      this.previewTransform = {
        ...IDENTITY
      };
      this.previewLoading = false;
    },
    /* ── 사진 확대보기(2026-10-20) ── */
    /** 이 방에 보이는 사진 첨부 전부(지워지지 않은 것, 시간순) — 좌우로 넘길 목록 */
    roomImageAttachments() {
      const out = [];
      for (const m of this.messages) {
        if (m.isDeleted || m.isUnreadable || m.type !== "image") {
          continue;
        }
        for (const a of m.attachments ?? []) {
          if (a.storagePath && (a.mimeType || "").startsWith("image/")) {
            out.push(a);
          }
        }
      }
      return out;
    },
    /** 말풍선의 사진을 눌렀다 — 그 사진부터 보여 주고 양옆은 미리 받아 둔다 */
    async openImagePreview(att) {
      const items = this.roomImageAttachments();
      const index = Math.max(0, items.findIndex((a) => a.storagePath === att.storagePath));
      this.previewItems = items.length > 0 ? items : [
        att
      ];
      this.previewTransform = {
        ...IDENTITY
      };
      this.previewImageName = att.originalName;
      this.previewImageUrl = " ";
      await this.showPreviewAt(index);
    },
    async showPreviewAt(index) {
      const items = this.previewItems;
      if (items.length === 0) {
        return;
      }
      const clamped = Math.min(items.length - 1, Math.max(0, index));
      const seq = ++this.previewSeq;
      this.previewIndex = clamped;
      this.previewTransform = {
        ...IDENTITY
      };
      this.previewAnimate = false;
      const att = items[clamped];
      this.previewImageName = att.originalName;
      this.previewLoading = true;
      try {
        const url = await this.attachmentUrl(att);
        if (seq !== this.previewSeq) {
          return;
        }
        this.previewImageUrl = url || " ";
      } catch {
        if (seq === this.previewSeq) {
          this.previewImageUrl = " ";
        }
      } finally {
        if (seq === this.previewSeq) {
          this.previewLoading = false;
        }
      }
      for (const i of [
        clamped - 1,
        clamped + 1
      ]) {
        const n = items[i];
        if (n) {
          this.attachmentUrl(n).catch(() => void 0);
        }
      }
    },
    get previewHasPrev() {
      return this.previewIndex > 0;
    },
    get previewHasNext() {
      return this.previewIndex < this.previewItems.length - 1;
    },
    previewPrev() {
      if (this.previewHasPrev) {
        this.showPreviewAt(this.previewIndex - 1);
      }
    },
    previewNext() {
      if (this.previewHasNext) {
        this.showPreviewAt(this.previewIndex + 1);
      }
    },
    /** img 의 transform — 손짓 중에는 즉시, 두 번 탭·되돌림은 짧게 움직인다 */
    get previewImgStyle() {
      const t = this.previewTransform;
      return `transform: translate(${t.tx}px, ${t.ty}px) scale(${t.scale}); transition: ${this.previewAnimate ? "transform 160ms ease-out" : "none"}`;
    },
    onPreviewImageLoad(event) {
      const img = event.target;
      this.previewImageSize = {
        width: img.clientWidth,
        height: img.clientHeight
      };
    },
    /** 스테이지 x-init — 핀치·두 번 탭·끌기·스와이프를 붙인다. 레이어가 닫히면 떼지 않아도 되지만(요소가 남는다) 한 번만 붙인다. */
    initImageViewer(stage) {
      this.previewDetachGestures?.();
      this.previewDetachGestures = attachViewerGestures(stage, {
        getTransform: /* @__PURE__ */ __name(() => this.previewTransform, "getTransform"),
        setTransform: /* @__PURE__ */ __name((t, animate) => {
          this.previewAnimate = animate;
          this.previewTransform = t;
        }, "setTransform"),
        imageSize: /* @__PURE__ */ __name(() => this.previewImageSize, "imageSize"),
        onSwipe: /* @__PURE__ */ __name((dir) => dir === "next" ? this.previewNext() : this.previewPrev(), "onSwipe"),
        onTap: /* @__PURE__ */ __name(() => this.closeImagePreview(), "onTap")
      });
    },
    /** 내려받기 — 암호화 첨부는 풀린 Blob, 평문은 받아서 Blob 으로. 직원 앱은 공유 시트(hereby:save-file), 웹은 다운로드 */
    async downloadPreviewImage() {
      const att = this.previewItems[this.previewIndex];
      if (!att) {
        return;
      }
      try {
        const url = await this.attachmentUrl(att);
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(String(res.status));
        }
        const blob = await res.blob();
        saveBlob(new Blob([
          blob
        ], {
          type: att.mimeType || blob.type || "image/jpeg"
        }), att.originalName || "image.jpg", att.mimeType || "image/jpeg");
      } catch {
        showError(herebyStore(this).t("messenger.image_download_failed"));
      }
    },
    /** 메신저 밖에서 내가 보낸 방을 목록 맨 위로 — 목록에 없는 방(처음 만든 「나와의 대화」)이면 먼저 다시 읽는다. */
    async bumpConversation(conversationId, preview) {
      let conv = this.conversations.find((c) => c.id === conversationId);
      if (!conv) {
        if (!this.loaded) {
          return;
        }
        await this.loadConversations();
        conv = this.conversations.find((c) => c.id === conversationId);
      }
      if (!conv) {
        return;
      }
      if (preview) {
        conv.lastMessage = preview;
      }
      conv.lastMessageTime = (/* @__PURE__ */ new Date()).toISOString();
      if (this.selectedConversation?.id !== conversationId) {
        conv.hasNewMessage = true;
      }
    },
    /* ── 화면 안 브라우저 알림 = 휴대폰 알림 설정과 같은 규칙 (2026-10-12) ── */
    /** 알림 설정 네 가지를 한 번 읽어 둔다. 설정을 바꾸면 `hereby:notification-settings-changed` 로 다시 읽는다. */
    async loadLocalNotifySettings() {
      if (!this.sdk?.notification) {
        return;
      }
      const source = await loadLocalNotifySource(this.sdk);
      if (source) {
        this.localNotifySettings = localNotifySettingsFor(source, "messenger");
      }
      try {
        const reg = await navigator.serviceWorker?.getRegistration?.();
        this.hasWebPushSubscription = Boolean(await reg?.pushManager?.getSubscription?.());
      } catch (_e) {
        this.hasWebPushSubscription = false;
      }
    },
    /**
    * 새 메시지의 화면 안 알림 — 서버 푸시와 같은 관문(push-gate)·같은 표시 방식(messenger-push-format).
    * 무엇을 띄울지(관문·제목·본문)는 여기서 정하고, 어떻게 띄울지는 `presentLocalNotification` 이 맡는다 —
    * 직원 앱은 그것을 갈아 끼워 브라우저 알림 대신 앱 상단 배너를 그린다(main.ts, 2026-10-12).
    */
    async notifyLocally(params) {
      if (!this.canPresentLocalNotification()) {
        return;
      }
      if (params.muted ?? params.conv?.muted === true) {
        return;
      }
      const tz = herebyStore(this).timezone;
      if (!localChatNotificationAllowed(this.localNotifySettings, /* @__PURE__ */ new Date(), tz)) {
        return;
      }
      const t = herebyStore(this).t;
      let body = params.lastMessage;
      if (!body && params.conv?.encryptionEpoch && params.conv.lastMessageEncrypted) {
        const before = params.conv.lastMessage;
        await this.decryptConversationPreviews([
          params.conv
        ]);
        body = params.conv.lastMessage !== before ? params.conv.lastMessage : "";
      }
      const built = buildLocalChatNotification({
        format: this.localNotifySettings?.format,
        senderName: params.senderName || params.conv?.contactName || "",
        body,
        labels: {
          genericTitle: "\uC0C8 \uBA54\uC2DC\uC9C0",
          genericBody: t("messenger.encrypted_push_body")
        }
      });
      this.presentLocalNotification({
        conversationId: params.conv?.id || params.conversationId || "",
        conv: params.conv,
        title: built.title,
        body: built.body
      });
    },
    /**
    * 화면 안 알림을 띄울 수단이 있나 — 기본은 브라우저 알림(권한 허용 + 웹 푸시 구독 없음: 구독이 있으면 서비스 워커가 띄운다).
    * 직원 앱은 앱 상단 배너로 갈아 끼우며 이것도 함께 바꾼다(main.ts).
    */
    canPresentLocalNotification() {
      if (typeof Notification === "undefined" || Notification.permission !== "granted") {
        return false;
      }
      return !this.hasWebPushSubscription;
    },
    /** 고른 제목·본문을 실제로 띄운다 — 기본은 브라우저 `Notification`. 호스트가 갈아 끼울 수 있다. */
    presentLocalNotification(n) {
      new Notification(n.title, {
        body: n.body,
        icon: "/icons/icon-192x192.png"
      });
    },
    /** 알림(답글·@멘션)에서 방을 열 때 — 목록에 없으면 한 번 다시 읽는다(새로 초대된 방). */
    async openConversationById(id) {
      let conv = this.conversations.find((c) => c.id === id);
      if (!conv) {
        await this.loadConversations();
        conv = this.conversations.find((c) => c.id === id);
      }
      if (conv) {
        await this.openConversation(conv);
      }
    },
    /* ── 방별 임시 저장 (2026-10-21) ── */
    get draftStore() {
      if (!this.drafts) {
        this.drafts = readChatDrafts(typeof localStorage === "undefined" ? null : localStorage, chatDraftStorageKey(this.currentUserId));
      }
      return this.drafts;
    },
    /** 지금 입력줄 상태를 그 방의 초안으로 — 본문·답글 대상은 저장소, 첨부 대기는 메모리 */
    saveDraftFor(conversationId) {
      this.drafts = updateChatDraft(this.draftStore, conversationId, {
        text: this.messageInput,
        replyToId: this.replyTarget?.id ?? null
      }, Date.now(), typeof localStorage === "undefined" ? null : localStorage, chatDraftStorageKey(this.currentUserId));
      if (this.pendingFiles.length > 0) {
        this.draftFiles.set(conversationId, [
          ...this.pendingFiles
        ]);
      } else {
        this.draftFiles.delete(conversationId);
      }
    },
    /** 입력 중 저장(디바운스) — 새로고침·앱 종료에도 글이 남게 */
    saveCurrentDraft() {
      if (this.selectedConversation && this.activeView === "chat") {
        this.saveDraftFor(this.selectedConversation.id);
      }
    },
    /** 방을 열 때 그 방의 초안을 입력줄에 되돌린다 — 답글 대상은 목록에 있을 때만 */
    restoreDraftFor(conversationId) {
      const draft = this.draftStore[conversationId];
      if (draft) {
        this.messageInput = draft.text;
        this.replyTarget = draft.replyToId ? this.messages.find((m) => m.id === draft.replyToId) ?? null : null;
      }
      this.pendingFiles = this.draftFiles.get(conversationId) ?? [];
    },
    clearDraftFor(conversationId) {
      this.drafts = updateChatDraft(this.draftStore, conversationId, null, Date.now(), typeof localStorage === "undefined" ? null : localStorage, chatDraftStorageKey(this.currentUserId));
      this.draftFiles.delete(conversationId);
    },
    /** 목록 행에 보일 초안 한 줄 — 없으면 빈 문자열 */
    draftPreviewOf(conversationId) {
      return this.draftStore[conversationId]?.text ?? "";
    },
    async openConversation(conv) {
      if (this.selectedConversation && this.selectedConversation.id !== conv.id) {
        this.saveDraftFor(this.selectedConversation.id);
      }
      this.messageInput = "";
      this.pendingFiles = [];
      this.replyTarget = null;
      this.pickedMentions = [];
      this.closeMentionPicker();
      this.closeMessageMenu();
      this.closeSelectCopy();
      this.reactions = {};
      this.pinnedMessage = null;
      this.pinnedById = null;
      this.lastTap = null;
      this.selectedConversation = conv;
      this.revokeDecryptedFileUrls();
      this.loadMentionCandidates(conv);
      this.roomKeySync = null;
      if (await this.hasCurrentRoomKeyLocally(conv)) {
        this.syncRoomKeys(conv).catch(() => void 0);
      } else {
        await this.syncRoomKeys(conv);
      }
      await this.loadMessages(conv.id);
      this.restoreDraftFor(conv.id);
      conv.unreadCount = 0;
      conv.hasNewMessage = false;
      this.activeView = "chat";
      this.syncViewingPresence();
      this.armInitialAutoScroll(conv.id);
      this.subscribeToConversation(conv.id);
      try {
        await this.sdk.message.markRead({
          conversationId: conv.id
        });
        await this.syncGlobalUnreadCount();
      } catch (_e) {
      }
      this._clearDeliveredNotifications();
    },
    /** Clear delivered push notifications from notification center */
    async _clearDeliveredNotifications() {
      try {
        const cap = globalThis.Capacitor;
        if (cap?.isNativePlatform?.()) {
          const push = cap.Plugins?.PushNotifications;
          await push?.removeAllDeliveredNotifications?.();
        }
      } catch (_e) {
      }
    },
    /**
    * 방 메시지 로드(2026-10-13, 캐시 우선) — 이 기기에 캐시가 있으면 먼저 그리고, 서버에는 캐시 마지막 시각 **뒤의 것만**
    * (새 메시지 + 그사이 지워진 것, `after` 델타) 묻는다. 캐시가 없으면 종전처럼 첫 페이지. 받은 것은 캐시에 쓴다.
    */
    async loadMessages(conversationId) {
      this.olderExhausted = false;
      let cached = [];
      try {
        cached = (await this.getChatKeyStore().getCachedMessages(this.currentUserId, conversationId, 50)).map((c) => c.payload);
      } catch {
        cached = [];
      }
      if (this.selectedConversation?.id !== conversationId) {
        return;
      }
      if (cached.length > 0) {
        const fromCache = cached.map((message) => mapMessageItem(message, this.currentUserId));
        await this.decryptMessageItems(fromCache);
        if (this.selectedConversation?.id !== conversationId) {
          return;
        }
        this.messages = fromCache;
        this.currentPage = 1;
        this.totalPages = 2;
        this.refreshConversationPreview(conversationId);
      }
      const after = cached.length > 0 ? new Date(cached[cached.length - 1].createdAt).toISOString() : void 0;
      try {
        const result = await this.sdk.message.list(after ? {
          conversationId,
          after
        } : {
          conversationId,
          pagination: {
            page: 1,
            limit: 50
          }
        });
        if (this.selectedConversation?.id !== conversationId) {
          return;
        }
        const items = result?.items || [];
        if (after) {
          const existing = new Set(this.messages.map((m) => m.id));
          for (const d of items.filter((m) => m.deletedAt)) {
            if (existing.has(d.id)) {
              applyMessageDeletion(this.messages, d.id);
            }
          }
          const fresh = items.filter((m) => !existing.has(m.id));
          if (fresh.length > 0) {
            const mapped = fresh.map((message) => mapMessageItem(message, this.currentUserId));
            await this.decryptMessageItems(mapped);
            if (this.selectedConversation?.id !== conversationId) {
              return;
            }
            this.messages = [
              ...this.messages,
              ...mapped
            ].sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
          }
        } else {
          this.totalPages = result?.totalPages || 1;
          this.currentPage = 1;
          const mapped = items.map((message) => mapMessageItem(message, this.currentUserId));
          await this.decryptMessageItems(mapped);
          if (this.selectedConversation?.id !== conversationId) {
            return;
          }
          this.messages = mapped;
        }
        this.cacheMessages(items);
        const states = result?.readStates;
        this.readStates = Object.fromEntries((states ?? []).map((s) => [
          s.employeeId,
          s.lastReadAt ? new Date(s.lastReadAt).toISOString() : null
        ]));
        this.refreshConversationPreview(conversationId);
      } catch (_e) {
        if (cached.length === 0) {
          this.messages = [];
        }
      }
      this.loadConversationExtras(conversationId).catch(() => void 0);
      this.attachInFlightUploads(conversationId);
    },
    /** 이 방에서 아직 올리는 중인 말풍선을 목록에 다시 붙인다(2026-10-21) — 방을 나갈 때 목록을 비워도 올리기는 계속된다 */
    attachInFlightUploads(conversationId) {
      if (this.selectedConversation?.id !== conversationId) {
        return;
      }
      let added = false;
      for (const job of this.uploadJobs.values()) {
        const m = job.msg;
        if (m.conversationId === conversationId && (m.status === "uploading" || m.status === "sending" || m.status === "failed") && !this.messages.some((x) => x.id === m.id)) {
          this.messages.push(m);
          added = true;
        }
      }
      if (added) {
        this.messages.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
        this.scrollChatToBottom();
      }
    },
    async loadConversationExtras(conversationId) {
      const result = await this.sdk.message.extras({
        conversationId
      });
      if (this.selectedConversation?.id !== conversationId) {
        return;
      }
      const byMessage = {};
      for (const entry of result.reactions) {
        const list = byMessage[entry.messageId] ?? [];
        list.push(entry);
        byMessage[entry.messageId] = list;
      }
      this.reactions = byMessage;
      this.pinnedById = result.pinnedById;
      await this.applyPinnedPayload(result.pinned, conversationId);
    },
    /** 고정 메시지 띠 갱신 — extras 응답·실시간 이벤트 공용. 암호화 방이면 띠 글도 기기가 푼다 */
    async applyPinnedPayload(payload, conversationId) {
      if (!payload) {
        this.pinnedMessage = null;
        return;
      }
      const item = mapMessageItem(payload, this.currentUserId);
      const loaded = this.messages.find((m) => m.id === item.id);
      if (loaded && !loaded.isUnreadable) {
        this.pinnedMessage = loaded;
        return;
      }
      await this.decryptMessageItems([
        item
      ]);
      if (this.selectedConversation?.id !== conversationId) {
        return;
      }
      this.pinnedMessage = item;
    },
    /**
    * 목록의 암호화 방 미리보기(2026-10-12) — 앱을 켜거나 새로고침한 첫 목록에서 방마다 「암호화된 대화」만 보이던 것.
    * 서버가 실어 준 마지막 메시지 암호문을 이 기기의 세대 키(IndexedDB)로 풀어 한 줄로 만든다. 키가 없는 방(이 기기에서
    * 한 번도 안 연 방, 멤버가 바뀌어 세대가 올라간 방)은 먼저 로컬로 시도하고, 안 풀리면 서버에서 내 세대 봉투를 한 번
    * 가져와(`sync`, 세대는 만들지 않음) 다시 푼다 — 방을 열기 전까지 「새 메시지가 도착했어요」만 보이던 것(2026-10-12).
    * 봉투를 가져와 본 (방:세대)는 세션에 한 번만이라 목록을 자주 다시 읽어도 요청이 늘지 않는다.
    */
    async decryptConversationPreviews(items) {
      const targets = items.filter((c) => c.encryptionEpoch && c.lastMessageEncrypted);
      if (targets.length === 0) {
        return;
      }
      const unresolved = await Promise.all(targets.map((conv) => this.decryptConversationPreview(conv)));
      if (this.getChatKeyManager().currentState !== "ready") {
        return;
      }
      const rooms = this.getConversationKeyManager();
      for (const conv of unresolved) {
        if (!conv) {
          continue;
        }
        const src = conv.lastMessageEncrypted;
        const epoch = isEncryptedMessage(src) ? src.keyEpoch : conv.encryptionEpoch;
        const mark = `${conv.id}:${epoch}`;
        if (this.previewKeyFetched.has(mark)) {
          continue;
        }
        this.previewKeyFetched.add(mark);
        try {
          await rooms.sync(conv.id, false);
        } catch {
          continue;
        }
        await this.decryptConversationPreview(conv);
      }
    },
    /** 방 하나의 미리보기를 이 기기 키로 푼다. 못 풀었으면(키 없음) 그 방을 돌려준다. */
    async decryptConversationPreview(conv) {
      const src = conv.lastMessageEncrypted;
      if (!src) {
        return null;
      }
      const t = herebyStore(this).t;
      const labels = {
        deleted: t("messenger.deleted_message"),
        file: `[${t("messenger.file_prefix")}]`
      };
      const organizationId = herebyStore(this).currentUser?.organizationId || "";
      let plain = null;
      let needsKey = false;
      if (!src.isDeleted) {
        const cached = this.decryptedTextById.get(src.id);
        if (cached !== void 0) {
          plain = {
            text: cached
          };
        } else if (!isEncryptedMessage(src) && src.content) {
          plain = {
            text: src.content
          };
        } else if (isEncryptedMessage(src) && src.senderId) {
          try {
            plain = await decryptIncomingMessage(this.getConversationKeyManager(), organizationId, {
              id: src.id,
              conversationId: conv.id,
              senderId: src.senderId,
              ciphertext: src.ciphertext,
              keyEpoch: src.keyEpoch,
              keyWrap: src.keyWrap,
              encVersion: src.encVersion ?? 1
            });
          } catch {
            plain = null;
          }
          needsKey = plain === null;
        }
      }
      const text = encryptedPreviewText(src, plain, labels);
      if (text !== null) {
        conv.lastMessage = text;
      } else if (needsKey) {
        conv.lastMessage = "";
      }
      return needsKey ? conv : null;
    },
    /** 암호화 방의 목록 미리보기 — 서버에 없으므로 이 세션에서 푼 마지막 메시지로 채운다(MED-893). */
    refreshConversationPreview(conversationId) {
      const conv = this.conversations.find((c) => c.id === conversationId);
      if (!conv?.encryptionEpoch) {
        return;
      }
      const last = [
        ...this.messages
      ].reverse().find((m) => !m.isDeleted && m.content);
      if (last) {
        conv.lastMessage = last.type === "text" ? last.content : `[\uD30C\uC77C] ${last.content}`;
      }
    },
    async loadOlderMessages() {
      if (this.currentPage >= this.totalPages || this.olderExhausted || this.loadingOlderMessages || !this.selectedConversation) {
        return;
      }
      this.loadingOlderMessages = true;
      const chatEl = document.getElementById("chat-messages");
      const oldScrollHeight = chatEl?.scrollHeight || 0;
      try {
        const olderPage = this.currentPage + 1;
        const oldestRaw = this.messages.find((m) => m.timestamp)?.timestamp;
        const oldest = oldestRaw ? new Date(oldestRaw).toISOString() : void 0;
        const result = await this.sdk.message.list(oldest ? {
          conversationId: this.selectedConversation.id,
          before: oldest,
          pagination: {
            page: 1,
            limit: 50
          }
        } : {
          conversationId: this.selectedConversation.id,
          pagination: {
            page: olderPage,
            limit: 50
          }
        });
        const items = result?.items || [];
        const existingIds = new Set(this.messages.map((message) => message.id));
        const olderMessages = items.filter((message) => !existingIds.has(message.id)).map((message) => mapMessageItem(message, this.currentUserId));
        await this.decryptMessageItems(olderMessages);
        this.cacheMessages(items);
        this.messages = [
          ...olderMessages,
          ...this.messages
        ];
        this.currentPage = olderPage;
        const hasMore = result?.hasMore;
        this.olderExhausted = hasMore === false || items.length === 0;
        this.totalPages = this.olderExhausted ? olderPage : olderPage + 1;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            if (chatEl) {
              chatEl.scrollTop = chatEl.scrollHeight - oldScrollHeight;
            }
          });
        });
      } catch (_e) {
      } finally {
        this.loadingOlderMessages = false;
      }
    },
    /* ── 연락처 프로필 ───────────────────────────────────────────────
    연락처를 누르면 1:1 채팅 전에 이 화면을 먼저 보인다 — 사진 · 소속 · 역할 · 직무/직군/직위 · 이메일,
    병원이 공개하면 전화번호와 「전화하기」. 정보는 서버 employee.contactProfile 이 정한다. */
    profileContact: null,
    /** 프로필을 연 화면 — 뒤로 가기는 여기로 돌아간다(채팅방 아바타에서 열었으면 그 방, 연락처에서 열었으면 연락처). */
    contactProfileReturnView: "contacts",
    contactProfile: null,
    contactProfileLoading: false,
    contactProfileFailed: false,
    contactProfilePhotoUrl: "",
    /** 늦게 온 응답이 다른 사람의 프로필을 덮지 않게 */
    contactProfileSeq: 0,
    async openContactProfile(contact) {
      const seq = ++this.contactProfileSeq;
      this.profileContact = contact;
      this.contactProfile = null;
      this.contactProfilePhotoUrl = "";
      this.contactProfileFailed = false;
      this.contactProfileLoading = true;
      this.contactProfileReturnView = this.activeView === "chat" && this.selectedConversation ? "chat" : "contacts";
      this.activeView = "contactProfile";
      try {
        const profile = await this.sdk.employee.getContactProfile(contact.id);
        if (seq !== this.contactProfileSeq) {
          return;
        }
        this.contactProfile = profile;
        this.contactProfileFailed = !profile;
        if (profile?.profilePicture) {
          herebyStore(this).getFileUrl(profile.profilePicture).then((url) => {
            if (seq === this.contactProfileSeq) {
              this.contactProfilePhotoUrl = url;
            }
          }).catch(() => void 0);
        }
      } catch (_e) {
        if (seq === this.contactProfileSeq) {
          this.contactProfileFailed = true;
        }
      } finally {
        if (seq === this.contactProfileSeq) {
          this.contactProfileLoading = false;
        }
      }
    },
    closeContactProfile() {
      this.contactProfileSeq++;
      this.activeView = this.contactProfileReturnView === "chat" && this.selectedConversation ? "chat" : "contacts";
      this.profileContact = null;
      this.contactProfile = null;
      this.contactProfilePhotoUrl = "";
    },
    /** 프로필의 정보 줄 — 빈 칸은 빼고, 전화번호는 공개일 때만 */
    get contactProfileRows() {
      return this.contactProfile ? contactProfileRows(this.contactProfile) : [];
    },
    /** 「전화하기」 링크 — 공개된 번호가 있을 때만(없으면 버튼 자체를 그리지 않는다) */
    get contactProfileTel() {
      const p = this.contactProfile;
      if (!(p?.phoneShared && p.phone)) {
        return "";
      }
      return `tel:${p.phone.replace(/[^0-9+]/g, "")}`;
    },
    /** 프로필의 「1:1 채팅」 — 이미 있는 대화면 그 방, 없으면 새로 만든다(startConversation). */
    async chatWithProfileContact() {
      const contact = this.profileContact;
      if (!contact) {
        return;
      }
      if (this.isMe(contact)) {
        await this.openSelfChat();
      } else {
        await this.startConversation(contact);
      }
      if (this.activeView !== "contactProfile") {
        this.contactProfileSeq++;
        this.profileContact = null;
        this.contactProfile = null;
        this.contactProfilePhotoUrl = "";
      }
    },
    /* ── 「나와의 대화」 (MED-903) ── */
    /** 목록에 있는 내 메모방 — 없으면 openSelfChat 이 만든다. 입구는 상단 프로필 시트·연락처 이름 검색 */
    get selfConversation() {
      return this.conversations.find((c) => c.type === "self");
    },
    async openSelfChat() {
      const listed = this.selfConversation;
      if (listed) {
        await this.openConversation(listed);
        return;
      }
      let convId = "";
      try {
        const result = await this.sdk.conversation.ensureSelf();
        convId = result?.data?.id || "";
      } catch (_e) {
        showError(herebyStore(this).t("messenger.self_chat_open_failed"));
        return;
      }
      if (!convId) {
        return;
      }
      const conv = {
        id: convId,
        type: "self",
        title: "",
        contactName: herebyStore(this).t("messenger.self_chat"),
        contactRole: herebyStore(this).t("messenger.self_chat_hint"),
        lastMessage: "",
        lastMessageTime: (/* @__PURE__ */ new Date()).toISOString(),
        unreadCount: 0,
        isPinned: false
      };
      this.conversations.unshift(conv);
      await this.openConversation(conv);
    },
    async startConversation(contact) {
      const existing = this.conversations.find((c) => c.type === "direct" && (c.memberIds ?? []).includes(contact.id));
      if (existing) {
        await this.openConversation(existing);
        return;
      }
      try {
        const result = await this.sdk.conversation.create({
          type: "direct",
          memberIds: [
            contact.id
          ],
          attestation: await this.membershipAttestation("create", null, [
            contact.id
          ])
        });
        const convId = result?.data?.id || result?.id;
        if (convId) {
          const listed = this.conversations.find((c) => c.id === convId);
          if (listed) {
            await this.openConversation(listed);
            return;
          }
          const conv = {
            id: convId,
            type: "direct",
            title: "",
            contactName: contact.name,
            contactRole: contact.role,
            memberIds: [
              this.currentUserId,
              contact.id
            ],
            lastMessage: "",
            lastMessageTime: (/* @__PURE__ */ new Date()).toISOString(),
            unreadCount: 0,
            isPinned: false
          };
          this.conversations.unshift(conv);
          await this.openConversation(conv);
        }
      } catch (_e) {
        await this.loadConversations();
        const listed = this.conversations.find((c) => c.type === "direct" && (c.memberIds ?? []).includes(contact.id));
        if (listed) {
          await this.openConversation(listed);
        }
      }
    },
    async startTeamConversation(group) {
      const team = group.name;
      const teamContacts = group.contacts;
      if (teamContacts.length === 0) {
        return;
      }
      const existing = findTeamConversation(this.conversations, group, this.contactGroups);
      if (existing) {
        await this.openConversation(existing);
        return;
      }
      try {
        const memberIds = teamContacts.map((c) => c.id);
        const result = await this.sdk.conversation.create({
          type: "group",
          title: team,
          memberIds,
          attestation: await this.membershipAttestation("create", null, memberIds.filter((id) => id !== this.currentUserId))
        });
        const convId = result?.data?.id || result?.id;
        if (convId) {
          const conv = {
            id: convId,
            type: "group",
            title: team,
            contactName: team,
            contactRole: `${teamContacts.length}\uBA85`,
            // 목록을 다시 읽기 전에 「단체」를 또 눌러도 이 방을 찾도록(findTeamConversation).
            memberIds: [
              ...memberIds,
              this.currentUserId
            ],
            lastMessage: "",
            lastMessageTime: (/* @__PURE__ */ new Date()).toISOString(),
            unreadCount: 0,
            isPinned: false
          };
          this.conversations.unshift(conv);
          this.selectedConversation = conv;
          this.messages = [];
          this.activeView = "chat";
        }
      } catch (_e) {
        await this.loadConversations();
      }
    },
    /* ── Group chat ── */
    enterGroupSelect() {
      this.groupSelectMode = true;
      this.groupSelectedIds = /* @__PURE__ */ new Set();
      this.groupTitle = "";
      this.showGroupTitleSheet = false;
      this.activeView = "contacts";
    },
    exitGroupSelect() {
      this.groupSelectMode = false;
      this.groupSelectedIds = /* @__PURE__ */ new Set();
      this.groupTitle = "";
      this.showGroupTitleSheet = false;
    },
    openGroupTitleSheet() {
      if (this.groupSelectedIds.size < 2) {
        showAlert(herebyStore(this).t("messenger.group_min_members"));
        return;
      }
      this.groupTitle = "";
      this.showGroupTitleSheet = true;
      this.$nextTick(() => {
        const input = this.$refs.groupTitleInput;
        input?.focus();
      });
    },
    closeGroupTitleSheet() {
      this.showGroupTitleSheet = false;
      this.groupTitle = "";
    },
    toggleGroupMember(contactId) {
      if (this.groupSelectedIds.has(contactId)) {
        this.groupSelectedIds.delete(contactId);
      } else {
        this.groupSelectedIds.add(contactId);
      }
      this.groupSelectedIds = new Set(this.groupSelectedIds);
    },
    isGroupSelected(contactId) {
      return this.groupSelectedIds.has(contactId);
    },
    /** 팀 · 전체 체크박스 상태 — 그룹 대화 선택용. */
    groupSelectionState(ids) {
      return selectionState(ids, this.groupSelectedIds);
    },
    /** 팀 · 전체 체크박스 — 전원 선택돼 있으면 이 묶음만 해제, 아니면 전원 선택. */
    toggleGroupMembers(ids) {
      this.groupSelectedIds = toggleSelection(this.groupSelectedIds, ids);
    },
    /** 「전체 선택」 대상 — 검색 중이면 검색 결과, 아니면 연락처 전부. */
    get groupPickableIds() {
      const list = this.isSearching ? this.searchedContacts : this.contacts;
      return list.map((c) => c.id);
    },
    get groupSelectedCount() {
      return this.groupSelectedIds.size;
    },
    async createGroupChat() {
      if (this.groupSelectedIds.size < 2) {
        showAlert(herebyStore(this).t("messenger.group_min_members"));
        return;
      }
      if (!this.groupTitle.trim()) {
        showAlert(herebyStore(this).t("messenger.group_name_required"));
        return;
      }
      if (this.groupCreating) {
        return;
      }
      this.groupCreating = true;
      try {
        const memberIds = [
          ...this.groupSelectedIds
        ];
        const result = await this.sdk.conversation.create({
          type: "group",
          title: this.groupTitle.trim(),
          memberIds,
          attestation: await this.membershipAttestation("create", null, memberIds.filter((id) => id !== this.currentUserId))
        });
        const convId = result?.data?.id || result?.id;
        if (convId) {
          const conv = {
            id: convId,
            type: "group",
            title: this.groupTitle.trim(),
            contactName: this.groupTitle.trim(),
            contactRole: `${memberIds.length + 1}\uBA85`,
            lastMessage: "",
            lastMessageTime: (/* @__PURE__ */ new Date()).toISOString(),
            unreadCount: 0,
            isPinned: false
          };
          this.conversations.unshift(conv);
          this.exitGroupSelect();
          this.selectedConversation = conv;
          this.messages = [];
          this.activeView = "chat";
        }
      } catch (_e) {
        showError(herebyStore(this).t("messenger.group_create_failed"));
      } finally {
        this.groupCreating = false;
      }
    },
    /* ── Member drawer ── */
    async openMemberDrawer() {
      if (!this.selectedConversation) {
        return;
      }
      try {
        const result = await this.sdk.conversation.getMembers(this.selectedConversation.id);
        this.drawerMembers = result?.members || [];
        this.drawerLeftMembers = result?.leftMembers || [];
        this.drawerPendingMembers = result?.pendingMembers || [];
        this.drawerMyRole = result?.myRole || "member";
        this.roomNameInput = this.selectedConversation.customName || this.selectedConversation.title || "";
        this.showMemberDrawer = true;
      } catch (_e) {
        showError("\uBA64\uBC84 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC62C \uC218 \uC5C6\uC2B5\uB2C8\uB2E4");
      }
    },
    /**
    * 방 멤버 칸을 서버 기준으로 다시 맞춘다(2026-10-20) — 목록 항목과 선택된 대화의 memberIds·memberNames·contactRole,
    * 그리고 @멘션 후보. 초대·내보내기·나가기는 한 기기에서 일어나지만 **다른 멤버의 기기**는 시스템 메시지만 받아
    * 헤더 「N명」·안 읽은 수(멤버 수가 분모)·멘션 후보가 앱을 다시 켤 때까지 옛 상태로 남았다.
    * 시스템 메시지가 도착할 때와 내가 초대·내보내기를 끝냈을 때 부른다. 실패하면 조용히 둔다 — 다음 목록 재조회가 맞춘다.
    */
    async refreshRoomMembership(conversationId) {
      try {
        const result = await this.sdk.conversation.getMembers(conversationId);
        const members = result?.members ?? [];
        const targets = [
          this.conversations.find((c) => c.id === conversationId),
          this.selectedConversation?.id === conversationId ? this.selectedConversation : null
        ].filter(Boolean);
        for (const target of targets) {
          const updated = applyMembersToItem(target, members);
          target.memberIds = updated.memberIds;
          target.memberNames = updated.memberNames;
          target.contactRole = updated.contactRole;
        }
        if (this.selectedConversation?.id === conversationId) {
          this.mentionCandidates = members.filter((m) => m.employeeId !== this.currentUserId).map((m) => ({
            employeeId: m.employeeId,
            name: m.name
          }));
          this.mentionCandidatesFor = conversationId;
        }
      } catch {
      }
    },
    async refreshDrawerMembers() {
      if (!this.selectedConversation) {
        return;
      }
      try {
        const result = await this.sdk.conversation.getMembers(this.selectedConversation.id);
        this.drawerMembers = result?.members || [];
        this.drawerLeftMembers = result?.leftMembers || [];
        this.drawerPendingMembers = result?.pendingMembers || [];
        this.drawerMyRole = result?.myRole || "member";
      } catch {
      }
    },
    closeMemberDrawer() {
      this.showMemberDrawer = false;
    },
    async saveCustomRoomName() {
      if (!this.selectedConversation) {
        return;
      }
      try {
        await this.sdk.conversation.updateMemberSettings(this.selectedConversation.id, this.roomNameInput.trim() || null);
        if (this.roomNameInput.trim()) {
          this.selectedConversation.contactName = this.roomNameInput.trim();
          this.selectedConversation.customName = this.roomNameInput.trim();
        }
        showAlert("\uB300\uD654\uBC29 \uC774\uB984\uC774 \uBCC0\uACBD\uB418\uC5C8\uC2B5\uB2C8\uB2E4");
      } catch (_e) {
        showError("\uC774\uB984 \uBCC0\uACBD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4");
      }
    },
    /**
    * DS 안내 팝업(확인 버튼 하나) — 템플릿에서 부르는 이름을 유지하기 위한 얇은 래퍼.
    * 실제 표시는 공용 다이얼로그(`@hereby/components` dialog 스토어)가 맡는다.
    * ⚠️ 예전엔 스토어가 없는 앱에서 네이티브 alert 으로 떨어졌는데, 네이티브 alert 은
    *    모바일에서 OS 시스템 대화상자로 떠서 DS 와 따로 놀 뿐 아니라 닫는 순간
    *    화면이 튕겨(포커스·고스트 클릭) 열려 있던 화면에서 이탈하는 사고가 있었다.
    *    공용 다이얼로그는 컴포넌트 플러그인이 모든 앱에 등록하므로 폴백이 필요 없다.
    */
    async showAlert(message, title = "") {
      showAlert(title ? {
        message,
        title
      } : message);
    },
    async openWorkflowAction(message) {
      const action = message.action;
      if (!action || action.kind !== "annual_leave_promotion_sign") {
        return;
      }
      const promotionId = typeof action.promotionId === "string" ? action.promotionId : "";
      const attemptId = typeof action.signAttemptId === "string" ? action.signAttemptId : "";
      if (!(promotionId && attemptId)) {
        await this.showAlert("\uC11C\uBA85 \uC694\uCCAD \uC815\uBCF4\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.");
        return;
      }
      try {
        const result = await this.sdk.annualLeavePromotion.openSigner({
          promotionId,
          attemptId
        });
        const url = new URL(result.sessionUrl, window.location.origin);
        if (!/^https?:$/.test(url.protocol) || url.protocol !== "https:" && window.location.hostname !== "localhost") {
          throw new Error("Invalid signer session origin");
        }
        window.location.assign(url.toString());
      } catch (_error) {
        showError("\uD604\uC7AC \uC11C\uBA85\uD560 \uC218 \uC788\uB294 \uC694\uCCAD\uC774 \uC544\uB2C8\uC5D0\uC694.");
      }
    },
    /** DS 확인 팝업(확인/취소). */
    async askConfirm(message, options = {}) {
      return askConfirm({
        message,
        tone: options.danger ? "danger" : "default"
      });
    },
    /** 드로어의 「대화방 나가기」, 또는 목록 메뉴에서 고른 방(`target`) — 열려 있지 않은 방은 역할을 따로 읽는다. */
    async leaveConversation(target) {
      const conv = target ?? this.selectedConversation;
      if (!conv) {
        return;
      }
      const isOpen = this.selectedConversation?.id === conv.id;
      if (conv.type === "self") {
        await this.showAlert(herebyStore(this).t("messenger.self_chat_cannot_leave"));
        return;
      }
      let myRole = this.drawerMyRole;
      if (!isOpen && (conv.type === "department" || conv.type === "group")) {
        try {
          const result = await this.sdk.conversation.getMembers(conv.id);
          myRole = result?.myRole || "member";
        } catch {
          myRole = "member";
        }
      }
      if (conv.type === "department") {
        if (myRole === "owner") {
          await this.showAlert("\uBC29\uC7A5 \uAD8C\uD55C\uC744 \uB2E4\uB978 \uC0AC\uB78C\uC5D0\uAC8C \uC704\uC784\uD55C \uD6C4\uC5D0 \uB098\uAC08 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
          return;
        }
        await this.showAlert("\uBD80\uC11C \uD544\uC218 \uB2E8\uD1A1\uBC29\uC740 \uB098\uAC08 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
        return;
      }
      if (conv.type === "group" && myRole === "owner") {
        if (!isOpen) {
          await this.openConversation(conv);
        }
        this.showDissolveConfirm = true;
        return;
      }
      if (!await this.askConfirm("\uC774 \uB300\uD654\uBC29\uC744 \uB098\uAC00\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\uB098\uAC04 \uD6C4\uC5D0\uB294 \uC774\uC804 \uB300\uD654 \uB0B4\uC6A9\uC744 \uBCFC \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.", {
        danger: true
      })) {
        return;
      }
      try {
        await this.sdk.conversation.leave(conv.id);
        this.conversations = this.conversations.filter((c) => c.id !== conv.id);
        this.syncGlobalUnreadCount();
        if (isOpen) {
          this.closeMemberDrawer();
          this.goBack();
        }
      } catch (e) {
        const msg = e?.message || "\uB300\uD654\uBC29 \uB098\uAC00\uAE30\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4";
        await this.showAlert(msg);
      }
    },
    /** Owner-only: open the ownership transfer picker. */
    openTransferOwnership() {
      this.showTransferOwnership = true;
    },
    closeTransferOwnership() {
      this.showTransferOwnership = false;
    },
    async transferOwnershipTo(newOwnerId, name) {
      const conv = this.selectedConversation;
      if (!conv) {
        return;
      }
      if (!await this.askConfirm(`${name}\uB2D8\uC5D0\uAC8C \uBC29\uC7A5 \uAD8C\uD55C\uC744 \uC704\uC784\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?`)) {
        return;
      }
      try {
        await this.sdk.conversation.transferOwnership(conv.id, newOwnerId);
        this.showTransferOwnership = false;
        await this.refreshDrawerMembers();
      } catch (e) {
        await this.showAlert(e?.message || "\uBC29\uC7A5 \uC704\uC784\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4");
      }
    },
    /** Group-room owner: dissolve the room (방장이 나가면서 방 해체). */
    async confirmDissolveRoom() {
      const conv = this.selectedConversation;
      if (!conv) {
        return;
      }
      try {
        await this.sdk.conversation.leaveAndDissolve(conv.id);
        this.conversations = this.conversations.filter((c) => c.id !== conv.id);
        this.showDissolveConfirm = false;
        this.closeMemberDrawer();
        this.goBack();
      } catch (e) {
        showError(e?.message || "\uB2E8\uD1A1\uBC29 \uD574\uCCB4\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4");
      }
    },
    cancelDissolveRoom() {
      this.showDissolveConfirm = false;
    },
    /** Owner-only: approve a pending join request (department-mandatory rooms). */
    async approvePendingMember(employeeId, name) {
      const conv = this.selectedConversation;
      if (!conv) {
        return;
      }
      if (!await askConfirm(`${name}\uB2D8\uC758 \uC785\uC7A5\uC744 \uC2B9\uC778\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?`)) {
        return;
      }
      try {
        await this.sdk.conversation.approveMember(conv.id, employeeId);
        await this.refreshDrawerMembers();
      } catch (e) {
        showError(e?.message || "\uC785\uC7A5 \uC2B9\uC778\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4");
      }
    },
    async kickMember(employeeId, name) {
      if (!this.selectedConversation) {
        return;
      }
      if (!await askConfirm({
        message: `${name}\uB2D8\uC744 \uB0B4\uBCF4\uB0B4\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?`,
        tone: "danger"
      })) {
        return;
      }
      const conv = this.selectedConversation;
      try {
        await this.sdk.conversation.removeMember(conv.id, employeeId, await this.membershipAttestation("remove", conv.id, [
          employeeId
        ]));
        this.drawerMembers = this.drawerMembers.filter((m) => m.employeeId !== employeeId);
        const updated = removeMemberFromItem(conv, employeeId);
        conv.members = updated.members;
        conv.memberIds = updated.memberIds;
        conv.contactRole = updated.contactRole;
        const listed = this.conversations.find((c) => c.id === conv.id);
        if (listed && listed !== conv) {
          listed.members = updated.members;
          listed.memberIds = updated.memberIds;
          listed.contactRole = updated.contactRole;
        }
      } catch (_e) {
        showError("\uBA64\uBC84 \uB0B4\uBCF4\uB0B4\uAE30\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4");
        return;
      }
      try {
        await this.loadConversations();
        const refreshed = this.conversations.find((c) => c.id === conv.id);
        if (refreshed && this.selectedConversation?.id === conv.id) {
          this.selectedConversation = refreshed;
        }
        await this.refreshRoomMembership(conv.id);
        await this.loadMessages(conv.id);
      } catch {
      }
      if (this.isEncryptableConversation(conv)) {
        this.roomKeySync = null;
        await this.syncRoomKeys(conv);
      }
    },
    /* ── Chat invite ── */
    openChatInvite() {
      this.chatInviteSelectedIds = /* @__PURE__ */ new Set();
      this.chatInviteSearch = "";
      this.showChatInvite = true;
    },
    closeChatInvite() {
      this.showChatInvite = false;
      this.chatInviteSelectedIds = /* @__PURE__ */ new Set();
    },
    /** Contacts filtered to exclude current members. Search matches name,
    *  role, or any team name. */
    get chatInviteContacts() {
      const currentMemberIds = new Set(this.drawerMembers.map((m) => m.employeeId));
      let list = this.contacts.filter((c) => !currentMemberIds.has(c.id));
      if (this.chatInviteSearching) {
        const term = this.chatInviteSearch.trim().toLowerCase();
        list = list.filter((c) => contactMatchesTerm(c, term));
      }
      return list;
    },
    /** 초대 검색 중이면 팀 묶음 없이 평평한 결과 목록(연락처 탭 검색과 같다). */
    get chatInviteSearching() {
      return this.chatInviteSearch.trim().length > 0;
    },
    /**
    * 초대 목록의 구간 — 검색 중이면 머리 없는 평평한 한 구간(연락처 탭 검색과 같다), 아니면 팀별 묶음.
    * 이미 방에 있는 사람은 빠진 채로 묶인다. 행 마크업을 한 벌로 두려고 두 경우를 같은 모양으로 낸다.
    */
    get chatInviteSections() {
      const contacts = this.chatInviteContacts;
      if (this.chatInviteSearching) {
        return [
          {
            key: "",
            name: "",
            contacts,
            ids: contacts.map((c) => c.id),
            flat: true
          }
        ];
      }
      return groupContactsByTeam(contacts, herebyStore(this).t("messenger.unassigned")).map((group) => ({
        ...group,
        flat: false
      }));
    },
    /** 「전체 선택」 대상 — 지금 보이는 초대 후보 전부(검색 중이면 검색 결과). */
    get chatInvitePickableIds() {
      return this.chatInviteContacts.map((c) => c.id);
    },
    chatInviteSelectionState(ids) {
      return selectionState(ids, this.chatInviteSelectedIds);
    },
    toggleChatInviteMembers(ids) {
      this.chatInviteSelectedIds = toggleSelection(this.chatInviteSelectedIds, ids);
    },
    toggleChatInvite(contactId) {
      if (this.chatInviteSelectedIds.has(contactId)) {
        this.chatInviteSelectedIds.delete(contactId);
      } else {
        this.chatInviteSelectedIds.add(contactId);
      }
      this.chatInviteSelectedIds = new Set(this.chatInviteSelectedIds);
    },
    async submitChatInvite() {
      if (!this.selectedConversation || this.chatInviteSelectedIds.size === 0) {
        return;
      }
      if (this.chatInviting) {
        return;
      }
      this.chatInviting = true;
      const conversationId = this.selectedConversation.id;
      try {
        const inviteIds = [
          ...this.chatInviteSelectedIds
        ];
        const result = await this.sdk.conversation.addMembers({
          conversationId,
          employeeIds: inviteIds,
          attestation: await this.membershipAttestation("add", conversationId, inviteIds)
        });
        if (result?.data?.type) {
          this.selectedConversation.type = result.data.type;
        }
        this.closeChatInvite();
        this.closeMemberDrawer();
        await this.loadConversations();
        const refreshed = this.conversations.find((c) => c.id === conversationId);
        if (refreshed) {
          this.selectedConversation = refreshed;
        }
        await this.refreshRoomMembership(conversationId);
        await this.fillRoomKeyEnvelopes(refreshed ?? this.selectedConversation);
        await this.loadMessages(conversationId);
      } catch (_e) {
        await this.showAlert("\uCD08\uB300\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4");
      } finally {
        this.chatInviting = false;
      }
    },
    goBack() {
      if (this.previewImageUrl) {
        this.closeImagePreview();
        return;
      }
      if (this.showChatInvite) {
        this.closeChatInvite();
        return;
      }
      if (this.showDissolveConfirm) {
        this.cancelDissolveRoom();
        return;
      }
      if (this.showTransferOwnership) {
        this.closeTransferOwnership();
        return;
      }
      if (this.showGroupTitleSheet) {
        this.closeGroupTitleSheet();
        return;
      }
      if (this.showMemberDrawer) {
        this.closeMemberDrawer();
        return;
      }
      if (this.groupSelectMode) {
        this.exitGroupSelect();
        return;
      }
      if (this.activeView === "contactProfile") {
        this.closeContactProfile();
        return;
      }
      if (this.activeView === "noticeDetail") {
        this.activeView = "conversations";
        this.selectedNotice = null;
        return;
      }
      this.unsubscribeFromConversation();
      if (this.prefilledDraft && this.messageInput === this.prefilledDraft) {
        this.messageInput = "";
      }
      this.prefilledDraft = "";
      if (this.selectedConversation) {
        this.saveDraftFor(this.selectedConversation.id);
      }
      this.messageInput = "";
      this.pendingFiles = [];
      this.replyTarget = null;
      this.activeView = "conversations";
      this.selectedConversation = null;
      this.syncViewingPresence();
      this.clearInitialAutoScroll();
      this.messages = [];
      this.newMessagesBelow = 0;
    },
    /* ── 입력칸(여러 줄) ─────────────────────────────────────────────
    한 줄 <input> 이던 것을 textarea 로 — 줄이 넘치면 높이가 따라 자라고, 최대 높이(5줄 · 화면 설정
    「크게」는 4줄, employee-app main.css)를 넘으면 칸 안에서 스크롤한다. */
    /** Enter — 보내기, Shift+Enter — 줄바꿈(PC · 휴대폰 공통). */
    /** 휴대폰(손가락 입력)인가 — 입력줄의 Enter 판정과 키보드 Enter 키 모양(`enterkeyhint`)이 이 값을 본다. */
    get composerCoarsePointer() {
      return isCoarsePointer();
    },
    onComposerEnter(event) {
      if (this.mentionPicker.open && !event.isComposing && this.mentionMatches.length > 0) {
        event.preventDefault();
        this.pickMention(this.mentionMatches[this.mentionPicker.index] ?? this.mentionMatches[0]);
        return;
      }
      if (!shouldSendOnEnter({
        isComposing: event.isComposing,
        shiftKey: event.shiftKey,
        coarsePointer: this.composerCoarsePointer
      })) {
        return;
      }
      event.preventDefault();
      if (this.pendingFiles.length > 0) {
        this.sendAttachments();
      } else {
        this.sendMessage();
      }
    },
    /** 내용 높이만큼 늘린다 — 줄어드는 쪽도 맞게 재려고 height:auto 로 한 번 되돌린다(AI 어시스턴트와 같은 방식).
    *  보낸 뒤 비워지거나 밖에서 문구를 채워 넣을 때도 x-effect 가 다시 부른다. */
    autosizeMessageInput(el2) {
      const field = el2 ?? this.composerField();
      if (!(field instanceof HTMLTextAreaElement)) {
        return;
      }
      field.style.height = "auto";
      field.style.height = `${field.scrollHeight}px`;
    },
    /* ── Messaging ── */
    /**
    * 보낼 메시지의 암호문 필드(MED-893). 평문 방이면 null, 암호화 방인데 이 기기에 현재 세대 키가 없으면 "missing-key".
    * 세대가 바뀌었을 수 있어 보내기 직전에 한 번 더 동기화한다.
    */
    async buildEncryptedFields(conv, payload) {
      if (!(this.isEncryptableConversation(conv) && conv.encryptionEpoch)) {
        return null;
      }
      if (!this.roomKeySync?.haveCurrentKey) {
        await this.syncRoomKeys(conv);
      }
      const epoch = this.roomKeySync?.currentEpoch ?? conv.encryptionEpoch;
      if (!(this.roomKeySync?.haveCurrentKey && epoch)) {
        return "missing-key";
      }
      await this.fillRoomKeyEnvelopes(conv);
      const user = herebyStore(this).currentUser;
      try {
        return await encryptOutgoingMessage({
          rooms: this.getConversationKeyManager(),
          organizationId: user?.organizationId || "",
          conversationId: conv.id,
          senderId: user?.id || "",
          keyEpoch: epoch,
          payload: {
            text: payload.text,
            ...payload.attachments && payload.attachments.length > 0 ? {
              attachments: payload.attachments.map((a) => ({
                name: a.originalName,
                mime: a.mimeType,
                size: a.size,
                storagePath: a.storagePath,
                fileKey: a.fileKey || "",
                fileIv: a.fileIv || "",
                thumbStoragePath: a.thumbStoragePath,
                thumbKey: a.thumbKey,
                thumbIv: a.thumbIv,
                width: a.width,
                height: a.height
              }))
            } : {}
          },
          recovery: await this.getRecoveryKeyInfo()
        });
      } catch {
        return "missing-key";
      }
    },
    async sendMessage() {
      const text = this.messageInput.trim();
      if (!(text && this.selectedConversation)) {
        return;
      }
      const conversationId = this.selectedConversation.id;
      const tempId = `m_${Date.now()}`;
      const msg = {
        id: tempId,
        conversationId,
        senderId: this.currentUserId,
        senderName: "\uB098",
        content: text,
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        isMine: true,
        type: "text",
        attachments: [],
        status: "sending",
        isDeleted: false,
        replyTo: this.replyTarget ? summarizeReplyTarget(this.replyTarget) : null,
        mentions: collectMentions(text, this.pickedMentions, this.mentionAllLabel())
      };
      const replyToMessageId = this.replyTarget?.id;
      const mentions = mentionsToInput(msg.mentions ?? null);
      this.replyTarget = null;
      this.pickedMentions = [];
      this.closeMentionPicker();
      this.clearDraftFor(conversationId);
      this.messages.push(msg);
      this.selectedConversation.lastMessage = text;
      this.selectedConversation.lastMessageTime = msg.timestamp;
      this.messageInput = "";
      this.focusMessageInput();
      this.scrollChatToBottom();
      try {
        const encrypted = await this.buildEncryptedFields(this.selectedConversation, {
          text
        });
        if (encrypted === "missing-key") {
          const found2 = this.messages.find((m) => m.id === tempId);
          if (found2) {
            found2.status = "failed";
          }
          showError(this.roomKeyBlockedMessage());
          return;
        }
        if (encrypted) {
          msg.id = encrypted.id;
          this.decryptedTextById.set(encrypted.id, text);
        }
        const result = await this.sdk.message.send({
          conversationId,
          content: encrypted ? "" : text,
          replyToMessageId,
          mentions,
          ...encrypted ? {
            encrypted
          } : {}
        });
        const found = this.messages.find((m) => m.id === (encrypted ? encrypted.id : tempId));
        if (found) {
          found.status = "sent";
          if (result?.data?.id) {
            const serverId = result.data.id;
            if (found.id !== serverId && this.messages.some((m) => m.id === serverId)) {
              this.messages = this.messages.filter((m) => m !== found);
            } else {
              found.id = serverId;
            }
          }
        }
        if (encrypted && (result?.data?.rejoinedMemberIds?.length ?? 0) > 0 && this.selectedConversation) {
          this.roomKeySync = null;
          await this.syncRoomKeys(this.selectedConversation);
        }
      } catch (e) {
        msg.status = "failed";
        this.reportSendFailure(e);
      }
    },
    /**
    * 보내기 실패를 삼키지 않는다(MED-979) — 예전에는 「재전송」만 보여 왜 실패했는지 알 수 없었다.
    * 세대 충돌(멤버가 빠져 세대가 바뀜 등)이면 세대 키를 다시 맞춰 둬 재전송이 통하게 한다.
    */
    reportSendFailure(e) {
      const message = e instanceof Error && e.message ? e.message : "";
      if (/세대|키/.test(message) && this.selectedConversation) {
        this.roomKeySync = null;
        this.syncRoomKeys(this.selectedConversation).catch(() => void 0);
      }
      showToastMessage(this, message ? `\uBCF4\uB0B4\uC9C0 \uBABB\uD588\uC5B4\uC694: ${message}` : "\uBCF4\uB0B4\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7AC\uC804\uC1A1\uC744 \uB20C\uB7EC \uC8FC\uC138\uC694.");
    },
    /** 재전송 — 처음 보낼 때와 같은 길(암호화 방이면 암호문)로 보낸다. 예전에는 평문으로 보내 암호화 방에서 늘 실패했다(MED-979). */
    async resendMessage(msg) {
      const conv = this.selectedConversation;
      if (!conv) {
        return;
      }
      if (msg.attachments && msg.attachments.length > 0) {
        if (await this.retryUpload(msg)) {
          return;
        }
        showError("\uCCA8\uBD80\uAC00 \uC788\uB294 \uBA54\uC2DC\uC9C0\uB294 \uB2E4\uC2DC \uBCF4\uB0B4\uAE30\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694. \uD30C\uC77C\uC744 \uB2E4\uC2DC \uC62C\uB824 \uC8FC\uC138\uC694.");
        return;
      }
      msg.status = "sending";
      try {
        const encrypted = await this.buildEncryptedFields(conv, {
          text: msg.content
        });
        if (encrypted === "missing-key") {
          msg.status = "failed";
          showError(this.roomKeyBlockedMessage());
          return;
        }
        if (encrypted) {
          msg.id = encrypted.id;
          this.decryptedTextById.set(encrypted.id, msg.content);
        }
        const result = await this.sdk.message.send({
          conversationId: msg.conversationId,
          content: encrypted ? "" : msg.content,
          ...encrypted ? {
            encrypted
          } : {}
        });
        msg.status = "sent";
        if (result?.data?.id && !this.messages.some((m) => m !== msg && m.id === result.data.id)) {
          msg.id = result.data.id;
        }
      } catch (e) {
        msg.status = "failed";
        this.reportSendFailure(e);
      }
    },
    /* ── Attachments ── */
    triggerFileInput() {
      const input = document.getElementById("chat-file-input");
      input?.click();
    },
    /**
    * 파일 고르기(2026-10-20) — 사진은 올리기 전에 기기에서 다시 인코딩(긴 변 2048 · JPEG)해 상한에 걸리지 않게 하고,
    * 그래도 상한(core upload-limits: 사진 10MB · 영상 50MB · 그 밖 25MB)을 넘는 파일은 크기와 상한을 알려 주고 뺀다.
    * 영상은 기기 인코딩이 없어 상한만 본다. 인코딩 중에는 미리보기 자리에 스피너가 돌고 그동안 채팅은 그대로 된다.
    */
    /**
    * 파일 고르기(2026-10-20) — 바로 보낼 수 있게 아무것도 기다리지 않는다. 사진 인코딩(긴 변 2048 JPEG)은 보내기를 누른 뒤
    * 말풍선이 뜬 상태에서 뒤에서 한다(카톡처럼: 미리보기 먼저 · 준비 중 → 올리는 중 %). 사진이 아닌 파일만 여기서 상한을 본다
    * (사진은 인코딩 뒤에 본다 — 휴대폰 원본은 상한을 넘어도 인코딩하면 들어온다).
    */
    handleFileSelect(event) {
      const input = event.target;
      const files = input.files ? [
        ...input.files
      ] : [];
      input.value = "";
      this.addPendingFiles(files);
    },
    /**
    * 클립보드 그림 붙여넣기(2026-10-22, 웹) — 입력칸에 Ctrl/Cmd+V 로 붙인 스크린샷이 + 버튼과 같은 첨부 대기로 들어간다.
    * 글과 같이 온 붙여넣기는 글은 평소대로 입력칸에, 그림만 첨부 대기에. 그림만 온 붙여넣기는 기본 동작을 막아 빈 글이 안 들어가게.
    */
    onComposerPaste(event) {
      const images = imageFilesFromClipboard(event.clipboardData);
      if (images.length === 0) {
        return;
      }
      if (!event.clipboardData?.getData("text/plain")) {
        event.preventDefault();
      }
      this.addPendingFiles(images);
      this.saveCurrentDraft();
    },
    /** 첨부 대기에 파일을 더한다 — + 버튼·붙여넣기 공용. 그림이 아닌 파일은 여기서 용량 상한을 본다(그림은 인코딩 뒤에) */
    addPendingFiles(files) {
      const t = herebyStore(this).t;
      for (const file of files) {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          const limit = messageAttachmentLimit(file.type);
          if (file.size > limit) {
            showError(t("messenger.file_too_large", {
              name: file.name,
              size: formatBytes(file.size),
              limit: formatBytes(limit)
            }));
            continue;
          }
        }
        this.pendingFiles.push({
          file,
          preview: isImage ? URL.createObjectURL(file) : ""
        });
      }
    },
    removePendingFile(index) {
      const removed = this.pendingFiles.splice(index, 1);
      if (removed[0]?.preview) {
        URL.revokeObjectURL(removed[0].preview);
      }
    },
    /**
    * 첨부 보내기(2026-10-20 비동기) — 누르는 즉시 말풍선(올리는 중 · 진행률)을 올리고 입력칸을 비워 채팅은 계속 된다.
    * 업로드는 뒤에서 돌고(파일마다 진행률 → 묶음 진행률), 다 올라가면 메시지를 서버에 보낸다.
    * 실패하면 말풍선에 「다시 보내기」(같은 파일로 다시 올림), 올리는 동안은 「취소」.
    */
    async sendAttachments(opts2 = {}) {
      if (this.pendingFiles.length === 0 || !this.selectedConversation) {
        return;
      }
      const conv = this.selectedConversation;
      const files = this.pendingFiles.map((pf) => pf.file);
      const previews = this.pendingFiles.map((pf) => pf.preview);
      const caption = this.messageInput.trim();
      const replyTarget = this.replyTarget;
      const picked = [
        ...this.pickedMentions
      ];
      this.pendingFiles = [];
      this.messageInput = "";
      this.replyTarget = null;
      this.pickedMentions = [];
      this.closeMentionPicker();
      this.clearDraftFor(conv.id);
      this.focusMessageInput();
      const tempId = `m_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
      const isImage = files.every((f) => f.type.startsWith("image/"));
      const displayText = caption || files.map((f) => f.name).join(", ");
      const msg = {
        id: tempId,
        conversationId: conv.id,
        senderId: this.currentUserId,
        senderName: "\uB098",
        content: displayText,
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        isMine: true,
        type: isImage ? "image" : "file",
        attachments: files.map((f, i) => ({
          filename: f.name,
          originalName: f.name,
          mimeType: f.type || "application/octet-stream",
          size: f.size,
          storagePath: "",
          localPreviewUrl: previews[i] || void 0
        })),
        isDeleted: false,
        replyTo: replyTarget ? summarizeReplyTarget(replyTarget) : null,
        mentions: collectMentions(displayText, picked, this.mentionAllLabel()),
        status: "uploading",
        uploadProgress: 0,
        uploadPreparing: true
      };
      this.messages.push(msg);
      const live = this.messages[this.messages.length - 1];
      conv.lastMessage = `[\uD30C\uC77C] ${displayText}`;
      conv.lastMessageTime = msg.timestamp;
      this.scrollChatToBottom();
      this.uploadJobs.set(tempId, {
        files,
        msg: live,
        // 다른 방에서 전달한 사진(2026-10-20)은 이미 줄인 파일이라 다시 인코딩하지 않는다
        encoded: opts2.encoded === true,
        caption,
        replyToMessageId: replyTarget?.id,
        mentions: mentionsToInput(msg.mentions ?? null),
        controllers: []
      });
      await this.runAttachmentUpload(live);
    },
    /** 올리는 중 취소 — 업로드를 끊고 말풍선을 거둔다(아직 서버에 메시지가 없다) */
    cancelUpload(msg) {
      const job = this.uploadJobs.get(msg.id);
      for (const c of job?.controllers ?? []) {
        c.abort();
      }
      this.uploadJobs.delete(msg.id);
      this.messages = this.messages.filter((m) => m !== msg);
    },
    /** 실패한 첨부 메시지 다시 보내기 — 같은 파일을 다시 올린다 */
    async retryUpload(msg) {
      if (!this.uploadJobs.has(msg.id)) {
        return false;
      }
      await this.runAttachmentUpload(msg);
      return true;
    },
    async runAttachmentUpload(msg) {
      const job = this.uploadJobs.get(msg.id);
      if (!job) {
        return;
      }
      const conversationId = msg.conversationId;
      const conv = this.selectedConversation?.id === conversationId ? this.selectedConversation : this.conversations.find((c) => c.id === conversationId);
      msg.status = "uploading";
      msg.uploadProgress = 0;
      job.controllers = [];
      if (!job.encoded) {
        msg.uploadPreparing = true;
        msg.uploadPrepared = 0;
        msg.uploadTotal = job.files.length;
        try {
          const encoded = [];
          for (const f of job.files) {
            encoded.push(f.type.startsWith("image/") ? await withTimeout(encodeImageForUpload(f), IMAGE_ENCODE_TIMEOUT_MS).catch(() => f) : f);
            msg.uploadPrepared = encoded.length;
          }
          job.files = encoded;
        } finally {
          msg.uploadPreparing = false;
        }
        job.encoded = true;
        const tooLarge = job.files.find((f) => f.size > messageAttachmentLimit(f.type));
        if (tooLarge) {
          this.cancelUpload(msg);
          showError(herebyStore(this).t("messenger.file_too_large", {
            name: tooLarge.name,
            size: formatBytes(tooLarge.size),
            limit: formatBytes(messageAttachmentLimit(tooLarge.type))
          }));
          return;
        }
        for (let i = 0; i < job.files.length; i++) {
          const a = msg.attachments[i];
          if (a) {
            a.size = job.files[i].size;
            a.mimeType = job.files[i].type || a.mimeType;
          }
        }
      }
      const sizes = job.files.map((f) => f.size);
      const loaded = job.files.map(() => 0);
      const report = /* @__PURE__ */ __name(() => {
        msg.uploadProgress = aggregateUploadProgress(sizes, loaded);
      }, "report");
      const progressFor = /* @__PURE__ */ __name((i) => (sent) => {
        loaded[i] = sent;
        report();
      }, "progressFor");
      const controller = /* @__PURE__ */ __name(() => {
        const c = new AbortController();
        job.controllers.push(c);
        return c;
      }, "controller");
      const isAbort = /* @__PURE__ */ __name((e) => e?.name === "AbortError", "isAbort");
      try {
        const encryptRoom = !!conv && this.isEncryptableConversation(conv) && Boolean(conv.encryptionEpoch);
        const uploadEncrypted = /* @__PURE__ */ __name(async (blob, onProgress) => {
          const bytes = new Uint8Array(await blob.arrayBuffer());
          const enc = await encryptFile(bytes);
          const name = `${globalThis.crypto.randomUUID()}.bin`;
          const upload = new File([
            enc.ciphertext
          ], name, {
            type: "application/octet-stream"
          });
          const { key } = await this.sdk.fileStorage.uploadFileWithProgress(upload, "message", conversationId, "application/octet-stream", onProgress ? (sent) => onProgress(sent) : void 0, controller().signal);
          return {
            key,
            fileKey: toBase64Url2(enc.key),
            iv: enc.iv
          };
        }, "uploadEncrypted");
        const encryptedRefs = [];
        const attachments2 = await Promise.all(job.files.map(async (file, i) => {
          if (encryptRoom) {
            const main = await uploadEncrypted(file, progressFor(i));
            let thumb = null;
            let dims = null;
            if (file.type.startsWith("image/")) {
              const t = await makeImageThumbnail(file);
              if (t) {
                thumb = await uploadEncrypted(t.blob);
                dims = {
                  width: t.width,
                  height: t.height
                };
              }
            }
            encryptedRefs.push({
              filename: main.key.split("/").pop() || file.name,
              originalName: file.name,
              mimeType: file.type || "application/octet-stream",
              size: file.size,
              storagePath: main.key,
              fileKey: main.fileKey,
              fileIv: main.iv,
              thumbStoragePath: thumb?.key,
              thumbKey: thumb?.fileKey,
              thumbIv: thumb?.iv,
              width: dims?.width,
              height: dims?.height
            });
            return {
              filename: "",
              originalName: "",
              mimeType: "application/octet-stream",
              size: file.size,
              storagePath: main.key
            };
          }
          const { key } = await this.sdk.fileStorage.uploadFileWithProgress(file, "message", conversationId, file.type || "application/octet-stream", progressFor(i), controller().signal);
          return {
            filename: file.name,
            originalName: file.name,
            mimeType: file.type || "application/octet-stream",
            size: file.size,
            storagePath: key
          };
        }));
        msg.uploadProgress = 1;
        const shownAttachments = encryptRoom ? encryptedRefs : attachments2;
        const previews = msg.attachments.map((a) => a.localPreviewUrl);
        msg.attachments = shownAttachments.map((a, i) => ({
          ...a,
          localPreviewUrl: previews[i]
        }));
        const isImage = shownAttachments.every((a) => a.mimeType.startsWith("image/"));
        const displayText = msg.content;
        let encrypted = null;
        if (encryptRoom && conv) {
          const built = await this.buildEncryptedFields(conv, {
            text: job.caption ? displayText : "",
            attachments: encryptedRefs
          });
          if (built === "missing-key" || built === null) {
            msg.status = "failed";
            showError(this.roomKeyBlockedMessage());
            return;
          }
          encrypted = built;
          msg.id = built.id;
          this.uploadJobs.set(built.id, job);
          this.decryptedTextById.set(built.id, displayText);
        }
        msg.status = "sending";
        const result = await this.sdk.message.sendWithAttachments({
          conversationId,
          content: encryptRoom ? "" : displayText,
          type: isImage ? "image" : "file",
          attachments: attachments2,
          replyToMessageId: job.replyToMessageId,
          mentions: job.mentions,
          ...encrypted ? {
            encrypted
          } : {}
        });
        const serverId = result?.data?.id;
        if (serverId) {
          if (msg.id !== serverId && this.messages.some((m) => m.id === serverId)) {
            this.messages = this.messages.filter((m) => m !== msg);
          } else {
            msg.id = serverId;
          }
        }
        msg.status = "sent";
        this.uploadJobs.delete(msg.id);
        if (this.selectedConversation?.id === conversationId && !this.messages.some((m) => m.id === msg.id)) {
          this.messages.push(msg);
          this.scrollChatToBottom();
        }
        for (const u of previews) {
          if (u) {
            URL.revokeObjectURL(u);
          }
        }
        for (const a of msg.attachments) {
          a.localPreviewUrl = void 0;
        }
        if (encrypted && (result?.data?.rejoinedMemberIds?.length ?? 0) > 0 && conv) {
          this.roomKeySync = null;
          await this.syncRoomKeys(conv);
        }
      } catch (e) {
        if (isAbort(e)) {
          return;
        }
        msg.status = "failed";
        const err = e;
        showError(err?.message || herebyStore(this).t("messenger.upload_failed"));
      }
    },
    /* ── Message Search ── */
    /** 서버 검색 결과 한 줄 → 메시지 항목 */
    // biome-ignore lint/suspicious/noExplicitAny: API response shape
    mapServerSearchItem(m) {
      return {
        id: m.id,
        conversationId: m.conversationId,
        senderId: m.senderId,
        senderName: m.sender ? `${m.sender.lastName || ""}${m.sender.firstName || ""}`.trim() : "\uC54C \uC218 \uC5C6\uC74C",
        content: m.content || "",
        timestamp: m.createdAt || "",
        isMine: m.senderId === this.currentUserId,
        type: m.type || "text",
        attachments: m.attachments || [],
        isDeleted: false
      };
    },
    /** 결과를 겹치지 않게 합치고 최신순으로 줄 세운다(서버 다음 묶음 · 이 기기 색인 공통) */
    mergeSearchResults(items) {
      const seen = new Set(this.msgSearchResults.map((m) => m.id));
      const fresh = items.filter((m) => !seen.has(m.id));
      if (fresh.length > 0) {
        this.msgSearchResults = [
          ...this.msgSearchResults,
          ...fresh
        ].sort((a, b) => (b.timestamp || "").localeCompare(a.timestamp || ""));
      }
      return fresh.length;
    },
    /** 직원 앱(hostHeader)은 **이 대화방 안**만 찾는다 — 결과를 ▲▼로 대화 속에서 짚기 때문이다. PC 위젯은 예전대로 전체 방. */
    get msgSearchRoomId() {
      return this.useHostHeader ? this.selectedConversation?.id : void 0;
    },
    async searchMessages() {
      const keyword = this.msgSearchKeyword.trim();
      if (!(keyword || this.msgSearchMine)) {
        this.msgSearchResults = [];
        this.msgSearchTotal = 0;
        return;
      }
      const roomId = this.msgSearchRoomId;
      this.msgSearchServerLoaded = 0;
      this.msgSearchServerTotal = 0;
      try {
        const result = await this.sdk.message.search({
          keyword,
          fromMe: this.msgSearchMine,
          limit: roomId ? ROOM_SEARCH_PAGE : 30,
          ...roomId ? {
            conversationId: roomId
          } : {}
        });
        this.msgSearchResults = (result?.items || []).map((m) => this.mapServerSearchItem(m));
        this.msgSearchServerLoaded = this.msgSearchResults.length;
        this.msgSearchServerTotal = result?.totalCount || 0;
        this.msgSearchTotal = this.msgSearchServerTotal;
      } catch (_e) {
        this.msgSearchResults = [];
        this.msgSearchTotal = 0;
      }
      if (this.chatLockEnabled) {
        try {
          const local = await this.getChatKeyStore().searchIndex({
            keyword,
            fromSenderId: this.msgSearchMine ? this.currentUserId : void 0,
            ...roomId ? {
              conversationId: roomId
            } : {},
            limit: roomId ? ROOM_SEARCH_LOCAL_LIMIT : 30
          });
          const added = this.mergeSearchResults(local.map((e) => ({
            id: e.messageId,
            conversationId: e.conversationId,
            senderId: e.senderId,
            senderName: e.senderName,
            content: e.text,
            timestamp: e.createdAt,
            isMine: e.senderId === this.currentUserId,
            type: e.type,
            attachments: [],
            isDeleted: false
          })));
          this.msgSearchTotal += added;
        } catch {
        }
      }
      this.msgSearchDone = true;
      this.msgSearchIndex = this.msgSearchResults.length > 0 ? 0 : -1;
      if (this.useHostHeader && this.msgSearchIndex === 0) {
        await this.scrollToMessage(this.msgSearchResults[0].id);
      }
    },
    /** 서버에 아직 안 받은 결과가 남았나(대화방 안 검색 전용) */
    get msgSearchHasMoreOnServer() {
      return Boolean(this.msgSearchRoomId) && this.msgSearchServerLoaded < this.msgSearchServerTotal;
    },
    /** 대화방 안 검색의 다음 묶음 — ▲ 로 받은 결과 끝에 닿았을 때 부른다. 늘어난 건수를 돌려준다. */
    async loadMoreMsgSearch() {
      const roomId = this.msgSearchRoomId;
      if (!roomId || this.msgSearchLoadingMore || !this.msgSearchHasMoreOnServer) {
        return 0;
      }
      this.msgSearchLoadingMore = true;
      try {
        const result = await this.sdk.message.search({
          keyword: this.msgSearchKeyword.trim(),
          fromMe: this.msgSearchMine,
          limit: ROOM_SEARCH_PAGE,
          offset: this.msgSearchServerLoaded,
          conversationId: roomId
        });
        const items = (result?.items || []).map((m) => this.mapServerSearchItem(m));
        if (items.length === 0) {
          this.msgSearchServerTotal = this.msgSearchServerLoaded;
          return 0;
        }
        this.msgSearchServerLoaded += items.length;
        return this.mergeSearchResults(items);
      } catch {
        return 0;
      } finally {
        this.msgSearchLoadingMore = false;
      }
    },
    /** 대화방 안 검색 막대의 상태 글자 — 「2/7」 · 「검색 결과가 없어요」 · 검색 전엔 빈칸.
    *  분모는 전체 건수(서버 전체 + 이 기기 색인) — 100건씩 나눠 받아도 실제 건수가 보인다. */
    get msgSearchStatus() {
      if (this.msgSearchIndex >= 0) {
        const total = Math.max(this.msgSearchTotal, this.msgSearchResults.length);
        return `${this.msgSearchIndex + 1}/${total}`;
      }
      return this.msgSearchDone ? herebyStore(this).t("messenger.no_search_results") : "";
    },
    get msgSearchHasOlder() {
      return this.msgSearchIndex >= 0 && (this.msgSearchIndex < this.msgSearchResults.length - 1 || this.msgSearchHasMoreOnServer);
    },
    get msgSearchHasNewer() {
      return this.msgSearchIndex > 0;
    },
    /** ▲ — 한 건 더 예전 일치 메시지로. 받은 결과 끝이면 서버에서 다음 묶음을 먼저 받는다. */
    async msgSearchOlder() {
      if (!this.msgSearchHasOlder) {
        return;
      }
      if (this.msgSearchIndex >= this.msgSearchResults.length - 1) {
        await this.loadMoreMsgSearch();
        if (this.msgSearchIndex >= this.msgSearchResults.length - 1) {
          return;
        }
      }
      this.msgSearchIndex += 1;
      await this.scrollToMessage(this.msgSearchResults[this.msgSearchIndex].id);
    },
    /** ▼ — 한 건 더 최근 일치 메시지로 */
    msgSearchNewer() {
      if (!this.msgSearchHasNewer) {
        return;
      }
      this.msgSearchIndex -= 1;
      return this.scrollToMessage(this.msgSearchResults[this.msgSearchIndex].id);
    },
    toggleMsgSearch() {
      this.showMsgSearch = !this.showMsgSearch;
      if (!this.showMsgSearch) {
        this.msgSearchKeyword = "";
        this.msgSearchMine = false;
        this.msgSearchResults = [];
        this.msgSearchTotal = 0;
      }
    },
    /** 「내가 보낸 메시지만」 토글 — 바로 다시 검색한다 */
    toggleMsgSearchMine() {
      this.msgSearchMine = !this.msgSearchMine;
      return this.searchMessages();
    },
    /* 검색 입력은 앱 셸의 헤더 오버레이가 갖고 있다(헤더 자리를 덮어야 해서). 여기는 실행과
    결과만 맡는다 — 아래 둘은 셸이 쏘는 window 이벤트의 수신부다. */
    /** 헤더 검색을 열었을 때 — 입력줄 자리에 검색 막대를 띄우고 지난 결과를 비운다(셸의 app-messenger-search-open). */
    openMsgSearch() {
      this.showMsgSearch = true;
      this.msgSearchKeyword = "";
      this.msgSearchMine = false;
      this.msgSearchResults = [];
      this.msgSearchTotal = 0;
      this.msgSearchIndex = -1;
      this.msgSearchDone = false;
    },
    /** 키워드를 받아 검색을 실행하고 결과 패널을 연다. */
    runMsgSearch(keyword) {
      this.msgSearchKeyword = keyword ?? "";
      this.showMsgSearch = true;
      return this.searchMessages();
    },
    /** 검색 종료 — 결과 패널을 닫고 비운다. */
    closeMsgSearch() {
      this.showMsgSearch = false;
      this.msgSearchKeyword = "";
      this.msgSearchMine = false;
      this.msgSearchResults = [];
      this.msgSearchTotal = 0;
      this.msgSearchIndex = -1;
      this.msgSearchDone = false;
    },
    async jumpToSearchResult(msg) {
      const conv = this.conversations.find((c) => c.id === msg.conversationId);
      if (!conv) {
        return;
      }
      if (this.selectedConversation?.id !== conv.id) {
        await this.openConversation(conv);
      }
      await this.scrollToMessage(msg.id);
    },
    /**
    * 검색 결과 → 본문의 해당 메시지로 앵커링.
    * 대상이 첫 페이지(최근 50개) 밖이면 나올 때까지 과거 페이지를 더 불러온 뒤
    * 부드럽게 스크롤하고 잠깐 강조한다.
    */
    async scrollToMessage(messageId) {
      this.clearInitialAutoScroll();
      const maxPages = 20;
      let loaded = 0;
      while (!this.messages.some((message) => message.id === messageId) && this.currentPage < this.totalPages && loaded < maxPages) {
        loaded++;
        await this.loadOlderMessages();
      }
      const el2 = await this.waitForMessageElement(messageId);
      if (!el2) {
        showToastMessage(this, herebyStore(this).t("messenger.search_jump_not_found"));
        return;
      }
      el2.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      el2.classList.add("msg-anchor-flash");
      setTimeout(() => el2.classList.remove("msg-anchor-flash"), 1600);
    },
    /**
    * 대상 메시지의 DOM 노드가 붙을 때까지 짧게 폴링한다(50ms × 최대 12회 ≈ 600ms).
    * 고정 지연 한 번(60ms)으로 기다리면 저사양 기기나 페이지를 여러 장 불러온 직후처럼
    * Alpine 렌더가 늦는 상황에서 그냥 실패했다 — 못 찾으면 호출부가 안내를 띄운다.
    */
    waitForMessageElement(messageId) {
      const selector = `[data-message-id="${messageId}"]`;
      return new Promise((resolve2) => {
        let tries = 0;
        const poll = /* @__PURE__ */ __name(() => {
          const el2 = document.querySelector(selector);
          if (el2 || tries >= 12) {
            resolve2(el2);
            return;
          }
          tries++;
          setTimeout(poll, 50);
        }, "poll");
        poll();
      });
    },
    /* ── Filtered conversations ── */
    get filteredConversations() {
      const term = this.convSearchTerm.toLowerCase();
      const list = term ? this.conversations.filter(
        // biome-ignore lint/suspicious/noExplicitAny: conversation item typing
        (c) => c.contactName.toLowerCase().includes(term) || c.lastMessage.toLowerCase().includes(term) || // 성명 검색 — match any member's full name in the room
        Array.isArray(c.memberNames) && c.memberNames.some((n) => n.toLowerCase().includes(term))
      ) : this.conversations;
      const lastAt = /* @__PURE__ */ __name((c) => {
        const t = new Date(c.lastMessageTime || 0).getTime();
        return Number.isNaN(t) ? 0 : t;
      }, "lastAt");
      return [
        ...list
      ].sort(
        // biome-ignore lint/suspicious/noExplicitAny: conversation item typing
        (a, b) => Number(b.type === "department") - Number(a.type === "department") || this.conversationRank(a) - this.conversationRank(b) || lastAt(b) - lastAt(a)
      );
    },
    /** 정렬 단계 — 0: 새 메시지 도착, 1: 안 읽음 남음, 2: 모두 읽음. */
    conversationRank(conv) {
      if (conv.hasNewMessage) {
        return 0;
      }
      return conv.unreadCount > 0 ? 1 : 2;
    },
    formatFileSize(bytes) {
      if (bytes < 1024) {
        return `${bytes}B`;
      }
      if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(0)}KB`;
      }
      return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
    },
    /* ── 대화방 알림 끄기 (MED-942) ── */
    canMuteConversation(conv) {
      return !!conv && canMuteConversation(conv);
    },
    /** 드로어·목록 메뉴의 「알림 끄기/켜기」 — 서버에 저장하고 목록·현재 방의 표시를 함께 바꾼다. */
    async toggleConversationMute(target) {
      const conv = target ?? this.selectedConversation;
      if (!(conv && canMuteConversation(conv))) {
        return;
      }
      const muted = !conv.muted;
      try {
        await this.sdk.conversation.setMuted({
          conversationId: conv.id,
          muted
        });
        conv.muted = muted;
        const listed = this.conversations.find((c) => c.id === conv.id);
        if (listed) {
          listed.muted = muted;
        }
        if (this.selectedConversation?.id === conv.id) {
          this.selectedConversation.muted = muted;
        }
      } catch (e) {
        showError(e?.message || herebyStore(this).t("messenger.mute_toggle_failed"));
      }
    },
    /* ── 같은 사람의 연속 메시지 묶음 · 아바타 · 보낸 사람 메뉴 (2026-10-13, 텔레그램 참조) ── */
    /** 바로 앞 메시지와 같은 묶음(같은 사람 · 5분 안 · 날짜 구분선 없음) — 이름을 생략한다. */
    isContinuation(index) {
      const msg = this.messages[index];
      if (!msg || index === 0) {
        return false;
      }
      return isMessageContinuation(this.messages[index - 1], msg) && !this.messageDateLabel(msg.timestamp, index);
    },
    /** 묶음의 마지막 메시지 — 아바타는 여기 한 번(텔레그램처럼 묶음 아래쪽에 붙는다). */
    isGroupEnd(index) {
      const next = this.messages[index + 1];
      if (!next) {
        return true;
      }
      return !(isMessageContinuation(this.messages[index], next) && !this.messageDateLabel(next.timestamp, index + 1));
    },
    /** 사람마다 고정된 색조(이름 해시) — 말풍선 안 이름 색과 글자 아바타 바탕이 같은 색을 쓴다. */
    senderTone(name) {
      let h = 0;
      for (const ch of name || "") {
        h = (h * 31 + ch.charCodeAt(0)) % 997;
      }
      return `ds-sender-tone-${h % 6}`;
    },
    /** 목록 아바타(2026-10-13) — 사진 경로의 URL(받아 둔 것만). 없으면 "" → 이니셜 */
    avatarUrlForPath(path) {
      return path && this.senderAvatarUrls[path] || "";
    },
    /**
    * 아바타 사진을 기기에 쌓아 두고 쓴다(사용자 요청 2026-10-13 — 연락처 사진은 많으니 미리 캐시, 새로 올라오면 갱신).
    * 사진 키는 업로드마다 새로 생기므로 「키가 캐시에 있으면 그 사진, 없으면 새 사진」 이 곧 갱신 규칙이다.
    * 1) 첨부 캐시(IndexedDB, 보호 키로 감쌈)에 있으면 네트워크 없이 Blob URL
    * 2) 없는 키는 40ms 모아 storage.getProfilePictureUrls 한 번으로 URL 을 받고(사람 수만큼 호출하지 않음)
    * 3) 바이트를 받아(동시 4개) 캐시에 넣는다 — 다음 세션부터는 1) 로 끝난다. 총량 정리는 묶음 끝에 한 번.
    */
    avatarQueue: /* @__PURE__ */ new Set(),
    avatarFlushTimer: 0,
    ensureAvatarForPath(path) {
      if (!path || this.senderAvatarUrls[path] || this.senderAvatarPending.has(path)) {
        return;
      }
      this.senderAvatarPending.add(path);
      this.avatarQueue.add(path);
      if (!this.avatarFlushTimer) {
        this.avatarFlushTimer = setTimeout(() => {
          this.avatarFlushTimer = 0;
          const batch = [
            ...this.avatarQueue
          ];
          this.avatarQueue.clear();
          this.resolveAvatarBatch(batch).catch(() => void 0);
        }, 40);
      }
    },
    async resolveAvatarBatch(paths) {
      const store = this.getChatKeyStore();
      const employeeId = this.currentUserId;
      const setUrl = /* @__PURE__ */ __name((path, url) => {
        this.senderAvatarUrls = {
          ...this.senderAvatarUrls,
          [path]: url
        };
      }, "setUrl");
      const toBlobUrl = /* @__PURE__ */ __name((bytes) => URL.createObjectURL(new Blob([
        bytes
      ], {
        type: "image/jpeg"
      })), "toBlobUrl");
      const misses = [];
      for (const path of paths) {
        let hit = null;
        try {
          hit = employeeId ? await store.getCachedAttachment(employeeId, path) : null;
        } catch {
          hit = null;
        }
        if (hit) {
          setUrl(path, toBlobUrl(hit.data));
          this.senderAvatarPending.delete(path);
        } else {
          misses.push(path);
        }
      }
      if (misses.length === 0) {
        return;
      }
      let urls = {};
      try {
        urls = await herebyStore(this).sdk.fileStorage.getProfilePictureUrls(misses);
      } catch {
        urls = {};
      }
      let stored = 0;
      const queue = misses.filter((p) => urls[p]);
      for (const p of misses) {
        if (!urls[p]) {
          this.senderAvatarPending.delete(p);
        }
      }
      const worker = /* @__PURE__ */ __name(async () => {
        for (; ; ) {
          const path = queue.shift();
          if (!path) {
            return;
          }
          const url = urls[path];
          setUrl(path, url);
          this.senderAvatarPending.delete(path);
          try {
            const res = await fetch(url);
            if (res.ok && employeeId) {
              const bytes = new Uint8Array(await res.arrayBuffer());
              await store.putCachedAttachment(employeeId, {
                path,
                mode: "wrapped",
                data: bytes
              }, {
                trim: false
              });
              stored++;
            }
          } catch {
          }
        }
      }, "worker");
      await Promise.all([
        worker(),
        worker(),
        worker(),
        worker()
      ]);
      if (stored > 0 && employeeId) {
        store.trimAttachmentCache(employeeId).catch(() => void 0);
      }
    },
    senderAvatarUrl(msg) {
      const path = this.senderPicturePaths[msg.senderId]?.path;
      return path && this.senderAvatarUrls[path] || "";
    },
    /**
    * 보낸 사람의 최신 사진 경로를 기억하고(더 새 메시지가 이김) 그 경로의 URL 을 한 번 받는다(아바타 x-init).
    * 사진이 없거나 실패하면 글자 아바타로 남는다. 사진을 지운 사람(경로 null)은 최신 메시지가 그걸 알려 주면 글자로 돌아간다.
    */
    ensureSenderAvatar(msg) {
      const id = msg.senderId;
      if (!id) {
        return;
      }
      const at = msg.timestamp ? new Date(msg.timestamp).getTime() : 0;
      const known = this.senderPicturePaths[id];
      if (!known || at >= known.at) {
        const path = msg.senderProfilePicture ?? "";
        if (!known || known.path !== path || known.at !== at) {
          this.senderPicturePaths = {
            ...this.senderPicturePaths,
            [id]: {
              path,
              at
            }
          };
        }
      }
      this.ensureAvatarForPath(this.senderPicturePaths[id]?.path);
    },
    senderMenuItems() {
      return senderMenuItems(this.selectedConversation);
    },
    openSenderMenu(msg, e) {
      this.closeMessageMenu();
      const target = e.currentTarget;
      const rect = target?.getBoundingClientRect();
      const point = rect ? {
        x: rect.left,
        y: rect.bottom + 4
      } : {
        x: 0,
        y: 0
      };
      const pos = clampMenuPosition(point, {
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.senderMenu = {
        open: true,
        employeeId: msg.senderId,
        name: msg.senderName,
        x: pos.x,
        y: pos.y
      };
    },
    closeSenderMenu() {
      this.senderMenu.open = false;
    },
    async runSenderMenuItem(key) {
      const { employeeId, name } = this.senderMenu;
      this.closeSenderMenu();
      if (!employeeId) {
        return;
      }
      const contact = {
        id: employeeId,
        name,
        role: "",
        team: "",
        teams: [],
        status: "offline"
      };
      if (key === "view_profile") {
        await this.openContactProfile(contact);
      } else if (key === "direct_chat") {
        await this.startConversation(contact);
      } else if (key === "mention") {
        this.mentionFromAvatar({
          employeeId,
          name
        });
      }
    },
    /** 아바타 메뉴의 「멘션하기」 — 입력칸 끝에 `@이름 ` 을 넣고 보낼 때 멘션으로 센다(pickMention 과 같은 규칙). */
    mentionFromAvatar(candidate) {
      const end = this.messageInput.length;
      const result = insertMention(this.messageInput, end, end, candidate.name);
      this.messageInput = result.text;
      this.pickedMentions = [
        ...this.pickedMentions.filter((p) => p.employeeId !== candidate.employeeId),
        candidate
      ];
      this.$nextTick(() => {
        const el2 = this.composerField();
        el2?.focus();
        el2?.setSelectionRange(result.caret, result.caret);
      });
    },
    /* ── 대화 목록 행 바로가기 메뉴 (2026-10-13) ── */
    /** 메뉴가 가리키는 방 — 목록에서 찾는다(닫힌 뒤엔 null). */
    get convMenuTarget() {
      return this.convMenu.open ? this.conversations.find((c) => c.id === this.convMenu.conversationId) ?? null : null;
    },
    /** 메뉴 항목 — 순수 규칙(`conversationMenuItems`). 비어 있으면 메뉴를 열지 않는다. */
    conversationMenuItems(conv) {
      return conversationMenuItems(conv);
    },
    /** 우클릭(PC)·길게 누르기(모바일) 공용 — 누른 지점에 띄운다. */
    openConversationMenu(conv, e) {
      if (conversationMenuItems(conv).length === 0) {
        return;
      }
      this.closeMessageMenu();
      let point;
      if ("touches" in e) {
        const touch = e.touches[0] || e.changedTouches[0];
        point = {
          x: touch?.clientX ?? 0,
          y: touch?.clientY ?? 0
        };
      } else {
        point = {
          x: e.clientX,
          y: e.clientY
        };
      }
      const pos = clampMenuPosition(point, {
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.convMenu = {
        open: true,
        conversationId: conv.id,
        x: pos.x,
        y: pos.y
      };
    },
    closeConversationMenu() {
      this.convMenu.open = false;
      this.convMenu.conversationId = "";
    },
    /** 길게 누르기(모바일) — 메시지 메뉴와 같은 500ms. 움직이면(스크롤) 취소. */
    onConversationPressStart(conv, e) {
      this.onConversationPressCancel();
      if (conversationMenuItems(conv).length === 0) {
        return;
      }
      this.convPressFired = false;
      this.convPressTimer = setTimeout(() => {
        this.convPressTimer = null;
        this.convPressFired = true;
        this.openConversationMenu(conv, e);
      }, 500);
    },
    onConversationPressCancel() {
      if (this.convPressTimer) {
        clearTimeout(this.convPressTimer);
        this.convPressTimer = null;
      }
    },
    onConversationPressEnd(e) {
      this.onConversationPressCancel();
      if (this.convPressFired) {
        e.preventDefault();
        this.convPressFired = false;
      }
    },
    /** 메뉴 항목 실행 — 항목 키는 `conversationMenuItems` 가 정한다. */
    async runConversationMenuItem(key) {
      const conv = this.convMenuTarget;
      this.closeConversationMenu();
      if (!conv) {
        return;
      }
      if (key === "mark_read") {
        await this.markConversationRead(conv);
      } else if (key === "mute" || key === "unmute") {
        await this.toggleConversationMute(conv);
      } else if (key === "leave") {
        await this.leaveConversation(conv);
      }
    },
    /** 목록에서 「읽음으로 표시」 — 방을 열지 않고 서버 읽음 + 배지를 맞춘다. */
    async markConversationRead(conv) {
      try {
        await this.sdk.message.markRead({
          conversationId: conv.id
        });
      } catch (e) {
        showError(e?.message || herebyStore(this).t("messenger.mark_read_failed"));
        return;
      }
      conv.unreadCount = 0;
      conv.hasNewMessage = false;
      await this.syncGlobalUnreadCount();
    },
    /** 목록은 첫 50개뿐이므로 전역 배지는 서버의 전체 집계로 맞춘다. */
    async syncGlobalUnreadCount() {
      await appStore(this, "messenger")?.refreshUnreadCount?.();
    },
    /* ── 보고 있는 방 presence (2026-10-13) ── */
    /**
    * 서버에 「지금 보고 있는 방」을 알린다 — 바뀌었을 때, 또는 보고 있는 동안 15초마다. 서버는 이 방의 새 메시지에
    * 푸시를 보내지 않는다(목록·안 읽음·알림함은 그대로). 실패하면 다음 틱에 다시 보낸다(TTL 45초가 바닥).
    */
    syncViewingPresence(force = false) {
      if (typeof this.sdk?.conversation?.setViewing !== "function") {
        return;
      }
      const conv = this.selectedConversation;
      const viewing = conv && this.isViewingConversation(conv.id) ? conv.id : null;
      const now = Date.now();
      const due = viewing !== null && now - this.viewingPresenceAt >= VIEWING_HEARTBEAT_MS;
      if (!(force || due || viewing !== this.viewingPresenceSent)) {
        return;
      }
      this.viewingPresenceSent = viewing;
      this.viewingPresenceAt = now;
      this.sdk.conversation.setViewing({
        conversationId: viewing
      }).catch(() => {
        this.viewingPresenceAt = 0;
      });
    },
    /* ── 내가 보낸 메시지 삭제 (MED-941) ── */
    canDeleteMessage(msg) {
      return canDeleteMessage(msg);
    },
    /** 메뉴가 열리는 메시지 — 답글(MED-944)은 누구 메시지에나 달 수 있어 내 것만이 아니다. 「삭제」 만 내 것에 한정. */
    canOpenMessageMenu(msg) {
      return canOpenMessageMenu(msg);
    },
    /** ⋯ 버튼·우클릭·길게 누르기 공용. 버튼이면 그 아래, 아니면 누른 지점에 띄운다. */
    openMessageMenu(msg, e) {
      if (!this.canOpenMessageMenu(msg)) {
        return;
      }
      let point;
      const target = e.currentTarget;
      if (target?.tagName === "BUTTON") {
        const rect = target.getBoundingClientRect();
        point = {
          x: rect.left,
          y: rect.bottom + 4
        };
      } else if ("touches" in e) {
        const touch = e.touches[0] || e.changedTouches[0];
        point = {
          x: touch?.clientX ?? 0,
          y: touch?.clientY ?? 0
        };
      } else {
        point = {
          x: e.clientX,
          y: e.clientY
        };
      }
      const pos = clampMenuPosition(point, {
        width: window.innerWidth,
        height: window.innerHeight
      }, {
        width: 280,
        height: 310
      });
      this.msgMenu = {
        open: true,
        messageId: msg.id,
        x: pos.x,
        y: pos.y
      };
    },
    closeMessageMenu() {
      this.msgMenu.open = false;
      this.msgMenu.messageId = "";
    },
    /** 메뉴가 열린 메시지 — 마크업이 항목마다 find 를 되풀이하지 않게 */
    get menuMessage() {
      if (!this.msgMenu.open) {
        return null;
      }
      return this.messages.find((m) => m.id === this.msgMenu.messageId) ?? null;
    },
    /* ── 이모지 반응 (2026-10-20) ── */
    /** 메뉴 맨 위 빠른 반응 줄 */
    get quickReactions() {
      return MESSAGE_REACTION_EMOJIS;
    },
    /** 두 번 두드리기의 기본 반응 — 마지막으로 쓴 이모지, 없으면 👍 */
    get defaultReaction() {
      return readLastReaction(MESSAGE_REACTION_EMOJIS, DEFAULT_MESSAGE_REACTION);
    },
    /** 말풍선 아래 칩 — 같은 이모지끼리 묶어 수와 「내가 눌렀는지」 */
    reactionChips(msg) {
      const entries = this.reactions[msg.id];
      return entries && entries.length > 0 ? groupReactionChips(entries, this.currentUserId) : [];
    },
    /** 칩 툴팁 — 누른 사람 이름 */
    reactionTooltip(chip) {
      return chip.names.filter(Boolean).join(", ");
    },
    canReactTo(msg) {
      return canOpenMessageMenu(msg);
    },
    /** 내가 쓴 반응 한 줄을 목록에 더하거나 뺀다 — 내 조작(낙관적)·서버 응답·실시간 이벤트가 같은 길 */
    applyReaction(change) {
      const current2 = this.reactions[change.messageId] ?? [];
      const next = applyReactionChange(current2, change);
      if (next.length === 0) {
        delete this.reactions[change.messageId];
      } else {
        this.reactions[change.messageId] = next;
      }
    },
    /** 반응 토글 — 먼저 화면에 바꾸고 서버에 보낸다. 실패하면 되돌린다 */
    async toggleReaction(msg, emoji) {
      if (!this.canReactTo(msg)) {
        return;
      }
      const store = herebyStore(this);
      const me = store.currentUser;
      const myName = me ? `${me.lastName || ""}${me.firstName || ""}`.trim() : "";
      const mine = (this.reactions[msg.id] ?? []).some((e) => e.employeeId === this.currentUserId && e.emoji === emoji);
      const change = {
        messageId: msg.id,
        emoji,
        employeeId: this.currentUserId,
        employeeName: myName,
        active: !mine
      };
      this.applyReaction(change);
      writeLastReaction(emoji);
      try {
        const result = await this.sdk.message.react({
          messageId: msg.id,
          emoji
        });
        if (result.active !== change.active) {
          this.applyReaction({
            ...change,
            active: result.active
          });
        }
      } catch (e) {
        this.applyReaction({
          ...change,
          active: mine
        });
        showError(e?.message || store.t("messenger.reaction_failed"));
      }
    },
    /** 메뉴 맨 위 이모지를 눌렀다 */
    reactFromMenu(emoji) {
      const msg = this.menuMessage;
      this.closeMessageMenu();
      if (msg) {
        this.toggleReaction(msg, emoji);
      }
    },
    /** 모바일 두 번 두드리기 — 같은 말풍선을 350ms 안에 두 번 두드리면 기본 반응(마지막으로 쓴 이모지) */
    onMessageTap(msg) {
      if (!isCoarsePointer()) {
        return;
      }
      const { doubleTap, next } = registerTap(this.lastTap, msg.id, Date.now());
      this.lastTap = next;
      if (doubleTap && this.canReactTo(msg)) {
        this.toggleReaction(msg, this.defaultReaction);
      }
    },
    /* ── 복사 · 보내기(전달) · 고정 (2026-10-20) ── */
    canCopyMessage(msg) {
      return canCopyMessage(msg);
    },
    canForwardMessage(msg) {
      return canForwardMessage(msg);
    },
    /** 메뉴의 「복사」 — 본문 글을 클립보드에 */
    async copyMessageFromMenu() {
      const msg = this.menuMessage;
      this.closeMessageMenu();
      if (!(msg && this.canCopyMessage(msg))) {
        return;
      }
      const t = herebyStore(this).t;
      const ok = await writeClipboardText(msg.content);
      if (ok) {
        showToastMessage(this, t("messenger.copied"));
      } else {
        showError(t("messenger.copy_failed"));
      }
    },
    /** 메뉴의 「선택 복사」 — 본문을 선택 가능한 창에 띄운다 */
    openSelectCopy() {
      const msg = this.menuMessage;
      this.closeMessageMenu();
      if (!(msg && this.canCopyMessage(msg))) {
        return;
      }
      this.selectCopy = {
        open: true,
        messageId: msg.id
      };
    },
    closeSelectCopy() {
      this.selectCopy.open = false;
      this.selectCopy.messageId = "";
    },
    get selectCopyText() {
      if (!this.selectCopy.open) {
        return "";
      }
      return this.messages.find((m) => m.id === this.selectCopy.messageId)?.content ?? "";
    },
    /** 드래그한 부분을 복사한다 — 고른 것이 없으면 전체 */
    async copySelectedText() {
      const selected = (window.getSelection?.()?.toString() ?? "").trim();
      const text = selected || this.selectCopyText;
      if (!text) {
        return;
      }
      const t = herebyStore(this).t;
      const ok = await writeClipboardText(text);
      if (ok) {
        showToastMessage(this, t(selected ? "messenger.copied_selection" : "messenger.copied"));
        this.closeSelectCopy();
      } else {
        showError(t("messenger.copy_failed"));
      }
    },
    /** 메뉴의 「보내기」 — 보낼 방을 고르는 창 */
    openForwardPicker() {
      const msg = this.menuMessage;
      this.closeMessageMenu();
      if (!(msg && this.canForwardMessage(msg))) {
        return;
      }
      this.forwardPicker = {
        open: true,
        messageId: msg.id,
        query: "",
        busy: false
      };
    },
    closeForwardPicker() {
      this.forwardPicker.open = false;
      this.forwardPicker.messageId = "";
      this.forwardPicker.query = "";
    },
    /** 보낼 방 후보 — 지금 방·업무 알림방 제외, 검색어로 거름 */
    get forwardTargets() {
      return forwardTargets(this.conversations, this.selectedConversation?.id ?? "", this.forwardPicker.query);
    },
    /**
    * 다른 방으로 보낸다 — 그 방을 열고 평소 보내기 길(암호화 방이면 그 방 키로 다시 암호화)을 그대로 탄다.
    * 첨부는 저장 키가 방 단위로 묶여 있어(막무가내로 키만 옮길 수 없다) 받아서 다시 올린다.
    */
    async forwardTo(target) {
      const msg = this.messages.find((m) => m.id === this.forwardPicker.messageId);
      if (!msg || this.forwardPicker.busy) {
        return;
      }
      const t = herebyStore(this).t;
      this.forwardPicker.busy = true;
      try {
        const files = [];
        for (const att of msg.attachments) {
          if (!att.storagePath) {
            continue;
          }
          const url = await this.attachmentUrl(att);
          const res = await fetch(url);
          if (!res.ok) {
            throw new Error(`attachment download failed: ${res.status}`);
          }
          const blob = await res.blob();
          files.push(new File([
            blob
          ], att.originalName || att.filename, {
            type: att.mimeType || blob.type
          }));
        }
        const namesOnly = msg.attachments.map((a) => a.originalName).join(", ");
        const text = files.length > 0 && msg.content === namesOnly ? "" : msg.content;
        this.closeForwardPicker();
        await this.openConversation(target);
        if (files.length > 0) {
          this.pendingFiles = files.map((file) => ({
            file,
            preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : ""
          }));
          this.messageInput = text;
          await this.sendAttachments({
            encoded: true
          });
        } else {
          this.messageInput = text;
          await this.sendMessage();
        }
        showToastMessage(this, t("messenger.forwarded"));
      } catch (e) {
        showError(e?.message || t("messenger.forward_failed"));
      } finally {
        this.forwardPicker.busy = false;
      }
    },
    isPinnedMessage(msg) {
      return this.pinnedMessage?.id === msg.id;
    },
    /** 메뉴의 「고정」/「고정 해제」 */
    async togglePinFromMenu() {
      const msg = this.menuMessage;
      this.closeMessageMenu();
      if (!(msg && this.selectedConversation)) {
        return;
      }
      await this.setPinned(this.isPinnedMessage(msg) ? null : msg);
    },
    async unpinMessage() {
      await this.setPinned(null);
    },
    async setPinned(msg) {
      const conv = this.selectedConversation;
      if (!conv) {
        return;
      }
      const t = herebyStore(this).t;
      try {
        await this.sdk.message.pin({
          conversationId: conv.id,
          messageId: msg ? msg.id : null
        });
        this.pinnedMessage = msg;
        this.pinnedById = msg ? this.currentUserId : null;
      } catch (e) {
        showError(e?.message || t("messenger.pin_failed"));
      }
    },
    /** 띠의 글 — 본문, 첨부만 있으면 [사진]/[파일] */
    pinnedPreview() {
      const msg = this.pinnedMessage;
      if (!msg) {
        return "";
      }
      const t = herebyStore(this).t;
      if (msg.isUnreadable) {
        return t("messenger.unreadable_message");
      }
      return replyPreviewText({
        content: msg.content,
        type: msg.type,
        isDeleted: msg.isDeleted
      }, {
        image: t("messenger.reply_preview_image"),
        file: t("messenger.reply_preview_file")
      });
    },
    /** 띠를 누르면 그 메시지로 */
    jumpToPinned() {
      if (this.pinnedMessage) {
        this.scrollToMessage(this.pinnedMessage.id);
      }
    },
    /* ── 읽음 영수증(MED-963) ── */
    /** 이 메시지를 아직 안 읽은 멤버 수 — 단체방은 숫자로, 1:1 은 0 이면 「읽음」 */
    unreadCountOf(msg) {
      const conv = this.selectedConversation;
      if (!conv || msg.type === "system" || msg.status === "sending" || msg.status === "failed") {
        return 0;
      }
      return unreadMemberIds(msg, conv.memberIds ?? [], this.readStates, this.currentUserId).length;
    },
    /** 1:1 방인가 — 상대가 읽으면 숫자 대신 「읽음」 */
    get isDirectConversation() {
      return this.selectedConversation?.type === "direct";
    },
    /** 말풍선 아래 표기 — 단체방: 안 읽은 사람 수(0 이면 비움) · 1:1: 내 메시지를 상대가 읽었으면 「읽음」 */
    readLabelOf(msg) {
      if (!this.selectedConversation || msg.type === "system") {
        return "";
      }
      const unread = this.unreadCountOf(msg);
      if (this.isDirectConversation) {
        return msg.isMine && unread === 0 && msg.status !== "sending" && msg.status !== "failed" ? herebyStore(this).t("messenger.read") : "";
      }
      return unread > 0 ? String(unread) : "";
    },
    openReadStatus(msg) {
      if (this.isDirectConversation || (this.selectedConversation?.memberIds ?? []).length === 0) {
        return;
      }
      this.readStatus = {
        open: true,
        messageId: msg.id
      };
    },
    closeReadStatus() {
      this.readStatus = {
        open: false,
        messageId: ""
      };
    },
    /** 「읽음 상태」 모달의 두 목록 — 보낸 사람·나는 읽은 쪽에 둔다 */
    get readStatusLists() {
      const conv = this.selectedConversation;
      const msg = this.messages.find((m) => m.id === this.readStatus.messageId);
      if (!(conv && msg)) {
        return {
          read: [],
          unread: []
        };
      }
      const ids = conv.memberIds ?? [];
      const names = conv.memberNames ?? [];
      const nameOf = /* @__PURE__ */ __name((id, i) => names[i] || id, "nameOf");
      const unread = new Set(unreadMemberIds(msg, ids, this.readStates, this.currentUserId));
      const read = [];
      const notRead = [];
      ids.forEach((id, i) => {
        if (id === msg.senderId) {
          return;
        }
        (unread.has(id) ? notRead : read).push(nameOf(id, i));
      });
      return {
        read,
        unread: notRead
      };
    },
    /** 길게 누르기(모바일) — 500ms 동안 움직이지 않고 누르면 메뉴. */
    onMessagePressStart(msg, e) {
      this.onMessagePressCancel();
      if (!this.canOpenMessageMenu(msg)) {
        return;
      }
      this.msgPressFired = false;
      this.msgPressTimer = setTimeout(() => {
        this.msgPressTimer = null;
        this.msgPressFired = true;
        this.openMessageMenu(msg, e);
      }, 500);
    },
    onMessagePressCancel() {
      if (this.msgPressTimer) {
        clearTimeout(this.msgPressTimer);
        this.msgPressTimer = null;
      }
    },
    onMessagePressEnd(e, msg) {
      const wasPressing = this.msgPressTimer !== null;
      this.onMessagePressCancel();
      if (this.msgPressFired) {
        e.preventDefault();
        this.msgPressFired = false;
        return;
      }
      if (wasPressing && msg) {
        this.onMessageTap(msg);
      }
    },
    /* ── @멘션 (MED-943) ── */
    mentionAllLabel() {
      return herebyStore(this).t("messenger.mention_all");
    },
    /** 방 참여자(나 제외)를 방을 열 때마다 읽는다 — 예전엔 같은 방이면 건너뛰어, 초대된 사람이 다시 열어도 후보에 없었다(2026-10-20). */
    async loadMentionCandidates(conv) {
      this.mentionCandidatesFor = conv.id;
      this.mentionCandidates = [];
      if (conv.type === "self" || conv.type === "workflow") {
        return;
      }
      try {
        const result = await this.sdk.conversation.getMembers(conv.id);
        if (this.mentionCandidatesFor !== conv.id) {
          return;
        }
        this.mentionCandidates = (result?.members || []).filter((m) => m.employeeId !== this.currentUserId).map((m) => ({
          employeeId: m.employeeId,
          name: m.name
        }));
      } catch (_e) {
      }
    },
    /** 후보 — 「전체」(단체방) + 이름에 검색어가 들어가는 사람, 8명까지. */
    get mentionMatches() {
      const q = this.mentionPicker.query.toLowerCase();
      const conv = this.selectedConversation;
      const allLabel = this.mentionAllLabel();
      const all = conv && canMuteConversation(conv) && (q === "" || allLabel.toLowerCase().includes(q)) ? [
        {
          employeeId: MENTION_ALL_ID,
          name: allLabel
        }
      ] : [];
      const people = this.mentionCandidates.filter((c) => c.name.toLowerCase().includes(q));
      return [
        ...all,
        ...people
      ].slice(0, 8);
    },
    /** 입력칸이 바뀔 때마다 커서 앞의 `@검색어` 를 본다. */
    onComposerInput(el2) {
      const caret = el2.selectionStart ?? el2.value.length;
      const q = mentionQueryAt(el2.value, caret);
      if (q && this.mentionCandidates.length > 0) {
        this.mentionPicker = {
          open: true,
          query: q.query,
          start: q.start,
          index: 0
        };
      } else if (this.mentionPicker.open) {
        this.mentionPicker.open = false;
      }
    },
    closeMentionPicker() {
      this.mentionPicker.open = false;
    },
    /** 후보를 골라 `@이름 ` 으로 넣는다 — 커서는 그 뒤로, 초점은 입력칸에 남긴다. */
    pickMention(candidate) {
      const el2 = this.composerField();
      const caret = el2?.selectionStart ?? this.messageInput.length;
      const result = insertMention(this.messageInput, this.mentionPicker.start, caret, candidate.name);
      this.messageInput = result.text;
      this.pickedMentions = [
        ...this.pickedMentions.filter((p) => p.employeeId !== candidate.employeeId),
        candidate
      ];
      this.closeMentionPicker();
      this.$nextTick(() => {
        if (el2) {
          el2.focus();
          el2.setSelectionRange(result.caret, result.caret);
          this.autosizeMessageInput(el2);
        }
      });
    },
    /** 후보 팝업이 떠 있을 때의 방향키·Tab — Enter 는 onComposerEnter, ESC 는 공용 ESC 층이 맡는다. */
    onComposerKeydown(event) {
      if (!this.mentionPicker.open) {
        return;
      }
      const count = this.mentionMatches.length;
      if (count === 0) {
        return;
      }
      if (event.key === "ArrowDown") {
        event.preventDefault();
        this.mentionPicker.index = (this.mentionPicker.index + 1) % count;
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        this.mentionPicker.index = (this.mentionPicker.index - 1 + count) % count;
      } else if (event.key === "Tab") {
        event.preventDefault();
        this.pickMention(this.mentionMatches[this.mentionPicker.index] ?? this.mentionMatches[0]);
      }
    },
    /** 본문 HTML — 이스케이프 + 멘션 강조. 멘션이 없으면 x-text 와 같은 결과다. */
    renderMessageHtml(msg) {
      return renderMessageHtml(msg.content, msg.mentions, this.mentionAllLabel());
    },
    /** 나를 지목한 메시지(상대가 보낸 것만) — 줄에 옅은 강조를 준다. */
    mentionsMe(msg) {
      return !msg.isMine && mentionsMe(msg.mentions, this.currentUserId);
    },
    /** 본문의 멘션 링크를 누르면 그 사람의 연락처 프로필로. 「전체」·나 자신은 열 곳이 없다. */
    onMessageContentClick(event) {
      const anchor = event.target?.closest("a[href]");
      if (anchor) {
        event.preventDefault();
        event.stopPropagation();
        const cap = globalThis.Capacitor;
        window.open(anchor.href, cap?.isNativePlatform?.() ? "_system" : "_blank", "noopener");
        return;
      }
      const target = event.target?.closest("[data-employee-id]");
      const id = target?.dataset.employeeId;
      if (!id || id === MENTION_ALL_ID || id === this.currentUserId) {
        return;
      }
      event.stopPropagation();
      const contact = this.contacts.find((c) => c.id === id);
      if (contact) {
        this.openContactProfile(contact);
      }
    },
    /** 메뉴의 「답글」(MED-944) — 입력창 위에 원문 미리보기를 세우고 입력칸에 초점을 준다. */
    replyFromMenu() {
      const messageId = this.msgMenu.messageId;
      this.closeMessageMenu();
      const msg = this.messages.find((m) => m.id === messageId);
      if (!(msg && this.canOpenMessageMenu(msg))) {
        return;
      }
      this.replyTarget = msg;
      this.focusMessageInput();
    },
    cancelReply() {
      this.replyTarget = null;
      this.focusMessageInput();
    },
    /** 인용 박스·입력창 위 미리보기의 글 — 첨부는 [사진]/[파일] 접두, 지운 원문은 호출부가 라벨로 대신한다. */
    replyPreview(reply) {
      if (!reply) {
        return "";
      }
      const t = herebyStore(this).t;
      return replyPreviewText(reply, {
        image: t("messenger.reply_preview_image"),
        file: t("messenger.reply_preview_file")
      });
    },
    /** 메뉴의 「삭제」 — 확인 창 뒤 서버에 지우고, 응답을 기다리지 않고 자리 표시로 바꾼다. */
    async deleteMessageFromMenu() {
      const messageId = this.msgMenu.messageId;
      this.closeMessageMenu();
      const msg = this.messages.find((m) => m.id === messageId);
      if (!(msg && this.canDeleteMessage(msg))) {
        return;
      }
      const t = herebyStore(this).t;
      const ok = await askConfirm({
        message: t("messenger.delete_message_confirm"),
        tone: "danger"
      });
      if (!ok) {
        return;
      }
      try {
        await this.sdk.message.delete({
          messageId
        });
        this.applyMessageDeleted(messageId);
      } catch (e) {
        showError(e?.message || t("messenger.delete_message_failed"));
      }
    },
    /** 삭제를 화면에 반영 — 내 조작·실시간 이벤트 공용. 마지막 메시지였으면 목록 미리보기도 바꾼다. */
    applyMessageDeleted(messageId) {
      this.getChatKeyStore().removeCachedMessages([
        messageId
      ]).catch(() => void 0);
      const { found, wasLast } = applyMessageDeletion(this.messages, messageId);
      if (!(found && wasLast)) {
        return;
      }
      const placeholder = herebyStore(this).t("messenger.deleted_message");
      const conversationId = this.messages.find((m) => m.id === messageId)?.conversationId;
      if (this.selectedConversation && this.selectedConversation.id === conversationId) {
        this.selectedConversation.lastMessage = placeholder;
      }
      const listed = this.conversations.find((c) => c.id === conversationId);
      if (listed) {
        listed.lastMessage = placeholder;
      }
    },
    /** Download an attachment using the original filename. Falls back to
    *  opening in a new tab if the browser blocks the synthetic download. */
    /** 풀어 둔 첨부의 Blob URL 캐시(MED-895) — 방을 바꾸면 비운다 */
    // biome-ignore lint/style/useNamingConvention: internal property prefixed with underscore
    _decryptedFileUrls: /* @__PURE__ */ new Map(),
    revokeDecryptedFileUrls() {
      for (const url of this._decryptedFileUrls.values()) {
        URL.revokeObjectURL(url);
      }
      this._decryptedFileUrls.clear();
    },
    /**
    * 첨부를 보여 줄 URL(MED-895). 암호화된 첨부는 받아서 기기에서 풀어 Blob URL 로, 평문 첨부는 종전 presigned URL.
    * `thumb` 가 true 면 미리보기(있을 때)를 쓴다.
    */
    async attachmentUrl(att, thumb = false) {
      const useThumb = thumb && att.thumbStoragePath && att.thumbKey && att.thumbIv;
      const path = useThumb ? att.thumbStoragePath : att.storagePath;
      const key = useThumb ? att.thumbKey : att.fileKey;
      const iv = useThumb ? att.thumbIv : att.fileIv;
      if (!path) {
        return "";
      }
      const cached = this._decryptedFileUrls.get(path);
      if (cached) {
        return cached;
      }
      const mime = useThumb ? "image/jpeg" : att.mimeType || "application/octet-stream";
      const store = this.getChatKeyStore();
      const employeeId = this.currentUserId;
      const encrypted = Boolean(key && iv);
      let bytes = null;
      try {
        const hit = employeeId ? await store.getCachedAttachment(employeeId, path) : null;
        if (hit && hit.mode === (encrypted ? "cipher" : "wrapped")) {
          bytes = hit.data;
        }
      } catch {
        bytes = null;
      }
      if (!bytes) {
        const url = await herebyStore(this).getFileUrl(path);
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`attachment download failed: ${res.status}`);
        }
        bytes = new Uint8Array(await res.arrayBuffer());
        if (employeeId) {
          store.putCachedAttachment(employeeId, {
            path,
            mode: encrypted ? "cipher" : "wrapped",
            data: bytes
          }).catch(() => void 0);
        }
      }
      const plain = encrypted ? await decryptFile({
        key: fromBase64Url2(key),
        iv,
        ciphertext: bytes
      }) : bytes;
      const blobUrl = URL.createObjectURL(new Blob([
        plain
      ], {
        type: mime
      }));
      this._decryptedFileUrls.set(path, blobUrl);
      return blobUrl;
    },
    async downloadAttachment(att) {
      if (!att.storagePath) {
        return;
      }
      try {
        const url = await this.attachmentUrl(att);
        const a = document.createElement("a");
        a.href = url;
        a.download = att.originalName || att.filename || "file";
        a.target = "_blank";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch {
        const url = await herebyStore(this).getFileUrl(att.storagePath);
        window.open(url, "_blank");
      }
    },
    subscribeToConversation(conversationId) {
      this.unsubscribeFromConversation();
      try {
        this.messageSubscription = this.sdk.message.subscribeToMessages(
          conversationId,
          (event) => {
            if ("kind" in event && event.kind === "deleted") {
              this.applyMessageDeleted(event.id);
              if (this.pinnedMessage?.id === event.id) {
                this.pinnedMessage = null;
              }
              return;
            }
            if ("kind" in event && event.kind === "reaction") {
              this.applyReaction(event);
              return;
            }
            if ("kind" in event && event.kind === "pinned") {
              this.pinnedById = event.pinnedById;
              this.applyPinnedPayload(event.message, event.conversationId).catch(() => void 0);
              return;
            }
            if ("kind" in event && event.kind === "read") {
              this.readStates = applyMemberRead(this.readStates, event.employeeId, event.lastReadAt);
              return;
            }
            const data = event;
            if (data.senderId && data.createdAt) {
              this.readStates = applyMemberRead(this.readStates, data.senderId, data.createdAt);
            }
            if (this.messages.some((message) => message.id === data.id)) {
              return;
            }
            const incoming = {
              ...mapMessageItem(data, this.currentUserId),
              isMine: false
            };
            if (data.type === "system") {
              this.refreshRoomMembership(conversationId).catch(() => void 0);
            }
            const atBottom = this.isChatAtLiveBottom();
            this.messages.push(incoming);
            this.cacheMessages([
              data
            ]);
            const live = this.messages[this.messages.length - 1];
            if (live.encrypted) {
              this.decryptMessageItems([
                live
              ]).then(async () => {
                if (live.isUnreadable && this.selectedConversation) {
                  await this.syncRoomKeys(this.selectedConversation);
                  await this.decryptMessageItems([
                    live
                  ]);
                }
                if (this.selectedConversation && !live.isUnreadable) {
                  this.selectedConversation.lastMessage = live.content;
                }
              });
            }
            if (this.selectedConversation) {
              this.selectedConversation.lastMessage = incoming.encrypted ? "" : data.content || "";
              this.selectedConversation.lastMessageTime = data.createdAt || "";
            }
            this.noteIncomingMessages(data.senderId === this.currentUserId ? 0 : 1, atBottom);
            if (this.isViewingConversation(conversationId)) {
              this.sdk.message.markRead({
                conversationId
              }).catch(() => {
              });
            }
          },
          // 구독이 오류로 끊기면 다시 붙인다 — 간격은 3s 에서 두 배씩 늘려 30s 까지(서버가 거절을 반복해도 폭주하지 않게).
          // dev QA(2026-10-11)에서 서버가 토픽 미등록으로 구독을 즉시 거절해 3초마다 영원히 실패했고, 서버가 고쳐져 붙어도
          // 그 사이 온 메시지는 아무도 다시 읽지 않았다 — 복구 신호(onStarted)에서 열린 방을 서버 기준으로 다시 맞춘다.
          (_err) => {
            this.messageSubscription = null;
            if (this.selectedConversation?.id === conversationId) {
              this.messageSubscribeRetries += 1;
              setTimeout(() => this.subscribeToConversation(conversationId), subscribeRetryDelayMs(this.messageSubscribeRetries));
            }
          },
          () => {
            if (this.messageSubscribeRetries === 0) {
              return;
            }
            this.messageSubscribeRetries = 0;
            if (this.selectedConversation?.id === conversationId) {
              this.syncOpenConversationMessages().catch(() => void 0);
            }
          }
        );
      } catch (_e) {
      }
    },
    unsubscribeFromConversation() {
      if (this.messageSubscription) {
        this.messageSubscription.unsubscribe();
        this.messageSubscription = null;
      }
    },
    /**
    * 사용자가 지금 이 대화방을 **눈으로 보고 있나** — 새 메시지를 바로 읽음 처리할지 가른다.
    * 방이 선택돼 있어도 탭이 뒤에 있거나 네이티브 앱이 백그라운드면 보고 있는 게 아니다. 호스트가 조건을 더한다
    * (채팅 위젯: 패널이 열려 있어야 한다 — `ChatWidget.ts`).
    */
    isViewingConversation(conversationId) {
      return this.activeView === "chat" && this.selectedConversation?.id === conversationId && !document.hidden && !this.appInBackground;
    },
    /** 보던 방이 다시 보이게 됐을 때(탭 복귀·패널 열기) 그사이 쌓인 미확인을 읽음으로 넘긴다. */
    async markViewedConversationRead() {
      const conversationId = this.selectedConversation?.id;
      if (!(conversationId && this.isViewingConversation(conversationId))) {
        return;
      }
      const conv = this.conversations.find((c) => c.id === conversationId);
      if (!conv || conv.unreadCount === 0 && !conv.hasNewMessage) {
        return;
      }
      conv.unreadCount = 0;
      conv.hasNewMessage = false;
      try {
        await this.sdk.message.markRead({
          conversationId
        });
        await this.syncGlobalUnreadCount();
      } catch (_e) {
      }
    },
    /** 대화 목록 실시간 구독(목록 갱신 · 다른 기기 읽음)을 모두 끊는다. */
    unsubscribeFromConversationUpdates() {
      this.stopChatLockPendingPoll();
      if (this._convUpdateHandler) {
        window.removeEventListener("hereby:conversation-update", this._convUpdateHandler);
        this._convUpdateHandler = null;
      }
      if (this.conversationUpdateSubscription) {
        this.conversationUpdateSubscription.unsubscribe();
        this.conversationUpdateSubscription = null;
      }
      if (this.readSyncSubscription) {
        this.readSyncSubscription.unsubscribe();
        this.readSyncSubscription = null;
      }
      if (this._chatKeyEventHandler) {
        window.removeEventListener("hereby:chat-key-event", this._chatKeyEventHandler);
        this._chatKeyEventHandler = null;
      }
      if (this.chatKeyEventSubscription) {
        this.chatKeyEventSubscription.unsubscribe();
        this.chatKeyEventSubscription = null;
      }
    },
    /**
    * 방 키 봉투 이벤트(2026-10-15) — 새로고침 없이 키가 오간다.
    * - envelopes: 내 봉투가 올라왔다 → 그 방을 보고 있으면 세대 키를 다시 맞추고 「읽을 수 없음」을 다시 푼다. 목록 미리보기도.
    * - request: 어떤 멤버 기기가 봉투를 달라고 한다 → 내가 그 방의 키를 갖고 있으면 지금 채운다(방을 열지 않아도).
    */
    async onChatKeyEvent(data) {
      if (!this.chatLockEnabled || this.getChatKeyManager().currentState !== "ready") {
        return;
      }
      const conv = this.conversations.find((c) => c.id === data.conversationId);
      if (data.kind === "request") {
        const target = conv ?? {
          id: data.conversationId,
          type: "group",
          encryptionEpoch: data.epoch
        };
        if (data.epoch && !target.encryptionEpoch) {
          target.encryptionEpoch = data.epoch;
        }
        await this.fillRoomKeyEnvelopes(target);
        return;
      }
      if (this.selectedConversation?.id === data.conversationId) {
        this.roomKeySync = null;
        await this.syncRoomKeys(this.selectedConversation);
        await this.decryptMessageItems(this.messages.filter((m) => m.isUnreadable));
        this.refreshConversationPreview(data.conversationId);
        return;
      }
      if (conv?.lastMessageEncrypted) {
        try {
          await this.getConversationKeyManager().sync(conv.id, false);
          await this.decryptConversationPreviews([
            conv
          ]);
        } catch {
        }
      }
    },
    subscribeToConversationUpdates() {
      this.unsubscribeFromConversationUpdates();
      const handleUpdate = /* @__PURE__ */ __name((data) => {
        const conv = this.conversations.find((c) => c.id === data.conversationId);
        if (data.own) {
          if (!conv) {
            this.loadConversations();
            return;
          }
          if (data.lastMessage || !conv.encryptionEpoch) {
            conv.lastMessage = data.lastMessage;
          } else if (data.lastMessageEncrypted) {
            conv.lastMessageEncrypted = data.lastMessageEncrypted;
            this.decryptConversationPreviews([
              conv
            ]);
          }
          conv.lastMessageTime = data.lastMessageTime;
          return;
        }
        if (conv) {
          if (this.isViewingConversation(data.conversationId)) {
            appStore(this, "messenger")?.decrementUnread?.(1);
          } else {
            conv.unreadCount++;
            conv.hasNewMessage = true;
          }
          if (data.lastMessage || !conv.encryptionEpoch) {
            conv.lastMessage = data.lastMessage;
          } else if (data.lastMessageEncrypted) {
            conv.lastMessageEncrypted = data.lastMessageEncrypted;
            this.decryptConversationPreviews([
              conv
            ]);
          }
          conv.lastMessageTime = data.lastMessageTime;
          if (!this.isViewingConversation(data.conversationId)) {
            this.notifyLocally({
              conv,
              conversationId: data.conversationId,
              senderName: data.senderName,
              lastMessage: data.lastMessage,
              muted: data.muted
            });
          }
        } else {
          this.loadConversations();
          this.notifyLocally({
            conv: null,
            conversationId: data.conversationId,
            senderName: data.senderName,
            lastMessage: data.lastMessage,
            muted: data.muted
          });
        }
      }, "handleUpdate");
      this._convUpdateHandler = (e) => {
        handleUpdate(e.detail);
      };
      window.addEventListener("hereby:conversation-update", this._convUpdateHandler);
      if (!appStore(this, "messenger") && this.sdk?.message?.subscribeToConversationUpdates) {
        try {
          this.conversationUpdateSubscription = this.sdk.message.subscribeToConversationUpdates(
            // biome-ignore lint/suspicious/noExplicitAny: real-time event data
            (data) => {
              window.dispatchEvent(new CustomEvent("hereby:conversation-update", {
                detail: data
              }));
            },
            (_err) => {
              this.conversationUpdateSubscription = null;
            }
          );
        } catch {
        }
      }
      this._chatKeyEventHandler = (e) => {
        this.onChatKeyEvent(e.detail).catch(() => void 0);
      };
      window.addEventListener("hereby:chat-key-event", this._chatKeyEventHandler);
      if (this.sdk?.message?.subscribeToChatKeyEvents) {
        try {
          this.chatKeyEventSubscription = this.sdk.message.subscribeToChatKeyEvents(
            // biome-ignore lint/suspicious/noExplicitAny: real-time event data
            (data) => {
              this.onChatKeyEvent(data).catch(() => void 0);
            },
            (_err) => {
              this.chatKeyEventSubscription = null;
            }
          );
        } catch {
        }
      }
      if (this.sdk?.message?.subscribeToReadSync) {
        try {
          this.readSyncSubscription = this.sdk.message.subscribeToReadSync((data) => {
            const conv = this.conversations.find((c) => c.id === data.conversationId);
            if (conv) {
              conv.unreadCount = 0;
              conv.hasNewMessage = false;
            }
            const channel = this.channels.find((c) => c.id === data.conversationId);
            if (channel) {
              channel.unreadCount = 0;
            }
            this.syncGlobalUnreadCount();
          }, () => {
            this.readSyncSubscription = null;
          });
        } catch {
        }
      }
    },
    /**
    * 입력칸(textarea). `$refs.messageInput` 으로 찾으면 안 된다 — 입력줄이 `x-data="{ composerFocus }"` 라는
    * **안쪽 스코프** 에 있어 바깥 컴포넌트의 $refs 에는 안 잡힌다(조용히 undefined → 초점·커서 이동이 전부
    * 무시되던 상태, 2026-10-07 답글 흐름에서 발견). 컴포넌트 루트에서 DOM 으로 찾는다.
    */
    composerField() {
      const root = this.rootEl;
      const el2 = root ? root.querySelector("textarea.ds-composer__field") : null;
      if (el2) {
        return el2;
      }
      const ref = this.$refs?.messageInput;
      return ref ?? null;
    },
    focusMessageInput() {
      this.composerField()?.focus();
    },
    clearInitialAutoScroll() {
      this.autoScrollConversationId = "";
      this.autoScrollUntilMs = 0;
      if (this.autoScrollReleaseTimer) {
        clearTimeout(this.autoScrollReleaseTimer);
        this.autoScrollReleaseTimer = null;
      }
    },
    armInitialAutoScroll(conversationId) {
      this.clearInitialAutoScroll();
      this.autoScrollConversationId = conversationId;
      this.autoScrollUntilMs = Date.now() + 2e3;
      this.scrollChatToBottom();
      setTimeout(() => {
        if (this.activeView === "chat" && this.selectedConversation?.id === conversationId && Date.now() <= this.autoScrollUntilMs) {
          this.scrollChatToBottom();
        }
      }, 180);
      this.autoScrollReleaseTimer = setTimeout(() => {
        if (this.selectedConversation?.id === conversationId) {
          this.clearInitialAutoScroll();
        }
      }, 2050);
    },
    handleMessageImageLoad() {
      if (this.activeView !== "chat") {
        return;
      }
      if (!this.selectedConversation || this.selectedConversation.id !== this.autoScrollConversationId) {
        return;
      }
      if (Date.now() > this.autoScrollUntilMs) {
        return;
      }
      this.scrollChatToBottom();
    },
    scrollChatToBottom() {
      this.newMessagesBelow = 0;
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const el2 = document.getElementById("chat-messages");
          if (el2) {
            el2.scrollTop = el2.scrollHeight;
          }
        });
      });
    },
    /* ── 「새 메시지 n개」 알약(2026-10-12 디자이너 결정) ──
    위로 올려 예전 대화를 보는 중에 새 메시지가 오면 끌어내리지 않고, 입력줄 위에 알약을 띄워 개수를 센다.
    탭하면 맨 아래로 부드럽게 내려가고(움직임 줄이기 설정이면 바로) 사라진다. 직접 맨 아래까지 내려가도 사라진다. */
    /** 대화 목록 스크롤 상자 — 화면에 없으면(목록 화면 · 테스트) null. */
    chatScrollEl() {
      return typeof document === "undefined" ? null : document.getElementById("chat-messages");
    },
    /** 지금 맨 아래(최신 메시지) 근처인가 — 자동 스크롤과 알약이 같은 판정(`isChatNearBottom`)을 쓴다. 상자가 없으면 맨 아래로 친다. */
    isChatAtLiveBottom() {
      const el2 = this.chatScrollEl();
      return el2 ? isChatNearBottom(el2) : true;
    },
    /** 새 메시지가 들어왔다 — 맨 아래였으면 따라 내려가고, 아니면 상대 메시지 수(`fromOthers`)만큼 알약 숫자를 올린다. */
    noteIncomingMessages(fromOthers, wasAtBottom) {
      if (wasAtBottom) {
        this.scrollChatToBottom();
        return;
      }
      if (fromOthers > 0) {
        this.newMessagesBelow += fromOthers;
      }
    },
    /** 대화 목록 @scroll — 사용자가 직접 맨 아래까지 내려오면 알약을 거둔다. 숫자가 있을 때만 써서 스크롤마다 반응형 쓰기를 하지 않는다. */
    onChatScroll(el2) {
      if (this.newMessagesBelow > 0 && isChatNearBottom(el2)) {
        this.newMessagesBelow = 0;
      }
    },
    /** 알약 숫자(99 넘으면 「99+」) */
    get newMessagesCountText() {
      return formatNewMessageCount(this.newMessagesBelow);
    },
    /** 알약 탭 — 맨 아래로 부드럽게 내려간다(움직임 줄이기 설정이면 바로). */
    jumpToLatestMessages() {
      this.newMessagesBelow = 0;
      const el2 = this.chatScrollEl();
      if (!el2) {
        return;
      }
      const reduce = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
      el2.scrollTo({
        top: el2.scrollHeight,
        behavior: reduce ? "auto" : "smooth"
      });
    },
    /* ── Contacts ── */
    /** 연락처를 팀별로 묶은 것 — 연락처 탭(1:1 시작)과 그룹 대화 선택이 함께 쓴다. */
    get contactGroups() {
      return groupContactsByTeam(this.contacts, herebyStore(this).t("messenger.unassigned"), {
        pinnedTeamIds: this.myTeamIds,
        filterTeamId: this.contactTeamFilterId
      });
    },
    /** 내 소속 팀 id(주 소속 먼저) — 연락처 응답의 나(myContact)에서. 묶음 맨 위 + 처음 펼침 */
    get myTeamIds() {
      return (this.myContact?.teams ?? []).map((t) => t.id);
    },
    /** 검색 방식 고르는 줄이 보이는가 — 검색칸에 커서가 있거나, 부서 검색 중이거나, 고른 부서가 있을 때 */
    get contactSearchModeVisible() {
      return this.contactSearchFocus || this.contactSearchMode === "team" || !!this.contactTeamFilterId;
    },
    onContactSearchFocus() {
      this.contactSearchFocus = true;
    },
    /** 고르는 줄의 버튼은 mousedown.prevent 로 초점을 지키므로, 진짜로 다른 곳을 눌렀을 때만 줄이 접힌다 */
    onContactSearchBlur() {
      setTimeout(() => {
        this.contactSearchFocus = false;
      }, 120);
    },
    /** 「이름」·「부서」 — 부서로 바꾸면 이름 검색어를 비우고 팀 피커 입력칸에 초점을 준다 */
    setContactSearchMode(mode) {
      this.contactSearchMode = mode;
      if (mode === "team") {
        this.searchTerm = "";
      }
      alpineMagics(this).$nextTick?.(() => {
        const root = this.rootEl;
        const selector = mode === "team" ? "[data-testid='messenger-contact-team-filter'] input" : "[data-testid='messenger-contact-search']";
        root?.querySelector(selector)?.focus();
      });
    },
    /** 「부서 거르기」로 고른 팀 id — 없으면 null */
    get contactTeamFilterId() {
      const picked = this.contactTeamFilter.find((s) => s.kind === "team");
      return picked ? picked.id : null;
    },
    clearContactTeamFilter() {
      this.contactTeamFilter = [];
      this.contactSearchMode = "name";
    },
    /** 고른 부서 이름 — 이름 검색으로 돌아와도 줄에 칩으로 남아 지울 수 있다 */
    get contactTeamFilterName() {
      const picked = this.contactTeamFilter.find((s) => s.kind === "team");
      return picked ? picked.name : "";
    },
    /** 검색 결과 줄의 「소속 · 역할」 — 팀 머리가 없는 평평한 목록에서 동명이인을 가른다. */
    contactMeta(contact) {
      return contactMeta(contact);
    },
    /** 소속 없는 사람들의 묶음 — 팀이 아니므로 「단체」(팀 대화) 버튼을 두지 않는다. */
    isUnassignedGroup(group) {
      return group.key === UNASSIGNED_TEAM_KEY;
    },
    /** Whether search is active (flat list mode) */
    get isSearching() {
      return this.searchTerm.trim().length > 0;
    },
    /** Flat search results across all teams — matches name, role,
    *  or any team the contact belongs to. */
    get searchedContacts() {
      if (!this.isSearching) {
        return [];
      }
      const term = this.searchTerm.trim().toLowerCase();
      const found = this.contacts.filter((c) => contactMatchesTerm(c, term));
      const me = this.myContact;
      if (me && !this.groupSelectMode && contactMatchesTerm(me, term)) {
        return [
          me,
          ...found
        ];
      }
      return found;
    },
    /** 연락처 줄·프로필이 나인가 */
    isMe(contact) {
      return !!contact && contact.id === this.currentUserId;
    },
    /** 지금 펼쳐진 팀 — 아직 손대지 않았으면 내 소속 팀만(MED-962) */
    get effectiveExpandedTeams() {
      return this.expandedTeams ?? new Set(this.myTeamIds);
    },
    _saveExpandedState() {
      if (this.expandedTeams) {
        writeExpandedTeams(this.expandedTeams);
      }
    },
    toggleTeam(team) {
      const next = new Set(this.effectiveExpandedTeams);
      if (next.has(team)) {
        next.delete(team);
      } else {
        next.add(team);
      }
      this.expandedTeams = next;
      this._saveExpandedState();
    },
    /** 접힘 판정 — 「부서 거르기」로 고른 팀(과 하위 팀)은 늘 펼친다 */
    isTeamCollapsed(team) {
      if (this.contactTeamFilterId) {
        return false;
      }
      return !this.effectiveExpandedTeams.has(team);
    },
    /* ── Notices ── */
    /** 열어 본 정보 게시글 id — 계정마다 기기에 저장한다(readNoticeIds). 바꿀 때는 새 Set 으로 갈아 끼운다. */
    readNotices: /* @__PURE__ */ new Set(),
    /** 「새로운 공지」 목록 — 확인한 공지·열어 본 정보 게시글은 숨긴다(데이터는 notices 에 그대로 둔다). */
    get listedNotices() {
      return messengerListNotices(this.notices, this.readNotices);
    },
    async loadNotices() {
      try {
        const result = await this.sdk.generalAffairs.listPublishedNotices({}, {
          page: 1,
          limit: 50,
          sortBy: "publishedAt",
          sortOrder: "desc"
        });
        const items = result?.items || [];
        this.notices = sortNoticesUnacknowledgedFirst(items.map(
          // biome-ignore lint/suspicious/noExplicitAny: API response shape
          (n) => ({
            id: n.id,
            title: n.title || "",
            content: n.content || "",
            category: n.category || "",
            priority: n.priority || "normal",
            publishedAt: n.publishedAt || n.createdAt || "",
            attachments: Array.isArray(n.attachments) ? n.attachments : [],
            isAcknowledged: !!n.isAcknowledged,
            acknowledgedAt: n.acknowledgedAt || null,
            requiresAcknowledgment: n.requiresAcknowledgment !== false,
            editedAt: n.editedAt ? String(n.editedAt) : null,
            reacknowledgmentRequested: n.reacknowledgmentRequested === true,
            createdByName: n.createdByName ? String(n.createdByName) : null
          })
        ));
        this.noticeUnreadCount = this.notices.filter((n) => n.requiresAcknowledgment && !n.isAcknowledged).length;
        this.noticesLoaded = true;
      } catch (_e) {
        this.notices = [];
        this.noticeUnreadCount = 0;
        this.noticesLoaded = true;
      }
    },
    async viewNotice(notice) {
      this.selectedNotice = notice;
      if (!(notice.requiresAcknowledgment || this.readNotices.has(notice.id))) {
        this.readNotices = /* @__PURE__ */ new Set([
          ...this.readNotices,
          notice.id
        ]);
        writeNoticeIds(this.currentUserId, this.readNotices);
        window.dispatchEvent(new CustomEvent(NOTICE_READ_EVENT, {
          detail: {
            id: notice.id
          }
        }));
      }
      this.noticeReadEnd = false;
      this.activeView = "noticeDetail";
    },
    /**
    * 공지 본문을 끝까지 봤는가 — 「확인 했어요」 활성 조건. 한 번 true가 되면 되돌리지
    * 않는다(위로 다시 스크롤했다고 확인을 뺏을 이유가 없다).
    * ⚠️ 내용이 짧아 **스크롤이 아예 없는** 공지도 즉시 true여야 한다. 그 경우 scroll
    * 이벤트가 영원히 안 오므로 열릴 때 한 번 직접 재는 경로가 반드시 필요하다.
    */
    updateNoticeReadEnd(el2) {
      if (!el2 || this.noticeReadEnd || el2.clientHeight === 0) {
        return;
      }
      if (el2.scrollTop + el2.clientHeight >= el2.scrollHeight - 8) {
        this.noticeReadEnd = true;
      }
    },
    async acknowledgeNotice() {
      if (!this.selectedNotice || this.selectedNotice.isAcknowledged) {
        return;
      }
      try {
        await this.sdk.generalAffairs.acknowledgeNotice(this.selectedNotice.id);
        this.selectedNotice.isAcknowledged = true;
        this.selectedNotice.acknowledgedAt = (/* @__PURE__ */ new Date()).toISOString();
        this.selectedNotice.reacknowledgmentRequested = false;
        const found = this.notices.find((n) => n.id === this.selectedNotice?.id);
        if (found) {
          found.isAcknowledged = true;
          found.acknowledgedAt = this.selectedNotice.acknowledgedAt;
        }
        if (this.noticeUnreadCount > 0) {
          this.noticeUnreadCount--;
        }
        window.dispatchEvent(new CustomEvent("hereby:notice-acknowledged", {
          detail: {
            id: this.selectedNotice.id
          }
        }));
      } catch (_e) {
      }
    },
    /**
    * 분류 → 표기. 문구는 총무 화면과 **같은 로케일 키**에서 온다(utils/notice-labels).
    * 예전엔 여기에 한글이 하드코딩돼 있었고 키 목록도 enum과 어긋나(`hr`·`event`·`system` 이
    * 있고 실제 값 `training_deadline`·`facility` 가 없음) 그 두 분류는 영문 키가 그대로 찍혔다.
    */
    noticeCategoryLabel(category) {
      return herebyStore(this).t(noticeCategoryLabelKey(category));
    },
    /**
    * 중요도·분류 → DS 라벨 색 변형(`.ds-label--*`). Tailwind 유틸 조합(bg-… + text-…)으로
    * 직접 칠하지 않는다 — 라벨은 색 변형 클래스로만 칠하는 것이 DS 강제 규칙이다.
    * 매핑 자체는 `utils/notice-labels` 한 곳에만 둔다(총무 화면과 색이 갈리지 않게).
    */
    noticePriorityColor(priority) {
      return noticePriorityLabelColor(priority);
    },
    noticeCategoryColor(category) {
      return noticeCategoryLabelColor(category);
    },
    /** 중요도 → 표기(참고 · 일반 · 중요 · 긴급). 분류와 같은 로케일 키를 총무 화면과 공유한다. */
    noticePriorityLabel(priority) {
      return herebyStore(this).t(noticePriorityLabelKey(priority));
    },
    /* ── Date Grouping ── */
    messageDateLabel(currentTimestamp, index) {
      if (!currentTimestamp) {
        return "";
      }
      const store = herebyStore(this);
      const currentDayStr = store.formatDateISO(new Date(currentTimestamp));
      if (index > 0 && this.messages[index - 1]) {
        const prevDayStr = store.formatDateISO(new Date(this.messages[index - 1].timestamp));
        if (currentDayStr === prevDayStr) {
          return "";
        }
      }
      const todayStr2 = store.todayLocal();
      const yesterdayStr = store.formatDateISO(new Date(Date.now() - 864e5));
      if (currentDayStr === todayStr2) {
        return "\uC624\uB298";
      }
      if (currentDayStr === yesterdayStr) {
        return "\uC5B4\uC81C";
      }
      return store.formatDateCustom(new Date(currentTimestamp), {
        month: "long",
        day: "numeric"
      });
    },
    /* ── Helpers ── */
    get messengerSubTabs() {
      const t = herebyStore(this).t;
      return [
        {
          id: "conversations",
          label: t("messenger.conversations")
        },
        {
          id: "contacts",
          label: t("messenger.contacts")
        }
      ];
    },
    get messengerSubTabActive() {
      return this.activeView === "contacts" ? "contacts" : "conversations";
    },
    switchMessengerSubTab(id) {
      if (id === "conversations" || id === "contacts") {
        this.activeView = id;
      }
    },
    /* ── 목록 검색 칸 스크롤 ─────────────────────────────────────────
    대화·연락처의 검색 칸은 목록과 같이 스크롤된다. 칸이 위로 완전히 사라지면
    앱 셸 헤더가 탭 줄 오른쪽에 검색 아이콘을 띄운다(listSearchHidden 을 syncMessengerView 로 넘김). */
    convSearchHidden: false,
    contactSearchHidden: false,
    /** 지금 보는 탭(대화/연락처)의 검색 칸이 스크롤로 가려졌는가. */
    get listSearchHidden() {
      if (this.activeView === "contacts") {
        return this.contactSearchHidden;
      }
      return this.activeView === "conversations" && this.convSearchHidden;
    },
    updateListSearchHidden(kind, scroller, box) {
      if (!box) {
        return;
      }
      const hidden = box.getBoundingClientRect().bottom <= scroller.getBoundingClientRect().top;
      if (kind === "conv") {
        this.convSearchHidden = hidden;
      } else {
        this.contactSearchHidden = hidden;
      }
    },
    /** 헤더의 검색 아이콘 — 맨 위로 되돌아가 검색 칸에 커서를 둔다.
    *  focus 는 클릭과 같은 흐름에서 바로 줘야 모바일 키보드가 올라온다(스크롤 끝을 기다리지 않는다). */
    revealListSearch() {
      const contacts = this.activeView === "contacts";
      const scroller = this.$refs[contacts ? "contactList" : "convList"];
      const input = this.$refs[contacts ? "contactSearchInput" : "convSearchInput"];
      scroller?.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      input?.focus({
        preventScroll: true
      });
    },
    get totalUnread() {
      return this.conversations.reduce((sum, c) => sum + c.unreadCount, 0);
    },
    contactInitial(name) {
      return name.charAt(0);
    },
    timeAgo(dateStr) {
      if (!dateStr) {
        return "";
      }
      const now = Date.now();
      const t = new Date(dateStr).getTime();
      const diff = Math.floor((now - t) / 6e4);
      if (diff < 1) {
        return "\uBC29\uAE08";
      }
      if (diff < 60) {
        return `${diff}\uBD84 \uC804`;
      }
      const hours = Math.floor(diff / 60);
      if (hours < 24) {
        return `${hours}\uC2DC\uAC04 \uC804`;
      }
      const days = Math.floor(hours / 24);
      if (days < 7) {
        return `${days}\uC77C \uC804`;
      }
      return herebyStore(this).formatDateCustom(new Date(dateStr), {
        month: "short",
        day: "numeric"
      });
    },
    messageTime(dateStr) {
      if (!dateStr) {
        return "";
      }
      return herebyStore(this).formatTime(new Date(dateStr));
    },
    /** 접속 표시 점의 클래스. 정본은 design-system.css 의 `.ds-presence` 다 —
    *  예전 `status-dot status-*` 는 전역 이름이라 앱마다 사본이 갈렸다(2026-09-09 이관). */
    statusClass(status) {
      return `ds-presence ds-presence--${status}`;
    }
  };
}
__name(messengerComponent, "messengerComponent");

// src/components/ChatWidget.ts
var UNREAD_POLL_MS = 6e4;
var FLOATING_PANEL_OPEN_EVENT2 = "hereby:floating-panel-open";
var UNREAD_BADGE_MAX = 99;
function chatWidgetComponent() {
  const component = messengerComponent({
    sectionName: "messenger"
  });
  component.isOpen = false;
  component.unreadTimer = null;
  component.fabBouncing = false;
  const arrivals = createUnreadArrivalTracker();
  let bounceAcknowledged = false;
  const baseInit = component.init;
  const baseIsViewingConversation = component.isViewingConversation;
  Object.defineProperty(component, "canUseChat", {
    get() {
      const store = herebyStore(this);
      return store?.authenticated === true && store.hasPermission?.("conversation:read") === true && !isMessengerPreviewBlocked(store.currentUser);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(component, "previewBlocked", {
    get() {
      return isMessengerPreviewBlocked(herebyStore(this)?.currentUser);
    },
    enumerable: true,
    configurable: true
  });
  component.init = function() {
    baseInit?.call(this);
    window.addEventListener(FLOATING_PANEL_OPEN_EVENT2, (event) => {
      if (event.detail !== "chat" && this.isOpen) {
        this.isOpen = false;
      }
    });
    this.$watch(() => this.canUseChat, (canUse) => {
      if (canUse) {
        this.startUnreadWatch();
      } else {
        this.stopUnreadWatch();
        this.isOpen = false;
      }
    });
    if (this.canUseChat) {
      this.startUnreadWatch();
    }
    this.$watch(() => this.isOpen, () => this.syncViewingPresence());
    window.addEventListener("hereby:open-chat-lock", () => {
      this.isOpen = true;
    });
    window.addEventListener("navigate-section", (event) => {
      const detail = event.detail;
      if (detail?.section !== "messenger" || !detail.conversationId) {
        return;
      }
      event.preventDefault();
      const self = this;
      self.isOpen = true;
      self.openConversationById(detail.conversationId);
    });
    this.$watch(() => this.conversations.map((c) => `${c.id}:${c.unreadCount}:${c.lastMessageTime || ""}`).join("|"), () => this.syncTabAttention());
  };
  component.destroy = function() {
    this.stopUnreadWatch();
  };
  component.stopUnreadWatch = function() {
    if (this.unreadTimer) {
      clearInterval(this.unreadTimer);
      this.unreadTimer = null;
    }
    this.unsubscribeFromConversationUpdates();
    arrivals.reset();
    bounceAcknowledged = false;
    this.fabBouncing = false;
    clearTabAttention();
  };
  component.startUnreadWatch = function() {
    if (isEmbeddedDocument()) {
      return;
    }
    if (this.unreadTimer) {
      return;
    }
    arrivals.reset();
    this.refreshUnreadBadge().then(() => {
      if (this.unreadTimer && this.sdk) {
        this.subscribeToConversationUpdates();
      }
    });
    this.unreadTimer = setInterval(() => this.refreshUnreadBadge(), UNREAD_POLL_MS);
  };
  component.syncTabAttention = function() {
    if (isEmbeddedDocument() || !herebyStore(this)?.authenticated) {
      return;
    }
    const { pending, arrived } = arrivals.observe(this.conversations);
    if (arrived) {
      bounceAcknowledged = false;
    }
    this.fabBouncing = pending && !bounceAcknowledged;
    if (pending) {
      showTabAttention(herebyStore(this).t("messenger.tab_attention_title"));
    } else {
      clearTabAttention();
    }
  };
  component.isViewingConversation = function(conversationId) {
    return this.isOpen && baseIsViewingConversation.call(this, conversationId);
  };
  component.refreshUnreadBadge = async function() {
    const store = herebyStore(this);
    if (this.isOpen || !store?.authenticated || !store.sdk || !this.canUseChat) {
      return;
    }
    this.sdk = store.sdk;
    this.currentUserId = store.currentUser?.id || "";
    await Promise.allSettled([
      this.loadConversations(),
      this.refreshNoticeUnread()
    ]);
  };
  component.refreshNoticeUnread = async function() {
    try {
      const result = await this.sdk.generalAffairs.unreadNoticeCount();
      this.noticeUnreadCount = typeof result === "number" ? result : result?.count ?? 0;
    } catch {
    }
  };
  component.toggle = function() {
    const canUse = this.canUseChat;
    this.isOpen = !this.isOpen;
    if (this.isOpen && !this.loaded && canUse) {
      this.loadData();
    }
    if (this.isOpen) {
      bounceAcknowledged = true;
      this.fabBouncing = false;
      this.markViewedConversationRead();
      window.dispatchEvent(new CustomEvent(FLOATING_PANEL_OPEN_EVENT2, {
        detail: "chat"
      }));
    }
  };
  component.close = function() {
    this.isOpen = false;
  };
  component.registerEsc = function(el2) {
    registerEscLayer(() => this.isOpen ? el2 : null, () => this.close());
  };
  Object.defineProperty(component, "totalUnread", {
    get() {
      return this.conversations.reduce((sum, c) => sum + (c.unreadCount || 0), 0);
    },
    configurable: true,
    enumerable: true
  });
  Object.defineProperty(component, "unreadBadgeCount", {
    get() {
      const messages = (
        // biome-ignore lint/suspicious/noExplicitAny: conversation item shape
        this.conversations.reduce((sum, c) => sum + (c.unreadCount || 0), 0) + // biome-ignore lint/suspicious/noExplicitAny: channel item shape
        this.channels.reduce((sum, c) => sum + (c.unreadCount || 0), 0)
      );
      return messages + (this.noticeUnreadCount || 0);
    },
    configurable: true,
    enumerable: true
  });
  Object.defineProperty(component, "unreadBadgeText", {
    get() {
      return this.unreadBadgeCount > UNREAD_BADGE_MAX ? `+${UNREAD_BADGE_MAX}` : String(this.unreadBadgeCount);
    },
    configurable: true,
    enumerable: true
  });
  return component;
}
__name(chatWidgetComponent, "chatWidgetComponent");

// src/components/DsDatePicker.ts
var pad = /* @__PURE__ */ __name((n) => String(n).padStart(2, "0"), "pad");
var todayStr = /* @__PURE__ */ __name(() => {
  const now = /* @__PURE__ */ new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}, "todayStr");
function dsDatePickerComponent(opts = {}) {
  return {
    /** Selected date `YYYY-MM-DD` — bound to the host field via x-modelable. */
    value: "",
    /** Popover open state (component-local). */
    open: false,
    /** Year dropdown open state. */
    yearOpen: false,
    /** Non-interactive trigger (host syncs a reactive expr via x-effect). */
    disabled: false,
    /** Inline `top/left` for the teleported popover (fixed, viewport coords). */
    popStyle: "",
    /** Calendar view year / month (1–12). */
    viewY: (/* @__PURE__ */ new Date()).getFullYear(),
    viewM: (/* @__PURE__ */ new Date()).getMonth() + 1,
    min: opts.min ?? "",
    max: opts.max ?? "",
    placeholder: opts.placeholder ?? "\uB0A0\uC9DC \uC120\uD0DD",
    defaultView: opts.defaultView,
    onChange: opts.onChange,
    weekdays: [
      "\uC77C",
      "\uC6D4",
      "\uD654",
      "\uC218",
      "\uBAA9",
      "\uAE08",
      "\uD1A0"
    ],
    /** Sync the calendar view to the current value (or today) when it exists. */
    init() {
      this.syncView();
    },
    get today() {
      return todayStr();
    },
    get triggerLabel() {
      return this.value || this.placeholder;
    },
    get daysInMonth() {
      return new Date(this.viewY, this.viewM, 0).getDate();
    },
    get firstOffset() {
      return new Date(this.viewY, this.viewM - 1, 1).getDay();
    },
    /** Leading blanks (null) + day numbers for the month grid. */
    get cells() {
      const arr = [];
      for (let i = 0; i < this.firstOffset; i++) {
        arr.push(null);
      }
      for (let d = 1; d <= this.daysInMonth; d++) {
        arr.push(d);
      }
      return arr;
    },
    /** 연도 드롭다운 목록 (내림차순 — 최근 연도가 위).
    *
    *  경계(min/max)가 지정된 경우 [min.year, max.year] 전체를 노출한다.
    *  생년월일처럼 1900년까지 거슬러 올라가야 하는 필드에서 ±10 슬라이딩 창을 여러 번
    *  이동해야 하던 이슈를 해소하기 위함 — 커스텀 캘린더는 드롭다운이 스크롤되므로
    *  100+ 개 항목을 한 번에 노출해도 UX 부담이 크지 않다.
    *
    *  경계가 전혀 없을 때만 기존 ±10 폴백을 유지한다(하한이 없으면 폭발적으로 길어질 수 있어). */
    get years() {
      const hasBound = !!(this.min || this.max);
      const minY = this.min ? Number(this.min.slice(0, 4)) : this.viewY - 10;
      const maxY = this.max ? Number(this.max.slice(0, 4)) : this.viewY + 10;
      let lo = Math.min(minY, this.viewY);
      let hi = Math.max(maxY, this.viewY);
      lo = Math.max(lo, this.viewY - 150);
      hi = Math.min(hi, this.viewY + 50);
      const out = [];
      if (hasBound) {
        for (let y = hi; y >= lo; y--) {
          out.push(y);
        }
      } else {
        for (let y = this.viewY + 10; y >= this.viewY - 10; y--) {
          out.push(y);
        }
      }
      return out;
    },
    dayStr(d) {
      return `${this.viewY}-${pad(this.viewM)}-${pad(d)}`;
    },
    isSelected(d) {
      return d !== null && this.dayStr(d) === this.value;
    },
    isToday(d) {
      return d !== null && this.dayStr(d) === this.today;
    },
    isOutOfRange(d) {
      if (d === null) {
        return true;
      }
      const s = this.dayStr(d);
      if (this.max && s > this.max) {
        return true;
      }
      if (this.min && s < this.min) {
        return true;
      }
      return false;
    },
    /** True when today falls outside [min, max] — disables & no-ops the "오늘"
    button so it can't set an out-of-range value (parity with pickDay). */
    get todayOutOfRange() {
      const t = this.today;
      if (this.max && t > this.max) {
        return true;
      }
      if (this.min && t < this.min) {
        return true;
      }
      return false;
    },
    syncView() {
      const dv = typeof this.defaultView === "function" ? this.defaultView() : this.defaultView;
      const parts = (this.value || dv || this.today).split("-");
      if (parts[0] && parts[1]) {
        this.viewY = Number(parts[0]);
        this.viewM = Number(parts[1]);
      }
    },
    openPicker(triggerEl) {
      if (this.disabled) {
        return;
      }
      const wasOpen = this.open;
      window.dispatchEvent(new CustomEvent("ds-picker-close"));
      if (wasOpen) {
        return;
      }
      this.syncView();
      this.positionPop(triggerEl);
      this.open = true;
    },
    /** Place the (teleported, fixed) popover just below the trigger, flipping
    up / clamping horizontally so it stays on screen. */
    positionPop(triggerEl) {
      if (!triggerEl || typeof triggerEl.getBoundingClientRect !== "function") {
        return;
      }
      const rect = triggerEl.getBoundingClientRect();
      const width = 252;
      const height = 300;
      const gap = 6;
      const margin = 8;
      let left = rect.left;
      if (left + width > window.innerWidth - margin) {
        left = rect.right - width;
      }
      if (left < margin) {
        left = margin;
      }
      let top = rect.bottom + gap;
      if (top + height > window.innerHeight - margin) {
        const above = rect.top - gap - height;
        top = above < margin ? margin : above;
      }
      this.popStyle = `top: ${Math.round(top)}px; left: ${Math.round(left)}px;`;
    },
    pickDay(d) {
      if (d === null || this.isOutOfRange(d)) {
        return;
      }
      this.value = this.dayStr(d);
      this.open = false;
      this.emitChange();
    },
    /** Fire onChange on the next tick (host x-model synced by then). */
    emitChange() {
      if (!this.onChange) {
        return;
      }
      const nextTick = this.$nextTick;
      if (typeof nextTick === "function") {
        nextTick(() => this.onChange?.());
      } else {
        this.onChange();
      }
    },
    prevMonth() {
      if (this.viewM === 1) {
        this.viewM = 12;
        this.viewY -= 1;
      } else {
        this.viewM -= 1;
      }
    },
    nextMonth() {
      if (this.viewM === 12) {
        this.viewM = 1;
        this.viewY += 1;
      } else {
        this.viewM += 1;
      }
    },
    pickYear(y) {
      this.viewY = y;
      this.yearOpen = false;
    },
    clearDate() {
      this.value = "";
      this.open = false;
      this.emitChange();
    },
    setToday() {
      if (this.todayOutOfRange) {
        return;
      }
      this.value = this.today;
      this.syncView();
      this.open = false;
      this.emitChange();
    }
  };
}
__name(dsDatePickerComponent, "dsDatePickerComponent");

// src/components/DsTimePicker.ts
var pad2 = /* @__PURE__ */ __name((n) => String(n).padStart(2, "0"), "pad2");
function dsTimePickerComponent(opts = {}) {
  return {
    /** Stored time `HH:MM` (24h) — bound to the host field via x-modelable. */
    value: "",
    open: false,
    /** Non-interactive trigger (host syncs a reactive expr via x-effect). */
    disabled: false,
    /** Inline `top/left` for the teleported popover (fixed, viewport coords). */
    popStyle: "",
    placeholder: opts.placeholder ?? "--:--",
    onChange: opts.onChange,
    // Editing state (12h display).
    teH: "12",
    teM: "00",
    teAmpm: "AM",
    teOrig: "",
    get triggerLabel() {
      return this.value || this.placeholder;
    },
    openPicker(triggerEl) {
      if (this.disabled) {
        return;
      }
      const wasOpen = this.open;
      window.dispatchEvent(new CustomEvent("ds-picker-close"));
      if (wasOpen) {
        return;
      }
      this.loadFromValue();
      this.positionPop(triggerEl);
      this.open = true;
      const self = this;
      self.$nextTick?.(() => self.$refs?.teHour?.focus());
    },
    /** Parse `value` (24h) into the 12h editing fields. */
    loadFromValue() {
      const parts = (this.value || "00:00").split(":");
      let h24 = Number.parseInt(parts[0], 10);
      if (Number.isNaN(h24)) {
        h24 = 0;
      }
      let m = Number.parseInt(parts[1], 10);
      if (Number.isNaN(m)) {
        m = 0;
      }
      this.teAmpm = h24 >= 12 ? "PM" : "AM";
      let h12 = h24 % 12;
      if (h12 === 0) {
        h12 = 12;
      }
      this.teH = pad2(h12);
      this.teM = pad2(m);
      this.teOrig = `${pad2(h24)}:${pad2(m)}`;
    },
    /** Place the (teleported, fixed) popover just below the trigger. */
    positionPop(triggerEl) {
      if (!triggerEl || typeof triggerEl.getBoundingClientRect !== "function") {
        return;
      }
      const rect = triggerEl.getBoundingClientRect();
      const width = 300;
      const height = 230;
      const gap = 6;
      const margin = 8;
      let left = rect.left;
      if (left + width > window.innerWidth - margin) {
        left = rect.right - width;
      }
      if (left < margin) {
        left = margin;
      }
      let top = rect.bottom + gap;
      if (top + height > window.innerHeight - margin) {
        const above = rect.top - gap - height;
        top = above < margin ? margin : above;
      }
      this.popStyle = `top: ${Math.round(top)}px; left: ${Math.round(left)}px;`;
    },
    teClamp(v, min, max) {
      let n = Number.parseInt(String(v).replace(/[^0-9]/g, ""), 10);
      if (Number.isNaN(n)) {
        n = min;
      }
      return pad2(Math.max(min, Math.min(max, n)));
    },
    /** 시 입력을 24시간제로도 허용 → 24h 값으로 환산(`17` → 오후 5시). */
    te24() {
      let h = Number.parseInt(String(this.teH).replace(/[^0-9]/g, ""), 10);
      if (Number.isNaN(h)) {
        h = 0;
      }
      if (h > 23) {
        h = 23;
      }
      if (h === 0) {
        return 0;
      }
      if (h >= 13) {
        return h;
      }
      if (h === 12) {
        return this.teAmpm === "PM" ? 12 : 0;
      }
      return this.teAmpm === "PM" ? h + 12 : h;
    },
    /** blur 시 표시값 정규화(`17` → 오후 + 05). */
    teNormHour() {
      const h24 = this.te24();
      this.teAmpm = h24 >= 12 ? "PM" : "AM";
      let h12 = h24 % 12;
      if (h12 === 0) {
        h12 = 12;
      }
      this.teH = pad2(h12);
    },
    teStepHour(delta) {
      this.teNormHour();
      let h = Number.parseInt(this.teH, 10);
      h = (h - 1 + delta + 12) % 12 + 1;
      this.teH = pad2(h);
    },
    teStepMin(delta) {
      let m = Number.parseInt(String(this.teM).replace(/[^0-9]/g, ""), 10);
      if (Number.isNaN(m)) {
        m = 0;
      }
      m = (m + delta + 60) % 60;
      this.teM = pad2(m);
    },
    teHValid() {
      return /^[0-9]{1,2}$/.test(String(this.teH).trim()) && +this.teH >= 0 && +this.teH <= 23;
    },
    teMValid() {
      return /^[0-9]{1,2}$/.test(String(this.teM).trim()) && +this.teM >= 0 && +this.teM <= 59;
    },
    /** 확인 활성: 시·분 모두 유효 AND 원래 값에서 바뀜. */
    teCanConfirm() {
      if (!(this.teHValid() && this.teMValid())) {
        return false;
      }
      const cur = `${pad2(this.te24())}:${this.teClamp(this.teM, 0, 59)}`;
      return cur !== this.teOrig;
    },
    teApply() {
      this.value = `${pad2(this.te24())}:${this.teClamp(this.teM, 0, 59)}`;
      this.open = false;
      this.emitChange();
    },
    /** Fire onChange on the next tick (host x-model synced by then). */
    emitChange() {
      if (!this.onChange) {
        return;
      }
      const nextTick = this.$nextTick;
      if (typeof nextTick === "function") {
        nextTick(() => this.onChange?.());
      } else {
        this.onChange();
      }
    },
    closePicker() {
      this.open = false;
    }
  };
}
__name(dsTimePickerComponent, "dsTimePickerComponent");

// src/components/EditEmployeePanel.ts
import { attachJosa, compareTeamOrder as compareTeamOrder2, describeTemporaryPasswordPolicy, matchesTemporaryPasswordPolicy, resolveUserPasswordPolicy, SHIFT_ASSIGNMENT_SOURCE_LABELS, WORK_PATTERN_DERIVED_FIELD_LABELS } from "@hereby/core/constants";
import { formatDate as formatDate2 } from "@hereby/core/date";

// src/analytics.ts
import { createAnalytics } from "@hereby/analytics";
import { analyticsAddressReadyEvent, createWebTransport } from "@hereby/analytics/web";
import { analyticsConfigSchema, analyticsPublicSettingsSchema, readAnalyticsPublicSettings } from "@hereby/core/analytics";
import { clearRetainedAuthToken } from "@hereby/analytics/web";
import { readAnalyticsPublicSettings as readAnalyticsPublicSettings2 } from "@hereby/core/analytics";
var clientsKey = Symbol.for("hereby.analytics.clients.v1");
var registryHost = globalThis;
var clients = registryHost[clientsKey] ?? /* @__PURE__ */ new Map();
registryHost[clientsKey] = clients;
var noopWorkflow = {
  dispose() {
    return void 0;
  },
  validationFailed() {
    return void 0;
  },
  submit() {
    return void 0;
  },
  complete() {
    return void 0;
  },
  fail() {
    return void 0;
  },
  unconfirmed() {
    return void 0;
  },
  retry() {
    return noopWorkflow;
  }
};
function appAnalytics(module) {
  return clients.get(module) ?? {
    view() {
      return void 0;
    },
    event() {
      return void 0;
    },
    startWorkflow: /* @__PURE__ */ __name(() => noopWorkflow, "startWorkflow"),
    context() {
      return void 0;
    },
    replace: /* @__PURE__ */ __name(async () => {
    }, "replace"),
    stop: /* @__PURE__ */ __name(async () => {
    }, "stop")
  };
}
__name(appAnalytics, "appAnalytics");
function reportWorkflowError(handle, error) {
  const code = error && typeof error === "object" && "data" in error ? error.data?.code : void 0;
  if (code === "BAD_REQUEST" || code === "UNPROCESSABLE_CONTENT") {
    handle.fail("validation");
  } else if (code === "FORBIDDEN" || code === "UNAUTHORIZED") {
    handle.fail("permission");
  } else if (code === "CONFLICT") {
    handle.fail("conflict");
  } else if (code === "INTERNAL_SERVER_ERROR") {
    handle.fail("server");
  } else {
    handle.unconfirmed();
  }
}
__name(reportWorkflowError, "reportWorkflowError");

// src/utils/picker-search.ts
function pickerQuery(raw) {
  return String(raw ?? "").trim().toLowerCase();
}
__name(pickerQuery, "pickerQuery");
function pickerMatches(name, query) {
  if (!query) {
    return true;
  }
  return String(name ?? "").toLowerCase().includes(query);
}
__name(pickerMatches, "pickerMatches");
function pickerRoles(roles, query = "", keepId = "") {
  const q = pickerQuery(query);
  return (roles ?? []).filter((r) => (r.isActive !== false || r.id === keepId) && pickerMatches(r.name, q));
}
__name(pickerRoles, "pickerRoles");

// src/utils/ward-assignment-rows.ts
import { NurseWorkType } from "@hereby/core/enums";
var NURSE_WORK_TYPES = Object.values(NurseWorkType);
function wardRowsFromAssignments(wards) {
  const list = Array.isArray(wards) ? wards : [];
  return list.map((w) => ({
    key: `ward-${w.profileId}`,
    profileId: w.profileId,
    wardId: w.wardId,
    wardName: w.wardName,
    scheduleGroupId: w.scheduleGroupId ?? "",
    scheduleGroupName: w.scheduleGroupName ?? "",
    workType: w.workType,
    isHeadNurse: !!w.isHeadNurse,
    original: {
      wardId: w.wardId,
      scheduleGroupId: w.scheduleGroupId ?? "",
      workType: w.workType,
      isHeadNurse: !!w.isHeadNurse
    }
  }));
}
__name(wardRowsFromAssignments, "wardRowsFromAssignments");
function suggestWardId(rows, linkedWardIds) {
  const used = new Set(rows.map((r) => r.wardId));
  return linkedWardIds.find((id) => !used.has(id)) ?? "";
}
__name(suggestWardId, "suggestWardId");
function defaultScheduleGroupId(wardId, groupList) {
  if (!wardId) {
    return "";
  }
  const ofWard = groupList.filter((g) => g.wardId === wardId);
  return (ofWard.find((g) => g.isDefault) ?? ofWard.find((g) => g.isActive))?.id ?? "";
}
__name(defaultScheduleGroupId, "defaultScheduleGroupId");
function createWardRow(key, wardId, wardList, groupList = []) {
  const scheduleGroupId = defaultScheduleGroupId(wardId, groupList);
  return {
    key,
    profileId: "",
    wardId,
    wardName: wardList.find((w) => w.id === wardId)?.name ?? "",
    scheduleGroupId,
    scheduleGroupName: groupList.find((g) => g.id === scheduleGroupId)?.name ?? "",
    workType: NurseWorkType.THREE_SHIFT,
    isHeadNurse: false,
    original: null
  };
}
__name(createWardRow, "createWardRow");
function syncRowWard(row, wardList, groupList) {
  row.wardName = wardList.find((w) => w.id === row.wardId)?.name ?? "";
  row.scheduleGroupId = defaultScheduleGroupId(row.wardId, groupList);
  syncRowScheduleGroup(row, groupList);
}
__name(syncRowWard, "syncRowWard");
function syncRowScheduleGroup(row, groupList) {
  row.scheduleGroupName = groupList.find((g) => g.id === row.scheduleGroupId)?.name ?? "";
}
__name(syncRowScheduleGroup, "syncRowScheduleGroup");
function removeWardRow(rows, index, removed) {
  const row = rows[index];
  if (!row) {
    return;
  }
  if (row.profileId && row.original) {
    removed.push({
      profileId: row.profileId,
      wardName: row.wardName,
      scheduleGroupName: row.scheduleGroupName,
      ...row.original
    });
  }
  rows.splice(index, 1);
}
__name(removeWardRow, "removeWardRow");
function wardOptionsForRow(row, rows, wardList, groupList = []) {
  const others = rows.filter((r) => r !== row);
  const wardsUsedByOthers = new Set(others.map((r) => r.wardId));
  const groupsUsedByOthers = new Set(others.map((r) => r.scheduleGroupId).filter(Boolean));
  const hasFreeGroup = /* @__PURE__ */ __name((wardId) => {
    const groups = groupList.filter((g) => g.wardId === wardId);
    if (groups.length === 0) {
      return !wardsUsedByOthers.has(wardId);
    }
    return groups.some((g) => g.isActive && !groupsUsedByOthers.has(g.id));
  }, "hasFreeGroup");
  const options = wardList.filter((w) => w.id === row.wardId || w.isActive && hasFreeGroup(w.id)).map((w) => ({
    id: w.id,
    name: w.name
  }));
  if (row.wardId && !options.some((o) => o.id === row.wardId)) {
    options.unshift({
      id: row.wardId,
      name: row.wardName || "(\uC0AD\uC81C\uB41C \uBCD1\uB3D9)"
    });
  }
  return options;
}
__name(wardOptionsForRow, "wardOptionsForRow");
function scheduleGroupOptionsForRow(row, rows, groupList) {
  const usedByOthers = new Set(rows.filter((r) => r !== row).map((r) => r.scheduleGroupId).filter(Boolean));
  const options = groupList.filter((g) => g.wardId === row.wardId && (g.isActive || g.id === row.scheduleGroupId) && !usedByOthers.has(g.id)).map((g) => ({
    id: g.id,
    name: g.name,
    isDefault: g.isDefault
  }));
  if (row.scheduleGroupId && !options.some((o) => o.id === row.scheduleGroupId)) {
    options.unshift({
      id: row.scheduleGroupId,
      name: row.scheduleGroupName || "(\uC0AD\uC81C\uB41C \uC2A4\uCF00\uC904\uB7EC)",
      isDefault: false
    });
  }
  return options;
}
__name(scheduleGroupOptionsForRow, "scheduleGroupOptionsForRow");
function wardRowBadge(row, rows, linkedWardIds) {
  if (!row.wardId) {
    return "";
  }
  if (linkedWardIds.includes(row.wardId)) {
    return "\uC18C\uC18D \uD300 \uC5F0\uACB0";
  }
  return rows.length > 1 ? "\uACB8\uC784" : "";
}
__name(wardRowBadge, "wardRowBadge");
function wardRowsError(rows) {
  if (rows.some((r) => !r.wardId)) {
    return "\uBCD1\uB3D9\uC744 \uACE8\uB77C \uC8FC\uC138\uC694.";
  }
  if (rows.some((r) => !r.scheduleGroupId)) {
    return "\uC2A4\uCF00\uC904\uB7EC\uB97C \uACE8\uB77C \uC8FC\uC138\uC694.";
  }
  const ids = rows.map((r) => r.scheduleGroupId);
  if (new Set(ids).size !== ids.length) {
    return "\uAC19\uC740 \uC2A4\uCF00\uC904\uB7EC\uAC00 \uB450 \uC904\uC5D0 \uB4E4\uC5B4\uAC00 \uC788\uC5B4\uC694.";
  }
  return "";
}
__name(wardRowsError, "wardRowsError");
function rowValue(row) {
  return {
    wardId: row.wardId,
    scheduleGroupId: row.scheduleGroupId,
    workType: row.workType,
    isHeadNurse: row.isHeadNurse
  };
}
__name(rowValue, "rowValue");
function sameValue(a, b) {
  return a.wardId === b.wardId && a.scheduleGroupId === b.scheduleGroupId && a.workType === b.workType && a.isHeadNurse === b.isHeadNurse;
}
__name(sameValue, "sameValue");
function planWardAssignmentChanges(rows, removed) {
  const plan = {
    deletes: removed.map((r) => r.profileId),
    updates: [],
    creates: []
  };
  for (const row of rows) {
    const value = rowValue(row);
    if (!(row.profileId && row.original)) {
      plan.creates.push({
        key: row.key,
        ...value
      });
      continue;
    }
    if (!sameValue(row.original, value)) {
      plan.updates.push({
        id: row.profileId,
        ...value
      });
    }
  }
  return plan;
}
__name(planWardAssignmentChanges, "planWardAssignmentChanges");
function hasWardAssignmentChanges(rows, removed) {
  const plan = planWardAssignmentChanges(rows, removed);
  return plan.deletes.length + plan.updates.length + plan.creates.length > 0;
}
__name(hasWardAssignmentChanges, "hasWardAssignmentChanges");
async function applyWardAssignmentChanges(api, employeeId, rows, removed) {
  const plan = planWardAssignmentChanges(rows, removed);
  for (const id of plan.deletes) {
    await api.deleteProfile(id);
  }
  removed.splice(0, removed.length);
  for (const u of plan.updates) {
    await api.updateProfile({
      id: u.id,
      wardId: u.wardId,
      // 빈 값은 uuid 검증에 걸린다 — 스케줄러를 못 고른 줄은 wardRowsError 가 저장을 막지만, 여기서도 빼서 보낸다
      scheduleGroupId: u.scheduleGroupId || void 0,
      workType: u.workType,
      isHeadNurse: u.isHeadNurse
    });
  }
  for (const c of plan.creates) {
    const result = await api.createProfile({
      employeeId,
      wardId: c.wardId,
      scheduleGroupId: c.scheduleGroupId || void 0,
      workType: c.workType,
      isHeadNurse: c.isHeadNurse
    });
    const row = rows.find((r) => r.key === c.key);
    if (row) {
      row.profileId = result.data.id;
    }
  }
  for (const row of rows) {
    row.original = rowValue(row);
  }
}
__name(applyWardAssignmentChanges, "applyWardAssignmentChanges");
function slotKey(row) {
  return row.scheduleGroupId || `ward:${row.wardId}`;
}
__name(slotKey, "slotKey");
function mergeServerWardRows(rows, removed, serverWards) {
  const server = wardRowsFromAssignments(serverWards);
  const serverById = new Map(server.map((s) => [
    s.profileId,
    s
  ]));
  const removedIds = new Set(removed.map((r) => r.profileId));
  const unchanged = /* @__PURE__ */ __name((r) => !!r.original && sameValue(r.original, r), "unchanged");
  const edited = /* @__PURE__ */ __name((r, field) => !r.original || r.original[field] !== r[field], "edited");
  const mergeEdited = /* @__PURE__ */ __name((row, s) => {
    const serverMoved = !!row.original && (row.original.wardId !== s.wardId || row.original.scheduleGroupId !== s.scheduleGroupId);
    const placeFromServer = serverMoved || !(edited(row, "wardId") || edited(row, "scheduleGroupId"));
    return {
      ...row,
      wardId: placeFromServer ? s.wardId : row.wardId,
      wardName: placeFromServer ? s.wardName : row.wardName,
      scheduleGroupId: placeFromServer ? s.scheduleGroupId : row.scheduleGroupId,
      scheduleGroupName: placeFromServer ? s.scheduleGroupName : row.scheduleGroupName,
      workType: edited(row, "workType") ? row.workType : s.workType,
      isHeadNurse: edited(row, "isHeadNurse") ? row.isHeadNurse : s.isHeadNurse,
      original: s.original
    };
  }, "mergeEdited");
  const next = [];
  for (const row of rows) {
    if (!row.profileId) {
      next.push(row);
      continue;
    }
    const s = serverById.get(row.profileId);
    if (!s) {
      if (!unchanged(row)) {
        next.push({
          ...row,
          profileId: "",
          original: null
        });
      }
      continue;
    }
    next.push(unchanged(row) ? {
      ...s,
      key: row.key
    } : mergeEdited(row, s));
  }
  const known = new Set(next.map((r) => r.profileId).filter(Boolean));
  for (const s of server) {
    if (known.has(s.profileId) || removedIds.has(s.profileId)) {
      continue;
    }
    const pending = next.find((r) => !r.profileId && slotKey(r) === slotKey(s));
    if (pending) {
      pending.profileId = s.profileId;
      pending.original = s.original;
    } else {
      next.push(s);
    }
  }
  return claimSameSlotRows(next, removed.filter((r) => serverById.has(r.profileId)), serverById);
}
__name(mergeServerWardRows, "mergeServerWardRows");
function claimSameSlotRows(rows, removed, serverById) {
  const result = [
    ...rows
  ];
  const nextRemoved = [
    ...removed
  ];
  const savedAt = /* @__PURE__ */ __name((r, slot) => !!r.profileId && !!r.original && slotKey(r.original) === slot, "savedAt");
  for (const slot of new Set(rows.filter((r) => r.wardId).map(slotKey))) {
    const same = result.filter((r) => slotKey(r) === slot);
    const holder = same.find((r) => savedAt(r, slot));
    const claimant = same.find((r) => r !== holder);
    if (same.length !== 2 || !holder || !claimant || savedAt(claimant, slot)) {
      continue;
    }
    const before = claimant.profileId ? serverById.get(claimant.profileId) : void 0;
    if (before?.original) {
      nextRemoved.push({
        profileId: before.profileId,
        wardName: before.wardName,
        scheduleGroupName: before.scheduleGroupName,
        ...before.original
      });
    }
    result[result.indexOf(claimant)] = {
      ...claimant,
      profileId: holder.profileId,
      original: holder.original
    };
    result.splice(result.indexOf(holder), 1);
  }
  return {
    rows: result,
    removed: nextRemoved
  };
}
__name(claimSameSlotRows, "claimSameSlotRows");

// src/components/EditEmployeePanel.ts
function membershipRowFromDetail(t) {
  const shiftGroupId = t.shiftGroupId || "";
  const shiftId = t.shiftId || "";
  const isPrimary = t.isPrimary === true;
  return {
    memberId: t.memberId || "",
    teamId: t.id || "",
    teamName: t.name || "",
    roleId: t.roleId || "",
    roleName: t.roleName || t.role || "",
    originalRoleId: t.roleId || "",
    shiftGroupId,
    shiftId,
    originalShiftGroupId: shiftGroupId,
    originalShiftId: shiftId,
    isPrimary,
    originalIsPrimary: isPrimary,
    shiftAssignedVia: t.shiftAssignedVia || ""
  };
}
__name(membershipRowFromDetail, "membershipRowFromDetail");
function mergeMembershipEdits(local, server) {
  const localPrimary = local.find((m) => m.isPrimary && !m.originalIsPrimary);
  const keepPrimaryId = localPrimary && server.some((m) => m.memberId === localPrimary.memberId) ? localPrimary.memberId : null;
  return server.map((row) => {
    const prev = local.find((m) => m.memberId === row.memberId);
    const next = {
      ...row
    };
    if (prev && (prev.shiftGroupId !== prev.originalShiftGroupId || prev.shiftId !== prev.originalShiftId)) {
      next.shiftGroupId = prev.shiftGroupId;
      next.shiftId = prev.shiftId;
    }
    if (prev && prev.roleId !== prev.originalRoleId) {
      next.roleId = prev.roleId;
      next.roleName = prev.roleName;
    }
    if (keepPrimaryId) {
      next.isPrimary = row.memberId === keepPrimaryId;
    }
    return next;
  });
}
__name(mergeMembershipEdits, "mergeMembershipEdits");
function displayDate(v, timezone) {
  if (!v || typeof v !== "string" && !(v instanceof Date)) {
    return "";
  }
  if (Number.isNaN(new Date(v).getTime())) {
    return "";
  }
  return formatDate2(v, "ko-KR", timezone || Intl.DateTimeFormat().resolvedOptions().timeZone);
}
__name(displayDate, "displayDate");
var DAUM_POSTCODE_SRC2 = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
function editEmployeePanelComponent(opts = {}) {
  return {
    employeePanelVisible: false,
    employeeEntryRevision: 0,
    /** 「편집」을 누른 뒤 패널이 준비되기 전 — 같은 크기의 껍데기 + 스켈레톤을 띄운다(2026-10-21) */
    editOpening: false,
    /** 여는 중 껍데기를 닫는다 — 진행 중인 열기는 revision 을 올려 버린다(나중에 패널이 튀어나오지 않게) */
    cancelEditOpening() {
      this.editOpening = false;
      this.employeeEntryRevision++;
    },
    get showEditEmployee() {
      return this.employeePanelVisible;
    },
    set showEditEmployee(value) {
      this.employeePanelVisible = value;
      if (!value) {
        this.employeeEntryRevision++;
        this.analyticsAttempt?.dispose();
        this.analyticsAttempt = null;
      }
    },
    /* Self-contained save-confirm (the panel is mounted standalone, so it can't
    rely on a host app's closeConfirm). X / 취소 / Esc route through
    attemptClosePanel() so typed input never silently disappears. */
    showCloseConfirm: false,
    /* Pristine snapshot taken when the panel opens (and refreshed after the
    async detail load) — an untouched form closes directly; the confirm only
    appears once something was changed. */
    closeBaseline: "",
    closeGuardState() {
      const { newPassword: _np, confirmPassword: _cp, passwordMode: _pm, ...formWithoutPassword } = this.editForm;
      return JSON.stringify([
        formWithoutPassword,
        this.editMemberships,
        this.leaveConfirmForm,
        this.terminationForm,
        this.editWards.map((w) => [
          w.profileId,
          w.wardId,
          w.scheduleGroupId,
          w.workType,
          w.isHeadNurse
        ]),
        this.editWardsRemoved.map((r) => r.profileId)
      ]);
    },
    /** 저장 버튼 활성 조건 — 폼이 열린 직후 기준선(closeBaseline)에서 바뀐 게 있으면 dirty.
    닫기 가드와 같은 스냅샷을 재사용해 "닫을 때 확인 뜸 = 저장 가능"으로 의미를 일치시킨다. */
    isEditFormDirty() {
      return this.closeGuardState() !== this.closeBaseline;
    },
    /** 저장 버튼 활성 조건 — 변경이 있고, 휴직/퇴직으로 '전환'했다면 그 필수값까지 채워졌을 때만.
    (saveEmployee의 분기 가드와 동일: 휴직 전환=사유+시작일, 퇴직 전환=사유+동의. 상태만 바꾸고
    입력 안 한 채로 저장이 활성화되던 문제 방지.) */
    canSaveEmployee() {
      if (!this.isEditFormDirty()) {
        return false;
      }
      if (this.wardRowsError()) {
        return false;
      }
      const action = this.editForm.statusAction;
      const cur = this.editForm.status;
      if (action === "ON_LEAVE" && cur !== "ON_LEAVE") {
        return !!(this.leaveConfirmForm.reason && this.leaveConfirmForm.startDate);
      }
      if (action === "TERMINATED" && cur !== "TERMINATED") {
        return !!(this.terminationForm.reason && this.terminationForm.confirmed);
      }
      return true;
    },
    attemptClosePanel() {
      if (this.closeGuardState() === this.closeBaseline) {
        this.showEditEmployee = false;
        return;
      }
      this.showCloseConfirm = true;
    },
    confirmClosePanel() {
      this.showCloseConfirm = false;
      this.showEditEmployee = false;
    },
    dismissClosePanel() {
      this.showCloseConfirm = false;
    },
    /** 패널 위 레이어 팝업이 막 닫힌 시각(ms) — ESC 연타/키리피트로 패널까지 닫히는 것을 막는 가드 키. */
    topLayerClosedAt: 0,
    /**
    * ESC 처리 — 패널 위 레이어 팝업을 위에서부터 "하나씩만" 닫는다. 팝업을 막 닫은 직후
    * (연타/키리피트)에는 패널이 통째로 닫히지 않도록 유예한다.
    *
    * 단일 window ESC 핸들러라 팝업이 닫힌 다음 키다운이 곧바로 패널 닫기 분기로 떨어지는데,
    * 팝업을 닫을 때 시각을 찍고 그 직후(<500ms)의 패널 닫기를 무시해 "둘째 ESC가 패널을 닫는"
    * 버그를 막는다(type-manager와 동일 패턴).
    */
    escapeClose() {
      if (permissionModalOwnsEsc()) {
        return;
      }
      if (this.confirmDialog.show) {
        this.resolveConfirm(false);
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.notice.show) {
        this.closeNotice();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.previewOpen) {
        this.closePreview();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.shiftRefOpen) {
        this.shiftRefOpen = false;
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.certPreview.open) {
        this.closeCertPreview();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.showAdminConfirm) {
        this.showAdminConfirm = false;
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.addrSearchOpen) {
        this.closeAddrSearch();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (this.showCloseConfirm) {
        this.dismissClosePanel();
        this.topLayerClosedAt = Date.now();
        return;
      }
      if (!this.showEditEmployee) {
        return;
      }
      if (Date.now() - this.topLayerClosedAt < 500) {
        return;
      }
      this.attemptClosePanel();
    },
    /* 사번 수정 — 사번은 로그인 ID. 필드는 직접 편집 가능하되 [수정] 버튼으로 변경을 '확정'한다.
    버튼은 값이 원본과 다를 때만 활성(수정 전엔 비활성)이며, 클릭 시 중복 검사를 돌려 이상 없으면
    확정(employeeNumberValidated=true)되고 다시 비활성이 된다. 값이 또 바뀌면 재활성.
    정책: 관리자 직원 수정에서 사번 편집 허용 + 저장 시 중복 확인(docs/ko/policy .../employee/page.md). */
    /** 사번 변경이 [수정] 클릭으로 중복검사를 통과해 확정됐는가 — 확정 시 [수정] 버튼 비활성. */
    employeeNumberValidated: false,
    /** 로드 시점 사번 — 변경 여부(로그인 ID 안내) 판단 기준. */
    originalEmployeeNumber: "",
    /** 사번 중복 검사용 직원 목록 — 편집/확정 시 지연 로드(1회). */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic employee list rows
    employees: [],
    /** 인라인 필드 오류(현재 사번 중복만). add 위저드의 addFormErrors.employeeNumber와 동일 문구. */
    editFormErrors: {
      employeeNumber: ""
    },
    /** 사번 중복 검사용 직원 목록을 아직 없으면 1회 지연 로드한다(실패 시 서버가 최종 검증). */
    async ensureEmployeeListLoaded() {
      if (this.employees.length || !this.sdk) {
        return;
      }
      try {
        const emps = await fetchAllPages2((page, limit) => this.sdk.employee.getEmployees({
          page,
          limit
        }), 1e3);
        this.employees = emps || [];
      } catch {
      }
    },
    /** 사번 입력 중 — 확정 상태를 풀고(재확정 필요), 목록 로드 후 실시간 중복 검사. */
    async onEmployeeNumberInput() {
      this.employeeNumberValidated = false;
      await this.ensureEmployeeListLoaded();
      this.checkEmployeeNumberDup();
    },
    /** 입력 중 사번 중복 검사 — 본인(editingEmployee.id) 제외. 중복이면 인라인 오류 문구. */
    checkEmployeeNumberDup() {
      const num = (this.editForm.employeeNumber || "").trim().toUpperCase();
      const selfId = this.editingEmployee?.id;
      const dup = !!num && this.employees.some(
        // biome-ignore lint/suspicious/noExplicitAny: dynamic employee list rows
        (e) => String(e.employeeNumber ?? "").toUpperCase() === num && e.id !== selfId
      );
      this.editFormErrors.employeeNumber = dup ? "\uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC778 \uC0AC\uBC88\uC785\uB2C8\uB2E4." : "";
    },
    /** [수정] 클릭 — 목록 로드 후 중복 검사를 돌려 이상 없으면 변경을 확정한다(버튼 비활성).
    서버 저장은 부모 '저장' 버튼(persistBasicEdits)에서 처리한다. */
    async confirmEmployeeNumber() {
      await this.ensureEmployeeListLoaded();
      this.checkEmployeeNumberDup();
      if (!this.editFormErrors.employeeNumber) {
        this.employeeNumberValidated = true;
      }
    },
    /** 사번이 로드 시점 값에서 바뀌었는가 — 바뀌면 '로그인 ID가 함께 바뀐다' 안내(ds-info) 노출. */
    employeeNumberChanged() {
      return (this.editForm.employeeNumber || "") !== (this.originalEmployeeNumber || "");
    },
    /* 주소 검색(우편번호) — 직원 추가 모달과 동일한 Daum 우편번호 서비스 흐름을 이식.
    address(도로명/지번) → street, postalCode, addressDetail → detail 로 저장된다. */
    addrSearchOpen: false,
    /** 스크립트 로드 프로미스(1회) — 실패 시 버려서 다음 시도에 재로드한다. */
    daumPostcodePromise: null,
    /** Daum 우편번호 서비스 스크립트를 lazy 로드한다(키 불필요·프론트 전용). */
    _loadDaumPostcode() {
      if (window.daum?.Postcode) {
        return Promise.resolve(window.daum);
      }
      if (!this.daumPostcodePromise) {
        this.daumPostcodePromise = new Promise((resolve2, reject) => {
          const script = document.createElement("script");
          script.src = DAUM_POSTCODE_SRC2;
          script.onload = () => {
            if (window.daum?.Postcode) {
              resolve2(window.daum);
            } else {
              this.daumPostcodePromise = null;
              reject(new Error("\uC8FC\uC18C \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC5B4\uC694."));
            }
          };
          script.onerror = () => {
            this.daumPostcodePromise = null;
            reject(new Error("\uC8FC\uC18C \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB124\uD2B8\uC6CC\uD06C\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694."));
          };
          document.head.appendChild(script);
        });
      }
      return this.daumPostcodePromise;
    },
    /** '검색' 클릭 — 공통 모달을 열고 컨테이너에 주소 검색(도로명·지번 리스트)을 마운트한다. */
    async openAddrSearch() {
      this.addrSearchOpen = true;
      try {
        const daum = await this._loadDaumPostcode();
        if (!this.addrSearchOpen) {
          return;
        }
        const box = document.getElementById("editEmpAddrEmbed");
        if (!box) {
          return;
        }
        box.innerHTML = "";
        new daum.Postcode({
          oncomplete: /* @__PURE__ */ __name((data) => this.applyAddrSelection(data), "oncomplete"),
          width: "100%",
          height: "100%"
        }).embed(box);
      } catch (err) {
        this.addrSearchOpen = false;
        this.showNotice(err instanceof Error ? err.message : String(err), "danger");
      }
    },
    closeAddrSearch() {
      this.addrSearchOpen = false;
    },
    /** 주소 리스트에서 항목 클릭 — 선택 표기(도로명/지번)를 기본 주소로, 우편번호를 함께 채운다. */
    applyAddrSelection(data) {
      const road = data.roadAddress || "";
      const jibun = data.jibunAddress || "";
      this.editForm.address = data.userSelectedType === "J" ? jibun || road : road || jibun;
      this.editForm.postalCode = data.zonecode || "";
      this.editForm.addressDetail = "";
      this.addrSearchOpen = false;
      setTimeout(() => document.getElementById("editEmpAddrDetail")?.focus(), 0);
    },
    /** 주소 선택 해제(X) — 주소는 선택 항목이라 잘못 선택했을 때 비울 수 있어야 한다. */
    clearAddress() {
      this.editForm.address = "";
      this.editForm.postalCode = "";
      this.editForm.addressDetail = "";
    },
    /** 자격증에 첨부파일(storagePath)이 있는가 — '첨부파일 미리보기' 버튼 노출 조건. */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic certification row
    certHasFile(cert) {
      return !!cert?.storagePath;
    },
    /** storagePath에서 파일명만 추출(경로 마지막 세그먼트). */
    certFileName(path) {
      return (path || "").split("/").pop() || "\uCCA8\uBD80\uD30C\uC77C";
    },
    /** 확장자로 미리보기 종류 판별 — image / pdf / other. */
    certFileKind(path) {
      const ext = ((path || "").split(".").pop() || "").toLowerCase();
      if ([
        "jpg",
        "jpeg",
        "png",
        "gif",
        "webp",
        "svg"
      ].includes(ext)) {
        return "image";
      }
      if (ext === "pdf") {
        return "pdf";
      }
      return "other";
    },
    /** '첨부파일 미리보기' 클릭 — presigned URL을 받아 뷰어 모달을 연다(패널 위, z-70). */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic certification row
    async openCertPreview(cert) {
      const path = cert?.storagePath;
      if (!path) {
        return;
      }
      this.certPreview = {
        open: true,
        loading: true,
        url: "",
        name: this.certFileName(path),
        kind: this.certFileKind(path),
        error: "",
        path
      };
      try {
        const url = await herebyStore(this).getFileUrl(path);
        if (!this.certPreview.open || this.certPreview.path !== path) {
          return;
        }
        if (!url) {
          this.certPreview.loading = false;
          this.certPreview.error = "\uCCA8\uBD80\uD30C\uC77C\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC5B4\uC694.";
          return;
        }
        this.certPreview.url = url;
        this.certPreview.loading = false;
      } catch {
        if (!this.certPreview.open || this.certPreview.path !== path) {
          return;
        }
        this.certPreview.loading = false;
        this.certPreview.error = "\uCCA8\uBD80\uD30C\uC77C\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      }
    },
    closeCertPreview() {
      this.certPreview = {
        open: false,
        loading: false,
        url: "",
        name: "",
        kind: "",
        error: "",
        path: ""
      };
    },
    showAdminConfirm: false,
    /* 알림(notice) 팝업 — 네이티브 alert() 대체. 처리 결과·오류·안내를 모달 위(또는 목록 위)에
    커스텀 미니 모달로 보여준다. 휴직/퇴직/복직 결과부터 저장/비밀번호 실패까지 이 팝업으로
    통일한다. tone은 성공/오류 구분용(현재 시각 스타일은 동일, 향후 확장 여지). */
    notice: {
      show: false,
      tone: "success",
      message: ""
    },
    /* 확인(confirm) 팝업 — 네이티브 confirm() 대체. askConfirm()이 Promise<boolean>을 돌려주므로
    기존 `if (!confirm(...)) return;` 흐름을 `if (!(await this.askConfirm(...))) return;`로 옮긴다.
    resolver는 렌더링 상태(confirmDialog)와 분리해 보관한다. */
    confirmDialog: {
      show: false,
      message: "",
      confirmLabel: "\uD655\uC778",
      tone: "default"
    },
    /** confirmDialog(렌더 상태)와 분리 보관하는 Promise resolver — askConfirm/resolveConfirm 전용. */
    confirmResolver: null,
    // biome-ignore lint/suspicious/noExplicitAny: dynamic employee object from list
    editingEmployee: null,
    editMemberships: [],
    /** 근태가 지금 쓰는 근무 — 상세 응답(effectiveShift). 소속 근무를 저장한 뒤 다시 읽어 갱신한다. */
    editEffectiveShift: null,
    // 소속 추가/변경 저장이 서버에 반영되고 목록을 다시 불러오는 동안 true (로더 표시용)
    affiliationBusy: false,
    employeeHistory: {
      leaves: [],
      resignations: []
    },
    // 직원 자격증/면허 목록 — 읽기 전용 표시용
    // biome-ignore lint/suspicious/noExplicitAny: dynamic certification items
    certifications: [],
    /* 자격증/면허 첨부파일 미리보기 — storagePath가 있으면 presigned URL을 받아 패널 위(z-70)
    뷰어 모달로 표시. 이미지/PDF는 인라인, 그 외 형식은 새 창 열기 안내. kind는 확장자 기반 판별. */
    certPreview: {
      open: false,
      loading: false,
      url: "",
      name: "",
      kind: "",
      error: "",
      // 열람 중인 파일 경로 — 늦게 도착한 이전 요청이 새 파일 위에 덮어쓰지 않도록 가드 키로 쓴다.
      path: ""
    },
    editForm: {
      lastName: "",
      firstName: "",
      email: "",
      phone: "",
      countryCode: "+82",
      employeeNumber: "",
      hireDate: "",
      birthDate: "",
      isLunarBirth: false,
      residentNumber: "",
      residentNumberFront: "",
      residentNumberBack: "",
      // 주소 — 우편번호 검색(공통 모달)으로 채워지는 구조화 입력 (직원 추가 모달과 동일).
      // address = 기본 주소(도로명/지번, street에 저장), postalCode = 5자리, addressDetail = 상세주소(detail).
      address: "",
      postalCode: "",
      addressDetail: "",
      status: "ACTIVE",
      // UI-only field driving the inline status dropdown.
      // Values: "ACTIVE" | "INACTIVE" | "ON_LEAVE" | "RETURN" | "TERMINATED" | "REINSTATE"(퇴직 취소)
      statusAction: "ACTIVE",
      shiftId: "",
      shiftGroupId: "",
      // 직원 단위 근무 배정의 출처(표시 전용) — 소속이 없을 때의 근무 배정 칸 아래에 보여 준다
      shiftAssignedVia: "",
      // 허용 근무 유형(MED-969) — 배정 그룹 밖에서도 직원 앱에서 고를 수 있는 근무 유형 id 들
      allowedShiftIds: [],
      attendanceMethod: "",
      // 직무 — 직무 마스터(job_duties)에서 고른 id. 비우면 null 로 지운다(이름 사본 jobDuty 도 서버가 비운다).
      jobDutyId: "",
      // 이름 사본(표시·미리보기용). 마스터에 없는 옛 값(참조 없음)도 여기 남는다.
      jobDuty: "",
      // 근로형태(work_patterns) — 상세 응답으로 채운다. overrides 는 수동으로 둔 파생 필드 키(표시용)
      workPatternId: "",
      workPatternName: "",
      workPatternOverrides: [],
      // 체크하면 저장 때 수동 필드를 전부 자동(근로형태 기준)으로 되돌린다
      workPatternResetOverrides: false,
      isSystemAdmin: false,
      payrollExcluded: false,
      accountId: "",
      phoneOtpEnabled: false,
      newPassword: "",
      confirmPassword: "",
      passwordMode: "sms",
      // 근로계약 — 저장은 employee.update가 아닌 전용 upsertContract(버전 append)로 처리한다.
      contractType: "permanent",
      wageType: "monthly",
      // 호봉 배정 — 활성 호봉 선택 시 기본급/호봉수당이 표 값으로 잠긴다.
      salaryGradeId: "",
      baseSalary: 0,
      hobongAmount: 0,
      longevityAmount: 0,
      mealAllowance: 0,
      transportAllowance: 0,
      positionAllowance: 0,
      standardWeeklyHours: 40,
      maxWeeklyHours: 52
    },
    /** 로드 시점 계약 스냅샷 — 저장 시 변경분이 있을 때만 upsertContract를 호출(불필요한 새 버전 방지). */
    editContractOriginal: "",
    leaveConfirmForm: {
      reason: "",
      reasonDetail: "",
      startDate: "",
      expectedReturnDate: "",
      notes: ""
    },
    terminationForm: {
      reason: "",
      reasonDetail: "",
      terminationDate: "",
      notes: "",
      confirmed: false
    },
    /** 퇴직 취소(재직 복귀) 박스 — 사유 필수(MED-834) */
    reinstateForm: {
      reason: ""
    },
    /** 퇴직 처리 박스의 「입사일 기준 잔여 연차」 — 정산 기준값. 조직 적용 기준이 회계년도면 참고 환산(isReference) */
    terminationLeaveBalance: null,
    terminationLeaveBalanceLoading: false,
    /** 마지막으로 조회한 "직원:퇴사일" — 같은 값이면 다시 조회하지 않는다 */
    terminationLeaveBalanceKey: "",
    // Reference data
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    teams: [],
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    roles: [],
    // 병동 배정 — 편집 중인 행 · 저장 때 지울 프로필 · 병동 목록(처음 열 때 조용히 불러온다)
    editWards: [],
    editWardsRemoved: [],
    wardList: [],
    /** 스케줄러(스케줄 그룹) 목록 — 병동 목록과 함께 받는다. 줄마다 병동 안의 스케줄러를 고른다 */
    scheduleGroupList: [],
    wardRowSeq: 0,
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    shifts: [],
    // 근무 그룹 목록 (근무 배정 그룹 선택용)
    // biome-ignore lint/suspicious/noExplicitAny: dynamic data
    shiftGroups: [],
    // 활성 호봉 목록 (호봉 정의 시트 정본, status=active 만).
    salaryGrades: [],
    // biome-ignore lint/suspicious/noExplicitAny: SDK type from Alpine store
    sdk: null,
    dataReady: false,
    _t(key, vars) {
      try {
        return herebyStore(this).t(key, vars) || key;
      } catch {
        return key;
      }
    },
    /**
    * admin 권한 토글 잠금 (owner가 있는 조직만):
    * - 대상이 owner → 해제 불가
    * - 호출자가 owner가 아님 → 부여/해제 불가 (admin 권한 할당은 owner만)
    * 레거시 조직(owner 없음)은 기존 동작 유지. 서버 가드와 이중.
    */
    get adminToggleLocked() {
      const cu = herebyStore(this).currentUser;
      const ownerAccountId = cu?.organizationOwnerAccountId || "";
      if (!ownerAccountId) {
        return false;
      }
      const targetIsOwner = !!this.editForm.accountId && this.editForm.accountId === ownerAccountId;
      const callerIsOwner = cu?.accountId === ownerAccountId;
      return targetIsOwner || !callerIsOwner;
    },
    get adminToggleLockReason() {
      const cu = herebyStore(this).currentUser;
      const ownerAccountId = cu?.organizationOwnerAccountId || "";
      if (!ownerAccountId) {
        return "";
      }
      if (this.editForm.accountId && this.editForm.accountId === ownerAccountId) {
        return "owner\uC758 admin \uAD8C\uD55C\uC740 \uD574\uC81C\uD560 \uC218 \uC5C6\uC5B4\uC694.";
      }
      if (cu?.accountId !== ownerAccountId) {
        return "admin \uAD8C\uD55C \uBD80\uC5EC/\uD574\uC81C\uB294 owner\uB9CC \uD560 \uC218 \uC788\uC5B4\uC694.";
      }
      return "";
    },
    /** 조직 로컬 오늘 날짜로 입사일을 즉시 채운다. (직원 추가 모달과 동일) */
    setHireDateToday() {
      const store = herebyStore(this);
      this.editForm.hireDate = store?.todayLocal?.() || (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
    },
    /* ──────────── 휴직/퇴직 이력 상태 표시 ──────────── */
    /** 휴직 기록 상태(LeaveOfAbsenceStatus) → 라벨. active=휴직 중, cancelled=휴직 취소, 그 외(returned)=복직.
    (이전엔 active 여부로만 갈라 cancelled가 '복직'으로 잘못 표시되던 문제 해결) */
    leaveStatusLabel(status) {
      if (status === "active") {
        return this._t("employee.on_leave_label");
      }
      if (status === "cancelled") {
        return this._t("employee.leave_cancelled_label");
      }
      return this._t("employee.returned_label");
    },
    /** 휴직 기록 상태 → DS 라벨(line/outline) 클래스. active=휴직(yellow), 그 외=gray. */
    leaveStatusBadgeClass(status) {
      return status === "active" ? "ds-label ds-label--sm ds-label--square ds-label--line ds-label--yellow" : "ds-label ds-label--sm ds-label--square ds-label--line ds-label--gray";
    },
    /** 퇴직 기록 처리 상태(ResignationStatus) → 한글 라벨. (이전엔 영어 원문 `(pending)` 등이 그대로 노출) */
    resignationStatusLabel(status) {
      const keyMap = {
        pending: "resignation.status_pending",
        processing: "resignation.status_processing",
        settled: "resignation.status_settled",
        completed: "resignation.status_completed"
      };
      return keyMap[status] ? this._t(keyMap[status]) : status || "";
    },
    /** Per-team collapsed state for the team-picker tree (persisted). */
    teamPickerCollapsed: (() => {
      try {
        const raw = localStorage.getItem("admin:teamPickerCollapsed");
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    })(),
    toggleTeamPickerCollapsed(teamId) {
      this.teamPickerCollapsed = {
        ...this.teamPickerCollapsed,
        [teamId]: !this.teamPickerCollapsed[teamId]
      };
      try {
        localStorage.setItem("admin:teamPickerCollapsed", JSON.stringify(this.teamPickerCollapsed));
      } catch {
      }
    },
    /**
    * Depth-first flat view of teams (roots → children → grandchildren) with
    * `treeDepth`, `treeIsLeaf`, and `treeChildCount`. Collapse retired: the
    * tree always renders fully expanded so no team can be hidden.
    */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic team rows
    teamTreeFlat() {
      const list = this.teams;
      const byParent = /* @__PURE__ */ new Map();
      for (const t of list) {
        const pid = t.parentTeamId || "";
        if (!byParent.has(pid)) {
          byParent.set(pid, []);
        }
        byParent.get(pid)?.push(t);
      }
      for (const arr of byParent.values()) {
        arr.sort((a, b) => compareTeamOrder2(a, b));
      }
      const out = [];
      const walk = /* @__PURE__ */ __name((parentId, depth) => {
        const kids = byParent.get(parentId) || [];
        for (const t of kids) {
          const childCount = (byParent.get(t.id) || []).length;
          out.push({
            ...t,
            treeDepth: depth,
            treeIsLeaf: childCount === 0,
            treeChildCount: childCount,
            treeCollapsed: false
          });
          if (childCount > 0) {
            walk(t.id, depth + 1);
          }
        }
      }, "walk");
      walk("", 0);
      return out;
    },
    /** 팀 피커(드롭다운 트리) 전용 — 접힌 부모의 하위 팀과 비활성 팀은 제외한 목록.
    *  `query` 가 있으면 검색 모드(계층·접기 무시, 이름 일치만 평평하게), `keepTeamId` 는
    *  지금 소속의 팀이라 비활성이어도 남긴다.
    *
    *  `teamTreeFlat()`은 항상 전체를 돌려준다(일괄 팀 변경 select · `teamLeavesFlat()` 처럼
    *  모든 팀이 보여야 하는 곳이 쓴다). 피커는 이 메서드를 써서 접기 상태를 반영한다.
    *  접힌 부모 행 자체는 항상 남고 chevron 도 그대로라, 저장된 접기 상태가 오래돼도
    *  팀이 영구히 사라지는 일은 없다 — 부모를 펼치면 언제든 다시 나온다.
    *  (2026-08 QA: 접기 버튼이 눌려도 아무 변화가 없던 것은, 상태·핸들러는 남았는데
    *  트리 생성이 접기를 무시하도록 고정돼 있었기 때문이다.) */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic team rows
    teamTreePicker(query = "", keepTeamId = "") {
      const q = pickerQuery(query);
      const shown = /* @__PURE__ */ __name((t) => t.isActive !== false || t.id === keepTeamId, "shown");
      if (q) {
        return this.teamTreeFlat().filter((t) => shown(t) && pickerMatches(t.name, q)).map((t) => ({
          ...t,
          treeDepth: 0,
          treeIsLeaf: true,
          treeChildCount: 0,
          treeCollapsed: false
        }));
      }
      const collapsed = this.teamPickerCollapsed || {};
      const hidden = /* @__PURE__ */ new Set();
      return this.teamTreeFlat().flatMap((t) => {
        const pid = t.parentTeamId || "";
        if (pid && hidden.has(pid)) {
          hidden.add(t.id);
          return [];
        }
        if (!shown(t)) {
          hidden.add(t.id);
          return [];
        }
        const isCollapsed = !t.treeIsLeaf && !!collapsed[t.id];
        if (isCollapsed) {
          hidden.add(t.id);
        }
        return [
          {
            ...t,
            treeCollapsed: isCollapsed
          }
        ];
      });
    },
    /** 역할 피커 목록 — 비활성 역할은 빼고(지금 소속의 역할 keepRoleId 만 예외) 검색어로 거른다 */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic role rows
    rolePickerList(query = "", keepRoleId = "") {
      return pickerRoles(this.roles, query, keepRoleId);
    },
    rrnError: "",
    // 패널 카테고리(좌측 메뉴) — 직원 추가 패널과 동일한 2단 구조.
    editEmployeeCats: [
      "basic",
      "hr",
      "certification",
      "contract",
      "allowances",
      "account"
    ],
    editEmployeeCat: "basic",
    // ── 반복 고정 수당 정의(MED-824) — 「이 수당을 이 기간 매달」. 시트가 그 달 기준으로 읽는다. ──
    recurringAllowances: [],
    recurringAllowancesLoading: false,
    recurringAllowanceSaving: false,
    recurringAllowanceForm: {
      code: "",
      label: "",
      amount: 0,
      validFrom: "",
      validUntil: "",
      note: ""
    },
    /** 행별 편집 값(종료일 · 정정 금액) — 저장 전까지 목록 값은 그대로 */
    recurringAllowanceEdits: {},
    async loadRecurringAllowances(employeeId) {
      this.recurringAllowancesLoading = true;
      try {
        const rows = await this.sdk.recurringAllowance.list({
          employeeId,
          includeEnded: true
        });
        this.recurringAllowances = rows;
        const edits = {};
        for (const r of rows) {
          edits[r.id] = {
            validUntil: r.validUntil ?? "",
            amount: r.amount
          };
        }
        this.recurringAllowanceEdits = edits;
      } catch (e) {
        showError(`${this._t("recurring.load_fail")}: ${e instanceof Error ? e.message : e}`);
      } finally {
        this.recurringAllowancesLoading = false;
      }
    },
    recurringAllowanceStatusLabel(status) {
      return this._t(`recurring.status_${status}`);
    },
    async addRecurringAllowance() {
      const emp = this.editingEmployee;
      const f = this.recurringAllowanceForm;
      if (!emp?.id) {
        return;
      }
      if (!(f.code && f.label && f.validFrom && f.amount > 0)) {
        showAlert(this._t("recurring.form_invalid"));
        return;
      }
      this.recurringAllowanceSaving = true;
      try {
        await this.sdk.recurringAllowance.create({
          employeeId: emp.id,
          code: f.code.trim().toLowerCase(),
          label: f.label.trim(),
          amount: f.amount,
          validFrom: f.validFrom,
          validUntil: f.validUntil || null,
          note: f.note.trim() || void 0
        });
        this.recurringAllowanceForm = {
          code: "",
          label: "",
          amount: 0,
          validFrom: "",
          validUntil: "",
          note: ""
        };
        await this.loadRecurringAllowances(emp.id);
      } catch (e) {
        showError(`${this._t("recurring.save_fail")}: ${e instanceof Error ? e.message : e}`);
      } finally {
        this.recurringAllowanceSaving = false;
      }
    },
    /** 종료일 저장 — 다음 달부터 시트에서 빠진다. 비우면 무기한으로 되돌린다. */
    async saveRecurringAllowanceEnd(id) {
      const emp = this.editingEmployee;
      const edit = this.recurringAllowanceEdits[id];
      if (!(emp?.id && edit)) {
        return;
      }
      this.recurringAllowanceSaving = true;
      try {
        await this.sdk.recurringAllowance.correct({
          id,
          validUntil: edit.validUntil || null
        });
        await this.loadRecurringAllowances(emp.id);
      } catch (e) {
        showError(`${this._t("recurring.save_fail")}: ${e instanceof Error ? e.message : e}`);
      } finally {
        this.recurringAllowanceSaving = false;
      }
    },
    /** 금액 정정 — 같은 정의의 새 버전. 이 정의가 걸친 모든 미커밋 달에 반영된다(시행일이 다르면 새로 등록). */
    async saveRecurringAllowanceAmount(id) {
      const emp = this.editingEmployee;
      const edit = this.recurringAllowanceEdits[id];
      if (!(emp?.id && edit)) {
        return;
      }
      if (!await this.askConfirm(this._t("recurring.correct_confirm"))) {
        return;
      }
      this.recurringAllowanceSaving = true;
      try {
        await this.sdk.recurringAllowance.correct({
          id,
          amount: Number(edit.amount)
        });
        await this.loadRecurringAllowances(emp.id);
      } catch (e) {
        showError(`${this._t("recurring.save_fail")}: ${e instanceof Error ? e.message : e}`);
      } finally {
        this.recurringAllowanceSaving = false;
      }
    },
    editCatLabel(id) {
      if (id === "basic") {
        return this._t("employee.basic_info");
      }
      if (id === "certification") {
        return this._t("employee.certification");
      }
      if (id === "contract") {
        return this._t("employee.contract");
      }
      if (id === "allowances") {
        return this._t("employee.recurring_allowances");
      }
      if (id === "account") {
        return this._t("employee.account_security");
      }
      return this._t("employee.hr_info");
    },
    editEmployeeGoCat(id) {
      this.editEmployeeCat = id;
    },
    /** 휴직/퇴직 입력 폼을 초기 상태(시작일/퇴직일=오늘, 나머지 빈값)로 되돌린다. 모달 진입 시 사용. */
    resetStatusForms() {
      const today = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
      this.leaveConfirmForm = {
        reason: "",
        reasonDetail: "",
        startDate: today,
        expectedReturnDate: "",
        notes: ""
      };
      this.terminationForm = {
        reason: "",
        reasonDetail: "",
        terminationDate: today,
        notes: "",
        confirmed: false
      };
      this.reinstateForm = {
        reason: ""
      };
      this.terminationLeaveBalance = null;
      this.terminationLeaveBalanceKey = "";
    },
    /**
    * 퇴직 처리 박스가 열리면 입사일 기준 잔여를 조회한다(퇴사 예정일 기준). 화면의 x-effect가
    * 상태 선택·퇴사일 변경마다 부르므로 같은 키면 건너뛴다. 권한이 없거나 실패하면 값을 비운다.
    */
    async loadTerminationLeaveBalance(terminationDate) {
      const employeeId = this.editingEmployee?.id;
      if (!employeeId) {
        return;
      }
      const asOf = terminationDate && /^\d{4}-\d{2}-\d{2}$/.test(terminationDate) ? terminationDate : "";
      const key = `${employeeId}:${asOf}`;
      if (this.terminationLeaveBalanceKey === key) {
        return;
      }
      this.terminationLeaveBalanceKey = key;
      this.terminationLeaveBalanceLoading = true;
      try {
        const r = await this.sdk.leaveRequest.settlementBalance(employeeId, asOf || void 0);
        if (this.terminationLeaveBalanceKey !== key) {
          return;
        }
        this.terminationLeaveBalance = r ? {
          remaining: Number(r.remaining),
          totalEntitled: Number(r.totalEntitled),
          used: Number(r.used),
          periodStart: String(r.periodStart),
          periodEnd: String(r.periodEnd),
          isReference: !!r.isReference
        } : null;
      } catch {
        this.terminationLeaveBalance = null;
      } finally {
        if (this.terminationLeaveBalanceKey === key) {
          this.terminationLeaveBalanceLoading = false;
        }
      }
    },
    /** "12일 (부여 15 · 사용 3 · 2026.03.01. ~ 2027.02.28.)" — 값이 없으면 "-" */
    terminationLeaveBalanceLabel() {
      if (this.terminationLeaveBalanceLoading && !this.terminationLeaveBalance) {
        return "\u2026";
      }
      const b = this.terminationLeaveBalance;
      if (!b) {
        return "-";
      }
      const dot = /* @__PURE__ */ __name((d) => displayDate(d.slice(0, 10), herebyStore(this)?.timezone), "dot");
      return `${b.remaining}\uC77C (\uBD80\uC5EC ${b.totalEntitled} \xB7 \uC0AC\uC6A9 ${b.used} \xB7 ${dot(b.periodStart)} ~ ${dot(b.periodEnd)})`;
    },
    /** 알림 팝업 표시 — 모든 네이티브 alert() 대체(처리 결과·오류·안내 공용). */
    showNotice(message, tone = "success") {
      this.notice = {
        show: true,
        tone,
        message
      };
    },
    closeNotice() {
      this.notice.show = false;
    },
    /** 확인 팝업 표시 — 네이티브 confirm() 대체. 사용자가 확인/취소를 고르면 resolve된다.
    이전 확인이 열린 채 남아 있으면 false로 정리해 resolver 누수를 막는다. */
    askConfirm(message, o = {}) {
      if (this.confirmResolver) {
        this.confirmResolver(false);
        this.confirmResolver = null;
      }
      this.confirmDialog = {
        show: true,
        message,
        confirmLabel: o.confirmLabel || "\uD655\uC778",
        tone: o.tone || "default"
      };
      return new Promise((resolve2) => {
        this.confirmResolver = resolve2;
      });
    },
    /** 확인 팝업 응답 — 확인=true / 취소·Esc=false. resolver를 호출하고 팝업을 닫는다. */
    resolveConfirm(ok) {
      this.confirmDialog.show = false;
      const r = this.confirmResolver;
      this.confirmResolver = null;
      if (r) {
        r(ok);
      }
    },
    /** 드롭다운 라벨 — "카테고리 3호봉 (2026)" 또는 카테고리 없이 "3호봉 (2026)". */
    salaryGradeLabel(g) {
      const cat = g.categoryName ? `${g.categoryName} ` : "";
      return `${cat}${g.grade}${this._t("grades.grade_suffix") || "\uD638\uBD09"} (${g.effectiveYear})`;
    },
    /** 호봉 선택 → 표 정본 값으로 기본급/호봉수당 자동 채움. */
    onSalaryGradeChange() {
      const id = this.editForm.salaryGradeId;
      if (!id) {
        return;
      }
      const g = this.salaryGrades.find((x) => x.id === id);
      if (g) {
        this.editForm.baseSalary = g.baseSalary;
        this.editForm.hobongAmount = g.hobongAmount;
      }
    },
    /** 근로계약 폼 값 스냅샷(문자열) — 저장 시 원본과 비교해 변경분이 있을 때만 upsertContract 호출. */
    contractSnapshot() {
      return JSON.stringify({
        contractType: this.editForm.contractType,
        wageType: this.editForm.wageType,
        salaryGradeId: this.editForm.salaryGradeId,
        baseSalary: this.editForm.baseSalary,
        hobongAmount: this.editForm.hobongAmount,
        longevityAmount: this.editForm.longevityAmount,
        mealAllowance: this.editForm.mealAllowance,
        transportAllowance: this.editForm.transportAllowance,
        positionAllowance: this.editForm.positionAllowance,
        standardWeeklyHours: this.editForm.standardWeeklyHours,
        maxWeeklyHours: this.editForm.maxWeeklyHours
      });
    },
    formatRrn(val) {
      const digits = val.replace(/\D/g, "").slice(0, 13);
      if (digits.length <= 6) {
        return digits;
      }
      return `${digits.slice(0, 6)}-${digits.slice(6)}`;
    },
    /** Validate full RRN. Returns "" if valid or incomplete; localized error otherwise. */
    validateRrn(rrn) {
      return validateRrn(rrn, (k) => this._t(k));
    },
    positionFloatingMenu(triggerEl, menuEl) {
      positionFloatingMenu(triggerEl, menuEl);
    },
    /**
    * 뒷 7자리 입력 핸들러. 숫자만 남기고 결합값을 동기화한다.
    * 앞 6자리는 생년월일에서만 파생(disabled)되므로 여기서는 건드리지 않는다.
    * (back 7 password-masked) — 보호 구간은 화면에 노출하지 않는다.
    */
    onResidentNumberInput() {
      const f = this.editForm;
      f.residentNumberBack = (f.residentNumberBack || "").replace(/\D/g, "").slice(0, 7);
      f.residentNumber = f.residentNumberBack ? `${f.residentNumberFront}-${f.residentNumberBack}` : f.residentNumberFront;
      this.rrnError = this.validateRrn(f.residentNumber);
    },
    /**
    * 생년월일 선택 시 주민등록번호 앞 6자리(YYMMDD)를 자동으로 채운다.
    * 생년월일을 비우면 앞자리도 함께 비운다. (단방향: 생년월일 → 앞자리)
    */
    onBirthDateChange() {
      const f = this.editForm;
      f.residentNumberFront = (f.birthDate || "").replace(/-/g, "").slice(2);
      if (!f.birthDate) {
        f.residentNumberBack = "";
        f.isLunarBirth = false;
      }
      f.residentNumber = f.residentNumberBack ? `${f.residentNumberFront}-${f.residentNumberBack}` : f.residentNumberFront;
      this.rrnError = this.validateRrn(f.residentNumber);
    },
    async init() {
      if (this.dataReady) {
        return;
      }
      const store = herebyStore(this);
      if (!store || store.isLoading || !store.currentUser || !store.sdk) {
        return;
      }
      this.sdk = store.sdk;
      this.dataReady = true;
    },
    async loadReferenceData() {
      if (!this.sdk) {
        const store = herebyStore(this);
        if (store?.sdk) {
          this.sdk = store.sdk;
          this.dataReady = true;
        }
      }
      if (!this.sdk) {
        return;
      }
      try {
        const [teams, roles, shifts, shiftGroups, grades, jobDuties] = await Promise.all([
          fetchAllPages2((page, limit) => this.sdk.team.list({
            page,
            limit
          }), 100),
          fetchAllPages2((page, limit) => this.sdk.role.list({
            includePermissions: false,
            page,
            limit
          }), 100),
          this.sdk.shift.list(),
          this.sdk.shiftGroup.list(),
          // 활성 호봉만 (호봉 정의 시트 [반영] 정본). 실패 시 자유 입력 폴백.
          this.sdk.salaryGrade?.list({
            status: "active"
          }, {
            page: 1,
            limit: 500
          }).catch(() => null),
          // 직무 마스터(활성만) — 실패해도 폼은 열려야 하므로 빈 목록으로 폴백
          this.sdk.jobDuty?.list({
            activeOnly: true
          }).catch(() => null)
        ]);
        this.teams = teams || [];
        this.roles = roles || [];
        this.jobDuties = jobDuties?.items ?? [];
        try {
          const wps = await this.sdk.workPattern?.list({
            activeOnly: true
          });
          this.workPatterns = wps?.items ?? [];
        } catch {
          this.workPatterns = [];
        }
        this.shifts = shifts?.items || shifts || [];
        this.shiftGroups = shiftGroups?.items || shiftGroups || [];
        const gradeItems = grades?.items;
        this.salaryGrades = Array.isArray(gradeItems) ? gradeItems.map((g) => ({
          id: g.id,
          grade: Number(g.grade),
          baseSalary: Number(g.baseSalary) || 0,
          hobongAmount: Number(g.hobongAmount) || 0,
          effectiveYear: Number(g.effectiveYear),
          categoryName: g.salaryGradeCategory?.name ?? ""
        })) : [];
      } catch (err) {
        this.showNotice(`\uCC38\uC870 \uB370\uC774\uD130 \uB85C\uB4DC \uC2E4\uD328: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    analyticsAttempt: null,
    analyticsAttemptRevision: 0,
    async openEditEmployee(emp) {
      if (this.showEditEmployee && this.editingEmployee?.id === emp.id) {
        return;
      }
      const entry = ++this.employeeEntryRevision;
      this.editOpening = true;
      this.analyticsAttempt?.dispose();
      this.analyticsAttempt = null;
      if (!this.sdk) {
        await this.init();
      }
      if (!this.sdk) {
        this.editOpening = false;
        this.showNotice("\uB85C\uADF8\uC778 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911\uC785\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.", "danger");
        return;
      }
      try {
        await this.loadReferenceData();
      } catch (e) {
        this.editOpening = false;
        throw e;
      }
      if (entry !== this.employeeEntryRevision) {
        return;
      }
      this.employees = [];
      const currentStatus = emp.status || "ACTIVE";
      const defaultStatusAction = currentStatus;
      this.resetStatusForms();
      const birthDateStr = emp.birthDate ? new Date(emp.birthDate).toISOString().split("T")[0] : "";
      this.editForm = {
        lastName: emp.lastName || "",
        firstName: emp.firstName || "",
        email: emp.email || "",
        phone: emp.phone || "",
        countryCode: emp.countryCode || "+82",
        employeeNumber: emp.employeeNumber || "",
        hireDate: emp.hireDate ? new Date(emp.hireDate).toISOString().split("T")[0] : "",
        birthDate: birthDateStr,
        isLunarBirth: !!emp.isLunarBirth,
        // 주민등록번호는 write-only: 기존 저장값(마스킹본)은 칸에 표시하지 않는다.
        // 앞 6자리는 생년월일에서 파생(disabled), 뒷 7자리는 빈 공란에서 시작 —
        // 새로 13자리 유효값을 입력한 경우에만 전송되므로 빈칸이면 기존 DB 값 보존.
        residentNumber: birthDateStr.replace(/-/g, "").slice(2),
        residentNumberFront: birthDateStr.replace(/-/g, "").slice(2),
        residentNumberBack: "",
        // 주소는 목록 행에 없을 수 있어 우선 emp.address로 채우고, 상세 로드에서 detail.address로 덮어쓴다.
        address: emp.address?.street || "",
        postalCode: emp.address?.postalCode || "",
        addressDetail: emp.address?.detail || "",
        status: currentStatus,
        statusAction: defaultStatusAction,
        shiftId: emp.shiftId || "",
        shiftGroupId: emp.shiftGroupId || "",
        allowedShiftIds: Array.isArray(emp.allowedShiftIds) ? [
          ...emp.allowedShiftIds
        ] : [],
        attendanceMethod: emp.attendanceMethod || "",
        // 직무는 목록 행에도 오지만, 상세 로드에서 detail.jobDuty/jobDutyId 로 한 번 더 덮어쓴다.
        jobDutyId: emp.jobDutyId || "",
        jobDuty: emp.jobDuty || "",
        workPatternId: emp.workPatternId || "",
        workPatternName: "",
        workPatternOverrides: [],
        workPatternResetOverrides: false,
        isSystemAdmin: !!emp.isSystemAdmin,
        payrollExcluded: !!emp.payrollExcluded,
        accountId: emp.accountId || "",
        phoneOtpEnabled: Array.isArray(emp.authMethods) ? emp.authMethods.includes("phone_otp") : false,
        /** 패스키 전용 로그인(2026-10-13) — 관리자는 해제만(직원이 기기를 잃었을 때). 켜는 건 본인이 인증/보안 설정에서. */
        passkeyOnlyLogin: !!emp.passkeyOnlyLogin,
        newPassword: "",
        confirmPassword: "",
        passwordMode: "sms",
        // 근로계약 — 목록 행엔 없으므로 기본값으로 시작하고, 상세 로드에서 detail.contract로 채운다.
        contractType: "permanent",
        wageType: "monthly",
        salaryGradeId: "",
        baseSalary: 0,
        hobongAmount: 0,
        longevityAmount: 0,
        mealAllowance: 0,
        transportAllowance: 0,
        positionAllowance: 0,
        standardWeeklyHours: 40,
        maxWeeklyHours: 52
      };
      this.editContractOriginal = this.contractSnapshot();
      this.editMemberships = [];
      this.editEffectiveShift = null;
      this.editWards = [];
      this.editWardsRemoved = [];
      this.wardList = [];
      this.scheduleGroupList = [];
      this.employeeHistory = {
        leaves: [],
        resignations: []
      };
      this.certifications = [];
      this.certPreview = {
        open: false,
        loading: false,
        url: "",
        name: "",
        kind: "",
        error: "",
        path: ""
      };
      this.rrnError = "";
      this.editEmployeeCat = "basic";
      this.previewOpen = false;
      this.previewData = [];
      this.addrSearchOpen = false;
      this.notice = {
        show: false,
        tone: "success",
        message: ""
      };
      this.confirmDialog = {
        show: false,
        message: "",
        confirmLabel: "\uD655\uC778",
        tone: "default"
      };
      this.confirmResolver = null;
      this.employeeNumberValidated = false;
      this.originalEmployeeNumber = emp.employeeNumber || "";
      this.editFormErrors = {
        employeeNumber: ""
      };
      this.editingEmployee = emp;
      this.closeBaseline = this.closeGuardState();
      this.editOpening = false;
      this.showEditEmployee = true;
      this.analyticsAttempt = appAnalytics("admin").startWorkflow("employee_save");
      this.recurringAllowances = [];
      this.loadRecurringAllowances(emp.id);
      try {
        const detail = await this.sdk.employee.getEmployee(emp.id);
        if (entry !== this.employeeEntryRevision) {
          return;
        }
        if (detail) {
          this.editForm.phone = detail.phone || this.editForm.phone;
          this.editForm.shiftId = detail.shiftId || this.editForm.shiftId;
          this.editForm.shiftGroupId = detail.shiftGroupId || this.editForm.shiftGroupId;
          this.editForm.shiftAssignedVia = detail.shiftAssignedVia || "";
          this.editEffectiveShift = detail.effectiveShift ?? null;
          this.editForm.jobDuty = detail.jobDuty || "";
          this.editForm.jobDutyId = detail.jobDutyId || "";
          emp.jobDuty = detail.jobDuty ?? null;
          emp.jobDutyId = detail.jobDutyId ?? null;
          this.editForm.workPatternId = detail.workPatternId || "";
          this.editForm.workPatternName = detail.workPatternName || "";
          this.editForm.workPatternOverrides = detail.workPatternOverrides ?? [];
          emp.workPatternId = detail.workPatternId ?? null;
          emp.workPatternName = detail.workPatternName ?? null;
          if (detail.attendanceMethod !== void 0 && detail.attendanceMethod !== null) {
            this.editForm.attendanceMethod = detail.attendanceMethod;
          }
          if (Array.isArray(detail.authMethods)) {
            this.editForm.phoneOtpEnabled = detail.authMethods.includes("phone_otp");
            emp.authMethods = detail.authMethods;
          }
          const addr = detail.address;
          this.editForm.address = addr?.street || "";
          this.editForm.postalCode = addr?.postalCode || "";
          this.editForm.addressDetail = addr?.detail || "";
          emp.address = detail.address;
          const c = detail.contract;
          if (c) {
            this.editForm.contractType = c.contractType || c.type || "permanent";
            this.editForm.wageType = c.wageType || "monthly";
            this.editForm.salaryGradeId = c.salaryGradeId || "";
            this.editForm.baseSalary = Number(c.baseSalary) || 0;
            this.editForm.hobongAmount = Number(c.hobongAmount) || 0;
            this.editForm.longevityAmount = Number(c.longevityAmount) || 0;
            this.editForm.standardWeeklyHours = Number(c.standardWeeklyHours) || 40;
            this.editForm.maxWeeklyHours = Number(c.maxWeeklyHours) || 52;
            const allowances = c.allowances || {};
            this.editForm.mealAllowance = allowances.meal || 0;
            this.editForm.transportAllowance = allowances.transportation || 0;
            this.editForm.positionAllowance = allowances.position || 0;
          }
          this.editContractOriginal = this.contractSnapshot();
        }
        const teams = detail?.teams || [];
        this.editMemberships = teams.map(membershipRowFromDetail);
        this.editWards = this.wardRowsFromDetail(detail?.wards);
        if (this.canEditWards()) {
          await this.ensureWardList();
        }
        this.sdk.employee.statusHistory(emp.id).then((h) => {
          if (h) {
            this.employeeHistory = h;
          }
        });
        this.sdk.employeeCertification.list({
          employeeId: emp.id
        }).then((certs) => {
          if (Array.isArray(certs)) {
            this.certifications = certs;
          }
        }).catch(() => {
        });
        this.closeBaseline = this.closeGuardState();
      } catch {
        this.editMemberships = [];
        this.closeBaseline = this.closeGuardState();
      }
    },
    async loadEditMemberships() {
      if (!this.editingEmployee) {
        return;
      }
      try {
        const detail = await this.sdk.employee.getEmployee(this.editingEmployee.id);
        const teams = detail?.teams || [];
        this.editMemberships = mergeMembershipEdits(this.editMemberships, teams.map(membershipRowFromDetail));
        this.editEffectiveShift = detail?.effectiveShift ?? null;
        const merged = mergeServerWardRows(this.editWards, this.editWardsRemoved, detail?.wards);
        this.editWards = merged.rows;
        this.editWardsRemoved = merged.removed;
      } catch {
      }
    },
    /* ── 병동 배정(간호 프로필) — 인사정보 「소속 (팀 · 역할)」 아래. 스케줄러 · 근무표와 같은 정보다.
    한 줄 = 병동 하나(겸임이면 여러 줄). 저장 버튼에서 삭제 → 수정 → 추가 순으로 반영한다. ── */
    /** 교대 형태 선택지 — 스케줄러 간호 정보와 같은 값(줄 편집 규칙은 utils/ward-assignment-rows 공용) */
    nurseWorkTypes: NURSE_WORK_TYPES,
    /** 병동 배정을 고칠 수 있는지 — 간호 스케줄 등록 · 수정 · 삭제 권한이 모두 있어야 한다(없으면 읽기 전용). */
    canEditWards() {
      const store = herebyStore(this);
      return [
        "create",
        "update",
        "delete"
      ].every((action) => !!store?.hasPermission(`nurse-scheduler:${action}`));
    },
    /** 병동 · 스케줄러 목록 — 한 번만 부르고, 권한이 없거나 실패하면 비워 둔다(행에 이미 있는 병동 이름은 그대로 보인다) */
    async ensureWardList() {
      if (this.wardList.length > 0) {
        return;
      }
      try {
        const [result, groups] = await Promise.all([
          this.sdk.nurseScheduler.listWards(void 0, {
            background: true
          }),
          this.sdk.nurseScheduler.listScheduleGroups(void 0, {
            background: true
          })
        ]);
        const items = Array.isArray(result) ? result : result?.items || [];
        this.wardList = items.map((w) => ({
          id: w.id,
          name: w.name || "",
          isActive: w.isActive !== false
        }));
        const groupItems = groups?.items ?? [];
        this.scheduleGroupList = groupItems.map((g) => ({
          id: g.id,
          wardId: g.wardId,
          name: g.name || "",
          isActive: g.isActive !== false,
          isDefault: !!g.isDefault
        }));
      } catch {
        this.wardList = [];
        this.scheduleGroupList = [];
      }
    },
    wardRowsFromDetail(wards) {
      return wardRowsFromAssignments(wards);
    },
    /** 소속 팀에 연결된 병동 id — 「소속 팀 연결」 라벨과 새 줄의 기본 병동에 쓴다 */
    linkedWardIds() {
      return this.editMemberships.map((m) => this.teams.find((t) => t.id === m.teamId)?.wardId).filter((id) => typeof id === "string" && id !== "");
    },
    /** 줄 추가 — 첫 줄이면 소속 팀의 연결 병동을 미리 고른다(이미 있는 병동은 건너뜀) */
    addWardRow() {
      this.wardRowSeq += 1;
      this.editWards.push(createWardRow(`ward-new-${this.wardRowSeq}`, suggestWardId(this.editWards, this.linkedWardIds()), this.wardList, this.scheduleGroupList));
    },
    removeWardRow(index) {
      removeWardRow(this.editWards, index, this.editWardsRemoved);
    },
    wardSelectOptions(row) {
      return wardOptionsForRow(row, this.editWards, this.wardList, this.scheduleGroupList);
    },
    /** 이 줄의 스케줄러 선택지 — 고른 병동의 운영 중인 스케줄러 중 다른 줄이 안 쓰는 것 */
    wardScheduleGroupOptions(row) {
      return scheduleGroupOptionsForRow(row, this.editWards, this.scheduleGroupList);
    },
    /** 병동을 바꾸면 스케줄러는 그 병동의 기본으로 되돌린다 */
    onWardRowChange(row) {
      syncRowWard(row, this.wardList, this.scheduleGroupList);
    },
    onWardRowGroupChange(row) {
      syncRowScheduleGroup(row, this.scheduleGroupList);
    },
    /** 줄 라벨 — 소속 팀에 연결된 병동이면 「소속 팀 연결」, 아니면서 두 줄 이상이면 「겸임」 */
    wardRowBadge(row) {
      return wardRowBadge(row, this.editWards, this.linkedWardIds());
    },
    /** 병동 배정 검증 메시지 — 비어 있으면 저장 가능 */
    wardRowsError() {
      return wardRowsError(this.editWards);
    },
    /** 병동 배정 저장 — 바뀐 게 있을 때만 삭제 → 수정 → 추가 */
    async saveWardAssignments(employeeId) {
      if (!(this.canEditWards() && hasWardAssignmentChanges(this.editWards, this.editWardsRemoved))) {
        return;
      }
      await applyWardAssignmentChanges(this.sdk.nurseScheduler, employeeId, this.editWards, this.editWardsRemoved);
    },
    async saveEmployee() {
      if (!this.editingEmployee) {
        return;
      }
      if (this.rrnError || this.editFormErrors.employeeNumber) {
        this.analyticsAttempt?.validationFailed("validation");
        return;
      }
      const action = this.editForm.statusAction;
      const cur = this.editForm.status;
      if (action === "ON_LEAVE" && cur !== "ON_LEAVE") {
        if (!this.leaveConfirmForm.reason) {
          this.showNotice(this._t("leave.select_reason"), "danger");
          return;
        }
        if (!this.leaveConfirmForm.startDate) {
          return;
        }
        await this.processLeave();
        return;
      }
      if (cur === "ON_LEAVE" && (action === "RETURN" || action === "ACTIVE")) {
        await this._doReturnFromLeave();
        return;
      }
      if (cur === "TERMINATED" && (action === "REINSTATE" || action === "ACTIVE")) {
        if (!this.reinstateForm.reason.trim()) {
          this.showNotice(this._t("employee.reinstate_reason_required"), "danger");
          return;
        }
        await this._doCancelTermination();
        return;
      }
      if (action === "TERMINATED" && cur !== "TERMINATED") {
        if (!this.terminationForm.reason) {
          this.showNotice(this._t("leave.select_reason"), "danger");
          return;
        }
        if (!this.terminationForm.confirmed) {
          this.showNotice(this._t("leave.termination_agree"), "danger");
          return;
        }
        await this.processTermination();
        return;
      }
      const entry = this.employeeEntryRevision;
      const ok = await this.persistBasicEdits();
      if (ok && entry === this.employeeEntryRevision) {
        this.showEditEmployee = false;
        opts.onSaved?.();
      }
    },
    /**
    * 일반 필드(이름·연락처·상태(재직/비활성)·근무형태·날짜·주민번호·인증수단·역할)를
    * diff로 저장하는 공용 경로. 저장(모달 닫기)과 중간 저장(모달 유지)이 함께 쓴다.
    * 휴직/퇴직/복직 전환은 호출 전에 별도 워크플로로 처리되므로 여기서는 다루지 않는다.
    * 성공하면 캐시된 editingEmployee를 저장값으로 갱신(연속 저장 시 재전송/오검출 방지)하고
    * true를, 실패하면 알림 후 false를 반환한다.
    */
    async persistBasicEdits() {
      const attempt = this.analyticsAttempt ?? appAnalytics("admin").startWorkflow("employee_save");
      this.analyticsAttempt = attempt;
      const entryRevision = this.employeeEntryRevision;
      const attemptRevision = ++this.analyticsAttemptRevision;
      const clearAttempt = /* @__PURE__ */ __name(() => {
        if (this.employeeEntryRevision === entryRevision && this.analyticsAttemptRevision === attemptRevision) {
          this.analyticsAttempt = null;
        }
      }, "clearAttempt");
      const action = this.editForm.statusAction;
      if (action === "ACTIVE" || action === "INACTIVE" || action === "ON_LEAVE" || action === "TERMINATED") {
        this.editForm.status = action;
      }
      try {
        const emp = this.editingEmployee;
        const update2 = {
          id: emp.id
        };
        const fields = [
          [
            "lastName",
            this.editForm.lastName,
            emp.lastName
          ],
          [
            "firstName",
            this.editForm.firstName,
            emp.firstName
          ],
          [
            "email",
            this.editForm.email,
            emp.email
          ],
          [
            "phone",
            this.editForm.phone,
            emp.phone
          ],
          [
            "employeeNumber",
            this.editForm.employeeNumber,
            emp.employeeNumber
          ],
          [
            "status",
            this.editForm.status,
            emp.status
          ]
        ];
        for (const [key, newVal, oldVal] of fields) {
          if (newVal && newVal !== (oldVal || "")) {
            update2[key] = newVal;
          }
        }
        if (this.editMemberships.length === 0) {
          if (this.editForm.shiftId !== (emp.shiftId || "")) {
            update2.shiftId = this.editForm.shiftId || null;
          }
          if (this.editForm.shiftGroupId !== (emp.shiftGroupId || "")) {
            update2.shiftGroupId = this.editForm.shiftGroupId || null;
          }
        }
        {
          const before = Array.isArray(emp.allowedShiftIds) ? emp.allowedShiftIds : [];
          const after = this.editForm.allowedShiftIds;
          if (before.length !== after.length || before.some((id) => !after.includes(id))) {
            update2.allowedShiftIds = [
              ...after
            ];
          }
        }
        {
          const oldAddr = emp.address || null;
          const newAddr = this.editForm.address ? {
            street: this.editForm.address,
            ...this.editForm.postalCode ? {
              postalCode: this.editForm.postalCode
            } : {},
            ...(this.editForm.addressDetail || "").trim() ? {
              detail: this.editForm.addressDetail.trim()
            } : {}
          } : null;
          const norm = /* @__PURE__ */ __name((a) => JSON.stringify({
            street: a?.street || "",
            postalCode: a?.postalCode || "",
            detail: a?.detail || ""
          }), "norm");
          if (norm(oldAddr) !== norm(newAddr)) {
            update2.address = newAddr;
          }
        }
        if (this.editForm.hireDate) {
          const oldDate = emp.hireDate ? new Date(emp.hireDate).toISOString().split("T")[0] : "";
          if (this.editForm.hireDate !== oldDate) {
            update2.hireDate = this.editForm.hireDate;
          }
        }
        if (this.editForm.birthDate) {
          const oldBirth = emp.birthDate ? new Date(emp.birthDate).toISOString().split("T")[0] : "";
          if (this.editForm.birthDate !== oldBirth) {
            update2.birthDate = this.editForm.birthDate;
          }
        }
        if (this.editForm.birthDate && this.editForm.isLunarBirth !== !!emp.isLunarBirth) {
          update2.isLunarBirth = this.editForm.isLunarBirth;
        }
        {
          const rrnDigits = (this.editForm.residentNumber || "").replace(/\D/g, "");
          if (rrnDigits.length === 13 && this.validateRrn(this.editForm.residentNumber) === "") {
            update2.residentNumber = this.editForm.residentNumber;
          }
        }
        const oldMethod = emp.attendanceMethod || "";
        if (this.editForm.attendanceMethod !== oldMethod) {
          update2.attendanceMethod = this.editForm.attendanceMethod || null;
        }
        if ((this.editForm.jobDutyId || "") !== (emp.jobDutyId || "")) {
          update2.jobDutyId = this.editForm.jobDutyId || null;
        }
        if ((this.editForm.workPatternId || "") !== (emp.workPatternId || "")) {
          update2.workPatternId = this.editForm.workPatternId || null;
        }
        if (this.editForm.workPatternResetOverrides) {
          update2.workPatternOverrides = [];
        }
        if (this.editForm.payrollExcluded !== !!emp.payrollExcluded) {
          update2.payrollExcluded = this.editForm.payrollExcluded;
        }
        if (this.editForm.isSystemAdmin !== !!emp.isSystemAdmin) {
          update2.isSystemAdmin = this.editForm.isSystemAdmin;
        }
        if (this.editForm.passkeyOnlyLogin !== !!emp.passkeyOnlyLogin) {
          update2.passkeyOnlyLogin = this.editForm.passkeyOnlyLogin;
        }
        const currentMethods = Array.isArray(emp.authMethods) ? emp.authMethods : [];
        const currentlyHasOtp = currentMethods.includes("phone_otp");
        if (this.editForm.phoneOtpEnabled !== currentlyHasOtp) {
          let nextMethods = currentMethods.filter((m) => m !== "phone_otp");
          if (this.editForm.phoneOtpEnabled) {
            nextMethods.push("phone_otp");
          }
          if (nextMethods.length === 0) {
            nextMethods = [
              "email"
            ];
          }
          update2.authMethods = nextMethods;
        }
        attempt.submit();
        await this.sdk.employee.updateEmployee(update2);
        let roleSaveError = "";
        for (const m of this.editMemberships) {
          if (m.roleId && m.roleId !== m.originalRoleId) {
            try {
              await this.sdk.team.updateMember(m.teamId, m.memberId, {
                roleId: m.roleId
              });
              m.originalRoleId = m.roleId;
            } catch (roleErr) {
              roleSaveError || (roleSaveError = roleErr instanceof Error ? roleErr.message : String(roleErr));
            }
          }
        }
        let shiftSaveError = "";
        const newPrimary = this.editMemberships.find((m) => m.isPrimary && !m.originalIsPrimary);
        if (newPrimary) {
          try {
            await this.sdk.employee.updateMembershipShift({
              memberId: newPrimary.memberId,
              isPrimary: true
            });
            for (const m of this.editMemberships) {
              m.originalIsPrimary = m.isPrimary;
            }
          } catch (err) {
            shiftSaveError || (shiftSaveError = err instanceof Error ? err.message : String(err));
          }
        }
        let shiftWritten = !!newPrimary;
        for (const m of this.editMemberships) {
          if (m.shiftGroupId !== m.originalShiftGroupId || m.shiftId !== m.originalShiftId) {
            try {
              await this.sdk.employee.updateMembershipShift({
                memberId: m.memberId,
                shiftGroupId: m.shiftGroupId || null,
                shiftId: m.shiftId || null
              });
              m.originalShiftGroupId = m.shiftGroupId;
              m.originalShiftId = m.shiftId;
              shiftWritten = true;
            } catch (err) {
              shiftSaveError || (shiftSaveError = err instanceof Error ? err.message : String(err));
            }
          }
        }
        if (shiftWritten) {
          await this.refreshEffectiveShift(emp.id);
        }
        if (this.contractSnapshot() !== this.editContractOriginal) {
          await this.sdk.employee.upsertContract({
            employeeId: emp.id,
            contractType: this.editForm.contractType,
            wageType: this.editForm.wageType,
            // 호봉 배정/해제 — 미선택("")은 null로 전송해 FK를 해제한다
            // (자유 입력 계약으로 복귀). undefined면 서버가 미변경으로 본다.
            salaryGradeId: this.editForm.salaryGradeId || null,
            baseSalary: this.editForm.baseSalary || 0,
            hobongAmount: this.editForm.hobongAmount || 0,
            longevityAmount: this.editForm.longevityAmount || 0,
            // 수당(식대/교통/직책)은 0을 포함해 항상 전송한다. 0을 빼면 서버가 "미변경"으로 보고
            // 이전 버전의 수당을 그대로 상속해, 화면에서 0으로 지운 수당이 저장되지 않고 되살아난다
            // (모두 0으로 지운 경우 특히). 0은 서버에서 allowances 객체에 담지 않아 저장 형태는 깔끔하게 유지된다.
            mealAllowance: this.editForm.mealAllowance || 0,
            transportAllowance: this.editForm.transportAllowance || 0,
            positionAllowance: this.editForm.positionAllowance || 0,
            standardWeeklyHours: this.editForm.standardWeeklyHours,
            maxWeeklyHours: this.editForm.maxWeeklyHours
          });
          this.editContractOriginal = this.contractSnapshot();
        }
        await this.saveWardAssignments(emp.id);
        const { id: _id, ...applied } = update2;
        Object.assign(emp, applied);
        if (roleSaveError) {
          attempt.unconfirmed();
          clearAttempt();
          this.showNotice(`\uC9C1\uC6D0 \uC815\uBCF4\uB294 \uC800\uC7A5\uD588\uC9C0\uB9CC ${attachJosa(herebyStore(this).term("role"), "\uC740/\uB294")} \uC800\uC7A5\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694: ${roleSaveError}`, "danger");
          return false;
        }
        if (shiftSaveError) {
          attempt.unconfirmed();
          clearAttempt();
          this.showNotice(`\uC9C1\uC6D0 \uC815\uBCF4\uB294 \uC800\uC7A5\uD588\uC9C0\uB9CC \uADFC\uBB34 \uBC30\uC815\uC740 \uC800\uC7A5\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694: ${shiftSaveError}`, "danger");
          return false;
        }
        attempt.complete();
        clearAttempt();
        return true;
      } catch (err) {
        reportWorkflowError(attempt, err);
        clearAttempt();
        this.showNotice(`${this._t("admin.save_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
        return false;
      }
    },
    /* 미리보기 — 저장 전 '변경 전→후' diff를 읽기 전용으로 보여주는 팝업(패널 위 겹침, 직원 추가와 동일 패턴).
    previewData는 openPreview 시점에 계산해 고정한다(미리보기가 열린 동안 패널은 inert라 폼이 안 바뀜). */
    previewOpen: false,
    // biome-ignore lint/suspicious/noExplicitAny: dynamic preview diff rows
    previewData: [],
    openPreview() {
      this.previewData = this.previewRows();
      this.previewOpen = true;
    },
    closePreview() {
      this.previewOpen = false;
    },
    /* 등록된 근무 유형 참고 팝업 — 근무 그룹 드롭다운 옆 버튼으로 여는 읽기 전용 목록(패널 위 레이어).
    입력을 바꾸지 않으므로 저장확인 가드 없이 X/닫기/Esc 로 닫힌다. */
    shiftRefOpen: false,
    // 선택한 근무 그룹으로 필터링된 근무 형태 목록. 그룹 미선택 시 그룹이 없는(레거시) 형태만.
    /** 허용 근무 유형 체크 목록(MED-969) — 조직의 활성 근무 전부를 「그룹 · 근무」로 */
    allowedShiftOptions() {
      const groupName = new Map(this.shiftGroups.map((g) => [
        g.id,
        g.name
      ]));
      const checked = this.editForm.allowedShiftIds;
      return this.shifts.filter((s) => s.isActive !== false || checked.includes(s.id)).map((s) => ({
        id: s.id,
        label: `${s.groupId && groupName.get(s.groupId) ? `${groupName.get(s.groupId)} \xB7 ` : ""}${s.name}`
      }));
    },
    toggleAllowedShift(id) {
      const list = this.editForm.allowedShiftIds;
      const i = list.indexOf(id);
      if (i >= 0) {
        list.splice(i, 1);
      } else {
        list.push(id);
      }
    },
    groupedShifts() {
      const gid = this.editForm.shiftGroupId;
      return this.shifts.filter((s) => s.isActive !== false && (gid ? s.groupId === gid : !s.groupId));
    },
    // '근무 유형 전체 보기' 팝업용 — 활성 근무형태가 있는 근무 그룹만 {id, name, shifts}로.
    // 그룹-유무로 빈 상태를 판정해, 유형이 전부 그룹 미지정(레거시)이면 빈 메시지가 정상 노출된다.
    shiftRefGroups() {
      return this.shiftGroups.map((g) => ({
        id: g.id,
        name: g.name,
        shifts: this.shifts.filter((s) => s.groupId === g.id && s.isActive !== false)
      })).filter((grp) => grp.shifts.length > 0);
    },
    /** 근무 배정 출처 라벨 — 「직무 기본 근무」「팀 대표 근무」「직접 선택」 … (값은 서버 shiftAssignedVia) */
    shiftAssignedViaLabel(code) {
      return SHIFT_ASSIGNMENT_SOURCE_LABELS[code] || "";
    },
    // ── 근로형태(마스터) ──
    workPatterns: [],
    /** 근로형태 선택지 — 활성(직무 미지정이거나 고른 직무에 속한 것) + 지금 값. */
    editWorkPatternOptions() {
      const current2 = this.editForm.workPatternId;
      const dutyId = this.editForm.jobDutyId;
      const list = this.workPatterns.filter((w) => w.id === current2 || w.isActive !== false && (!(w.jobDutyId && dutyId) || w.jobDutyId === dutyId));
      if (current2 && !list.some((w) => w.id === current2)) {
        list.push({
          id: current2,
          name: this.editForm.workPatternName || ""
        });
      }
      return list;
    },
    workPatternName(id) {
      if (!id) {
        return "";
      }
      return this.workPatterns.find((w) => w.id === id)?.name || (id === this.editForm.workPatternId ? this.editForm.workPatternName : "") || "";
    },
    /** 수동으로 둔 파생 필드의 한글 라벨(「통상시급 · 포괄시간」). */
    workPatternOverrideLabels() {
      return this.editForm.workPatternOverrides.map((f) => WORK_PATTERN_DERIVED_FIELD_LABELS[f] || f).join(" \xB7 ");
    },
    // ── 직무(마스터) ──
    jobDuties: [],
    /** 직무 선택지 — 활성 직무 + 지금 값(비활성이어도 그 값은 남긴다). */
    editJobDutyOptions() {
      const current2 = this.editForm.jobDutyId;
      const list = this.jobDuties.filter((d) => d.isActive !== false || d.id === current2);
      if (current2 && !list.some((d) => d.id === current2)) {
        list.push({
          id: current2,
          name: this.editForm.jobDuty || ""
        });
      }
      return list;
    },
    jobDutyName(id) {
      if (!id) {
        return "";
      }
      return this.jobDuties.find((d) => d.id === id)?.name || (id === this.editForm.jobDutyId ? this.editForm.jobDuty : "") || "";
    },
    /**
    * 직무 기본 근무(팀 대표보다 먼저 보는 기본값) — 드롭다운에 있는 값만.
    * 수정 화면에서는 **비어 있는** 근무 줄만 채운다(이미 근무가 있는 직원의 근무를 조용히 바꾸지 않는다).
    */
    editJobDutyDefaultShift() {
      const pattern = this.workPatterns.find((w) => w.id === this.editForm.workPatternId);
      const duty = pattern?.shiftGroupId ? pattern : this.jobDuties.find((d) => d.id === this.editForm.jobDutyId);
      const groupId = duty?.shiftGroupId || "";
      const group = groupId ? this.shiftGroups.find((g) => g.id === groupId && g.isActive !== false) : null;
      if (!group) {
        return {
          shiftGroupId: "",
          shiftId: ""
        };
      }
      const shiftId = duty?.shiftId || "";
      const shiftOk = !!shiftId && this.shifts.some((x) => x.id === shiftId && x.groupId === groupId && x.isActive !== false);
      return {
        shiftGroupId: groupId,
        shiftId: shiftOk ? shiftId : ""
      };
    },
    /**
    * 직무(근로형태) 기본 근무와 지금 근무의 차이 — 주 소속 줄(없으면 직원 단위 값) 기준.
    * "" = 같거나 기본 없음 · "empty" = 기본은 있는데 근무 없음/그룹만 · "differs" = 개별 지정이 기본과 다름.
    */
    editDefaultShiftMismatch() {
      const d = this.editJobDutyDefaultShift();
      const none = {
        kind: "",
        defaultName: "",
        currentName: ""
      };
      if (!d.shiftGroupId) {
        return none;
      }
      const primary = this.editMemberships.find((m) => m.isPrimary);
      const cur = primary ? {
        shiftGroupId: primary.shiftGroupId,
        shiftId: primary.shiftId
      } : {
        shiftGroupId: this.editForm.shiftGroupId,
        shiftId: this.editForm.shiftId
      };
      const name = /* @__PURE__ */ __name((p) => {
        const g = this.shiftGroups.find((x) => x.id === p.shiftGroupId)?.name || "";
        const s = this.shifts.find((x) => x.id === p.shiftId)?.name || "";
        return s ? `${g} \u203A ${s}` : g ? `${g} (\uADF8\uB8F9\uB9CC)` : "";
      }, "name");
      if (cur.shiftGroupId === d.shiftGroupId && (cur.shiftId || "") === (d.shiftId || "")) {
        return none;
      }
      if (!cur.shiftId && (!cur.shiftGroupId || cur.shiftGroupId === d.shiftGroupId)) {
        return {
          kind: "empty",
          defaultName: name(d),
          currentName: name(cur)
        };
      }
      return {
        kind: "differs",
        defaultName: name(d),
        currentName: name(cur)
      };
    },
    /** 「직무 기본으로 맞추기」 — 주 소속 줄(없으면 직원 단위 값)을 기본 근무로 바꾼다. 저장해야 반영된다. */
    applyDefaultShiftToEdit() {
      const d = this.editJobDutyDefaultShift();
      if (!d.shiftGroupId) {
        return;
      }
      const primary = this.editMemberships.find((m) => m.isPrimary);
      if (primary) {
        primary.shiftGroupId = d.shiftGroupId;
        primary.shiftId = d.shiftId;
      } else {
        this.editForm.shiftGroupId = d.shiftGroupId;
        this.editForm.shiftId = d.shiftId;
      }
    },
    onEditJobDutyChange() {
      this.editForm.jobDuty = this.jobDutyName(this.editForm.jobDutyId);
      const d = this.editJobDutyDefaultShift();
      if (!d.shiftGroupId) {
        return;
      }
      let filled = false;
      for (const m of this.editMemberships) {
        if (!m.shiftGroupId) {
          m.shiftGroupId = d.shiftGroupId;
          m.shiftId = d.shiftId;
          filled = true;
        }
      }
      if (this.editMemberships.length === 0 && !this.editForm.shiftGroupId) {
        this.editForm.shiftGroupId = d.shiftGroupId;
        this.editForm.shiftId = d.shiftId;
        filled = true;
      }
      if (filled) {
        this.notice = {
          show: true,
          tone: "info",
          message: this._t("employee.work_group_from_job_duty", {
            name: this.editForm.jobDuty
          })
        };
      }
    },
    // ── 소속별 근무 · 주 소속 (소속이 있을 때). 소속이 없으면 아래 직원 단위 선택(editForm)을 쓴다. ──
    /** 한 소속 줄의 근무형태 선택지 — 그 줄 그룹 하위 활성 형태. 지금 값이 비활성이면 그 값도 남긴다. */
    editRowShifts(groupId, current2) {
      return this.shifts.filter((x) => (x.isActive !== false || x.id === current2) && (groupId ? x.groupId === groupId : !x.groupId));
    },
    /** 한 소속 줄의 근무 그룹 선택지 — 조직 전체 활성 그룹. 지금 값이 비활성이면 그 값도 남긴다. */
    editRowShiftGroupOptions(current2) {
      return this.shiftGroups.filter((g) => g.isActive !== false || g.id === current2);
    },
    /** 줄의 그룹이 바뀌면 그 그룹에 속하지 않는 형태를 비운다. */
    onEditRowShiftGroupChange(m) {
      const cur = this.shifts.find((x) => x.id === m.shiftId);
      if (!m.shiftGroupId || cur && cur.groupId !== m.shiftGroupId) {
        m.shiftId = "";
      }
    },
    /** 주 소속 지정 — 저장할 때 서버가 직원 근무(근태·연차)를 이 줄의 근무로 맞춘다. */
    setEditPrimary(memberId) {
      for (const m of this.editMemberships) {
        m.isPrimary = m.memberId === memberId;
      }
    },
    /**
    * 주 소속이 아닌 줄의 근무 그룹을 지울 수 있는가(MED-924) — 소속이 둘 이상이고, 그 줄에 근무가 있을 때만.
    * 주 소속 줄은 지울 수 없다(근태가 읽는 근무라 비우면 기본 근무로 떨어진다) — 대신 안내(showPrimaryRemoveHint).
    */
    canRemoveRowShiftGroup(m) {
      return this.editMemberships.length > 1 && !m.isPrimary && !!(m.shiftGroupId || m.shiftId);
    },
    showPrimaryRemoveHint(m) {
      return this.editMemberships.length > 1 && m.isPrimary && !!(m.shiftGroupId || m.shiftId);
    },
    /** 지우기로 해 둔 줄 — 저장 전까지 「저장하면 비워져요」 안내를 붙인다 */
    rowShiftGroupCleared(m) {
      return !(m.shiftGroupId || m.shiftId) && !!(m.originalShiftGroupId || m.originalShiftId);
    },
    /**
    * 줄의 근무 그룹·형태 지우기 — 폼만 비운다. 저장할 때 updateMembershipShift({ shiftGroupId: null, shiftId: null }) 로
    * 가고 서버가 그 줄을 직접 선택(manual)으로 남겨 재합류·기본 재적용이 다시 채우지 않는다.
    */
    async removeEditRowShiftGroup(m) {
      if (!this.canRemoveRowShiftGroup(m)) {
        return;
      }
      const ok = await this.askConfirm(this._t("employee.remove_row_shift_group_confirm", {
        team: m.teamName || "-"
      }), {
        confirmLabel: this._t("common.delete"),
        tone: "danger"
      });
      if (!ok) {
        return;
      }
      m.shiftGroupId = "";
      m.shiftId = "";
    },
    /** 「현재 판정에 사용 중인 근무: 이름 09:00-18:00 (출처: 직원 근무 배정)」 — 서버 effectiveShift 를 한 줄로 */
    effectiveShiftLine() {
      const e = this.editEffectiveShift;
      if (!e) {
        return "";
      }
      const hhmm = /* @__PURE__ */ __name((t) => (t || "").slice(0, 5), "hhmm");
      let body = "";
      if (e.kind === "shift" && e.shift) {
        body = `${e.shift.name} ${hhmm(e.shift.startTime)}-${hhmm(e.shift.endTime)}`;
      } else if (e.kind === "group") {
        body = this._t("employee.effective_shift_group_auto", {
          group: e.groupName || "-",
          count: e.groupShifts.length
        });
      } else {
        body = this._t("employee.effective_shift_none");
      }
      const source = e.sourceLabel ? ` (${this._t("employee.effective_shift_source", {
        source: e.sourceLabel
      })})` : "";
      return `${this._t("employee.effective_shift_label")}: ${body}${source}`;
    },
    /** 소속 근무를 저장한 뒤 판정 줄만 다시 읽는다 — 실패해도 저장 결과는 그대로라 조용히 넘긴다 */
    async refreshEffectiveShift(employeeId) {
      try {
        const detail = await this.sdk.employee.getEmployee(employeeId);
        this.editEffectiveShift = detail?.effectiveShift ?? null;
      } catch {
      }
    },
    // 근무 그룹 변경 시: 현재 근무 형태가 그 그룹 소속이 아니면 선택 해제(그룹만 배정 상태로).
    onShiftGroupChange() {
      const cur = this.shifts.find((s) => s.id === this.editForm.shiftId);
      if (cur && cur.groupId !== (this.editForm.shiftGroupId || void 0)) {
        this.editForm.shiftId = "";
      }
    },
    /** 미리보기 — 로드 시점(원본) 대비 현재 폼 '전체'를 섹션별로 모은다(기존값 포함). 각 행은
    {label, before, after, changed}. changed=true면 변경 전→후로 강조, 나머지는 현재값만 표시.
    저장 시 실제 반영되는 필드 기준 — 소속(팀·역할)·비밀번호처럼 즉시 저장/별도 경로인 항목은
    제외한다. 상태 전환(휴직/퇴직/복직)은 '상태' 행의 전→후로 표시. */
    // biome-ignore lint/suspicious/noExplicitAny: dynamic preview sections
    previewRows() {
      const emp = this.editingEmployee || {};
      const f = this.editForm;
      const sections = [];
      const mk = /* @__PURE__ */ __name((title) => {
        const s = {
          title,
          rows: []
        };
        sections.push(s);
        return s;
      }, "mk");
      const add = /* @__PURE__ */ __name((sec, label2, before, after) => {
        const b = before == null ? "" : String(before);
        const a = after == null ? "" : String(after);
        sec.rows.push({
          label: label2,
          before: b || "-",
          after: a || "-",
          changed: b !== a
        });
      }, "add");
      const dt = /* @__PURE__ */ __name((v) => displayDate(v, herebyStore(this)?.timezone), "dt");
      const won = /* @__PURE__ */ __name((n) => `${Number(n || 0).toLocaleString()}${this._t("common.won_suffix")}`, "won");
      const hrs = /* @__PURE__ */ __name((n) => n == null || n === "" ? "-" : `${n}\uC2DC\uAC04`, "hrs");
      const yesNo = /* @__PURE__ */ __name((b) => b ? "\uC608" : "\uC544\uB2C8\uC624", "yesNo");
      const label = /* @__PURE__ */ __name((map2, k) => map2[k] || k || "-", "label");
      const shiftName = /* @__PURE__ */ __name((id) => id ? this.shifts.find((s) => s.id === id)?.name || "\uBBF8\uBC30\uC815" : "\uBBF8\uBC30\uC815", "shiftName");
      const groupName = /* @__PURE__ */ __name((id) => id ? this.shiftGroups.find((g) => g.id === id)?.name || "\uADF8\uB8F9 \uBBF8\uC9C0\uC815" : "\uADF8\uB8F9 \uBBF8\uC9C0\uC815", "groupName");
      const statusMap = {
        ACTIVE: "\uC7AC\uC9C1",
        INACTIVE: "\uBE44\uD65C\uC131",
        ON_LEAVE: "\uD734\uC9C1",
        TERMINATED: "\uD1F4\uC9C1",
        RETURN: "\uBCF5\uC9C1"
      };
      const attendMap = {
        "": "\uC870\uC9C1 \uAE30\uBCF8\uAC12",
        app: "\uC571",
        secom: "\uC9C0\uBB38 \uB2E8\uB9D0\uAE30",
        manual: "\uAD00\uB9AC\uC790 \uC218\uB3D9"
      };
      const contractMap = {
        permanent: "\uC815\uADDC\uC9C1",
        temporary: "\uC784\uC2DC\uC9C1",
        contract: "\uACC4\uC57D\uC9C1",
        internship: "\uC778\uD134",
        part_time: "\uD30C\uD2B8\uD0C0\uC784"
      };
      const wageMap = {
        monthly: "\uC6D4\uAE09",
        hourly: "\uC2DC\uAE09",
        daily: "\uC77C\uAE09",
        annual: "\uC5F0\uBD09"
      };
      const basic = mk("\uAE30\uBCF8\uC815\uBCF4");
      add(basic, "\uC774\uB984", `${emp.lastName || ""}${emp.firstName || ""}`, `${f.lastName || ""}${f.firstName || ""}`);
      add(basic, "\uC0AC\uBC88", this.originalEmployeeNumber, f.employeeNumber);
      add(basic, "\uC774\uBA54\uC77C", emp.email, f.email);
      add(basic, "\uC804\uD654\uBC88\uD638", emp.phone, f.phone);
      add(basic, "\uC0DD\uB144\uC6D4\uC77C", dt(emp.birthDate), dt(f.birthDate));
      const ea = emp.address || {};
      add(basic, "\uC8FC\uC18C", [
        ea.street,
        ea.detail
      ].filter(Boolean).join(" "), [
        f.address,
        f.addressDetail
      ].filter(Boolean).join(" "));
      const hr = mk("\uC778\uC0AC\uC815\uBCF4");
      add(hr, "\uC785\uC0AC\uC77C", dt(emp.hireDate), dt(f.hireDate));
      add(hr, "\uC9C1\uBB34", emp.jobDuty, this.jobDutyName(f.jobDutyId) || (f.jobDutyId ? "" : ""));
      add(hr, "\uADFC\uB85C\uD615\uD0DC", emp.workPatternName, this.workPatternName(f.workPatternId));
      if (f.workPatternResetOverrides && f.workPatternOverrides.length > 0) {
        add(hr, "\uADFC\uB85C\uD615\uD0DC \uC218\uB3D9 \uAC12", this.workPatternOverrideLabels(), "\uC790\uB3D9\uC73C\uB85C \uB418\uB3CC\uB9BC");
      }
      add(hr, "\uC0C1\uD0DC", label(statusMap, f.status), label(statusMap, f.statusAction));
      if (this.editMemberships.length === 0) {
        add(hr, "\uADFC\uBB34 \uADF8\uB8F9", groupName(emp.shiftGroupId), groupName(f.shiftGroupId));
        add(hr, "\uADFC\uBB34\uD615\uD0DC", shiftName(emp.shiftId), shiftName(f.shiftId));
      } else {
        const pairLabel = /* @__PURE__ */ __name((g, sh) => g ? sh ? `${groupName(g)} \xB7 ${shiftName(sh)}` : `${groupName(g)} (\uADFC\uBB34\uD615\uD0DC \uBBF8\uC9C0\uC815)` : "\uBBF8\uC9C0\uC815", "pairLabel");
        const rows = this.editMemberships;
        add(hr, "\uC8FC \uC18C\uC18D", rows.find((m) => m.originalIsPrimary)?.teamName, rows.find((m) => m.isPrimary)?.teamName);
        for (const m of rows) {
          add(hr, `\uADFC\uBB34 (${m.teamName})`, pairLabel(m.originalShiftGroupId, m.originalShiftId), pairLabel(m.shiftGroupId, m.shiftId));
        }
      }
      add(hr, "\uCD9C\uADFC \uAE30\uB85D \uBC29\uC2DD", label(attendMap, emp.attendanceMethod || ""), label(attendMap, f.attendanceMethod || ""));
      add(hr, "\uAE09\uC5EC \uC9C0\uAE09 \uB300\uC0C1", yesNo(!emp.payrollExcluded), yesNo(!f.payrollExcluded));
      add(hr, "\uC2DC\uC2A4\uD15C \uAD00\uB9AC\uC790", yesNo(!!emp.isSystemAdmin), yesNo(f.isSystemAdmin));
      if (this.editWards.length > 0 || this.editWardsRemoved.length > 0) {
        const wardSec = mk("\uBCD1\uB3D9 \uBC30\uC815");
        const wardNameOf = /* @__PURE__ */ __name((wardId, fallback) => this.wardList.find((x) => x.id === wardId)?.name || fallback, "wardNameOf");
        const groupNameOf = /* @__PURE__ */ __name((groupId, fallback) => this.scheduleGroupList.find((g) => g.id === groupId)?.name || fallback, "groupNameOf");
        const summary = /* @__PURE__ */ __name((wardName, groupName2, workType, isHeadNurse) => [
          wardName,
          groupName2,
          this._t(`nurse.work_type_${workType}`),
          isHeadNurse ? "\uC218\uAC04\uD638\uC0AC(\uCC45\uC784\uC790)" : ""
        ].filter(Boolean).join(" \xB7 "), "summary");
        for (const w of this.editWards) {
          const wardName = wardNameOf(w.wardId, w.wardName);
          const groupName2 = groupNameOf(w.scheduleGroupId, w.scheduleGroupName);
          add(wardSec, wardName || "\uBCD1\uB3D9", w.original ? summary(wardNameOf(w.original.wardId, w.wardName), groupNameOf(w.original.scheduleGroupId, w.scheduleGroupName), w.original.workType, w.original.isHeadNurse) : "", summary(wardName, groupName2, w.workType, w.isHeadNurse));
        }
        for (const r of this.editWardsRemoved) {
          add(wardSec, r.wardName || "\uBCD1\uB3D9", summary(r.wardName, r.scheduleGroupName, r.workType, r.isHeadNurse), "\uC0AD\uC81C");
        }
      }
      let c0 = {};
      try {
        c0 = JSON.parse(this.editContractOriginal || "{}");
      } catch {
        c0 = {};
      }
      const contract = mk("\uADFC\uB85C\uACC4\uC57D");
      add(contract, "\uACC4\uC57D\uD615\uD0DC", label(contractMap, c0.contractType), label(contractMap, f.contractType));
      add(contract, "\uC784\uAE08\uC720\uD615", label(wageMap, c0.wageType), label(wageMap, f.wageType));
      add(contract, "\uAE30\uBCF8\uAE09", won(c0.baseSalary), won(f.baseSalary));
      add(contract, "\uD638\uBD09", won(c0.hobongAmount), won(f.hobongAmount));
      add(contract, "\uADFC\uC18D\uC218\uB2F9", won(c0.longevityAmount), won(f.longevityAmount));
      add(contract, "\uC2DD\uB300", won(c0.mealAllowance), won(f.mealAllowance));
      add(contract, "\uAD50\uD1B5\uBE44", won(c0.transportAllowance), won(f.transportAllowance));
      add(contract, "\uC9C1\uCC45\uC218\uB2F9", won(c0.positionAllowance), won(f.positionAllowance));
      add(contract, "\uAE30\uC900 \uADFC\uB85C\uC2DC\uAC04", hrs(c0.standardWeeklyHours), hrs(f.standardWeeklyHours));
      add(contract, "\uCD5C\uB300 \uADFC\uB85C\uC2DC\uAC04", hrs(c0.maxWeeklyHours), hrs(f.maxWeeklyHours));
      const account = mk("\uACC4\uC815\xB7\uBCF4\uC548");
      const hadOtp = Array.isArray(emp.authMethods) && emp.authMethods.includes("phone_otp");
      add(account, "SMS \uB85C\uADF8\uC778 \uD5C8\uC6A9", yesNo(hadOtp), yesNo(f.phoneOtpEnabled));
      add(account, "\uD328\uC2A4\uD0A4 \uC804\uC6A9 \uB85C\uADF8\uC778", yesNo(!!emp.passkeyOnlyLogin), yesNo(f.passkeyOnlyLogin));
      return sections.filter((s) => s.rows.length > 0);
    },
    async removeTeamMembership(idx) {
      const m = this.editMemberships[idx];
      if (!(m && this.editingEmployee)) {
        return;
      }
      const ok = await this.askConfirm(this._t("admin.confirm_remove_team").replace("{team}", m.teamName), {
        confirmLabel: "\uC81C\uAC70",
        tone: "danger"
      });
      if (!ok) {
        return;
      }
      try {
        await this.sdk.team.removeMember(m.teamId, m.memberId);
        this.editMemberships.splice(idx, 1);
      } catch (err) {
        this.showNotice(`${this._t("admin.team_remove_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    async changeMembership(empId, editMemberId, teamId, roleId) {
      const wasDirty = this.isEditFormDirty();
      let addInput = {
        teamId,
        employeeId: empId,
        ...roleId ? {
          roleId
        } : {}
      };
      const old = editMemberId ? this.editMemberships.find((m) => m.memberId === editMemberId) : void 0;
      if (old && old.teamId !== teamId) {
        const decision = await this.askWardMove(old.teamId, teamId);
        if (decision === "cancel") {
          return;
        }
        if (decision === "move") {
          addInput = {
            ...addInput,
            wardAssignment: "move",
            fromTeamId: old.teamId
          };
        } else if (decision === "keep") {
          addInput = {
            ...addInput,
            wardAssignment: "none"
          };
        }
      }
      this.affiliationBusy = true;
      try {
        if (old) {
          try {
            await this.sdk.team.removeMember(old.teamId, editMemberId);
          } catch {
          }
        }
        await this.sdk.team.addMember(addInput);
        await this.loadEditMemberships();
        if (!wasDirty) {
          this.closeBaseline = this.closeGuardState();
        }
      } catch (err) {
        this.showNotice(`\uC18C\uC18D ${editMemberId ? "\uBCC0\uACBD" : "\uCD94\uAC00"} \uC2E4\uD328: ${err instanceof Error ? err.message : String(err)}`, "danger");
      } finally {
        this.affiliationBusy = false;
      }
    },
    /**
    * 팀 이동 확인 — 병동이 연결된 팀에서 다른 병동 팀으로 옮기고, 예전 팀 병동에 저장된 배정이 있으면
    * 병동 배정도 함께 옮길지 묻는다(admin 명부의 팀 변경과 같은 규칙). 그 밖에는 자동 배정(auto).
    * move = 병동도 함께 옮기기 · keep = 팀만 옮기기 · cancel = Esc(이동 취소)
    */
    async askWardMove(fromTeamId, toTeamId) {
      const from = this.teams.find((t) => t.id === fromTeamId);
      const to = this.teams.find((t) => t.id === toTeamId);
      const fromWardId = from?.wardId;
      const toWardId = to?.wardId;
      if (!(fromWardId && toWardId) || fromWardId === toWardId) {
        return "auto";
      }
      const saved = this.editWards.filter((w) => w.original);
      const hasFrom = saved.some((w) => w.original?.wardId === fromWardId);
      const hasTo = saved.some((w) => w.original?.wardId === toWardId);
      if (!hasFrom || hasTo) {
        return "auto";
      }
      const name = `${this.editForm.lastName || ""}${this.editForm.firstName || ""}`.trim();
      const toName = to?.name || "";
      const choice = await askChoice({
        message: `${name}\uB2D8\uC744 ${from?.name || ""}\uC5D0\uC11C ${toName} \uD300\uC73C\uB85C \uC62E\uACA8\uC694.
${toName}\uC5D0 \uC5F0\uACB0\uB41C \uBCD1\uB3D9\uC73C\uB85C \uBCD1\uB3D9 \uBC30\uC815\uB3C4 \uD568\uAED8 \uC62E\uAE38\uAE4C\uC694?`,
        emphasis: [
          name,
          toName
        ].filter(Boolean),
        confirmLabel: "\uBCD1\uB3D9\uB3C4 \uD568\uAED8 \uC62E\uAE30\uAE30",
        altLabel: "\uD300\uB9CC \uC62E\uAE30\uAE30"
      });
      if (choice === "confirm") {
        return "move";
      }
      return choice === "alt" ? "keep" : "cancel";
    },
    /**
    * 소속 칩에서 역할을 고름 — 다른 입력과 같이 **폼 변경으로만** 잡아 두고, 「저장」을 눌렀을 때
    * persistBasicEdits 의 역할 저장 루프(team.updateMember)가 보낸다 (MED-926).
    * 종전에는 여기서 바로 서버에 저장하고 기준선을 다시 잡아 저장 버튼이 켜지지 않았고,
    * onSaved 도 부르지 않아 패널을 닫은 뒤 직원 목록·팀 명단에 옛 역할이 남았다.
    * 같은 역할을 다시 고르면 그대로 둔다. 역할 이름은 칩 표시용으로 함께 바꾼다.
    */
    quickRoleChange(_empId, roleId, m) {
      if (!m || m.roleId === roleId) {
        return;
      }
      const role = this.roles.find((r) => r.id === roleId);
      m.roleId = roleId;
      m.roleName = role?.name || "";
    },
    async resetEmployeePassword() {
      if (!this.editingEmployee) {
        return;
      }
      const ok = await this.askConfirm(this._t("admin.confirm_password_reset"), {
        confirmLabel: "\uCD08\uAE30\uD654"
      });
      if (!ok) {
        return;
      }
      try {
        const result = await this.sdk.auth.adminResetPassword(this.editingEmployee.id);
        if (result.smsSent) {
          this.showNotice(this._t("admin.temp_password_sent"), "success");
        } else if (result.temporaryPassword) {
          this.showNotice(this._t("admin.temp_password_manual_msg").replace("{pw}", result.temporaryPassword), "success");
        } else {
          this.showNotice(result.message || this._t("admin.password_reset_done"), "success");
        }
      } catch (err) {
        this.showNotice(`${this._t("admin.password_reset_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    /** 조직 임시 비밀번호 형식(settings.passwordPolicy) — 패널이 열릴 때 한 번 읽어 둔다. */
    tempPasswordPolicy: null,
    /** 병원 설정의 일반 비밀번호 최소 길이(settings.userPasswordPolicy, 4~20·기본 8) — 같은 때 읽는다. */
    manualPasswordMinLength: 8,
    tempPasswordPolicyLoaded: false,
    async ensureTempPasswordPolicy() {
      if (this.tempPasswordPolicyLoaded) {
        return;
      }
      this.tempPasswordPolicyLoaded = true;
      try {
        const org = await this.sdk.organization.getCurrent();
        this.tempPasswordPolicy = org?.settings?.passwordPolicy ?? null;
        this.manualPasswordMinLength = resolveUserPasswordPolicy(org?.settings?.userPasswordPolicy).minLength;
      } catch {
        this.tempPasswordPolicy = null;
      }
    },
    manualPasswordIsTemporaryFormat(pw) {
      return matchesTemporaryPasswordPolicy(pw, this.tempPasswordPolicy);
    },
    /** 직접 설정 입력칸 아래 안내 — 「{병원 최소 길이}자 이상 또는 임시 비밀번호 형식(숫자 4자)」 */
    get manualPasswordRuleText() {
      const format = describeTemporaryPasswordPolicy(this.tempPasswordPolicy);
      return format ? this._t("employee.manual_password_rule_with_format").replace("{format}", format).replace("{min}", String(this.manualPasswordMinLength)) : this.manualPasswordRuleError;
    },
    /** 규칙 위반 문구 — 「{병원 최소 길이}자 이상이거나 조직의 임시 비밀번호 형식과 같아야 해요.」 */
    get manualPasswordRuleError() {
      return this._t("employee.manual_password_rule").replace("{min}", String(this.manualPasswordMinLength));
    },
    /** 새 비밀번호 칸 안내 — 「새 비밀번호 ({병원 최소 길이}자 이상)」 */
    get manualPasswordPlaceholder() {
      return this._t("employee.new_password_placeholder").replace("{min}", String(this.manualPasswordMinLength));
    },
    /** 저장 버튼 활성 조건 — 입력값이 규칙(병원 최소 길이 이상 또는 임시 형식)에 맞고 확인칸이 같을 때 */
    get manualPasswordValid() {
      const pw = this.editForm.newPassword;
      return Boolean(pw) && (pw.length >= this.manualPasswordMinLength || this.manualPasswordIsTemporaryFormat(pw));
    },
    async setManualPassword() {
      if (!this.editingEmployee) {
        return;
      }
      await this.ensureTempPasswordPolicy();
      const pw = this.editForm.newPassword;
      const temporaryFormat = this.manualPasswordIsTemporaryFormat(pw);
      if (!pw || pw.length < this.manualPasswordMinLength && !temporaryFormat) {
        this.showNotice(this.manualPasswordRuleError, "danger");
        return;
      }
      if (pw !== this.editForm.confirmPassword) {
        this.showNotice(this._t("admin.password_mismatch"), "danger");
        return;
      }
      const ok = await this.askConfirm(temporaryFormat ? this._t("employee.confirm_temp_format_password") : this._t("admin.confirm_password_set"), {
        confirmLabel: "\uC124\uC815"
      });
      if (!ok) {
        return;
      }
      try {
        await this.sdk.employee.updateEmployee({
          id: this.editingEmployee.id,
          password: pw
        });
        this.editForm.newPassword = "";
        this.editForm.confirmPassword = "";
        this.showNotice(this._t("admin.password_changed"), "success");
      } catch (err) {
        this.showNotice(`${this._t("admin.password_change_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    async processLeave() {
      if (!(this.editingEmployee && this.leaveConfirmForm.reason)) {
        return;
      }
      const reason = this.leaveConfirmForm.reason === "\uAE30\uD0C0" ? this.leaveConfirmForm.reasonDetail || "\uAE30\uD0C0" : this.leaveConfirmForm.reason;
      try {
        await this.sdk.employee.createLeaveRecord({
          employeeId: this.editingEmployee.id,
          reason,
          startDate: this.leaveConfirmForm.startDate,
          expectedReturnDate: this.leaveConfirmForm.expectedReturnDate || void 0,
          notes: this.leaveConfirmForm.notes || void 0
        });
        await this.sdk.employee.updateEmployee({
          id: this.editingEmployee.id,
          status: "ON_LEAVE"
        });
        this.editForm.status = "ON_LEAVE";
        this.showEditEmployee = false;
        this.showNotice(`${this._t("admin.leave_processed").replace("{name}", this.editingEmployee.fullName || "")}
${reason} / ${displayDate(this.leaveConfirmForm.startDate, herebyStore(this)?.timezone)}`);
        opts.onSaved?.();
      } catch (err) {
        this.showNotice(`${this._t("admin.leave_process_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    async _doReturnFromLeave() {
      if (!this.editingEmployee) {
        return;
      }
      try {
        await this.sdk.employee.returnFromLeave(this.editingEmployee.id);
        await this.sdk.employee.updateEmployee({
          id: this.editingEmployee.id,
          status: "ACTIVE"
        });
        this.editForm.status = "ACTIVE";
        this.showEditEmployee = false;
        this.showNotice(this._t("admin.return_processed"));
        opts.onSaved?.();
      } catch (err) {
        this.showNotice(`${this._t("admin.return_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    /** 퇴직 취소 — 서버가 한 트랜잭션에서 퇴사 기록 닫기·상태 재직·팀 단톡방 복귀를 한다(MED-834). */
    async _doCancelTermination() {
      if (!this.editingEmployee) {
        return;
      }
      try {
        await this.sdk.employee.cancelTermination({
          id: this.editingEmployee.id,
          reason: this.reinstateForm.reason.trim()
        });
        this.editForm.status = "ACTIVE";
        this.editForm.statusAction = "ACTIVE";
        this.showEditEmployee = false;
        const name = `${this.editingEmployee.lastName || ""}${this.editingEmployee.firstName || ""}`.trim();
        this.showNotice(this._t("admin.reinstate_processed").replace("{name}", name));
        opts.onSaved?.();
      } catch (err) {
        this.showNotice(`${this._t("admin.reinstate_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    /** 기본 정보 탭의 안내에서 「퇴직 취소하러 가기」 — 인사 정보 탭의 상태 칸으로 옮기고 퇴직 취소를 골라 둔다 */
    goToReinstate() {
      this.editEmployeeCat = "hr";
      this.editForm.statusAction = "REINSTATE";
    },
    async processTermination() {
      if (!(this.editingEmployee && this.terminationForm.reason && this.terminationForm.confirmed)) {
        return;
      }
      const reason = this.terminationForm.reason === "\uAE30\uD0C0" ? this.terminationForm.reasonDetail || "\uAE30\uD0C0" : this.terminationForm.reason;
      try {
        await this.sdk.resignation.create({
          employeeId: this.editingEmployee.id,
          resignationDate: this.terminationForm.terminationDate,
          reason,
          notes: this.terminationForm.notes || void 0
        });
        await this.sdk.employee.updateEmployee({
          id: this.editingEmployee.id,
          status: "TERMINATED"
        });
        this.editForm.status = "TERMINATED";
        this.showEditEmployee = false;
        this.showNotice(`${this._t("admin.termination_processed").replace("{name}", this.editingEmployee.fullName || "")}
${reason} / ${displayDate(this.terminationForm.terminationDate, herebyStore(this)?.timezone)}`);
        opts.onSaved?.();
      } catch (err) {
        this.showNotice(`${this._t("admin.termination_failed")}: ${err instanceof Error ? err.message : String(err)}`, "danger");
      }
    },
    formatPhone(val) {
      return val.replace(/\D/g, "").slice(0, 11);
    }
  };
}
__name(editEmployeePanelComponent, "editEmployeePanelComponent");

// src/components/EntityPicker.ts
import { buildTeamTreeRows, entityPickerRecentContext, filterEmployees, filterTeamTreeRows, teamDescendantIds } from "@hereby/core/constants";
var RECENT_LIMIT = 5;
var EMPLOYEE_ROW_LIMIT = 50;
var directoryCache = null;
function entityPickerComponent(opts) {
  const context = String(opts?.context ?? "picker");
  const kinds = Array.isArray(opts?.kinds) && opts.kinds.length > 0 ? opts.kinds : [
    "team",
    "employee"
  ];
  const multiple = opts?.multiple !== false;
  const subTeamsOption = opts?.subTeams !== false;
  const hostEmployees = Array.isArray(opts?.employees) ? opts.employees : null;
  const max = Number.isFinite(opts?.max) && opts?.max > 0 ? Math.floor(opts?.max) : 0;
  return {
    kinds,
    tab: kinds[0],
    /**
    * 검색어. 이름이 `query` 가 아닌 이유: 검색창은 안쪽 `dsSearchInput` 컴포넌트가 감싸고 그 요소의
    * `x-model` 은 **안쪽 스코프에서** 평가된다. dsSearchInput 에도 `query`(정규화 getter)가 있어 `x-model="query"`
    * 는 선택기가 아니라 검색창 자신에 묶여 목록이 걸러지지 않았다(2026-10-06 자동 QA). dsSearchInput 에 없는
    * 이름이어야 한다 — SearchInput.test 가 충돌을 감시한다.
    */
    pickerQuery: "",
    loading: false,
    loaded: false,
    loadError: "",
    teams: [],
    employees: [],
    employeeNumberVisible: false,
    /** 고른 대상 — 호스트 x-model 과 묶인다 */
    selected: [],
    /** 고를 수 없는 id(이미 공유된 대상 등) — 호스트가 x-effect 로 준다 */
    excluded: [],
    /** 종류별 최근 선택 id(최신순) */
    recentIds: {
      team: [],
      employee: []
    },
    multiple,
    subTeamsOption,
    /** 칩에 순서 번호 */
    ordered: opts?.ordered === true,
    /** 다중 선택 상한(0 = 없음) */
    max,
    /** 검색칸 클래스 — ds-input--32(기본) · ds-input--48 */
    searchInputClass: opts?.inputSize === 48 ? "ds-input--48" : opts?.inputSize === 40 ? "ds-input--40" : "ds-input--32",
    placeholder: opts?.placeholder ?? (hostEmployees ? "\uC774\uB984 \xB7 \uD300\uC73C\uB85C \uCC3E\uAE30" : "\uC774\uB984 \xB7 \uC0AC\uBC88 \xB7 \uD300 \xB7 \uC9C1\uBB34\uB85C \uAC80\uC0C9"),
    /** 검색어 이력 컨텍스트(SearchInput 에 넘김) */
    searchContext: `picker.${context}.search`,
    get showTabs() {
      return this.kinds.length > 1;
    },
    get excludedSet() {
      return new Set(this.excluded ?? []);
    },
    get hasQuery() {
      return this.pickerQuery.trim().length > 0;
    },
    /** 상한을 채웠나 — 남은 행은 비활성, 바꾸려면 먼저 뺀다 */
    get atMax() {
      return this.multiple && this.max > 0 && this.selected.length >= this.max;
    },
    get teamTreeRows() {
      return filterTeamTreeRows(buildTeamTreeRows(this.teams), this.pickerQuery);
    },
    /** 현재 탭의 후보 행 — 팀은 트리(제외 대상은 흐리게 남김), 개인은 일치하는 50명 */
    get rows() {
      const excluded = this.excludedSet;
      if (this.tab === "team") {
        return this.teamTreeRows.map((t) => {
          const kids = teamDescendantIds(this.teams, t.id).length;
          return {
            kind: "team",
            id: t.id,
            name: t.name,
            meta: kids > 0 ? `\uD558\uC704 \uD300 ${kids}` : "",
            depth: t.depth,
            hasChildren: t.hasChildren,
            disabled: excluded.has(t.id)
          };
        });
      }
      return filterEmployees(this.employees, this.pickerQuery, [], EMPLOYEE_ROW_LIMIT).map((e) => ({
        kind: "employee",
        id: e.id,
        name: e.name,
        meta: [
          e.employeeNumber,
          e.teamNames.join(" \xB7 "),
          e.jobDuty
        ].filter(Boolean).join(" \xB7 "),
        depth: 0,
        hasChildren: false,
        disabled: excluded.has(e.id)
      }));
    },
    /** 검색 전 상단의 「최근 선택」 — 고를 수 있는 것만, 최대 5 */
    get recentRows() {
      if (this.hasQuery) {
        return [];
      }
      const excluded = this.excludedSet;
      const ids = this.recentIds[this.tab] ?? [];
      const out = [];
      for (const id of ids) {
        if (excluded.has(id)) {
          continue;
        }
        if (this.tab === "team") {
          const t = this.teams.find((x) => x.id === id);
          if (t) {
            out.push({
              kind: "team",
              id,
              name: t.name,
              meta: "",
              depth: 0,
              hasChildren: false,
              disabled: false
            });
          }
        } else {
          const e = this.employees.find((x) => x.id === id);
          if (e) {
            out.push({
              kind: "employee",
              id,
              name: e.name,
              meta: [
                e.employeeNumber,
                e.teamNames[0]
              ].filter(Boolean).join(" \xB7 "),
              depth: 0,
              hasChildren: false,
              disabled: false
            });
          }
        }
        if (out.length >= RECENT_LIMIT) {
          break;
        }
      }
      return out;
    },
    get isEmpty() {
      return this.loaded && this.rows.length === 0;
    },
    /** 현재 탭의 직원 후보가 상한에 잘렸는가 — 더 좁히라는 안내용 */
    get employeeRowsTruncated() {
      if (this.tab !== "employee") {
        return false;
      }
      return filterEmployees(this.employees, this.pickerQuery, [], Number.POSITIVE_INFINITY).length > EMPLOYEE_ROW_LIMIT;
    },
    tabLabel(kind) {
      return kind === "team" ? "\uD300" : "\uAC1C\uC778";
    },
    /** 호스트가 x-effect 로 넘기는 제외 id — 배열 참조가 바뀔 때마다 들어온다 */
    setExcluded(ids) {
      this.excluded = Array.isArray(ids) ? ids.map(String) : [];
    },
    isSelected(kind, id) {
      return this.selected.some((s) => s.kind === kind && s.id === id);
    },
    /** 고른 순서(1부터). 안 골랐으면 0 */
    orderOf(kind, id) {
      return this.selected.findIndex((s) => s.kind === kind && s.id === id) + 1;
    },
    hasSubTeams(teamId) {
      return teamDescendantIds(this.teams, teamId).length > 0;
    },
    subTeamsOf(teamId) {
      const byId = new Map(this.teams.map((t) => [
        t.id,
        t
      ]));
      return teamDescendantIds(this.teams, teamId).map((id) => byId.get(id)).filter((t) => Boolean(t)).map((t) => ({
        id: t.id,
        name: t.name
      }));
    },
    async load() {
      if (this.loaded || this.loading) {
        return;
      }
      if (hostEmployees) {
        this.applyDirectory({
          teams: [],
          employees: hostEmployees,
          employeeNumberVisible: false
        });
        return;
      }
      if (directoryCache) {
        this.applyDirectory(directoryCache);
        return;
      }
      this.loading = true;
      this.loadError = "";
      try {
        const sdk = herebyStore(this).sdk;
        const dir = await sdk.entityPicker.directory({
          kinds: this.kinds
        });
        directoryCache = {
          teams: dir.teams,
          employees: dir.employees,
          employeeNumberVisible: dir.employeeNumberVisible
        };
        this.applyDirectory(directoryCache);
        this.loadRecent();
      } catch (e) {
        this.loadError = e instanceof Error ? e.message : "\uD6C4\uBCF4 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694.";
        this.loaded = true;
      } finally {
        this.loading = false;
      }
    },
    applyDirectory(dir) {
      this.teams = dir.teams;
      this.employees = dir.employees;
      this.employeeNumberVisible = dir.employeeNumberVisible;
      this.loaded = true;
    },
    /** 종류별 최근 선택 — SearchInput 과 같은 이력 저장소(`picker.<화면>.<종류>`, term = id) */
    async loadRecent() {
      try {
        const sdk = herebyStore(this).sdk;
        const lists = await Promise.all(this.kinds.map((k) => sdk.searchHistory.list({
          context: entityPickerRecentContext(context, k)
        })));
        this.kinds.forEach((k, i) => {
          this.recentIds[k] = (lists[i] ?? []).map((r) => r.term);
        });
      } catch {
      }
    },
    /** 행 클릭 — 고르기/해제. 단일 선택이면 바꿔 끼운다. */
    toggle(row) {
      if (row.disabled) {
        return;
      }
      const idx = this.selected.findIndex((s) => s.kind === row.kind && s.id === row.id);
      if (idx >= 0) {
        this.selected.splice(idx, 1);
        return;
      }
      if (this.atMax) {
        return;
      }
      const entry = {
        kind: row.kind,
        id: row.id,
        name: row.name
      };
      if (row.kind === "team") {
        entry.includeSubTeams = false;
        entry.subTeams = this.subTeamsOf(row.id);
      }
      if (this.multiple) {
        this.selected.push(entry);
      } else {
        this.selected.splice(0, this.selected.length, entry);
      }
      if (!hostEmployees) {
        this.recordPick(row.kind, row.id);
      }
    },
    removeSelection(sel) {
      const idx = this.selected.findIndex((s) => s.kind === sel.kind && s.id === sel.id);
      if (idx >= 0) {
        this.selected.splice(idx, 1);
      }
    },
    /** 순서 바꾸기(ordered 일 때 칩의 ▲▼) — 끝에서 더 가면 아무 일도 없다. 끌기 대신 버튼(모바일 스크롤과 안 겹치게) */
    moveSelection(sel, delta) {
      const idx = this.selected.findIndex((s) => s.kind === sel.kind && s.id === sel.id);
      const to = idx + delta;
      if (idx < 0 || to < 0 || to >= this.selected.length) {
        return;
      }
      const [item] = this.selected.splice(idx, 1);
      this.selected.splice(to, 0, item);
    },
    clear() {
      this.selected.splice(0, this.selected.length);
    },
    toggleSubTeams(sel) {
      const idx = this.selected.findIndex((s) => s.kind === sel.kind && s.id === sel.id);
      if (idx < 0) {
        return;
      }
      const cur = this.selected[idx];
      this.selected.splice(idx, 1, {
        ...cur,
        includeSubTeams: !cur.includeSubTeams,
        subTeams: this.subTeamsOf(cur.id)
      });
    },
    /** 최근 선택 기록 — 로컬 최신순 갱신 + 서버(실패는 조용히) */
    recordPick(kind, id) {
      const list = this.recentIds[kind] ?? [];
      this.recentIds[kind] = [
        id,
        ...list.filter((x) => x !== id)
      ].slice(0, 20);
      try {
        herebyStore(this).sdk.searchHistory.record({
          context: entityPickerRecentContext(context, kind),
          term: id
        }).catch(() => void 0);
      } catch {
      }
    },
    init() {
      this.load();
    }
  };
}
__name(entityPickerComponent, "entityPickerComponent");

// src/components/ForgotPasswordForm.ts
function forgotPasswordFormComponent() {
  return {
    title: "",
    subtitle: "",
    identifier: "",
    error: "",
    isLoading: false,
    success: false,
    init() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      this.title = t("auth.forgot_password");
      this.subtitle = t("auth.forgot_password_subtitle");
    },
    async submit() {
      if (!this.identifier.trim()) {
        this.error = herebyStore(this).t("auth.identifier_required");
        return;
      }
      this.error = "";
      this.isLoading = true;
      try {
        const store = herebyStore(this);
        await store.sdk.auth.requestPasswordReset(this.identifier.trim());
        this.success = true;
      } catch (e) {
        const err = e;
        this.error = err.message || herebyStore(this).t("auth.forgot_password_failed");
      } finally {
        this.isLoading = false;
      }
    },
    goBack() {
      appStore(this, "router")?.navigate("/signin");
    }
  };
}
__name(forgotPasswordFormComponent, "forgotPasswordFormComponent");

// src/components/LnbSidebar.ts
function itemKey(item) {
  return item.id ?? item.label;
}
__name(itemKey, "itemKey");
function lnbSidebarComponent(opts) {
  const config = opts.config ?? {
    sections: []
  };
  const isActiveFn = opts.isActive;
  const onSelectFn = opts.onSelect;
  const onToggleCollapseFn = opts.onToggleCollapse;
  const isCollapsedFn = opts.isCollapsed;
  const initialExpanded = [];
  function collectDefaults(items) {
    for (const it of items) {
      if (it.defaultExpanded !== false && it.children && it.children.length > 0) {
        initialExpanded.push(itemKey(it));
      }
      if (it.children) {
        collectDefaults(it.children);
      }
    }
  }
  __name(collectDefaults, "collectDefaults");
  for (const section of config.sections) {
    collectDefaults(section.items);
  }
  return {
    config,
    expanded: initialExpanded,
    get entries() {
      const out = [];
      for (const section of this.config.sections) {
        if (section.label) {
          out.push({
            kind: "section-head",
            key: `sh-${section.label}`,
            label: section.label
          });
        }
        for (const item of section.items) {
          const parentKey = itemKey(item);
          out.push({
            kind: "item",
            key: `it-${parentKey}`,
            item
          });
          if (item.children) {
            for (const child of item.children) {
              out.push({
                kind: "submenu-item",
                key: `it-${itemKey(child)}-of-${parentKey}`,
                item: child,
                parentKey
              });
            }
          }
        }
      }
      return out;
    },
    iconFor(name) {
      return getIcon(name);
    },
    /* ── badge (DS .ds-label) ──
    badge가 문자열/숫자면 기존 카운트 필(primary·round), 객체면 지정한
    DS 라벨 변형(tone·line·shape·size)으로 렌더. 시각 스타일은 전부
    .ds-label 클래스가 담당한다. */
    badgeText(item) {
      const b = item.badge;
      if (b === void 0 || b === null) {
        return "";
      }
      return typeof b === "object" ? String(b.text) : String(b);
    },
    badgeClass(item) {
      const b = item.badge;
      const v = typeof b === "object" && b !== null ? b : {
        text: ""
      };
      const classes = [
        "ds-label",
        `ds-label--${v.size ?? "xs"}`,
        `ds-label--${v.shape ?? "round"}`
      ];
      if (v.line) {
        classes.push("ds-label--line");
      }
      classes.push(`ds-label--${v.tone ?? "primary"}`);
      return classes.join(" ");
    },
    isActive(id) {
      if (!id) {
        return false;
      }
      return isActiveFn ? isActiveFn(id) : false;
    },
    hasChildren(item) {
      return !!(item.children && item.children.length > 0);
    },
    /* 하위 메뉴 중 활성 항목 존재 여부 — 접힘 레일에서 하위가 숨겨질 때
    부모 아이콘에 활성 표시(is-child-active)를 주기 위한 판정. */
    hasActiveChild(item) {
      return !!item.children?.some((child) => this.isActive(child.id));
    },
    isExpanded(item) {
      return this.expanded.includes(itemKey(item));
    },
    isExpandedByKey(key) {
      return this.expanded.includes(key);
    },
    toggleExpand(item) {
      const key = itemKey(item);
      const idx = this.expanded.indexOf(key);
      if (idx >= 0) {
        this.expanded.splice(idx, 1);
      } else {
        this.expanded.push(key);
      }
    },
    /* ── collapsed-rail tooltip ──
    접힘 레일은 라벨이 숨겨지므로 호버 시 커스텀 툴팁을 fixed로 띄운다.
    네이티브 title은 한번 뜨면 코드로 못 지워 플라이아웃을 가리므로
    사용하지 않는다. 클릭(메뉴 선택·플라이아웃 열기) 즉시 숨긴다. */
    tipLabel: "",
    tipTop: 0,
    tipLeft: 0,
    showTip(item, ev) {
      const btn = ev.currentTarget;
      if (!btn.closest(".ds-lnb--collapsed") || this.flyoutKey === itemKey(item)) {
        return;
      }
      const rect = btn.getBoundingClientRect();
      this.tipTop = rect.top + rect.height / 2;
      this.tipLeft = rect.right + 6;
      this.tipLabel = item.label;
    },
    hideTip() {
      this.tipLabel = "";
    },
    handleItemClick(item, ev) {
      this.hideTip();
      if (item.disabled) {
        return;
      }
      const host2 = ev?.currentTarget;
      const isCollapsed = typeof isCollapsedFn === "function" ? !!isCollapsedFn() : !!host2?.closest(".ds-lnb--collapsed");
      const representsActivePage = item.id && this.isActive(item.id) || this.hasActiveChild(item);
      if (onToggleCollapseFn && representsActivePage) {
        if (isCollapsed) {
          this.closeFlyout();
          onToggleCollapseFn();
          return;
        }
        if (!this.hasChildren(item)) {
          if (item.id && onSelectFn) {
            onSelectFn(item.id);
          }
          this.closeFlyout();
          onToggleCollapseFn();
          return;
        }
      }
      if (this.hasChildren(item)) {
        if (host2?.closest(".ds-lnb--collapsed")) {
          this.openFlyout(item, ev);
          return;
        }
        this.toggleExpand(item);
        if (item.id && onSelectFn) {
          onSelectFn(item.id);
        }
        return;
      }
      this.closeFlyout();
      if (item.id && onSelectFn) {
        onSelectFn(item.id);
      }
    },
    /* ── collapsed-rail flyout ──
    접힘 상태에서 부모 메뉴를 클릭하면 하위 메뉴 그룹을 아이콘 우측에
    띄운다 (markup: lnb-sidebar.html의 .ds-lnb__flyout). 클릭한 버튼의
    화면 좌표 기준 fixed 배치라 레일 스크롤/overflow에 잘리지 않는다. */
    flyoutKey: "",
    flyoutItem: null,
    flyoutTop: 0,
    flyoutLeft: 0,
    openFlyout(item, ev) {
      ev.stopPropagation();
      const key = itemKey(item);
      if (this.flyoutKey === key) {
        this.closeFlyout();
        return;
      }
      const btn = ev.currentTarget;
      const rect = btn.getBoundingClientRect();
      this.flyoutTop = rect.top;
      this.flyoutLeft = rect.right + 6;
      this.flyoutKey = key;
      this.flyoutItem = item;
    },
    closeFlyout() {
      this.flyoutKey = "";
      this.flyoutItem = null;
    },
    handleFlyoutSelect(child) {
      if (child.disabled) {
        return;
      }
      if (child.id && onSelectFn) {
        onSelectFn(child.id);
      }
      this.closeFlyout();
      if (onToggleCollapseFn && child.id && this.isActive(child.id) && (typeof isCollapsedFn === "function" ? isCollapsedFn() : true)) {
        onToggleCollapseFn();
      }
    }
  };
}
__name(lnbSidebarComponent, "lnbSidebarComponent");

// src/components/LoginForm.ts
var turnstileLoading = null;
function loadTurnstile() {
  const existing = window.turnstile;
  if (existing) {
    return Promise.resolve(existing);
  }
  if (!turnstileLoading) {
    turnstileLoading = new Promise((resolve2, reject) => {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = () => {
        const api = window.turnstile;
        if (api) {
          resolve2(api);
        } else {
          reject(new Error("turnstile missing"));
        }
      };
      script.onerror = () => {
        turnstileLoading = null;
        reject(new Error("turnstile load failed"));
      };
      document.head.appendChild(script);
    });
  }
  return turnstileLoading;
}
__name(loadTurnstile, "loadTurnstile");
var SKIP_DEVICE_LOGIN_AUTO_KEY2 = "hereby:skip-device-login-auto";
function consumeSkipDeviceLoginAuto(storage2 = safeSessionStorage()) {
  if (!storage2) {
    return false;
  }
  try {
    const flagged = storage2.getItem(SKIP_DEVICE_LOGIN_AUTO_KEY2) === "1";
    if (flagged) {
      storage2.removeItem(SKIP_DEVICE_LOGIN_AUTO_KEY2);
    }
    return flagged;
  } catch {
    return false;
  }
}
__name(consumeSkipDeviceLoginAuto, "consumeSkipDeviceLoginAuto");
function safeSessionStorage() {
  try {
    return typeof sessionStorage === "undefined" ? void 0 : sessionStorage;
  } catch {
    return void 0;
  }
}
__name(safeSessionStorage, "safeSessionStorage");
function formatLoginError(e, t) {
  if (e instanceof TypeError && /fetch|Load failed|network/i.test(String(e.message))) {
    return t("auth.api_unreachable");
  }
  if (e instanceof Error) {
    if (e.message === "Failed to fetch") {
      return t("auth.api_unreachable");
    }
    return e.message;
  }
  return t("auth.login_failed");
}
__name(formatLoginError, "formatLoginError");
function loginFormComponent(opts = {}) {
  return {
    // 앱이 title을 안 넘겼을 때의 폴백. 브랜드 표기는 소문자 `hereby` + 서비스명이 정본이다
    // (마스터에 서비스명을 붙이지 않으므로 `Hereby Admin` 같은 조합은 쓰지 않는다).
    title: opts.title ?? "hereby Medical",
    subtitle: opts.subtitle ?? "",
    showSignupLink: opts.showSignupLink ?? true,
    showForgotPassword: false,
    /**
    * 상단 BI 심볼(HTML). `showBrandLogo`가 켜졌을 때만 이 앱 패밀리의 심볼을 돌려주고,
    * 아니면 빈 문자열이라 템플릿은 종전대로 텍스트 제목을 그린다.
    * 락업이 아니라 **심볼만** 쓴다(워드마크가 들어가면 부제 문구와 서비스명이 겹친다).
    */
    get brandSymbol() {
      if (!opts.showBrandLogo) {
        return "";
      }
      return getIcon(`logo-hereby-${herebyStore(this).brandFamily}`);
    },
    /**
    * 브랜드 조판용 제목 분절 — 영문(`hereby`)은 Geist SemiBold 600, 국문 서비스명(`웍스`)은
    * Pretendard Bold 700 이 정본이라 한 락업 안에서 두 폰트가 섞인다(brand.md 조판 규칙).
    * 한 요소에는 서체·weight 를 하나씩밖에 못 주므로 한글 덩어리를 잘라 낸다.
    * 심볼을 안 켠 앱은 이 getter 를 읽지 않는다(템플릿이 종전 x-text 제목을 쓴다).
    */
    get titleParts() {
      return String(this.title).split(/([가-힣]+)/).filter((part) => part.length > 0).map((text) => ({
        text,
        ko: /[가-힣]/.test(text)
      }));
    },
    // Login method state
    availableMethods: [
      "password"
    ],
    mode: "password",
    // Shared
    identifier: "",
    error: "",
    isLoading: false,
    // Password mode
    password: "",
    showPassword: false,
    /* ── 키 로그인(2026-10-13) ──
    기기 키가 등록된 기기(직원 앱)는 **키로만** 로그인한다(사용자 결정): 비밀번호 폼 대신 「기기 잠금으로 로그인」 한 벌.
    서버가 키를 거부(회수·퇴직)하면 스토어가 로컬 키를 지우고 이 화면은 비밀번호 폼으로 되돌아간다.
    패스키(웹)는 비밀번호 폼 아래 버튼 하나. */
    deviceKeyBusy: false,
    deviceKeyError: "",
    /** 키가 있어도 아이디·비밀번호로 로그인하기로 골랐다(사용자 결정 2026-10-13) — 키는 그대로 둔다 */
    preferPassword: false,
    /** 자동 시도는 화면당 한 번 — 취소한 사람에게 계속 프롬프트를 띄우지 않는다 */
    deviceKeyAutoTried: false,
    passkeyBusy: false,
    /* ── 2단계 인증(2026-10-13) — 비밀번호(또는 문자 코드) 뒤 인증 앱 코드 한 단계. 스토어 twoFactor 가 주인. */
    twoFactorCode: "",
    /* ── 캡차(2026-10-13) — 평소와 다른 환경이면 서버가 Turnstile 을 요구한다. 스토어 captcha 가 주인, 위젯은 여기서 그린다. */
    captchaBusy: false,
    captchaWidgetId: null,
    // OTP mode
    code: "",
    codeSent: false,
    isRequestingCode: false,
    cooldownSeconds: 0,
    cooldownTimer: 0,
    init() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (!this.subtitle) {
        this.subtitle = t("auth.login_subtitle");
      }
      const sdk = herebyStore(this).sdk;
      if (consumeSkipDeviceLoginAuto()) {
        this.deviceKeyAutoTried = true;
      }
      const tryAuto = /* @__PURE__ */ __name(() => {
        if (this.keyOnly && !this.deviceKeyAutoTried) {
          this.deviceKeyAutoTried = true;
          this.loginWithDeviceKey();
        }
      }, "tryAuto");
      tryAuto();
      window.addEventListener("hereby:login-prefill", (event) => {
        const detail = event.detail;
        if (!(detail?.identifier && detail.password)) {
          return;
        }
        this.mode = "password";
        this.preferPassword = true;
        this.identifier = detail.identifier;
        this.password = detail.password;
        this.error = "";
        this.submit().catch(() => void 0);
      });
      window.dispatchEvent(new Event("hereby:login-form-ready"));
      this.$watch?.("$store.hereby.deviceLogin.ready", () => tryAuto());
      if (sdk?.auth?.passwordResetAvailable) {
        sdk.auth.passwordResetAvailable().then((available) => {
          this.showForgotPassword = available;
        }).catch(() => {
        });
      }
      if (sdk?.auth?.availableLoginMethods) {
        sdk.auth.availableLoginMethods().then((methods) => {
          if (methods && methods.length > 0) {
            this.availableMethods = methods;
            if (!methods.includes(this.mode)) {
              this.mode = methods[0];
            }
          }
        }).catch(() => {
        });
      }
    },
    /** 스토어의 키 로그인 상태(없으면 빈 객체 — 옛 번들·테스트) */
    get deviceLogin() {
      return herebyStore(this).deviceLogin ?? {};
    },
    /** 기기 키가 등록돼 있다 — 로그인 화면은 키 블록으로 시작한다(아이디·비밀번호는 고르면 열린다). */
    get hasDeviceKey() {
      return this.deviceLogin.hasDeviceKey === true;
    },
    /** 지금 키 블록을 보일 때 — 키가 있고 아이디·비밀번호를 고르지 않았을 때. 상태를 읽기 전에는 비밀번호 폼도 숨긴다. */
    get keyOnly() {
      return this.hasDeviceKey && !this.preferPassword;
    },
    /** 「아이디·비밀번호로 로그인」 — 키는 지우지 않는다. 다른 계정으로 들어오면 로그인 뒤 그 사람 키로 다시 등록된다. */
    usePassword() {
      this.preferPassword = true;
      this.deviceKeyError = "";
    },
    /** 「지문·기기 잠금으로 로그인」 — 키 블록으로 되돌아간다 */
    useDeviceKey() {
      this.preferPassword = false;
      this.error = "";
      this.loginWithDeviceKey();
    },
    /** 비밀번호·SMS 폼을 그릴까 — 키 전용 기기가 아니고, 키 상태를 한 번 읽은 뒤(깜빡임 방지; 옛 스토어는 바로) */
    get showCredentialForms() {
      const d = this.deviceLogin;
      if (d.ready === void 0) {
        return true;
      }
      return d.ready === true && !this.keyOnly;
    },
    get passkeyAvailable() {
      return this.deviceLogin.passkeyAvailable === true;
    },
    get deviceLoginGreeting() {
      const t = herebyStore(this).t;
      const name = this.deviceLogin.employeeName;
      return name ? t("auth.device_login_greeting", {
        name
      }) : t("auth.device_login_title");
    },
    async loginWithDeviceKey() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (this.deviceKeyBusy) {
        return;
      }
      this.deviceKeyError = "";
      this.deviceKeyBusy = true;
      try {
        const store = herebyStore(this);
        const outcome = await store.loginWithDeviceKey?.() ?? "no-key";
        if (outcome === "ok") {
          opts.onSuccess?.();
        } else if (outcome === "cancelled") {
          this.deviceKeyError = t("auth.device_login_cancelled");
        } else if (outcome === "rejected") {
          this.error = t("auth.device_login_rejected");
        }
      } catch (e) {
        this.deviceKeyError = formatLoginError(e, t);
      } finally {
        this.deviceKeyBusy = false;
      }
    },
    /**
    * 첫 로그인 뒤 패스키 권유(웹, 2026-10-13) — 직원 앱의 기기 키 자동 등록과 짝. 비밀번호·SMS 로 들어온 직후 패스키를 쓸 수
    * 있는 브라우저면 한 번 묻고, 동의하면 바로 등록한다. 거절하면 이 브라우저·계정에는 다시 묻지 않는다(내 정보에서 언제든).
    * 확인 창은 호스트가 있을 때만 — 호스트 없이 askConfirm 은 자동 통과라 묻지 않은 채 등록할 뻔한다.
    */
    async offerPasskeyAfterLogin(options = {}) {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      const d = this.deviceLogin;
      if (d.platform !== "web" || !d.passkeyAvailable || !hasDialogHost()) {
        return;
      }
      const unusual = options.unusual === true;
      const store = herebyStore(this);
      const userId = store.currentUser?.id;
      if (!(userId && store.registerThisPasskey)) {
        return;
      }
      const marker = `hereby:passkey-offer:${userId}`;
      try {
        if (!unusual && localStorage.getItem(marker)) {
          return;
        }
        if (unusual && localStorage.getItem(marker) === "accepted") {
          return;
        }
      } catch {
      }
      const ok = await askConfirm({
        message: t(unusual ? "auth.passkey_offer_unusual" : "auth.passkey_offer"),
        confirmLabel: t("auth.passkey_register"),
        cancelLabel: t("auth.passkey_offer_later")
      });
      try {
        localStorage.setItem(marker, ok ? "accepted" : "declined");
      } catch {
      }
      if (!ok) {
        return;
      }
      try {
        await store.registerThisPasskey(t("auth.passkey_default_name"));
      } catch {
      }
    },
    async loginWithPasskey() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (this.passkeyBusy) {
        return;
      }
      this.error = "";
      this.passkeyBusy = true;
      try {
        const store = herebyStore(this);
        const ok = await store.loginWithPasskey?.(this.identifier.trim() || void 0);
        if (ok) {
          opts.onSuccess?.();
        }
      } catch (e) {
        this.error = formatLoginError(e, t);
      } finally {
        this.passkeyBusy = false;
      }
    },
    destroy() {
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = 0;
      }
    },
    switchMode(next) {
      if (this.mode === next) {
        return;
      }
      this.mode = next;
      this.error = "";
    },
    startCooldown(seconds) {
      this.cooldownSeconds = seconds;
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
      }
      this.cooldownTimer = setInterval(() => {
        this.cooldownSeconds -= 1;
        if (this.cooldownSeconds <= 0) {
          this.cooldownSeconds = 0;
          if (this.cooldownTimer) {
            clearInterval(this.cooldownTimer);
            this.cooldownTimer = 0;
          }
        }
      }, 1e3);
    },
    async submit() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (!(this.identifier && this.password)) {
        this.error = t("auth.identifier_required");
        return;
      }
      this.error = "";
      this.isLoading = true;
      try {
        const store = herebyStore(this);
        const outcome = opts.accountLogin ? await store.accountLogin(this.identifier.trim(), this.password) : await store.login(this.identifier.trim(), this.password);
        if (this.handleLoginOutcome(outcome)) {
          return;
        }
        this.finishLogin();
      } catch (e) {
        this.error = formatLoginError(e, t);
      } finally {
        this.isLoading = false;
      }
    },
    /** 2단계 인증 대기 중 — 스토어가 챌린지를 들고 있으면 코드 입력 화면만 보인다 */
    get twoFactorPending() {
      return Boolean(herebyStore(this).twoFactor);
    },
    /** 스토어 결과가 중간 단계(2단계 코드·캡차)면 그 화면으로 넘기고 true. 세션이 생겼으면 false. */
    handleLoginOutcome(outcome) {
      if (outcome === "two_factor") {
        this.twoFactorCode = "";
        return true;
      }
      if (outcome === "captcha") {
        this.renderCaptcha();
        return true;
      }
      return false;
    },
    /** 평소와 다른 로그인 캡차 대기 중 — 스토어가 사이트 키를 들고 있으면 위젯 화면만 보인다 */
    get captchaPending() {
      return Boolean(herebyStore(this).captcha);
    },
    /** Turnstile 위젯 — 스크립트는 한 번만 싣고, 토큰이 오면 같은 자격증명으로 로그인을 다시 보낸다 */
    renderCaptcha() {
      const store = herebyStore(this);
      const siteKey = store.captcha?.siteKey;
      if (!siteKey) {
        return;
      }
      this.error = "";
      loadTurnstile().then((turnstile) => {
        const refs = this.$refs;
        const host2 = refs?.turnstile;
        if (!(host2 && store.captcha)) {
          return;
        }
        host2.innerHTML = "";
        this.captchaWidgetId = turnstile.render(host2, {
          sitekey: siteKey,
          callback: /* @__PURE__ */ __name((token) => {
            this.submitCaptcha(token).catch(() => void 0);
          }, "callback"),
          "error-callback": /* @__PURE__ */ __name(() => {
            this.error = herebyStore(this).t("auth.captcha_failed");
          }, "error-callback")
        });
      }).catch(() => {
        this.error = herebyStore(this).t("auth.captcha_failed");
      });
    },
    /** 캡차 토큰으로 같은 로그인을 다시 — 비밀번호·문자 코드·회원 로그인 중 서버가 요구한 그 경로로 */
    async submitCaptcha(token) {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      const store = herebyStore(this);
      const pending = store.captcha;
      if (!pending) {
        return;
      }
      this.error = "";
      this.captchaBusy = true;
      try {
        const outcome = pending.kind === "code" ? await store.loginWithCode(pending.identifier, pending.secret, token) : pending.kind === "account" ? await store.accountLogin(pending.identifier, pending.secret, token) : await store.login(pending.identifier, pending.secret, token);
        if (this.handleLoginOutcome(outcome)) {
          return;
        }
        this.finishLogin();
      } catch (e) {
        this.error = formatLoginError(e, t);
        this.renderCaptcha();
      } finally {
        this.captchaBusy = false;
      }
    },
    cancelCaptcha() {
      herebyStore(this).cancelCaptcha?.();
      this.captchaWidgetId = null;
      this.error = "";
    },
    /** 세션 채택 뒤 공통 마무리 — onSuccess · 패스키 권유(평소와 다른 로그인이면 거절 기록과 무관하게 권함) · 조직이 2단계 인증을 필수로 했는데 미등록이면 인증/보안 설정 안내 */
    finishLogin() {
      opts.onSuccess?.();
      const store = herebyStore(this);
      if (store.currentUser?.requires2FA) {
        setTimeout(() => window.dispatchEvent(new Event("open-security-settings")), 400);
        return;
      }
      this.offerPasskeyAfterLogin({
        unusual: store.unusualLogin === true
      }).catch(() => void 0);
    },
    async verifyTwoFactor() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      const code = this.twoFactorCode.trim();
      if (!code) {
        this.error = t("security.two_factor_code_format");
        return;
      }
      this.error = "";
      this.isLoading = true;
      try {
        await herebyStore(this).verifyTwoFactor(code);
        this.twoFactorCode = "";
        this.finishLogin();
      } catch (e) {
        this.error = formatLoginError(e, t);
      } finally {
        this.isLoading = false;
      }
    },
    cancelTwoFactor() {
      herebyStore(this).cancelTwoFactor?.();
      this.twoFactorCode = "";
      this.error = "";
    },
    async requestCode() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (!this.identifier.trim()) {
        this.error = t("auth.identifier_required");
        return;
      }
      this.error = "";
      this.isRequestingCode = true;
      try {
        const sdk = herebyStore(this).sdk;
        await sdk.auth.requestLoginCode(this.identifier.trim());
        this.codeSent = true;
        this.startCooldown(60);
      } catch (e) {
        this.error = formatLoginError(e, t);
      } finally {
        this.isRequestingCode = false;
      }
    },
    async verifyCode() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      if (!(this.identifier.trim() && this.code.trim())) {
        this.error = t("auth.code_required");
        return;
      }
      if (!/^\d{6}$/.test(this.code.trim())) {
        this.error = t("auth.code_format_invalid");
        return;
      }
      this.error = "";
      this.isLoading = true;
      try {
        const store = herebyStore(this);
        if (this.handleLoginOutcome(await store.loginWithCode(this.identifier.trim(), this.code.trim()))) {
          return;
        }
        this.finishLogin();
      } catch (e) {
        this.error = formatLoginError(e, t);
      } finally {
        this.isLoading = false;
      }
    }
  };
}
__name(loginFormComponent, "loginFormComponent");

// src/components/MyInfoForm.ts
import { isValidQuietHours, NOTIFICATION_PUSH_CATEGORIES, notificationPushCategoryEventType, quietHoursLabel } from "@hereby/core/constants";
import { DeliveryChannel, NotificationMuteType } from "@hereby/core/enums";

// src/utils/profile-photo.ts
var PROFILE_PHOTO_MAX_EDGE = 1024;
var PROFILE_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
var DIRECT_TYPES = /* @__PURE__ */ new Set([
  "image/jpeg",
  "image/jpg",
  "image/png"
]);
function planProfilePhoto(file) {
  const type = (file.type || "").toLowerCase();
  if (type && !type.startsWith("image/")) {
    return "reject";
  }
  if (DIRECT_TYPES.has(type) && file.size <= PROFILE_PHOTO_MAX_BYTES) {
    return "direct";
  }
  return "downscale";
}
__name(planProfilePhoto, "planProfilePhoto");
function fitWithin(width, height, maxEdge) {
  const longest = Math.max(width, height);
  if (longest <= maxEdge || longest === 0) {
    return {
      width,
      height
    };
  }
  const scale = maxEdge / longest;
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale))
  };
}
__name(fitWithin, "fitWithin");
async function downscaleProfilePhoto(file, maxEdge = PROFILE_PHOTO_MAX_EDGE) {
  const bitmap = await createImageBitmap(file);
  try {
    const { width, height } = fitWithin(bitmap.width, bitmap.height, maxEdge);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("canvas 2d context unavailable");
    }
    ctx.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise((resolve2, reject) => {
      canvas.toBlob((b) => b ? resolve2(b) : reject(new Error("toBlob failed")), "image/jpeg", 0.85);
    });
    return new File([
      blob
    ], "profile.jpg", {
      type: "image/jpeg"
    });
  } finally {
    bitmap.close();
  }
}
__name(downscaleProfilePhoto, "downscaleProfilePhoto");
async function prepareProfilePhoto(file) {
  const plan = planProfilePhoto(file);
  if (plan === "reject") {
    return null;
  }
  if (plan === "direct") {
    return file;
  }
  try {
    const out = await downscaleProfilePhoto(file);
    return out.size <= PROFILE_PHOTO_MAX_BYTES ? out : null;
  } catch {
    return null;
  }
}
__name(prepareProfilePhoto, "prepareProfilePhoto");

// src/components/MyInfoForm.ts
var DAUM_POSTCODE_SRC3 = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
async function signatureFileToDataUri(file, maxWidth = 360, maxHeight = 160) {
  const objectUrl = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve2, reject) => {
      const el2 = new Image();
      el2.onload = () => resolve2(el2);
      el2.onerror = () => reject(new Error("\uC774\uBBF8\uC9C0\uB97C \uC77D\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."));
      el2.src = objectUrl;
    });
    const scale = Math.min(1, maxWidth / img.width, maxHeight / img.height);
    const width = Math.max(1, Math.round(img.width * scale));
    const height = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) {
      throw new Error("\uCE94\uBC84\uC2A4\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
    }
    context.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL("image/png");
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
__name(signatureFileToDataUri, "signatureFileToDataUri");
function myInfoFormComponent() {
  return {
    showMyInfo: false,
    /** 내 정보를 받는 중 — 화면(모달 · 직원 앱 2depth)은 먼저 열리고 본문 자리는 스켈레톤이다(DS skeleton, 2026-10-21). */
    myInfoLoading: false,
    // 더보기 → 서명/도장 · 알림 설정 2depth 페이지(주인 = 이 플래그, 내 정보와 동일 패턴).
    showSignature: false,
    showNotifications: false,
    saving: false,
    editingSection: "",
    photoError: "",
    // 프로필 사진 삭제 확인(커스텀 모달) 표시 상태 — 시스템 confirm 대체
    photoRemoveConfirm: false,
    // 항목(전화/주소/비상연락처/계좌) 내용 삭제 확인 — 열린 섹션명("" = 닫힘)
    fieldClearConfirm: "",
    profilePictureUrl: "",
    // 서명/도장 (결재문서 {{서명}} 자리에 삽입되는 data URI) — 미리보기 + 오류 상태
    signatureUrl: "",
    signatureError: "",
    // hereby 계정(Account) 셀프 업그레이드 상태 — 레거시 직원의 계정 연결
    upgradeLoading: false,
    upgradeMessage: "",
    upgradeError: false,
    myInfo: {
      id: "",
      phone: "",
      address: {
        street: "",
        city: "",
        state: "",
        postalCode: "",
        detail: ""
      },
      emergencyContact: {
        name: "",
        phone: "",
        relationship: ""
      },
      bankAccount: {
        bankName: "",
        accountNumber: "",
        accountHolder: ""
      }
    },
    // 주소 검색(Daum 우편번호) — 내 정보 페이지의 주소 편집 모달에서 사용.
    addrSearchOpen: false,
    daumPostcodePromise: null,
    // Notification settings (알림 정책 2026-06: 설정 진입을 종 아이콘 ⚙️ 탭에서 내 정보로 이동)
    notifPrefs: {},
    muteRules: [],
    notifLoaded: false,
    // 근무시간 (시프트) 자기 선택 — 추론은 추천 배지까지만, 확정은 본인이 직접 선택
    shiftLoaded: false,
    shiftOptions: [],
    currentShiftId: "",
    recommendedShiftId: "",
    selectedShiftId: "",
    shiftSampleCount: 0,
    infoDisplay: {
      employeeNumber: "",
      teamName: "",
      hireDate: "",
      email: "",
      birthDate: ""
    },
    /* ── 내 정보 페이지(admin 설정 탭)용 항목별 편집 모달 상태 ──
    editModal = 열린 섹션(phone/address/emergencyContact/bankAccount/shift/password),
    빈 문자열이면 닫힘. editSnapshot = 열 때의 값 스냅샷(dirty 비교용).
    editCloseConfirm = 변경 후 닫기 시도 시 뜨는 저장 확인 미니모달. */
    editModal: "",
    editSnapshot: "",
    editCloseConfirm: false,
    // 모바일 항상-편집형 내 정보의 dirty 스냅샷(JSON). 로드 시 찍고, 저장 버튼 활성화 판정에 쓴다.
    editBaseline: "",
    init() {
      window.addEventListener("open-my-info", () => this.openMyInfo());
      window.addEventListener("open-signature", () => this.openSignature());
      window.addEventListener("open-notifications", () => this.openNotifications());
      window.addEventListener("load-my-info", () => this.loadInline());
      window.addEventListener("hereby:profile-picture-changed", () => this.refreshProfilePicture());
      document.addEventListener("app-back-button", (e) => {
        if (this.showMyInfo) {
          e.preventDefault();
          this.showMyInfo = false;
        } else if (this.showSignature) {
          e.preventDefault();
          this.showSignature = false;
        } else if (this.showNotifications) {
          e.preventDefault();
          this.showNotifications = false;
        }
      });
    },
    /** 서명/도장 2depth 페이지 — 더보기에서 진입. 서명 이미지를 로드하고 페이지를 연다.
    depth·헤더는 more.html의 x-effect(syncSignaturePage)가 showSignature를 따라간다. */
    openSignature() {
      this.loadSignature();
      this.showSignature = true;
    },
    /** 알림 설정 2depth 페이지 — 더보기에서 진입. 알림 설정을 로드하고 페이지를 연다. */
    openNotifications() {
      this.loadNotificationSettings();
      this.showNotifications = true;
    },
    t(key) {
      return herebyStore(this).t(key) || key;
    },
    /**
    * hereby 계정 연결 인증 메일 요청 (레거시 직원 셀프 업그레이드).
    * 메일 링크의 /invite 페이지에서 비밀번호 설정/확인으로 연결이 완료된다.
    */
    async requestAccountUpgrade() {
      if (this.upgradeLoading) {
        return;
      }
      this.upgradeLoading = true;
      this.upgradeMessage = "";
      this.upgradeError = false;
      try {
        const sdk = herebyStore(this).sdk;
        const result = await sdk.account.requestSelfUpgrade();
        this.upgradeMessage = result.message;
      } catch (e) {
        this.upgradeError = true;
        this.upgradeMessage = e instanceof Error ? e.message : "\uC778\uC99D \uBA54\uC77C \uBC1C\uC1A1\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      } finally {
        this.upgradeLoading = false;
      }
    },
    get currentUser() {
      return herebyStore(this).currentUser || null;
    },
    get displayName() {
      const u = this.currentUser;
      if (!u) {
        return "";
      }
      return `${u.lastName || ""}${u.firstName || ""}`.trim() || u.email || "";
    },
    /** Check if a field section is editable by the employee */
    canEdit(field) {
      const selfEditable = herebyStore(this).currentUser?.selfEditableFields;
      if (!selfEditable || Object.keys(selfEditable).length === 0) {
        return [
          "address",
          "emergencyContact",
          "profilePicture"
        ].includes(field);
      }
      return !!selfEditable[field];
    },
    formatPhone(value) {
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 3) {
        return digits;
      }
      if (digits.length <= 7) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
    },
    formatAddress(addr) {
      if (!addr) {
        return "";
      }
      const parts = [
        addr.street,
        addr.detail,
        addr.city,
        addr.postalCode
      ].filter(Boolean);
      return parts.join(" ");
    },
    async openMyInfo() {
      this.editingSection = "";
      this.photoError = "";
      const sdk = herebyStore(this).sdk;
      const userId = this.currentUser?.id;
      if (!(userId && sdk)) {
        return;
      }
      this.myInfoLoading = true;
      this.showMyInfo = true;
      try {
        const emp = await sdk.employee.getEmployee(userId);
        this._populateFromEmployee(emp);
        this.loadNotificationSettings();
        this.loadShiftSection();
      } catch {
        this.showMyInfo = false;
        showError(this.t("employee.my_info_load_error"));
      } finally {
        this.myInfoLoading = false;
      }
    },
    // ── Notification settings ──
    async loadNotificationSettings() {
      try {
        const sdk = herebyStore(this).sdk;
        if (!sdk) {
          return;
        }
        const [prefs, mutes] = await Promise.all([
          sdk.notification.getSettings(),
          sdk.notification.getMuteList()
        ]);
        this.notifPrefs = prefs ?? {};
        this.muteRules = Array.isArray(mutes) ? mutes : [];
        this.notifLoaded = true;
        sdk.notification.getPushQuietHours().then((r) => {
          this.quietHours = isValidQuietHours(r.quietHours) ? r.quietHours : null;
          if (this.quietHours) {
            this.quietDraft = {
              ...this.quietHours
            };
          }
        }).catch(() => void 0);
        if (herebyStore(this).currentUser?.messengerEncryption === true) {
          sdk.notification.getMessengerPushFormat().then((r) => {
            this.messengerPushFormat = r.format;
          }).catch(() => void 0);
        }
      } catch {
      }
    },
    /**
    * 메신저 푸시 포맷(MED-893, D4) — name_only 기본. name_body(E10)는 서버가 암호문을 실어 보내고 기기가 푼다:
    * 웹(서비스 워커)은 바로, 앱(iOS·Android)은 네이티브 복호가 들어간 앱 버전부터 본문이 보이고 그 전엔 이름만.
    */
    messengerPushFormat: "name_only",
    get messengerPushFormatVisible() {
      return herebyStore(this).currentUser?.messengerEncryption === true;
    },
    async changeMessengerPushFormat(format) {
      const sdk = herebyStore(this).sdk;
      if (!sdk) {
        return;
      }
      const previous = this.messengerPushFormat;
      this.messengerPushFormat = format;
      try {
        await sdk.notification.updateMessengerPushFormat(format);
      } catch {
        this.messengerPushFormat = previous;
        showError(this.t("notification.settings_error"));
      }
    },
    /** Global push channel toggle state (falls back to system default: enabled) */
    get pushEnabled() {
      const globalPrefs = this.notifPrefs["*"];
      if (globalPrefs && "push" in globalPrefs) {
        return globalPrefs.push;
      }
      return true;
    },
    async togglePush() {
      const newValue = !this.pushEnabled;
      const sdk = herebyStore(this).sdk;
      if (!sdk) {
        return;
      }
      if (!this.notifPrefs["*"]) {
        this.notifPrefs["*"] = {};
      }
      this.notifPrefs["*"].push = newValue;
      try {
        await sdk.notification.updateSettings({
          eventType: "*",
          channel: DeliveryChannel.PUSH,
          enabled: newValue
        });
      } catch {
        this.notifPrefs["*"].push = !newValue;
        showError(this.t("notification.settings_error"));
      }
    },
    // ── 종류별 휴대폰 알림 · 방해 금지 시간 (MED-967) ──
    /** 설정 화면에 그리는 종류 — 보내는 곳이 아직 없는 종류(available=false)는 뺀다 */
    get pushCategoryRows() {
      return NOTIFICATION_PUSH_CATEGORIES.filter((c) => c.available);
    },
    /** 「푸시 알림」이나 「전체 알림 받기」가 꺼져 있으면 종류별 스위치는 뜻이 없다 — 흐리게 + 안내 */
    get pushCategoriesBlocked() {
      return !(this.pushEnabled && this.allTypesEnabled);
    },
    /** 이 종류의 휴대폰 알림 — 선호 행(`category:<key>`/push)이 없으면 켜짐 */
    categoryPushEnabled(key) {
      const pref = this.notifPrefs[notificationPushCategoryEventType(key)];
      return !(pref && pref.push === false);
    },
    async toggleCategoryPush(key) {
      const sdk = herebyStore(this).sdk;
      if (!sdk) {
        return;
      }
      const eventType = notificationPushCategoryEventType(key);
      const next = !this.categoryPushEnabled(key);
      this.notifPrefs = {
        ...this.notifPrefs,
        [eventType]: {
          ...this.notifPrefs[eventType] ?? {},
          push: next
        }
      };
      try {
        await sdk.notification.updateSettings({
          eventType,
          channel: DeliveryChannel.PUSH,
          enabled: next
        });
      } catch {
        this.notifPrefs = {
          ...this.notifPrefs,
          [eventType]: {
            ...this.notifPrefs[eventType] ?? {},
            push: !next
          }
        };
        showError(this.t("notification.settings_error"));
      }
    },
    /** 저장된 방해 금지 시간(null = 끔)과, 끈 상태에서도 기억해 두는 입력값 */
    quietHours: null,
    quietDraft: {
      start: "22:00",
      end: "07:00"
    },
    quietSaving: false,
    get quietHoursEnabled() {
      return this.quietHours !== null;
    },
    get quietHoursSummary() {
      return quietHoursLabel(this.quietHours);
    },
    async toggleQuietHours() {
      await this._saveQuietHours(this.quietHoursEnabled ? null : {
        ...this.quietDraft
      });
    },
    /** 시각 입력을 바꿨을 때 — 켜져 있으면 바로 저장, 꺼져 있으면 다음에 켤 값으로만 기억 */
    async changeQuietHours(field, value) {
      this.quietDraft = {
        ...this.quietDraft,
        [field]: value
      };
      if (!this.quietHoursEnabled) {
        return;
      }
      if (!isValidQuietHours(this.quietDraft)) {
        showError("\uC2DC\uC791\uACFC \uB05D \uC2DC\uAC01\uC744 \uB2E4\uB974\uAC8C \uACE8\uB77C \uC8FC\uC138\uC694.");
        this.quietDraft = {
          ...this.quietHours
        };
        return;
      }
      await this._saveQuietHours({
        ...this.quietDraft
      });
    },
    async _saveQuietHours(next) {
      const sdk = herebyStore(this).sdk;
      if (!sdk || this.quietSaving) {
        return;
      }
      if (next && !isValidQuietHours(next)) {
        showError("\uC2DC\uC791\uACFC \uB05D \uC2DC\uAC01\uC744 \uB2E4\uB974\uAC8C \uACE8\uB77C \uC8FC\uC138\uC694.");
        return;
      }
      const previous = this.quietHours;
      this.quietHours = next;
      this.quietSaving = true;
      try {
        await sdk.notification.updatePushQuietHours(next);
      } catch {
        this.quietHours = previous;
        showError(this.t("notification.settings_error"));
      } finally {
        this.quietSaving = false;
      }
    },
    /** Unified notification toggle — on while no "mute everything" rule exists */
    get allTypesEnabled() {
      return !this.muteRules.some((r) => r.muteType === "all");
    },
    /** Toggle all notification types at once (유형별 알림 통합 토글) */
    async toggleAllTypes() {
      const store = herebyStore(this);
      const sdk = store?.sdk;
      if (!sdk) {
        return;
      }
      try {
        if (this.allTypesEnabled) {
          const orgId = store.currentUser?.organizationId;
          if (!orgId) {
            showAlert(this.t("notification.org_not_found"));
            return;
          }
          await sdk.notification.mute({
            organizationId: orgId,
            muteType: NotificationMuteType.ALL
          });
        } else {
          const rules = this.muteRules.filter(
            // biome-ignore lint/suspicious/noExplicitAny: mute rule shape
            (r) => r.muteType === "all" || r.muteType === "event_type"
          );
          for (const rule of rules) {
            await sdk.notification.unmute(rule.id);
          }
        }
        await this.loadNotificationSettings();
      } catch (e) {
        const err = e;
        showError(err?.message || this.t("notification.settings_error"));
      }
    },
    // ── 근무시간 (시프트) 자기 선택 ──
    async loadShiftSection() {
      try {
        const sdk = herebyStore(this).sdk;
        if (!sdk?.shift?.recommendForMe) {
          return;
        }
        const rec = await sdk.shift.recommendForMe();
        this.shiftOptions = Array.isArray(rec?.shifts) ? rec.shifts : [];
        this.currentShiftId = rec?.currentShiftId || "";
        this.recommendedShiftId = rec?.recommendedShiftId || "";
        this.shiftSampleCount = rec?.sampleCount || 0;
        this.selectedShiftId = this.currentShiftId || this.recommendedShiftId || "";
        this.shiftLoaded = true;
        this.syncShiftBaseline();
      } catch {
      }
    },
    // biome-ignore lint/suspicious/noExplicitAny: option shape from API
    shiftLabel(s) {
      const hm = /* @__PURE__ */ __name((v) => (v || "").slice(0, 5), "hm");
      const range = s.startTime && s.endTime ? ` (${hm(s.startTime)}\u2013${hm(s.endTime)})` : "";
      return `${s.name}${range}`;
    },
    get currentShiftLabel() {
      const s = this.shiftOptions.find((o) => o.id === this.currentShiftId);
      return s ? this.shiftLabel(s) : "";
    },
    /** 추천이 현재 설정과 다를 때만 확인 안내를 띄운다 */
    get shiftMismatch() {
      return Boolean(this.shiftLoaded && this.shiftSampleCount > 0 && this.recommendedShiftId && this.recommendedShiftId !== this.currentShiftId);
    },
    /* ── 모바일 내 정보(항상-편집형)용 dirty 추적 ──
    편집 가능한 값(전화·주소·비상연락처·계좌·근무시간)의 스냅샷과 비교해, 실제로 바뀐 게
    있을 때만 저장 버튼을 활성화한다. 데스크톱 섹션형 편집의 isEditDirty(editModal 기준)와는
    별개 경로다. 스냅샷은 로드 완료 시점(_populateFromEmployee·loadShiftSection)에 찍는다. */
    _editableValues() {
      return {
        phone: this.myInfo.phone,
        address: this.myInfo.address,
        emergencyContact: this.myInfo.emergencyContact,
        bankAccount: this.myInfo.bankAccount,
        selectedShiftId: this.selectedShiftId
      };
    },
    captureEditBaseline() {
      this.editBaseline = JSON.stringify(this._editableValues());
    },
    /** 스냅샷의 근무 칸만 현재 값으로 — 스냅샷이 없으면(아직 로드 전) 새로 찍는다 */
    syncShiftBaseline() {
      if (!this.editBaseline) {
        this.captureEditBaseline();
        return;
      }
      const base = JSON.parse(this.editBaseline);
      base.selectedShiftId = this.selectedShiftId;
      this.editBaseline = JSON.stringify(base);
    },
    /** 우편번호가 적혀 있으면 숫자 5자리여야 한다(서버 스키마) — 비어 있으면 통과 */
    _postalCodeValid() {
      const pc = this.myInfo.address.postalCode;
      return !pc || /^\d{5}$/.test(pc);
    },
    /** 서버에 저장된 키로 미리보기를 다시 받는다(캐시 무시) */
    async refreshProfilePicture() {
      const store = herebyStore(this);
      const key = store.currentUser?.profilePicture || "";
      if (!key) {
        this.profilePictureUrl = "";
        return;
      }
      try {
        store._fileUrlCache?.delete(key);
        this.profilePictureUrl = await store.getFileUrl(key);
      } catch {
      }
    },
    /** 섹션 값이 로드 시점 스냅샷과 다른지. 스냅샷이 없으면(로드 전) 바뀐 것으로 본다. */
    _sectionChanged(section) {
      if (!this.editBaseline) {
        return true;
      }
      const base = JSON.parse(this.editBaseline);
      return JSON.stringify(base[section]) !== JSON.stringify(this.myInfo[section]);
    },
    /**
    * 섹션 값을 updateEmployee 입력으로 직렬화한다 (saveSection·saveAll 공용).
    * 빈 문자열은 서버 스키마(우편번호 5자리 regex, 관계 문자열)에 걸리므로 빼고,
    * 섹션 자체가 비어 있으면 null로 보내 컬럼을 지운다.
    */
    _serializeSection(section) {
      if (section === "phone") {
        return this.myInfo.phone || void 0;
      }
      if (section === "address") {
        const a = this.myInfo.address;
        if (!(a.street || a.city)) {
          return null;
        }
        return {
          ...a,
          postalCode: a.postalCode || void 0,
          detail: a.detail || void 0
        };
      }
      if (section === "emergencyContact") {
        const ec = this.myInfo.emergencyContact;
        if (!(ec.name && ec.phone)) {
          return null;
        }
        return {
          ...ec,
          relationship: ec.relationship || void 0
        };
      }
      const ba = this.myInfo.bankAccount;
      return ba.bankName && ba.accountNumber && ba.accountHolder ? {
        ...ba
      } : null;
    },
    get isDirty() {
      return this.editBaseline !== "" && JSON.stringify(this._editableValues()) !== this.editBaseline;
    },
    startEditShift() {
      this.editingSection = "shift";
      this.$nextTick(() => {
        this.selectedShiftId = this.currentShiftId || this.recommendedShiftId || "";
      });
    },
    async saveShift() {
      if (!this.selectedShiftId || this.saving) {
        return;
      }
      this.saving = true;
      try {
        const sdk = herebyStore(this).sdk;
        await sdk.shift.setMyShift(this.selectedShiftId);
        this.currentShiftId = this.selectedShiftId;
        this.editingSection = "";
      } catch {
        showError(this.t("employee.save_error"));
      } finally {
        this.saving = false;
      }
    },
    /** Muted people from mute rules (set via bell hover → "이 사람 알림 끄기") */
    get mutedPeople() {
      return this.muteRules.filter((r) => r.muteType === "employee");
    },
    async removeMuteRule(id) {
      try {
        const sdk = herebyStore(this).sdk;
        await sdk.notification.unmute(id);
        this.muteRules = this.muteRules.filter((r) => r.id !== id);
      } catch {
      }
    },
    async reloadMyInfo() {
      const sdk = herebyStore(this).sdk;
      const userId = this.currentUser?.id;
      if (!(userId && sdk)) {
        return;
      }
      try {
        const emp = await sdk.employee.getEmployee(userId);
        this._populateFromEmployee(emp);
      } catch {
      }
    },
    // ── 내 정보 페이지(인라인) 로드 ──
    /** Load the current user's employee record + shift options without opening
    the modal — used when 내 정보 is rendered as a settings page (admin).
    Notification settings are intentionally NOT loaded here: they live in the
    조직 설정 탭 as an independent section. */
    async loadInline() {
      this.editModal = "";
      this.editCloseConfirm = false;
      const sdk = herebyStore(this).sdk;
      const userId = this.currentUser?.id;
      if (!(userId && sdk)) {
        return;
      }
      try {
        const emp = await sdk.employee.getEmployee(userId);
        this._populateFromEmployee(emp);
        this.loadShiftSection();
      } catch {
      }
    },
    // ── 항목별 편집 모달 (내 정보 페이지) ──
    // biome-ignore lint/suspicious/noExplicitAny: section value is a mixed shape
    _sectionValue(section) {
      if (section === "phone") {
        return this.myInfo.phone;
      }
      if (section === "address") {
        return this.myInfo.address;
      }
      if (section === "emergencyContact") {
        return this.myInfo.emergencyContact;
      }
      if (section === "bankAccount") {
        return this.myInfo.bankAccount;
      }
      if (section === "shift") {
        return this.selectedShiftId;
      }
      return null;
    },
    openEditModal(section) {
      this.editModal = section;
      this.editCloseConfirm = false;
      this.addrSearchOpen = false;
      if (section === "shift") {
        this.selectedShiftId = this.currentShiftId || this.recommendedShiftId || "";
      }
      this.editSnapshot = JSON.stringify(this._sectionValue(section));
    },
    get editModalDirty() {
      if (!this.editModal) {
        return false;
      }
      return JSON.stringify(this._sectionValue(this.editModal)) !== this.editSnapshot;
    },
    /** X / 취소 / ESC → close, but guard unsaved edits with a save-confirm popup. */
    attemptCloseEdit() {
      if (this.editCloseConfirm) {
        return;
      }
      if (this.editModalDirty) {
        this.editCloseConfirm = true;
        return;
      }
      this.closeEditModal();
    },
    /** Discard edits and close (re-fetch restores the pristine values). */
    async closeEditModal() {
      const wasSection = this.editModal;
      this.editModal = "";
      this.editCloseConfirm = false;
      this.addrSearchOpen = false;
      if (wasSection && wasSection !== "shift" && wasSection !== "password") {
        await this.reloadMyInfo();
      }
    },
    confirmCloseEdit() {
      this.closeEditModal();
    },
    dismissCloseEdit() {
      this.editCloseConfirm = false;
    },
    /** Save the open section's edit modal; close only when the write succeeds. */
    async saveEditModal() {
      const section = this.editModal;
      if (!section) {
        return;
      }
      if (section === "shift") {
        await this.saveShift();
        if (this.currentShiftId === this.selectedShiftId) {
          this.editModal = "";
          this.editCloseConfirm = false;
        }
        return;
      }
      const ok = await this.saveSection(section);
      if (ok) {
        this.editModal = "";
        this.editCloseConfirm = false;
      }
    },
    // ── 주소 검색 (Daum 우편번호) — 직원 추가 패널과 동일 방식 ──
    /** Daum 우편번호 서비스 스크립트를 lazy 로드한다(키 불필요·프론트 전용). */
    _loadDaumPostcode() {
      if (window.daum?.Postcode) {
        return Promise.resolve(window.daum);
      }
      if (!this.daumPostcodePromise) {
        this.daumPostcodePromise = new Promise((resolve2, reject) => {
          const script = document.createElement("script");
          script.src = DAUM_POSTCODE_SRC3;
          script.onload = () => {
            if (window.daum?.Postcode) {
              resolve2(window.daum);
            } else {
              this.daumPostcodePromise = null;
              reject(new Error("\uC8FC\uC18C \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC5B4\uC694."));
            }
          };
          script.onerror = () => {
            this.daumPostcodePromise = null;
            reject(new Error("\uC8FC\uC18C \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB124\uD2B8\uC6CC\uD06C\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694."));
          };
          document.head.appendChild(script);
        });
      }
      return this.daumPostcodePromise;
    },
    /** '검색' 클릭 — --top 모달을 열고 컨테이너에 주소 검색(도로명·지번 리스트)을 마운트. */
    async openAddrSearch() {
      this.addrSearchOpen = true;
      try {
        const daum = await this._loadDaumPostcode();
        if (!this.addrSearchOpen) {
          return;
        }
        const box = document.getElementById("myInfoAddrEmbed");
        if (!box) {
          return;
        }
        box.innerHTML = "";
        new daum.Postcode({
          oncomplete: /* @__PURE__ */ __name((data) => this.applyAddrSelection(data), "oncomplete"),
          width: "100%",
          height: "100%"
        }).embed(box);
      } catch (err) {
        this.addrSearchOpen = false;
        showError(err instanceof Error ? err.message : String(err));
      }
    },
    closeAddrSearch() {
      this.addrSearchOpen = false;
    },
    /** 주소 리스트 선택 — 표기(도로명/지번)를 street, 우편번호를 postalCode에 채우고
    상세주소는 비워 이어서 입력하게 한다. city/state는 Daum이 주지 않으므로 비운다. */
    applyAddrSelection(data) {
      const road = data.roadAddress || "";
      const jibun = data.jibunAddress || "";
      this.myInfo.address.street = data.userSelectedType === "J" ? jibun || road : road || jibun;
      this.myInfo.address.postalCode = data.zonecode || "";
      this.myInfo.address.city = "";
      this.myInfo.address.state = "";
      this.myInfo.address.detail = "";
      this.addrSearchOpen = false;
      setTimeout(() => document.getElementById("myInfoAddrDetail")?.focus(), 0);
    },
    /** 주소 선택 해제 — 잘못 선택했을 때 비울 수 있어야 한다. */
    clearAddress() {
      this.myInfo.address.street = "";
      this.myInfo.address.postalCode = "";
      this.myInfo.address.detail = "";
    },
    // biome-ignore lint/suspicious/noExplicitAny: API response shape
    _populateFromEmployee(emp) {
      this.myInfo.id = emp.id;
      this.myInfo.phone = this.formatPhone(emp.phone || "");
      this.myInfo.address = {
        street: emp.address?.street || "",
        city: emp.address?.city || "",
        state: emp.address?.state || "",
        postalCode: emp.address?.postalCode || "",
        detail: emp.address?.detail || ""
      };
      this.myInfo.emergencyContact = {
        name: emp.emergencyContact?.name || "",
        phone: this.formatPhone(emp.emergencyContact?.phone || ""),
        relationship: emp.emergencyContact?.relationship || ""
      };
      this.myInfo.bankAccount = {
        bankName: emp.bankAccount?.bankName || "",
        accountNumber: emp.bankAccount?.accountNumber || "",
        accountHolder: emp.bankAccount?.accountHolder || ""
      };
      if (emp.profilePicture) {
        const store = herebyStore(this);
        if (store?.getFileUrl) {
          store.getFileUrl(emp.profilePicture).then((url) => {
            this.profilePictureUrl = url;
          }).catch(() => {
          });
        } else {
          this.profilePictureUrl = emp.profilePicture;
        }
      } else {
        this.profilePictureUrl = "";
      }
      this.loadSignature();
      const teamNames = emp.teams ? emp.teams.map((t) => [
        t.name,
        t.roleName || t.role
      ].filter(Boolean).join(" / ")).filter(Boolean) : emp.teamNames || [];
      this.infoDisplay = {
        employeeNumber: emp.employeeNumber || "",
        teamName: teamNames.join(" / ") || "-",
        hireDate: emp.hireDate ? herebyStore(this).formatDate(new Date(emp.hireDate)) : "",
        email: emp.email || "",
        birthDate: emp.birthDate ? herebyStore(this).formatDate(new Date(emp.birthDate)) : ""
      };
      this.captureEditBaseline();
    },
    /** Save one section. Returns true on success so modal/inline hosts can close
    only when the write actually landed (false = validation or network fail). */
    async saveSection(section) {
      if (this.saving) {
        return false;
      }
      if (section === "phone" && this.myInfo.phone) {
        const digits = this.myInfo.phone.replace(/\D/g, "");
        if (digits.length < 10 || digits.length > 11) {
          showAlert(this.t("employee.phone_invalid"));
          return false;
        }
      }
      if (section === "address" && !this._postalCodeValid()) {
        showAlert(this.t("employee.postal_code_invalid"));
        return false;
      }
      if (section === "emergencyContact") {
        const ec = this.myInfo.emergencyContact;
        if (ec.name || ec.phone || ec.relationship) {
          if (!ec.name) {
            showAlert(this.t("employee.emergency_name_required"));
            return false;
          }
          if (!ec.phone) {
            showAlert(this.t("employee.emergency_phone_required"));
            return false;
          }
        }
      }
      if (section === "bankAccount") {
        const ba = this.myInfo.bankAccount;
        if (ba.bankName || ba.accountNumber || ba.accountHolder) {
          if (!(ba.bankName && ba.accountNumber && ba.accountHolder)) {
            showAlert(this.t("employee.bank_all_required"));
            return false;
          }
        }
      }
      this.saving = true;
      let ok = false;
      try {
        const sdk = herebyStore(this).sdk;
        const params = {
          id: this.myInfo.id
        };
        if (section === "phone" || section === "address" || section === "emergencyContact" || section === "bankAccount") {
          params[section] = this._serializeSection(section);
        }
        await sdk.employee.updateEmployee(params);
        this.editingSection = "";
        ok = true;
      } catch {
        showError(this.t("employee.save_error"));
      } finally {
        this.saving = false;
      }
      return ok;
    },
    // ── 항목 내용 삭제 (편집 버튼 옆 휴지통) — 시스템 confirm 대신 커스텀 모달로 확인 ──
    /** 삭제 확인 모달 열기. section: phone/address/emergencyContact/bankAccount. */
    attemptClearSection(section) {
      this.fieldClearConfirm = section;
    },
    cancelClearSection() {
      this.fieldClearConfirm = "";
    },
    /** 해당 항목의 기존 내용을 비우고 저장한다(saveSection이 빈 값이면 null/undefined로 전송).
    저장 실패 시 표시값을 서버 값으로 되돌린다. */
    async clearSection(section) {
      this.fieldClearConfirm = "";
      if (section === "phone") {
        this.myInfo.phone = "";
      } else if (section === "address") {
        this.myInfo.address.street = "";
        this.myInfo.address.city = "";
        this.myInfo.address.state = "";
        this.myInfo.address.postalCode = "";
        this.myInfo.address.detail = "";
      } else if (section === "emergencyContact") {
        this.myInfo.emergencyContact.name = "";
        this.myInfo.emergencyContact.phone = "";
        this.myInfo.emergencyContact.relationship = "";
      } else if (section === "bankAccount") {
        this.myInfo.bankAccount.bankName = "";
        this.myInfo.bankAccount.accountNumber = "";
        this.myInfo.bankAccount.accountHolder = "";
      } else {
        return;
      }
      const ok = await this.saveSection(section);
      if (!ok) {
        await this.reloadMyInfo();
      }
    },
    /**
    * 항상-편집형 레이아웃(employee-app 풀페이지 모달)용 일괄 저장.
    * 편집 가능한 섹션을 saveSection과 동일한 검증/직렬화로 모아 한 번에 PATCH한다.
    * 근무시간이 바뀌었으면 함께 저장. 섹션형 UI에는 영향 없음.
    */
    async saveAll() {
      if (this.saving) {
        return;
      }
      if (this.canEdit("phone") && this.myInfo.phone) {
        const digits = this.myInfo.phone.replace(/\D/g, "");
        if (digits.length < 10 || digits.length > 11) {
          showAlert(this.t("employee.phone_invalid"));
          return;
        }
      }
      if (this.canEdit("address") && !this._postalCodeValid()) {
        showAlert(this.t("employee.postal_code_invalid"));
        return;
      }
      if (this.canEdit("emergencyContact")) {
        const ec = this.myInfo.emergencyContact;
        if (ec.name || ec.phone || ec.relationship) {
          if (!ec.name) {
            showAlert(this.t("employee.emergency_name_required"));
            return;
          }
          if (!ec.phone) {
            showAlert(this.t("employee.emergency_phone_required"));
            return;
          }
        }
      }
      if (this.canEdit("bankAccount")) {
        const ba = this.myInfo.bankAccount;
        if (ba.bankName || ba.accountNumber || ba.accountHolder) {
          if (!(ba.bankName && ba.accountNumber && ba.accountHolder)) {
            showAlert(this.t("employee.bank_all_required"));
            return;
          }
        }
      }
      this.saving = true;
      try {
        const sdk = herebyStore(this).sdk;
        const params = {
          id: this.myInfo.id
        };
        let hasEmployeeChanges = false;
        for (const section of [
          "phone",
          "address",
          "emergencyContact",
          "bankAccount"
        ]) {
          if (this.canEdit(section) && this._sectionChanged(section)) {
            params[section] = this._serializeSection(section);
            hasEmployeeChanges = true;
          }
        }
        if (hasEmployeeChanges) {
          await sdk.employee.updateEmployee(params);
        }
        if (this.selectedShiftId && this.selectedShiftId !== this.currentShiftId) {
          await sdk.shift.setMyShift(this.selectedShiftId);
          this.currentShiftId = this.selectedShiftId;
        }
        this.editingSection = "";
        this.showMyInfo = false;
      } catch {
        showError(this.t("employee.save_error"));
      } finally {
        this.saving = false;
      }
    },
    async uploadPhoto(event) {
      const input = event.target;
      const file = input.files?.[0];
      if (!file) {
        return;
      }
      this.photoError = "";
      const photo = await prepareProfilePhoto(file);
      if (!photo) {
        this.photoError = "\uC0AC\uC9C4 \uD30C\uC77C(jpg \xB7 png \xB7 webp)\uB9CC \uC62C\uB9B4 \uC218 \uC788\uC5B4\uC694. \uB2E4\uB978 \uC0AC\uC9C4\uC73C\uB85C \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
        input.value = "";
        return;
      }
      try {
        const sdk = herebyStore(this).sdk;
        const { url, key } = await sdk.fileStorage.getUploadUrl(`profile-pictures/${this.myInfo.id}.jpg`, photo.type, "profile");
        const uploaded = await fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": photo.type
          },
          body: photo
        });
        if (!uploaded.ok) {
          throw new Error(`upload failed: ${uploaded.status}`);
        }
        await sdk.employee.confirmProfilePicture({
          key
        });
        this.profilePictureUrl = URL.createObjectURL(photo);
        const store = herebyStore(this);
        if (store.currentUser) {
          store.currentUser.profilePicture = key;
        }
        await store.refreshProfilePictureUrl();
      } catch {
        this.photoError = "\uD30C\uC77C \uC5C5\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      } finally {
        input.value = "";
      }
    },
    /** 삭제 확인(커스텀 모달) 열기 — 사진이 있을 때만. 시스템 confirm 대신 사용. */
    attemptRemovePhoto() {
      if (!this.profilePictureUrl) {
        return;
      }
      this.photoRemoveConfirm = true;
    },
    /** 삭제 확인 모달 닫기(취소). */
    cancelRemovePhoto() {
      this.photoRemoveConfirm = false;
    },
    /** 프로필 사진 초기화 — 저장된 사진을 지우고 이니셜 아바타로 되돌린다.
    서버에서 컬럼/파일을 지운 뒤 로컬 미리보기와 헤더 아바타(스토어)를 함께 동기화.
    확인은 커스텀 모달(photoRemoveConfirm)에서 이뤄지므로 여기서는 바로 실행한다. */
    async removeProfilePicture() {
      this.photoRemoveConfirm = false;
      if (!this.profilePictureUrl) {
        return;
      }
      this.photoError = "";
      try {
        const store = herebyStore(this);
        await store.sdk.employee.removeProfilePicture();
        this.profilePictureUrl = "";
        if (store.currentUser) {
          store.currentUser.profilePicture = "";
        }
        await store.refreshProfilePictureUrl();
      } catch {
        this.photoError = "\uD504\uB85C\uD544 \uC0AC\uC9C4 \uC0AD\uC81C\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      }
    },
    /** 본인 서명/도장 이미지 로드 — 내 정보 열 때 미리보기 채움. 실패는 조용히 무시. */
    async loadSignature() {
      try {
        const sdk = herebyStore(this).sdk;
        const result = await sdk.employee.mySignature();
        this.signatureUrl = result?.signatureImage || "";
      } catch {
        this.signatureUrl = "";
      }
    },
    /** 서명/도장 등록/변경 — 파일을 캔버스로 축소한 PNG data URI로 저장 (서버 크기 제한 준수). */
    async uploadSignature(event) {
      const input = event.target;
      const file = input.files?.[0];
      if (!file) {
        return;
      }
      this.signatureError = "";
      if (!/^image\/(png|jpeg|webp)$/.test(file.type)) {
        this.signatureError = "PNG/JPG/WebP \uC774\uBBF8\uC9C0\uB9CC \uB4F1\uB85D\uD560 \uC218 \uC788\uC5B4\uC694.";
        input.value = "";
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.signatureError = "5MB \uC774\uC0C1\uC758 \uD30C\uC77C\uC740 \uC5C5\uB85C\uB4DC\uD560 \uC218 \uC5C6\uC5B4\uC694.";
        input.value = "";
        return;
      }
      try {
        const dataUri = await signatureFileToDataUri(file);
        await herebyStore(this).sdk.employee.setMySignature(dataUri);
        this.signatureUrl = dataUri;
      } catch {
        this.signatureError = "\uC11C\uBA85 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      } finally {
        input.value = "";
      }
    },
    /** 서명/도장 삭제 — 결재문서 서명란은 다시 빈칸/(인)으로 출력된다.
    *  `confirm: true` 면 지우기 전에 컨펌 다이얼로그로 한 번 묻는다(admin 내 정보). */
    async removeSignature(opts = {}) {
      if (!this.signatureUrl) {
        return;
      }
      if (opts.confirm && // 병동 삭제와 같은 형태 — 「…삭제할까요?」 + 되돌릴 수 없다는 줄(굵게). 앱 문구는 해요체(「없습니다」 X)
      !await askConfirm({
        message: "\uC11C\uBA85/\uB3C4\uC7A5 \uC774\uBBF8\uC9C0\uB97C \uC0AD\uC81C\uD560\uAE4C\uC694?\n\uC0AD\uC81C\uD558\uBA74 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC5B4\uC694.",
        emphasis: "\uC0AD\uC81C\uD558\uBA74 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC5B4\uC694.",
        confirmLabel: "\uC0AD\uC81C",
        tone: "danger"
      })) {
        return;
      }
      this.signatureError = "";
      try {
        await herebyStore(this).sdk.employee.setMySignature(null);
        this.signatureUrl = "";
      } catch {
        this.signatureError = "\uC11C\uBA85 \uC0AD\uC81C\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      }
    }
  };
}
__name(myInfoFormComponent, "myInfoFormComponent");

// src/components/NotificationBell.ts
import { resolveNotificationAppLabel, resolveNotificationTarget } from "@hereby/core/constants";
import { formatDateTime as formatDateTime2 } from "@hereby/core/date";
import { NotificationMuteType as NotificationMuteType2 } from "@hereby/core/enums";
var NOTIFICATION_RECEIVED_EVENT = "notification-received";
function notificationBellComponent(opts = {}) {
  return {
    open: false,
    unreadCount: 0,
    notifications: [],
    isLoading: false,
    pollTimer: null,
    // 앱이 다른 화면(모바일 2depth 인박스 등)에서 알림을 읽었을 때 이 벨의 미읽음 카운트를
    // 함께 줄이기 위한 window 이벤트 핸들러. 이 벨의 드롭다운을 안 쓰는 모바일에서 필수.
    onExternalRead: null,
    // 같은 이유의 「모두 읽음」 판 — 모바일 2depth 화면의 일괄 읽음은 서버 인박스 전체를
    // 읽음 처리하므로 1씩 빼는 대신 카운트를 0으로 맞춘다.
    onExternalReadAll: null,
    // 실시간 새 알림(NOTIFICATION_RECEIVED_EVENT) — 미읽음 +1 · 목록 맨 앞에 끼우기
    onExternalReceived: null,
    // 공용 ESC 층 등록 해제 함수 — 열린 드롭다운을 ESC 로 닫는다(화면에서 가장 위 하나만 닫히는 규칙을 따른다)
    offEsc: null,
    async init() {
      if (!this.offEsc && this.$el) {
        const root = this.$el;
        this.offEsc = registerEscLayer(() => this.open ? root.querySelector("[data-ds-esc-panel]") : null, () => this.close());
      }
      this.onExternalRead = () => {
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      };
      window.addEventListener("notification-read", this.onExternalRead);
      this.onExternalReadAll = () => {
        this.unreadCount = 0;
        for (const n of this.notifications) {
          n.isRead = true;
        }
      };
      window.addEventListener("notification-read-all", this.onExternalReadAll);
      if (!this.onExternalReceived) {
        this.onExternalReceived = (e) => {
          const item = e.detail;
          const id = typeof item?.id === "string" ? item.id : "";
          if (id && this.notifications.some((n) => n.id === id)) {
            return;
          }
          this.unreadCount += 1;
          if (item && id) {
            this.notifications = [
              {
                ...item,
                isRead: false
              },
              ...this.notifications
            ];
          }
        };
        window.addEventListener(NOTIFICATION_RECEIVED_EVENT, this.onExternalReceived);
      }
      const store = herebyStore(this);
      if (!store?.authenticated) {
        return;
      }
      await this.refresh();
      const interval = opts.pollInterval ?? 6e4;
      this.pollTimer = setInterval(() => this.refreshCount(), interval);
    },
    destroy() {
      this.offEsc?.();
      this.offEsc = null;
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      if (this.onExternalRead) {
        window.removeEventListener("notification-read", this.onExternalRead);
        this.onExternalRead = null;
      }
      if (this.onExternalReadAll) {
        window.removeEventListener("notification-read-all", this.onExternalReadAll);
        this.onExternalReadAll = null;
      }
      if (this.onExternalReceived) {
        window.removeEventListener(NOTIFICATION_RECEIVED_EVENT, this.onExternalReceived);
        this.onExternalReceived = null;
      }
    },
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.refresh();
      }
    },
    close() {
      this.open = false;
    },
    // ── Data loading ──
    async refresh() {
      if (!herebyStore(this).authenticated) {
        return;
      }
      this.isLoading = true;
      try {
        const sdk = herebyStore(this).sdk;
        const [countResult, inboxResult] = await Promise.all([
          sdk.notification.getUnreadCount(),
          sdk.notification.getInbox({
            limit: 20
          })
        ]);
        this.unreadCount = countResult ?? 0;
        this.notifications = inboxResult?.items ?? inboxResult ?? [];
      } catch {
      } finally {
        this.isLoading = false;
      }
    },
    async refreshCount() {
      if (!herebyStore(this).authenticated) {
        return;
      }
      try {
        const sdk = herebyStore(this).sdk;
        this.unreadCount = await sdk.notification.getUnreadCount() ?? 0;
      } catch {
      }
    },
    // ── Notification actions ──
    /** 알림 클릭 — 읽음 처리 + 해당 화면으로 이동, 못 가면 어디서 보는지 안내.
    *
    *  목적지 표는 `@hereby/core/constants`의 resolveNotificationTarget 하나뿐이다
    *  (직원 앱 알림 목록·서버 푸시 payload와 같은 표를 쓴다).
    *
    *  `navigate-section`은 **그 이벤트를 듣는 앱(직원 앱)에서만** 이동이 된다.
    *  듣는 쪽이 없으면 이벤트가 그냥 사라지므로, 이동이 성사됐는지는 이벤트를
    *  cancelable로 쏘고 소비자가 preventDefault 했는지로 판단한다. 아무도 안
    *  받았고 안내할 앱 이름이 있으면 "{앱이름}에서 확인해 주세요"를 띄운다 —
    *  눌러도 아무 일이 없으면 고장으로 읽힌다. */
    // biome-ignore lint/suspicious/noExplicitAny: notification item shape
    async openNotification(notif) {
      if (!notif.isRead) {
        await this.markRead(notif.id);
      }
      if (notif.referenceType) {
        const handled = !window.dispatchEvent(new CustomEvent("navigate-reference", {
          detail: {
            referenceType: notif.referenceType,
            referenceId: notif.referenceId,
            type: notif.type
          },
          cancelable: true
        }));
        if (handled) {
          this.close();
          return;
        }
      }
      const target = resolveNotificationTarget(notif);
      if (target?.section === "csReport") {
        this.close();
        window.dispatchEvent(new CustomEvent("hereby:cs-report-open", {
          detail: {
            view: "history",
            reportId: target.csReportId
          }
        }));
        return;
      }
      if (target) {
        this.close();
        const consumed = !window.dispatchEvent(new CustomEvent("navigate-section", {
          detail: {
            ...target,
            type: notif.type
          },
          cancelable: true
        }));
        if (consumed) {
          return;
        }
      }
      const appLabel = resolveNotificationAppLabel(notif);
      if (appLabel) {
        this.close();
        showAlert({
          message: `${appLabel}\uC5D0\uC11C \uD655\uC778\uD574 \uC8FC\uC138\uC694.`,
          emphasis: appLabel
        });
      }
    },
    async markRead(id) {
      try {
        const sdk = herebyStore(this).sdk;
        await sdk.notification.markRead(id);
        const notif = this.notifications.find((n) => n.id === id);
        if (notif) {
          notif.isRead = true;
        }
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      } catch {
      }
    },
    async markAllRead() {
      try {
        const sdk = herebyStore(this).sdk;
        await sdk.notification.markAllRead();
        for (const n of this.notifications) {
          n.isRead = true;
        }
        this.unreadCount = 0;
      } catch {
      }
    },
    // ── Mute actions (contextual) ──
    /** Mute notifications from a specific person (called from notification item hover) */
    async muteActor(actorId, actorName) {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      const displayName = actorName || actorId;
      if (!await askConfirm(`${displayName}${t("notification.mute_confirm")}`)) {
        return;
      }
      try {
        const store = herebyStore(this);
        const sdk = store.sdk;
        const orgId = store.currentUser?.organizationId;
        if (!orgId) {
          showAlert(t("notification.org_not_found"));
          return;
        }
        await sdk.notification.mute({
          organizationId: orgId,
          muteType: NotificationMuteType2.EMPLOYEE,
          muteTargetId: actorId
        });
        this.notifications = this.notifications.filter((n) => n.actorId !== actorId);
        showAlert(`${displayName}${t("notification.muted_success")}`);
      } catch (e) {
        const err = e;
        showError(err?.message || t("notification.mute_error"));
      }
    },
    /** 알림 시각 — 화면 공통 표기 「2026.10.13. 14:30」 (조직 시간대 · 24시간제 · 초 없음) */
    formatTimestamp(dateStr) {
      const store = herebyStore(this);
      const tz = store?.timezone ?? "Asia/Seoul";
      try {
        const d = new Date(dateStr);
        if (Number.isNaN(d.getTime())) {
          return dateStr;
        }
        return formatDateTime2(d, "ko-KR", tz);
      } catch {
        return dateStr;
      }
    }
  };
}
__name(notificationBellComponent, "notificationBellComponent");

// src/components/PageHeader.ts
function pageHeaderComponent(opts) {
  const staticShowTeamFilter = opts.showTeamFilter === true;
  const showRefresh = opts.showRefresh === true;
  const showNotification = opts.showNotification !== false;
  const showProfile = opts.showProfile === true;
  const showReport = opts.showReport !== false;
  const onLogoutCb = opts.onLogout;
  const onMyInfoCb = opts.onMyInfo;
  const onOrgInfoCb = opts.onOrgInfo;
  const onSecurityCb = opts.onSecurity;
  const onSwitchWorkspaceCb = opts.onSwitchWorkspace;
  const getTitleFn = opts.getTitle;
  const staticTitle = opts.title ?? "";
  const getIconFn = opts.getIcon;
  const staticIcon = opts.icon ?? "";
  const getShowTeamFilterFn = opts.getShowTeamFilter;
  const getTeams = opts.getTeams;
  const getSelectedTeamId = opts.getSelectedTeamId;
  const onTeamChangeCb = opts.onTeamChange;
  const onRefreshCb = opts.onRefresh;
  const getRefreshLoadingFn = opts.getRefreshLoading;
  const staticShowBack = opts.showBack === true;
  const getShowBackFn = opts.getShowBack;
  const onBackCb = opts.onBack;
  return {
    showRefresh,
    showNotification,
    showReport,
    /** 리포트 호스트가 이 페이지에 실제로 떠 있을 때만 버튼을 보인다 —
    include 를 빠뜨린 앱에서 눌러도 아무 일 없는 죽은 버튼을 막는다 */
    get reportAvailable() {
      return this.showReport && typeof document !== "undefined" && !!document.querySelector("[data-cs-report-host]");
    },
    /** 상시 진입 (§4.1 B) — 오류 없이도 UI 불편·기능 제안을 보낸다 */
    openCsReport() {
      window.dispatchEvent(new CustomEvent("hereby:cs-report-open"));
    },
    showProfile,
    /* 조직 설정 popover entry — shown only when the host provides onOrgInfo. */
    showOrgInfo: !!onOrgInfoCb,
    /* 워크스페이스 전환 entry — host가 onSwitchWorkspace를 제공할 때만.
    (마크업에서 currentUser.accountId 게이트가 추가로 적용된다) */
    showSwitchWorkspace: !!onSwitchWorkspaceCb,
    /* Profile popover open state (markup in page-header-toolbar.html). */
    profileMenuOpen: false,
    /* 프로필 메뉴의 공용 ESC 층 해제 함수 — 프로필 영역은 x-if 안이라 다시 그려질 수 있어 이전 등록을 풀고 다시 건다. */
    offProfileEsc: null,
    /* 프로필 메뉴를 ESC 로 닫는다(화면에서 가장 위 하나만 닫히는 공용 ESC 층). page-header-toolbar.html 의 x-init 이 부른다. */
    registerProfileEsc(el2) {
      this.offProfileEsc?.();
      this.offProfileEsc = registerEscLayer(() => this.profileMenuOpen && el2.isConnected ? el2.querySelector(".ds-page-header__profile-menu") : null, () => {
        this.profileMenuOpen = false;
      });
    },
    get title() {
      return getTitleFn ? getTitleFn() : staticTitle;
    },
    get iconName() {
      return getIconFn ? getIconFn() : staticIcon;
    },
    iconSvg(name) {
      return name ? getIcon(name) : "";
    },
    get showTeamFilter() {
      return getShowTeamFilterFn ? getShowTeamFilterFn() : staticShowTeamFilter;
    },
    get teams() {
      return getTeams ? getTeams() : [];
    },
    get selectedTeamId() {
      return getSelectedTeamId ? getSelectedTeamId() : "";
    },
    handleTeamChange(id) {
      if (onTeamChangeCb) {
        onTeamChangeCb(id);
      }
    },
    handleRefresh() {
      if (onRefreshCb) {
        onRefreshCb();
      }
    },
    get refreshLoading() {
      return getRefreshLoadingFn ? getRefreshLoadingFn() : false;
    },
    get showBack() {
      return getShowBackFn ? getShowBackFn() : staticShowBack;
    },
    handleBack() {
      if (onBackCb) {
        onBackCb();
      }
    },
    /* Profile popover actions — markup in page-header-toolbar.html. */
    handleMyInfo() {
      this.profileMenuOpen = false;
      if (onMyInfoCb) {
        onMyInfoCb();
        return;
      }
      window.dispatchEvent(new Event("open-my-info"));
    },
    /** 인증/보안 설정 — 비밀번호·2단계 인증·로그인 기기·로그인한 기기·대화 잠금을 한 화면에서. */
    handleSecurity() {
      this.profileMenuOpen = false;
      if (onSecurityCb) {
        onSecurityCb();
        return;
      }
      window.dispatchEvent(new Event("open-security-settings"));
    },
    handleOrgInfo() {
      this.profileMenuOpen = false;
      onOrgInfoCb?.();
    },
    handleSwitchWorkspace() {
      this.profileMenuOpen = false;
      onSwitchWorkspaceCb?.();
    },
    handleLogout() {
      this.profileMenuOpen = false;
      if (onLogoutCb) {
        onLogoutCb();
        return;
      }
      this.$store.hereby.logout();
    }
  };
}
__name(pageHeaderComponent, "pageHeaderComponent");

// src/utils/permission-code.ts
var PERMISSION_CODE_RE2 = /^[\w-]+:[\w-]+(?:\.[\w-]+)?$/;
function isPermissionCode(value) {
  return !!value && PERMISSION_CODE_RE2.test(value);
}
__name(isPermissionCode, "isPermissionCode");

// src/components/PermissionDeniedModal.ts
function permissionDeniedModalComponent(opts = {}) {
  return {
    isOpen: false,
    blockedPermission: "",
    /** 권한 코드가 없는 거절의 서버 문구(업무 규칙 거절) — 코드 대신 이 문장을 보여 준다 */
    serverMessage: "",
    reason: "",
    submitting: false,
    sent: false,
    errorMessage: "",
    descriptions: opts.descriptions ?? {},
    init() {
      const root = this.$root;
      const handler = /* @__PURE__ */ __name((ev) => {
        const detail = ev.detail;
        if (typeof detail === "string") {
          this.open(detail);
        } else if (detail && typeof detail === "object") {
          const d = detail;
          this.open(d.permission ?? "", d.message ?? "");
        } else {
          this.open("");
        }
      }, "handler");
      window.addEventListener("permission-denied", handler);
      root.addEventListener("alpine:removed", () => {
        window.removeEventListener("permission-denied", handler);
      });
    },
    open(permissionKey = "", message = "") {
      if (this.isOpen) {
        return;
      }
      this.blockedPermission = isPermissionCode(permissionKey) ? permissionKey : "";
      this.serverMessage = message;
      this.reason = "";
      this.sent = false;
      this.submitting = false;
      this.errorMessage = "";
      this.isOpen = true;
      setPermissionModalOpen(true);
    },
    close() {
      this.isOpen = false;
      this.blockedPermission = "";
      this.serverMessage = "";
      this.reason = "";
      this.sent = false;
      this.errorMessage = "";
      setPermissionModalOpen(false);
    },
    get info() {
      const explicit = this.descriptions[this.blockedPermission];
      if (explicit) {
        return explicit;
      }
      const store = herebyStore(this);
      const label = this.blockedPermission && typeof store?.tPermission === "function" ? store.tPermission(this.blockedPermission) : "";
      return {
        name: label || "\uAD8C\uD55C",
        description: this.serverMessage || "\uC774 \uAE30\uB2A5\uC5D0 \uC811\uADFC\uD558\uB824\uBA74 \uD574\uB2F9 \uAD8C\uD55C\uC774 \uD544\uC694\uD569\uB2C8\uB2E4."
      };
    },
    /** 권한 요청을 보낼 수 있는 거절인가 — 코드 없는 업무 규칙 거절은 안내만 한다 */
    get canRequest() {
      return isPermissionCode(this.blockedPermission);
    },
    async submit() {
      if (!this.reason.trim()) {
        return;
      }
      this.submitting = true;
      this.errorMessage = "";
      try {
        const sdk = herebyStore(this).sdk;
        if (!sdk?.permissionRequest?.create) {
          throw new Error("\uAD8C\uD55C \uC694\uCCAD \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
        }
        await sdk.permissionRequest.create({
          reason: this.reason.trim(),
          requestedPath: this.blockedPermission || (typeof window !== "undefined" ? window.location.pathname : void 0)
        });
        this.sent = true;
      } catch (e) {
        this.errorMessage = e instanceof Error ? e.message : String(e);
      } finally {
        this.submitting = false;
      }
    }
  };
}
__name(permissionDeniedModalComponent, "permissionDeniedModalComponent");

// src/components/RegisterForm.ts
import { describeUserPasswordPolicy as describeUserPasswordPolicy2, userPasswordPolicyError as userPasswordPolicyError2 } from "@hereby/core/constants";
function registerFormComponent(opts = {}) {
  return {
    // 가입 화면 상단은 **BI 락업**이라 여기에 브랜드 문자열 폴백을 두지 않는다.
    // 브랜드를 문자열로 박으면 앱마다 다른 패밀리가 조용히 새어 나온다
    // (실제로 직원 앱 가입 화면에 `hereby Medical` 이 뜨던 사고가 있었다).
    // opts.title 은 락업 대신 글자를 쓰고 싶은 예외 화면만 넘긴다.
    title: opts.title ?? "",
    /**
    * 상단 BI 락업 — **상위 서비스**의 것이다.
    * 직원 앱(Works)은 병원의 Medical 과 연동되므로 Medical 락업이 위에 온다.
    * 연동 대상이 없는 앱(자기 자신이 상위)은 자기 락업을 쓴다.
    */
    /** 비밀번호 칸 안내 — 병원이 없는 가입이라 기본 규칙 */
    get passwordHint() {
      return describeUserPasswordPolicy2();
    },
    get brandLockup() {
      const s = herebyStore(this);
      return getIcon(`logo-lockup-hereby-${s.linkedBrandFamily || s.brandFamily}`);
    },
    /**
    * 락업 아래 텍스트 — **이 앱**의 표기.
    * 상위 서비스가 따로 있을 때만 보여준다. 자기 자신이 상위면 위 락업과 같은 브랜드라
    * 두 번 적히므로 생략한다.
    */
    get appBrand() {
      const s = herebyStore(this);
      return s.linkedBrandFamily ? s.brand : "";
    },
    // Form fields
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    organizationName: "",
    organizationCode: "",
    acceptTerms: false,
    // UI state
    showPassword: false,
    isLoading: false,
    errors: {},
    step: 1,
    /** Auto-format phone number as 010-1234-5678 */
    formatPhone() {
      const digits = this.phone.replace(/\D/g, "").slice(0, 11);
      if (digits.length <= 3) {
        this.phone = digits;
      } else if (digits.length <= 7) {
        this.phone = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      } else {
        this.phone = `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
      }
    },
    /** Convert Korean phone (010-1234-5678) to E.164 digits (821012345678) */
    phoneToE164() {
      const digits = this.phone.replace(/\D/g, "");
      if (digits.startsWith("0")) {
        return `82${digits.slice(1)}`;
      }
      return digits;
    },
    // Validation
    validate() {
      const t = /* @__PURE__ */ __name((key) => herebyStore(this).t(key), "t");
      const errs = {};
      if (this.step === 1) {
        if (!this.firstName.trim()) {
          errs.firstName = t("auth.first_name_required");
        }
        if (!this.lastName.trim()) {
          errs.lastName = t("auth.last_name_required");
        }
        if (!this.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          errs.email = t("auth.email_invalid");
        }
        if (!this.phone.replace(/-/g, "").match(/^01[016789]\d{7,8}$/)) {
          errs.phone = t("auth.phone_invalid");
        }
        const policyError = userPasswordPolicyError2(this.password);
        if (policyError) {
          errs.password = policyError;
        }
        if (this.password !== this.confirmPassword) {
          errs.confirmPassword = t("auth.password_mismatch");
        }
      }
      if (this.step === 2) {
        if (!this.organizationName.trim()) {
          errs.organizationName = t("auth.org_name_required");
        }
        if (!this.organizationCode.match(/^[a-zA-Z][a-zA-Z0-9_-]{2,49}$/)) {
          errs.organizationCode = t("auth.org_code_invalid");
        }
        if (!this.acceptTerms) {
          errs.acceptTerms = t("auth.accept_terms_required");
        }
      }
      this.errors = errs;
      return Object.keys(errs).length === 0;
    },
    nextStep() {
      if (this.validate()) {
        this.step = 2;
      }
    },
    prevStep() {
      this.step = 1;
      this.errors = {};
    },
    async submit() {
      if (!this.validate()) {
        return;
      }
      this.isLoading = true;
      this.errors = {};
      try {
        const store = herebyStore(this);
        await store.sdk.auth.register({
          email: this.email,
          phone: this.phoneToE164(),
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          organizationName: this.organizationName,
          organizationCode: this.organizationCode,
          acceptTerms: true
        });
        store.authenticated = true;
        try {
          store.currentUser = await store.sdk.auth.getCurrentUser();
        } catch (_) {
        }
        opts.onSuccess?.();
      } catch (e) {
        const err = e;
        this.errors = {
          submit: err.message || herebyStore(this).t("auth.signup_failed")
        };
      } finally {
        this.isLoading = false;
      }
    }
  };
}
__name(registerFormComponent, "registerFormComponent");

// src/components/SearchInput.ts
import { mergeSearchSuggestions, normalizeSearchTerm, shouldRecordSearchTerm, splitSearchHistory } from "@hereby/core/constants";
var historyCache = /* @__PURE__ */ new Map();
var POP_MIN_WIDTH = 240;
var POP_MAX_HEIGHT = 320;
function dsSearchInputComponent(opts) {
  const context = String(opts?.context ?? "");
  const openOnFocus = opts?.openOnFocus !== false;
  return {
    /** 검색어 — 호스트의 x-model 과 x-modelable 로 묶인다 */
    value: "",
    open: false,
    loading: false,
    loaded: false,
    entries: [],
    /** 키보드로 고르는 중인 항목(평면 인덱스), -1 = 없음 */
    activeIndex: -1,
    /**
    * 팝오버 좌표 — **객체**로 바인딩한다. 문자열 `:style` 은 style 속성을 통째로 다시 써서 x-show 가 넣은
    * `display:none` 을 지운다 — 항목이 없어 x-show 가 꺼진 뒤 좌표가 다시 계산되면 빈 팝오버가 9px 흰 줄로
    * 떠 있었다(2026-10-12 메신저 연락처 「부서 거르기」 검색 뒤). 객체 바인딩은 자기 키만 만지고 display 는 두지 않는다.
    */
    popStyle: {},
    /** 마지막으로 서버에 기록한 값 — 같은 값을 blur 마다 다시 기록하지 않는다 */
    lastCommitted: "",
    inputEl: null,
    context,
    get query() {
      return normalizeSearchTerm(this.value);
    },
    /** 드롭다운 묶음 — 비어 있으면 자주·최근, 입력 중이면 제안 하나 */
    get sections() {
      const q = this.query;
      if (q) {
        const data = typeof opts?.suggest === "function" ? opts.suggest(q) ?? [] : [];
        const items = mergeSearchSuggestions(this.entries, data, q);
        return items.length > 0 ? [
          {
            key: "suggest",
            title: "\uCD94\uCC9C \uAC80\uC0C9\uC5B4",
            items,
            removable: false
          }
        ] : [];
      }
      if (!openOnFocus) {
        return [];
      }
      const { frequent, recent } = splitSearchHistory(this.entries);
      const out = [];
      if (frequent.length > 0) {
        out.push({
          key: "frequent",
          title: "\uC790\uC8FC \uCC3E\uB294 \uAC80\uC0C9\uC5B4",
          items: frequent.map((e) => e.term),
          removable: true
        });
      }
      if (recent.length > 0) {
        out.push({
          key: "recent",
          title: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4",
          items: recent.map((e) => e.term),
          removable: true
        });
      }
      return out;
    },
    /** 키보드 이동용 평면 목록 */
    get flatItems() {
      return this.sections.flatMap((s) => s.items);
    },
    get hasItems() {
      return this.flatItems.length > 0;
    },
    /** 실제로 떠 있는가 — 호스트가 자기 팝오버와 겹치지 않게 할 때 읽는다 */
    get dropdownVisible() {
      return this.open && this.hasItems;
    },
    /** 「전체 지우기」 — 이력 묶음을 보여 줄 때만 */
    get canClearAll() {
      return !this.query && this.entries.length > 0;
    },
    /** 입력값이 민감 패턴이라 저장되지 않을 때 드롭다운 아래에 알린다 */
    get sensitiveNotice() {
      const q = this.query;
      return q.length >= 2 && !shouldRecordSearchTerm(q);
    },
    /** 이력에서 보이는 항목인지(X 를 그릴지) */
    isHistoryTerm(term) {
      return this.entries.some((e) => e.term === term);
    },
    flatIndexOf(sectionIndex, itemIndex) {
      let n = 0;
      for (let i = 0; i < sectionIndex; i++) {
        n += this.sections[i].items.length;
      }
      return n + itemIndex;
    },
    async load() {
      if (this.loaded || !context) {
        return;
      }
      const cached = historyCache.get(context);
      if (cached) {
        this.entries = [
          ...cached
        ];
        this.loaded = true;
        return;
      }
      this.loading = true;
      try {
        const sdk = herebyStore(this).sdk;
        const rows = await sdk.searchHistory.list({
          context
        });
        const entries = (rows ?? []).map((r) => ({
          term: r.term,
          useCount: r.useCount,
          lastUsedAt: r.lastUsedAt,
          pinned: r.pinned === true
        }));
        historyCache.set(context, entries);
        this.entries = [
          ...entries
        ];
        this.loaded = true;
      } catch {
        this.loaded = true;
      } finally {
        this.loading = false;
      }
    },
    onFocus(el2) {
      this.inputEl = el2;
      this.load();
      this.positionPop();
      this.activeIndex = -1;
      this.open = true;
    },
    onInput() {
      this.activeIndex = -1;
      this.open = true;
      this.positionPop();
    },
    onBlur() {
      this.open = false;
      this.activeIndex = -1;
      this.commit();
    },
    onKeydown(ev) {
      if (ev.key === "ArrowDown" || ev.key === "ArrowUp") {
        const n = this.flatItems.length;
        if (n === 0) {
          return;
        }
        ev.preventDefault();
        this.open = true;
        const delta = ev.key === "ArrowDown" ? 1 : -1;
        const slots = n + 1;
        this.activeIndex = (this.activeIndex + 1 + delta + slots) % slots - 1;
        return;
      }
      if (ev.key === "Enter") {
        if (this.open && this.activeIndex >= 0 && this.activeIndex < this.flatItems.length) {
          ev.preventDefault();
          this.pick(this.flatItems[this.activeIndex]);
          return;
        }
        this.commit();
        this.open = false;
        return;
      }
      if (ev.key === "Escape") {
        if (this.open) {
          this.open = false;
          this.activeIndex = -1;
        }
      }
    },
    /** 제안을 고름 — 값을 넣고 입력칸에 input 이벤트를 쏘아 호스트의 검색 핸들러가 돌게 한다. */
    pick(term) {
      this.value = term;
      this.open = false;
      this.activeIndex = -1;
      const el2 = this.inputEl;
      if (el2) {
        el2.value = term;
        el2.dispatchEvent(new Event("input", {
          bubbles: true
        }));
        el2.focus();
      }
      this.commit(term);
    },
    /** 확정 — 저장 조건을 통과하면 로컬 이력·캐시를 먼저 고치고 서버에 기록한다(실패는 조용히). */
    commit(raw) {
      const term = normalizeSearchTerm(raw ?? this.value);
      if (!(context && shouldRecordSearchTerm(term)) || term === this.lastCommitted) {
        return;
      }
      this.lastCommitted = term;
      const now = /* @__PURE__ */ new Date();
      const idx = this.entries.findIndex((e) => e.term === term);
      if (idx >= 0) {
        const cur = this.entries[idx];
        this.entries.splice(idx, 1, {
          ...cur,
          useCount: cur.useCount + 1,
          lastUsedAt: now
        });
      } else {
        this.entries.unshift({
          term,
          useCount: 1,
          lastUsedAt: now
        });
      }
      historyCache.set(context, [
        ...this.entries
      ]);
      try {
        herebyStore(this).sdk.searchHistory.record({
          context,
          term
        }).catch(() => void 0);
      } catch {
      }
    },
    /** 즐겨찾기(별)인가 — 「자주 찾는 검색어」 맨 위에 고정된 검색어 */
    isPinned(term) {
      return this.entries.some((e) => e.term === term && e.pinned === true);
    },
    /**
    * 별 — 즐겨찾기 켬/끔. 항목 클릭(pick = 검색)과 **분리된 동작**이라 호출부는 `@click.stop` 으로 막아야 한다
    * (2026-10-12: 별이 장식 아이콘이라 누르면 검색으로 넘어갔다). 로컬·캐시를 먼저 고치고 서버는 조용히.
    */
    togglePin(term) {
      const next = !this.isPinned(term);
      const existing = this.entries.find((e) => e.term === term);
      if (existing) {
        this.entries = this.entries.map((e) => e.term === term ? {
          ...e,
          pinned: next
        } : e);
      } else {
        this.entries = [
          ...this.entries,
          {
            term,
            useCount: 0,
            lastUsedAt: (/* @__PURE__ */ new Date()).toISOString(),
            pinned: next
          }
        ];
      }
      historyCache.set(context, [
        ...this.entries
      ]);
      this.activeIndex = -1;
      try {
        herebyStore(this).sdk.searchHistory.pin({
          context,
          term,
          pinned: next
        }).catch(() => void 0);
      } catch {
      }
    },
    /** 항목별 X — 이력에서 지운다. 입력칸 포커스는 유지된다(mousedown.prevent). */
    remove(term) {
      this.entries = this.entries.filter((e) => e.term !== term);
      historyCache.set(context, [
        ...this.entries
      ]);
      if (this.lastCommitted === term) {
        this.lastCommitted = "";
      }
      if (this.activeIndex >= this.flatItems.length) {
        this.activeIndex = -1;
      }
      try {
        herebyStore(this).sdk.searchHistory.remove({
          context,
          term
        }).catch(() => void 0);
      } catch {
      }
    },
    clearAll() {
      this.entries = [];
      this.lastCommitted = "";
      this.activeIndex = -1;
      historyCache.set(context, []);
      try {
        herebyStore(this).sdk.searchHistory.clear({
          context
        }).catch(() => void 0);
      } catch {
      }
    },
    /** 텔레포트된 고정 패널을 입력칸 바로 아래에 — 입력칸 폭을 따르되 최소 240px. */
    positionPop() {
      const el2 = this.inputEl;
      if (!el2 || typeof el2.getBoundingClientRect !== "function") {
        return;
      }
      const rect = el2.getBoundingClientRect();
      const width = Math.max(POP_MIN_WIDTH, Math.round(rect.width));
      const margin = 8;
      const gap = 4;
      let left = rect.left;
      if (left + width > window.innerWidth - margin) {
        left = Math.max(margin, window.innerWidth - margin - width);
      }
      let top = rect.bottom + gap;
      if (top + POP_MAX_HEIGHT > window.innerHeight - margin) {
        const above = rect.top - gap - POP_MAX_HEIGHT;
        if (above > margin) {
          top = above;
        }
      }
      this.popStyle = {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`,
        width: `${width}px`
      };
    },
    init() {
      alpineMagics(this).$watch?.(() => this.value, (v) => {
        if (!normalizeSearchTerm(v)) {
          this.lastCommitted = "";
        }
      });
    }
  };
}
__name(dsSearchInputComponent, "dsSearchInputComponent");

// src/components/SecuritySettings.ts
import { describeUserPasswordPolicy as describeUserPasswordPolicy3, userPasswordPolicyError as userPasswordPolicyError3 } from "@hereby/core/constants";
function securitySettingsComponent() {
  return {
    showSecurity: false,
    loading: false,
    overview: null,
    sessions: [],
    sessionsLoaded: false,
    sessionBusy: "",
    deviceCredentials: [],
    deviceCredentialsLoaded: false,
    deviceCredentialBusy: false,
    deviceCredentialError: "",
    /* 비밀번호 변경 — 내 정보에서 옮겨 옴. 현재 비밀번호 확인 → 새 비밀번호 */
    passwordStep: "",
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    pwError: "",
    pwLoading: false,
    /* 2단계 인증 */
    twoFactorSetup: null,
    twoFactorCode: "",
    twoFactorBackupCodes: null,
    twoFactorBusy: false,
    twoFactorError: "",
    twoFactorDisableOpen: false,
    init() {
      window.addEventListener("open-security-settings", () => this.open());
      document.addEventListener("app-back-button", (e) => {
        if (this.showSecurity) {
          e.preventDefault();
          this.close();
        }
      });
    },
    t(key, params) {
      return herebyStore(this).t(key, params) || key;
    },
    get deviceLoginState() {
      return herebyStore(this).deviceLogin ?? {};
    },
    get chatLockAvailable() {
      const store = herebyStore(this);
      return Boolean(store.currentUser?.messengerEncryption) && store.hasPermission?.("conversation:read") !== false;
    },
    /** 조직이 2단계 인증을 필수로 했는데 아직 등록 전 — 맨 위 안내 */
    get twoFactorEnrollmentRequired() {
      return Boolean(this.overview?.twoFactor.requiredByOrg && !this.overview?.twoFactor.enabled);
    },
    async open() {
      this.showSecurity = true;
      this.passwordStep = "";
      this.pwError = "";
      this.twoFactorSetup = null;
      this.twoFactorBackupCodes = null;
      this.twoFactorError = "";
      this.twoFactorDisableOpen = false;
      await this.reload();
    },
    close() {
      this.showSecurity = false;
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
      this.twoFactorCode = "";
    },
    async reload() {
      this.loading = true;
      try {
        await Promise.all([
          this.loadOverview(),
          this.loadSessions(),
          this.loadDeviceCredentials()
        ]);
      } finally {
        this.loading = false;
      }
    },
    async loadOverview() {
      try {
        this.overview = await herebyStore(this).sdk.security.overview();
      } catch {
        this.overview = null;
      }
    },
    async loadSessions() {
      try {
        this.sessions = await herebyStore(this).sdk.security.sessions();
      } catch {
        this.sessions = [];
      } finally {
        this.sessionsLoaded = true;
      }
    },
    async loadDeviceCredentials() {
      try {
        this.deviceCredentials = await herebyStore(this).sdk.deviceCredential.list();
      } catch {
        this.deviceCredentials = [];
      } finally {
        this.deviceCredentialsLoaded = true;
      }
    },
    /** 로그인 방법 라벨 — 사번·이메일·전화번호 중 실제로 로그인에 쓸 수 있는 식별자 */
    get loginIdentifiers() {
      const o = this.overview;
      if (!o) {
        return [];
      }
      const rows = [];
      if (o.employeeNumber) {
        rows.push({
          label: this.t("security.id_employee_number"),
          value: o.employeeNumber
        });
      }
      if (o.email) {
        rows.push({
          label: this.t("security.id_email"),
          value: o.email
        });
      }
      if (o.phone) {
        rows.push({
          label: this.t("security.id_phone"),
          value: o.phone
        });
      }
      return rows;
    },
    /** 휴대폰 인증(SMS 코드) 로그인 허용 — 내 정보에서 옮겨 옴(개인 설정: 내 authMethods 의 phone_otp). */
    get phoneOtpEnabled() {
      return (this.overview?.authMethods ?? []).includes("phone_otp");
    },
    phoneOtpBusy: false,
    async togglePhoneOtp(on) {
      const employeeId = herebyStore(this).currentUser?.id;
      if (!(this.overview && employeeId)) {
        return;
      }
      const before = [
        ...this.overview.authMethods
      ];
      let methods = before.filter((m) => m !== "phone_otp");
      if (on) {
        methods.push("phone_otp");
      }
      if (methods.length === 0) {
        methods = [
          "email"
        ];
      }
      this.overview.authMethods = methods;
      this.phoneOtpBusy = true;
      try {
        await herebyStore(this).sdk.employee.updateEmployee({
          id: employeeId,
          authMethods: methods
        });
      } catch (e) {
        this.overview.authMethods = before;
        showError(e?.message || this.t("employee.save_error"));
      } finally {
        this.phoneOtpBusy = false;
      }
    },
    formatWhen(value) {
      return value ? herebyStore(this).formatDateTime(value) : "-";
    },
    /* ── 로그인한 기기 ── */
    async revokeSession(row) {
      const message = row.current ? this.t("security.session_logout_current_confirm") : this.t("security.session_logout_confirm", {
        device: row.device
      });
      if (!await askConfirm({
        message,
        tone: "danger"
      })) {
        return;
      }
      this.sessionBusy = row.id;
      try {
        await herebyStore(this).sdk.security.revokeSession({
          id: row.id
        });
        if (row.current) {
          await herebyStore(this).logout();
          return;
        }
        await this.loadSessions();
      } catch (e) {
        showError(e?.message || this.t("security.session_logout_failed"));
      } finally {
        this.sessionBusy = "";
      }
    },
    /** 현재 기기 외에 로그인된 기기가 있는가 — 「모두 로그아웃」 버튼 노출 조건 */
    get hasOtherSessions() {
      return this.sessions.some((s) => !s.current);
    },
    /** 현재 기기 외 모두 로그아웃(사용자 요청 2026-10-13) */
    async revokeOtherSessions() {
      if (!await askConfirm({
        message: this.t("security.sessions_logout_others_confirm"),
        tone: "danger"
      })) {
        return;
      }
      this.sessionBusy = "others";
      try {
        await herebyStore(this).sdk.security.revokeOtherSessions();
        await this.loadSessions();
        this.notify(this.t("security.sessions_logout_others_done"));
      } catch (e) {
        showError(e?.message || this.t("security.session_logout_failed"));
      } finally {
        this.sessionBusy = "";
      }
    },
    /* ── 패스키 전용 로그인(2026-10-13) — 켜면 비밀번호·문자 코드 로그인 거부. 등록된 키가 있어야 켤 수 있다 ── */
    passkeyOnlyBusy: false,
    get passkeyOnlyAvailable() {
      return this.deviceCredentials.length > 0;
    },
    async togglePasskeyOnly(on) {
      if (!this.overview) {
        return;
      }
      if (on && !this.passkeyOnlyAvailable) {
        showError(this.t("security.passkey_only_need_credential"));
        return;
      }
      if (on && !await askConfirm({
        message: this.t("security.passkey_only_confirm"),
        tone: "danger"
      })) {
        return;
      }
      const before = this.overview.passkeyOnly;
      this.overview.passkeyOnly = on;
      this.passkeyOnlyBusy = true;
      try {
        await herebyStore(this).sdk.security.setPasskeyOnly({
          enabled: on
        });
      } catch (e) {
        this.overview.passkeyOnly = before;
        showError(e?.message || this.t("security.two_factor_failed"));
      } finally {
        this.passkeyOnlyBusy = false;
      }
    },
    /* ── 기기 로그인(패스키·기기 키) — 내 정보에서 옮겨 옴 ── */
    deviceCredentialLabel(kind) {
      return this.t(kind === "passkey" ? "auth.device_credential_passkey" : "auth.device_credential_device_key");
    },
    async registerPasskey() {
      this.deviceCredentialError = "";
      this.deviceCredentialBusy = true;
      try {
        const store = herebyStore(this);
        if (await store.registerThisPasskey?.(this.t("auth.passkey_default_name"))) {
          await this.loadDeviceCredentials();
        }
      } catch (e) {
        this.deviceCredentialError = e?.message || this.t("auth.device_credential_failed");
      } finally {
        this.deviceCredentialBusy = false;
      }
    },
    async registerDeviceKey() {
      this.deviceCredentialError = "";
      this.deviceCredentialBusy = true;
      try {
        const store = herebyStore(this);
        if (await store.registerThisDeviceKey?.()) {
          await this.loadDeviceCredentials();
        }
      } catch (e) {
        this.deviceCredentialError = e?.message || this.t("auth.device_credential_failed");
      } finally {
        this.deviceCredentialBusy = false;
      }
    },
    async revokeDeviceCredential(id) {
      if (!await askConfirm({
        message: this.t("auth.device_credential_revoke_confirm"),
        tone: "danger"
      })) {
        return;
      }
      this.deviceCredentialError = "";
      try {
        const sdk = herebyStore(this).sdk;
        await sdk.deviceCredential.revoke({
          id
        });
        const store = herebyStore(this);
        if (store.deviceLogin?.hasDeviceKey) {
          const { getActiveDeviceKey: getActiveDeviceKey2 } = await Promise.resolve().then(() => (init_dist(), dist_exports));
          const active = await getActiveDeviceKey2({
            service: sdk.deviceCredential
          });
          if (active?.credentialId === id) {
            await store.forgetThisDeviceKey?.(false);
          }
        }
        await Promise.all([
          this.loadDeviceCredentials(),
          this.loadOverview()
        ]);
      } catch (e) {
        this.deviceCredentialError = e?.message || this.t("auth.device_credential_failed");
      }
    },
    /* ── 비밀번호 변경 ── */
    get passwordPolicy() {
      const user = herebyStore(this).currentUser;
      return user?.passwordPolicy ?? null;
    },
    get passwordHint() {
      return describeUserPasswordPolicy3(this.passwordPolicy);
    },
    startPasswordChange() {
      this.passwordStep = "verify";
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
      this.pwError = "";
    },
    cancelPasswordChange() {
      this.passwordStep = "";
      this.pwError = "";
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
    },
    /** 1단계 — 현재 비밀번호 확인. 같은 값으로 바꿔 보고 규칙 오류(BAD_REQUEST)면 맞는 것, UNAUTHORIZED 면 틀린 것. */
    async verifyCurrentPassword() {
      if (!this.currentPassword) {
        return;
      }
      this.pwError = "";
      this.pwLoading = true;
      try {
        await herebyStore(this).sdk.auth.changePassword(this.currentPassword, this.currentPassword, this.currentPassword);
        this.passwordStep = "newpw";
      } catch (e) {
        const code = e?.data?.code;
        if (code === "BAD_REQUEST") {
          this.passwordStep = "newpw";
        } else {
          this.pwError = this.t("auth.password_mismatch_current") || "\uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uC2DC \uD655\uC778\uD574 \uC8FC\uC138\uC694.";
        }
      } finally {
        this.pwLoading = false;
      }
    },
    async submitNewPassword() {
      if (!this.newPassword || this.newPassword !== this.confirmNewPassword) {
        return;
      }
      const policyError = userPasswordPolicyError3(this.newPassword, this.passwordPolicy);
      if (policyError) {
        this.pwError = policyError;
        return;
      }
      this.pwError = "";
      this.pwLoading = true;
      try {
        await herebyStore(this).sdk.auth.changePassword(this.currentPassword, this.newPassword, this.confirmNewPassword);
        this.cancelPasswordChange();
        this.notify(this.t("admin.password_changed") || "\uBE44\uBC00\uBC88\uD638\uAC00 \uBCC0\uACBD\uB418\uC5C8\uC5B4\uC694.");
      } catch (e) {
        this.pwError = e instanceof Error ? e.message : String(e);
      } finally {
        this.pwLoading = false;
      }
    },
    notify(message) {
      const toast = appStore(this, "toast");
      if (typeof toast?.success === "function") {
        toast.success(message);
      } else if (typeof toast?.show === "function") {
        toast.show(message, "success");
      }
    },
    /* ── 2단계 인증(TOTP) ── */
    async startTwoFactorSetup() {
      this.twoFactorError = "";
      this.twoFactorCode = "";
      this.twoFactorBackupCodes = null;
      this.twoFactorBusy = true;
      try {
        this.twoFactorSetup = await herebyStore(this).sdk.security.twoFactorSetupStart();
      } catch (e) {
        this.twoFactorError = e?.message || this.t("security.two_factor_failed");
      } finally {
        this.twoFactorBusy = false;
      }
    },
    cancelTwoFactorSetup() {
      this.twoFactorSetup = null;
      this.twoFactorCode = "";
      this.twoFactorError = "";
    },
    async confirmTwoFactorSetup() {
      if (!/^\d{6}$/.test(this.twoFactorCode.trim())) {
        this.twoFactorError = this.t("security.two_factor_code_format");
        return;
      }
      this.twoFactorError = "";
      this.twoFactorBusy = true;
      try {
        const { backupCodes } = await herebyStore(this).sdk.security.twoFactorSetupConfirm({
          code: this.twoFactorCode.trim()
        });
        this.twoFactorSetup = null;
        this.twoFactorCode = "";
        this.twoFactorBackupCodes = backupCodes;
        await this.loadOverview();
        const user = herebyStore(this).currentUser;
        if (user?.requires2FA) {
          user.requires2FA = false;
        }
      } catch (e) {
        this.twoFactorError = e?.message || this.t("security.two_factor_failed");
      } finally {
        this.twoFactorBusy = false;
      }
    },
    async disableTwoFactor() {
      if (!this.twoFactorCode.trim()) {
        this.twoFactorError = this.t("security.two_factor_code_format");
        return;
      }
      this.twoFactorError = "";
      this.twoFactorBusy = true;
      try {
        await herebyStore(this).sdk.security.twoFactorDisable({
          code: this.twoFactorCode.trim()
        });
        this.twoFactorDisableOpen = false;
        this.twoFactorCode = "";
        await this.loadOverview();
      } catch (e) {
        this.twoFactorError = e?.message || this.t("security.two_factor_failed");
      } finally {
        this.twoFactorBusy = false;
      }
    },
    backupCodesText() {
      return (this.twoFactorBackupCodes ?? []).join("\n");
    },
    async copyBackupCodes() {
      try {
        await navigator.clipboard.writeText(this.backupCodesText());
        this.notify(this.t("security.backup_codes_copied"));
      } catch {
      }
    },
    /* ── 대화 잠금(메신저 암호화 키) — 메신저의 잠금 설정 모달로 ── */
    openChatLock() {
      this.close();
      window.dispatchEvent(new Event("hereby:open-chat-lock"));
    }
  };
}
__name(securitySettingsComponent, "securitySettingsComponent");

// src/components/Segment.ts
function segmentComponent(opts = {}) {
  const getTabs = opts.getTabs;
  const getActive = opts.getActive;
  const onSelect = opts.onSelect;
  const size = opts.size ?? "sm";
  const fill = opts.fill ?? false;
  return {
    /** Group modifier classes (.ds-segment) — size · fill. */
    get segmentGroupClass() {
      const cls = [];
      if (size === "md") {
        cls.push("ds-segment--md");
      }
      if (fill) {
        cls.push("ds-segment--fill");
      }
      return cls.join(" ");
    },
    get segmentItems() {
      return getTabs ? getTabs() : [];
    },
    get segmentActiveId() {
      return getActive ? getActive() : "";
    },
    segmentIsActive(id) {
      return this.segmentActiveId === id;
    },
    segmentSelect(item) {
      if (item.disabled) {
        return;
      }
      onSelect?.(item.id);
    },
    segmentIconSvg(name) {
      return name ? getIcon(name) : "";
    }
  };
}
__name(segmentComponent, "segmentComponent");

// src/components/SubTab.ts
function subTabComponent(opts = {}) {
  const getTabs = opts.getTabs;
  const getActive = opts.getActive;
  const onSelect = opts.onSelect;
  const size = opts.size ?? "md";
  const radius = opts.radius ?? "8";
  const color = opts.color ?? "dark";
  const fill = opts.fill ?? "solid";
  return {
    /** Group modifier classes (.ds-sub-tab) — size · radius · color · fill 축 조합. */
    get subTabGroupClass() {
      const cls = [];
      if (size === "sm") {
        cls.push("ds-sub-tab--sm");
      }
      if (size === "ml") {
        cls.push("ds-sub-tab--ml");
      }
      cls.push(`ds-sub-tab--r${radius}`);
      if (color === "primary") {
        cls.push("ds-sub-tab--primary");
      }
      if (fill === "line") {
        cls.push("ds-sub-tab--line");
      }
      return cls.join(" ");
    },
    get subTabItems() {
      return getTabs ? getTabs() : [];
    },
    get subTabActiveId() {
      return getActive ? getActive() : "";
    },
    /** `<testidPrefix>-<id>` for one tab button. See SubTabOptions.testidPrefix. */
    subTabTestId(id) {
      return `${opts.testidPrefix ?? "subtab"}-${id}`;
    },
    subTabIsActive(id) {
      if (opts.isActive) {
        return opts.isActive(id);
      }
      return this.subTabActiveId === id;
    },
    subTabSelect(item) {
      if (item.disabled) {
        return;
      }
      onSelect?.(item.id);
    },
    subTabIconSvg(name) {
      return name ? getIcon(name) : "";
    }
  };
}
__name(subTabComponent, "subTabComponent");

// src/components/TabNav.ts
function magics2(ctx) {
  return ctx;
}
__name(magics2, "magics");
var ROW_SELECTOR = ".ds-tab-nav-row";
var ROW_ACTIONS_SELECTOR = ".ds-tab-nav-row__actions";
var ROW_COMPACT_CLASS = "is-compact";
var HAS_ICON_CLASS = "has-ico";
var AUTO_TIP_ATTR = "data-ds-tabnav-auto-tip";
var SCROLL_EPS_PX = 2;
var ARROW_STEP_RATIO = 0.8;
var REVEAL_GUTTER_PX = 32;
function syncRowActionTips(actions2, compact) {
  for (const btn of Array.from(actions2.querySelectorAll(".ds-btn"))) {
    const hasIcon2 = btn.querySelector(".ds-ico") !== null;
    btn.classList.toggle(HAS_ICON_CLASS, hasIcon2);
    if (!hasIcon2) {
      continue;
    }
    if (compact) {
      if (btn.hasAttribute("title") || btn.hasAttribute(AUTO_TIP_ATTR)) {
        continue;
      }
      const label = Array.from(btn.children).filter((c) => !c.classList.contains("ds-ico")).map((c) => c.textContent?.trim() ?? "").filter(Boolean).join(" ");
      if (!label) {
        continue;
      }
      btn.setAttribute("title", label);
      btn.setAttribute("data-ds-tip", "bottom");
      btn.setAttribute(AUTO_TIP_ATTR, "1");
    } else if (btn.hasAttribute(AUTO_TIP_ATTR)) {
      btn.removeAttribute("title");
      btn.removeAttribute("data-ds-tip");
      btn.removeAttribute("data-tip-title");
      btn.removeAttribute(AUTO_TIP_ATTR);
    }
  }
}
__name(syncRowActionTips, "syncRowActionTips");
function tabNavComponent(opts = {}) {
  const getTabs = opts.getTabs;
  const getActive = opts.getActive;
  const onSelect = opts.onSelect;
  const size = opts.size ?? "md";
  const divider = opts.divider ?? true;
  const fill = opts.fill ?? false;
  let resizeObserver = null;
  let mutationObserver = null;
  let frame = 0;
  return {
    /** Size modifier class for each .ds-tab-item ("" = md default, "ds-tab-item--ml" = ml). */
    get tabNavSizeClass() {
      return size === "ml" ? "ds-tab-item--ml" : "";
    },
    /** Bottom-divider modifier on nav ("" = line on, "ds-tab-nav--flush" = line off). */
    get tabNavDividerClass() {
      return divider ? "" : "ds-tab-nav--flush";
    },
    /** Fill modifier on nav ("" = natural width, "ds-tab-nav--fill" = equal-width tabs, no side gap). */
    get tabNavFillClass() {
      return fill ? "ds-tab-nav--fill" : "";
    },
    get tabNavItems() {
      return getTabs ? getTabs() : [];
    },
    get tabNavActiveId() {
      return getActive ? getActive() : "";
    },
    tabNavIsActive(id) {
      return this.tabNavActiveId === id;
    },
    tabNavSelect(item) {
      if (item.disabled) {
        return;
      }
      onSelect?.(item.id);
      magics2(this).$nextTick(() => this.tabNavRevealActive(true));
    },
    /* ── 좁아졌을 때 ─────────────────────────────────────────────
    * 탭이 가로로 넘치면 넘치는 방향에만 셰브론(< >)을 띄운다. 탭 줄이 `.ds-tab-nav-row`
    * 안에 있으면(오른쪽에 기능 버튼) 그보다 먼저 버튼을 아이콘만 남긴다(.is-compact).
    * 판정은 늘 「버튼 라벨이 다 보이는」 원래 폭으로 한다 — 줄인 상태에서 재면 「줄였더니
    * 들어가서 되돌리고 다시 넘치는」 반복이 생긴다. 한 프레임 안에서 떼고 재고 붙이므로
    * 화면은 깜빡이지 않는다. */
    /** 왼쪽/오른쪽으로 더 볼 탭이 있는가 — nav 의 can-scroll-prev/next 클래스로 반영. */
    tabNavCanPrev: false,
    tabNavCanNext: false,
    init() {
      const { $el, $refs, $nextTick } = magics2(this);
      const scroller = $refs.tabNavScroller;
      if (!scroller) {
        return;
      }
      const schedule2 = /* @__PURE__ */ __name(() => {
        if (frame) {
          return;
        }
        frame = requestAnimationFrame(() => {
          frame = 0;
          this.tabNavSync();
        });
      }, "schedule");
      scroller.addEventListener("scroll", () => this.tabNavSyncArrows(), {
        passive: true
      });
      const row = $el.closest(ROW_SELECTOR);
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver = new ResizeObserver(schedule2);
        resizeObserver.observe(scroller);
        if (row) {
          resizeObserver.observe(row);
        }
      }
      mutationObserver = new MutationObserver(schedule2);
      mutationObserver.observe(scroller, {
        childList: true,
        subtree: true
      });
      const actions2 = row?.querySelector(ROW_ACTIONS_SELECTOR);
      if (actions2) {
        mutationObserver.observe(actions2, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: [
            "style"
          ]
        });
      }
      $nextTick(() => {
        this.tabNavSync();
        this.tabNavRevealActive(false);
      });
    },
    destroy() {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      if (frame) {
        cancelAnimationFrame(frame);
        frame = 0;
      }
    },
    /** 오른쪽 버튼의 아이콘화 여부를 정하고, 셰브론 상태를 맞춘다. */
    tabNavSync() {
      const { $el, $refs } = magics2(this);
      const scroller = $refs.tabNavScroller;
      if (!scroller) {
        return;
      }
      const row = $el.closest(ROW_SELECTOR);
      if (row && row.clientWidth > 0) {
        const actions2 = row.querySelector(ROW_ACTIONS_SELECTOR);
        row.classList.remove(ROW_COMPACT_CLASS);
        const needed = scroller.scrollWidth + (actions2 ? actions2.offsetWidth : 0);
        const compact = needed > row.clientWidth + 0.5;
        row.classList.toggle(ROW_COMPACT_CLASS, compact);
        if (actions2) {
          syncRowActionTips(actions2, compact);
        }
      }
      this.tabNavSyncArrows();
    },
    /** 넘치는 방향에만 셰브론. overflow 를 visible 로 푼 호스트는 스크롤할 수 없어 끈다. */
    tabNavSyncArrows() {
      const scroller = magics2(this).$refs.tabNavScroller;
      if (!scroller) {
        return;
      }
      const scrollable = getComputedStyle(scroller).overflowX !== "visible";
      const max = scroller.scrollWidth - scroller.clientWidth;
      this.tabNavCanPrev = scrollable && scroller.scrollLeft > SCROLL_EPS_PX;
      this.tabNavCanNext = scrollable && max > SCROLL_EPS_PX && scroller.scrollLeft < max - SCROLL_EPS_PX;
    },
    /** 셰브론 클릭 — 보이는 폭의 80%씩 민다. */
    tabNavScrollBy(direction) {
      const scroller = magics2(this).$refs.tabNavScroller;
      if (!scroller) {
        return;
      }
      const step = Math.max(80, scroller.clientWidth * ARROW_STEP_RATIO);
      scroller.scrollBy({
        left: direction * step,
        behavior: "smooth"
      });
    },
    /**
    * 활성 탭이 잘려 있으면 보이게 당긴다. `scrollIntoView` 는 바깥 스크롤(페이지)까지
    * 움직이므로 쓰지 않고 이 스크롤 박스만 민다.
    */
    tabNavRevealActive(smooth) {
      const scroller = magics2(this).$refs.tabNavScroller;
      const active = scroller?.querySelector(".tab-active");
      if (!(scroller && active) || scroller.scrollWidth <= scroller.clientWidth) {
        return;
      }
      const box = scroller.getBoundingClientRect();
      const tab = active.getBoundingClientRect();
      const behavior = smooth ? "smooth" : "auto";
      if (tab.left < box.left + REVEAL_GUTTER_PX) {
        scroller.scrollBy({
          left: tab.left - box.left - REVEAL_GUTTER_PX,
          behavior
        });
      } else if (tab.right > box.right - REVEAL_GUTTER_PX) {
        scroller.scrollBy({
          left: tab.right - box.right + REVEAL_GUTTER_PX,
          behavior
        });
      }
    },
    tabNavIconSvg(name) {
      return name ? getIcon(name) : "";
    },
    tabNavHasBadge(item) {
      return item.badge !== void 0 && item.badge !== null && `${item.badge}` !== "";
    }
  };
}
__name(tabNavComponent, "tabNavComponent");

// src/components/WorkspaceSwitcher.ts
var ITEMS = [
  {
    id: "admin",
    group: "\uC870\uC9C1 \uC6B4\uC601",
    title: "Workspace \uC124\uC815",
    desc: "\uC9C1\uC6D0\xB7\uD300\xB7\uBD80\uC11C\xB7\uC5ED\uD560",
    path: "/admin",
    devPort: 4001,
    icon: "ic-workspace"
  },
  {
    id: "hr-system",
    group: "\uC870\uC9C1 \uC6B4\uC601",
    title: "\uAE09\uC5EC\uAD00\uB9AC",
    desc: "\uC6D4\uAE09 \uBA85\uC138\xB7\uC218\uB2F9\xB7\uACF5\uC81C",
    path: "/hr-system",
    devPort: 4e3,
    icon: "ic-money",
    hidden: true
  },
  {
    id: "management-dashboard",
    group: "\uBD84\uC11D & \uC2A4\uCF00\uC974",
    title: "\uACBD\uC601 \uB300\uC2DC\uBCF4\uB4DC",
    desc: "\uC778\uAC74\uBE44\xB7\uCCAD\uAD6C\xB7\uC778\uB825 \uBD84\uC11D",
    path: "/management-dashboard",
    devPort: 4006,
    icon: "ic-chart-up"
  },
  {
    id: "team-manager",
    group: "\uBD84\uC11D & \uC2A4\uCF00\uC974",
    title: "\uB0B4\uBD80 \uACB0\uC7AC",
    desc: "\uD734\uAC00\xB7\uCD08\uACFC\uADFC\uBB34\xB7\uC2B9\uC778",
    path: "/team-manager",
    devPort: 4004,
    icon: "ic-approval",
    hidden: true
  },
  {
    id: "general-affairs",
    group: "\uC5C5\uBB34 & \uC790\uC6D0",
    title: "\uCD1D\uBB34",
    desc: "\uAD50\uC721\xB7\uC815\uAE30\uC5C5\uBB34\xB7\uACF5\uC9C0",
    path: "/general-affairs",
    devPort: 4005,
    icon: "ic-clipboard"
  },
  {
    id: "inventory",
    group: "\uC5C5\uBB34 & \uC790\uC6D0",
    title: "\uC7AC\uACE0\uAD00\uB9AC",
    desc: "\uBB3C\uD488\xB7\uC720\uD1B5\uAE30\uD55C\xB7\uD658\uBD88",
    path: "/inventory",
    devPort: 4007,
    icon: "ic-cube",
    disabled: true,
    badge: "Coming soon"
  }
];
var PRIVATE_IP = /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/;
function isDevHost(hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname.endsWith(".local") || PRIVATE_IP.test(hostname);
}
__name(isDevHost, "isDevHost");
function buildHref(path, devPort) {
  const { protocol, hostname, origin } = window.location;
  if (isDevHost(hostname)) {
    return `${protocol}//${hostname}:${devPort}`;
  }
  return `${origin}${path}`;
}
__name(buildHref, "buildHref");
function workspaceSwitcherComponent(opts = {}) {
  const current2 = opts.current ?? "";
  return {
    open: false,
    items: ITEMS,
    /**
    * Flat render list: alternates between group-label / divider / item
    * entries. Avoids nested <template x-for> which has known fragility
    * inside an outer x-for's wrapper element in Alpine v3.
    */
    get entries() {
      const out = [];
      let lastGroup = null;
      for (const item of ITEMS) {
        if (item.group !== lastGroup) {
          if (lastGroup !== null) {
            out.push({
              kind: "divider",
              key: `div-${item.group}`
            });
          }
          out.push({
            kind: "group",
            key: `grp-${item.group}`,
            label: item.group
          });
          lastGroup = item.group;
        }
        out.push({
          kind: "item",
          key: `itm-${item.id}`,
          item
        });
      }
      return out;
    },
    get currentItem() {
      return ITEMS.find((i) => i.id === current2);
    },
    get triggerLabel() {
      return this.currentItem?.title ?? "Workspace";
    },
    iconFor(name) {
      return getIcon(name);
    },
    isCurrent(itemId) {
      return itemId === current2;
    },
    hrefFor(item) {
      if (item.disabled) {
        return "#";
      }
      return buildHref(item.path, item.devPort);
    },
    toggle() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
    handleItemClick(event, item) {
      if (item.disabled) {
        event.preventDefault();
        return;
      }
      this.close();
    }
  };
}
__name(workspaceSwitcherComponent, "workspaceSwitcherComponent");

// src/components/ApprovalReplace.ts
import { approvalReplaceHint } from "@hereby/core/constants";
var APPROVAL_REPLACE_OPEN_EVENT = "hereby:approval-replace-open";
var APPROVAL_REPLACE_STATE_EVENT = "hereby:approval-replace-state";
var APPROVAL_REPLACED_EVENT = "hereby:approval-replaced";
function approvalReplaceMessage(result) {
  const head = `${result.stepOrder}\uB2E8\uACC4 \uACB0\uC7AC\uC790\uB97C ${result.from.name} \uB2D8\uC5D0\uC11C ${result.to.name} \uB2D8\uC73C\uB85C \uBC14\uAFE8\uC5B4\uC694.`;
  return result.notified ? `${head} ${result.to.name} \uB2D8\uC5D0\uAC8C \uC54C\uB838\uC5B4\uC694.` : head;
}
__name(approvalReplaceMessage, "approvalReplaceMessage");
function requestApprovalReplace(detail) {
  window.dispatchEvent(new CustomEvent(APPROVAL_REPLACE_OPEN_EVENT, {
    detail
  }));
}
__name(requestApprovalReplace, "requestApprovalReplace");
function bindApprovalReplaceHost(handlers) {
  const onState = /* @__PURE__ */ __name((e) => handlers.onState?.(e.detail.open), "onState");
  const onReplaced = /* @__PURE__ */ __name((e) => {
    Promise.resolve(handlers.onReplaced?.(e.detail)).catch(() => void 0);
  }, "onReplaced");
  window.addEventListener(APPROVAL_REPLACE_STATE_EVENT, onState);
  window.addEventListener(APPROVAL_REPLACED_EVENT, onReplaced);
  return () => {
    window.removeEventListener(APPROVAL_REPLACE_STATE_EVENT, onState);
    window.removeEventListener(APPROVAL_REPLACED_EVENT, onReplaced);
  };
}
__name(bindApprovalReplaceHost, "bindApprovalReplaceHost");
function approvalReplaceComponent() {
  return {
    isOpen: false,
    step: null,
    ref: null,
    loading: false,
    busy: false,
    candidates: [],
    /** 공용 대상 선택기의 선택(x-modelable) — 한 명 */
    picked: [],
    /** 공용 대상 선택기에 넣을 후보(사번 없이 「팀 · 직책」) */
    employees() {
      return this.candidates.map((c) => ({
        id: c.employeeId,
        name: c.name,
        employeeNumber: null,
        teamIds: [],
        teamNames: c.teams,
        jobDuty: c.title
      }));
    },
    title() {
      return this.step ? `\uACB0\uC7AC\uC790 \uBC14\uAFB8\uAE30 \u2014 ${this.step.stepOrder}\uB2E8\uACC4` : "\uACB0\uC7AC\uC790 \uBC14\uAFB8\uAE30";
    },
    /** 지금 결재자 — 「최급여 · 인사 관리자」 */
    current() {
      const step = this.step;
      if (!step) {
        return "";
      }
      return step.approverTitle ? `${step.approverName} \xB7 ${step.approverTitle}` : step.approverName;
    },
    _sdk() {
      return herebyStore(this).sdk;
    },
    _emitState(open) {
      window.dispatchEvent(new CustomEvent(APPROVAL_REPLACE_STATE_EVENT, {
        detail: {
          open
        }
      }));
    },
    _reset() {
      this.isOpen = false;
      this.step = null;
      this.ref = null;
      this.loading = false;
      this.busy = false;
      this.candidates = [];
      this.picked = [];
    },
    async openReplace(detail) {
      if (!(detail?.step && detail.ref)) {
        return;
      }
      this._reset();
      this.isOpen = true;
      this.step = detail.step;
      this.ref = detail.ref;
      this.loading = true;
      this._emitState(true);
      try {
        const { candidates } = await this._sdk().approvalFlow.replaceCandidates(detail.ref.requestType, detail.ref.requestId);
        if (this.isOpen) {
          this.candidates = candidates;
        }
      } catch (err) {
        this.closeReplace();
        showError(err instanceof Error ? err.message : "\uD6C4\uBCF4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694.");
      } finally {
        this.loading = false;
      }
    },
    closeReplace() {
      if (this.busy) {
        return;
      }
      const wasOpen = this.isOpen;
      this._reset();
      if (wasOpen) {
        this._emitState(false);
      }
    },
    /** 고른 한 명으로 바꾸기 — 확인창 → 서버 → 호스트에 결과. 실패해도 호스트가 재조회한다(단계가 이미 처리됐을 수 있다) */
    async confirmReplace() {
      const { step, ref, busy } = this;
      const pick = this.picked[0];
      if (!(step && ref && pick) || busy) {
        return;
      }
      const to = this.candidates.find((c) => c.employeeId === pick.id);
      if (!to) {
        return;
      }
      const ok = await askConfirm({
        message: approvalReplaceHint(step, to.name),
        confirmLabel: "\uBC14\uAFB8\uAE30"
      });
      if (!ok) {
        return;
      }
      this.busy = true;
      let detail;
      try {
        const result = await this._sdk().approvalFlow.replaceApprover({
          requestType: ref.requestType,
          requestId: ref.requestId,
          stepId: step.id,
          newApproverId: to.employeeId
        });
        detail = {
          ref,
          result,
          message: approvalReplaceMessage(result)
        };
      } catch (err) {
        detail = {
          ref,
          result: null,
          message: null
        };
        showError(err instanceof Error ? err.message : "\uACB0\uC7AC\uC790\uB97C \uBC14\uAFB8\uC9C0 \uBABB\uD588\uC5B4\uC694.");
      }
      this.busy = false;
      this.closeReplace();
      window.dispatchEvent(new CustomEvent(APPROVAL_REPLACED_EVENT, {
        detail
      }));
    }
  };
}
__name(approvalReplaceComponent, "approvalReplaceComponent");

// src/components/ImpersonationBanner.ts
init_dist();
function impersonationBannerState(currentUser, isTopLevel) {
  const hidden = {
    visible: false,
    targetName: "",
    roleLabel: "",
    actorName: "",
    expiresAt: null
  };
  if (!(currentUser && isTopLevel) || currentUser.impersonating !== true) {
    return hidden;
  }
  const meta = currentUser.impersonation;
  if (!meta || meta.origin !== "ORG_DEBUG") {
    return hidden;
  }
  const expires = meta.expiresAt ? new Date(meta.expiresAt).getTime() : Number.NaN;
  return {
    visible: true,
    targetName: meta.targetName || currentUser.impersonatedEmployeeName || "",
    roleLabel: (meta.targetRoles ?? []).map((r) => r.name).join(", "),
    actorName: meta.actorName ?? "",
    expiresAt: Number.isFinite(expires) ? expires : null
  };
}
__name(impersonationBannerState, "impersonationBannerState");
function formatRemaining(expiresAt, now) {
  if (expiresAt === null) {
    return "";
  }
  const total = Math.max(0, Math.floor((expiresAt - now) / 1e3));
  const h = Math.floor(total / 3600);
  const m = Math.floor(total % 3600 / 60);
  const s = total % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
__name(formatRemaining, "formatRemaining");
function isRemainingUrgent(expiresAt, now) {
  return expiresAt !== null && expiresAt - now < 5 * 6e4;
}
__name(isRemainingUrgent, "isRemainingUrgent");
function isTopLevelWindow() {
  try {
    return typeof window === "undefined" || window.top === window;
  } catch {
    return false;
  }
}
__name(isTopLevelWindow, "isTopLevelWindow");
function syncImpersonationBodyClass(visible, body = typeof document === "undefined" ? null : document.body) {
  body?.classList.toggle("ds-impersonating", visible);
}
__name(syncImpersonationBodyClass, "syncImpersonationBodyClass");
function impersonationBannerComponent() {
  return {
    now: Date.now(),
    ending: false,
    /** 복귀 직후 도착한 앱이 한 번 보여 주는 안내 */
    notice: "",
    timerHandle: null,
    init() {
      this.notice = takeImpersonationNotice() ?? "";
      if (this.notice) {
        setTimeout(() => {
          this.notice = "";
        }, 6e3);
      }
      this.timerHandle = setInterval(() => {
        this.now = Date.now();
      }, 1e3);
      syncImpersonationBodyClass(this.state.visible);
      this.$watch("state.visible", (visible) => syncImpersonationBodyClass(visible));
    },
    destroy() {
      if (this.timerHandle) {
        clearInterval(this.timerHandle);
      }
      syncImpersonationBodyClass(false);
    },
    get state() {
      return impersonationBannerState(herebyStore(this).currentUser, isTopLevelWindow());
    },
    get remaining() {
      return formatRemaining(this.state.expiresAt, this.now);
    },
    get urgent() {
      return isRemainingUrgent(this.state.expiresAt, this.now);
    },
    /** [종료] — 서버 회수 뒤 원래 세션으로. 서버가 실패해도 로컬은 되돌린다 */
    async endPreview() {
      if (this.ending) {
        return;
      }
      this.ending = true;
      const store = herebyStore(this);
      try {
        await store.sdk.impersonation.end();
      } catch {
      }
      const saved = readImpersonationReturn();
      const outcome = restoreImpersonationReturn(store.sdk, IMPERSONATION_ENDED_NOTICE);
      const fallback = `${window.location.origin}/admin/#employees`;
      navigateAfterImpersonationExit(outcome.restored ? saved?.returnUrl || fallback : `${window.location.origin}/admin/`);
    }
  };
}
__name(impersonationBannerComponent, "impersonationBannerComponent");

// src/embed-modal-center.ts
var EDGE = 32;
var EDGE_Y = 8;
var FILL_EDGE_Y = 48;
var MIN_WIDTH_RATIO = 0.9;
function clampShift(diff, room) {
  const limit = Math.max(0, room);
  if (diff > 0) {
    return Math.min(diff, limit);
  }
  if (diff < 0) {
    return -Math.min(-diff, limit);
  }
  return 0;
}
__name(clampShift, "clampShift");
function computeCenterShift(gaps, frame, modal) {
  const diffX = gaps.left - gaps.right;
  const widthAfterFullShift = frame.width - Math.abs(diffX) - EDGE;
  const x = widthAfterFullShift >= modal.width * MIN_WIDTH_RATIO ? diffX : clampShift(diffX, frame.width - modal.width - EDGE);
  return {
    x,
    y: clampShift(gaps.top - gaps.bottom, frame.height - modal.height - EDGE_Y)
  };
}
__name(computeCenterShift, "computeCenterShift");
var MIN_FIT_HEIGHT = 320;
function computeFitMaxHeight(gaps, frame) {
  return Math.max(MIN_FIT_HEIGHT, frame.height - Math.abs(gaps.top - gaps.bottom) - EDGE_Y);
}
__name(computeFitMaxHeight, "computeFitMaxHeight");
function computeFillMaxHeight(frame) {
  return Math.max(MIN_FIT_HEIGHT, frame.height - FILL_EDGE_Y);
}
__name(computeFillMaxHeight, "computeFillMaxHeight");
function resolveFitMaxHeight(fit, originalMax) {
  return originalMax !== null && originalMax < fit ? originalMax : fit;
}
__name(resolveFitMaxHeight, "resolveFitMaxHeight");
var EMBED_BACKDROP_SELECTOR = ".ds-modal-backdrop, [data-embed-center]";
function findCard(backdrop) {
  if (backdrop.classList.contains("ds-modal-backdrop--white")) {
    return null;
  }
  for (const child of Array.from(backdrop.children)) {
    if (child instanceof HTMLElement && child.tagName !== "TEMPLATE" && child.getClientRects().length > 0) {
      return child;
    }
  }
  return null;
}
__name(findCard, "findCard");
function originalMaxHeight(card) {
  if (card.dataset.embedOrigMax === void 0) {
    const v = Number.parseFloat(window.getComputedStyle(card).maxHeight);
    card.dataset.embedOrigMax = Number.isFinite(v) ? String(v) : "";
  }
  const saved = card.dataset.embedOrigMax;
  return saved ? Number(saved) : null;
}
__name(originalMaxHeight, "originalMaxHeight");
function isEmbedGaps(v) {
  if (!v || typeof v !== "object") {
    return false;
  }
  const o = v;
  return [
    "left",
    "top",
    "right",
    "bottom"
  ].every((k) => typeof o[k] === "number" && Number.isFinite(o[k]));
}
__name(isEmbedGaps, "isEmbedGaps");
function setIfChanged(style, prop, value) {
  if (style[prop] !== value) {
    style[prop] = value;
  }
}
__name(setIfChanged, "setIfChanged");
function naturalModalSize(modal, frameWidth) {
  const rect = modal.getBoundingClientRect();
  const maxW = Number.parseFloat(window.getComputedStyle(modal).maxWidth);
  const width = Number.isFinite(maxW) ? Math.min(maxW, frameWidth - EDGE) : rect.width;
  return {
    width,
    height: rect.height
  };
}
__name(naturalModalSize, "naturalModalSize");
function setupEmbedModalCentering() {
  if (window.parent === window) {
    return;
  }
  let gaps = null;
  let lastRequestAt = 0;
  const request3 = /* @__PURE__ */ __name(() => {
    lastRequestAt = Date.now();
    window.parent.postMessage({
      type: "hereby:tm:embed-gaps-request"
    }, "*");
  }, "request");
  const apply = /* @__PURE__ */ __name(() => {
    if (!gaps) {
      const anyOpen = Array.from(document.querySelectorAll(EMBED_BACKDROP_SELECTOR)).some((b) => findCard(b) !== null);
      if (anyOpen && Date.now() - lastRequestAt > 1e3) {
        request3();
      }
      return;
    }
    const sbX = window.innerWidth - document.documentElement.clientWidth;
    const sbY = window.innerHeight - document.documentElement.clientHeight;
    const frameGaps = {
      ...gaps,
      right: gaps.right + sbX,
      bottom: gaps.bottom + sbY
    };
    const frame = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
    for (const el2 of Array.from(document.querySelectorAll(EMBED_BACKDROP_SELECTOR))) {
      const modal = findCard(el2);
      if (!modal) {
        continue;
      }
      const fitPx = modal.dataset.embedFill !== void 0 ? computeFillMaxHeight(frame) : resolveFitMaxHeight(computeFitMaxHeight(frameGaps, frame), originalMaxHeight(modal));
      const fit = `${fitPx}px`;
      if (modal.style.maxHeight !== fit) {
        modal.style.maxHeight = fit;
      }
      if (modal.dataset.embedFill !== void 0 && modal.style.height !== fit) {
        modal.style.height = fit;
      }
      if (modal.dataset.embedOrigMin === void 0) {
        modal.dataset.embedOrigMin = modal.style.minHeight || window.getComputedStyle(modal).minHeight;
      }
      const origMin = modal.dataset.embedOrigMin;
      const minH = origMin && origMin !== "0px" && origMin !== "auto" ? `min(${origMin}, ${fit})` : "";
      if (minH && modal.dataset.embedMinSet !== minH) {
        modal.dataset.embedMinSet = minH;
        modal.style.minHeight = minH;
      }
      if (modal.scrollHeight > modal.clientHeight + 1 && window.getComputedStyle(modal).overflowY === "visible") {
        modal.style.overflowY = "auto";
      }
      const shift = computeCenterShift(frameGaps, frame, naturalModalSize(modal, frame.width));
      setIfChanged(el2.style, "paddingRight", shift.x > 0 ? `${shift.x}px` : "0px");
      setIfChanged(el2.style, "paddingLeft", shift.x < 0 ? `${-shift.x}px` : "0px");
      setIfChanged(el2.style, "paddingBottom", shift.y > 0 ? `${shift.y}px` : "0px");
      setIfChanged(el2.style, "paddingTop", shift.y < 0 ? `${-shift.y}px` : "0px");
    }
  }, "apply");
  let timer;
  const schedule2 = /* @__PURE__ */ __name(() => {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, 0);
  }, "schedule");
  window.addEventListener("message", (e) => {
    if (e.source !== window.parent) {
      return;
    }
    const data = e.data;
    if (data?.type === "hereby:embed:gaps" && isEmbedGaps(data.gaps)) {
      gaps = data.gaps;
      schedule2();
    }
  });
  window.addEventListener("resize", () => {
    request3();
    schedule2();
  });
  new MutationObserver(schedule2).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true
  });
  request3();
}
__name(setupEmbedModalCentering, "setupEmbedModalCentering");

// src/embed-org-guard.ts
var REQUEST = "hereby:embed:org?";
var REPLY = "hereby:embed:org";
function isOrgMismatch(a, b) {
  if (!(a?.organizationId && b?.organizationId)) {
    return false;
  }
  return a.organizationId !== b.organizationId;
}
__name(isOrgMismatch, "isOrgMismatch");
function publishEmbedOrg(read) {
  const onMessage = /* @__PURE__ */ __name((e) => {
    if (e.data?.type !== REQUEST) {
      return;
    }
    const org = read();
    if (!org?.organizationId) {
      return;
    }
    e.source?.postMessage({
      type: REPLY,
      ...org
    }, e.origin);
  }, "onMessage");
  window.addEventListener("message", onMessage);
  return () => window.removeEventListener("message", onMessage);
}
__name(publishEmbedOrg, "publishEmbedOrg");
function guardEmbeddedOrg(readMine, onMismatch, opts = {}) {
  if (typeof window === "undefined" || window.parent === window) {
    return () => {
    };
  }
  const pollMs = opts.pollMs ?? 500;
  const timeoutMs = opts.timeoutMs ?? 15e3;
  let parentOrg = null;
  let done = false;
  let timer = null;
  const stop = /* @__PURE__ */ __name(() => {
    done = true;
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    window.removeEventListener("message", onMessage);
  }, "stop");
  function check() {
    if (done || !parentOrg) {
      return;
    }
    const mine = readMine();
    if (!mine?.organizationId) {
      return;
    }
    stop();
    if (isOrgMismatch(parentOrg, mine)) {
      onMismatch(parentOrg, mine);
    }
  }
  __name(check, "check");
  function onMessage(e) {
    const data = e.data;
    if (data?.type !== REPLY || !data.organizationId) {
      return;
    }
    parentOrg = {
      organizationId: data.organizationId,
      organizationName: data.organizationName
    };
    check();
  }
  __name(onMessage, "onMessage");
  window.addEventListener("message", onMessage);
  const started = Date.now();
  const ask = /* @__PURE__ */ __name(() => {
    if (done) {
      return;
    }
    if (Date.now() - started > timeoutMs) {
      stop();
      return;
    }
    if (!parentOrg) {
      window.parent.postMessage({
        type: REQUEST
      }, "*");
    }
    check();
  }, "ask");
  ask();
  timer = setInterval(ask, pollMs);
  return stop;
}
__name(guardEmbeddedOrg, "guardEmbeddedOrg");

// src/embed-scroll-reset.ts
var EMBED_RESET_SCROLL_MESSAGE = "hereby:embed:reset-scroll";
function resetScrollPositions(root = document) {
  for (const el2 of Array.from(root.querySelectorAll("[x-page-scroll], .overflow-auto, .overflow-y-auto, .overflow-x-auto, .overflow-scroll"))) {
    el2.scrollTop = 0;
    el2.scrollLeft = 0;
  }
}
__name(resetScrollPositions, "resetScrollPositions");
function setupEmbedScrollReset() {
  if (window.parent === window) {
    return;
  }
  window.addEventListener("message", (e) => {
    if (e.source !== window.parent) {
      return;
    }
    const data = e.data;
    if (data?.type !== EMBED_RESET_SCROLL_MESSAGE) {
      return;
    }
    window.scrollTo(0, 0);
    resetScrollPositions();
  });
}
__name(setupEmbedScrollReset, "setupEmbedScrollReset");

// src/employee-card.ts
var actions = {};
var anchorEl = null;
var cardResizeObserved = /* @__PURE__ */ new WeakSet();
function setAnchor(next) {
  anchorEl?.setAttribute("aria-expanded", "false");
  anchorEl = next;
  anchorEl?.setAttribute("aria-expanded", "true");
}
__name(setAnchor, "setAnchor");
function registerEmployeeCardActions(next) {
  actions = {
    ...next
  };
}
__name(registerEmployeeCardActions, "registerEmployeeCardActions");
function employeeCardStatusClass(status) {
  const map2 = {
    ACTIVE: "ds-label--green",
    INACTIVE: "ds-label--light-gray",
    ON_LEAVE: "ds-label--yellow",
    TERMINATED: "ds-label--red"
  };
  return map2[status] || "ds-label--gray";
}
__name(employeeCardStatusClass, "employeeCardStatusClass");
function errorCode(err) {
  return err?.data?.code ?? "";
}
__name(errorCode, "errorCode");
function createEmployeeCardStore(getSdk) {
  let seq = 0;
  return {
    open: false,
    employeeId: "",
    from: "",
    name: "",
    state: "idle",
    data: null,
    /** 이름 클릭 — 같은 이름을 다시 누르면 닫는다 */
    async show(employeeId, anchor, opts = {}) {
      if (!employeeId) {
        return;
      }
      if (this.open && this.employeeId === employeeId && anchorEl === anchor) {
        this.close();
        return;
      }
      setAnchor(anchor);
      this.employeeId = employeeId;
      this.from = opts.from ?? "";
      this.name = opts.name ?? "";
      this.data = null;
      this.state = "loading";
      this.open = true;
      const mine = ++seq;
      const sdk = getSdk();
      if (!sdk) {
        this.state = "error";
        return;
      }
      try {
        const data = await sdk.employee.getEmployeeCard(employeeId);
        if (mine !== seq) {
          return;
        }
        this.data = data;
        this.state = data ? "ready" : "missing";
      } catch (err) {
        if (mine !== seq) {
          return;
        }
        this.state = errorCode(err) === "FORBIDDEN" ? "denied" : "error";
      }
    },
    close() {
      seq += 1;
      setAnchor(null);
      this.open = false;
      this.employeeId = "";
      this.data = null;
      this.state = "idle";
    },
    /** 카드를 누른 이름 아래에 붙인다 — 화면 밖으로 나가지 않게 공용 배치 함수가 맞춘다.
    *  카드 높이가 바뀌면(불러오는 중 → 내용 · 안내) 다시 붙인다. 아래 공간이 모자라 이름 **위**에 띄울 때는
    *  위치가 높이에 달려 있어, 처음(불러오는 중) 높이로 잡은 자리에 그대로 두면 카드가 줄어든 만큼 이름에서
    *  떨어져 떴다(근태 › 연차현황 아래쪽 행에서 160px, 2026-10-21 실측). */
    position(cardEl) {
      if (!cardEl) {
        return;
      }
      if (anchorEl?.isConnected) {
        positionFloatingMenu(anchorEl, cardEl);
      }
      if (!cardResizeObserved.has(cardEl) && typeof ResizeObserver === "function") {
        cardResizeObserved.add(cardEl);
        new ResizeObserver(() => {
          if (this.open && anchorEl?.isConnected) {
            positionFloatingMenu(anchorEl, cardEl);
          }
        }).observe(cardEl);
      }
    },
    /** 이 이름의 카드가 열려 있는가 — 트리거의 aria-expanded 용 */
    isOpenFor(employeeId) {
      return this.open && this.employeeId === employeeId;
    },
    get displayName() {
      return this.data?.name || this.name;
    },
    get showTeams() {
      return this.from !== "teams";
    },
    get showWards() {
      return this.from !== "wards";
    },
    canEdit() {
      return !!actions.edit;
    },
    canGoTeam() {
      return !!actions.goTeam;
    },
    canGoWard() {
      return !!actions.goWard;
    },
    /** 「스케줄러 보기」 — 근무표에서 연 카드에서는 숨긴다. 병동 배정이 여럿이면 첫 번째 병동 */
    schedulerWardId() {
      if (!actions.goScheduler || this.from === "scheduler") {
        return "";
      }
      return this.data?.wards[0]?.wardId ?? "";
    },
    /**
    * ⚠️ 동작을 **먼저** 부르고 닫는다. 카드 안쪽은 x-if 라 닫는 순간 누른 버튼이 DOM 에서 빠지고,
    * 동작이 그 버튼 자리에서 이벤트를 쏘면 떨어져 나간 요소의 이벤트는 window 까지 못 간다
    * (2026-09-23 실측: 직원 정보 수정 패널이 오류 없이 안 열렸다).
    */
    async edit() {
      const id = this.employeeId;
      await actions.edit?.(id);
      this.close();
    },
    goTeam(teamId) {
      const id = this.employeeId;
      actions.goTeam?.(teamId, id);
      this.close();
    },
    goWard(wardId) {
      const id = this.employeeId;
      actions.goWard?.(wardId, id);
      this.close();
    },
    goScheduler() {
      const id = this.employeeId;
      const wardId = this.schedulerWardId();
      if (wardId) {
        actions.goScheduler?.(wardId, id);
      }
      this.close();
    },
    statusClass(status) {
      return employeeCardStatusClass(status);
    }
  };
}
__name(createEmployeeCardStore, "createEmployeeCardStore");

// src/filter-bar.ts
var BAR_SELECTOR = ".ds-filter-bar";
var COMPACT_CLASS = "is-compact";
var LEFT_COMPACT_CLASS = "is-left-compact";
var DENSE_OPT_CLASS = "ds-filter-bar--dense";
var COLLAPSIBLE_CLASS = "is-collapsible";
var STACKED_CLASS = "is-stacked";
var HAS_ICON_CLASS2 = "has-ico";
var MEASURING_CLASS = "is-measuring";
var OPEN_CLASS = "is-open";
var BOUND_ATTR = "data-ds-filter-bar-bound";
var AUTO_TIP_ATTR2 = "data-ds-filter-auto-tip";
var MIN_STRIP_PX = 200;
var BAR_GAP_PX = 8;
var NAV_STEP_RATIO = 0.8;
var SCROLL_EPS_PX2 = 2;
var MAX_LABEL_CHARS = 4;
var ELLIPSIS2 = "\u2026";
var RESCAN_DELAY_MS = 120;
var POPUP_PAIRS = [
  {
    host: ".ms-dropdown.is-open",
    trigger: ".ms-dropdown__trigger",
    menu: ".ms-dropdown__menu"
  }
];
var bound = /* @__PURE__ */ new Map();
var installed2 = false;
var rescanTimer = null;
function el(host2, selector) {
  const found = host2.querySelector(selector);
  return found instanceof HTMLElement ? found : null;
}
__name(el, "el");
function applyMode(b, mode) {
  const bar = b.el;
  const left = mode !== "full";
  bar.classList.toggle(LEFT_COMPACT_CLASS, left);
  bar.classList.toggle(COMPACT_CLASS, mode === "compact");
  bar.classList.toggle(STACKED_CLASS, mode === "stacked");
  syncSearchCollapsible(b, left);
  fitControls(b, left);
}
__name(applyMode, "applyMode");
function syncSearchCollapsible(b, collapsible) {
  b.search?.classList.toggle(COLLAPSIBLE_CLASS, collapsible);
}
__name(syncSearchCollapsible, "syncSearchCollapsible");
function innerWidth(bar) {
  const style = getComputedStyle(bar);
  return bar.clientWidth - Number.parseFloat(style.paddingLeft) - Number.parseFloat(style.paddingRight);
}
__name(innerWidth, "innerWidth");
function contentWidth(bar) {
  const gap = Number.parseFloat(getComputedStyle(bar).columnGap) || 0;
  let total = 0;
  let count = 0;
  for (const child of Array.from(bar.children)) {
    if (!(child instanceof HTMLElement) || getComputedStyle(child).display === "none") {
      continue;
    }
    total += child.getBoundingClientRect().width;
    count += 1;
  }
  return total + gap * Math.max(0, count - 1);
}
__name(contentWidth, "contentWidth");
var FIT_EPS_PX = 0.5;
function decide(b) {
  const bar = b.el;
  const prev = bar.classList.contains(STACKED_CLASS) ? "stacked" : bar.classList.contains(COMPACT_CLASS) ? "compact" : bar.classList.contains(LEFT_COMPACT_CLASS) ? "dense" : "full";
  const denseOptIn = bar.classList.contains(DENSE_OPT_CLASS);
  bar.classList.add(MEASURING_CLASS);
  applyMode(b, "full");
  const container = innerWidth(bar);
  let state3 = null;
  if (bar.clientWidth <= 0) {
    state3 = prev;
  } else if (!denseOptIn && contentWidth(bar) <= container + FIT_EPS_PX) {
    state3 = "full";
  } else {
    applyMode(b, "dense");
    if (contentWidth(bar) <= container + FIT_EPS_PX) {
      state3 = "dense";
    } else {
      applyMode(b, "compact");
      const actionsCompact = b.actions ? b.actions.offsetWidth : 0;
      const stripNatural = b.scroller ? b.scroller.scrollWidth : 0;
      const minStrip = Math.min(MIN_STRIP_PX, stripNatural);
      state3 = actionsCompact + minStrip + BAR_GAP_PX > container ? "stacked" : "compact";
    }
  }
  bar.classList.remove(MEASURING_CLASS);
  applyMode(b, state3);
  return state3;
}
__name(decide, "decide");
var measureCtx;
function textWidth(text, style) {
  if (measureCtx === void 0) {
    measureCtx = document.createElement("canvas").getContext("2d");
  }
  if (!measureCtx) {
    return 0;
  }
  measureCtx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
  return measureCtx.measureText(text).width;
}
__name(textWidth, "textWidth");
function shortLabel(text) {
  const chars = Array.from(text.trim());
  return chars.length > MAX_LABEL_CHARS ? chars.slice(0, MAX_LABEL_CHARS).join("") + ELLIPSIS2 : chars.join("");
}
__name(shortLabel, "shortLabel");
function fitControls(b, compact) {
  const scroller = b.scroller;
  if (!scroller) {
    return;
  }
  for (const sel of Array.from(scroller.querySelectorAll("select"))) {
    const text = sel.options[sel.selectedIndex]?.text ?? "";
    if (!(compact && text.trim())) {
      sel.style.removeProperty("width");
      continue;
    }
    const style = getComputedStyle(sel);
    const chrome = Number.parseFloat(style.paddingLeft) + Number.parseFloat(style.paddingRight) + Number.parseFloat(style.borderLeftWidth) + Number.parseFloat(style.borderRightWidth);
    sel.style.width = `${Math.ceil(textWidth(shortLabel(text), style) + chrome) + 1}px`;
  }
  for (const label of Array.from(scroller.querySelectorAll(".ms-dropdown__label"))) {
    if (!(label instanceof HTMLElement)) {
      continue;
    }
    const text = label.textContent ?? "";
    if (!(compact && text.trim())) {
      label.style.removeProperty("max-width");
      continue;
    }
    label.style.maxWidth = `${Math.ceil(textWidth(shortLabel(text), getComputedStyle(label))) + 1}px`;
  }
}
__name(fitControls, "fitControls");
function syncActionTips(b, compact) {
  if (!b.actions) {
    return;
  }
  for (const btn of Array.from(b.actions.querySelectorAll(".ds-btn"))) {
    if (!(btn instanceof HTMLElement)) {
      continue;
    }
    const hasIcon2 = btn.querySelector(".ds-ico") !== null;
    btn.classList.toggle(HAS_ICON_CLASS2, hasIcon2);
    if (!hasIcon2) {
      continue;
    }
    if (compact) {
      if (btn.hasAttribute("title") || btn.hasAttribute(AUTO_TIP_ATTR2)) {
        continue;
      }
      const label = Array.from(btn.children).filter((c) => !c.classList.contains("ds-ico")).map((c) => c.textContent?.trim() ?? "").filter(Boolean).join(" ");
      if (!label) {
        continue;
      }
      btn.setAttribute("title", label);
      btn.setAttribute("data-ds-tip", "top");
      btn.setAttribute(AUTO_TIP_ATTR2, "1");
    } else if (btn.hasAttribute(AUTO_TIP_ATTR2)) {
      btn.removeAttribute("title");
      btn.removeAttribute("data-ds-tip");
      btn.removeAttribute("data-tip-title");
      btn.removeAttribute(AUTO_TIP_ATTR2);
    }
  }
}
__name(syncActionTips, "syncActionTips");
function buildSearchParts(b) {
  const wrap = b.search;
  const input = b.searchInput;
  if (!(wrap && input) || wrap.querySelector(".ds-filter-search__toggle")) {
    return;
  }
  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = "ds-filter-search__toggle";
  toggle.setAttribute("aria-label", "\uAC80\uC0C9");
  toggle.setAttribute("title", "\uAC80\uC0C9");
  toggle.setAttribute("data-ds-tip", "top");
  toggle.innerHTML = `<span class="ds-ico" aria-hidden="true">${getIcon("ic-search")}</span>`;
  toggle.addEventListener("click", () => {
    wrap.classList.add(OPEN_CLASS);
    input.focus();
  });
  const clear = document.createElement("button");
  clear.type = "button";
  clear.className = "ds-filter-search__clear";
  clear.setAttribute("aria-label", "\uAC80\uC0C9\uC5B4 \uC9C0\uC6B0\uAE30");
  clear.setAttribute("title", "\uAC80\uC0C9\uC5B4 \uC9C0\uC6B0\uAE30");
  clear.setAttribute("data-ds-tip", "top");
  clear.innerHTML = `<span class="ds-ico" aria-hidden="true">${getIcon("ic-close")}</span>`;
  clear.addEventListener("click", () => {
    clearSearch(input);
    input.focus();
  });
  const cancel = document.createElement("button");
  cancel.type = "button";
  cancel.className = "ds-filter-search__cancel";
  cancel.textContent = "\uCDE8\uC18C";
  cancel.addEventListener("click", () => {
    clearSearch(input);
    wrap.classList.remove(OPEN_CLASS);
  });
  wrap.insertBefore(toggle, wrap.firstChild);
  input.insertAdjacentElement("afterend", clear);
  wrap.appendChild(cancel);
  input.addEventListener("input", () => {
    syncSearchOpen(b);
  });
  input.addEventListener("keydown", (ev) => {
    if (ev.key !== "Escape") {
      return;
    }
    clearSearch(input);
    wrap.classList.remove(OPEN_CLASS);
    input.blur();
  });
}
__name(buildSearchParts, "buildSearchParts");
function clearSearch(input) {
  if (!input.value) {
    return;
  }
  input.value = "";
  input.dispatchEvent(new Event("input", {
    bubbles: true
  }));
}
__name(clearSearch, "clearSearch");
function syncSearchOpen(b) {
  if (!(b.search && b.searchInput)) {
    return;
  }
  const hasValue = b.searchInput.value.length > 0;
  b.search.classList.toggle("has-value", hasValue);
  if (hasValue) {
    b.search.classList.add(OPEN_CLASS);
  }
}
__name(syncSearchOpen, "syncSearchOpen");
function buildNav(b) {
  const filters = b.filters;
  const scroller = b.scroller;
  if (!(filters && scroller) || filters.querySelector(".ds-filter-bar__nav")) {
    return;
  }
  for (const dir of [
    "prev",
    "next"
  ]) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `ds-filter-bar__nav ds-filter-bar__nav--${dir} ds-r-999`;
    btn.setAttribute("aria-label", dir === "prev" ? "\uC774\uC804 \uD544\uD130 \uBCF4\uAE30" : "\uB2E4\uC74C \uD544\uD130 \uBCF4\uAE30");
    btn.tabIndex = -1;
    const icon = dir === "prev" ? "ic-chevron-left" : "ic-chevron-right";
    btn.innerHTML = `<span class="ds-ico" aria-hidden="true">${getIcon(icon)}</span>`;
    btn.addEventListener("click", () => {
      const step = Math.max(80, scroller.clientWidth * NAV_STEP_RATIO);
      scroller.scrollBy({
        left: dir === "prev" ? -step : step,
        behavior: "smooth"
      });
    });
    filters.appendChild(btn);
  }
}
__name(buildNav, "buildNav");
function syncNav(b) {
  const filters = b.filters;
  const scroller = b.scroller;
  if (!(filters && scroller)) {
    return;
  }
  const scrollable = b.el.classList.contains(LEFT_COMPACT_CLASS);
  const max = scroller.scrollWidth - scroller.clientWidth;
  filters.classList.toggle("can-scroll-prev", scrollable && scroller.scrollLeft > SCROLL_EPS_PX2);
  filters.classList.toggle("can-scroll-next", scrollable && max > SCROLL_EPS_PX2 && scroller.scrollLeft < max - SCROLL_EPS_PX2);
}
__name(syncNav, "syncNav");
function repositionPopups(b) {
  const scroller = b.scroller;
  if (!scroller) {
    return;
  }
  if (!b.el.classList.contains(LEFT_COMPACT_CLASS)) {
    return;
  }
  for (const pair of POPUP_PAIRS) {
    for (const host2 of Array.from(scroller.querySelectorAll(pair.host))) {
      positionFloatingMenu(host2.querySelector(pair.trigger), host2.querySelector(pair.menu));
    }
  }
  for (const menu of Array.from(scroller.querySelectorAll(".ds-menu"))) {
    if (menu.offsetParent === null) {
      continue;
    }
    const anchor = menu.parentElement?.querySelector('[role="button"], button');
    positionFloatingMenu(anchor instanceof HTMLElement ? anchor : null, menu);
  }
}
__name(repositionPopups, "repositionPopups");
var MUTATION_OPTIONS = {
  subtree: true,
  childList: true,
  characterData: true,
  attributes: true,
  attributeFilter: [
    "style",
    "class"
  ]
};
function quiet(b, write) {
  b.mutationObserver?.disconnect();
  try {
    write();
  } finally {
    b.mutationObserver?.observe(b.el, MUTATION_OPTIONS);
  }
}
__name(quiet, "quiet");
function update(b) {
  if (!b.el.isConnected) {
    return;
  }
  quiet(b, () => {
    syncSearchOpen(b);
    const mode = decide(b);
    syncActionTips(b, mode === "compact" || mode === "stacked");
    syncNav(b);
    repositionPopups(b);
  });
}
__name(update, "update");
function bind(bar) {
  if (bound.has(bar)) {
    return;
  }
  const b = {
    el: bar,
    filters: el(bar, ".ds-filter-bar__filters"),
    scroller: el(bar, ".ds-filter-bar__scroller"),
    actions: el(bar, ".ds-filter-bar__actions"),
    search: el(bar, ".ds-filter-search"),
    searchInput: null,
    resizeObserver: null,
    mutationObserver: null,
    detach: /* @__PURE__ */ __name(() => {
    }, "detach")
  };
  const input = b.search?.querySelector("input");
  b.searchInput = input instanceof HTMLInputElement ? input : null;
  buildNav(b);
  buildSearchParts(b);
  let frame = null;
  const schedule2 = /* @__PURE__ */ __name(() => {
    if (frame !== null) {
      return;
    }
    frame = requestAnimationFrame(() => {
      frame = null;
      update(b);
    });
  }, "schedule");
  const onScroll = /* @__PURE__ */ __name(() => {
    quiet(b, () => {
      syncNav(b);
      repositionPopups(b);
    });
  }, "onScroll");
  b.scroller?.addEventListener("scroll", onScroll, {
    passive: true
  });
  const onChange = /* @__PURE__ */ __name(() => update(b), "onChange");
  b.scroller?.addEventListener("change", onChange);
  b.mutationObserver = new MutationObserver(() => {
    quiet(b, () => repositionPopups(b));
    schedule2();
  });
  b.mutationObserver.observe(bar, MUTATION_OPTIONS);
  if (typeof ResizeObserver !== "undefined") {
    b.resizeObserver = new ResizeObserver(schedule2);
    b.resizeObserver.observe(bar);
  }
  b.detach = () => {
    b.scroller?.removeEventListener("scroll", onScroll);
    b.scroller?.removeEventListener("change", onChange);
    b.mutationObserver?.disconnect();
    b.resizeObserver?.disconnect();
    if (frame !== null) {
      cancelAnimationFrame(frame);
    }
  };
  bar.setAttribute(BOUND_ATTR, "1");
  bound.set(bar, b);
  update(b);
}
__name(bind, "bind");
function rescan() {
  for (const bar of Array.from(document.querySelectorAll(BAR_SELECTOR))) {
    bind(bar);
  }
  for (const [bar, b] of Array.from(bound.entries())) {
    if (bar.isConnected) {
      update(b);
    } else {
      b.detach();
      bound.delete(bar);
    }
  }
}
__name(rescan, "rescan");
function scheduleRescan() {
  if (rescanTimer !== null) {
    clearTimeout(rescanTimer);
  }
  rescanTimer = setTimeout(() => {
    rescanTimer = null;
    rescan();
  }, RESCAN_DELAY_MS);
}
__name(scheduleRescan, "scheduleRescan");
function needsRescan(records) {
  for (const record of records) {
    for (const node of [
      ...record.addedNodes,
      ...record.removedNodes
    ]) {
      if (node instanceof Element && (node.matches(BAR_SELECTOR) || node.querySelector(BAR_SELECTOR))) {
        return true;
      }
    }
    const target = record.target instanceof Element ? record.target : record.target.parentElement;
    if (!target || target.closest(BAR_SELECTOR)) {
      continue;
    }
    for (const bar of bound.keys()) {
      if (target.contains(bar)) {
        return true;
      }
    }
  }
  return false;
}
__name(needsRescan, "needsRescan");
function setupFilterBar() {
  if (installed2 || typeof document === "undefined") {
    return;
  }
  installed2 = true;
  const start = /* @__PURE__ */ __name(() => {
    rescan();
    new MutationObserver((records) => {
      if (needsRescan(records)) {
        scheduleRescan();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
    window.addEventListener("resize", scheduleRescan, {
      passive: true
    });
  }, "start");
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true
    });
  } else {
    start();
  }
}
__name(setupFilterBar, "setupFilterBar");

// src/holiday-calendar.ts
var holidayByDate = /* @__PURE__ */ new Map();
var nationalByDate = /* @__PURE__ */ new Map();
var loadedYears = /* @__PURE__ */ new Set();
async function ensureHolidayYears(sdk, years) {
  await Promise.all([
    ...new Set(years)
  ].filter((y) => Number.isInteger(y) && y >= 2e3 && y <= 2100 && !loadedYears.has(y)).map(async (year) => {
    loadedYears.add(year);
    try {
      const res = await sdk.organizationHoliday.list(year);
      for (const item of res.items) {
        if (item.applied === false) {
          continue;
        }
        holidayByDate.set(item.date, item.name);
        if (item.source === "national") {
          nationalByDate.set(item.date, item.name);
        }
      }
    } catch {
      loadedYears.delete(year);
    }
  }));
}
__name(ensureHolidayYears, "ensureHolidayYears");
function invalidateHolidayYear(year) {
  loadedYears.delete(year);
  const from = `${year}-01-01`;
  const to = `${year}-12-31`;
  for (const d of [
    ...holidayByDate.keys()
  ]) {
    if (d >= from && d <= to) {
      holidayByDate.delete(d);
    }
  }
  for (const d of [
    ...nationalByDate.keys()
  ]) {
    if (d >= from && d <= to) {
      nationalByDate.delete(d);
    }
  }
}
__name(invalidateHolidayYear, "invalidateHolidayYear");
function isHoliday(dateStr) {
  return holidayByDate.has(dateStr.slice(0, 10));
}
__name(isHoliday, "isHoliday");
function getHolidayName(dateStr) {
  return holidayByDate.get(dateStr.slice(0, 10)) ?? "";
}
__name(getHolidayName, "getHolidayName");
function getNationalHolidayName(dateStr) {
  return nationalByDate.get(dateStr.slice(0, 10)) ?? "";
}
__name(getNationalHolidayName, "getNationalHolidayName");

// src/lnb-tooltip.ts
var TOOLTIP_CLASS = "ds-lnb-tooltip";
var MENU_SELECTOR = ".ds-lnb--collapsed .ds-lnb__menu[title]";
var GAP = 12;
var tooltipEl = null;
var installed3 = false;
function ensureTooltipEl() {
  if (tooltipEl) {
    return tooltipEl;
  }
  const el2 = document.createElement("div");
  el2.className = TOOLTIP_CLASS;
  el2.setAttribute("role", "tooltip");
  el2.setAttribute("aria-hidden", "true");
  document.body.appendChild(el2);
  tooltipEl = el2;
  return el2;
}
__name(ensureTooltipEl, "ensureTooltipEl");
function show(menu) {
  const title = menu.getAttribute("title");
  if (!title) {
    return;
  }
  const tip = ensureTooltipEl();
  tip.textContent = title;
  const rect = menu.getBoundingClientRect();
  tip.style.left = `${rect.right + GAP}px`;
  tip.style.top = `${rect.top + rect.height / 2}px`;
  tip.style.transform = "translateY(-50%) translateX(-4px)";
  requestAnimationFrame(() => {
    tip.classList.add("is-visible");
    tip.style.transform = "translateY(-50%) translateX(0)";
  });
}
__name(show, "show");
function hide() {
  if (!tooltipEl) {
    return;
  }
  tooltipEl.classList.remove("is-visible");
}
__name(hide, "hide");
function handleMouseOver(e) {
  const target = e.target;
  if (!(target instanceof Element)) {
    return;
  }
  const menu = target.closest(MENU_SELECTOR);
  if (menu instanceof HTMLElement) {
    if (menu.hasAttribute("title")) {
      const t = menu.getAttribute("title") || "";
      menu.dataset.lnbTooltipTitle = t;
      menu.removeAttribute("title");
      show(menu);
    } else if (menu.dataset.lnbTooltipTitle) {
      show(menu);
    }
  }
}
__name(handleMouseOver, "handleMouseOver");
function handleMouseOut(e) {
  const target = e.target;
  if (!(target instanceof Element)) {
    return;
  }
  const menu = target.closest(MENU_SELECTOR.replace("[title]", ""));
  if (menu instanceof HTMLElement && menu.dataset.lnbTooltipTitle) {
    menu.setAttribute("title", menu.dataset.lnbTooltipTitle);
    hide();
  }
}
__name(handleMouseOut, "handleMouseOut");
function setupLnbTooltip() {
  if (installed3 || typeof document === "undefined") {
    return;
  }
  installed3 = true;
  document.addEventListener("mouseover", handleMouseOver, true);
  document.addEventListener("mouseout", handleMouseOut, true);
}
__name(setupLnbTooltip, "setupLnbTooltip");

// src/menu-dividers.ts
var EMPTY_CLASS = "ds-menu__divider--empty";
var installed4 = false;
var scheduled = false;
function isVisible(el2) {
  const style = window.getComputedStyle(el2);
  return style.display !== "none" && style.visibility !== "hidden";
}
__name(isVisible, "isVisible");
function sweepMenu(menu) {
  const children = Array.from(menu.children);
  const isDivider = /* @__PURE__ */ __name((el2) => el2.classList.contains("ds-menu__divider"), "isDivider");
  const isVisibleItem = /* @__PURE__ */ __name((el2) => !isDivider(el2) && el2.tagName !== "TEMPLATE" && isVisible(el2), "isVisibleItem");
  let itemSinceLastKeptDivider = false;
  children.forEach((child, i) => {
    if (!isDivider(child)) {
      if (isVisibleItem(child)) {
        itemSinceLastKeptDivider = true;
      }
      return;
    }
    const hasItemAfter = children.slice(i + 1).some(isVisibleItem);
    const keep = itemSinceLastKeptDivider && hasItemAfter;
    child.classList.toggle(EMPTY_CLASS, !keep);
    if (keep) {
      itemSinceLastKeptDivider = false;
    }
  });
}
__name(sweepMenu, "sweepMenu");
function sweepAll() {
  scheduled = false;
  for (const menu of Array.from(document.querySelectorAll(".ds-menu"))) {
    if (isVisible(menu)) {
      sweepMenu(menu);
    }
  }
}
__name(sweepAll, "sweepAll");
function schedule() {
  if (scheduled) {
    return;
  }
  scheduled = true;
  window.requestAnimationFrame(sweepAll);
}
__name(schedule, "schedule");
function onMenuKeydown(event) {
  const target = event.target;
  const key = typeof event.key === "string" ? event.key : "";
  const isPlainEdit = !(event.altKey || event.ctrlKey || event.metaKey) && (event.isComposing || key.length === 1 || key === "Backspace" || key === "Delete");
  if (isPlainEdit && target instanceof HTMLElement && !target.closest(".ds-menu")) {
    const isTextField = target instanceof HTMLTextAreaElement || target instanceof HTMLInputElement && [
      "text",
      "search",
      "email",
      "url",
      "tel",
      "password",
      "number"
    ].includes(target.type);
    if (isTextField && !target.readOnly && !target.disabled || target.isContentEditable) {
      return;
    }
  }
  schedule();
}
__name(onMenuKeydown, "onMenuKeydown");
function setupMenuDividers() {
  if (installed4 || typeof document === "undefined") {
    return;
  }
  installed4 = true;
  document.addEventListener("click", schedule, true);
  document.addEventListener("contextmenu", schedule, true);
  document.addEventListener("keydown", onMenuKeydown, true);
  new MutationObserver((records) => {
    for (const rec of records) {
      if (touchesMenu(rec)) {
        schedule();
        return;
      }
    }
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
}
__name(setupMenuDividers, "setupMenuDividers");
function touchesMenu(rec) {
  const target = rec.target instanceof Element ? rec.target : rec.target.parentElement;
  if (target?.closest(".ds-menu")) {
    return true;
  }
  for (const node of Array.from(rec.addedNodes)) {
    if (node instanceof Element && (node.matches(".ds-menu") || node.querySelector(".ds-menu"))) {
      return true;
    }
  }
  return false;
}
__name(touchesMenu, "touchesMenu");

// src/page-scroll.ts
function visibleHeight(el2) {
  if (!(el2 instanceof HTMLElement) || el2.getClientRects().length === 0) {
    return 0;
  }
  return el2.offsetHeight;
}
__name(visibleHeight, "visibleHeight");
function setupPageScroll(root) {
  let tableMax = 0;
  const fitPageBoxes = /* @__PURE__ */ __name(() => {
    const rootTop = root.getBoundingClientRect().top;
    for (const box of Array.from(root.querySelectorAll("[data-page-fit]"))) {
      if (box.getClientRects().length === 0) {
        continue;
      }
      const spacer = box.nextElementSibling;
      const full = Math.min(tableMax, box.scrollHeight);
      const top = box.getBoundingClientRect().top - rootTop;
      const pad3 = Number(box.dataset.pageFit || 20);
      const avail = root.clientHeight - top - pad3;
      const visible = Math.max(Math.min(full, 200), Math.min(full, avail));
      const px = `${Math.round(visible)}px`;
      if (box.style.maxHeight !== px) {
        box.style.maxHeight = px;
      }
      if (spacer instanceof HTMLElement && spacer.hasAttribute("data-page-fit-spacer")) {
        const sp = `${Math.max(0, Math.round(full - visible))}px`;
        if (spacer.style.height !== sp) {
          spacer.style.height = sp;
        }
      }
    }
  }, "fitPageBoxes");
  const sync2 = /* @__PURE__ */ __name(() => {
    const sticky = Array.from(root.querySelectorAll("[data-page-sticky]")).reduce((sum, el2) => sum + visibleHeight(el2), 0);
    const reserve = Number(root.dataset.pageReserve ?? 100);
    tableMax = Math.max(240, root.clientHeight - sticky - reserve);
    setVar("--page-frame-h", `${Math.max(320, root.clientHeight - sticky)}px`);
    setVar("--page-table-max", `${tableMax}px`);
    fitPageBoxes();
  }, "sync");
  function setVar(name, value) {
    if (root.style.getPropertyValue(name) !== value) {
      root.style.setProperty(name, value);
    }
  }
  __name(setVar, "setVar");
  let queued = false;
  const queue = /* @__PURE__ */ __name(() => {
    if (queued) {
      return;
    }
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      sync2();
    });
  }, "queue");
  sync2();
  const ro = new ResizeObserver(sync2);
  ro.observe(root);
  const mo = new MutationObserver(queue);
  mo.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      "style",
      "class"
    ]
  });
  root.addEventListener("scroll", fitPageBoxes, {
    passive: true
  });
  return () => {
    ro.disconnect();
    mo.disconnect();
    root.removeEventListener("scroll", fitPageBoxes);
  };
}
__name(setupPageScroll, "setupPageScroll");

// src/backdrop-watch.ts
var OPEN_CLASS2 = "ds-backdrop-open";
var BACKDROP_CLASS = "ds-modal-backdrop";
var installed5 = false;
function containsBackdrop(nodes) {
  for (const node of nodes) {
    if (node instanceof Element && (node.classList.contains(BACKDROP_CLASS) || node.querySelector(`.${BACKDROP_CLASS}`))) {
      return true;
    }
  }
  return false;
}
__name(containsBackdrop, "containsBackdrop");
function affectsBackdropState(record) {
  if (record.type === "attributes") {
    return record.target instanceof Element && record.target.classList.contains(BACKDROP_CLASS);
  }
  return containsBackdrop(record.addedNodes) || containsBackdrop(record.removedNodes);
}
__name(affectsBackdropState, "affectsBackdropState");
function hasOpenBackdrop(backdrops) {
  for (let i = 0; i < backdrops.length; i++) {
    const el2 = backdrops[i];
    if (el2 instanceof HTMLElement && el2.style.display !== "none") {
      return true;
    }
  }
  return false;
}
__name(hasOpenBackdrop, "hasOpenBackdrop");
function setupBackdropWatch() {
  if (installed5 || typeof document === "undefined" || typeof MutationObserver === "undefined") {
    return;
  }
  installed5 = true;
  const backdrops = document.getElementsByClassName(BACKDROP_CLASS);
  let frame = 0;
  const sync2 = /* @__PURE__ */ __name(() => {
    frame = 0;
    document.body.classList.toggle(OPEN_CLASS2, hasOpenBackdrop(backdrops));
  }, "sync");
  const observer = new MutationObserver((records) => {
    if (!frame && records.some(affectsBackdropState)) {
      frame = requestAnimationFrame(sync2);
    }
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: [
      "style"
    ]
  });
  sync2();
}
__name(setupBackdropWatch, "setupBackdropWatch");

// src/components/CsReport.ts
var CAPTURE_MAX_EDGE = 1920;
var CAPTURE_TIMEOUT_MS = 1e4;
var PRECAPTURE_TTL_MS = 6e4;
var MAX_USER_FILES = 3;
var MAX_USER_FILE_BYTES = 10 * 1024 * 1024;
var CAPTURE_STYLE_PROPERTIES = [
  "display",
  "position",
  "top",
  "right",
  "bottom",
  "left",
  "z-index",
  "flex",
  "flex-direction",
  "flex-wrap",
  "flex-grow",
  "flex-shrink",
  "flex-basis",
  "grid-template-columns",
  "grid-template-rows",
  "grid-column",
  "grid-row",
  "gap",
  "align-items",
  "align-self",
  "justify-content",
  "justify-items",
  "order",
  "width",
  "min-width",
  "max-width",
  "height",
  "min-height",
  "max-height",
  "margin-top",
  "margin-right",
  "margin-bottom",
  "margin-left",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left",
  "box-sizing",
  "overflow",
  "overflow-x",
  "overflow-y",
  "font-family",
  "font-size",
  "font-weight",
  "font-style",
  "line-height",
  "letter-spacing",
  "text-align",
  "text-decoration",
  "text-overflow",
  "text-transform",
  "white-space",
  "word-break",
  "vertical-align",
  "color",
  "background",
  "background-color",
  "background-image",
  "background-size",
  "background-position",
  "background-repeat",
  "border",
  "border-top",
  "border-right",
  "border-bottom",
  "border-left",
  "border-radius",
  "border-color",
  "border-style",
  "border-width",
  "outline",
  "box-shadow",
  "opacity",
  "visibility",
  "transform",
  // Tailwind 4 의 `translate-*`·`rotate-*`·`scale-*` 는 `transform` 이 아니라 **개별
  // 프로퍼티**(`translate`/`rotate`/`scale`)를 쓴다 — 빠지면 `-translate-x-1/2` 로
  // 가운데 맞춘 팝오버·드롭다운·토글 손잡이가 엉뚱한 자리에 그려져 옆 요소를 가린다.
  "translate",
  "rotate",
  "scale",
  "transform-origin",
  "filter",
  // `line-clamp-N` = `display:-webkit-box` + 아래 둘. display 만 복사되면 줄 제한이
  // 풀려 셀이 세로로 늘어나고 아래 행을 밀어낸다.
  "-webkit-line-clamp",
  "-webkit-box-orient",
  "overflow-wrap",
  "aspect-ratio",
  "appearance",
  "font-variant-numeric",
  "object-fit",
  "object-position",
  "cursor",
  "table-layout",
  "border-collapse",
  "border-spacing",
  "list-style",
  "content",
  "fill",
  "stroke",
  "stroke-width"
];
var unregisterEsc = null;
var MASK_STYLE_ID = "cs-report-mask-style";
var MASK_CSS = "[data-cs-mask], [data-cs-mask] * { background: #000 !important; color: transparent !important; text-shadow: none !important; box-shadow: none !important; }[data-cs-mask] img, [data-cs-mask] svg, [data-cs-mask] canvas { visibility: hidden !important; }";
function magics3(ctx) {
  return ctx;
}
__name(magics3, "magics");
function isReportShortcut(event) {
  return event.key === "F1" && event.shiftKey;
}
__name(isReportShortcut, "isReportShortcut");
var TRANSPARENT_PIXEL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
function shouldSkipCaptureImage(src, complete, naturalWidth, pageOrigin) {
  if (!src || complete && naturalWidth === 0) {
    return true;
  }
  if (src.startsWith("data:") || src.startsWith("blob:")) {
    return false;
  }
  try {
    return new URL(src, pageOrigin).origin !== pageOrigin;
  } catch {
    return true;
  }
}
__name(shouldSkipCaptureImage, "shouldSkipCaptureImage");
function captureFilter(node) {
  if (!node.classList) {
    return true;
  }
  if (node.ownerDocument !== document) {
    return false;
  }
  if (node.hasAttribute?.("data-cs-report-host") || // 확인·알림 다이얼로그(`--top`)만 뺀다. 오류 다이얼로그의 「리포트 보내기」로
  // 들어온 경우 사용자가 신고하려는 것은 다이얼로그가 아니라 **그 뒤 화면**이다(§5.1).
  node.classList.contains("ds-modal-backdrop--top")) {
    return false;
  }
  if (node.tagName === "IMG") {
    const img = node;
    if (shouldSkipCaptureImage(img.currentSrc || img.getAttribute("src") || "", img.complete, img.naturalWidth, window.location.origin)) {
      return false;
    }
  }
  if (node === node.ownerDocument?.body) {
    return true;
  }
  const view = node.ownerDocument?.defaultView;
  return !view || view.getComputedStyle(node).display !== "none";
}
__name(captureFilter, "captureFilter");
function sanitizeCaptureXml(xml) {
  return xml.replace(/<!--[\s\S]*?-->/g, "").replace(/ (?!xmlns[:=]|xml:|xlink:)[^\s=]*[:@][^\s=]*="[^"]*"/g, " ");
}
__name(sanitizeCaptureXml, "sanitizeCaptureXml");
var SCROLL_ATTR = "data-cs-scroll";
var XHTML_NS = "http://www.w3.org/1999/xhtml";
var MAX_EMBED_FRAMES = 10;
var EMBED_PLACEHOLDER_LABEL = "\uC784\uBCA0\uB4DC \uD654\uBA74 \u2014 \uC790\uB3D9 \uCEA1\uCC98\uC5D0 \uB2F4\uAE30\uC9C0 \uC54A\uC544\uC694";
function markScrolledElements(doc) {
  const marked = [];
  const skip = /* @__PURE__ */ new Set([
    doc.documentElement,
    doc.body,
    doc.scrollingElement
  ]);
  for (const el2 of doc.querySelectorAll("*")) {
    if (skip.has(el2)) {
      continue;
    }
    const left = Math.round(el2.scrollLeft);
    const top = Math.round(el2.scrollTop);
    if (left > 0 || top > 0) {
      el2.setAttribute(SCROLL_ATTR, `${left},${top}`);
      marked.push(el2);
    }
  }
  return () => {
    for (const el2 of marked) {
      el2.removeAttribute(SCROLL_ATTR);
    }
  };
}
__name(markScrolledElements, "markScrolledElements");
function restoreScrollInClone(parsed) {
  let count = 0;
  for (const el2 of parsed.querySelectorAll(`[${SCROLL_ATTR}]`)) {
    const [left, top] = (el2.getAttribute(SCROLL_ATTR) ?? "").split(",").map(Number);
    el2.removeAttribute(SCROLL_ATTR);
    if (!(left > 0 || top > 0)) {
      continue;
    }
    const style = el2.getAttribute("style") ?? "";
    const position = /(?:^|;)\s*position:\s*([a-z-]+)/.exec(style)?.[1];
    const positioned = Boolean(position) && position !== "static";
    el2.setAttribute("style", `${style}${positioned ? "" : "; position: relative"}; scroll-snap-type: both mandatory`);
    const marker = parsed.createElementNS(XHTML_NS, "div");
    marker.setAttribute("style", `position: absolute; top: ${top}px; left: ${left}px; width: 1px; height: 1px; scroll-snap-align: start; pointer-events: none`);
    el2.appendChild(marker);
    count++;
  }
  return count;
}
__name(restoreScrollInClone, "restoreScrollInClone");
function embedFramePath(src, title) {
  if (!src) {
    return title ? `(${title})` : "(inline)";
  }
  try {
    const url = new URL(src, "http://hereby.invalid");
    return `${url.pathname}${url.search}`.slice(0, 200);
  } catch {
    return src.slice(0, 200);
  }
}
__name(embedFramePath, "embedFramePath");
function collectEmbedFrames(doc) {
  const out = [];
  for (const frame of doc.querySelectorAll("iframe")) {
    const rect = frame.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) {
      continue;
    }
    out.push(embedFramePath(frame.getAttribute("src"), frame.title));
    if (out.length >= MAX_EMBED_FRAMES) {
      break;
    }
  }
  return out;
}
__name(collectEmbedFrames, "collectEmbedFrames");
function replaceEmbedFramesInClone(parsed, label, colors) {
  let count = 0;
  for (const el2 of parsed.querySelectorAll("iframe, body body")) {
    const box = parsed.createElementNS(XHTML_NS, "div");
    box.setAttribute("style", `${el2.getAttribute("style") ?? ""}; display: flex; align-items: center; justify-content: center; overflow: hidden; background: ${colors.bg}`);
    const text = parsed.createElementNS(XHTML_NS, "span");
    text.setAttribute("style", `font: 13px sans-serif; color: ${colors.fg}; white-space: nowrap`);
    text.textContent = label;
    box.appendChild(text);
    el2.replaceWith(box);
    count++;
  }
  return count;
}
__name(replaceEmbedFramesInClone, "replaceEmbedFramesInClone");
function embedPlaceholderColors() {
  const root = getComputedStyle(document.documentElement);
  const read = /* @__PURE__ */ __name((name, fallback) => root.getPropertyValue(name).trim() || fallback, "read");
  return {
    bg: read("--color-neutral-100", "#e5e5e5"),
    fg: read("--color-neutral-500", "#5e5e5e")
  };
}
__name(embedPlaceholderColors, "embedPlaceholderColors");
function loadImage(src) {
  return new Promise((resolve2, reject) => {
    const img = new Image();
    img.onload = () => resolve2(img);
    img.onerror = () => reject(new Error("screenshot svg failed to load"));
    img.src = src;
  });
}
__name(loadImage, "loadImage");
async function captureBodyToCanvas() {
  const { toSvg } = await import("html-to-image");
  const style = document.createElement("style");
  style.id = MASK_STYLE_ID;
  style.textContent = MASK_CSS;
  document.head.appendChild(style);
  const unmarkScroll = markScrolledElements(document);
  const embedFrames = collectEmbedFrames(document);
  try {
    const dataUri = await toSvg(document.body, {
      filter: captureFilter,
      pixelRatio: 1,
      backgroundColor: "#ffffff",
      // 전체 computed style 복사는 Tailwind 4 커스텀 프로퍼티 수백 개 × 요소 수로
      // 메인 스레드를 수십 초 세운다(실측) — 레이아웃·페인트 축만 복사한다
      includeStyleProperties: CAPTURE_STYLE_PROPERTIES,
      // 웹폰트 인라이닝 생략 — 시스템 폴백으로 그려져도 리포트 목적에 충분
      skipFonts: true,
      // 필터를 통과했는데도 인라인에 실패한 이미지의 최후 방어 — 전체 reject 대신 투명 픽셀
      imagePlaceholder: TRANSPARENT_PIXEL
    });
    const xml = sanitizeCaptureXml(decodeURIComponent(dataUri.replace("data:image/svg+xml;charset=utf-8,", "")));
    const parsed = new DOMParser().parseFromString(xml, "image/svg+xml");
    if (parsed.querySelector("parsererror")) {
      throw new Error("screenshot svg is not well-formed");
    }
    restoreScrollInClone(parsed);
    replaceEmbedFramesInClone(parsed, EMBED_PLACEHOLDER_LABEL, embedPlaceholderColors());
    const width = Number(parsed.documentElement.getAttribute("width")) || window.innerWidth;
    const height = Number(parsed.documentElement.getAttribute("height")) || window.innerHeight;
    const img = await loadImage(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(parsed))}`);
    const scale = Math.min(1, CAPTURE_MAX_EDGE / Math.max(width, height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("canvas 2d context unavailable");
    }
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return {
      canvas,
      embedFrames
    };
  } finally {
    unmarkScroll();
    document.getElementById(MASK_STYLE_ID)?.remove();
  }
}
__name(captureBodyToCanvas, "captureBodyToCanvas");
function withTimeout2(promise, ms) {
  return new Promise((resolve2, reject) => {
    const timer = setTimeout(() => reject(new Error("capture timeout")), ms);
    promise.then((v) => {
      clearTimeout(timer);
      resolve2(v);
    }, (e) => {
      clearTimeout(timer);
      reject(e);
    });
  });
}
__name(withTimeout2, "withTimeout");
function canvasToBlob(canvas) {
  return new Promise((resolve2) => {
    canvas.toBlob((webp) => {
      if (webp && webp.type === "image/webp") {
        resolve2({
          blob: webp,
          mime: "image/webp"
        });
        return;
      }
      canvas.toBlob((png) => resolve2(png ? {
        blob: png,
        mime: "image/png"
      } : null), "image/png");
    }, "image/webp", 0.8);
  });
}
__name(canvasToBlob, "canvasToBlob");
var CLOSING_STATUSES = /* @__PURE__ */ new Set([
  "resolved",
  "wont_fix",
  "duplicate"
]);
function isClosingReportStatus(status) {
  return CLOSING_STATUSES.has(status);
}
__name(isClosingReportStatus, "isClosingReportStatus");
function describeReportStatus(status) {
  switch (status) {
    case "received":
      return {
        tone: "info",
        icon: "ic-clock",
        headline: "\uC2E0\uACE0\uAC00 \uC811\uC218\uB410\uC5B4\uC694",
        hint: "\uC6B4\uC601\uC790\uAC00 \uD655\uC778\uD558\uBA74 \uCC98\uB9AC \uC774\uB825\uC5D0 \uD45C\uC2DC\uB3FC\uC694."
      };
    case "triaged":
      return {
        tone: "info",
        icon: "ic-info-circle",
        headline: "\uC2E0\uACE0 \uB0B4\uC6A9\uC744 \uD655\uC778\uD588\uC5B4\uC694",
        hint: "\uACE7 \uCC98\uB9AC\uB97C \uC2DC\uC791\uD574\uC694. \uC9C4\uD589 \uC0C1\uD669\uC740 \uC544\uB798 \uCC98\uB9AC \uC774\uB825\uC5D0\uC11C \uBCFC \uC218 \uC788\uC5B4\uC694."
      };
    case "in_progress":
      return {
        tone: "info",
        icon: "ic-clock",
        headline: "\uC9C0\uAE08 \uCC98\uB9AC\uD558\uACE0 \uC788\uC5B4\uC694",
        hint: "\uCC98\uB9AC\uAC00 \uB05D\uB098\uBA74 \uC54C\uB9BC\uC73C\uB85C \uC54C\uB824\uB4DC\uB824\uC694."
      };
    // 배포대기 — 수정은 끝났지만 아직 앱에 반영되지 않았다. "완료됐어요"로 읽히면 안 되고,
    // 반영되어 「처리가 완료됐어요」로 바뀌는 시점에 알림이 간다(운영자가 해결로 전이).
    case "awaiting_release":
      return {
        tone: "info",
        icon: "ic-clock",
        headline: "\uC218\uC815\uC744 \uB9C8\uCE58\uACE0 \uBC18\uC601\uC744 \uAE30\uB2E4\uB9AC\uACE0 \uC788\uC5B4\uC694",
        hint: "\uB2E4\uC74C \uC5C5\uB370\uC774\uD2B8\uC5D0 \uBC18\uC601\uB418\uBA74 \uCC98\uB9AC \uC644\uB8CC\uB85C \uBC14\uB00C\uACE0 \uC54C\uB9BC\uC73C\uB85C \uC54C\uB824\uB4DC\uB824\uC694."
      };
    case "resolved":
      return {
        tone: "success",
        icon: "ic-check-circle",
        headline: "\uCC98\uB9AC\uAC00 \uC644\uB8CC\uB410\uC5B4\uC694",
        hint: "\uC2E0\uACE0\uD558\uC2E0 \uBB38\uC81C\uAC00 \uD574\uACB0\uB410\uC5B4\uC694."
      };
    case "wont_fix":
      return {
        tone: "warning",
        icon: "ic-exclamation-circle",
        headline: "\uCC98\uB9AC\uAC00 \uC644\uB8CC\uB410\uC5B4\uC694 (\uBC18\uC601 \uBCF4\uB958)",
        hint: "\uAC80\uD1A0 \uACB0\uACFC \uC774\uBC88\uC5D0\uB294 \uBC18\uC601\uD558\uC9C0 \uC54A\uAE30\uB85C \uD588\uC5B4\uC694."
      };
    case "duplicate":
      return {
        tone: "info",
        icon: "ic-info-circle",
        headline: "\uCC98\uB9AC\uAC00 \uC644\uB8CC\uB410\uC5B4\uC694 (\uC911\uBCF5 \uC2E0\uACE0)",
        hint: "\uBA3C\uC800 \uC811\uC218\uB41C \uAC19\uC740 \uC2E0\uACE0\uC640 \uD568\uAED8 \uCC98\uB9AC\uB3FC\uC694."
      };
    case "cancelled":
      return {
        tone: "warning",
        icon: "ic-exclamation-circle",
        headline: "\uCDE8\uC18C\uB41C \uC2E0\uACE0\uC608\uC694",
        hint: "\uC2E0\uACE0\uC790\uAC00 \uCDE8\uC18C\uD574 \uB354 \uC774\uC0C1 \uCC98\uB9AC\uD558\uC9C0 \uC54A\uC544\uC694."
      };
    default:
      return {
        tone: "info",
        icon: "ic-info-circle",
        headline: status,
        hint: ""
      };
  }
}
__name(describeReportStatus, "describeReportStatus");
function defaultResolutionMessage(status) {
  switch (status) {
    case "resolved":
      return "\uC2E0\uACE0\uD558\uC2E0 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC5B4 \uCC98\uB9AC\uB97C \uC644\uB8CC\uD588\uC5B4\uC694. \uAC19\uC740 \uBB38\uC81C\uAC00 \uB2E4\uC2DC \uC0DD\uAE30\uBA74 \uC0C8 \uC2E0\uACE0\uB85C \uC54C\uB824 \uC8FC\uC138\uC694.";
    case "wont_fix":
      return "\uAC80\uD1A0 \uACB0\uACFC \uC774\uBC88\uC5D0\uB294 \uBC18\uC601\uD558\uC9C0 \uC54A\uAE30\uB85C \uD588\uC5B4\uC694. \uB0A8\uACA8 \uC8FC\uC2E0 \uC758\uACAC\uC740 \uB2E4\uC74C \uAC1C\uC120 \uB54C \uCC38\uACE0\uD560\uAC8C\uC694.";
    case "duplicate":
      return "\uBA3C\uC800 \uC811\uC218\uB41C \uAC19\uC740 \uC2E0\uACE0\uC640 \uBB36\uC5B4 \uCC98\uB9AC\uD558\uACE0 \uC788\uC5B4\uC694. \uCC98\uB9AC \uACB0\uACFC\uB294 \uC54C\uB9BC\uC73C\uB85C \uC54C\uB824\uB4DC\uB824\uC694.";
    default:
      return null;
  }
}
__name(defaultResolutionMessage, "defaultResolutionMessage");
function describeStatusEvent(toStatus, fromStatus) {
  switch (toStatus) {
    case "received":
      return "\uC2E0\uACE0\uB97C \uC811\uC218\uD588\uC5B4\uC694";
    case "triaged":
      return "\uC6B4\uC601\uC790\uAC00 \uC2E0\uACE0 \uB0B4\uC6A9\uC744 \uD655\uC778\uD588\uC5B4\uC694";
    case "in_progress":
      if (fromStatus && isClosingReportStatus(fromStatus)) {
        return "\uCC98\uB9AC\uB97C \uB2E4\uC2DC \uC2DC\uC791\uD588\uC5B4\uC694 (\uC7AC\uC624\uD508)";
      }
      return fromStatus === "awaiting_release" ? "\uBC18\uC601 \uC804\uC5D0 \uB2E4\uC2DC \uCC98\uB9AC\uD558\uACE0 \uC788\uC5B4\uC694" : "\uCC98\uB9AC\uB97C \uC2DC\uC791\uD588\uC5B4\uC694";
    case "awaiting_release":
      return "\uC218\uC815\uC744 \uB9C8\uCCE4\uC5B4\uC694 (\uBC18\uC601 \uB300\uAE30)";
    case "resolved":
      return "\uBB38\uC81C\uB97C \uD574\uACB0\uD558\uACE0 \uCC98\uB9AC\uB97C \uC644\uB8CC\uD588\uC5B4\uC694";
    case "wont_fix":
      return "\uAC80\uD1A0 \uD6C4 \uBC18\uC601\uC744 \uBCF4\uB958\uD588\uC5B4\uC694";
    case "duplicate":
      return "\uC911\uBCF5 \uC2E0\uACE0\uB85C \uC815\uB9AC\uD588\uC5B4\uC694";
    case "cancelled":
      return "\uC2E0\uACE0\uB97C \uCDE8\uC18C\uD588\uC5B4\uC694";
    default:
      return toStatus;
  }
}
__name(describeStatusEvent, "describeStatusEvent");
function buildHistoryRows(detail) {
  if (detail.statusHistory.length > 0) {
    return detail.statusHistory;
  }
  const rows = [
    {
      id: "synth-received",
      fromStatus: null,
      toStatus: "received",
      at: detail.createdAt
    }
  ];
  if (detail.inProgressAt) {
    rows.push({
      id: "synth-in-progress",
      fromStatus: "received",
      toStatus: "in_progress",
      at: detail.inProgressAt
    });
  }
  if (detail.resolvedAt && isClosingReportStatus(detail.status)) {
    rows.push({
      id: "synth-closed",
      fromStatus: detail.inProgressAt ? "in_progress" : "received",
      toStatus: detail.status,
      at: detail.resolvedAt
    });
  }
  return rows;
}
__name(buildHistoryRows, "buildHistoryRows");
function csReportComponent(opts = {}) {
  let masterCanvas = null;
  let preCaptured = null;
  let userFiles = [];
  let dragStart = null;
  const fullLayer = Boolean(opts.fullLayer);
  return {
    /**
    * 풀레이어 모드 여부 — 셸·사이즈 클래스 분기는 **템플릿**이 이 값으로 고른다.
    * 클래스 문자열을 여기(.ts)로 끌어오면 안 된다: 앱의 Tailwind 는
    * `@source ".../components/html"` 만 훑어서 .ts 안에만 있는 유틸리티
    * (`mx-4`·`w-5`)는 그 앱에서 **아예 생성되지 않는다**(CLAUDE.md 아이콘 규칙과 같은 함정).
    */
    fullLayer,
    /** 카드 크기 — 인라인 스타일이라 스캔 대상이 아니다. 풀레이어는 CSS 가 100dvh 를 진다. */
    shellStyle: fullLayer ? "" : "max-width: 560px; max-height: 90vh",
    isOpen: false,
    /**
    * 위젯 뷰 — compose(신고 작성/완료) · history(내 신고 내역) · detail(신고 상세+답변).
    * 알림 「신고에 답변이 등록됐어요」 클릭이 history/detail 로 바로 연다
    * (`hereby:cs-report-open` 이벤트의 detail.view / detail.reportId).
    */
    view: "compose",
    phase: "form",
    type: "bug",
    title: "",
    description: "",
    includeLogs: true,
    notifyReporter: true,
    screenshotState: "none",
    /**
    * 스크린샷에서 회색으로 남긴 임베드(iframe) 식별자 — 비어 있지 않으면 미리보기 아래
    * 안내가 뜨고 컨텍스트 `embedFrames` 로 함께 전송된다(요구사항 §5.1).
    */
    embedFrames: [],
    /** 미리보기 렌더 트리거 — masterCanvas 가 바뀔 때마다 증가 */
    shotVersion: 0,
    fileNames: [],
    submitting: false,
    errorMsg: "",
    reportNumber: "",
    /** 자동 첨부 안내(details)의 펼침 상태 */
    showAutoInfo: false,
    dragRect: null,
    errorSnapshot: null,
    /** AI 어시스턴트 답변 카드에서 연 신고의 메타 — submit 때 context.ai 로 나간다 */
    aiMeta: null,
    /* ── 내 신고 내역 (history/detail 뷰) ── */
    myReports: [],
    historyLoading: false,
    historyError: "",
    reportDetail: null,
    detailLoading: false,
    init() {
      setupBackdropWatch();
      window.addEventListener("hereby:cs-report-precapture", () => {
        captureBodyToCanvas().then((result) => {
          preCaptured = {
            ...result,
            at: Date.now()
          };
          window.dispatchEvent(new CustomEvent("hereby:cs-report-precaptured", {
            detail: {
              canvas: result.canvas
            }
          }));
        }, () => {
          preCaptured = null;
          window.dispatchEvent(new CustomEvent("hereby:cs-report-precaptured", {
            detail: {
              canvas: null
            }
          }));
        });
      });
      window.addEventListener("hereby:cs-report-open", (event) => {
        const detail = event.detail;
        if (detail?.view === "history") {
          this.openHistory(detail.reportId);
          return;
        }
        this.open(detail?.prefill, detail?.ai, detail?.screenshot);
      });
      window.addEventListener("keydown", (event) => {
        if (isReportShortcut(event)) {
          event.preventDefault();
          this.open();
        }
      });
      document.addEventListener("app-back-button", (event) => this.handleBackButton(event), true);
    },
    /** 백버튼 한 번 = 한 층 뒤로. 팝업이 안 떠 있으면 손대지 않는다(아래층 몫). */
    handleBackButton(event) {
      if (!this.isOpen) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.submitting) {
        return;
      }
      if (this.view === "detail") {
        this.backToHistory();
        return;
      }
      this.close();
    },
    async open(prefill, ai, screenshot) {
      if (this.isOpen) {
        return;
      }
      const store = herebyStore(this);
      this.view = "compose";
      this.phase = "form";
      this.type = prefill?.type ?? "bug";
      this.title = prefill?.title ?? "";
      this.description = prefill?.description ?? "";
      this.aiMeta = ai ?? null;
      this.includeLogs = true;
      this.notifyReporter = true;
      this.errorMsg = "";
      this.reportNumber = "";
      this.showAutoInfo = false;
      userFiles = [];
      this.fileNames = [];
      const snap = store.csReport?.lastError();
      this.errorSnapshot = snap ? {
        ...snap
      } : null;
      if (!(this.errorSnapshot || prefill?.type)) {
        this.type = "inconvenience";
      }
      this.isOpen = true;
      this.registerEsc();
      if (screenshot === "none") {
        this.removeScreenshot();
        return;
      }
      const fresh = preCaptured && (screenshot === "precaptured" || Date.now() - preCaptured.at < PRECAPTURE_TTL_MS);
      if (preCaptured && fresh) {
        masterCanvas = preCaptured.canvas;
        this.embedFrames = preCaptured.embedFrames;
        this.screenshotState = "ready";
        this.bumpShot();
      } else {
        await this.retake();
      }
    },
    close() {
      this.isOpen = false;
      masterCanvas = null;
      preCaptured = null;
      this.embedFrames = [];
      unregisterEsc?.();
      unregisterEsc = null;
    },
    /* ── 내 신고 내역 — 답변(운영자 회신) 열람 (QA: 답변 받아도 확인 불가) ── */
    /** ESC 레이어 등록 — open()/openHistory() 공용 */
    registerEsc() {
      unregisterEsc?.();
      unregisterEsc = registerEscLayer(() => document.querySelector('[data-testid="cs-report-modal"]'), () => {
        if (!this.submitting) {
          this.close();
        }
      });
    },
    /** 내 신고 내역으로 연다. reportId 가 있으면 그 신고의 상세까지 바로 연다. */
    async openHistory(reportId) {
      this.view = "history";
      this.reportDetail = null;
      this.historyError = "";
      if (!this.isOpen) {
        this.isOpen = true;
        this.registerEsc();
      }
      const loadList = this.loadMyReports();
      if (reportId) {
        await this.openReportDetail(reportId);
      }
      await loadList;
    },
    async loadMyReports() {
      this.historyLoading = true;
      this.historyError = "";
      try {
        const sdk = herebyStore(this).sdk;
        const result = await sdk.trpc.csReport.listMine.query({});
        this.myReports = result.items.map((r) => ({
          id: r.id,
          reportNumber: r.reportNumber,
          type: r.type,
          status: r.status,
          title: r.title,
          createdAt: String(r.createdAt)
        }));
      } catch {
        this.historyError = "\uC2E0\uACE0 \uB0B4\uC5ED\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      } finally {
        this.historyLoading = false;
      }
    },
    async openReportDetail(id) {
      this.view = "detail";
      this.detailLoading = true;
      this.historyError = "";
      try {
        const sdk = herebyStore(this).sdk;
        const r = await sdk.trpc.csReport.getMine.query({
          id
        });
        this.reportDetail = {
          id: r.id,
          reportNumber: r.reportNumber,
          type: r.type,
          status: r.status,
          title: r.title,
          description: r.description,
          resolutionNote: r.resolutionNote,
          createdAt: String(r.createdAt),
          inProgressAt: r.inProgressAt ? String(r.inProgressAt) : null,
          resolvedAt: r.resolvedAt ? String(r.resolvedAt) : null,
          replies: r.replies.map((c) => ({
            id: c.id,
            body: c.body,
            createdAt: String(c.createdAt)
          })),
          statusHistory: r.statusHistory.map((e) => ({
            id: e.id,
            fromStatus: e.fromStatus ?? null,
            toStatus: e.toStatus,
            at: String(e.at)
          }))
        };
      } catch {
        this.reportDetail = null;
        this.view = "history";
        this.historyError = "\uC2E0\uACE0 \uC0C1\uC138\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      } finally {
        this.detailLoading = false;
      }
    },
    backToHistory() {
      this.view = "history";
      this.reportDetail = null;
      if (this.myReports.length === 0 && !this.historyLoading) {
        this.loadMyReports();
      }
    },
    /** 내역/상세 뷰에서 「새 신고 작성」 — 닫지 않고 작성 화면으로 전환 */
    switchToCompose() {
      this.isOpen = false;
      this.open();
    },
    /** 신고 상태 한글 라벨 — 운영 상태값을 사용자 언어로 */
    statusLabel(status) {
      const labels = {
        received: "\uC811\uC218\uB428",
        triaged: "\uD655\uC778 \uC911",
        in_progress: "\uCC98\uB9AC \uC911",
        awaiting_release: "\uBC18\uC601 \uB300\uAE30",
        resolved: "\uD574\uACB0\uB428",
        wont_fix: "\uBC18\uC601 \uBCF4\uB958",
        duplicate: "\uC911\uBCF5 \uC2E0\uACE0",
        cancelled: "\uCDE8\uC18C\uB428"
      };
      return labels[status] ?? status;
    },
    /** 상태 뱃지 색 — ds-label variant */
    statusLabelClass(status) {
      if (status === "resolved") {
        return "ds-label--green";
      }
      if (status === "in_progress" || status === "triaged") {
        return "ds-label--blue";
      }
      if (status === "awaiting_release") {
        return "ds-label--aqua";
      }
      if (status === "cancelled" || status === "duplicate" || status === "wont_fix") {
        return "ds-label--gray";
      }
      return "ds-label--yellow";
    },
    /** 유형 한글 라벨 (작성 세그먼트와 같은 표기) */
    typeLabel(type) {
      const labels = {
        bug: "\uC624\uB958",
        inconvenience: "\uBD88\uD3B8/\uAC1C\uC120",
        feature_request: "\uAE30\uB2A5 \uC694\uCCAD",
        question: "\uBB38\uC758"
      };
      return labels[type] ?? type;
    },
    /** 내역 날짜 표기 — 조직 타임존은 스토어 포매터가 안다 */
    formatReportDate(value) {
      const store = herebyStore(this);
      return store.formatDateTime ? store.formatDateTime(value) : value;
    },
    /** 상세 맨 위 처리 배너 (톤·아이콘·문장) */
    statusBanner() {
      return describeReportStatus(this.reportDetail?.status ?? "");
    },
    /** 배너 셋째 줄 — 완료/시작 시각. 없으면 빈 문자열(x-show 로 숨김) */
    statusTimeLine() {
      const d = this.reportDetail;
      if (!d) {
        return "";
      }
      if (isClosingReportStatus(d.status) && d.resolvedAt) {
        return `${this.formatReportDate(d.resolvedAt)}\uC5D0 \uCC98\uB9AC\uAC00 \uC644\uB8CC\uB410\uC5B4\uC694.`;
      }
      if (d.status === "in_progress" && d.inProgressAt) {
        return `${this.formatReportDate(d.inProgressAt)}\uBD80\uD130 \uCC98\uB9AC \uC911\uC774\uC5D0\uC694.`;
      }
      return "";
    },
    /** 답변·처리 메모가 모두 없는 종결 신고에 보여 줄 기본 안내문 (아니면 null) */
    resolutionFallback() {
      const d = this.reportDetail;
      if (!d || d.replies.length > 0 || d.resolutionNote) {
        return null;
      }
      return defaultResolutionMessage(d.status);
    },
    /** 처리 이력 행 — 오래된 순(접수 → … → 현재) */
    historyRows() {
      return this.reportDetail ? buildHistoryRows(this.reportDetail) : [];
    },
    eventLabel(event) {
      return describeStatusEvent(event.toStatus, event.fromStatus);
    },
    /** 이력 점 색 — 마지막(현재) 행만 상태 톤, 나머지는 중립 (색 클래스는 마크업이 든다) */
    eventTone(event) {
      return describeReportStatus(event.toStatus).tone;
    },
    /** 다시 찍기 — 모달은 filter 로 캡처에서 빠지므로 열려 있어도 된다 */
    async retake() {
      this.screenshotState = "capturing";
      try {
        const result = await withTimeout2(captureBodyToCanvas(), CAPTURE_TIMEOUT_MS);
        masterCanvas = result.canvas;
        this.embedFrames = result.embedFrames;
        this.screenshotState = "ready";
      } catch {
        masterCanvas = null;
        this.embedFrames = [];
        this.screenshotState = "failed";
      }
      this.bumpShot();
    },
    removeScreenshot() {
      masterCanvas = null;
      this.embedFrames = [];
      this.screenshotState = "none";
      this.bumpShot();
    },
    bumpShot() {
      this.shotVersion++;
      magics3(this).$nextTick(() => this.drawPreview());
    },
    /** 미리보기 캔버스에 마스터를 그린다(+진행 중 드래그 사각형) */
    drawPreview() {
      const el2 = magics3(this).$refs.csPreview;
      if (!(el2 && masterCanvas)) {
        return;
      }
      el2.width = masterCanvas.width;
      el2.height = masterCanvas.height;
      const ctx = el2.getContext("2d");
      if (!ctx) {
        return;
      }
      ctx.drawImage(masterCanvas, 0, 0);
      if (this.dragRect) {
        ctx.fillStyle = "rgba(0,0,0,0.85)";
        ctx.fillRect(this.dragRect.x, this.dragRect.y, this.dragRect.w, this.dragRect.h);
      }
    },
    /** 미리보기 좌표(CSS px) → 캔버스 픽셀 좌표 */
    toCanvasPoint(event) {
      const el2 = magics3(this).$refs.csPreview;
      if (!(el2 && masterCanvas)) {
        return null;
      }
      const rect = el2.getBoundingClientRect();
      return {
        x: (event.clientX - rect.left) / rect.width * el2.width,
        y: (event.clientY - rect.top) / rect.height * el2.height
      };
    },
    maskStart(event) {
      const p = this.toCanvasPoint(event);
      if (!p) {
        return;
      }
      dragStart = p;
      event.target.setPointerCapture?.(event.pointerId);
    },
    maskMove(event) {
      if (!dragStart) {
        return;
      }
      const p = this.toCanvasPoint(event);
      if (!p) {
        return;
      }
      this.dragRect = {
        x: Math.min(dragStart.x, p.x),
        y: Math.min(dragStart.y, p.y),
        w: Math.abs(p.x - dragStart.x),
        h: Math.abs(p.y - dragStart.y)
      };
      this.drawPreview();
    },
    /** 드래그 종료 — 사각형을 마스터에 굽는다(burn-in). 원본은 남지 않는다 (§4.2) */
    maskEnd() {
      if (dragStart && this.dragRect && masterCanvas && this.dragRect.w > 4 && this.dragRect.h > 4) {
        const ctx = masterCanvas.getContext("2d");
        if (ctx) {
          ctx.fillStyle = "#000000";
          ctx.fillRect(this.dragRect.x, this.dragRect.y, this.dragRect.w, this.dragRect.h);
          this.masked = true;
        }
      }
      dragStart = null;
      this.dragRect = null;
      this.drawPreview();
    },
    masked: false,
    onFilesPicked(event) {
      const input = event.target;
      const picked = Array.from(input.files ?? []);
      for (const file of picked) {
        if (userFiles.length >= MAX_USER_FILES) {
          this.errorMsg = `\uD30C\uC77C\uC740 \uCD5C\uB300 ${MAX_USER_FILES}\uAC1C\uAE4C\uC9C0 \uCCA8\uBD80\uD560 \uC218 \uC788\uC5B4\uC694.`;
          break;
        }
        if (file.size > MAX_USER_FILE_BYTES) {
          this.errorMsg = "10MB\uB97C \uB118\uB294 \uD30C\uC77C\uC740 \uCCA8\uBD80\uD560 \uC218 \uC5C6\uC5B4\uC694.";
          continue;
        }
        userFiles.push(file);
      }
      this.fileNames = userFiles.map((f) => f.name);
      input.value = "";
    },
    removeFile(index) {
      userFiles.splice(index, 1);
      this.fileNames = userFiles.map((f) => f.name);
    },
    /** 자동 첨부 안내에 보여 줄 실제 값 (§4.2 투명성) */
    get autoInfo() {
      const store = herebyStore(this);
      const env = store.csReport?.envContext() ?? {};
      const logs = store.csReport?.snapshotLogs() ?? [];
      return [
        {
          label: "\uC571",
          value: store.csAppId || "-"
        },
        {
          label: "\uD654\uBA74 \uC8FC\uC18C",
          value: `${location.pathname}${location.hash}`
        },
        {
          label: "\uC571 \uBC84\uC804",
          value: String(env.buildVersion ?? "-")
        },
        {
          label: "\uBE0C\uB77C\uC6B0\uC800",
          value: String(env.userAgent ?? "-").slice(0, 80)
        },
        {
          label: "\uCD5C\uADFC \uB85C\uADF8",
          value: this.includeLogs ? `${logs.length}\uAC74` : "\uBCF4\uB0B4\uC9C0 \uC54A\uC74C"
        },
        {
          label: "\uC624\uB958 \uC815\uBCF4",
          value: this.errorSnapshot ? this.errorSnapshot.message : "\uC5C6\uC74C"
        },
        ...this.embedFrames.length > 0 ? [
          {
            label: "\uC784\uBCA0\uB4DC \uD654\uBA74",
            value: `${this.embedFrames.length}\uACF3 \uD68C\uC0C9 \uCC98\uB9AC`
          }
        ] : []
      ];
    },
    async submit() {
      if (this.submitting) {
        return;
      }
      const store = herebyStore(this);
      if (!this.title.trim()) {
        this.errorMsg = "\uC81C\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
        return;
      }
      if (!store.csAppId) {
        this.errorMsg = "\uC571 \uC124\uC815(appId)\uC774 \uC5C6\uC5B4 \uB9AC\uD3EC\uD2B8\uB97C \uBCF4\uB0BC \uC218 \uC5C6\uC5B4\uC694. \uAD00\uB9AC\uC790\uC5D0\uAC8C \uC54C\uB824 \uC8FC\uC138\uC694.";
        return;
      }
      this.submitting = true;
      this.errorMsg = "";
      try {
        const sdk = store.sdk;
        const attachments2 = [];
        const upload = /* @__PURE__ */ __name(async (kind, filename, blob, mime, masked = false) => {
          const prep = await sdk.trpc.csReport.prepareUpload.mutate({
            kind,
            filename,
            contentType: mime,
            size: blob.size
          });
          const put = await fetch(prep.url, {
            method: "PUT",
            headers: {
              "Content-Type": mime
            },
            body: blob
          });
          if (!put.ok) {
            throw new Error("\uCCA8\uBD80 \uD30C\uC77C \uC5C5\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.");
          }
          attachments2.push({
            kind,
            storageKey: prep.key,
            mimeType: mime,
            size: blob.size,
            originalName: filename,
            masked
          });
        }, "upload");
        if (masterCanvas && this.screenshotState === "ready") {
          const shot = await canvasToBlob(masterCanvas);
          if (shot) {
            const ext = shot.mime === "image/webp" ? "webp" : "png";
            await upload("screenshot", `screenshot.${ext}`, shot.blob, shot.mime, this.masked);
          }
        }
        if (this.includeLogs) {
          const logs = store.csReport?.snapshotLogs() ?? [];
          const blob = new Blob([
            JSON.stringify(logs)
          ], {
            type: "application/json"
          });
          await upload("log", "client-log.json", blob, "application/json");
        }
        for (const file of userFiles) {
          await upload("user_file", file.name, file, file.type || "application/octet-stream");
        }
        const result = await sdk.trpc.csReport.create.mutate({
          type: this.type,
          title: this.title.trim(),
          description: this.description.trim() || void 0,
          appId: store.csAppId,
          route: `${location.pathname}${location.hash}`,
          context: {
            ...store.csReport?.envContext() ?? {},
            // 회색으로 남긴 임베드 — 운영자가 「빈 회색 = 시트/근태 임베드」를 알 수 있게 (§5.1)
            ...this.embedFrames.length > 0 ? {
              embedFrames: this.embedFrames
            } : {},
            // AI 답변 카드에서 들어온 신고 — 대화·답변·프롬프트 버전(결정 ①)
            ...this.aiMeta ? {
              ai: this.aiMeta
            } : {}
          },
          errorSnapshot: this.errorSnapshot ?? void 0,
          attachments: attachments2,
          notifyReporter: this.notifyReporter
        });
        this.reportNumber = result.reportNumber;
        this.phase = "done";
      } catch (e) {
        this.errorMsg = e instanceof Error && e.message ? e.message : "\uC9C0\uAE08\uC740 \uBCF4\uB0B4\uC9C0 \uBABB\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.";
      } finally {
        this.submitting = false;
      }
    },
    async copyReportNumber() {
      try {
        await navigator.clipboard.writeText(this.reportNumber);
      } catch {
      }
    }
  };
}
__name(csReportComponent, "csReportComponent");

// src/plugin.ts
function createAuthComponentsPlugin() {
  return /* @__PURE__ */ __name(function herebyComponentsPlugin(Alpine) {
    createIconPlugin()(Alpine);
    markEmbeddedDocument();
    Alpine.store("dialog", createDialogStore());
    startChatDeviceLinkWatch(() => Alpine.store("hereby"));
    Alpine.store("employeeCard", createEmployeeCardStore(() => Alpine.store("hereby")?.sdk));
    Alpine.magic("employeeCard", (el2) => (employeeId, opts) => Alpine.store("employeeCard").show(employeeId, el2, opts ?? {}));
    Alpine.data("csReport", (opts = {}) => csReportComponent(opts));
    Alpine.data("addEmployeePanel", (opts = {}) => addEmployeePanelComponent(opts));
    Alpine.data("editEmployeePanel", (opts = {}) => editEmployeePanelComponent(opts));
    Alpine.data("authGate", () => authGateComponent());
    Alpine.data("impersonationBanner", () => impersonationBannerComponent());
    Alpine.data("changePasswordForm", (opts = {}) => changePasswordFormComponent(opts));
    Alpine.data("forgotPasswordForm", () => forgotPasswordFormComponent());
    Alpine.data("loginForm", (opts = {}) => loginFormComponent(opts));
    Alpine.data("notificationBell", (opts = {}) => notificationBellComponent(opts));
    Alpine.data("permissionDeniedModal", (opts = {}) => permissionDeniedModalComponent(opts));
    Alpine.data("registerForm", (opts = {}) => registerFormComponent(opts));
    Alpine.data("chatWidget", () => chatWidgetComponent());
    Alpine.data("aiAssistant", (opts = {}) => aiAssistantComponent(opts));
    Alpine.data("dsDatePicker", (opts = {}) => dsDatePickerComponent(opts));
    Alpine.data("dsTimePicker", (opts = {}) => dsTimePickerComponent(opts));
    Alpine.data("dsSearchInput", (opts = {}) => dsSearchInputComponent(opts));
    Alpine.data("entityPicker", (opts = {}) => entityPickerComponent(opts));
    Alpine.data("myInfoForm", () => myInfoFormComponent());
    Alpine.data("securitySettings", () => securitySettingsComponent());
    Alpine.data("messengerShared", (opts = {}) => messengerComponent(opts));
    Alpine.data("workspaceSwitcher", (opts = {}) => workspaceSwitcherComponent(opts));
    Alpine.data("lnbSidebar", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      lnbSidebarComponent(opts)
    ));
    Alpine.data("pageHeader", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      pageHeaderComponent(opts)
    ));
    Alpine.data("tabNav", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      tabNavComponent(opts)
    ));
    Alpine.data("subTab", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      subTabComponent(opts)
    ));
    Alpine.data("approvalReplace", () => approvalReplaceComponent());
    Alpine.data("approvalSteps", (opts = {}) => approvalStepsComponent(opts));
    Alpine.data("segment", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      segmentComponent(opts)
    ));
    Alpine.data("appHeader", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      appHeaderComponent(opts)
    ));
    Alpine.data("bottomNav", (opts = {}) => (
      // biome-ignore lint/suspicious/noExplicitAny: opts crosses Alpine boundary
      bottomNavComponent(opts)
    ));
  }, "herebyComponentsPlugin");
}
__name(createAuthComponentsPlugin, "createAuthComponentsPlugin");

// src/table-host.ts
var HOST_CLASS = "has-table";
var TABLE_SELECTOR = "table:not(.sched-grid)";
var WRAPPER_SELECTOR = ".overflow-auto, .overflow-y-auto";
var installed6 = false;
function markTableHosts(root = document) {
  for (const table of Array.from(root.querySelectorAll(TABLE_SELECTOR))) {
    const parent = table.parentElement;
    if (parent?.matches(WRAPPER_SELECTOR)) {
      parent.classList.add(HOST_CLASS);
    }
  }
}
__name(markTableHosts, "markTableHosts");
function addsTable(records) {
  for (const record of records) {
    for (const node of Array.from(record.addedNodes)) {
      if (!(node instanceof Element)) {
        continue;
      }
      if (node.matches(TABLE_SELECTOR) || node.querySelector(TABLE_SELECTOR)) {
        return true;
      }
    }
  }
  return false;
}
__name(addsTable, "addsTable");
function setupTableHost() {
  if (installed6 || typeof document === "undefined" || typeof MutationObserver === "undefined") {
    return;
  }
  installed6 = true;
  let frame = 0;
  const observer = new MutationObserver((records) => {
    if (!frame && addsTable(records)) {
      frame = requestAnimationFrame(() => {
        frame = 0;
        markTableHosts();
      });
    }
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true
  });
  markTableHosts();
}
__name(setupTableHost, "setupTableHost");

// src/table-xscroll.ts
var BAR_CLASS = "ds-xscroll";
var BOTTOM_CLASS = "ds-xscroll--bottom";
var THUMB_CLASS = "ds-xscroll__thumb";
var DRAGGING_CLASS = "is-dragging";
var HIDDEN_CLASS = "is-hidden";
var HOST_ATTR = "data-ds-xscroll-host";
var OFF_SELECTOR = '[data-ds-xscroll="off"]';
var INFLOW_SELECTOR = "[data-ds-xscroll-inflow], .sheet-scroll";
var INFLOW_CLASS = "ds-xscroll--inflow";
var EXCLUDED_TABLE_SELECTOR = ".sched-grid";
var MIN_WIDTH_PX = 768;
var MIN_THUMB_PX = 28;
var RESCAN_DELAY_MS2 = 120;
var bound2 = /* @__PURE__ */ new Map();
var installed7 = false;
var rescanTimer2 = null;
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
__name(clamp, "clamp");
function isScrollableX(el2) {
  const overflowX = getComputedStyle(el2).overflowX;
  return overflowX === "auto" || overflowX === "scroll";
}
__name(isScrollableX, "isScrollableX");
function findHost(table) {
  let el2 = table.parentElement;
  while (el2 && el2 !== document.body) {
    if (isScrollableX(el2)) {
      return el2;
    }
    el2 = el2.parentElement;
  }
  return null;
}
__name(findHost, "findHost");
function canInsertSibling(host2) {
  const parent = host2.parentElement;
  if (!parent) {
    return false;
  }
  const style = getComputedStyle(parent);
  if (style.display === "grid" || style.display === "inline-grid") {
    return false;
  }
  if (style.display === "flex" || style.display === "inline-flex") {
    return style.flexDirection === "column";
  }
  return true;
}
__name(canInsertSibling, "canInsertSibling");
function maxScrollOf(host2) {
  return Math.max(0, host2.scrollWidth - host2.clientWidth);
}
__name(maxScrollOf, "maxScrollOf");
function overflowsX(host2) {
  return maxScrollOf(host2) > 1;
}
__name(overflowsX, "overflowsX");
function thumbTravel(host2, bar) {
  const trackWidth = bar.el.clientWidth;
  return Math.max(0, trackWidth - thumbWidth(host2, bar));
}
__name(thumbTravel, "thumbTravel");
function thumbWidth(host2, bar) {
  const trackWidth = bar.el.clientWidth;
  if (host2.scrollWidth <= 0) {
    return MIN_THUMB_PX;
  }
  const visibleRatio = host2.clientWidth / host2.scrollWidth;
  return clamp(Math.round(trackWidth * visibleRatio), MIN_THUMB_PX, trackWidth);
}
__name(thumbWidth, "thumbWidth");
function render(host2, bar) {
  const travel = thumbTravel(host2, bar);
  const maxScroll = maxScrollOf(host2);
  const progress = maxScroll > 0 ? clamp(host2.scrollLeft / maxScroll, 0, 1) : 0;
  bar.thumb.style.width = `${thumbWidth(host2, bar)}px`;
  bar.thumb.style.transform = `translateX(${Math.round(progress * travel)}px)`;
}
__name(render, "render");
function bindDrag(host2, bar) {
  let dragStartX = 0;
  let dragStartScrollLeft = 0;
  let dragging = false;
  const scrollTo = /* @__PURE__ */ __name((value) => {
    host2.scrollLeft = clamp(value, 0, maxScrollOf(host2));
  }, "scrollTo");
  const onPointerDown = /* @__PURE__ */ __name((event) => {
    if (event.button !== 0) {
      return;
    }
    event.preventDefault();
    if (event.target === bar.thumb) {
      dragging = true;
      dragStartX = event.clientX;
      dragStartScrollLeft = host2.scrollLeft;
      bar.thumb.classList.add(DRAGGING_CLASS);
      bar.thumb.setPointerCapture?.(event.pointerId);
      return;
    }
    const travel = thumbTravel(host2, bar);
    if (travel <= 0) {
      return;
    }
    const offsetX = event.clientX - bar.el.getBoundingClientRect().left;
    const progress = clamp((offsetX - thumbWidth(host2, bar) / 2) / travel, 0, 1);
    scrollTo(progress * maxScrollOf(host2));
  }, "onPointerDown");
  const onPointerMove = /* @__PURE__ */ __name((event) => {
    if (!dragging) {
      return;
    }
    const travel = thumbTravel(host2, bar);
    if (travel <= 0) {
      return;
    }
    const movedPx = event.clientX - dragStartX;
    scrollTo(dragStartScrollLeft + movedPx / travel * maxScrollOf(host2));
  }, "onPointerMove");
  const endDrag = /* @__PURE__ */ __name((event) => {
    if (!dragging) {
      return;
    }
    dragging = false;
    bar.thumb.classList.remove(DRAGGING_CLASS);
    bar.thumb.releasePointerCapture?.(event.pointerId);
  }, "endDrag");
  bar.el.addEventListener("pointerdown", onPointerDown);
  bar.thumb.addEventListener("pointermove", onPointerMove);
  bar.thumb.addEventListener("pointerup", endDrag);
  bar.thumb.addEventListener("pointercancel", endDrag);
  return () => {
    bar.el.removeEventListener("pointerdown", onPointerDown);
    bar.thumb.removeEventListener("pointermove", onPointerMove);
    bar.thumb.removeEventListener("pointerup", endDrag);
    bar.thumb.removeEventListener("pointercancel", endDrag);
  };
}
__name(bindDrag, "bindDrag");
function createBar(variantClass) {
  const el2 = document.createElement("div");
  el2.className = `${BAR_CLASS} ${variantClass}`;
  el2.setAttribute("aria-hidden", "true");
  const thumb = document.createElement("div");
  thumb.className = THUMB_CLASS;
  el2.appendChild(thumb);
  return {
    el: el2,
    thumb,
    detach: /* @__PURE__ */ __name(() => void 0, "detach")
  };
}
__name(createBar, "createBar");
function sync(host2) {
  const entry = bound2.get(host2);
  if (!entry) {
    return;
  }
  const needed = overflowsX(host2);
  host2.toggleAttribute(HOST_ATTR, needed);
  for (const bar of entry.bars) {
    bar.el.classList.toggle(HIDDEN_CLASS, !needed);
    if (needed) {
      render(host2, bar);
    }
  }
}
__name(sync, "sync");
function attach(host2) {
  if (bound2.has(host2)) {
    return;
  }
  const parent = host2.parentElement;
  if (!parent) {
    return;
  }
  const bottom = createBar(BOTTOM_CLASS);
  if (host2.closest(INFLOW_SELECTOR) !== null) {
    bottom.el.classList.add(INFLOW_CLASS);
  }
  parent.insertBefore(bottom.el, host2.nextSibling);
  const bars = [
    bottom
  ];
  const onHostScroll = /* @__PURE__ */ __name(() => {
    for (const bar of bars) {
      render(host2, bar);
    }
  }, "onHostScroll");
  host2.addEventListener("scroll", onHostScroll, {
    passive: true
  });
  for (const bar of bars) {
    bar.detach = bindDrag(host2, bar);
  }
  let resizeObserver = null;
  if (typeof ResizeObserver !== "undefined") {
    resizeObserver = new ResizeObserver(() => sync(host2));
    resizeObserver.observe(host2);
    const table = host2.querySelector("table");
    if (table) {
      resizeObserver.observe(table);
    }
  }
  bound2.set(host2, {
    bars,
    onHostScroll,
    resizeObserver
  });
  sync(host2);
}
__name(attach, "attach");
function detach(host2) {
  const entry = bound2.get(host2);
  if (!entry) {
    return;
  }
  host2.removeEventListener("scroll", entry.onHostScroll);
  for (const bar of entry.bars) {
    bar.detach();
    bar.el.remove();
  }
  entry.resizeObserver?.disconnect();
  host2.removeAttribute(HOST_ATTR);
  bound2.delete(host2);
}
__name(detach, "detach");
function detachAll() {
  for (const host2 of [
    ...bound2.keys()
  ]) {
    detach(host2);
  }
}
__name(detachAll, "detachAll");
function isEnabled() {
  return typeof window !== "undefined" && window.innerWidth >= MIN_WIDTH_PX;
}
__name(isEnabled, "isEnabled");
function refreshTableXScroll() {
  if (typeof document === "undefined") {
    return;
  }
  if (!isEnabled()) {
    detachAll();
    return;
  }
  const seen = /* @__PURE__ */ new Set();
  for (const table of document.querySelectorAll("table")) {
    if (table.matches(EXCLUDED_TABLE_SELECTOR) || table.closest(OFF_SELECTOR)) {
      continue;
    }
    const host2 = findHost(table);
    if (!(host2 && canInsertSibling(host2))) {
      continue;
    }
    seen.add(host2);
    if (bound2.has(host2)) {
      sync(host2);
    } else if (overflowsX(host2)) {
      attach(host2);
    }
  }
  for (const host2 of [
    ...bound2.keys()
  ]) {
    if (!(seen.has(host2) && host2.isConnected)) {
      detach(host2);
    }
  }
}
__name(refreshTableXScroll, "refreshTableXScroll");
function boundHostContaining(node) {
  let el2 = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
  while (el2) {
    if (bound2.has(el2)) {
      return el2;
    }
    el2 = el2.parentElement;
  }
  return null;
}
__name(boundHostContaining, "boundHostContaining");
var pendingSync = /* @__PURE__ */ new Set();
var syncTimer = null;
function scheduleSync(hosts) {
  for (const h of hosts) {
    pendingSync.add(h);
  }
  if (syncTimer !== null || rescanTimer2 !== null) {
    return;
  }
  syncTimer = setTimeout(() => {
    syncTimer = null;
    for (const host2 of pendingSync) {
      if (host2.isConnected) {
        sync(host2);
      } else {
        detach(host2);
      }
    }
    pendingSync.clear();
  }, RESCAN_DELAY_MS2);
}
__name(scheduleSync, "scheduleSync");
function scheduleRefresh() {
  if (rescanTimer2 !== null) {
    return;
  }
  rescanTimer2 = setTimeout(() => {
    rescanTimer2 = null;
    refreshTableXScroll();
  }, RESCAN_DELAY_MS2);
}
__name(scheduleRefresh, "scheduleRefresh");
function setupTableXScroll() {
  if (installed7 || typeof document === "undefined") {
    return;
  }
  installed7 = true;
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver((records) => {
      const hostsToSync = /* @__PURE__ */ new Set();
      for (const rec of records) {
        const host2 = boundHostContaining(rec.target);
        if (!host2) {
          scheduleRefresh();
          return;
        }
        hostsToSync.add(host2);
      }
      scheduleSync(hostsToSync);
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  window.addEventListener("resize", scheduleRefresh, {
    passive: true
  });
  refreshTableXScroll();
}
__name(setupTableXScroll, "setupTableXScroll");

// src/theme.ts
var THEME_STORAGE_KEY = "hereby.theme";
var ADMIN_THEME_QA_STORAGE_KEY = "hereby.theme.admin-qa";
var THEME_CHANGE_EVENT = "hereby:theme-change";
var DEFAULT_PREFERENCE = "light";
var PREFERENCES = [
  "light",
  "dark",
  "system"
];
var DATA_ATTR = "theme";
var THEME_LABELS = {
  light: "\uB77C\uC774\uD2B8",
  dark: "\uB2E4\uD06C",
  system: "\uC2DC\uC2A4\uD15C \uC124\uC815 \uB530\uB974\uAE30"
};
var mediaQuery = null;
var mediaListener = null;
function isThemePreference(value) {
  return typeof value === "string" && PREFERENCES.includes(value);
}
__name(isThemePreference, "isThemePreference");
function getWindow() {
  return typeof window === "undefined" ? void 0 : window;
}
__name(getWindow, "getWindow");
function readStoredThemePreference(key = THEME_STORAGE_KEY) {
  const w = getWindow();
  if (!w) {
    return DEFAULT_PREFERENCE;
  }
  try {
    const stored = w.localStorage.getItem(key);
    return isThemePreference(stored) ? stored : DEFAULT_PREFERENCE;
  } catch {
    return DEFAULT_PREFERENCE;
  }
}
__name(readStoredThemePreference, "readStoredThemePreference");
function persistThemePreference(preference) {
  const w = getWindow();
  if (!w) {
    return;
  }
  try {
    if (preference === DEFAULT_PREFERENCE) {
      w.localStorage.removeItem(THEME_STORAGE_KEY);
      return;
    }
    w.localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
  }
}
__name(persistThemePreference, "persistThemePreference");
function systemPrefersDark() {
  const w = getWindow();
  return Boolean(w?.matchMedia?.("(prefers-color-scheme: dark)").matches);
}
__name(systemPrefersDark, "systemPrefersDark");
function resolveTheme(preference) {
  if (preference === "system") {
    return systemPrefersDark() ? "dark" : "light";
  }
  return preference;
}
__name(resolveTheme, "resolveTheme");
function currentTheme() {
  const root = getWindow()?.document?.documentElement;
  return root?.dataset[DATA_ATTR] === "dark" ? "dark" : "light";
}
__name(currentTheme, "currentTheme");
function setRootTheme(theme) {
  const w = getWindow();
  const root = w?.document?.documentElement;
  if (!root) {
    return;
  }
  const before = currentTheme();
  if (theme === "dark") {
    root.dataset[DATA_ATTR] = "dark";
  } else {
    delete root.dataset[DATA_ATTR];
  }
  if (before !== theme) {
    w.document.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, {
      detail: {
        theme
      }
    }));
  }
}
__name(setRootTheme, "setRootTheme");
function applyThemePreference(preference) {
  const w = getWindow();
  if (!w) {
    return;
  }
  if (mediaQuery && mediaListener) {
    mediaQuery.removeEventListener("change", mediaListener);
    mediaQuery = null;
    mediaListener = null;
  }
  if (preference === "system" && w.matchMedia) {
    mediaQuery = w.matchMedia("(prefers-color-scheme: dark)");
    mediaListener = /* @__PURE__ */ __name((event) => setRootTheme(event.matches ? "dark" : "light"), "mediaListener");
    mediaQuery.addEventListener("change", mediaListener);
  }
  setRootTheme(resolveTheme(preference));
}
__name(applyThemePreference, "applyThemePreference");
function onThemeChange(listener) {
  const w = getWindow();
  if (!w) {
    return () => void 0;
  }
  const handler = /* @__PURE__ */ __name((event) => {
    const detail = event.detail;
    listener(detail?.theme ?? currentTheme());
  }, "handler");
  w.document.addEventListener(THEME_CHANGE_EVENT, handler);
  return () => w.document.removeEventListener(THEME_CHANGE_EVENT, handler);
}
__name(onThemeChange, "onThemeChange");

// src/tooltip.ts
var ViewportMargin = 8;
var ArrowInset = 10;
function clampTooltipX(targetCenterX, bubbleWidth, viewportWidth, margin = ViewportMargin) {
  const half = bubbleWidth / 2;
  const min = margin + half;
  const max = viewportWidth - margin - half;
  const centerX = max < min ? viewportWidth / 2 : Math.min(Math.max(targetCenterX, min), max);
  const rawArrowX = targetCenterX - (centerX - half);
  const arrowX = Math.min(Math.max(rawArrowX, ArrowInset), Math.max(bubbleWidth - ArrowInset, 0));
  return {
    centerX,
    arrowX
  };
}
__name(clampTooltipX, "clampTooltipX");
function clampTooltipLeft(left, bubbleWidth, viewportWidth, margin = ViewportMargin) {
  const max = viewportWidth - margin - bubbleWidth;
  return max < margin ? margin : Math.min(Math.max(left, margin), max);
}
__name(clampTooltipLeft, "clampTooltipLeft");
var installed8 = false;
function setupTooltip() {
  if (installed8 || typeof document === "undefined") {
    return;
  }
  installed8 = true;
  const TooltipClass = "ds-tooltip";
  const LnbSelector = ".ds-lnb--collapsed .ds-lnb__menu";
  const TopSelector = ".icon-btn, .ds-btn--icon, .org-tree__action-btn, [data-ds-tip='top']";
  const CompactSelector = "select, [data-ds-tip='compact'], .ms-dropdown__trigger";
  const CompactCenterSelector = "[data-ds-tip='compact-center']";
  const CompactGap = 4;
  const TruncSelector = ".role-card__group-label, .role-card__pill, .cell-trunc-tip";
  const MultilineSelector = "[title], [data-tip-title]";
  const Gap = 4;
  const ArrowDepth = 6;
  const LnbGap = Gap + ArrowDepth;
  const TopGap = Gap + ArrowDepth;
  let tip = null;
  let tipText = null;
  let active = null;
  function ensureTip() {
    if (tip) {
      return tip;
    }
    tip = document.createElement("div");
    tip.className = TooltipClass;
    tip.setAttribute("role", "tooltip");
    tip.setAttribute("aria-hidden", "true");
    tipText = document.createTextNode("");
    tip.appendChild(tipText);
    document.body.appendChild(tip);
    return tip;
  }
  __name(ensureTip, "ensureTip");
  function targetMatch(el2) {
    const lnb = el2.closest(LnbSelector);
    if (lnb instanceof HTMLElement) {
      return {
        node: lnb,
        placement: "right"
      };
    }
    const compactCenter = el2.closest(CompactCenterSelector);
    if (compactCenter instanceof HTMLElement) {
      return {
        node: compactCenter,
        placement: "compact-center"
      };
    }
    const compact = el2.closest(CompactSelector);
    if (compact instanceof HTMLElement && !(compact.tagName === "SELECT" && hasMultilineLabel(compact))) {
      return {
        node: compact,
        placement: "compact"
      };
    }
    const btn = el2.closest(TopSelector);
    if (btn instanceof HTMLElement) {
      return {
        node: btn,
        placement: "top"
      };
    }
    const trunc = el2.closest(TruncSelector);
    if (trunc instanceof HTMLElement) {
      return {
        node: trunc,
        placement: "top",
        truncateOnly: true
      };
    }
    const multiline = el2.closest(MultilineSelector);
    if (multiline instanceof HTMLElement && hasMultilineLabel(multiline)) {
      return {
        node: multiline,
        placement: "top"
      };
    }
    return null;
  }
  __name(targetMatch, "targetMatch");
  function hasMultilineLabel(node) {
    const label = node.getAttribute("title") ?? node.dataset.tipTitle ?? "";
    return label.includes("\n");
  }
  __name(hasMultilineLabel, "hasMultilineLabel");
  function applyCenteredX(el2, r, viewportWidth) {
    const { centerX, arrowX } = clampTooltipX(r.left + r.width / 2, el2.offsetWidth, viewportWidth);
    el2.style.left = `${centerX}px`;
    if (Math.abs(centerX - (r.left + r.width / 2)) > 0.5) {
      el2.style.setProperty("--ds-tip-arrow-x", `${arrowX}px`);
    }
  }
  __name(applyCenteredX, "applyCenteredX");
  function show2(node, placement) {
    let label = node.getAttribute("title") || node.dataset.tipTitle || "";
    if (placement === "compact") {
      if (node instanceof HTMLSelectElement) {
        const opt = node.options[node.selectedIndex];
        if (opt?.text) {
          label = opt.text;
        }
      } else if (node.classList.contains("ms-dropdown__trigger")) {
        const container = node.closest(".ms-dropdown");
        const checked = [];
        if (container) {
          container.querySelectorAll(".ms-dropdown__item").forEach((item) => {
            const cb = item.querySelector('input[type="checkbox"]');
            if (cb instanceof HTMLInputElement && cb.checked) {
              const txt = item.querySelector(".ms-dropdown__item-label")?.textContent?.trim();
              if (txt) {
                checked.push(txt);
              }
            }
          });
        }
        if (checked.length > 1) {
          label = checked.join(", ");
        } else {
          const labelEl = node.querySelector(".ms-dropdown__label");
          const txt = labelEl?.textContent?.trim();
          if (txt) {
            label = txt;
          }
        }
      }
    }
    if (!label) {
      return;
    }
    const el2 = ensureTip();
    if (tipText) {
      tipText.data = label;
    } else {
      el2.textContent = label;
    }
    el2.classList.toggle("ds-tooltip--multiline", label.includes("\n"));
    el2.classList.toggle("ds-tooltip--light", node.closest('[data-ds-tip-tone="light"]') !== null);
    el2.setAttribute("data-placement", placement);
    el2.removeAttribute("data-flip");
    el2.style.removeProperty("--ds-tip-arrow-x");
    const r = node.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    if (placement === "right") {
      const lnb = node.closest(".ds-lnb--collapsed");
      const x = (lnb ? lnb.getBoundingClientRect().right : r.right) + LnbGap;
      el2.style.left = `${x}px`;
      el2.style.top = `${r.top + r.height / 2}px`;
    } else if (placement === "compact") {
      el2.style.left = `${clampTooltipLeft(r.left, el2.offsetWidth, viewportWidth)}px`;
      if (r.top - CompactGap - el2.offsetHeight < 0) {
        el2.setAttribute("data-flip", "down");
        el2.style.top = `${r.bottom + CompactGap}px`;
      } else {
        el2.style.top = `${r.top - CompactGap}px`;
      }
    } else if (placement === "compact-center") {
      applyCenteredX(el2, r, viewportWidth);
      if (r.top - TopGap - el2.offsetHeight < 0) {
        el2.setAttribute("data-flip", "down");
        el2.style.top = `${r.bottom + TopGap}px`;
      } else {
        el2.style.top = `${r.top - TopGap}px`;
      }
    } else {
      applyCenteredX(el2, r, viewportWidth);
      if (r.top - TopGap - el2.offsetHeight < 0) {
        el2.setAttribute("data-flip", "down");
        el2.style.top = `${r.bottom + TopGap}px`;
      } else {
        el2.style.top = `${r.top - TopGap}px`;
      }
    }
    requestAnimationFrame(() => el2.classList.add("is-visible"));
  }
  __name(show2, "show");
  function hide2() {
    if (tip) {
      tip.classList.remove("is-visible");
    }
    if (active?.dataset.tipTitle) {
      if (!active.hasAttribute("title")) {
        active.setAttribute("title", active.dataset.tipTitle);
      }
      delete active.dataset.tipTitle;
    }
    active = null;
  }
  __name(hide2, "hide");
  const ClickTriggerSelector = "[data-ds-tip-trigger='click']";
  function activate(match) {
    const title = match.node.getAttribute("title");
    if (title) {
      match.node.dataset.tipTitle = title;
      match.node.setAttribute("aria-label", title);
      match.node.removeAttribute("title");
    } else if (!match.node.dataset.tipTitle) {
      return;
    }
    active = match.node;
    show2(match.node, match.placement);
  }
  __name(activate, "activate");
  document.addEventListener("pointerover", (e) => {
    const t = e.target;
    if (!t) {
      return;
    }
    if (t.closest(ClickTriggerSelector)) {
      if (active && !active.matches(ClickTriggerSelector)) {
        hide2();
      }
      return;
    }
    const match = targetMatch(t);
    if (match && match.node !== active) {
      hide2();
      if (match.truncateOnly && match.node.scrollWidth <= match.node.clientWidth + 1 && match.node.scrollHeight <= match.node.clientHeight + 1) {
        return;
      }
      const title = match.node.getAttribute("title");
      if (title) {
        match.node.dataset.tipTitle = title;
        match.node.setAttribute("aria-label", title);
        match.node.removeAttribute("title");
        active = match.node;
        show2(match.node, match.placement);
      } else if (match.node.dataset.tipTitle) {
        active = match.node;
        show2(match.node, match.placement);
      } else if (match.placement === "compact" && (match.node instanceof HTMLSelectElement || match.node.classList.contains("ms-dropdown__trigger"))) {
        active = match.node;
        show2(match.node, match.placement);
      }
    } else if (!match && active) {
      hide2();
    }
  }, true);
  document.addEventListener("pointerleave", () => hide2(), true);
  document.addEventListener("click", (e) => {
    const t = e.target;
    const trigger = t?.closest(ClickTriggerSelector);
    if (trigger instanceof HTMLElement) {
      const match = targetMatch(trigger);
      if (match && match.node === trigger) {
        if (active === trigger) {
          hide2();
          return;
        }
        hide2();
        activate(match);
        return;
      }
    }
    hide2();
  });
}
__name(setupTooltip, "setupTooltip");

// src/utils/access-error.ts
function isAccessDeniedError(e) {
  const err = e;
  const code = err?.data?.code;
  if (code) {
    return code === "FORBIDDEN" || code === "UNAUTHORIZED";
  }
  return /FORBIDDEN|UNAUTHORIZED/.test(err?.message ?? "");
}
__name(isAccessDeniedError, "isAccessDeniedError");

// src/utils/auth-ready.ts
function whenAuthenticated(ctx) {
  if (herebyStore(ctx)?.authenticated) {
    return Promise.resolve();
  }
  return new Promise((resolve2) => {
    ctx.$watch("$store.hereby.authenticated", (authenticated) => {
      if (authenticated) {
        resolve2();
      }
    });
  });
}
__name(whenAuthenticated, "whenAuthenticated");
function whenCurrentUserLoaded(ctx) {
  if (herebyStore(ctx)?.currentUser) {
    return Promise.resolve();
  }
  return new Promise((resolve2) => {
    ctx.$watch("$store.hereby.currentUser", (user) => {
      if (user) {
        resolve2();
      }
    });
  });
}
__name(whenCurrentUserLoaded, "whenCurrentUserLoaded");

// src/utils/last-selection.ts
function lastSelectionKey(app, what, organizationId) {
  return `${app}:${what}:${organizationId || "default"}`;
}
__name(lastSelectionKey, "lastSelectionKey");
function readLastSelection(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
__name(readLastSelection, "readLastSelection");
function writeLastSelection(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
  }
}
__name(writeLastSelection, "writeLastSelection");

// src/utils/print-html.ts
var PRINT_IFRAME_CLEANUP_DELAY_MS = 5e3;
function printHtmlDocument(html) {
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  iframe.style.opacity = "0";
  document.body.appendChild(iframe);
  const printWindow = iframe.contentWindow;
  const printDocument = iframe.contentDocument || printWindow?.document;
  if (printDocument) {
    printDocument.open();
    printDocument.write(html);
    printDocument.close();
    if (typeof printWindow?.focus === "function") {
      printWindow.focus();
    }
    if (typeof printWindow?.print === "function") {
      printWindow.print();
    }
  }
  window.setTimeout(() => iframe.remove(), PRINT_IFRAME_CLEANUP_DELAY_MS);
}
__name(printHtmlDocument, "printHtmlDocument");

// src/utils/work-log-bar.ts
var WORK_LOG_AXIS_MAX = 1800;
function workLogBarGeometry(startMin, endMin, axisMax = WORK_LOG_AXIS_MAX) {
  if (startMin === null || startMin === void 0 || endMin === null || endMin === void 0) {
    return null;
  }
  const start = Math.max(0, Math.min(axisMax, startMin));
  const end = Math.max(0, Math.min(axisMax, endMin));
  if (end <= start) {
    return null;
  }
  const round2 = /* @__PURE__ */ __name((n) => Math.round(n * 100) / 100, "round2");
  return {
    leftPct: round2(start / axisMax * 100),
    widthPct: round2((end - start) / axisMax * 100)
  };
}
__name(workLogBarGeometry, "workLogBarGeometry");
function workLogBarStyle(startMin, endMin, axisMax = WORK_LOG_AXIS_MAX) {
  const g = workLogBarGeometry(startMin, endMin, axisMax);
  if (!g) {
    return "display:none";
  }
  return `left:${g.leftPct}%;width:${g.widthPct}%`;
}
__name(workLogBarStyle, "workLogBarStyle");
function workLogAxisTicks(axisMax = WORK_LOG_AXIS_MAX) {
  const ticks = [];
  for (let min = 0; min <= axisMax; min += 360) {
    const hour = min / 60 % 24;
    const label = min >= 1440 && hour === 0 ? "\uC775\uC77C 0\uC2DC" : `${hour}\uC2DC`;
    ticks.push({
      label,
      leftPct: Math.round(min / axisMax * 1e4) / 100
    });
  }
  return ticks;
}
__name(workLogAxisTicks, "workLogAxisTicks");
function formatWorkLogMinutes(min) {
  if (min === null || min === void 0 || !Number.isFinite(min)) {
    return "-";
  }
  const inDay = (min % 1440 + 1440) % 1440;
  const h = Math.floor(inDay / 60);
  const m = inDay % 60;
  const label = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  return min >= 1440 ? `\uC775\uC77C ${label}` : label;
}
__name(formatWorkLogMinutes, "formatWorkLogMinutes");
function workLogRangeLabel(startMin, endMin) {
  if (startMin === null || startMin === void 0 || endMin === null || endMin === void 0) {
    return "\uC2DC\uAC04 \uBBF8\uC785\uB825";
  }
  return `${formatWorkLogMinutes(startMin)}~${formatWorkLogMinutes(endMin)}`;
}
__name(workLogRangeLabel, "workLogRangeLabel");
function workLogKindLabel(kind) {
  switch (kind) {
    case "clock":
      return "\uCD9C\uD1F4\uADFC";
    case "overtime":
      return "\uC5F0\uC7A5\uADFC\uBB34";
    case "offsite":
      return "\uC678\uADFC";
    default:
      return String(kind);
  }
}
__name(workLogKindLabel, "workLogKindLabel");
function workLogStatusLabel(kind, status) {
  if (kind === "overtime") {
    const map2 = {
      manual: "\uC9C1\uC811 \uC785\uB825",
      pending: "\uC2B9\uC778 \uB300\uAE30",
      approved: "\uC2B9\uC778",
      report_pending: "\uBCF4\uACE0\uC11C \uB300\uAE30",
      report_approved: "\uBCF4\uACE0 \uC644\uB8CC",
      report_rejected: "\uBCF4\uACE0\uC11C \uBC18\uB824"
    };
    return map2[status] ?? status;
  }
  if (kind === "offsite") {
    const map2 = {
      approved: "\uC2B9\uC778 (\uBCF4\uACE0 \uC804)",
      report_pending: "\uACB0\uACFC \uBCF4\uACE0 \uB300\uAE30",
      report_approved: "\uBCF4\uACE0 \uC644\uB8CC"
    };
    return map2[status] ?? status;
  }
  return "";
}
__name(workLogStatusLabel, "workLogStatusLabel");
function workLogMonthRange(yearMonth) {
  const m = /^(\d{4})-(\d{2})$/.exec(yearMonth);
  if (!m) {
    return null;
  }
  const year = Number(m[1]);
  const month = Number(m[2]);
  if (month < 1 || month > 12) {
    return null;
  }
  const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return {
    from: `${yearMonth}-01`,
    to: `${yearMonth}-${String(last).padStart(2, "0")}`
  };
}
__name(workLogMonthRange, "workLogMonthRange");
function workLogShiftMonth(yearMonth, delta) {
  const m = /^(\d{4})-(\d{2})$/.exec(yearMonth);
  if (!m) {
    return yearMonth;
  }
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}
__name(workLogShiftMonth, "workLogShiftMonth");
export {
  ADMIN_THEME_QA_STORAGE_KEY,
  APPROVAL_REPLACED_EVENT,
  APPROVAL_REPLACE_OPEN_EVENT,
  APPROVAL_REPLACE_STATE_EVENT,
  EMBED_BACKDROP_SELECTOR,
  EMBED_RESET_SCROLL_MESSAGE,
  NOTICE_CATEGORY_LABEL_COLOR,
  NOTICE_CATEGORY_LABEL_KEY,
  NOTICE_PRIORITY_LABEL_COLOR,
  NOTICE_PRIORITY_LABEL_KEY,
  NOTICE_READ_EVENT,
  NOTIFICATION_RECEIVED_EVENT,
  NURSE_WORK_TYPES,
  THEME_CHANGE_EVENT,
  THEME_LABELS,
  THEME_STORAGE_KEY,
  WORK_LOG_AXIS_MAX,
  aiAssistantComponent,
  appHeaderComponent,
  applyThemePreference,
  applyWardAssignmentChanges,
  approvalReplaceComponent,
  approvalReplaceMessage,
  askChoice,
  askConfirm,
  assertGuidanceCanNavigate,
  authGateComponent,
  bindApprovalReplaceHost,
  bottomNavComponent,
  buildLocalChatNotification,
  changePasswordFormComponent,
  chatWidgetComponent,
  checkPendingDeviceLinks,
  computeCenterShift,
  computeFillMaxHeight,
  computeFitMaxHeight,
  createAuthComponentsPlugin,
  createDialogStore,
  createEmployeeCardStore,
  createIconPlugin,
  createWardRow,
  currentTheme,
  decisionResultMessage,
  defaultScheduleGroupId,
  dismissOpenDialog,
  dsSearchInputComponent,
  employeeCardStatusClass,
  ensureHolidayYears,
  entityPickerComponent,
  explainDecisionError,
  formatRemaining as formatImpersonationRemaining,
  formatWorkLogMinutes,
  getHolidayName,
  getIcon,
  getNationalHolidayName,
  guardEmbeddedOrg,
  handleDecisionError,
  hasIcon,
  hasWardAssignmentChanges,
  highlightGuidanceTarget,
  iconNames,
  impersonationBannerComponent,
  impersonationBannerState,
  invalidateHolidayYear,
  isAccessDeniedError,
  isHoliday,
  isRemainingUrgent as isImpersonationRemainingUrgent,
  isMessengerPreviewBlocked,
  isOrgMismatch,
  isOveruseConfirmError,
  isThemePreference,
  lastSelectionKey,
  loadLocalNotifySource,
  localChatNotificationAllowed,
  localNotifySettingsFor,
  loginFormComponent,
  matchMenuEntries,
  mergeServerWardRows,
  messengerComponent,
  normalizeEmphasis,
  noticeCategoryLabelColor,
  noticeCategoryLabelKey,
  noticePriorityLabelColor,
  noticePriorityLabelKey,
  notificationBellComponent,
  onThemeChange,
  pageHeaderComponent,
  persistThemePreference,
  pickerMatches,
  pickerQuery,
  pickerRoles,
  planWardAssignmentChanges,
  positionFloatingMenu,
  printHtmlDocument,
  publishEmbedOrg,
  readLastSelection,
  readNoticeIds,
  readStoredThemePreference,
  readTrpcErrorCode,
  refreshTableXScroll,
  registerDialogHost,
  registerEmployeeCardActions,
  registerEscLayer,
  registerFormComponent,
  removeWardRow,
  requestApprovalReplace,
  resetDialogHost,
  resetScrollPositions,
  resolveFitMaxHeight,
  resolveTheme,
  scheduleGroupOptionsForRow,
  segmentComponent,
  setupEmbedModalCentering,
  setupEmbedScrollReset,
  setupFilterBar,
  setupLnbTooltip,
  setupMenuDividers,
  setupPageScroll,
  setupTableHost,
  setupTableXScroll,
  setupTooltip,
  showAlert,
  showError,
  showPrompt,
  splitEmphasis,
  startChatDeviceLinkWatch,
  subTabComponent,
  suggestWardId,
  syncRowScheduleGroup,
  syncRowWard,
  tabNavComponent,
  tickChatDeviceLinkWatch,
  wardOptionsForRow,
  wardRowBadge,
  wardRowsError,
  wardRowsFromAssignments,
  wardSchedulerHint,
  whenAuthenticated,
  whenCurrentUserLoaded,
  withOveruseConfirm,
  workLogAxisTicks,
  workLogBarGeometry,
  workLogBarStyle,
  workLogKindLabel,
  workLogMonthRange,
  workLogRangeLabel,
  workLogShiftMonth,
  workLogStatusLabel,
  writeLastSelection
};
/*! Bundled license information:

@trpc/client/dist/httpBatchLink-fQ1NAi-e.mjs:
  (* istanbul ignore if -- @preserve *)
*/
//# sourceMappingURL=index.js.map